
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $0d79572b4b22d35c$export$3545e07a80636437 = "169";
const $0d79572b4b22d35c$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $0d79572b4b22d35c$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $0d79572b4b22d35c$export$3237e1f2c1ea1f44 = 0;
const $0d79572b4b22d35c$export$b9a7b4fc5cb15f9b = 1;
const $0d79572b4b22d35c$export$b8058bcc7037d3f3 = 2;
const $0d79572b4b22d35c$export$f24be24dcddeac0d = 3;
const $0d79572b4b22d35c$export$346307dbae2b7447 = 0;
const $0d79572b4b22d35c$export$5813f879eee7cd88 = 1;
const $0d79572b4b22d35c$export$a47c4b43a1be34f0 = 2;
const $0d79572b4b22d35c$export$896ae1ade6c829c4 = 3;
const $0d79572b4b22d35c$export$2ede184fc2998901 = 0;
const $0d79572b4b22d35c$export$d9f0486e75b5ace = 1;
const $0d79572b4b22d35c$export$3b296b6f144d5b03 = 2;
const $0d79572b4b22d35c$export$63b8d6b580fc65ba = 0;
const $0d79572b4b22d35c$export$5b29a26d96ee6af0 = 1;
const $0d79572b4b22d35c$export$777d8f9551c2216b = 2;
const $0d79572b4b22d35c$export$cdfa06f868e2e467 = 3;
const $0d79572b4b22d35c$export$4138e1c684b46a20 = 4;
const $0d79572b4b22d35c$export$eda4864c68df1fa2 = 5;
const $0d79572b4b22d35c$export$20183a0484ce21a0 = 100;
const $0d79572b4b22d35c$export$73e0df5177988548 = 101;
const $0d79572b4b22d35c$export$28e582859cbec660 = 102;
const $0d79572b4b22d35c$export$c8c1508da8d0600c = 103;
const $0d79572b4b22d35c$export$99948c02fb51055f = 104;
const $0d79572b4b22d35c$export$2110f05edf778d3d = 200;
const $0d79572b4b22d35c$export$8805bad65e24940e = 201;
const $0d79572b4b22d35c$export$7fbe15b28d28cf52 = 202;
const $0d79572b4b22d35c$export$947829af9f2c17f6 = 203;
const $0d79572b4b22d35c$export$d5773124e86cf28c = 204;
const $0d79572b4b22d35c$export$11d468cc7f19e971 = 205;
const $0d79572b4b22d35c$export$a78aed1ca2a87192 = 206;
const $0d79572b4b22d35c$export$5d0fe17fd8773bac = 207;
const $0d79572b4b22d35c$export$ef5f2dd8ffac5574 = 208;
const $0d79572b4b22d35c$export$56b85b2686ab16 = 209;
const $0d79572b4b22d35c$export$c05e2a1fc8609506 = 210;
const $0d79572b4b22d35c$export$7dd8f434fd59075 = 211;
const $0d79572b4b22d35c$export$99c8d898a9afbcee = 212;
const $0d79572b4b22d35c$export$310cd2be38d13b56 = 213;
const $0d79572b4b22d35c$export$db77b8fbcf45dbf4 = 214;
const $0d79572b4b22d35c$export$69025ce147cee220 = 0;
const $0d79572b4b22d35c$export$7182eb52ea3b3f04 = 1;
const $0d79572b4b22d35c$export$eedccec66ab7ebe = 2;
const $0d79572b4b22d35c$export$296f78a0b892f81a = 3;
const $0d79572b4b22d35c$export$a60d398fc7b7590e = 4;
const $0d79572b4b22d35c$export$7d7234c1240a1fc4 = 5;
const $0d79572b4b22d35c$export$c5e2c52991f30937 = 6;
const $0d79572b4b22d35c$export$2f843afa843d8916 = 7;
const $0d79572b4b22d35c$export$e50ac29801f1774d = 0;
const $0d79572b4b22d35c$export$9f9d94f963c85479 = 1;
const $0d79572b4b22d35c$export$e641dc52bc3494aa = 2;
const $0d79572b4b22d35c$export$9fcb6b4294603b2 = 0;
const $0d79572b4b22d35c$export$98f52c2a46c598ca = 1;
const $0d79572b4b22d35c$export$74b25e54b3bcd548 = 2;
const $0d79572b4b22d35c$export$932b3dd283d4a366 = 3;
const $0d79572b4b22d35c$export$a0d98fe6d7e4af64 = 4;
const $0d79572b4b22d35c$export$2c7b09c1e9abfb5e = 5;
const $0d79572b4b22d35c$export$212d53a513a325b2 = 6;
const $0d79572b4b22d35c$export$f2863e1668a8e317 = 7;
const $0d79572b4b22d35c$export$2595a3798997538 = "attached";
const $0d79572b4b22d35c$export$d7e7dc2e114517a0 = "detached";
const $0d79572b4b22d35c$export$1beec6768cbb3d2d = 300;
const $0d79572b4b22d35c$export$8759762a6477f2c4 = 301;
const $0d79572b4b22d35c$export$dc59f8aed047f61d = 302;
const $0d79572b4b22d35c$export$d64030b316d3b087 = 303;
const $0d79572b4b22d35c$export$ee99d97d46898098 = 304;
const $0d79572b4b22d35c$export$dbf3e70ff37af79 = 306;
const $0d79572b4b22d35c$export$533346c8e8dac0f5 = 1000;
const $0d79572b4b22d35c$export$9d9334239a5a5e06 = 1001;
const $0d79572b4b22d35c$export$c7e7c00b14f51a4f = 1002;
const $0d79572b4b22d35c$export$727aa5ec3fe39bf0 = 1003;
const $0d79572b4b22d35c$export$d129e38cf6feaa8c = 1004;
const $0d79572b4b22d35c$export$14a4936464a36496 = 1004;
const $0d79572b4b22d35c$export$d2327c1afe5bfdf2 = 1005;
const $0d79572b4b22d35c$export$cbc5b7f5647595d8 = 1005;
const $0d79572b4b22d35c$export$8a72f490b25c56c8 = 1006;
const $0d79572b4b22d35c$export$19a719f377145a13 = 1007;
const $0d79572b4b22d35c$export$dbe96bee3fe9dbf0 = 1007;
const $0d79572b4b22d35c$export$5d8599b6a933fb1b = 1008;
const $0d79572b4b22d35c$export$90d80f1e3506775f = 1008;
const $0d79572b4b22d35c$export$2e8ce08d3f6f5e10 = 1009;
const $0d79572b4b22d35c$export$545fce0311a9796a = 1010;
const $0d79572b4b22d35c$export$88572337f312435f = 1011;
const $0d79572b4b22d35c$export$c63dc51868b06a9d = 1012;
const $0d79572b4b22d35c$export$5c612977753abe2 = 1013;
const $0d79572b4b22d35c$export$c3c7fc4518ebba96 = 1014;
const $0d79572b4b22d35c$export$f6d331659b644596 = 1015;
const $0d79572b4b22d35c$export$2697304443f382bc = 1016;
const $0d79572b4b22d35c$export$b3969b01faf587f2 = 1017;
const $0d79572b4b22d35c$export$18886f8ae33e90de = 1018;
const $0d79572b4b22d35c$export$6c8ea339bfab1301 = 1020;
const $0d79572b4b22d35c$export$5a4c329b7e2092d3 = 35902;
const $0d79572b4b22d35c$export$988473390501ed4b = 1021;
const $0d79572b4b22d35c$export$7c67423a5ee6f5eb = 1022;
const $0d79572b4b22d35c$export$3f8bb04b555a363c = 1023;
const $0d79572b4b22d35c$export$cc09ccbf6d1ed449 = 1024;
const $0d79572b4b22d35c$export$9053a81c4a69c289 = 1025;
const $0d79572b4b22d35c$export$c1b6b5136be58045 = 1026;
const $0d79572b4b22d35c$export$1e113ac2d0905829 = 1027;
const $0d79572b4b22d35c$export$4e041a7967d15c4b = 1028;
const $0d79572b4b22d35c$export$aa92e870a709d190 = 1029;
const $0d79572b4b22d35c$export$6cdf0b461c7ce8a0 = 1030;
const $0d79572b4b22d35c$export$1ba1c45f9f77d4d7 = 1031;
const $0d79572b4b22d35c$export$d1fd40c11bfa798e = 1032;
const $0d79572b4b22d35c$export$c200e7d26f592f21 = 1033;
const $0d79572b4b22d35c$export$21d1799c6d552fc0 = 33776;
const $0d79572b4b22d35c$export$afa304c3e981b668 = 33777;
const $0d79572b4b22d35c$export$d2a1a68024a3e56c = 33778;
const $0d79572b4b22d35c$export$9a79c424327dacf9 = 33779;
const $0d79572b4b22d35c$export$19ada9bbb1af3573 = 35840;
const $0d79572b4b22d35c$export$d0f0355bb3d948e4 = 35841;
const $0d79572b4b22d35c$export$b82296714358084c = 35842;
const $0d79572b4b22d35c$export$b71692456c47b6c3 = 35843;
const $0d79572b4b22d35c$export$6ab91af2d757aee7 = 36196;
const $0d79572b4b22d35c$export$7800993ef8106a6a = 37492;
const $0d79572b4b22d35c$export$23ed8300a860e7d8 = 37496;
const $0d79572b4b22d35c$export$dc5570b4a2b92d48 = 37808;
const $0d79572b4b22d35c$export$68880cd325f8b2fb = 37809;
const $0d79572b4b22d35c$export$7d2c0be323373d95 = 37810;
const $0d79572b4b22d35c$export$22b52da301fc3a3e = 37811;
const $0d79572b4b22d35c$export$c009e2cb4a66485e = 37812;
const $0d79572b4b22d35c$export$118fff5afa255b63 = 37813;
const $0d79572b4b22d35c$export$120713c829ae0667 = 37814;
const $0d79572b4b22d35c$export$c79eeabbf53313e9 = 37815;
const $0d79572b4b22d35c$export$443cf6567cdd6424 = 37816;
const $0d79572b4b22d35c$export$6573984fc9840780 = 37817;
const $0d79572b4b22d35c$export$e7aee563f30091de = 37818;
const $0d79572b4b22d35c$export$2eb8634622ddeab7 = 37819;
const $0d79572b4b22d35c$export$202b1ce7b5d25742 = 37820;
const $0d79572b4b22d35c$export$18ab77abd087e467 = 37821;
const $0d79572b4b22d35c$export$ce40b115e188bc81 = 36492;
const $0d79572b4b22d35c$export$d279c5c4bac5121e = 36494;
const $0d79572b4b22d35c$export$cde52d17225fdbd3 = 36495;
const $0d79572b4b22d35c$export$b1688df4c4c21670 = 36283;
const $0d79572b4b22d35c$export$fc15e5d8261eed58 = 36284;
const $0d79572b4b22d35c$export$d220f6ade8463a0f = 36285;
const $0d79572b4b22d35c$export$768646d09dc1b6ef = 36286;
const $0d79572b4b22d35c$export$d62fdc9d1b1cccad = 2200;
const $0d79572b4b22d35c$export$dfaf4422ce096e29 = 2201;
const $0d79572b4b22d35c$export$f8f6f2041b78e210 = 2202;
const $0d79572b4b22d35c$export$995b32462a65e855 = 2300;
const $0d79572b4b22d35c$export$30fac1aace31cf4d = 2301;
const $0d79572b4b22d35c$export$198b11ff4c72bb30 = 2302;
const $0d79572b4b22d35c$export$7f795934b84ab523 = 2400;
const $0d79572b4b22d35c$export$24a4ccb5099273b5 = 2401;
const $0d79572b4b22d35c$export$8e8c3ecdcd8e1fee = 2402;
const $0d79572b4b22d35c$export$bcfbbdcf8de7f8cd = 2500;
const $0d79572b4b22d35c$export$d875e029ef558d3 = 2501;
const $0d79572b4b22d35c$export$4c28c87c2dc84758 = 0;
const $0d79572b4b22d35c$export$b23a071aa286eb29 = 1;
const $0d79572b4b22d35c$export$f0d8293634f88842 = 2;
const $0d79572b4b22d35c$export$deeb383078690b50 = 3200;
const $0d79572b4b22d35c$export$8f910f4c4f73df11 = 3201;
const $0d79572b4b22d35c$export$be2e2ddbc3983173 = 3202;
const $0d79572b4b22d35c$export$1a54198784742f80 = 3203;
const $0d79572b4b22d35c$export$2852a58ebdac27b8 = 0;
const $0d79572b4b22d35c$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $0d79572b4b22d35c$export$bfcb490c2dd3db51 = "";
const $0d79572b4b22d35c$export$561f394b24edfcaa = "srgb";
const $0d79572b4b22d35c$export$42429b3acfb233a4 = "srgb-linear";
const $0d79572b4b22d35c$export$626af19ae879bdf6 = "display-p3";
const $0d79572b4b22d35c$export$c0dc1bc7e964761 = "display-p3-linear";
const $0d79572b4b22d35c$export$f197347d588c1b4a = "linear";
const $0d79572b4b22d35c$export$8d0a61916cc26abb = "srgb";
const $0d79572b4b22d35c$export$ce9118f9eaae3bb2 = "rec709";
const $0d79572b4b22d35c$export$ef371755dbe7f98a = "p3";
const $0d79572b4b22d35c$export$69433f11f42d5527 = 0;
const $0d79572b4b22d35c$export$9f542ae4b5baca34 = 7680;
const $0d79572b4b22d35c$export$8a4f28336ef203d3 = 7681;
const $0d79572b4b22d35c$export$2928c0231297c036 = 7682;
const $0d79572b4b22d35c$export$c0e9611c8a15f9a8 = 7683;
const $0d79572b4b22d35c$export$9c2c08927385dcc4 = 34055;
const $0d79572b4b22d35c$export$7c74ea00fa1315e6 = 34056;
const $0d79572b4b22d35c$export$22e2e5726612443 = 5386;
const $0d79572b4b22d35c$export$1343870698229224 = 512;
const $0d79572b4b22d35c$export$8e1d8ed281997fa6 = 513;
const $0d79572b4b22d35c$export$55648a1cde8329a7 = 514;
const $0d79572b4b22d35c$export$2dff107857e6aca2 = 515;
const $0d79572b4b22d35c$export$6f93765ab2f451a2 = 516;
const $0d79572b4b22d35c$export$6f3fb2d2440f2b76 = 517;
const $0d79572b4b22d35c$export$4119cf7b4c98fd5a = 518;
const $0d79572b4b22d35c$export$14cf96713ddd97a8 = 519;
const $0d79572b4b22d35c$export$d9e2d19a747baaab = 512;
const $0d79572b4b22d35c$export$36bcf49c713b3eb7 = 513;
const $0d79572b4b22d35c$export$66f28d946fc6a0d5 = 514;
const $0d79572b4b22d35c$export$64eea11eb407ddf1 = 515;
const $0d79572b4b22d35c$export$155af022118f3a38 = 516;
const $0d79572b4b22d35c$export$67ab95dde6bed156 = 517;
const $0d79572b4b22d35c$export$1cdcb70d53d65f61 = 518;
const $0d79572b4b22d35c$export$187b73a3e352c145 = 519;
const $0d79572b4b22d35c$export$763e8360f4d7f77d = 35044;
const $0d79572b4b22d35c$export$8505d14ac8546ca = 35048;
const $0d79572b4b22d35c$export$721e63549e51d81e = 35040;
const $0d79572b4b22d35c$export$415731dc4f48e299 = 35045;
const $0d79572b4b22d35c$export$9e809946455f13bc = 35049;
const $0d79572b4b22d35c$export$2ed9499a35b5f832 = 35041;
const $0d79572b4b22d35c$export$32ab2503ea19469a = 35046;
const $0d79572b4b22d35c$export$ab4022c2c3f86315 = 35050;
const $0d79572b4b22d35c$export$ba7f1db36a76a970 = 35042;
const $0d79572b4b22d35c$export$43600cc67fabd9f = "100";
const $0d79572b4b22d35c$export$f63012db5506e7dd = "300 es";
const $0d79572b4b22d35c$export$5a0e9190d10875d3 = 2000;
const $0d79572b4b22d35c$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $0d79572b4b22d35c$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $0d79572b4b22d35c$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $0d79572b4b22d35c$var$_seed = 1234567;
const $0d79572b4b22d35c$var$DEG2RAD = Math.PI / 180;
const $0d79572b4b22d35c$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $0d79572b4b22d35c$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $0d79572b4b22d35c$var$_lut[d0 & 0xff] + $0d79572b4b22d35c$var$_lut[d0 >> 8 & 0xff] + $0d79572b4b22d35c$var$_lut[d0 >> 16 & 0xff] + $0d79572b4b22d35c$var$_lut[d0 >> 24 & 0xff] + "-" + $0d79572b4b22d35c$var$_lut[d1 & 0xff] + $0d79572b4b22d35c$var$_lut[d1 >> 8 & 0xff] + "-" + $0d79572b4b22d35c$var$_lut[d1 >> 16 & 0x0f | 0x40] + $0d79572b4b22d35c$var$_lut[d1 >> 24 & 0xff] + "-" + $0d79572b4b22d35c$var$_lut[d2 & 0x3f | 0x80] + $0d79572b4b22d35c$var$_lut[d2 >> 8 & 0xff] + "-" + $0d79572b4b22d35c$var$_lut[d2 >> 16 & 0xff] + $0d79572b4b22d35c$var$_lut[d2 >> 24 & 0xff] + $0d79572b4b22d35c$var$_lut[d3 & 0xff] + $0d79572b4b22d35c$var$_lut[d3 >> 8 & 0xff] + $0d79572b4b22d35c$var$_lut[d3 >> 16 & 0xff] + $0d79572b4b22d35c$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $0d79572b4b22d35c$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $0d79572b4b22d35c$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $0d79572b4b22d35c$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $0d79572b4b22d35c$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $0d79572b4b22d35c$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $0d79572b4b22d35c$var$damp(x, y, lambda, dt) {
    return $0d79572b4b22d35c$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $0d79572b4b22d35c$var$pingpong(x, length = 1) {
    return length - Math.abs($0d79572b4b22d35c$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $0d79572b4b22d35c$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $0d79572b4b22d35c$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $0d79572b4b22d35c$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $0d79572b4b22d35c$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $0d79572b4b22d35c$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $0d79572b4b22d35c$var$seededRandom(s) {
    if (s !== undefined) $0d79572b4b22d35c$var$_seed = s;
    // Mulberry32 generator
    let t = $0d79572b4b22d35c$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $0d79572b4b22d35c$var$degToRad(degrees) {
    return degrees * $0d79572b4b22d35c$var$DEG2RAD;
}
function $0d79572b4b22d35c$var$radToDeg(radians) {
    return radians * $0d79572b4b22d35c$var$RAD2DEG;
}
function $0d79572b4b22d35c$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $0d79572b4b22d35c$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $0d79572b4b22d35c$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $0d79572b4b22d35c$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $0d79572b4b22d35c$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $0d79572b4b22d35c$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
const $0d79572b4b22d35c$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $0d79572b4b22d35c$var$DEG2RAD,
    RAD2DEG: $0d79572b4b22d35c$var$RAD2DEG,
    generateUUID: $0d79572b4b22d35c$var$generateUUID,
    clamp: $0d79572b4b22d35c$var$clamp,
    euclideanModulo: $0d79572b4b22d35c$var$euclideanModulo,
    mapLinear: $0d79572b4b22d35c$var$mapLinear,
    inverseLerp: $0d79572b4b22d35c$var$inverseLerp,
    lerp: $0d79572b4b22d35c$var$lerp,
    damp: $0d79572b4b22d35c$var$damp,
    pingpong: $0d79572b4b22d35c$var$pingpong,
    smoothstep: $0d79572b4b22d35c$var$smoothstep,
    smootherstep: $0d79572b4b22d35c$var$smootherstep,
    randInt: $0d79572b4b22d35c$var$randInt,
    randFloat: $0d79572b4b22d35c$var$randFloat,
    randFloatSpread: $0d79572b4b22d35c$var$randFloatSpread,
    seededRandom: $0d79572b4b22d35c$var$seededRandom,
    degToRad: $0d79572b4b22d35c$var$degToRad,
    radToDeg: $0d79572b4b22d35c$var$radToDeg,
    isPowerOfTwo: $0d79572b4b22d35c$var$isPowerOfTwo,
    ceilPowerOfTwo: $0d79572b4b22d35c$var$ceilPowerOfTwo,
    floorPowerOfTwo: $0d79572b4b22d35c$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $0d79572b4b22d35c$var$setQuaternionFromProperEuler,
    normalize: $0d79572b4b22d35c$var$normalize,
    denormalize: $0d79572b4b22d35c$var$denormalize
};
class $0d79572b4b22d35c$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $0d79572b4b22d35c$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($0d79572b4b22d35c$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $0d79572b4b22d35c$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $0d79572b4b22d35c$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($0d79572b4b22d35c$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($0d79572b4b22d35c$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($0d79572b4b22d35c$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $0d79572b4b22d35c$var$_m3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918();
function $0d79572b4b22d35c$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $0d79572b4b22d35c$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $0d79572b4b22d35c$var$getTypedArray(type, buffer) {
    return new $0d79572b4b22d35c$var$TYPED_ARRAYS[type](buffer);
}
function $0d79572b4b22d35c$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
function $0d79572b4b22d35c$export$1033a2df66368859() {
    const canvas = $0d79572b4b22d35c$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
const $0d79572b4b22d35c$var$_cache = {};
function $0d79572b4b22d35c$var$warnOnce(message) {
    if (message in $0d79572b4b22d35c$var$_cache) return;
    $0d79572b4b22d35c$var$_cache[message] = true;
    console.warn(message);
}
function $0d79572b4b22d35c$var$probeAsync(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
function $0d79572b4b22d35c$var$toNormalizedProjectionMatrix(projectionMatrix) {
    const m = projectionMatrix.elements;
    // Convert [-1, 1] to [0, 1] projection matrix
    m[2] = 0.5 * m[2] + 0.5 * m[3];
    m[6] = 0.5 * m[6] + 0.5 * m[7];
    m[10] = 0.5 * m[10] + 0.5 * m[11];
    m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function $0d79572b4b22d35c$var$toReversedProjectionMatrix(projectionMatrix) {
    const m = projectionMatrix.elements;
    const isPerspectiveMatrix = m[11] === -1;
    // Reverse [0, 1] projection matrix
    if (isPerspectiveMatrix) {
        m[10] = -m[10] - 1;
        m[14] = -m[14];
    } else {
        m[10] = -m[10];
        m[14] = -m[14] + 1;
    }
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $0d79572b4b22d35c$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918().set(0.8224621, 0.177538, 0.0, 0.0331941, 0.9668058, 0.0, 0.0170827, 0.0723974, 0.9105199);
const $0d79572b4b22d35c$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918().set(1.2249401, -0.2249404, 0.0, -0.0420569, 1.0420571, 0.0, -0.0196376, -0.0786361, 1.0982735);
/**
 * Defines supported color spaces by transfer function and primaries,
 * and provides conversions to/from the Linear-sRGB reference space.
 */ const $0d79572b4b22d35c$var$COLOR_SPACES = {
    [$0d79572b4b22d35c$export$42429b3acfb233a4]: {
        transfer: $0d79572b4b22d35c$export$f197347d588c1b4a,
        primaries: $0d79572b4b22d35c$export$ce9118f9eaae3bb2,
        luminanceCoefficients: [
            0.2126,
            0.7152,
            0.0722
        ],
        toReference: (color)=>color,
        fromReference: (color)=>color
    },
    [$0d79572b4b22d35c$export$561f394b24edfcaa]: {
        transfer: $0d79572b4b22d35c$export$8d0a61916cc26abb,
        primaries: $0d79572b4b22d35c$export$ce9118f9eaae3bb2,
        luminanceCoefficients: [
            0.2126,
            0.7152,
            0.0722
        ],
        toReference: (color)=>color.convertSRGBToLinear(),
        fromReference: (color)=>color.convertLinearToSRGB()
    },
    [$0d79572b4b22d35c$export$c0dc1bc7e964761]: {
        transfer: $0d79572b4b22d35c$export$f197347d588c1b4a,
        primaries: $0d79572b4b22d35c$export$ef371755dbe7f98a,
        luminanceCoefficients: [
            0.2289,
            0.6917,
            0.0793
        ],
        toReference: (color)=>color.applyMatrix3($0d79572b4b22d35c$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
        fromReference: (color)=>color.applyMatrix3($0d79572b4b22d35c$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3)
    },
    [$0d79572b4b22d35c$export$626af19ae879bdf6]: {
        transfer: $0d79572b4b22d35c$export$8d0a61916cc26abb,
        primaries: $0d79572b4b22d35c$export$ef371755dbe7f98a,
        luminanceCoefficients: [
            0.2289,
            0.6917,
            0.0793
        ],
        toReference: (color)=>color.convertSRGBToLinear().applyMatrix3($0d79572b4b22d35c$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
        fromReference: (color)=>color.applyMatrix3($0d79572b4b22d35c$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB()
    }
};
const $0d79572b4b22d35c$var$SUPPORTED_WORKING_COLOR_SPACES = new Set([
    $0d79572b4b22d35c$export$42429b3acfb233a4,
    $0d79572b4b22d35c$export$c0dc1bc7e964761
]);
const $0d79572b4b22d35c$export$5e6fd513f44698c = {
    enabled: true,
    _workingColorSpace: $0d79572b4b22d35c$export$42429b3acfb233a4,
    get workingColorSpace () {
        return this._workingColorSpace;
    },
    set workingColorSpace (colorSpace){
        if (!$0d79572b4b22d35c$var$SUPPORTED_WORKING_COLOR_SPACES.has(colorSpace)) throw new Error(`Unsupported working color space, "${colorSpace}".`);
        this._workingColorSpace = colorSpace;
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToReference = $0d79572b4b22d35c$var$COLOR_SPACES[sourceColorSpace].toReference;
        const targetFromReference = $0d79572b4b22d35c$var$COLOR_SPACES[targetColorSpace].fromReference;
        return targetFromReference(sourceToReference(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this._workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this._workingColorSpace);
    },
    getPrimaries: function(colorSpace1) {
        return $0d79572b4b22d35c$var$COLOR_SPACES[colorSpace1].primaries;
    },
    getTransfer: function(colorSpace1) {
        if (colorSpace1 === $0d79572b4b22d35c$export$bfcb490c2dd3db51) return $0d79572b4b22d35c$export$f197347d588c1b4a;
        return $0d79572b4b22d35c$var$COLOR_SPACES[colorSpace1].transfer;
    },
    getLuminanceCoefficients: function(target, colorSpace1 = this._workingColorSpace) {
        return target.fromArray($0d79572b4b22d35c$var$COLOR_SPACES[colorSpace1].luminanceCoefficients);
    }
};
function $0d79572b4b22d35c$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $0d79572b4b22d35c$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $0d79572b4b22d35c$var$_canvas;
class $0d79572b4b22d35c$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($0d79572b4b22d35c$var$_canvas === undefined) $0d79572b4b22d35c$var$_canvas = $0d79572b4b22d35c$var$createElementNS("canvas");
            $0d79572b4b22d35c$var$_canvas.width = image.width;
            $0d79572b4b22d35c$var$_canvas.height = image.height;
            const context = $0d79572b4b22d35c$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $0d79572b4b22d35c$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $0d79572b4b22d35c$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $0d79572b4b22d35c$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($0d79572b4b22d35c$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $0d79572b4b22d35c$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
let $0d79572b4b22d35c$var$_sourceId = 0;
class $0d79572b4b22d35c$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, "id", {
            value: $0d79572b4b22d35c$var$_sourceId++
        });
        this.uuid = $0d79572b4b22d35c$var$generateUUID();
        this.data = data;
        this.dataReady = true;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ""
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($0d79572b4b22d35c$var$serializeImage(data[i].image));
                else url.push($0d79572b4b22d35c$var$serializeImage(data[i]));
            } else // texture
            url = $0d79572b4b22d35c$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $0d79572b4b22d35c$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $0d79572b4b22d35c$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
let $0d79572b4b22d35c$var$_textureId = 0;
class $0d79572b4b22d35c$export$5431306cf43de24a extends $0d79572b4b22d35c$export$ec8b666c5fe2c75a {
    constructor(image = $0d79572b4b22d35c$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $0d79572b4b22d35c$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $0d79572b4b22d35c$export$9d9334239a5a5e06, wrapT = $0d79572b4b22d35c$export$9d9334239a5a5e06, magFilter = $0d79572b4b22d35c$export$8a72f490b25c56c8, minFilter = $0d79572b4b22d35c$export$5d8599b6a933fb1b, format = $0d79572b4b22d35c$export$3f8bb04b555a363c, type = $0d79572b4b22d35c$export$2e8ce08d3f6f5e10, anisotropy = $0d79572b4b22d35c$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $0d79572b4b22d35c$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, "id", {
            value: $0d79572b4b22d35c$var$_textureId++
        });
        this.uuid = $0d79572b4b22d35c$var$generateUUID();
        this.name = "";
        this.source = new $0d79572b4b22d35c$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $0d79572b4b22d35c$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1);
        this.center = new $0d79572b4b22d35c$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $0d79572b4b22d35c$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        this.colorSpace = colorSpace1;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $0d79572b4b22d35c$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $0d79572b4b22d35c$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $0d79572b4b22d35c$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $0d79572b4b22d35c$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $0d79572b4b22d35c$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $0d79572b4b22d35c$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $0d79572b4b22d35c$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
$0d79572b4b22d35c$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$0d79572b4b22d35c$export$5431306cf43de24a.DEFAULT_MAPPING = $0d79572b4b22d35c$export$1beec6768cbb3d2d;
$0d79572b4b22d35c$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $0d79572b4b22d35c$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $0d79572b4b22d35c$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $0d79572b4b22d35c$export$efcb1f8bf367cbfb extends $0d79572b4b22d35c$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $0d79572b4b22d35c$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $0d79572b4b22d35c$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $0d79572b4b22d35c$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1
        }, options);
        const texture = new $0d79572b4b22d35c$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        texture.flipY = false;
        texture.generateMipmaps = options.generateMipmaps;
        texture.internalFormat = options.internalFormat;
        this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
        }
        this.depthBuffer = options.depthBuffer;
        this.stencilBuffer = options.stencilBuffer;
        this.resolveDepthBuffer = options.resolveDepthBuffer;
        this.resolveStencilBuffer = options.resolveStencilBuffer;
        this.depthTexture = options.depthTexture;
        this.samples = options.samples;
    }
    get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
        }
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $0d79572b4b22d35c$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $0d79572b4b22d35c$export$3c052beb2e51e23f extends $0d79572b4b22d35c$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $0d79572b4b22d35c$export$dfac6c8e811406a3 extends $0d79572b4b22d35c$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $0d79572b4b22d35c$export$727aa5ec3fe39bf0;
        this.minFilter = $0d79572b4b22d35c$export$727aa5ec3fe39bf0;
        this.wrapR = $0d79572b4b22d35c$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $0d79572b4b22d35c$export$c77a02c11ed180c7 extends $0d79572b4b22d35c$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $0d79572b4b22d35c$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $0d79572b4b22d35c$export$d7a3086320f856db extends $0d79572b4b22d35c$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $0d79572b4b22d35c$export$727aa5ec3fe39bf0;
        this.minFilter = $0d79572b4b22d35c$export$727aa5ec3fe39bf0;
        this.wrapR = $0d79572b4b22d35c$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $0d79572b4b22d35c$export$7ee06591009639df extends $0d79572b4b22d35c$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $0d79572b4b22d35c$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $0d79572b4b22d35c$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($0d79572b4b22d35c$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize(); // normalize calls _onChangeCallback()
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // sets this quaternion to a uniform random unit quaternnion
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $0d79572b4b22d35c$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $0d79572b4b22d35c$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($0d79572b4b22d35c$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($0d79572b4b22d35c$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $0d79572b4b22d35c$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($0d79572b4b22d35c$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($0d79572b4b22d35c$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($0d79572b4b22d35c$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $0d79572b4b22d35c$var$_vector$c = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_quaternion$4 = /*@__PURE__*/ new $0d79572b4b22d35c$export$23d6a54f0bbc85a3();
class $0d79572b4b22d35c$export$6f7d5a9418ab2aa3 {
    constructor(min = new $0d79572b4b22d35c$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $0d79572b4b22d35c$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($0d79572b4b22d35c$var$_vector$b.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($0d79572b4b22d35c$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $0d79572b4b22d35c$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute("position");
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $0d79572b4b22d35c$var$_vector$b);
                else $0d79572b4b22d35c$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $0d79572b4b22d35c$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($0d79572b4b22d35c$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $0d79572b4b22d35c$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $0d79572b4b22d35c$var$_box$4.copy(geometry.boundingBox);
                }
                $0d79572b4b22d35c$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($0d79572b4b22d35c$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $0d79572b4b22d35c$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $0d79572b4b22d35c$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($0d79572b4b22d35c$var$_center);
        $0d79572b4b22d35c$var$_extents.subVectors(this.max, $0d79572b4b22d35c$var$_center);
        // translate triangle to aabb origin
        $0d79572b4b22d35c$var$_v0$3.subVectors(triangle.a, $0d79572b4b22d35c$var$_center);
        $0d79572b4b22d35c$var$_v1$7.subVectors(triangle.b, $0d79572b4b22d35c$var$_center);
        $0d79572b4b22d35c$var$_v2$4.subVectors(triangle.c, $0d79572b4b22d35c$var$_center);
        // compute edge vectors for triangle
        $0d79572b4b22d35c$var$_f0.subVectors($0d79572b4b22d35c$var$_v1$7, $0d79572b4b22d35c$var$_v0$3);
        $0d79572b4b22d35c$var$_f1.subVectors($0d79572b4b22d35c$var$_v2$4, $0d79572b4b22d35c$var$_v1$7);
        $0d79572b4b22d35c$var$_f2.subVectors($0d79572b4b22d35c$var$_v0$3, $0d79572b4b22d35c$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$0d79572b4b22d35c$var$_f0.z,
            $0d79572b4b22d35c$var$_f0.y,
            0,
            -$0d79572b4b22d35c$var$_f1.z,
            $0d79572b4b22d35c$var$_f1.y,
            0,
            -$0d79572b4b22d35c$var$_f2.z,
            $0d79572b4b22d35c$var$_f2.y,
            $0d79572b4b22d35c$var$_f0.z,
            0,
            -$0d79572b4b22d35c$var$_f0.x,
            $0d79572b4b22d35c$var$_f1.z,
            0,
            -$0d79572b4b22d35c$var$_f1.x,
            $0d79572b4b22d35c$var$_f2.z,
            0,
            -$0d79572b4b22d35c$var$_f2.x,
            -$0d79572b4b22d35c$var$_f0.y,
            $0d79572b4b22d35c$var$_f0.x,
            0,
            -$0d79572b4b22d35c$var$_f1.y,
            $0d79572b4b22d35c$var$_f1.x,
            0,
            -$0d79572b4b22d35c$var$_f2.y,
            $0d79572b4b22d35c$var$_f2.x,
            0
        ];
        if (!$0d79572b4b22d35c$var$satForAxes(axes, $0d79572b4b22d35c$var$_v0$3, $0d79572b4b22d35c$var$_v1$7, $0d79572b4b22d35c$var$_v2$4, $0d79572b4b22d35c$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$0d79572b4b22d35c$var$satForAxes(axes, $0d79572b4b22d35c$var$_v0$3, $0d79572b4b22d35c$var$_v1$7, $0d79572b4b22d35c$var$_v2$4, $0d79572b4b22d35c$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $0d79572b4b22d35c$var$_triangleNormal.crossVectors($0d79572b4b22d35c$var$_f0, $0d79572b4b22d35c$var$_f1);
        axes = [
            $0d79572b4b22d35c$var$_triangleNormal.x,
            $0d79572b4b22d35c$var$_triangleNormal.y,
            $0d79572b4b22d35c$var$_triangleNormal.z
        ];
        return $0d79572b4b22d35c$var$satForAxes(axes, $0d79572b4b22d35c$var$_v0$3, $0d79572b4b22d35c$var$_v1$7, $0d79572b4b22d35c$var$_v2$4, $0d79572b4b22d35c$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $0d79572b4b22d35c$var$_vector$b).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($0d79572b4b22d35c$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $0d79572b4b22d35c$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $0d79572b4b22d35c$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $0d79572b4b22d35c$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $0d79572b4b22d35c$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $0d79572b4b22d35c$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $0d79572b4b22d35c$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $0d79572b4b22d35c$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $0d79572b4b22d35c$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($0d79572b4b22d35c$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $0d79572b4b22d35c$var$_points = [
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699()
];
const $0d79572b4b22d35c$var$_vector$b = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_box$4 = /*@__PURE__*/ new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $0d79572b4b22d35c$var$_v0$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v1$7 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v2$4 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
// triangle edge vectors
const $0d79572b4b22d35c$var$_f0 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_f1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_f2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_center = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_extents = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_triangleNormal = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_testAxis = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
function $0d79572b4b22d35c$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $0d79572b4b22d35c$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($0d79572b4b22d35c$var$_testAxis.x) + extents.y * Math.abs($0d79572b4b22d35c$var$_testAxis.y) + extents.z * Math.abs($0d79572b4b22d35c$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($0d79572b4b22d35c$var$_testAxis);
        const p1 = v1.dot($0d79572b4b22d35c$var$_testAxis);
        const p2 = v2.dot($0d79572b4b22d35c$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $0d79572b4b22d35c$var$_box$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
const $0d79572b4b22d35c$var$_v1$6 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v2$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$805e8b72413ccaba {
    constructor(center = new $0d79572b4b22d35c$export$64b5c384219d3699(), radius = -1){
        this.isSphere = true;
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $0d79572b4b22d35c$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $0d79572b4b22d35c$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $0d79572b4b22d35c$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($0d79572b4b22d35c$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $0d79572b4b22d35c$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($0d79572b4b22d35c$var$_v1$6.copy(sphere.center).add($0d79572b4b22d35c$var$_v2$3));
            this.expandByPoint($0d79572b4b22d35c$var$_v1$6.copy(sphere.center).sub($0d79572b4b22d35c$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0d79572b4b22d35c$var$_vector$a = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_segCenter = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_segDir = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_diff = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_edge1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_edge2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_normal$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$a186db52eed6d40e {
    constructor(origin = new $0d79572b4b22d35c$export$64b5c384219d3699(), direction = new $0d79572b4b22d35c$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $0d79572b4b22d35c$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $0d79572b4b22d35c$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $0d79572b4b22d35c$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $0d79572b4b22d35c$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $0d79572b4b22d35c$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $0d79572b4b22d35c$var$_segDir.copy(v1).sub(v0).normalize();
        $0d79572b4b22d35c$var$_diff.copy(this.origin).sub($0d79572b4b22d35c$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($0d79572b4b22d35c$var$_segDir);
        const b0 = $0d79572b4b22d35c$var$_diff.dot(this.direction);
        const b1 = -$0d79572b4b22d35c$var$_diff.dot($0d79572b4b22d35c$var$_segDir);
        const c = $0d79572b4b22d35c$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($0d79572b4b22d35c$var$_segCenter).addScaledVector($0d79572b4b22d35c$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $0d79572b4b22d35c$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $0d79572b4b22d35c$var$_vector$a.dot(this.direction);
        const d2 = $0d79572b4b22d35c$var$_vector$a.dot($0d79572b4b22d35c$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $0d79572b4b22d35c$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $0d79572b4b22d35c$var$_edge1.subVectors(b, a);
        $0d79572b4b22d35c$var$_edge2.subVectors(c, a);
        $0d79572b4b22d35c$var$_normal$1.crossVectors($0d79572b4b22d35c$var$_edge1, $0d79572b4b22d35c$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($0d79572b4b22d35c$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $0d79572b4b22d35c$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($0d79572b4b22d35c$var$_edge2.crossVectors($0d79572b4b22d35c$var$_diff, $0d79572b4b22d35c$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($0d79572b4b22d35c$var$_edge1.cross($0d79572b4b22d35c$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $0d79572b4b22d35c$var$_diff.dot($0d79572b4b22d35c$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $0d79572b4b22d35c$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $0d79572b4b22d35c$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $0d79572b4b22d35c$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $0d79572b4b22d35c$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $0d79572b4b22d35c$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $0d79572b4b22d35c$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($0d79572b4b22d35c$var$_zero, q, $0d79572b4b22d35c$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $0d79572b4b22d35c$var$_z.subVectors(eye, target);
        if ($0d79572b4b22d35c$var$_z.lengthSq() === 0) // eye and target are in the same position
        $0d79572b4b22d35c$var$_z.z = 1;
        $0d79572b4b22d35c$var$_z.normalize();
        $0d79572b4b22d35c$var$_x.crossVectors(up, $0d79572b4b22d35c$var$_z);
        if ($0d79572b4b22d35c$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $0d79572b4b22d35c$var$_z.x += 0.0001;
            else $0d79572b4b22d35c$var$_z.z += 0.0001;
            $0d79572b4b22d35c$var$_z.normalize();
            $0d79572b4b22d35c$var$_x.crossVectors(up, $0d79572b4b22d35c$var$_z);
        }
        $0d79572b4b22d35c$var$_x.normalize();
        $0d79572b4b22d35c$var$_y.crossVectors($0d79572b4b22d35c$var$_z, $0d79572b4b22d35c$var$_x);
        te[0] = $0d79572b4b22d35c$var$_x.x;
        te[4] = $0d79572b4b22d35c$var$_y.x;
        te[8] = $0d79572b4b22d35c$var$_z.x;
        te[1] = $0d79572b4b22d35c$var$_x.y;
        te[5] = $0d79572b4b22d35c$var$_y.y;
        te[9] = $0d79572b4b22d35c$var$_z.y;
        te[2] = $0d79572b4b22d35c$var$_x.z;
        te[6] = $0d79572b4b22d35c$var$_y.z;
        te[10] = $0d79572b4b22d35c$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $0d79572b4b22d35c$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $0d79572b4b22d35c$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $0d79572b4b22d35c$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $0d79572b4b22d35c$var$_m1$4.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $0d79572b4b22d35c$var$_m1$4.elements[0] *= invSX;
        $0d79572b4b22d35c$var$_m1$4.elements[1] *= invSX;
        $0d79572b4b22d35c$var$_m1$4.elements[2] *= invSX;
        $0d79572b4b22d35c$var$_m1$4.elements[4] *= invSY;
        $0d79572b4b22d35c$var$_m1$4.elements[5] *= invSY;
        $0d79572b4b22d35c$var$_m1$4.elements[6] *= invSY;
        $0d79572b4b22d35c$var$_m1$4.elements[8] *= invSZ;
        $0d79572b4b22d35c$var$_m1$4.elements[9] *= invSZ;
        $0d79572b4b22d35c$var$_m1$4.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($0d79572b4b22d35c$var$_m1$4);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $0d79572b4b22d35c$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $0d79572b4b22d35c$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $0d79572b4b22d35c$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $0d79572b4b22d35c$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $0d79572b4b22d35c$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $0d79572b4b22d35c$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $0d79572b4b22d35c$var$_v1$5 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_m1$4 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_zero = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(0, 0, 0);
const $0d79572b4b22d35c$var$_one = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(1, 1, 1);
const $0d79572b4b22d35c$var$_x = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_y = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_z = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_matrix$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_quaternion$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$23d6a54f0bbc85a3();
class $0d79572b4b22d35c$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $0d79572b4b22d35c$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($0d79572b4b22d35c$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$0d79572b4b22d35c$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($0d79572b4b22d35c$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$0d79572b4b22d35c$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($0d79572b4b22d35c$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$0d79572b4b22d35c$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $0d79572b4b22d35c$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($0d79572b4b22d35c$var$_matrix$2, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $0d79572b4b22d35c$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($0d79572b4b22d35c$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$0d79572b4b22d35c$export$d93cc409a0768c5f.DEFAULT_ORDER = "XYZ";
class $0d79572b4b22d35c$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $0d79572b4b22d35c$var$_object3DId = 0;
const $0d79572b4b22d35c$var$_v1$4 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_q1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$23d6a54f0bbc85a3();
const $0d79572b4b22d35c$var$_m1$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_target = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_position$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_scale$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_quaternion$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$23d6a54f0bbc85a3();
const $0d79572b4b22d35c$var$_xAxis = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(1, 0, 0);
const $0d79572b4b22d35c$var$_yAxis = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(0, 1, 0);
const $0d79572b4b22d35c$var$_zAxis = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(0, 0, 1);
const $0d79572b4b22d35c$var$_addedEvent = {
    type: "added"
};
const $0d79572b4b22d35c$var$_removedEvent = {
    type: "removed"
};
const $0d79572b4b22d35c$var$_childaddedEvent = {
    type: "childadded",
    child: null
};
const $0d79572b4b22d35c$var$_childremovedEvent = {
    type: "childremoved",
    child: null
};
class $0d79572b4b22d35c$export$e4dd07dff30cc924 extends $0d79572b4b22d35c$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, "id", {
            value: $0d79572b4b22d35c$var$_object3DId++
        });
        this.uuid = $0d79572b4b22d35c$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $0d79572b4b22d35c$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const rotation = new $0d79572b4b22d35c$export$d93cc409a0768c5f();
        const quaternion = new $0d79572b4b22d35c$export$23d6a54f0bbc85a3();
        const scale = new $0d79572b4b22d35c$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $0d79572b4b22d35c$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $0d79572b4b22d35c$export$8ff26dafa08918()
            }
        });
        this.matrix = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        this.matrixWorld = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $0d79572b4b22d35c$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldAutoUpdate = $0d79572b4b22d35c$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $0d79572b4b22d35c$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $0d79572b4b22d35c$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($0d79572b4b22d35c$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $0d79572b4b22d35c$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($0d79572b4b22d35c$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($0d79572b4b22d35c$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($0d79572b4b22d35c$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($0d79572b4b22d35c$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $0d79572b4b22d35c$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($0d79572b4b22d35c$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($0d79572b4b22d35c$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($0d79572b4b22d35c$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($0d79572b4b22d35c$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($0d79572b4b22d35c$var$_m1$3.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $0d79572b4b22d35c$var$_target.copy(x);
        else $0d79572b4b22d35c$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $0d79572b4b22d35c$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $0d79572b4b22d35c$var$_m1$3.lookAt($0d79572b4b22d35c$var$_position$3, $0d79572b4b22d35c$var$_target, this.up);
        else $0d79572b4b22d35c$var$_m1$3.lookAt($0d79572b4b22d35c$var$_target, $0d79572b4b22d35c$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($0d79572b4b22d35c$var$_m1$3);
        if (parent) {
            $0d79572b4b22d35c$var$_m1$3.extractRotation(parent.matrixWorld);
            $0d79572b4b22d35c$var$_q1.setFromRotationMatrix($0d79572b4b22d35c$var$_m1$3);
            this.quaternion.premultiply($0d79572b4b22d35c$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($0d79572b4b22d35c$var$_addedEvent);
            $0d79572b4b22d35c$var$_childaddedEvent.child = object;
            this.dispatchEvent($0d79572b4b22d35c$var$_childaddedEvent);
            $0d79572b4b22d35c$var$_childaddedEvent.child = null;
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($0d79572b4b22d35c$var$_removedEvent);
            $0d79572b4b22d35c$var$_childremovedEvent.child = object;
            this.dispatchEvent($0d79572b4b22d35c$var$_childremovedEvent);
            $0d79572b4b22d35c$var$_childremovedEvent.child = null;
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $0d79572b4b22d35c$var$_m1$3.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $0d79572b4b22d35c$var$_m1$3.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($0d79572b4b22d35c$var$_m1$3);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($0d79572b4b22d35c$var$_addedEvent);
        $0d79572b4b22d35c$var$_childaddedEvent.child = object;
        this.dispatchEvent($0d79572b4b22d35c$var$_childaddedEvent);
        $0d79572b4b22d35c$var$_childaddedEvent.child = null;
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($0d79572b4b22d35c$var$_position$3, target, $0d79572b4b22d35c$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($0d79572b4b22d35c$var$_position$3, $0d79572b4b22d35c$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = "BatchedMesh";
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.visibility = this._visibility;
            object.active = this._active;
            object.bounds = this._bounds.map((bound)=>({
                    boxInitialized: bound.boxInitialized,
                    boxMin: bound.box.min.toArray(),
                    boxMax: bound.box.max.toArray(),
                    sphereInitialized: bound.sphereInitialized,
                    sphereRadius: bound.sphere.radius,
                    sphereCenter: bound.sphere.center.toArray()
                }));
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.geometryCount = this._geometryCount;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = {
                center: object.boundingSphere.center.toArray(),
                radius: object.boundingSphere.radius
            };
            if (this.boundingBox !== null) object.boundingBox = {
                min: object.boundingBox.min.toArray(),
                max: object.boundingBox.max.toArray()
            };
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$0d79572b4b22d35c$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(0, 1, 0);
$0d79572b4b22d35c$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$0d79572b4b22d35c$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $0d79572b4b22d35c$var$_v0$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v1$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v2$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v3$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vab = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vac = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vbc = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vap = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vbp = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vcp = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v40 = /*@__PURE__*/ new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
const $0d79572b4b22d35c$var$_v41 = /*@__PURE__*/ new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
const $0d79572b4b22d35c$var$_v42 = /*@__PURE__*/ new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
class $0d79572b4b22d35c$export$5a465592bfe74b48 {
    constructor(a = new $0d79572b4b22d35c$export$64b5c384219d3699(), b = new $0d79572b4b22d35c$export$64b5c384219d3699(), c = new $0d79572b4b22d35c$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $0d79572b4b22d35c$var$_v0$2.subVectors(a, b);
        target.cross($0d79572b4b22d35c$var$_v0$2);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $0d79572b4b22d35c$var$_v0$2.subVectors(c, a);
        $0d79572b4b22d35c$var$_v1$3.subVectors(b, a);
        $0d79572b4b22d35c$var$_v2$2.subVectors(point, a);
        const dot00 = $0d79572b4b22d35c$var$_v0$2.dot($0d79572b4b22d35c$var$_v0$2);
        const dot01 = $0d79572b4b22d35c$var$_v0$2.dot($0d79572b4b22d35c$var$_v1$3);
        const dot02 = $0d79572b4b22d35c$var$_v0$2.dot($0d79572b4b22d35c$var$_v2$2);
        const dot11 = $0d79572b4b22d35c$var$_v1$3.dot($0d79572b4b22d35c$var$_v1$3);
        const dot12 = $0d79572b4b22d35c$var$_v1$3.dot($0d79572b4b22d35c$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $0d79572b4b22d35c$var$_v3$2) === null) return false;
        return $0d79572b4b22d35c$var$_v3$2.x >= 0 && $0d79572b4b22d35c$var$_v3$2.y >= 0 && $0d79572b4b22d35c$var$_v3$2.x + $0d79572b4b22d35c$var$_v3$2.y <= 1;
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $0d79572b4b22d35c$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ("z" in target) target.z = 0;
            if ("w" in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $0d79572b4b22d35c$var$_v3$2.x);
        target.addScaledVector(v2, $0d79572b4b22d35c$var$_v3$2.y);
        target.addScaledVector(v3, $0d79572b4b22d35c$var$_v3$2.z);
        return target;
    }
    static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $0d79572b4b22d35c$var$_v40.setScalar(0);
        $0d79572b4b22d35c$var$_v41.setScalar(0);
        $0d79572b4b22d35c$var$_v42.setScalar(0);
        $0d79572b4b22d35c$var$_v40.fromBufferAttribute(attr, i1);
        $0d79572b4b22d35c$var$_v41.fromBufferAttribute(attr, i2);
        $0d79572b4b22d35c$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($0d79572b4b22d35c$var$_v40, barycoord.x);
        target.addScaledVector($0d79572b4b22d35c$var$_v41, barycoord.y);
        target.addScaledVector($0d79572b4b22d35c$var$_v42, barycoord.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $0d79572b4b22d35c$var$_v0$2.subVectors(c, b);
        $0d79572b4b22d35c$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $0d79572b4b22d35c$var$_v0$2.cross($0d79572b4b22d35c$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $0d79572b4b22d35c$var$_v0$2.subVectors(this.c, this.b);
        $0d79572b4b22d35c$var$_v1$3.subVectors(this.a, this.b);
        return $0d79572b4b22d35c$var$_v0$2.cross($0d79572b4b22d35c$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $0d79572b4b22d35c$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $0d79572b4b22d35c$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $0d79572b4b22d35c$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $0d79572b4b22d35c$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $0d79572b4b22d35c$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $0d79572b4b22d35c$var$_vab.subVectors(b, a);
        $0d79572b4b22d35c$var$_vac.subVectors(c, a);
        $0d79572b4b22d35c$var$_vap.subVectors(p, a);
        const d1 = $0d79572b4b22d35c$var$_vab.dot($0d79572b4b22d35c$var$_vap);
        const d2 = $0d79572b4b22d35c$var$_vac.dot($0d79572b4b22d35c$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $0d79572b4b22d35c$var$_vbp.subVectors(p, b);
        const d3 = $0d79572b4b22d35c$var$_vab.dot($0d79572b4b22d35c$var$_vbp);
        const d4 = $0d79572b4b22d35c$var$_vac.dot($0d79572b4b22d35c$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($0d79572b4b22d35c$var$_vab, v);
        }
        $0d79572b4b22d35c$var$_vcp.subVectors(p, c);
        const d5 = $0d79572b4b22d35c$var$_vab.dot($0d79572b4b22d35c$var$_vcp);
        const d6 = $0d79572b4b22d35c$var$_vac.dot($0d79572b4b22d35c$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($0d79572b4b22d35c$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $0d79572b4b22d35c$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($0d79572b4b22d35c$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($0d79572b4b22d35c$var$_vab, v).addScaledVector($0d79572b4b22d35c$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const $0d79572b4b22d35c$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $0d79572b4b22d35c$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $0d79572b4b22d35c$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $0d79572b4b22d35c$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $0d79572b4b22d35c$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === "number") this.setHex(value);
            else if (typeof value === "string") this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $0d79572b4b22d35c$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $0d79572b4b22d35c$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $0d79572b4b22d35c$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $0d79572b4b22d35c$var$euclideanModulo(h, 1);
        s = $0d79572b4b22d35c$var$clamp(s, 0, 1);
        l = $0d79572b4b22d35c$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $0d79572b4b22d35c$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $0d79572b4b22d35c$var$hue2rgb(q, p, h);
            this.b = $0d79572b4b22d35c$var$hue2rgb(q, p, h - 1 / 3);
        }
        $0d79572b4b22d35c$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $0d79572b4b22d35c$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn("THREE.Color: Unknown color model " + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn("THREE.Color: Invalid hex color " + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $0d79572b4b22d35c$export$561f394b24edfcaa) {
        // color keywords
        const hex = $0d79572b4b22d35c$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $0d79572b4b22d35c$var$SRGBToLinear(color.r);
        this.g = $0d79572b4b22d35c$var$SRGBToLinear(color.g);
        this.b = $0d79572b4b22d35c$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $0d79572b4b22d35c$var$LinearToSRGB(color.r);
        this.g = $0d79572b4b22d35c$var$LinearToSRGB(color.g);
        this.b = $0d79572b4b22d35c$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $0d79572b4b22d35c$export$561f394b24edfcaa) {
        $0d79572b4b22d35c$export$5e6fd513f44698c.fromWorkingColorSpace($0d79572b4b22d35c$var$_color.copy(this), colorSpace1);
        return Math.round($0d79572b4b22d35c$var$clamp($0d79572b4b22d35c$var$_color.r * 255, 0, 255)) * 65536 + Math.round($0d79572b4b22d35c$var$clamp($0d79572b4b22d35c$var$_color.g * 255, 0, 255)) * 256 + Math.round($0d79572b4b22d35c$var$clamp($0d79572b4b22d35c$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $0d79572b4b22d35c$export$561f394b24edfcaa) {
        return ("000000" + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $0d79572b4b22d35c$export$5e6fd513f44698c.fromWorkingColorSpace($0d79572b4b22d35c$var$_color.copy(this), colorSpace1);
        const r = $0d79572b4b22d35c$var$_color.r, g = $0d79572b4b22d35c$var$_color.g, b = $0d79572b4b22d35c$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace) {
        $0d79572b4b22d35c$export$5e6fd513f44698c.fromWorkingColorSpace($0d79572b4b22d35c$var$_color.copy(this), colorSpace1);
        target.r = $0d79572b4b22d35c$var$_color.r;
        target.g = $0d79572b4b22d35c$var$_color.g;
        target.b = $0d79572b4b22d35c$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $0d79572b4b22d35c$export$561f394b24edfcaa) {
        $0d79572b4b22d35c$export$5e6fd513f44698c.fromWorkingColorSpace($0d79572b4b22d35c$var$_color.copy(this), colorSpace1);
        const r = $0d79572b4b22d35c$var$_color.r, g = $0d79572b4b22d35c$var$_color.g, b = $0d79572b4b22d35c$var$_color.b;
        if (colorSpace1 !== $0d79572b4b22d35c$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($0d79572b4b22d35c$var$_hslA);
        return this.setHSL($0d79572b4b22d35c$var$_hslA.h + h, $0d79572b4b22d35c$var$_hslA.s + s, $0d79572b4b22d35c$var$_hslA.l + l);
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($0d79572b4b22d35c$var$_hslA);
        color.getHSL($0d79572b4b22d35c$var$_hslB);
        const h = $0d79572b4b22d35c$var$lerp($0d79572b4b22d35c$var$_hslA.h, $0d79572b4b22d35c$var$_hslB.h, alpha);
        const s = $0d79572b4b22d35c$var$lerp($0d79572b4b22d35c$var$_hslA.s, $0d79572b4b22d35c$var$_hslB.s, alpha);
        const l = $0d79572b4b22d35c$var$lerp($0d79572b4b22d35c$var$_hslA.l, $0d79572b4b22d35c$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $0d79572b4b22d35c$var$_color = /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e();
$0d79572b4b22d35c$export$892596cec99bc70e.NAMES = $0d79572b4b22d35c$var$_colorKeywords;
let $0d79572b4b22d35c$var$_materialId = 0;
class $0d79572b4b22d35c$export$a2d8b23205c25948 extends $0d79572b4b22d35c$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, "id", {
            value: $0d79572b4b22d35c$var$_materialId++
        });
        this.uuid = $0d79572b4b22d35c$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.blending = $0d79572b4b22d35c$export$5b29a26d96ee6af0;
        this.side = $0d79572b4b22d35c$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = $0d79572b4b22d35c$export$d5773124e86cf28c;
        this.blendDst = $0d79572b4b22d35c$export$11d468cc7f19e971;
        this.blendEquation = $0d79572b4b22d35c$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.blendColor = new $0d79572b4b22d35c$export$892596cec99bc70e(0, 0, 0);
        this.blendAlpha = 0;
        this.depthFunc = $0d79572b4b22d35c$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $0d79572b4b22d35c$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $0d79572b4b22d35c$export$9f542ae4b5baca34;
        this.stencilZFail = $0d79572b4b22d35c$export$9f542ae4b5baca34;
        this.stencilZPass = $0d79572b4b22d35c$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $0d79572b4b22d35c$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $0d79572b4b22d35c$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $0d79572b4b22d35c$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $0d79572b4b22d35c$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $0d79572b4b22d35c$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $0d79572b4b22d35c$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $0d79572b4b22d35c$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $0d79572b4b22d35c$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $0d79572b4b22d35c$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $0d79572b4b22d35c$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    onBuild() {
        console.warn("Material: onBuild() has been removed."); // @deprecated, r166
    }
}
class $0d79572b4b22d35c$export$55cbcc9b622fe1f5 extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = "MeshBasicMaterial";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $0d79572b4b22d35c$export$d93cc409a0768c5f();
        this.combine = $0d79572b4b22d35c$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $0d79572b4b22d35c$var$_tables = /*@__PURE__*/ $0d79572b4b22d35c$var$_generateTables();
function $0d79572b4b22d35c$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $0d79572b4b22d35c$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
    val = $0d79572b4b22d35c$var$clamp(val, -65504, 65504);
    $0d79572b4b22d35c$var$_tables.floatView[0] = val;
    const f = $0d79572b4b22d35c$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $0d79572b4b22d35c$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $0d79572b4b22d35c$var$_tables.shiftTable[e]);
}
// float16 to float32
function $0d79572b4b22d35c$var$fromHalfFloat(val) {
    const m = val >> 10;
    $0d79572b4b22d35c$var$_tables.uint32View[0] = $0d79572b4b22d35c$var$_tables.mantissaTable[$0d79572b4b22d35c$var$_tables.offsetTable[m] + (val & 0x3ff)] + $0d79572b4b22d35c$var$_tables.exponentTable[m];
    return $0d79572b4b22d35c$var$_tables.floatView[0];
}
const $0d79572b4b22d35c$export$11ce8b759162cc80 = {
    toHalfFloat: $0d79572b4b22d35c$var$toHalfFloat,
    fromHalfFloat: $0d79572b4b22d35c$var$fromHalfFloat
};
const $0d79572b4b22d35c$var$_vector$9 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vector2$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1();
class $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = true;
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $0d79572b4b22d35c$export$763e8360f4d7f77d;
        this.updateRanges = [];
        this.gpuType = $0d79572b4b22d35c$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $0d79572b4b22d35c$var$_vector2$1.fromBufferAttribute(this, i);
            $0d79572b4b22d35c$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $0d79572b4b22d35c$var$_vector2$1.x, $0d79572b4b22d35c$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $0d79572b4b22d35c$var$_vector$9.fromBufferAttribute(this, i);
            $0d79572b4b22d35c$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $0d79572b4b22d35c$var$_vector$9.x, $0d79572b4b22d35c$var$_vector$9.y, $0d79572b4b22d35c$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0d79572b4b22d35c$var$_vector$9.fromBufferAttribute(this, i);
            $0d79572b4b22d35c$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $0d79572b4b22d35c$var$_vector$9.x, $0d79572b4b22d35c$var$_vector$9.y, $0d79572b4b22d35c$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0d79572b4b22d35c$var$_vector$9.fromBufferAttribute(this, i);
            $0d79572b4b22d35c$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $0d79572b4b22d35c$var$_vector$9.x, $0d79572b4b22d35c$var$_vector$9.y, $0d79572b4b22d35c$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0d79572b4b22d35c$var$_vector$9.fromBufferAttribute(this, i);
            $0d79572b4b22d35c$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $0d79572b4b22d35c$var$_vector$9.x, $0d79572b4b22d35c$var$_vector$9.y, $0d79572b4b22d35c$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $0d79572b4b22d35c$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $0d79572b4b22d35c$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $0d79572b4b22d35c$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $0d79572b4b22d35c$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $0d79572b4b22d35c$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $0d79572b4b22d35c$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $0d79572b4b22d35c$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $0d79572b4b22d35c$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $0d79572b4b22d35c$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $0d79572b4b22d35c$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0d79572b4b22d35c$var$normalize(x, this.array);
            y = $0d79572b4b22d35c$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0d79572b4b22d35c$var$normalize(x, this.array);
            y = $0d79572b4b22d35c$var$normalize(y, this.array);
            z = $0d79572b4b22d35c$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0d79572b4b22d35c$var$normalize(x, this.array);
            y = $0d79572b4b22d35c$var$normalize(y, this.array);
            z = $0d79572b4b22d35c$var$normalize(z, this.array);
            w = $0d79572b4b22d35c$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $0d79572b4b22d35c$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
}
//
class $0d79572b4b22d35c$export$f9ff2d6a20248cbf extends $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $0d79572b4b22d35c$export$cacc90cf35d11cdd extends $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $0d79572b4b22d35c$export$baaa85a1a812c157 extends $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $0d79572b4b22d35c$export$2b755a102ccdcefe extends $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $0d79572b4b22d35c$export$640a853f68025f2e extends $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $0d79572b4b22d35c$export$46b369aed2968a0a extends $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $0d79572b4b22d35c$export$7eb8c9fa25cd5bd6 extends $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $0d79572b4b22d35c$export$dbd3698c64958d69 extends $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $0d79572b4b22d35c$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $0d79572b4b22d35c$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $0d79572b4b22d35c$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $0d79572b4b22d35c$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $0d79572b4b22d35c$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $0d79572b4b22d35c$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $0d79572b4b22d35c$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $0d79572b4b22d35c$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $0d79572b4b22d35c$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $0d79572b4b22d35c$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $0d79572b4b22d35c$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $0d79572b4b22d35c$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $0d79572b4b22d35c$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $0d79572b4b22d35c$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $0d79572b4b22d35c$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $0d79572b4b22d35c$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0d79572b4b22d35c$var$normalize(x, this.array);
            y = $0d79572b4b22d35c$var$normalize(y, this.array);
        }
        this.array[index + 0] = $0d79572b4b22d35c$var$toHalfFloat(x);
        this.array[index + 1] = $0d79572b4b22d35c$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0d79572b4b22d35c$var$normalize(x, this.array);
            y = $0d79572b4b22d35c$var$normalize(y, this.array);
            z = $0d79572b4b22d35c$var$normalize(z, this.array);
        }
        this.array[index + 0] = $0d79572b4b22d35c$var$toHalfFloat(x);
        this.array[index + 1] = $0d79572b4b22d35c$var$toHalfFloat(y);
        this.array[index + 2] = $0d79572b4b22d35c$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $0d79572b4b22d35c$var$normalize(x, this.array);
            y = $0d79572b4b22d35c$var$normalize(y, this.array);
            z = $0d79572b4b22d35c$var$normalize(z, this.array);
            w = $0d79572b4b22d35c$var$normalize(w, this.array);
        }
        this.array[index + 0] = $0d79572b4b22d35c$var$toHalfFloat(x);
        this.array[index + 1] = $0d79572b4b22d35c$var$toHalfFloat(y);
        this.array[index + 2] = $0d79572b4b22d35c$var$toHalfFloat(z);
        this.array[index + 3] = $0d79572b4b22d35c$var$toHalfFloat(w);
        return this;
    }
}
class $0d79572b4b22d35c$export$cbe7a62641830ebd extends $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let $0d79572b4b22d35c$var$_id$2 = 0;
const $0d79572b4b22d35c$var$_m1$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_obj = /*@__PURE__*/ new $0d79572b4b22d35c$export$e4dd07dff30cc924();
const $0d79572b4b22d35c$var$_offset = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_box$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
const $0d79572b4b22d35c$var$_boxMorphTargets = /*@__PURE__*/ new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
const $0d79572b4b22d35c$var$_vector$8 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$b7be63a67df8959 extends $0d79572b4b22d35c$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, "id", {
            value: $0d79572b4b22d35c$var$_id$2++
        });
        this.uuid = $0d79572b4b22d35c$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($0d79572b4b22d35c$var$arrayNeedsUint32(index) ? $0d79572b4b22d35c$export$7eb8c9fa25cd5bd6 : $0d79572b4b22d35c$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $0d79572b4b22d35c$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $0d79572b4b22d35c$var$_m1$2.makeRotationFromQuaternion(q);
        this.applyMatrix4($0d79572b4b22d35c$var$_m1$2);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $0d79572b4b22d35c$var$_m1$2.makeRotationX(angle);
        this.applyMatrix4($0d79572b4b22d35c$var$_m1$2);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $0d79572b4b22d35c$var$_m1$2.makeRotationY(angle);
        this.applyMatrix4($0d79572b4b22d35c$var$_m1$2);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $0d79572b4b22d35c$var$_m1$2.makeRotationZ(angle);
        this.applyMatrix4($0d79572b4b22d35c$var$_m1$2);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $0d79572b4b22d35c$var$_m1$2.makeTranslation(x, y, z);
        this.applyMatrix4($0d79572b4b22d35c$var$_m1$2);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $0d79572b4b22d35c$var$_m1$2.makeScale(x, y, z);
        this.applyMatrix4($0d79572b4b22d35c$var$_m1$2);
        return this;
    }
    lookAt(vector) {
        $0d79572b4b22d35c$var$_obj.lookAt(vector);
        $0d79572b4b22d35c$var$_obj.updateMatrix();
        this.applyMatrix4($0d79572b4b22d35c$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($0d79572b4b22d35c$var$_offset).negate();
        this.translate($0d79572b4b22d35c$var$_offset.x, $0d79572b4b22d35c$var$_offset.y, $0d79572b4b22d35c$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this);
            this.boundingBox.set(new $0d79572b4b22d35c$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $0d79572b4b22d35c$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $0d79572b4b22d35c$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $0d79572b4b22d35c$var$_vector$8.addVectors(this.boundingBox.min, $0d79572b4b22d35c$var$_box$2.min);
                    this.boundingBox.expandByPoint($0d79572b4b22d35c$var$_vector$8);
                    $0d79572b4b22d35c$var$_vector$8.addVectors(this.boundingBox.max, $0d79572b4b22d35c$var$_box$2.max);
                    this.boundingBox.expandByPoint($0d79572b4b22d35c$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($0d79572b4b22d35c$var$_box$2.min);
                    this.boundingBox.expandByPoint($0d79572b4b22d35c$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $0d79572b4b22d35c$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this);
            this.boundingSphere.set(new $0d79572b4b22d35c$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $0d79572b4b22d35c$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $0d79572b4b22d35c$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $0d79572b4b22d35c$var$_vector$8.addVectors($0d79572b4b22d35c$var$_box$2.min, $0d79572b4b22d35c$var$_boxMorphTargets.min);
                    $0d79572b4b22d35c$var$_box$2.expandByPoint($0d79572b4b22d35c$var$_vector$8);
                    $0d79572b4b22d35c$var$_vector$8.addVectors($0d79572b4b22d35c$var$_box$2.max, $0d79572b4b22d35c$var$_boxMorphTargets.max);
                    $0d79572b4b22d35c$var$_box$2.expandByPoint($0d79572b4b22d35c$var$_vector$8);
                } else {
                    $0d79572b4b22d35c$var$_box$2.expandByPoint($0d79572b4b22d35c$var$_boxMorphTargets.min);
                    $0d79572b4b22d35c$var$_box$2.expandByPoint($0d79572b4b22d35c$var$_boxMorphTargets.max);
                }
            }
            $0d79572b4b22d35c$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $0d79572b4b22d35c$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($0d79572b4b22d35c$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $0d79572b4b22d35c$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $0d79572b4b22d35c$var$_offset.fromBufferAttribute(position, j);
                        $0d79572b4b22d35c$var$_vector$8.add($0d79572b4b22d35c$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($0d79572b4b22d35c$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute("tangent") === false) this.setAttribute("tangent", new $0d79572b4b22d35c$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute("tangent");
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $0d79572b4b22d35c$export$64b5c384219d3699();
            tan2[i] = new $0d79572b4b22d35c$export$64b5c384219d3699();
        }
        const vA = new $0d79572b4b22d35c$export$64b5c384219d3699(), vB = new $0d79572b4b22d35c$export$64b5c384219d3699(), vC = new $0d79572b4b22d35c$export$64b5c384219d3699(), uvA = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), uvB = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), uvC = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), sdir = new $0d79572b4b22d35c$export$64b5c384219d3699(), tdir = new $0d79572b4b22d35c$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $0d79572b4b22d35c$export$64b5c384219d3699(), tmp2 = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const n = new $0d79572b4b22d35c$export$64b5c384219d3699(), n2 = new $0d79572b4b22d35c$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $0d79572b4b22d35c$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $0d79572b4b22d35c$export$64b5c384219d3699(), pB = new $0d79572b4b22d35c$export$64b5c384219d3699(), pC = new $0d79572b4b22d35c$export$64b5c384219d3699();
            const nA = new $0d79572b4b22d35c$export$64b5c384219d3699(), nB = new $0d79572b4b22d35c$export$64b5c384219d3699(), nC = new $0d79572b4b22d35c$export$64b5c384219d3699();
            const cb = new $0d79572b4b22d35c$export$64b5c384219d3699(), ab = new $0d79572b4b22d35c$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $0d79572b4b22d35c$var$_vector$8.fromBufferAttribute(normals, i);
            $0d79572b4b22d35c$var$_vector$8.normalize();
            normals.setXYZ(i, $0d79572b4b22d35c$var$_vector$8.x, $0d79572b4b22d35c$var$_vector$8.y, $0d79572b4b22d35c$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $0d79572b4b22d35c$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $0d79572b4b22d35c$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $0d79572b4b22d35c$var$_inverseMatrix$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_ray$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$a186db52eed6d40e();
const $0d79572b4b22d35c$var$_sphere$6 = /*@__PURE__*/ new $0d79572b4b22d35c$export$805e8b72413ccaba();
const $0d79572b4b22d35c$var$_sphereHitAt = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vA$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vB$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vC$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_tempA = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_morphA = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_intersectionPoint = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_intersectionPointWorld = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$e176487c05830cc5 extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(geometry = new $0d79572b4b22d35c$export$b7be63a67df8959(), material = new $0d79572b4b22d35c$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $0d79572b4b22d35c$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $0d79572b4b22d35c$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $0d79572b4b22d35c$var$_morphA.addScaledVector($0d79572b4b22d35c$var$_tempA, influence);
                else $0d79572b4b22d35c$var$_morphA.addScaledVector($0d79572b4b22d35c$var$_tempA.sub(target), influence);
            }
            target.add($0d79572b4b22d35c$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0d79572b4b22d35c$var$_sphere$6.copy(geometry.boundingSphere);
        $0d79572b4b22d35c$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $0d79572b4b22d35c$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($0d79572b4b22d35c$var$_sphere$6.containsPoint($0d79572b4b22d35c$var$_ray$3.origin) === false) {
            if ($0d79572b4b22d35c$var$_ray$3.intersectSphere($0d79572b4b22d35c$var$_sphere$6, $0d79572b4b22d35c$var$_sphereHitAt) === null) return;
            if ($0d79572b4b22d35c$var$_ray$3.origin.distanceToSquared($0d79572b4b22d35c$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $0d79572b4b22d35c$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $0d79572b4b22d35c$var$_ray$3.copy(raycaster.ray).applyMatrix4($0d79572b4b22d35c$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($0d79572b4b22d35c$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $0d79572b4b22d35c$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $0d79572b4b22d35c$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $0d79572b4b22d35c$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $0d79572b4b22d35c$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $0d79572b4b22d35c$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $0d79572b4b22d35c$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $0d79572b4b22d35c$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $0d79572b4b22d35c$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $0d79572b4b22d35c$var$_intersectionPointWorld.copy(point);
    $0d79572b4b22d35c$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($0d79572b4b22d35c$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $0d79572b4b22d35c$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $0d79572b4b22d35c$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $0d79572b4b22d35c$var$_vA$1);
    object.getVertexPosition(b, $0d79572b4b22d35c$var$_vB$1);
    object.getVertexPosition(c, $0d79572b4b22d35c$var$_vC$1);
    const intersection = $0d79572b4b22d35c$var$checkIntersection$1(object, material, raycaster, ray, $0d79572b4b22d35c$var$_vA$1, $0d79572b4b22d35c$var$_vB$1, $0d79572b4b22d35c$var$_vC$1, $0d79572b4b22d35c$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new $0d79572b4b22d35c$export$64b5c384219d3699();
        $0d79572b4b22d35c$export$5a465592bfe74b48.getBarycoord($0d79572b4b22d35c$var$_intersectionPoint, $0d79572b4b22d35c$var$_vA$1, $0d79572b4b22d35c$var$_vB$1, $0d79572b4b22d35c$var$_vC$1, barycoord);
        if (uv) intersection.uv = $0d79572b4b22d35c$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $0d79572b4b22d35c$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $0d79572b4b22d35c$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $0d79572b4b22d35c$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $0d79572b4b22d35c$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $0d79572b4b22d35c$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $0d79572b4b22d35c$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $0d79572b4b22d35c$export$5a465592bfe74b48.getNormal($0d79572b4b22d35c$var$_vA$1, $0d79572b4b22d35c$var$_vB$1, $0d79572b4b22d35c$var$_vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
class $0d79572b4b22d35c$export$33e43285f7406bd5 extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $0d79572b4b22d35c$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $0d79572b4b22d35c$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $0d79572b4b22d35c$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $0d79572b4b22d35c$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $0d79572b4b22d35c$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $0d79572b4b22d35c$var$getUnlitUniformColorSpace(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $0d79572b4b22d35c$export$d8ecdf8615bfea69 = {
    clone: $0d79572b4b22d35c$var$cloneUniforms,
    merge: $0d79572b4b22d35c$var$mergeUniforms
};
var $0d79572b4b22d35c$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $0d79572b4b22d35c$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $0d79572b4b22d35c$export$83c7d75d550a8b0d extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $0d79572b4b22d35c$var$default_vertex;
        this.fragmentShader = $0d79572b4b22d35c$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv1": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $0d79572b4b22d35c$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $0d79572b4b22d35c$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $0d79572b4b22d35c$export$79f141de891a5fed extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = "Camera";
        this.matrixWorldInverse = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        this.coordinateSystem = $0d79572b4b22d35c$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0d79572b4b22d35c$var$_v3$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_minTarget = /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1();
const $0d79572b4b22d35c$var$_maxTarget = /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1();
class $0d79572b4b22d35c$export$74e4ae24825f68d7 extends $0d79572b4b22d35c$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $0d79572b4b22d35c$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($0d79572b4b22d35c$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $0d79572b4b22d35c$var$RAD2DEG * 2 * Math.atan(Math.tan($0d79572b4b22d35c$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $0d79572b4b22d35c$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($0d79572b4b22d35c$var$_v3$1.x, $0d79572b4b22d35c$var$_v3$1.y).multiplyScalar(-distance / $0d79572b4b22d35c$var$_v3$1.z);
        $0d79572b4b22d35c$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($0d79572b4b22d35c$var$_v3$1.x, $0d79572b4b22d35c$var$_v3$1.y).multiplyScalar(-distance / $0d79572b4b22d35c$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Copies the result into the target Vector2, where x is width and y is height.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $0d79572b4b22d35c$var$_minTarget, $0d79572b4b22d35c$var$_maxTarget);
        return target.subVectors($0d79572b4b22d35c$var$_maxTarget, $0d79572b4b22d35c$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($0d79572b4b22d35c$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $0d79572b4b22d35c$var$fov = -90; // negative fov is not an error
const $0d79572b4b22d35c$var$aspect = 1;
class $0d79572b4b22d35c$export$d0cdd0bd804995de extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        this.activeMipmapLevel = 0;
        const cameraPX = new $0d79572b4b22d35c$export$74e4ae24825f68d7($0d79572b4b22d35c$var$fov, $0d79572b4b22d35c$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $0d79572b4b22d35c$export$74e4ae24825f68d7($0d79572b4b22d35c$var$fov, $0d79572b4b22d35c$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $0d79572b4b22d35c$export$74e4ae24825f68d7($0d79572b4b22d35c$var$fov, $0d79572b4b22d35c$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $0d79572b4b22d35c$export$74e4ae24825f68d7($0d79572b4b22d35c$var$fov, $0d79572b4b22d35c$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $0d79572b4b22d35c$export$74e4ae24825f68d7($0d79572b4b22d35c$var$fov, $0d79572b4b22d35c$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $0d79572b4b22d35c$export$74e4ae24825f68d7($0d79572b4b22d35c$var$fov, $0d79572b4b22d35c$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $0d79572b4b22d35c$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $0d79572b4b22d35c$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $0d79572b4b22d35c$export$ee2e5a18258a4049 extends $0d79572b4b22d35c$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $0d79572b4b22d35c$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $0d79572b4b22d35c$export$ac386671d651941e extends $0d79572b4b22d35c$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new $0d79572b4b22d35c$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $0d79572b4b22d35c$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $0d79572b4b22d35c$export$33e43285f7406bd5(5, 5, 5);
        const material = new $0d79572b4b22d35c$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $0d79572b4b22d35c$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $0d79572b4b22d35c$export$d9f0486e75b5ace,
            blending: $0d79572b4b22d35c$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $0d79572b4b22d35c$export$5d8599b6a933fb1b) texture.minFilter = $0d79572b4b22d35c$export$8a72f490b25c56c8;
        const camera = new $0d79572b4b22d35c$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $0d79572b4b22d35c$var$_vector1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vector2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_normalMatrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918();
class $0d79572b4b22d35c$export$7ff5ac152ef991b0 {
    constructor(normal = new $0d79572b4b22d35c$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $0d79572b4b22d35c$var$_vector1.subVectors(c, b).cross($0d79572b4b22d35c$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($0d79572b4b22d35c$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $0d79572b4b22d35c$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($0d79572b4b22d35c$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0d79572b4b22d35c$var$_sphere$5 = /*@__PURE__*/ new $0d79572b4b22d35c$export$805e8b72413ccaba();
const $0d79572b4b22d35c$var$_vector$7 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$35efe6f4c85463d2 {
    constructor(p0 = new $0d79572b4b22d35c$export$7ff5ac152ef991b0(), p1 = new $0d79572b4b22d35c$export$7ff5ac152ef991b0(), p2 = new $0d79572b4b22d35c$export$7ff5ac152ef991b0(), p3 = new $0d79572b4b22d35c$export$7ff5ac152ef991b0(), p4 = new $0d79572b4b22d35c$export$7ff5ac152ef991b0(), p5 = new $0d79572b4b22d35c$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $0d79572b4b22d35c$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $0d79572b4b22d35c$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $0d79572b4b22d35c$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $0d79572b4b22d35c$var$_sphere$5.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $0d79572b4b22d35c$var$_sphere$5.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($0d79572b4b22d35c$var$_sphere$5);
    }
    intersectsSprite(sprite) {
        $0d79572b4b22d35c$var$_sphere$5.center.set(0, 0, 0);
        $0d79572b4b22d35c$var$_sphere$5.radius = 0.7071067811865476;
        $0d79572b4b22d35c$var$_sphere$5.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($0d79572b4b22d35c$var$_sphere$5);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $0d79572b4b22d35c$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $0d79572b4b22d35c$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $0d79572b4b22d35c$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($0d79572b4b22d35c$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $0d79572b4b22d35c$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $0d79572b4b22d35c$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $0d79572b4b22d35c$export$967d831af31f69ce extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $0d79572b4b22d35c$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $0d79572b4b22d35c$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif";
var $0d79572b4b22d35c$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $0d79572b4b22d35c$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $0d79572b4b22d35c$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	#ifdef ALPHA_TO_COVERAGE\n	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n	if ( diffuseColor.a == 0.0 ) discard;\n	#else\n	if ( diffuseColor.a < alphaTest ) discard;\n	#endif\n#endif";
var $0d79572b4b22d35c$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $0d79572b4b22d35c$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $0d79572b4b22d35c$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $0d79572b4b22d35c$var$batching_pars_vertex = "#ifdef USE_BATCHING\n	#if ! defined( GL_ANGLE_multi_draw )\n	#define gl_DrawID _gl_DrawID\n	uniform int _gl_DrawID;\n	#endif\n	uniform highp sampler2D batchingTexture;\n	uniform highp usampler2D batchingIdTexture;\n	mat4 getBatchingMatrix( const in float i ) {\n		int size = textureSize( batchingTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n	float getIndirectIndex( const in int i ) {\n		int size = textureSize( batchingIdTexture, 0 ).x;\n		int x = i % size;\n		int y = i / size;\n		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n	}\n#endif\n#ifdef USE_BATCHING_COLOR\n	uniform sampler2D batchingColorTexture;\n	vec3 getBatchingColor( const in float i ) {\n		int size = textureSize( batchingColorTexture, 0 ).x;\n		int j = int( i );\n		int x = j % size;\n		int y = j / size;\n		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n	}\n#endif";
var $0d79572b4b22d35c$var$batching_vertex = "#ifdef USE_BATCHING\n	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $0d79572b4b22d35c$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif";
var $0d79572b4b22d35c$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $0d79572b4b22d35c$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
var $0d79572b4b22d35c$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
var $0d79572b4b22d35c$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $0d79572b4b22d35c$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#ifdef ALPHA_TO_COVERAGE\n		float distanceToPlane, distanceGradient;\n		float clipOpacity = 1.0;\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n			distanceGradient = fwidth( distanceToPlane ) / 2.0;\n			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			if ( clipOpacity == 0.0 ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			float unionClipOpacity = 1.0;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n				distanceGradient = fwidth( distanceToPlane ) / 2.0;\n				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			}\n			#pragma unroll_loop_end\n			clipOpacity *= 1.0 - unionClipOpacity;\n		#endif\n		diffuseColor.a *= clipOpacity;\n		if ( diffuseColor.a == 0.0 ) discard;\n	#else\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			bool clipped = true;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n			}\n			#pragma unroll_loop_end\n			if ( clipped ) discard;\n		#endif\n	#endif\n#endif";
var $0d79572b4b22d35c$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $0d79572b4b22d35c$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $0d79572b4b22d35c$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $0d79572b4b22d35c$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $0d79572b4b22d35c$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $0d79572b4b22d35c$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	varying vec3 vColor;\n#endif";
var $0d79572b4b22d35c$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n	vColor.xyz *= batchingColor.xyz;\n#endif";
var $0d79572b4b22d35c$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $0d79572b4b22d35c$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $0d79572b4b22d35c$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n	vec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n	mat3 bm = mat3( batchingMatrix );\n	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n	transformedNormal = bm * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = bm * transformedTangent;\n	#endif\n#endif\n#ifdef USE_INSTANCING\n	mat3 im = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n	transformedNormal = im * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = im * transformedTangent;\n	#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $0d79572b4b22d35c$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $0d79572b4b22d35c$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $0d79572b4b22d35c$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $0d79572b4b22d35c$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $0d79572b4b22d35c$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $0d79572b4b22d35c$var$colorspace_pars_fragment = "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n	vec3( 0.8224621, 0.177538, 0.0 ),\n	vec3( 0.0331941, 0.9668058, 0.0 ),\n	vec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n	vec3( 1.2249401, - 0.2249404, 0.0 ),\n	vec3( - 0.0420569, 1.0420571, 0.0 ),\n	vec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $0d79572b4b22d35c$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $0d79572b4b22d35c$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	uniform mat3 envMapRotation;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $0d79572b4b22d35c$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $0d79572b4b22d35c$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $0d79572b4b22d35c$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $0d79572b4b22d35c$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $0d79572b4b22d35c$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $0d79572b4b22d35c$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $0d79572b4b22d35c$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $0d79572b4b22d35c$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
var $0d79572b4b22d35c$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $0d79572b4b22d35c$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $0d79572b4b22d35c$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
var $0d79572b4b22d35c$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if ( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $0d79572b4b22d35c$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif";
var $0d79572b4b22d35c$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $0d79572b4b22d35c$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
var $0d79572b4b22d35c$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $0d79572b4b22d35c$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
var $0d79572b4b22d35c$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n	material.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	if( material.anisotropy == 0.0 ) {\n		anisotropyV = vec2( 1.0, 0.0 );\n	} else {\n		anisotropyV /= material.anisotropy;\n		material.anisotropy = saturate( material.anisotropy );\n	}\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $0d79572b4b22d35c$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	float dispersion;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $0d79572b4b22d35c$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $0d79572b4b22d35c$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $0d79572b4b22d35c$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $0d79572b4b22d35c$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $0d79572b4b22d35c$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $0d79572b4b22d35c$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $0d79572b4b22d35c$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	vFragDepth = 1.0 + gl_Position.w;\n	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $0d79572b4b22d35c$var$map_fragment = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
var $0d79572b4b22d35c$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $0d79572b4b22d35c$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $0d79572b4b22d35c$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $0d79572b4b22d35c$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $0d79572b4b22d35c$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $0d79572b4b22d35c$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n	float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n	}\n#endif";
var $0d79572b4b22d35c$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var $0d79572b4b22d35c$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
var $0d79572b4b22d35c$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	#ifndef USE_INSTANCING_MORPH\n		uniform float morphTargetBaseInfluence;\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	#endif\n	uniform sampler2DArray morphTargetsTexture;\n	uniform ivec2 morphTargetsTextureSize;\n	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n		int y = texelIndex / morphTargetsTextureSize.x;\n		int x = texelIndex - y * morphTargetsTextureSize.x;\n		ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n		return texelFetch( morphTargetsTexture, morphUV, 0 );\n	}\n#endif";
var $0d79572b4b22d35c$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
var $0d79572b4b22d35c$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $0d79572b4b22d35c$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $0d79572b4b22d35c$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $0d79572b4b22d35c$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $0d79572b4b22d35c$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $0d79572b4b22d35c$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
var $0d79572b4b22d35c$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $0d79572b4b22d35c$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $0d79572b4b22d35c$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
var $0d79572b4b22d35c$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var $0d79572b4b22d35c$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $0d79572b4b22d35c$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n	if( v <= 0.0 )\n		return vec4( 0., 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec4( 1., 1., 1., 1. );\n	float vuf;\n	float af = modf( v * PackFactors.a, vuf );\n	float bf = modf( vuf * ShiftRight8, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n	if( v <= 0.0 )\n		return vec3( 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec3( 1., 1., 1. );\n	float vuf;\n	float bf = modf( v * PackFactors.b, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n	if( v <= 0.0 )\n		return vec2( 0., 0. );\n	if( v >= 1.0 )\n		return vec2( 1., 1. );\n	float vuf;\n	float gf = modf( v * 256., vuf );\n	return vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n	return dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $0d79572b4b22d35c$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $0d79572b4b22d35c$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n	mvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $0d79572b4b22d35c$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $0d79572b4b22d35c$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $0d79572b4b22d35c$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $0d79572b4b22d35c$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $0d79572b4b22d35c$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		\n		float lightToPositionLength = length( lightToPosition );\n		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;\n			vec3 bd3D = normalize( lightToPosition );\n			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n				shadow = (\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n				) * ( 1.0 / 9.0 );\n			#else\n				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n			#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n#endif";
var $0d79572b4b22d35c$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $0d79572b4b22d35c$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
var $0d79572b4b22d35c$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $0d79572b4b22d35c$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $0d79572b4b22d35c$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	mat4 getBoneMatrix( const in float i ) {\n		int size = textureSize( boneTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n#endif";
var $0d79572b4b22d35c$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $0d79572b4b22d35c$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $0d79572b4b22d35c$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $0d79572b4b22d35c$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $0d79572b4b22d35c$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $0d79572b4b22d35c$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n	vec3( 1.6605, - 0.1246, - 0.0182 ),\n	vec3( - 0.5876, 1.1329, - 0.1006 ),\n	vec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n	vec3( 0.6274, 0.0691, 0.0164 ),\n	vec3( 0.3293, 0.9195, 0.0880 ),\n	vec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n	vec3 x2 = x * x;\n	vec3 x4 = x2 * x2;\n	return + 15.5 * x4 * x2\n		- 40.14 * x4 * x\n		+ 31.96 * x4\n		- 6.868 * x2 * x\n		+ 0.4298 * x2\n		+ 0.1191 * x\n		- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n	const mat3 AgXInsetMatrix = mat3(\n		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n	);\n	const mat3 AgXOutsetMatrix = mat3(\n		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n	);\n	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;\n	color *= toneMappingExposure;\n	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n	color = AgXInsetMatrix * color;\n	color = max( color, 1e-10 );	color = log2( color );\n	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n	color = clamp( color, 0.0, 1.0 );\n	color = agxDefaultContrastApprox( color );\n	color = AgXOutsetMatrix * color;\n	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n	color = clamp( color, 0.0, 1.0 );\n	return color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n	const float StartCompression = 0.8 - 0.04;\n	const float Desaturation = 0.15;\n	color *= toneMappingExposure;\n	float x = min( color.r, min( color.g, color.b ) );\n	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n	color -= offset;\n	float peak = max( color.r, max( color.g, color.b ) );\n	if ( peak < StartCompression ) return color;\n	float d = 1. - StartCompression;\n	float newPeak = 1. - d * d / ( peak + d - StartCompression );\n	color *= newPeak / peak;\n	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n	return mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $0d79572b4b22d35c$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $0d79572b4b22d35c$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec4 transmittedLight;\n		vec3 transmittance;\n		#ifdef USE_DISPERSION\n			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n			for ( int i = 0; i < 3; i ++ ) {\n				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n				vec3 refractedRayExit = position + transmissionRay;\n		\n				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n				vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n				refractionCoords += 1.0;\n				refractionCoords /= 2.0;\n		\n				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n				transmittedLight[ i ] = transmissionSample[ i ];\n				transmittedLight.a += transmissionSample.a;\n				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n			}\n			transmittedLight.a /= 3.0;\n		\n		#else\n		\n			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n			vec3 refractedRayExit = position + transmissionRay;\n			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n			vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n			refractionCoords += 1.0;\n			refractionCoords /= 2.0;\n			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		\n		#endif\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif";
var $0d79572b4b22d35c$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $0d79572b4b22d35c$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $0d79572b4b22d35c$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $0d79572b4b22d35c$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_BATCHING\n		worldPosition = batchingMatrix * worldPosition;\n	#endif\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $0d79572b4b22d35c$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $0d79572b4b22d35c$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $0d79572b4b22d35c$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $0d79572b4b22d35c$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $0d79572b4b22d35c$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#elif DEPTH_PACKING == 3202\n		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n	#elif DEPTH_PACKING == 3203\n		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n	#endif\n}";
const $0d79572b4b22d35c$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $0d79572b4b22d35c$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $0d79572b4b22d35c$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $0d79572b4b22d35c$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $0d79572b4b22d35c$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $0d79572b4b22d35c$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0d79572b4b22d35c$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $0d79572b4b22d35c$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $0d79572b4b22d35c$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const $0d79572b4b22d35c$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0d79572b4b22d35c$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $0d79572b4b22d35c$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n	uniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0d79572b4b22d35c$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $0d79572b4b22d35c$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $0d79572b4b22d35c$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const $0d79572b4b22d35c$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix[ 3 ];\n	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $0d79572b4b22d35c$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const $0d79572b4b22d35c$export$955f9f2e84c43c8b = {
    alphahash_fragment: $0d79572b4b22d35c$var$alphahash_fragment,
    alphahash_pars_fragment: $0d79572b4b22d35c$var$alphahash_pars_fragment,
    alphamap_fragment: $0d79572b4b22d35c$var$alphamap_fragment,
    alphamap_pars_fragment: $0d79572b4b22d35c$var$alphamap_pars_fragment,
    alphatest_fragment: $0d79572b4b22d35c$var$alphatest_fragment,
    alphatest_pars_fragment: $0d79572b4b22d35c$var$alphatest_pars_fragment,
    aomap_fragment: $0d79572b4b22d35c$var$aomap_fragment,
    aomap_pars_fragment: $0d79572b4b22d35c$var$aomap_pars_fragment,
    batching_pars_vertex: $0d79572b4b22d35c$var$batching_pars_vertex,
    batching_vertex: $0d79572b4b22d35c$var$batching_vertex,
    begin_vertex: $0d79572b4b22d35c$var$begin_vertex,
    beginnormal_vertex: $0d79572b4b22d35c$var$beginnormal_vertex,
    bsdfs: $0d79572b4b22d35c$var$bsdfs,
    iridescence_fragment: $0d79572b4b22d35c$var$iridescence_fragment,
    bumpmap_pars_fragment: $0d79572b4b22d35c$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $0d79572b4b22d35c$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $0d79572b4b22d35c$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $0d79572b4b22d35c$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $0d79572b4b22d35c$var$clipping_planes_vertex,
    color_fragment: $0d79572b4b22d35c$var$color_fragment,
    color_pars_fragment: $0d79572b4b22d35c$var$color_pars_fragment,
    color_pars_vertex: $0d79572b4b22d35c$var$color_pars_vertex,
    color_vertex: $0d79572b4b22d35c$var$color_vertex,
    common: $0d79572b4b22d35c$var$common,
    cube_uv_reflection_fragment: $0d79572b4b22d35c$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $0d79572b4b22d35c$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $0d79572b4b22d35c$var$displacementmap_pars_vertex,
    displacementmap_vertex: $0d79572b4b22d35c$var$displacementmap_vertex,
    emissivemap_fragment: $0d79572b4b22d35c$var$emissivemap_fragment,
    emissivemap_pars_fragment: $0d79572b4b22d35c$var$emissivemap_pars_fragment,
    colorspace_fragment: $0d79572b4b22d35c$var$colorspace_fragment,
    colorspace_pars_fragment: $0d79572b4b22d35c$var$colorspace_pars_fragment,
    envmap_fragment: $0d79572b4b22d35c$var$envmap_fragment,
    envmap_common_pars_fragment: $0d79572b4b22d35c$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $0d79572b4b22d35c$var$envmap_pars_fragment,
    envmap_pars_vertex: $0d79572b4b22d35c$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $0d79572b4b22d35c$var$envmap_physical_pars_fragment,
    envmap_vertex: $0d79572b4b22d35c$var$envmap_vertex,
    fog_vertex: $0d79572b4b22d35c$var$fog_vertex,
    fog_pars_vertex: $0d79572b4b22d35c$var$fog_pars_vertex,
    fog_fragment: $0d79572b4b22d35c$var$fog_fragment,
    fog_pars_fragment: $0d79572b4b22d35c$var$fog_pars_fragment,
    gradientmap_pars_fragment: $0d79572b4b22d35c$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $0d79572b4b22d35c$var$lightmap_pars_fragment,
    lights_lambert_fragment: $0d79572b4b22d35c$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $0d79572b4b22d35c$var$lights_lambert_pars_fragment,
    lights_pars_begin: $0d79572b4b22d35c$var$lights_pars_begin,
    lights_toon_fragment: $0d79572b4b22d35c$var$lights_toon_fragment,
    lights_toon_pars_fragment: $0d79572b4b22d35c$var$lights_toon_pars_fragment,
    lights_phong_fragment: $0d79572b4b22d35c$var$lights_phong_fragment,
    lights_phong_pars_fragment: $0d79572b4b22d35c$var$lights_phong_pars_fragment,
    lights_physical_fragment: $0d79572b4b22d35c$var$lights_physical_fragment,
    lights_physical_pars_fragment: $0d79572b4b22d35c$var$lights_physical_pars_fragment,
    lights_fragment_begin: $0d79572b4b22d35c$var$lights_fragment_begin,
    lights_fragment_maps: $0d79572b4b22d35c$var$lights_fragment_maps,
    lights_fragment_end: $0d79572b4b22d35c$var$lights_fragment_end,
    logdepthbuf_fragment: $0d79572b4b22d35c$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $0d79572b4b22d35c$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $0d79572b4b22d35c$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $0d79572b4b22d35c$var$logdepthbuf_vertex,
    map_fragment: $0d79572b4b22d35c$var$map_fragment,
    map_pars_fragment: $0d79572b4b22d35c$var$map_pars_fragment,
    map_particle_fragment: $0d79572b4b22d35c$var$map_particle_fragment,
    map_particle_pars_fragment: $0d79572b4b22d35c$var$map_particle_pars_fragment,
    metalnessmap_fragment: $0d79572b4b22d35c$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $0d79572b4b22d35c$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $0d79572b4b22d35c$var$morphinstance_vertex,
    morphcolor_vertex: $0d79572b4b22d35c$var$morphcolor_vertex,
    morphnormal_vertex: $0d79572b4b22d35c$var$morphnormal_vertex,
    morphtarget_pars_vertex: $0d79572b4b22d35c$var$morphtarget_pars_vertex,
    morphtarget_vertex: $0d79572b4b22d35c$var$morphtarget_vertex,
    normal_fragment_begin: $0d79572b4b22d35c$var$normal_fragment_begin,
    normal_fragment_maps: $0d79572b4b22d35c$var$normal_fragment_maps,
    normal_pars_fragment: $0d79572b4b22d35c$var$normal_pars_fragment,
    normal_pars_vertex: $0d79572b4b22d35c$var$normal_pars_vertex,
    normal_vertex: $0d79572b4b22d35c$var$normal_vertex,
    normalmap_pars_fragment: $0d79572b4b22d35c$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $0d79572b4b22d35c$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $0d79572b4b22d35c$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $0d79572b4b22d35c$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $0d79572b4b22d35c$var$iridescence_pars_fragment,
    opaque_fragment: $0d79572b4b22d35c$var$opaque_fragment,
    packing: $0d79572b4b22d35c$var$packing,
    premultiplied_alpha_fragment: $0d79572b4b22d35c$var$premultiplied_alpha_fragment,
    project_vertex: $0d79572b4b22d35c$var$project_vertex,
    dithering_fragment: $0d79572b4b22d35c$var$dithering_fragment,
    dithering_pars_fragment: $0d79572b4b22d35c$var$dithering_pars_fragment,
    roughnessmap_fragment: $0d79572b4b22d35c$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $0d79572b4b22d35c$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $0d79572b4b22d35c$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $0d79572b4b22d35c$var$shadowmap_pars_vertex,
    shadowmap_vertex: $0d79572b4b22d35c$var$shadowmap_vertex,
    shadowmask_pars_fragment: $0d79572b4b22d35c$var$shadowmask_pars_fragment,
    skinbase_vertex: $0d79572b4b22d35c$var$skinbase_vertex,
    skinning_pars_vertex: $0d79572b4b22d35c$var$skinning_pars_vertex,
    skinning_vertex: $0d79572b4b22d35c$var$skinning_vertex,
    skinnormal_vertex: $0d79572b4b22d35c$var$skinnormal_vertex,
    specularmap_fragment: $0d79572b4b22d35c$var$specularmap_fragment,
    specularmap_pars_fragment: $0d79572b4b22d35c$var$specularmap_pars_fragment,
    tonemapping_fragment: $0d79572b4b22d35c$var$tonemapping_fragment,
    tonemapping_pars_fragment: $0d79572b4b22d35c$var$tonemapping_pars_fragment,
    transmission_fragment: $0d79572b4b22d35c$var$transmission_fragment,
    transmission_pars_fragment: $0d79572b4b22d35c$var$transmission_pars_fragment,
    uv_pars_fragment: $0d79572b4b22d35c$var$uv_pars_fragment,
    uv_pars_vertex: $0d79572b4b22d35c$var$uv_pars_vertex,
    uv_vertex: $0d79572b4b22d35c$var$uv_vertex,
    worldpos_vertex: $0d79572b4b22d35c$var$worldpos_vertex,
    background_vert: $0d79572b4b22d35c$var$vertex$h,
    background_frag: $0d79572b4b22d35c$var$fragment$h,
    backgroundCube_vert: $0d79572b4b22d35c$var$vertex$g,
    backgroundCube_frag: $0d79572b4b22d35c$var$fragment$g,
    cube_vert: $0d79572b4b22d35c$var$vertex$f,
    cube_frag: $0d79572b4b22d35c$var$fragment$f,
    depth_vert: $0d79572b4b22d35c$var$vertex$e,
    depth_frag: $0d79572b4b22d35c$var$fragment$e,
    distanceRGBA_vert: $0d79572b4b22d35c$var$vertex$d,
    distanceRGBA_frag: $0d79572b4b22d35c$var$fragment$d,
    equirect_vert: $0d79572b4b22d35c$var$vertex$c,
    equirect_frag: $0d79572b4b22d35c$var$fragment$c,
    linedashed_vert: $0d79572b4b22d35c$var$vertex$b,
    linedashed_frag: $0d79572b4b22d35c$var$fragment$b,
    meshbasic_vert: $0d79572b4b22d35c$var$vertex$a,
    meshbasic_frag: $0d79572b4b22d35c$var$fragment$a,
    meshlambert_vert: $0d79572b4b22d35c$var$vertex$9,
    meshlambert_frag: $0d79572b4b22d35c$var$fragment$9,
    meshmatcap_vert: $0d79572b4b22d35c$var$vertex$8,
    meshmatcap_frag: $0d79572b4b22d35c$var$fragment$8,
    meshnormal_vert: $0d79572b4b22d35c$var$vertex$7,
    meshnormal_frag: $0d79572b4b22d35c$var$fragment$7,
    meshphong_vert: $0d79572b4b22d35c$var$vertex$6,
    meshphong_frag: $0d79572b4b22d35c$var$fragment$6,
    meshphysical_vert: $0d79572b4b22d35c$var$vertex$5,
    meshphysical_frag: $0d79572b4b22d35c$var$fragment$5,
    meshtoon_vert: $0d79572b4b22d35c$var$vertex$4,
    meshtoon_frag: $0d79572b4b22d35c$var$fragment$4,
    points_vert: $0d79572b4b22d35c$var$vertex$3,
    points_frag: $0d79572b4b22d35c$var$fragment$3,
    shadow_vert: $0d79572b4b22d35c$var$vertex$2,
    shadow_frag: $0d79572b4b22d35c$var$fragment$2,
    sprite_vert: $0d79572b4b22d35c$var$vertex$1,
    sprite_frag: $0d79572b4b22d35c$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $0d79572b4b22d35c$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $0d79572b4b22d35c$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.common,
            $0d79572b4b22d35c$export$6643083551874bf5.specularmap,
            $0d79572b4b22d35c$export$6643083551874bf5.envmap,
            $0d79572b4b22d35c$export$6643083551874bf5.aomap,
            $0d79572b4b22d35c$export$6643083551874bf5.lightmap,
            $0d79572b4b22d35c$export$6643083551874bf5.fog
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.common,
            $0d79572b4b22d35c$export$6643083551874bf5.specularmap,
            $0d79572b4b22d35c$export$6643083551874bf5.envmap,
            $0d79572b4b22d35c$export$6643083551874bf5.aomap,
            $0d79572b4b22d35c$export$6643083551874bf5.lightmap,
            $0d79572b4b22d35c$export$6643083551874bf5.emissivemap,
            $0d79572b4b22d35c$export$6643083551874bf5.bumpmap,
            $0d79572b4b22d35c$export$6643083551874bf5.normalmap,
            $0d79572b4b22d35c$export$6643083551874bf5.displacementmap,
            $0d79572b4b22d35c$export$6643083551874bf5.fog,
            $0d79572b4b22d35c$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.common,
            $0d79572b4b22d35c$export$6643083551874bf5.specularmap,
            $0d79572b4b22d35c$export$6643083551874bf5.envmap,
            $0d79572b4b22d35c$export$6643083551874bf5.aomap,
            $0d79572b4b22d35c$export$6643083551874bf5.lightmap,
            $0d79572b4b22d35c$export$6643083551874bf5.emissivemap,
            $0d79572b4b22d35c$export$6643083551874bf5.bumpmap,
            $0d79572b4b22d35c$export$6643083551874bf5.normalmap,
            $0d79572b4b22d35c$export$6643083551874bf5.displacementmap,
            $0d79572b4b22d35c$export$6643083551874bf5.fog,
            $0d79572b4b22d35c$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.common,
            $0d79572b4b22d35c$export$6643083551874bf5.envmap,
            $0d79572b4b22d35c$export$6643083551874bf5.aomap,
            $0d79572b4b22d35c$export$6643083551874bf5.lightmap,
            $0d79572b4b22d35c$export$6643083551874bf5.emissivemap,
            $0d79572b4b22d35c$export$6643083551874bf5.bumpmap,
            $0d79572b4b22d35c$export$6643083551874bf5.normalmap,
            $0d79572b4b22d35c$export$6643083551874bf5.displacementmap,
            $0d79572b4b22d35c$export$6643083551874bf5.roughnessmap,
            $0d79572b4b22d35c$export$6643083551874bf5.metalnessmap,
            $0d79572b4b22d35c$export$6643083551874bf5.fog,
            $0d79572b4b22d35c$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.common,
            $0d79572b4b22d35c$export$6643083551874bf5.aomap,
            $0d79572b4b22d35c$export$6643083551874bf5.lightmap,
            $0d79572b4b22d35c$export$6643083551874bf5.emissivemap,
            $0d79572b4b22d35c$export$6643083551874bf5.bumpmap,
            $0d79572b4b22d35c$export$6643083551874bf5.normalmap,
            $0d79572b4b22d35c$export$6643083551874bf5.displacementmap,
            $0d79572b4b22d35c$export$6643083551874bf5.gradientmap,
            $0d79572b4b22d35c$export$6643083551874bf5.fog,
            $0d79572b4b22d35c$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.common,
            $0d79572b4b22d35c$export$6643083551874bf5.bumpmap,
            $0d79572b4b22d35c$export$6643083551874bf5.normalmap,
            $0d79572b4b22d35c$export$6643083551874bf5.displacementmap,
            $0d79572b4b22d35c$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.points,
            $0d79572b4b22d35c$export$6643083551874bf5.fog
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.common,
            $0d79572b4b22d35c$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.common,
            $0d79572b4b22d35c$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.common,
            $0d79572b4b22d35c$export$6643083551874bf5.bumpmap,
            $0d79572b4b22d35c$export$6643083551874bf5.normalmap,
            $0d79572b4b22d35c$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.sprite,
            $0d79572b4b22d35c$export$6643083551874bf5.fog
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            }
        },
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.common,
            $0d79572b4b22d35c$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
            $0d79572b4b22d35c$export$6643083551874bf5.lights,
            $0d79572b4b22d35c$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.shadow_frag
    }
};
$0d79572b4b22d35c$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $0d79572b4b22d35c$var$mergeUniforms([
        $0d79572b4b22d35c$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $0d79572b4b22d35c$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $0d79572b4b22d35c$export$955f9f2e84c43c8b.meshphysical_frag
};
const $0d79572b4b22d35c$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $0d79572b4b22d35c$var$_e1$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$d93cc409a0768c5f();
const $0d79572b4b22d35c$var$_m1$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
function $0d79572b4b22d35c$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === "additive") state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === "alpha-blend") state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === $0d79572b4b22d35c$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $0d79572b4b22d35c$export$e176487c05830cc5(new $0d79572b4b22d35c$export$33e43285f7406bd5(1, 1, 1), new $0d79572b4b22d35c$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $0d79572b4b22d35c$var$cloneUniforms($0d79572b4b22d35c$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $0d79572b4b22d35c$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $0d79572b4b22d35c$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $0d79572b4b22d35c$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $0d79572b4b22d35c$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $0d79572b4b22d35c$var$_e1$1.x *= -1;
            $0d79572b4b22d35c$var$_e1$1.y *= -1;
            $0d79572b4b22d35c$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $0d79572b4b22d35c$var$_e1$1.y *= -1;
                $0d79572b4b22d35c$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($0d79572b4b22d35c$var$_m1$1.makeRotationFromEuler($0d79572b4b22d35c$var$_e1$1));
            boxMesh.material.toneMapped = $0d79572b4b22d35c$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $0d79572b4b22d35c$export$8d0a61916cc26abb;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $0d79572b4b22d35c$export$e176487c05830cc5(new $0d79572b4b22d35c$export$967d831af31f69ce(2, 2), new $0d79572b4b22d35c$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $0d79572b4b22d35c$var$cloneUniforms($0d79572b4b22d35c$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $0d79572b4b22d35c$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $0d79572b4b22d35c$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $0d79572b4b22d35c$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = $0d79572b4b22d35c$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $0d79572b4b22d35c$export$8d0a61916cc26abb;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($0d79572b4b22d35c$var$_rgb, $0d79572b4b22d35c$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($0d79572b4b22d35c$var$_rgb.r, $0d79572b4b22d35c$var$_rgb.g, $0d79572b4b22d35c$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList
    };
}
function $0d79572b4b22d35c$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $0d79572b4b22d35c$export$5c612977753abe2;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $0d79572b4b22d35c$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get("WEBGL_multi_draw");
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get("WEBGL_multi_draw");
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i];
            for(let i = 0; i < primcount.length; i++)info.update(elementCount, mode, primcount[i]);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $0d79572b4b22d35c$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== $0d79572b4b22d35c$export$3f8bb04b555a363c && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === $0d79572b4b22d35c$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || extensions.has("EXT_color_buffer_float"));
        if (textureType !== $0d79572b4b22d35c$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== $0d79572b4b22d35c$export$f6d331659b644596 && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return "mediump";
        }
        return "lowp";
    }
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions.has("EXT_clip_control");
    if (reverseDepthBuffer === true) {
        const ext = extensions.get("EXT_clip_control");
        ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
    }
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reverseDepthBuffer: reverseDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $0d79572b4b22d35c$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $0d79572b4b22d35c$export$7ff5ac152ef991b0(), viewNormalMatrix = new $0d79572b4b22d35c$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $0d79572b4b22d35c$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $0d79572b4b22d35c$export$d64030b316d3b087) texture.mapping = $0d79572b4b22d35c$export$8759762a6477f2c4;
        else if (mapping === $0d79572b4b22d35c$export$ee99d97d46898098) texture.mapping = $0d79572b4b22d35c$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === $0d79572b4b22d35c$export$d64030b316d3b087 || mapping === $0d79572b4b22d35c$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $0d79572b4b22d35c$export$ac386671d651941e(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $0d79572b4b22d35c$export$9ebf355ee4ed261b extends $0d79572b4b22d35c$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $0d79572b4b22d35c$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $0d79572b4b22d35c$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $0d79572b4b22d35c$var$MAX_SAMPLES = 20;
const $0d79572b4b22d35c$var$_flatCamera = /*@__PURE__*/ new $0d79572b4b22d35c$export$9ebf355ee4ed261b();
const $0d79572b4b22d35c$var$_clearColor = /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e();
let $0d79572b4b22d35c$var$_oldTarget = null;
let $0d79572b4b22d35c$var$_oldActiveCubeFace = 0;
let $0d79572b4b22d35c$var$_oldActiveMipmapLevel = 0;
let $0d79572b4b22d35c$var$_oldXrEnabled = false;
// Golden Ratio
const $0d79572b4b22d35c$var$PHI = (1 + Math.sqrt(5)) / 2;
const $0d79572b4b22d35c$var$INV_PHI = 1 / $0d79572b4b22d35c$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $0d79572b4b22d35c$var$_axisDirections = [
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(-$0d79572b4b22d35c$var$PHI, $0d79572b4b22d35c$var$INV_PHI, 0),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699($0d79572b4b22d35c$var$PHI, $0d79572b4b22d35c$var$INV_PHI, 0),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(-$0d79572b4b22d35c$var$INV_PHI, 0, $0d79572b4b22d35c$var$PHI),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699($0d79572b4b22d35c$var$INV_PHI, 0, $0d79572b4b22d35c$var$PHI),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(0, $0d79572b4b22d35c$var$PHI, -$0d79572b4b22d35c$var$INV_PHI),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(0, $0d79572b4b22d35c$var$PHI, $0d79572b4b22d35c$var$INV_PHI),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699(1, 1, 1)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $0d79572b4b22d35c$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $0d79572b4b22d35c$var$_oldTarget = this._renderer.getRenderTarget();
        $0d79572b4b22d35c$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $0d79572b4b22d35c$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $0d79572b4b22d35c$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported equirectangular image size is 64 x 32.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported cube size is 16 x 16.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $0d79572b4b22d35c$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $0d79572b4b22d35c$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($0d79572b4b22d35c$var$_oldTarget, $0d79572b4b22d35c$var$_oldActiveCubeFace, $0d79572b4b22d35c$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $0d79572b4b22d35c$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $0d79572b4b22d35c$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $0d79572b4b22d35c$export$8759762a6477f2c4 || texture.mapping === $0d79572b4b22d35c$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $0d79572b4b22d35c$var$_oldTarget = this._renderer.getRenderTarget();
        $0d79572b4b22d35c$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $0d79572b4b22d35c$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $0d79572b4b22d35c$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $0d79572b4b22d35c$export$8a72f490b25c56c8,
            minFilter: $0d79572b4b22d35c$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $0d79572b4b22d35c$export$2697304443f382bc,
            format: $0d79572b4b22d35c$export$3f8bb04b555a363c,
            colorSpace: $0d79572b4b22d35c$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $0d79572b4b22d35c$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $0d79572b4b22d35c$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $0d79572b4b22d35c$var$_createPlanes(_lodMax));
            this._blurMaterial = $0d79572b4b22d35c$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $0d79572b4b22d35c$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $0d79572b4b22d35c$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $0d79572b4b22d35c$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($0d79572b4b22d35c$var$_clearColor);
        renderer.toneMapping = $0d79572b4b22d35c$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $0d79572b4b22d35c$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $0d79572b4b22d35c$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $0d79572b4b22d35c$export$e176487c05830cc5(new $0d79572b4b22d35c$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($0d79572b4b22d35c$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $0d79572b4b22d35c$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $0d79572b4b22d35c$export$8759762a6477f2c4 || texture.mapping === $0d79572b4b22d35c$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $0d79572b4b22d35c$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $0d79572b4b22d35c$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        const size = this._cubeSize;
        $0d79572b4b22d35c$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $0d79572b4b22d35c$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodPlanes.length;
        for(let i = 1; i < n; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $0d79572b4b22d35c$var$_axisDirections[(n - i - 1) % $0d79572b4b22d35c$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $0d79572b4b22d35c$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $0d79572b4b22d35c$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $0d79572b4b22d35c$var$MAX_SAMPLES;
        if (samples > $0d79572b4b22d35c$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$0d79572b4b22d35c$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $0d79572b4b22d35c$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $0d79572b4b22d35c$var$LOD_MIN ? lodOut - _lodMax + $0d79572b4b22d35c$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $0d79572b4b22d35c$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $0d79572b4b22d35c$var$_flatCamera);
    }
}
function $0d79572b4b22d35c$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $0d79572b4b22d35c$var$LOD_MIN + 1 + $0d79572b4b22d35c$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $0d79572b4b22d35c$var$LOD_MIN) sigma = $0d79572b4b22d35c$var$EXTRA_LOD_SIGMA[i - lodMax + $0d79572b4b22d35c$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $0d79572b4b22d35c$export$b7be63a67df8959();
        planes.setAttribute("position", new $0d79572b4b22d35c$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $0d79572b4b22d35c$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $0d79572b4b22d35c$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $0d79572b4b22d35c$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $0d79572b4b22d35c$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $0d79572b4b22d35c$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $0d79572b4b22d35c$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $0d79572b4b22d35c$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $0d79572b4b22d35c$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($0d79572b4b22d35c$var$MAX_SAMPLES);
    const poleAxis = new $0d79572b4b22d35c$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $0d79572b4b22d35c$export$83c7d75d550a8b0d({
        name: "SphericalGaussianBlur",
        defines: {
            "n": $0d79572b4b22d35c$var$MAX_SAMPLES,
            "CUBEUV_TEXEL_WIDTH": 1.0 / width,
            "CUBEUV_TEXEL_HEIGHT": 1.0 / height,
            "CUBEUV_MAX_MIP": `${lodMax}.0`
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $0d79572b4b22d35c$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $0d79572b4b22d35c$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $0d79572b4b22d35c$var$_getEquirectMaterial() {
    return new $0d79572b4b22d35c$export$83c7d75d550a8b0d({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            }
        },
        vertexShader: $0d79572b4b22d35c$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $0d79572b4b22d35c$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $0d79572b4b22d35c$var$_getCubemapMaterial() {
    return new $0d79572b4b22d35c$export$83c7d75d550a8b0d({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $0d79572b4b22d35c$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $0d79572b4b22d35c$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $0d79572b4b22d35c$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $0d79572b4b22d35c$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $0d79572b4b22d35c$export$d64030b316d3b087 || mapping === $0d79572b4b22d35c$export$ee99d97d46898098;
            const isCubeMap = mapping === $0d79572b4b22d35c$export$8759762a6477f2c4 || mapping === $0d79572b4b22d35c$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $0d79572b4b22d35c$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $0d79572b4b22d35c$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $0d79572b4b22d35c$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension("EXT_color_buffer_float");
            getExtension("WEBGL_clip_cull_distance");
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
            getExtension("WEBGL_render_shared_exponent");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) $0d79572b4b22d35c$var$warnOnce("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $0d79572b4b22d35c$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ($0d79572b4b22d35c$var$arrayNeedsUint32(indices) ? $0d79572b4b22d35c$export$7eb8c9fa25cd5bd6 : $0d79572b4b22d35c$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $0d79572b4b22d35c$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get("WEBGL_multi_draw");
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get("WEBGL_multi_draw");
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i];
            for(let i = 0; i < primcount.length; i++)info.update(elementCount, mode, primcount[i]);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $0d79572b4b22d35c$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $0d79572b4b22d35c$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new $0d79572b4b22d35c$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
            texture.type = $0d79572b4b22d35c$export$f6d331659b644596;
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new $0d79572b4b22d35c$export$c977b3e384af9ae1(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener("dispose", disposeTexture);
            }
            geometry.addEventListener("dispose", disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, "morphTexture", object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
        }
        program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
        program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
    }
    return {
        update: update
    };
}
function $0d79572b4b22d35c$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
class $0d79572b4b22d35c$export$fc830aa069cc8c2f extends $0d79572b4b22d35c$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format = $0d79572b4b22d35c$export$c1b6b5136be58045){
        if (format !== $0d79572b4b22d35c$export$c1b6b5136be58045 && format !== $0d79572b4b22d35c$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $0d79572b4b22d35c$export$c1b6b5136be58045) type = $0d79572b4b22d35c$export$c3c7fc4518ebba96;
        if (type === undefined && format === $0d79572b4b22d35c$export$1e113ac2d0905829) type = $0d79572b4b22d35c$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $0d79572b4b22d35c$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $0d79572b4b22d35c$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $0d79572b4b22d35c$var$emptyTexture = /*@__PURE__*/ new $0d79572b4b22d35c$export$5431306cf43de24a();
const $0d79572b4b22d35c$var$emptyShadowTexture = /*@__PURE__*/ new $0d79572b4b22d35c$export$fc830aa069cc8c2f(1, 1);
const $0d79572b4b22d35c$var$emptyArrayTexture = /*@__PURE__*/ new $0d79572b4b22d35c$export$dfac6c8e811406a3();
const $0d79572b4b22d35c$var$empty3dTexture = /*@__PURE__*/ new $0d79572b4b22d35c$export$d7a3086320f856db();
const $0d79572b4b22d35c$var$emptyCubeTexture = /*@__PURE__*/ new $0d79572b4b22d35c$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $0d79572b4b22d35c$var$arrayCacheF32 = [];
const $0d79572b4b22d35c$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $0d79572b4b22d35c$var$mat4array = new Float32Array(16);
const $0d79572b4b22d35c$var$mat3array = new Float32Array(9);
const $0d79572b4b22d35c$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $0d79572b4b22d35c$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $0d79572b4b22d35c$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $0d79572b4b22d35c$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $0d79572b4b22d35c$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $0d79572b4b22d35c$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $0d79572b4b22d35c$var$allocTexUnits(textures, n) {
    let r = $0d79572b4b22d35c$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $0d79572b4b22d35c$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $0d79572b4b22d35c$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $0d79572b4b22d35c$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    }
}
function $0d79572b4b22d35c$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    }
}
function $0d79572b4b22d35c$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $0d79572b4b22d35c$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, elements)) return;
        $0d79572b4b22d35c$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $0d79572b4b22d35c$var$mat2array);
        $0d79572b4b22d35c$var$copyArray(cache, elements);
    }
}
function $0d79572b4b22d35c$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, elements)) return;
        $0d79572b4b22d35c$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $0d79572b4b22d35c$var$mat3array);
        $0d79572b4b22d35c$var$copyArray(cache, elements);
    }
}
function $0d79572b4b22d35c$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, elements)) return;
        $0d79572b4b22d35c$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $0d79572b4b22d35c$var$mat4array);
        $0d79572b4b22d35c$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $0d79572b4b22d35c$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $0d79572b4b22d35c$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    }
}
function $0d79572b4b22d35c$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    }
}
function $0d79572b4b22d35c$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $0d79572b4b22d35c$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $0d79572b4b22d35c$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    }
}
function $0d79572b4b22d35c$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    }
}
function $0d79572b4b22d35c$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($0d79572b4b22d35c$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $0d79572b4b22d35c$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $0d79572b4b22d35c$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $0d79572b4b22d35c$var$emptyShadowTexture.compareFunction = $0d79572b4b22d35c$export$64eea11eb407ddf1; // #28670
        emptyTexture2D = $0d79572b4b22d35c$var$emptyShadowTexture;
    } else emptyTexture2D = $0d79572b4b22d35c$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $0d79572b4b22d35c$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $0d79572b4b22d35c$var$empty3dTexture, unit);
}
function $0d79572b4b22d35c$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $0d79572b4b22d35c$var$emptyCubeTexture, unit);
}
function $0d79572b4b22d35c$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $0d79572b4b22d35c$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $0d79572b4b22d35c$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $0d79572b4b22d35c$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $0d79572b4b22d35c$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $0d79572b4b22d35c$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $0d79572b4b22d35c$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $0d79572b4b22d35c$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $0d79572b4b22d35c$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $0d79572b4b22d35c$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $0d79572b4b22d35c$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $0d79572b4b22d35c$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $0d79572b4b22d35c$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $0d79572b4b22d35c$var$setValueV4i; // _VEC4
        case 0x1405:
            return $0d79572b4b22d35c$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $0d79572b4b22d35c$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $0d79572b4b22d35c$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $0d79572b4b22d35c$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $0d79572b4b22d35c$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $0d79572b4b22d35c$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $0d79572b4b22d35c$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $0d79572b4b22d35c$var$setValueT2DArray1;
    }
}
// Array of scalars
function $0d79572b4b22d35c$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $0d79572b4b22d35c$var$setValueV2fArray(gl, v) {
    const data = $0d79572b4b22d35c$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $0d79572b4b22d35c$var$setValueV3fArray(gl, v) {
    const data = $0d79572b4b22d35c$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $0d79572b4b22d35c$var$setValueV4fArray(gl, v) {
    const data = $0d79572b4b22d35c$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $0d79572b4b22d35c$var$setValueM2Array(gl, v) {
    const data = $0d79572b4b22d35c$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $0d79572b4b22d35c$var$setValueM3Array(gl, v) {
    const data = $0d79572b4b22d35c$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $0d79572b4b22d35c$var$setValueM4Array(gl, v) {
    const data = $0d79572b4b22d35c$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $0d79572b4b22d35c$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $0d79572b4b22d35c$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $0d79572b4b22d35c$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $0d79572b4b22d35c$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $0d79572b4b22d35c$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $0d79572b4b22d35c$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $0d79572b4b22d35c$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $0d79572b4b22d35c$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $0d79572b4b22d35c$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $0d79572b4b22d35c$var$allocTexUnits(textures, n);
    if (!$0d79572b4b22d35c$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $0d79572b4b22d35c$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $0d79572b4b22d35c$var$emptyTexture, units[i]);
}
function $0d79572b4b22d35c$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $0d79572b4b22d35c$var$allocTexUnits(textures, n);
    if (!$0d79572b4b22d35c$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $0d79572b4b22d35c$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $0d79572b4b22d35c$var$empty3dTexture, units[i]);
}
function $0d79572b4b22d35c$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $0d79572b4b22d35c$var$allocTexUnits(textures, n);
    if (!$0d79572b4b22d35c$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $0d79572b4b22d35c$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $0d79572b4b22d35c$var$emptyCubeTexture, units[i]);
}
function $0d79572b4b22d35c$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $0d79572b4b22d35c$var$allocTexUnits(textures, n);
    if (!$0d79572b4b22d35c$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $0d79572b4b22d35c$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $0d79572b4b22d35c$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $0d79572b4b22d35c$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $0d79572b4b22d35c$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $0d79572b4b22d35c$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $0d79572b4b22d35c$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $0d79572b4b22d35c$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $0d79572b4b22d35c$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $0d79572b4b22d35c$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $0d79572b4b22d35c$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $0d79572b4b22d35c$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $0d79572b4b22d35c$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $0d79572b4b22d35c$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $0d79572b4b22d35c$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $0d79572b4b22d35c$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $0d79572b4b22d35c$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $0d79572b4b22d35c$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $0d79572b4b22d35c$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $0d79572b4b22d35c$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $0d79572b4b22d35c$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $0d79572b4b22d35c$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $0d79572b4b22d35c$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $0d79572b4b22d35c$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $0d79572b4b22d35c$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $0d79572b4b22d35c$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $0d79572b4b22d35c$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $0d79572b4b22d35c$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $0d79572b4b22d35c$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $0d79572b4b22d35c$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $0d79572b4b22d35c$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $0d79572b4b22d35c$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $0d79572b4b22d35c$var$RePathPart.exec(path), matchEnd = $0d79572b4b22d35c$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $0d79572b4b22d35c$var$addUniform(container, subscript === undefined ? new $0d79572b4b22d35c$var$SingleUniform(id, activeInfo, addr) : new $0d79572b4b22d35c$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $0d79572b4b22d35c$var$StructuredUniform(id);
                $0d79572b4b22d35c$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $0d79572b4b22d35c$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $0d79572b4b22d35c$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $0d79572b4b22d35c$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $0d79572b4b22d35c$var$COMPLETION_STATUS_KHR = 0x91B1;
let $0d79572b4b22d35c$var$programIdCount = 0;
function $0d79572b4b22d35c$var$handleSource(string, errorLine) {
    const lines = string.split("\n");
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i]}`);
    }
    return lines2.join("\n");
}
function $0d79572b4b22d35c$var$getEncodingComponents(colorSpace1) {
    const workingPrimaries = $0d79572b4b22d35c$export$5e6fd513f44698c.getPrimaries($0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace);
    const encodingPrimaries = $0d79572b4b22d35c$export$5e6fd513f44698c.getPrimaries(colorSpace1);
    let gamutMapping;
    if (workingPrimaries === encodingPrimaries) gamutMapping = "";
    else if (workingPrimaries === $0d79572b4b22d35c$export$ef371755dbe7f98a && encodingPrimaries === $0d79572b4b22d35c$export$ce9118f9eaae3bb2) gamutMapping = "LinearDisplayP3ToLinearSRGB";
    else if (workingPrimaries === $0d79572b4b22d35c$export$ce9118f9eaae3bb2 && encodingPrimaries === $0d79572b4b22d35c$export$ef371755dbe7f98a) gamutMapping = "LinearSRGBToLinearDisplayP3";
    switch(colorSpace1){
        case $0d79572b4b22d35c$export$42429b3acfb233a4:
        case $0d79572b4b22d35c$export$c0dc1bc7e964761:
            return [
                gamutMapping,
                "LinearTransferOETF"
            ];
        case $0d79572b4b22d35c$export$561f394b24edfcaa:
        case $0d79572b4b22d35c$export$626af19ae879bdf6:
            return [
                gamutMapping,
                "sRGBTransferOETF"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported color space:", colorSpace1);
            return [
                gamutMapping,
                "LinearTransferOETF"
            ];
    }
}
function $0d79572b4b22d35c$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + "\n\n" + errors + "\n\n" + $0d79572b4b22d35c$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $0d79572b4b22d35c$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $0d79572b4b22d35c$var$getEncodingComponents(colorSpace1);
    return `vec4 ${functionName}( vec4 value ) { return ${components[0]}( ${components[1]}( value ) ); }`;
}
function $0d79572b4b22d35c$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $0d79572b4b22d35c$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $0d79572b4b22d35c$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $0d79572b4b22d35c$export$932b3dd283d4a366:
            toneMappingName = "Cineon";
            break;
        case $0d79572b4b22d35c$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $0d79572b4b22d35c$export$212d53a513a325b2:
            toneMappingName = "AgX";
            break;
        case $0d79572b4b22d35c$export$f2863e1668a8e317:
            toneMappingName = "Neutral";
            break;
        case $0d79572b4b22d35c$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
const $0d79572b4b22d35c$var$_v0$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
function $0d79572b4b22d35c$var$getLuminanceFunction() {
    $0d79572b4b22d35c$export$5e6fd513f44698c.getLuminanceCoefficients($0d79572b4b22d35c$var$_v0$1);
    const r = $0d79572b4b22d35c$var$_v0$1.x.toFixed(4);
    const g = $0d79572b4b22d35c$var$_v0$1.y.toFixed(4);
    const b = $0d79572b4b22d35c$var$_v0$1.z.toFixed(4);
    return [
        "float luminance( const in vec3 rgb ) {",
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        "	return dot( weights, rgb );",
        "}"
    ].join("\n");
}
function $0d79572b4b22d35c$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
        parameters.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
    ];
    return chunks.filter($0d79572b4b22d35c$var$filterEmptyLine).join("\n");
}
function $0d79572b4b22d35c$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $0d79572b4b22d35c$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $0d79572b4b22d35c$var$filterEmptyLine(string) {
    return string !== "";
}
function $0d79572b4b22d35c$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $0d79572b4b22d35c$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $0d79572b4b22d35c$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $0d79572b4b22d35c$var$resolveIncludes(string) {
    return string.replace($0d79572b4b22d35c$var$includePattern, $0d79572b4b22d35c$var$includeReplacer);
}
const $0d79572b4b22d35c$var$shaderChunkMap = new Map();
function $0d79572b4b22d35c$var$includeReplacer(match, include) {
    let string = $0d79572b4b22d35c$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $0d79572b4b22d35c$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $0d79572b4b22d35c$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error("Can not resolve #include <" + include + ">");
    }
    return $0d79572b4b22d35c$var$resolveIncludes(string);
}
// Unroll Loops
const $0d79572b4b22d35c$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $0d79572b4b22d35c$var$unrollLoops(string) {
    return string.replace($0d79572b4b22d35c$var$unrollLoopPattern, $0d79572b4b22d35c$var$loopReplacer);
}
function $0d79572b4b22d35c$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $0d79572b4b22d35c$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $0d79572b4b22d35c$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $0d79572b4b22d35c$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $0d79572b4b22d35c$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $0d79572b4b22d35c$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $0d79572b4b22d35c$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $0d79572b4b22d35c$export$8759762a6477f2c4:
        case $0d79572b4b22d35c$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $0d79572b4b22d35c$export$dbf3e70ff37af79:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $0d79572b4b22d35c$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $0d79572b4b22d35c$export$dc59f8aed047f61d:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $0d79572b4b22d35c$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $0d79572b4b22d35c$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $0d79572b4b22d35c$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $0d79572b4b22d35c$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $0d79572b4b22d35c$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $0d79572b4b22d35c$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $0d79572b4b22d35c$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $0d79572b4b22d35c$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $0d79572b4b22d35c$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $0d79572b4b22d35c$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $0d79572b4b22d35c$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $0d79572b4b22d35c$var$generateVertexExtensions(parameters);
    const customDefines = $0d79572b4b22d35c$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($0d79572b4b22d35c$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($0d79572b4b22d35c$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $0d79572b4b22d35c$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
            parameters.batching ? "#define USE_BATCHING" : "",
            parameters.batchingColor ? "#define USE_BATCHING_COLOR" : "",
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            //
            parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
            parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
            parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
            parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
            parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
            parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
            parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
            parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
            parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
            parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
            parameters.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + parameters.anisotropyMapUv : "",
            parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
            parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
            parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
            parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
            parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
            parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
            parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
            parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
            parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
            parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
            parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
            parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
            //
            parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphColors ? "#define USE_MORPHCOLORS" : "",
            parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
            parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "#ifdef USE_INSTANCING_MORPH",
            "	uniform sampler2D morphTexture;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_UV1",
            "	attribute vec2 uv1;",
            "#endif",
            "#ifdef USE_UV2",
            "	attribute vec2 uv2;",
            "#endif",
            "#ifdef USE_UV3",
            "	attribute vec2 uv3;",
            "#endif",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($0d79572b4b22d35c$var$filterEmptyLine).join("\n");
        prefixFragment = [
            $0d79572b4b22d35c$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
            envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.dispersion ? "#define USE_DISPERSION" : "",
            parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
            parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $0d79572b4b22d35c$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $0d79572b4b22d35c$export$9fcb6b4294603b2 ? $0d79572b4b22d35c$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $0d79572b4b22d35c$export$9fcb6b4294603b2 ? $0d79572b4b22d35c$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.opaque ? "#define OPAQUE" : "",
            $0d79572b4b22d35c$export$955f9f2e84c43c8b["colorspace_pars_fragment"],
            $0d79572b4b22d35c$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputColorSpace),
            $0d79572b4b22d35c$var$getLuminanceFunction(),
            parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($0d79572b4b22d35c$var$filterEmptyLine).join("\n");
    }
    vertexShader = $0d79572b4b22d35c$var$resolveIncludes(vertexShader);
    vertexShader = $0d79572b4b22d35c$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $0d79572b4b22d35c$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $0d79572b4b22d35c$var$resolveIncludes(fragmentShader);
    fragmentShader = $0d79572b4b22d35c$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $0d79572b4b22d35c$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $0d79572b4b22d35c$var$unrollLoops(vertexShader);
    fragmentShader = $0d79572b4b22d35c$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            customVertexExtensions,
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $0d79572b4b22d35c$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $0d79572b4b22d35c$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $0d79572b4b22d35c$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $0d79572b4b22d35c$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programLog = gl.getProgramInfoLog(program).trim();
            const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === "function") renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $0d79572b4b22d35c$var$getShaderErrors(gl, glVertexShader, "vertex");
                    const fragmentErrors = $0d79572b4b22d35c$var$getShaderErrors(gl, glFragmentShader, "fragment");
                    console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\n" + "Material Name: " + self1.name + "\n" + "Material Type: " + self1.type + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
                }
            } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
            else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $0d79572b4b22d35c$var$WebGLUniforms(gl, program);
        cachedAttributes = $0d79572b4b22d35c$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $0d79572b4b22d35c$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $0d79572b4b22d35c$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $0d79572b4b22d35c$var$_id$1 = 0;
class $0d79572b4b22d35c$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $0d79572b4b22d35c$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $0d79572b4b22d35c$var$WebGLShaderStage {
    constructor(code){
        this.id = $0d79572b4b22d35c$var$_id$1++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $0d79572b4b22d35c$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $0d79572b4b22d35c$export$89312ce47c0ca777();
    const _customShaders = new $0d79572b4b22d35c$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const reverseDepthBuffer = capabilities.reverseDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return "uv";
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $0d79572b4b22d35c$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $0d79572b4b22d35c$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = $0d79572b4b22d35c$export$9fcb6b4294603b2;
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $0d79572b4b22d35c$export$42429b3acfb233a4,
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $0d79572b4b22d35c$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $0d79572b4b22d35c$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $0d79572b4b22d35c$export$5b29a26d96ee6af0 && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reverseDepthBuffer: reverseDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && $0d79572b4b22d35c$export$5e6fd513f44698c.getTransfer(material.map.colorSpace) === $0d79572b4b22d35c$export$8d0a61916cc26abb,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $0d79572b4b22d35c$export$3b296b6f144d5b03,
            flipSided: material.side === $0d79572b4b22d35c$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has("WEBGL_clip_cull_distance"),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has("WEBGL_multi_draw"),
            rendererExtensionParallelShaderCompile: extensions.has("KHR_parallel_shader_compile"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reverseDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.alphaToCoverage) _programLayers.enable(20);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $0d79572b4b22d35c$export$bee4a7d47f8f5014[shaderID];
            uniforms = $0d79572b4b22d35c$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $0d79572b4b22d35c$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $0d79572b4b22d35c$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $0d79572b4b22d35c$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $0d79572b4b22d35c$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $0d79572b4b22d35c$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $0d79572b4b22d35c$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $0d79572b4b22d35c$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $0d79572b4b22d35c$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $0d79572b4b22d35c$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $0d79572b4b22d35c$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $0d79572b4b22d35c$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $0d79572b4b22d35c$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $0d79572b4b22d35c$export$64b5c384219d3699(),
                        color: new $0d79572b4b22d35c$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $0d79572b4b22d35c$export$64b5c384219d3699(),
                        direction: new $0d79572b4b22d35c$export$64b5c384219d3699(),
                        color: new $0d79572b4b22d35c$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $0d79572b4b22d35c$export$64b5c384219d3699(),
                        color: new $0d79572b4b22d35c$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $0d79572b4b22d35c$export$64b5c384219d3699(),
                        skyColor: new $0d79572b4b22d35c$export$892596cec99bc70e(),
                        groundColor: new $0d79572b4b22d35c$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $0d79572b4b22d35c$export$892596cec99bc70e(),
                        position: new $0d79572b4b22d35c$export$64b5c384219d3699(),
                        halfWidth: new $0d79572b4b22d35c$export$64b5c384219d3699(),
                        halfHeight: new $0d79572b4b22d35c$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $0d79572b4b22d35c$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0d79572b4b22d35c$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0d79572b4b22d35c$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $0d79572b4b22d35c$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $0d79572b4b22d35c$var$nextVersion = 0;
function $0d79572b4b22d35c$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $0d79572b4b22d35c$var$WebGLLights(extensions) {
    const cache = new $0d79572b4b22d35c$var$UniformsCache();
    const shadowCache = $0d79572b4b22d35c$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $0d79572b4b22d35c$export$64b5c384219d3699());
    const vector3 = new $0d79572b4b22d35c$export$64b5c384219d3699();
    const matrix4 = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
    const matrix42 = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($0d79572b4b22d35c$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has("OES_texture_float_linear") === true) {
                state.rectAreaLTC1 = $0d79572b4b22d35c$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $0d79572b4b22d35c$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $0d79572b4b22d35c$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $0d79572b4b22d35c$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $0d79572b4b22d35c$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $0d79572b4b22d35c$var$WebGLRenderState(extensions) {
    const lights = new $0d79572b4b22d35c$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $0d79572b4b22d35c$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $0d79572b4b22d35c$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $0d79572b4b22d35c$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $0d79572b4b22d35c$export$2698c22ec13825db extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = "MeshDepthMaterial";
        this.depthPacking = $0d79572b4b22d35c$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $0d79572b4b22d35c$export$33e187ed002f2a19 extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = "MeshDistanceMaterial";
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $0d79572b4b22d35c$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $0d79572b4b22d35c$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $0d79572b4b22d35c$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new $0d79572b4b22d35c$export$35efe6f4c85463d2();
    const _shadowMapSize = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), _viewportSize = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), _viewport = new $0d79572b4b22d35c$export$fa7daccca11cdbe3(), _depthMaterial = new $0d79572b4b22d35c$export$2698c22ec13825db({
        depthPacking: $0d79572b4b22d35c$export$8f910f4c4f73df11
    }), _distanceMaterial = new $0d79572b4b22d35c$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [$0d79572b4b22d35c$export$2ede184fc2998901]: $0d79572b4b22d35c$export$d9f0486e75b5ace,
        [$0d79572b4b22d35c$export$d9f0486e75b5ace]: $0d79572b4b22d35c$export$2ede184fc2998901,
        [$0d79572b4b22d35c$export$3b296b6f144d5b03]: $0d79572b4b22d35c$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $0d79572b4b22d35c$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $0d79572b4b22d35c$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $0d79572b4b22d35c$var$vertex,
        fragmentShader: $0d79572b4b22d35c$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $0d79572b4b22d35c$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $0d79572b4b22d35c$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $0d79572b4b22d35c$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $0d79572b4b22d35c$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending($0d79572b4b22d35c$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $0d79572b4b22d35c$export$896ae1ade6c829c4 && this.type === $0d79572b4b22d35c$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $0d79572b4b22d35c$export$896ae1ade6c829c4 && this.type !== $0d79572b4b22d35c$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $0d79572b4b22d35c$export$896ae1ade6c829c4 ? {
                    minFilter: $0d79572b4b22d35c$export$727aa5ec3fe39bf0,
                    magFilter: $0d79572b4b22d35c$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $0d79572b4b22d35c$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $0d79572b4b22d35c$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $0d79572b4b22d35c$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener("dispose", onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $0d79572b4b22d35c$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $0d79572b4b22d35c$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener("dispose", onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
const $0d79572b4b22d35c$var$reversedFuncs = {
    [$0d79572b4b22d35c$export$69025ce147cee220]: $0d79572b4b22d35c$export$7182eb52ea3b3f04,
    [$0d79572b4b22d35c$export$eedccec66ab7ebe]: $0d79572b4b22d35c$export$c5e2c52991f30937,
    [$0d79572b4b22d35c$export$a60d398fc7b7590e]: $0d79572b4b22d35c$export$2f843afa843d8916,
    [$0d79572b4b22d35c$export$296f78a0b892f81a]: $0d79572b4b22d35c$export$7d7234c1240a1fc4,
    [$0d79572b4b22d35c$export$7182eb52ea3b3f04]: $0d79572b4b22d35c$export$69025ce147cee220,
    [$0d79572b4b22d35c$export$c5e2c52991f30937]: $0d79572b4b22d35c$export$eedccec66ab7ebe,
    [$0d79572b4b22d35c$export$2f843afa843d8916]: $0d79572b4b22d35c$export$a60d398fc7b7590e,
    [$0d79572b4b22d35c$export$7d7234c1240a1fc4]: $0d79572b4b22d35c$export$296f78a0b892f81a
};
function $0d79572b4b22d35c$var$WebGLState(gl) {
    function ColorBuffer() {
        let locked = false;
        const color = new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $0d79572b4b22d35c$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let reversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(value) {
                reversed = value;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (reversed) depthFunc = $0d79572b4b22d35c$var$reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $0d79572b4b22d35c$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $0d79572b4b22d35c$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $0d79572b4b22d35c$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $0d79572b4b22d35c$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $0d79572b4b22d35c$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $0d79572b4b22d35c$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $0d79572b4b22d35c$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $0d79572b4b22d35c$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new $0d79572b4b22d35c$export$892596cec99bc70e(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $0d79572b4b22d35c$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $0d79572b4b22d35c$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($0d79572b4b22d35c$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($0d79572b4b22d35c$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($0d79572b4b22d35c$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$0d79572b4b22d35c$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$0d79572b4b22d35c$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$0d79572b4b22d35c$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[$0d79572b4b22d35c$export$c8c1508da8d0600c] = gl.MIN;
    equationToGL[$0d79572b4b22d35c$export$99948c02fb51055f] = gl.MAX;
    const factorToGL = {
        [$0d79572b4b22d35c$export$2110f05edf778d3d]: gl.ZERO,
        [$0d79572b4b22d35c$export$8805bad65e24940e]: gl.ONE,
        [$0d79572b4b22d35c$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$0d79572b4b22d35c$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$0d79572b4b22d35c$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$0d79572b4b22d35c$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$0d79572b4b22d35c$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$0d79572b4b22d35c$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$0d79572b4b22d35c$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$0d79572b4b22d35c$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$0d79572b4b22d35c$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA,
        [$0d79572b4b22d35c$export$7dd8f434fd59075]: gl.CONSTANT_COLOR,
        [$0d79572b4b22d35c$export$99c8d898a9afbcee]: gl.ONE_MINUS_CONSTANT_COLOR,
        [$0d79572b4b22d35c$export$310cd2be38d13b56]: gl.CONSTANT_ALPHA,
        [$0d79572b4b22d35c$export$db77b8fbcf45dbf4]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === $0d79572b4b22d35c$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $0d79572b4b22d35c$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $0d79572b4b22d35c$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $0d79572b4b22d35c$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $0d79572b4b22d35c$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $0d79572b4b22d35c$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $0d79572b4b22d35c$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $0d79572b4b22d35c$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $0d79572b4b22d35c$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $0d79572b4b22d35c$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $0d79572b4b22d35c$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $0d79572b4b22d35c$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $0d79572b4b22d35c$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $0d79572b4b22d35c$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $0d79572b4b22d35c$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $0d79572b4b22d35c$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $0d79572b4b22d35c$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($0d79572b4b22d35c$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $0d79572b4b22d35c$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $0d79572b4b22d35c$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $0d79572b4b22d35c$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new $0d79572b4b22d35c$export$892596cec99bc70e(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $0d79572b4b22d35c$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
function $0d79572b4b22d35c$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
function $0d79572b4b22d35c$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Given the width, height, format, and type of a texture. Determines how many
 * bytes must be used to represent the texture.
 */ function $0d79572b4b22d35c$var$getByteLength(width, height, format, type) {
    const typeByteLength = $0d79572b4b22d35c$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $0d79572b4b22d35c$export$988473390501ed4b:
            return width * height;
        case $0d79572b4b22d35c$export$cc09ccbf6d1ed449:
            return width * height;
        case $0d79572b4b22d35c$export$9053a81c4a69c289:
            return width * height * 2;
        case $0d79572b4b22d35c$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $0d79572b4b22d35c$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $0d79572b4b22d35c$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $0d79572b4b22d35c$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $0d79572b4b22d35c$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $0d79572b4b22d35c$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $0d79572b4b22d35c$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $0d79572b4b22d35c$export$21d1799c6d552fc0:
        case $0d79572b4b22d35c$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $0d79572b4b22d35c$export$d2a1a68024a3e56c:
        case $0d79572b4b22d35c$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $0d79572b4b22d35c$export$d0f0355bb3d948e4:
        case $0d79572b4b22d35c$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $0d79572b4b22d35c$export$19ada9bbb1af3573:
        case $0d79572b4b22d35c$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $0d79572b4b22d35c$export$6ab91af2d757aee7:
        case $0d79572b4b22d35c$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $0d79572b4b22d35c$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $0d79572b4b22d35c$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $0d79572b4b22d35c$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $0d79572b4b22d35c$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $0d79572b4b22d35c$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $0d79572b4b22d35c$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $0d79572b4b22d35c$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $0d79572b4b22d35c$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $0d79572b4b22d35c$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $0d79572b4b22d35c$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $0d79572b4b22d35c$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $0d79572b4b22d35c$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $0d79572b4b22d35c$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $0d79572b4b22d35c$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $0d79572b4b22d35c$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $0d79572b4b22d35c$export$ce40b115e188bc81:
        case $0d79572b4b22d35c$export$d279c5c4bac5121e:
        case $0d79572b4b22d35c$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $0d79572b4b22d35c$export$b1688df4c4c21670:
        case $0d79572b4b22d35c$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $0d79572b4b22d35c$export$d220f6ade8463a0f:
        case $0d79572b4b22d35c$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $0d79572b4b22d35c$var$getTextureTypeByteLength(type) {
    switch(type){
        case $0d79572b4b22d35c$export$2e8ce08d3f6f5e10:
        case $0d79572b4b22d35c$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $0d79572b4b22d35c$export$c63dc51868b06a9d:
        case $0d79572b4b22d35c$export$88572337f312435f:
        case $0d79572b4b22d35c$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $0d79572b4b22d35c$export$b3969b01faf587f2:
        case $0d79572b4b22d35c$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $0d79572b4b22d35c$export$c3c7fc4518ebba96:
        case $0d79572b4b22d35c$export$5c612977753abe2:
        case $0d79572b4b22d35c$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $0d79572b4b22d35c$export$5a4c329b7e2092d3:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
const $0d79572b4b22d35c$export$ec276d39f33d4b7 = {
    contain: $0d79572b4b22d35c$var$contain,
    cover: $0d79572b4b22d35c$var$cover,
    fill: $0d79572b4b22d35c$var$fill,
    getByteLength: $0d79572b4b22d35c$var$getByteLength
};
function $0d79572b4b22d35c$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
    const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $0d79572b4b22d35c$var$createElementNS("canvas");
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap || typeof VideoFrame !== "undefined" && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + dimensions.width + "x" + dimensions.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + dimensions.width + "x" + dimensions.height + ").");
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps && texture.minFilter !== $0d79572b4b22d35c$export$727aa5ec3fe39bf0 && texture.minFilter !== $0d79572b4b22d35c$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? $0d79572b4b22d35c$export$f197347d588c1b4a : $0d79572b4b22d35c$export$5e6fd513f44698c.getTransfer(colorSpace1);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === $0d79572b4b22d35c$export$c3c7fc4518ebba96 || depthType === $0d79572b4b22d35c$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === $0d79572b4b22d35c$export$f6d331659b644596) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === $0d79572b4b22d35c$export$c63dc51868b06a9d) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.");
            }
        } else {
            if (depthType === null || depthType === $0d79572b4b22d35c$export$c3c7fc4518ebba96 || depthType === $0d79572b4b22d35c$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === $0d79572b4b22d35c$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === $0d79572b4b22d35c$export$c63dc51868b06a9d) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== $0d79572b4b22d35c$export$727aa5ec3fe39bf0 && texture.minFilter !== $0d79572b4b22d35c$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$0d79572b4b22d35c$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$0d79572b4b22d35c$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$0d79572b4b22d35c$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$0d79572b4b22d35c$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$0d79572b4b22d35c$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$0d79572b4b22d35c$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$0d79572b4b22d35c$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$0d79572b4b22d35c$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$0d79572b4b22d35c$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$0d79572b4b22d35c$export$d9e2d19a747baaab]: _gl.NEVER,
        [$0d79572b4b22d35c$export$187b73a3e352c145]: _gl.ALWAYS,
        [$0d79572b4b22d35c$export$36bcf49c713b3eb7]: _gl.LESS,
        [$0d79572b4b22d35c$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$0d79572b4b22d35c$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$0d79572b4b22d35c$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$0d79572b4b22d35c$export$155af022118f3a38]: _gl.GREATER,
        [$0d79572b4b22d35c$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === $0d79572b4b22d35c$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false && (texture.magFilter === $0d79572b4b22d35c$export$8a72f490b25c56c8 || texture.magFilter === $0d79572b4b22d35c$export$19a719f377145a13 || texture.magFilter === $0d79572b4b22d35c$export$d2327c1afe5bfdf2 || texture.magFilter === $0d79572b4b22d35c$export$5d8599b6a933fb1b || texture.minFilter === $0d79572b4b22d35c$export$8a72f490b25c56c8 || texture.minFilter === $0d79572b4b22d35c$export$19a719f377145a13 || texture.minFilter === $0d79572b4b22d35c$export$d2327c1afe5bfdf2 || texture.minFilter === $0d79572b4b22d35c$export$5d8599b6a933fb1b)) console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.");
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            if (texture.magFilter === $0d79572b4b22d35c$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $0d79572b4b22d35c$export$d2327c1afe5bfdf2 && texture.minFilter !== $0d79572b4b22d35c$export$5d8599b6a933fb1b) return;
            if (texture.type === $0d79572b4b22d35c$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get("EXT_texture_filter_anisotropic");
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $0d79572b4b22d35c$export$5e6fd513f44698c.getPrimaries($0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $0d79572b4b22d35c$export$bfcb490c2dd3db51 ? null : $0d79572b4b22d35c$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $0d79572b4b22d35c$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === $0d79572b4b22d35c$export$1e113ac2d0905829, texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $0d79572b4b22d35c$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = $0d79572b4b22d35c$var$getByteLength(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData, 0, 0);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $0d79572b4b22d35c$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = $0d79572b4b22d35c$var$getByteLength(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $0d79572b4b22d35c$export$5e6fd513f44698c.getPrimaries($0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $0d79572b4b22d35c$export$bfcb490c2dd3db51 ? null : $0d79572b4b22d35c$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $0d79572b4b22d35c$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $0d79572b4b22d35c$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            const samples = getRenderTargetSamples(renderTarget);
            const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $0d79572b4b22d35c$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $0d79572b4b22d35c$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener("dispose", disposeEvent);
                };
                depthTexture.addEventListener("dispose", disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace1 !== $0d79572b4b22d35c$export$42429b3acfb233a4 && colorSpace1 !== $0d79572b4b22d35c$export$bfcb490c2dd3db51) {
            // sRGB
            if ($0d79572b4b22d35c$export$5e6fd513f44698c.getTransfer(colorSpace1) === $0d79572b4b22d35c$export$8d0a61916cc26abb) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== $0d79572b4b22d35c$export$3f8bb04b555a363c || type !== $0d79572b4b22d35c$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace1);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== "undefined" && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $0d79572b4b22d35c$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace1 = $0d79572b4b22d35c$export$bfcb490c2dd3db51) {
        let extension;
        const transfer = $0d79572b4b22d35c$export$5e6fd513f44698c.getTransfer(colorSpace1);
        if (p === $0d79572b4b22d35c$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $0d79572b4b22d35c$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $0d79572b4b22d35c$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $0d79572b4b22d35c$export$5a4c329b7e2092d3) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === $0d79572b4b22d35c$export$545fce0311a9796a) return gl.BYTE;
        if (p === $0d79572b4b22d35c$export$88572337f312435f) return gl.SHORT;
        if (p === $0d79572b4b22d35c$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $0d79572b4b22d35c$export$5c612977753abe2) return gl.INT;
        if (p === $0d79572b4b22d35c$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $0d79572b4b22d35c$export$f6d331659b644596) return gl.FLOAT;
        if (p === $0d79572b4b22d35c$export$2697304443f382bc) return gl.HALF_FLOAT;
        if (p === $0d79572b4b22d35c$export$988473390501ed4b) return gl.ALPHA;
        if (p === $0d79572b4b22d35c$export$7c67423a5ee6f5eb) return gl.RGB;
        if (p === $0d79572b4b22d35c$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $0d79572b4b22d35c$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $0d79572b4b22d35c$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $0d79572b4b22d35c$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $0d79572b4b22d35c$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === $0d79572b4b22d35c$export$4e041a7967d15c4b) return gl.RED;
        if (p === $0d79572b4b22d35c$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $0d79572b4b22d35c$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $0d79572b4b22d35c$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $0d79572b4b22d35c$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $0d79572b4b22d35c$export$21d1799c6d552fc0 || p === $0d79572b4b22d35c$export$afa304c3e981b668 || p === $0d79572b4b22d35c$export$d2a1a68024a3e56c || p === $0d79572b4b22d35c$export$9a79c424327dacf9) {
            if (transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $0d79572b4b22d35c$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $0d79572b4b22d35c$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $0d79572b4b22d35c$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $0d79572b4b22d35c$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $0d79572b4b22d35c$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $0d79572b4b22d35c$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $0d79572b4b22d35c$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $0d79572b4b22d35c$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $0d79572b4b22d35c$export$19ada9bbb1af3573 || p === $0d79572b4b22d35c$export$d0f0355bb3d948e4 || p === $0d79572b4b22d35c$export$b82296714358084c || p === $0d79572b4b22d35c$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $0d79572b4b22d35c$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $0d79572b4b22d35c$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $0d79572b4b22d35c$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $0d79572b4b22d35c$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === $0d79572b4b22d35c$export$6ab91af2d757aee7 || p === $0d79572b4b22d35c$export$7800993ef8106a6a || p === $0d79572b4b22d35c$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $0d79572b4b22d35c$export$6ab91af2d757aee7 || p === $0d79572b4b22d35c$export$7800993ef8106a6a) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $0d79572b4b22d35c$export$23ed8300a860e7d8) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $0d79572b4b22d35c$export$dc5570b4a2b92d48 || p === $0d79572b4b22d35c$export$68880cd325f8b2fb || p === $0d79572b4b22d35c$export$7d2c0be323373d95 || p === $0d79572b4b22d35c$export$22b52da301fc3a3e || p === $0d79572b4b22d35c$export$c009e2cb4a66485e || p === $0d79572b4b22d35c$export$118fff5afa255b63 || p === $0d79572b4b22d35c$export$120713c829ae0667 || p === $0d79572b4b22d35c$export$c79eeabbf53313e9 || p === $0d79572b4b22d35c$export$443cf6567cdd6424 || p === $0d79572b4b22d35c$export$6573984fc9840780 || p === $0d79572b4b22d35c$export$e7aee563f30091de || p === $0d79572b4b22d35c$export$2eb8634622ddeab7 || p === $0d79572b4b22d35c$export$202b1ce7b5d25742 || p === $0d79572b4b22d35c$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $0d79572b4b22d35c$export$dc5570b4a2b92d48) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $0d79572b4b22d35c$export$68880cd325f8b2fb) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $0d79572b4b22d35c$export$7d2c0be323373d95) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $0d79572b4b22d35c$export$22b52da301fc3a3e) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $0d79572b4b22d35c$export$c009e2cb4a66485e) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $0d79572b4b22d35c$export$118fff5afa255b63) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $0d79572b4b22d35c$export$120713c829ae0667) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $0d79572b4b22d35c$export$c79eeabbf53313e9) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $0d79572b4b22d35c$export$443cf6567cdd6424) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $0d79572b4b22d35c$export$6573984fc9840780) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $0d79572b4b22d35c$export$e7aee563f30091de) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $0d79572b4b22d35c$export$2eb8634622ddeab7) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $0d79572b4b22d35c$export$202b1ce7b5d25742) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $0d79572b4b22d35c$export$18ab77abd087e467) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $0d79572b4b22d35c$export$ce40b115e188bc81 || p === $0d79572b4b22d35c$export$d279c5c4bac5121e || p === $0d79572b4b22d35c$export$cde52d17225fdbd3) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $0d79572b4b22d35c$export$ce40b115e188bc81) return transfer === $0d79572b4b22d35c$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === $0d79572b4b22d35c$export$d279c5c4bac5121e) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === $0d79572b4b22d35c$export$cde52d17225fdbd3) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === $0d79572b4b22d35c$export$b1688df4c4c21670 || p === $0d79572b4b22d35c$export$fc15e5d8261eed58 || p === $0d79572b4b22d35c$export$d220f6ade8463a0f || p === $0d79572b4b22d35c$export$768646d09dc1b6ef) {
            extension = extensions.get("EXT_texture_compression_rgtc");
            if (extension !== null) {
                if (p === $0d79572b4b22d35c$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $0d79572b4b22d35c$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $0d79572b4b22d35c$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $0d79572b4b22d35c$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $0d79572b4b22d35c$export$6c8ea339bfab1301) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $0d79572b4b22d35c$export$56b937d9e5581166 extends $0d79572b4b22d35c$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $0d79572b4b22d35c$export$eb2fcfdbd7ba97d4 extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = "Group";
    }
}
const $0d79572b4b22d35c$var$_moveEvent = {
    type: "move"
};
class $0d79572b4b22d35c$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $0d79572b4b22d35c$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $0d79572b4b22d35c$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $0d79572b4b22d35c$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $0d79572b4b22d35c$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $0d79572b4b22d35c$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $0d79572b4b22d35c$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $0d79572b4b22d35c$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: "connected",
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($0d79572b4b22d35c$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $0d79572b4b22d35c$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
const $0d79572b4b22d35c$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $0d79572b4b22d35c$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class $0d79572b4b22d35c$var$WebXRDepthSensing {
    constructor(){
        this.texture = null;
        this.mesh = null;
        this.depthNear = 0;
        this.depthFar = 0;
    }
    init(renderer, depthData, renderState) {
        if (this.texture === null) {
            const texture = new $0d79572b4b22d35c$export$5431306cf43de24a();
            const texProps = renderer.properties.get(texture);
            texProps.__webglTexture = depthData.texture;
            if (depthData.depthNear != renderState.depthNear || depthData.depthFar != renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new $0d79572b4b22d35c$export$83c7d75d550a8b0d({
                    vertexShader: $0d79572b4b22d35c$var$_occlusion_vertex,
                    fragmentShader: $0d79572b4b22d35c$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(new $0d79572b4b22d35c$export$967d831af31f69ce(20, 20), material);
            }
        }
        return this.mesh;
    }
    reset() {
        this.texture = null;
        this.mesh = null;
    }
    getDepthTexture() {
        return this.texture;
    }
}
class $0d79572b4b22d35c$var$WebXRManager extends $0d79572b4b22d35c$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const depthSensing = new $0d79572b4b22d35c$var$WebXRDepthSensing();
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
        let currentPixelRatio = null;
        //
        const cameraL = new $0d79572b4b22d35c$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
        const cameraR = new $0d79572b4b22d35c$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $0d79572b4b22d35c$export$56b937d9e5581166();
        cameraXR.layers.enable(1);
        cameraXR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0d79572b4b22d35c$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0d79572b4b22d35c$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $0d79572b4b22d35c$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener("select", onSessionEvent);
            session.removeEventListener("selectstart", onSessionEvent);
            session.removeEventListener("selectend", onSessionEvent);
            session.removeEventListener("squeeze", onSessionEvent);
            session.removeEventListener("squeezestart", onSessionEvent);
            session.removeEventListener("squeezeend", onSessionEvent);
            session.removeEventListener("end", onSessionEnd);
            session.removeEventListener("inputsourceschange", onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                if (session.renderState.layers === undefined) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new $0d79572b4b22d35c$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $0d79572b4b22d35c$export$3f8bb04b555a363c,
                        type: $0d79572b4b22d35c$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $0d79572b4b22d35c$export$1e113ac2d0905829 : $0d79572b4b22d35c$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $0d79572b4b22d35c$export$6c8ea339bfab1301 : $0d79572b4b22d35c$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new $0d79572b4b22d35c$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $0d79572b4b22d35c$export$3f8bb04b555a363c,
                        type: $0d79572b4b22d35c$export$2e8ce08d3f6f5e10,
                        depthTexture: new $0d79572b4b22d35c$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const cameraRPos = new $0d79572b4b22d35c$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $0d79572b4b22d35c$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $0d79572b4b22d35c$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                if (enabledFeatures && enabledFeatures.includes("depth-sensing")) {
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(renderer, depthData, session.renderState);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: "planesdetected",
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $0d79572b4b22d35c$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $0d79572b4b22d35c$var$_e1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$d93cc409a0768c5f();
const $0d79572b4b22d35c$var$_m1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
function $0d79572b4b22d35c$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $0d79572b4b22d35c$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $0d79572b4b22d35c$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $0d79572b4b22d35c$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $0d79572b4b22d35c$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $0d79572b4b22d35c$var$_e1.x *= -1;
            $0d79572b4b22d35c$var$_e1.y *= -1;
            $0d79572b4b22d35c$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $0d79572b4b22d35c$var$_e1.y *= -1;
                $0d79572b4b22d35c$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($0d79572b4b22d35c$var$_m1.makeRotationFromEuler($0d79572b4b22d35c$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $0d79572b4b22d35c$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $0d79572b4b22d35c$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === "number" || typeof value === "boolean") {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + "_" + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === "number" || typeof value === "boolean") cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === "number" || typeof value === "boolean") {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === "number" || typeof value === "boolean") {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
        else console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
class $0d79572b4b22d35c$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $0d79572b4b22d35c$export$1033a2df66368859(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = "default", failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== "undefined" && context instanceof WebGLRenderingContext) throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this._outputColorSpace = $0d79572b4b22d35c$export$561f394b24edfcaa;
        // tone mapping
        this.toneMapping = $0d79572b4b22d35c$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
        const _currentScissor = new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $0d79572b4b22d35c$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $0d79572b4b22d35c$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $0d79572b4b22d35c$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _currentProjectionMatrix = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        const _projScreenMatrix = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        const _vector3 = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const _vector4 = new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${$0d79572b4b22d35c$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener("webglcontextlost", onContextLost, false);
            canvas.addEventListener("webglcontextrestored", onContextRestore, false);
            canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
            if (_gl === null) {
                const contextName = "webgl2";
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error("Error creating WebGL context with your selected attributes.");
                    else throw new Error("Error creating WebGL context.");
                }
            }
        } catch (error) {
            console.error("THREE.WebGLRenderer: " + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $0d79572b4b22d35c$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $0d79572b4b22d35c$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $0d79572b4b22d35c$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $0d79572b4b22d35c$var$WebGLState(_gl);
            if (capabilities.reverseDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $0d79572b4b22d35c$var$WebGLInfo(_gl);
            properties = new $0d79572b4b22d35c$var$WebGLProperties();
            textures = new $0d79572b4b22d35c$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $0d79572b4b22d35c$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $0d79572b4b22d35c$var$WebGLCubeUVMaps(_this);
            attributes = new $0d79572b4b22d35c$var$WebGLAttributes(_gl);
            bindingStates = new $0d79572b4b22d35c$var$WebGLBindingStates(_gl, attributes);
            geometries = new $0d79572b4b22d35c$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $0d79572b4b22d35c$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $0d79572b4b22d35c$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $0d79572b4b22d35c$var$WebGLClipping(properties);
            programCache = new $0d79572b4b22d35c$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $0d79572b4b22d35c$var$WebGLMaterials(_this, properties);
            renderLists = new $0d79572b4b22d35c$var$WebGLRenderLists();
            renderStates = new $0d79572b4b22d35c$var$WebGLRenderStates(extensions);
            background = new $0d79572b4b22d35c$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $0d79572b4b22d35c$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $0d79572b4b22d35c$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $0d79572b4b22d35c$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $0d79572b4b22d35c$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $0d79572b4b22d35c$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + "px";
                canvas.style.height = height + "px";
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $0d79572b4b22d35c$export$c200e7d26f592f21 || targetFormat === $0d79572b4b22d35c$export$1ba1c45f9f77d4d7 || targetFormat === $0d79572b4b22d35c$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $0d79572b4b22d35c$export$2e8ce08d3f6f5e10 || targetType === $0d79572b4b22d35c$export$c3c7fc4518ebba96 || targetType === $0d79572b4b22d35c$export$c63dc51868b06a9d || targetType === $0d79572b4b22d35c$export$6c8ea339bfab1301 || targetType === $0d79572b4b22d35c$export$b3969b01faf587f2 || targetType === $0d79572b4b22d35c$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) {
                bits |= _gl.DEPTH_BUFFER_BIT;
                _gl.clearDepth(this.capabilities.reverseDepthBuffer ? 0 : 1);
            }
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener("webglcontextlost", onContextLost, false);
            canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
            canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener("sessionstart", onXRSessionStart);
            xr.removeEventListener("sessionend", onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log("THREE.WebGLRenderer: Context Lost.");
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log("THREE.WebGLRenderer: Context Restored.");
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener("dispose", onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                else if (!extensions.get("WEBGL_multi_draw")) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, "_gl_DrawID", i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === $0d79572b4b22d35c$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $0d79572b4b22d35c$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $0d79572b4b22d35c$export$2ede184fc2998901;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $0d79572b4b22d35c$export$3b296b6f144d5b03;
            } else getProgram(material, scene, object);
        }
        this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
            return materials;
        };
        // compileAsync
        this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get("KHR_parallel_shader_compile") !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $0d79572b4b22d35c$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== "undefined") animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener("sessionstart", onXRSessionStart);
        xr.addEventListener("sessionend", onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new $0d79572b4b22d35c$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has("EXT_color_buffer_half_float") || extensions.has("EXT_color_buffer_float") ? $0d79572b4b22d35c$export$2697304443f382bc : $0d79572b4b22d35c$export$2e8ce08d3f6f5e10,
                minFilter: $0d79572b4b22d35c$export$5d8599b6a933fb1b,
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: $0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace
            });
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z, activeViewport.w);
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $0d79572b4b22d35c$export$9fcb6b4294603b2;
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has("WEBGL_multisampled_render_to_texture") === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const object = renderItem.object;
                    const geometry = renderItem.geometry;
                    const material = renderItem.material;
                    const group = renderItem.group;
                    if (material.side === $0d79572b4b22d35c$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = $0d79572b4b22d35c$export$d9f0486e75b5ace;
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $0d79572b4b22d35c$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $0d79572b4b22d35c$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $0d79572b4b22d35c$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $0d79572b4b22d35c$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener("dispose", onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $0d79572b4b22d35c$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $0d79572b4b22d35c$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = $0d79572b4b22d35c$export$9fcb6b4294603b2;
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                if (capabilities.reverseDepthBuffer) {
                    _currentProjectionMatrix.copy(camera.projectionMatrix);
                    $0d79572b4b22d35c$var$toNormalizedProjectionMatrix(_currentProjectionMatrix);
                    $0d79572b4b22d35c$var$toReversedProjectionMatrix(_currentProjectionMatrix);
                    p_uniforms.setValue(_gl, "projectionMatrix", _currentProjectionMatrix);
                } else p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
                p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, "bindMatrix");
                p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, "batchingTexture");
                p_uniforms.setValue(_gl, "batchingTexture", object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, "batchingIdTexture");
                p_uniforms.setValue(_gl, "batchingIdTexture", object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, "batchingColorTexture");
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, "batchingColorTexture", object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $0d79572b4b22d35c$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $0d79572b4b22d35c$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
            // common matrices
            p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
            p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
            p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
                    console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
                    renderTargetProperties.__useRenderToTexture = false;
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (!capabilities.textureFormatReadable(textureFormat)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
                if (!capabilities.textureTypeReadable(textureType)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await $0d79572b4b22d35c$var$probeAsync(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
            }
        };
        this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            // support previous signature with position first
            if (texture.isTexture !== true) {
                // @deprecated, r165
                $0d79572b4b22d35c$var$warnOnce("WebGLRenderer: copyFramebufferToTexture function signature has changed.");
                position = arguments[0] || null;
                texture = arguments[1];
            }
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // support previous signature with dstPosition first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                $0d79572b4b22d35c$var$warnOnce("WebGLRenderer: copyTextureToTexture function signature has changed.");
                dstPosition = arguments[0] || null;
                srcTexture = arguments[1];
                dstTexture = arguments[2];
                level = arguments[3] || 0;
                srcRegion = null;
            }
            let width, height, minX, minY;
            let dstX, dstY;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
            } else {
                width = srcTexture.image.width;
                height = srcTexture.image.height;
                minX = 0;
                minY = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
            } else {
                dstX = 0;
                dstY = 0;
            }
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[level] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, image.width, image.height, glFormat, image.data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // support previous signature with source box first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                $0d79572b4b22d35c$var$warnOnce("WebGLRenderer: copyTextureToTexture3D function signature has changed.");
                srcRegion = arguments[0] || null;
                dstPosition = arguments[1] || null;
                srcTexture = arguments[2];
                dstTexture = arguments[3];
                level = arguments[4] || 0;
            }
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[level] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.max.z - srcRegion.min.z;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.min.z;
            } else {
                width = image.width;
                height = image.height;
                depth = image.depth;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
            else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
            else _gl.texSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $0d79572b4b22d35c$export$5a0e9190d10875d3;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace1) {
        this._outputColorSpace = colorSpace1;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = colorSpace1 === $0d79572b4b22d35c$export$626af19ae879bdf6 ? "display-p3" : "srgb";
        gl.unpackColorSpace = $0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace === $0d79572b4b22d35c$export$c0dc1bc7e964761 ? "display-p3" : "srgb";
    }
}
class $0d79572b4b22d35c$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = "";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $0d79572b4b22d35c$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $0d79572b4b22d35c$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = "";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $0d79572b4b22d35c$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $0d79572b4b22d35c$export$38af1803e3442a7f extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.backgroundRotation = new $0d79572b4b22d35c$export$d93cc409a0768c5f();
        this.environmentIntensity = 1;
        this.environmentRotation = new $0d79572b4b22d35c$export$d93cc409a0768c5f();
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
class $0d79572b4b22d35c$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $0d79572b4b22d35c$export$763e8360f4d7f77d;
        this.updateRanges = [];
        this.version = 0;
        this.uuid = $0d79572b4b22d35c$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $0d79572b4b22d35c$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $0d79572b4b22d35c$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $0d79572b4b22d35c$var$_vector$6 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $0d79572b4b22d35c$var$_vector$6.fromBufferAttribute(this, i);
            $0d79572b4b22d35c$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $0d79572b4b22d35c$var$_vector$6.x, $0d79572b4b22d35c$var$_vector$6.y, $0d79572b4b22d35c$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0d79572b4b22d35c$var$_vector$6.fromBufferAttribute(this, i);
            $0d79572b4b22d35c$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $0d79572b4b22d35c$var$_vector$6.x, $0d79572b4b22d35c$var$_vector$6.y, $0d79572b4b22d35c$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $0d79572b4b22d35c$var$_vector$6.fromBufferAttribute(this, i);
            $0d79572b4b22d35c$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $0d79572b4b22d35c$var$_vector$6.x, $0d79572b4b22d35c$var$_vector$6.y, $0d79572b4b22d35c$var$_vector$6.z);
        }
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $0d79572b4b22d35c$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $0d79572b4b22d35c$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $0d79572b4b22d35c$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $0d79572b4b22d35c$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $0d79572b4b22d35c$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $0d79572b4b22d35c$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $0d79572b4b22d35c$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $0d79572b4b22d35c$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $0d79572b4b22d35c$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $0d79572b4b22d35c$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $0d79572b4b22d35c$var$normalize(x, this.array);
            y = $0d79572b4b22d35c$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $0d79572b4b22d35c$var$normalize(x, this.array);
            y = $0d79572b4b22d35c$var$normalize(y, this.array);
            z = $0d79572b4b22d35c$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $0d79572b4b22d35c$var$normalize(x, this.array);
            y = $0d79572b4b22d35c$var$normalize(y, this.array);
            z = $0d79572b4b22d35c$var$normalize(z, this.array);
            w = $0d79572b4b22d35c$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $0d79572b4b22d35c$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $0d79572b4b22d35c$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $0d79572b4b22d35c$export$5ec7dd1c6994bf8e extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = "SpriteMaterial";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $0d79572b4b22d35c$var$_geometry;
const $0d79572b4b22d35c$var$_intersectPoint = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_worldScale = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_mvPosition = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_alignedPosition = /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1();
const $0d79572b4b22d35c$var$_rotatedPosition = /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1();
const $0d79572b4b22d35c$var$_viewWorldMatrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_vA = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vB = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vC = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_uvA = /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1();
const $0d79572b4b22d35c$var$_uvB = /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1();
const $0d79572b4b22d35c$var$_uvC = /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1();
class $0d79572b4b22d35c$export$3075603db8e6204c extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(material = new $0d79572b4b22d35c$export$5ec7dd1c6994bf8e()){
        super();
        this.isSprite = true;
        this.type = "Sprite";
        if ($0d79572b4b22d35c$var$_geometry === undefined) {
            $0d79572b4b22d35c$var$_geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $0d79572b4b22d35c$export$3d5cd879f108f53f(float32Array, 5);
            $0d79572b4b22d35c$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $0d79572b4b22d35c$var$_geometry.setAttribute("position", new $0d79572b4b22d35c$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $0d79572b4b22d35c$var$_geometry.setAttribute("uv", new $0d79572b4b22d35c$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $0d79572b4b22d35c$var$_geometry;
        this.material = material;
        this.center = new $0d79572b4b22d35c$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $0d79572b4b22d35c$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $0d79572b4b22d35c$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $0d79572b4b22d35c$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $0d79572b4b22d35c$var$_worldScale.multiplyScalar(-$0d79572b4b22d35c$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $0d79572b4b22d35c$var$transformVertex($0d79572b4b22d35c$var$_vA.set(-0.5, -0.5, 0), $0d79572b4b22d35c$var$_mvPosition, center, $0d79572b4b22d35c$var$_worldScale, sin, cos);
        $0d79572b4b22d35c$var$transformVertex($0d79572b4b22d35c$var$_vB.set(0.5, -0.5, 0), $0d79572b4b22d35c$var$_mvPosition, center, $0d79572b4b22d35c$var$_worldScale, sin, cos);
        $0d79572b4b22d35c$var$transformVertex($0d79572b4b22d35c$var$_vC.set(0.5, 0.5, 0), $0d79572b4b22d35c$var$_mvPosition, center, $0d79572b4b22d35c$var$_worldScale, sin, cos);
        $0d79572b4b22d35c$var$_uvA.set(0, 0);
        $0d79572b4b22d35c$var$_uvB.set(1, 0);
        $0d79572b4b22d35c$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($0d79572b4b22d35c$var$_vA, $0d79572b4b22d35c$var$_vB, $0d79572b4b22d35c$var$_vC, false, $0d79572b4b22d35c$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $0d79572b4b22d35c$var$transformVertex($0d79572b4b22d35c$var$_vB.set(-0.5, 0.5, 0), $0d79572b4b22d35c$var$_mvPosition, center, $0d79572b4b22d35c$var$_worldScale, sin, cos);
            $0d79572b4b22d35c$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($0d79572b4b22d35c$var$_vA, $0d79572b4b22d35c$var$_vC, $0d79572b4b22d35c$var$_vB, false, $0d79572b4b22d35c$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($0d79572b4b22d35c$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $0d79572b4b22d35c$var$_intersectPoint.clone(),
            uv: $0d79572b4b22d35c$export$5a465592bfe74b48.getInterpolation($0d79572b4b22d35c$var$_intersectPoint, $0d79572b4b22d35c$var$_vA, $0d79572b4b22d35c$var$_vB, $0d79572b4b22d35c$var$_vC, $0d79572b4b22d35c$var$_uvA, $0d79572b4b22d35c$var$_uvB, $0d79572b4b22d35c$var$_uvC, new $0d79572b4b22d35c$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $0d79572b4b22d35c$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $0d79572b4b22d35c$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $0d79572b4b22d35c$var$_rotatedPosition.x = cos * $0d79572b4b22d35c$var$_alignedPosition.x - sin * $0d79572b4b22d35c$var$_alignedPosition.y;
        $0d79572b4b22d35c$var$_rotatedPosition.y = sin * $0d79572b4b22d35c$var$_alignedPosition.x + cos * $0d79572b4b22d35c$var$_alignedPosition.y;
    } else $0d79572b4b22d35c$var$_rotatedPosition.copy($0d79572b4b22d35c$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $0d79572b4b22d35c$var$_rotatedPosition.x;
    vertexPosition.y += $0d79572b4b22d35c$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($0d79572b4b22d35c$var$_viewWorldMatrix);
}
const $0d79572b4b22d35c$var$_v1$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v2$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$112e7237be0c5f30 extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $0d79572b4b22d35c$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($0d79572b4b22d35c$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $0d79572b4b22d35c$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $0d79572b4b22d35c$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $0d79572b4b22d35c$var$_v1$2.distanceTo($0d79572b4b22d35c$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $0d79572b4b22d35c$var$_basePosition = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_skinIndex = /*@__PURE__*/ new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
const $0d79572b4b22d35c$var$_skinWeight = /*@__PURE__*/ new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
const $0d79572b4b22d35c$var$_vector3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_matrix4 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_vertex = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_sphere$4 = /*@__PURE__*/ new $0d79572b4b22d35c$export$805e8b72413ccaba();
const $0d79572b4b22d35c$var$_inverseMatrix$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_ray$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$a186db52eed6d40e();
class $0d79572b4b22d35c$export$b303577035157ecf extends $0d79572b4b22d35c$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = "SkinnedMesh";
        this.bindMode = $0d79572b4b22d35c$export$2595a3798997538;
        this.bindMatrix = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $0d79572b4b22d35c$var$_vertex);
            this.boundingBox.expandByPoint($0d79572b4b22d35c$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $0d79572b4b22d35c$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $0d79572b4b22d35c$var$_vertex);
            this.boundingSphere.expandByPoint($0d79572b4b22d35c$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $0d79572b4b22d35c$var$_sphere$4.copy(this.boundingSphere);
        $0d79572b4b22d35c$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($0d79572b4b22d35c$var$_sphere$4) === false) return;
        // convert ray to local space of skinned mesh
        $0d79572b4b22d35c$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $0d79572b4b22d35c$var$_ray$2.copy(raycaster.ray).applyMatrix4($0d79572b4b22d35c$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($0d79572b4b22d35c$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $0d79572b4b22d35c$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $0d79572b4b22d35c$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $0d79572b4b22d35c$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $0d79572b4b22d35c$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $0d79572b4b22d35c$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $0d79572b4b22d35c$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $0d79572b4b22d35c$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $0d79572b4b22d35c$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $0d79572b4b22d35c$var$_skinIndex.getComponent(i);
                $0d79572b4b22d35c$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($0d79572b4b22d35c$var$_vector3.copy($0d79572b4b22d35c$var$_basePosition).applyMatrix4($0d79572b4b22d35c$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
}
class $0d79572b4b22d35c$export$b127726e56765aa4 extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = "Bone";
    }
}
class $0d79572b4b22d35c$export$b691f601014eabe1 extends $0d79572b4b22d35c$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $0d79572b4b22d35c$export$727aa5ec3fe39bf0, minFilter = $0d79572b4b22d35c$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $0d79572b4b22d35c$var$_offsetMatrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_identityMatrix$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
class $0d79572b4b22d35c$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $0d79572b4b22d35c$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $0d79572b4b22d35c$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $0d79572b4b22d35c$var$_identityMatrix$1;
            $0d79572b4b22d35c$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $0d79572b4b22d35c$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $0d79572b4b22d35c$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $0d79572b4b22d35c$export$b691f601014eabe1(boneMatrices, size, size, $0d79572b4b22d35c$export$3f8bb04b555a363c, $0d79572b4b22d35c$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $0d79572b4b22d35c$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $0d79572b4b22d35c$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $0d79572b4b22d35c$export$32ea87a8b54d744a extends $0d79572b4b22d35c$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $0d79572b4b22d35c$var$_instanceLocalMatrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_instanceWorldMatrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_instanceIntersects = [];
const $0d79572b4b22d35c$var$_box3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
const $0d79572b4b22d35c$var$_identity = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_mesh$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$e176487c05830cc5();
const $0d79572b4b22d35c$var$_sphere$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$805e8b72413ccaba();
class $0d79572b4b22d35c$export$f3c979c331175ad7 extends $0d79572b4b22d35c$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $0d79572b4b22d35c$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.morphTexture = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $0d79572b4b22d35c$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $0d79572b4b22d35c$var$_instanceLocalMatrix);
            $0d79572b4b22d35c$var$_box3.copy(geometry.boundingBox).applyMatrix4($0d79572b4b22d35c$var$_instanceLocalMatrix);
            this.boundingBox.union($0d79572b4b22d35c$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $0d79572b4b22d35c$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $0d79572b4b22d35c$var$_instanceLocalMatrix);
            $0d79572b4b22d35c$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4($0d79572b4b22d35c$var$_instanceLocalMatrix);
            this.boundingSphere.union($0d79572b4b22d35c$var$_sphere$3);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $0d79572b4b22d35c$var$_mesh$1.geometry = this.geometry;
        $0d79572b4b22d35c$var$_mesh$1.material = this.material;
        if ($0d79572b4b22d35c$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $0d79572b4b22d35c$var$_sphere$3.copy(this.boundingSphere);
        $0d79572b4b22d35c$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($0d79572b4b22d35c$var$_sphere$3) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $0d79572b4b22d35c$var$_instanceLocalMatrix);
            $0d79572b4b22d35c$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $0d79572b4b22d35c$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $0d79572b4b22d35c$var$_mesh$1.matrixWorld = $0d79572b4b22d35c$var$_instanceWorldMatrix;
            $0d79572b4b22d35c$var$_mesh$1.raycast(raycaster, $0d79572b4b22d35c$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $0d79572b4b22d35c$var$_instanceIntersects.length; i < l; i++){
                const intersect = $0d79572b4b22d35c$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $0d79572b4b22d35c$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $0d79572b4b22d35c$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $0d79572b4b22d35c$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $0d79572b4b22d35c$export$4e041a7967d15c4b, $0d79572b4b22d35c$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
        return this;
    }
}
function $0d79572b4b22d35c$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $0d79572b4b22d35c$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $0d79572b4b22d35c$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(drawRange, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = drawRange.start;
        item.count = drawRange.count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $0d79572b4b22d35c$var$_matrix$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_invMatrixWorld = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_identityMatrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_whiteColor = /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e(1, 1, 1);
const $0d79572b4b22d35c$var$_projScreenMatrix$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_frustum = /*@__PURE__*/ new $0d79572b4b22d35c$export$35efe6f4c85463d2();
const $0d79572b4b22d35c$var$_box$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
const $0d79572b4b22d35c$var$_sphere$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$805e8b72413ccaba();
const $0d79572b4b22d35c$var$_vector$5 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_forward = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_temp = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_renderList = /*@__PURE__*/ new $0d79572b4b22d35c$var$MultiDrawRenderList();
const $0d79572b4b22d35c$var$_mesh = /*@__PURE__*/ new $0d79572b4b22d35c$export$e176487c05830cc5();
const $0d79572b4b22d35c$var$_batchIntersects = [];
// @TODO: SkinnedMesh support?
// @TODO: geometry.groups support?
// @TODO: geometry.drawRange support?
// @TODO: geometry.morphAttributes support?
// @TODO: Support uniform parameter per geometry
// @TODO: Add an "optimize" function to pack geometry and remove data gaps
// copies data from attribute "src" into "target" starting at "targetOffset"
function $0d79572b4b22d35c$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
class $0d79572b4b22d35c$export$6e01c5ee52ed8f7b extends $0d79572b4b22d35c$export$e176487c05830cc5 {
    get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $0d79572b4b22d35c$export$b7be63a67df8959(), material);
        this.isBatchedMesh = true;
        this.perObjectFrustumCulled = true;
        this.sortObjects = true;
        this.boundingBox = null;
        this.boundingSphere = null;
        this.customSort = null;
        // stores visible, active, and geometry id per object
        this._drawInfo = [];
        // instance ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        // geometry information
        this._drawRanges = [];
        this._reservedRanges = [];
        this._bounds = [];
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        this._geometryInitialized = false;
        this._geometryCount = 0;
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        this._visibilityChanged = true;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $0d79572b4b22d35c$export$b691f601014eabe1(matricesArray, size, size, $0d79572b4b22d35c$export$3f8bb04b555a363c, $0d79572b4b22d35c$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $0d79572b4b22d35c$export$b691f601014eabe1(indirectArray, size, size, $0d79572b4b22d35c$export$aa92e870a709d190, $0d79572b4b22d35c$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $0d79572b4b22d35c$export$b691f601014eabe1(colorsArray, size, size, $0d79572b4b22d35c$export$3f8bb04b555a363c, $0d79572b4b22d35c$export$f6d331659b644596);
        colorsTexture.colorSpace = $0d79572b4b22d35c$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $0d79572b4b22d35c$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $0d79572b4b22d35c$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error("BatchedMesh: All attributes must have a consistent itemSize and normalized value.");
        }
    }
    setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const drawInfo = this._drawInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = drawInfo.length; i < l; i++){
            if (drawInfo[i].active === false) continue;
            const geometryId = drawInfo[i].geometryIndex;
            this.getMatrixAt(i, $0d79572b4b22d35c$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $0d79572b4b22d35c$var$_box$1).applyMatrix4($0d79572b4b22d35c$var$_matrix$1);
            boundingBox.union($0d79572b4b22d35c$var$_box$1);
        }
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $0d79572b4b22d35c$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const drawInfo = this._drawInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = drawInfo.length; i < l; i++){
            if (drawInfo[i].active === false) continue;
            const geometryId = drawInfo[i].geometryIndex;
            this.getMatrixAt(i, $0d79572b4b22d35c$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $0d79572b4b22d35c$var$_sphere$2).applyMatrix4($0d79572b4b22d35c$var$_matrix$1);
            boundingSphere.union($0d79572b4b22d35c$var$_sphere$2);
        }
    }
    addInstance(geometryId) {
        const atCapacity = this._drawInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error("BatchedMesh: Maximum item count reached.");
        const instanceDrawInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            drawId = this._availableInstanceIds.pop();
            this._drawInfo[drawId] = instanceDrawInfo;
        } else {
            drawId = this._drawInfo.length;
            this._drawInfo.push(instanceDrawInfo);
        }
        const matricesTexture = this._matricesTexture;
        const matricesArray = matricesTexture.image.data;
        $0d79572b4b22d35c$var$_identityMatrix.toArray(matricesArray, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $0d79572b4b22d35c$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        return drawId;
    }
    addGeometry(geometry, vertexCount = -1, indexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        // ensure we're not over geometry
        if (this._drawInfo.length >= this._maxInstanceCount) throw new Error("BatchedMesh: Maximum item count reached.");
        // get the necessary range fo the geometry
        const reservedRange = {
            vertexStart: -1,
            vertexCount: -1,
            indexStart: -1,
            indexCount: -1
        };
        let lastRange = null;
        const reservedRanges = this._reservedRanges;
        const drawRanges = this._drawRanges;
        const bounds = this._bounds;
        if (this._geometryCount !== 0) lastRange = reservedRanges[reservedRanges.length - 1];
        if (vertexCount === -1) reservedRange.vertexCount = geometry.getAttribute("position").count;
        else reservedRange.vertexCount = vertexCount;
        if (lastRange === null) reservedRange.vertexStart = 0;
        else reservedRange.vertexStart = lastRange.vertexStart + lastRange.vertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            if (indexCount === -1) reservedRange.indexCount = index.count;
            else reservedRange.indexCount = indexCount;
            if (lastRange === null) reservedRange.indexStart = 0;
            else reservedRange.indexStart = lastRange.indexStart + lastRange.indexCount;
        }
        if (reservedRange.indexStart !== -1 && reservedRange.indexStart + reservedRange.indexCount > this._maxIndexCount || reservedRange.vertexStart + reservedRange.vertexCount > this._maxVertexCount) throw new Error("BatchedMesh: Reserved space request exceeds the maximum buffer size.");
        // update id
        const geometryId = this._geometryCount;
        this._geometryCount++;
        // add the reserved range and draw range objects
        reservedRanges.push(reservedRange);
        drawRanges.push({
            start: hasIndex ? reservedRange.indexStart : reservedRange.vertexStart,
            count: -1
        });
        bounds.push({
            boxInitialized: false,
            box: new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3(),
            sphereInitialized: false,
            sphere: new $0d79572b4b22d35c$export$805e8b72413ccaba()
        });
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        return geometryId;
    }
    setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error("BatchedMesh: Maximum geometry count reached.");
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const reservedRange = this._reservedRanges[geometryId];
        if (hasIndex && srcIndex.count > reservedRange.indexCount || geometry.attributes.position.count > reservedRange.vertexCount) throw new Error("BatchedMesh: Reserved space not large enough for provided geometry.");
        // copy geometry over
        const vertexStart = reservedRange.vertexStart;
        const vertexCount = reservedRange.vertexCount;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $0d79572b4b22d35c$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = vertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, vertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = reservedRange.indexStart;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedRange.indexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, reservedRange.indexCount);
        }
        // store the bounding boxes
        const bound = this._bounds[geometryId];
        if (geometry.boundingBox !== null) {
            bound.box.copy(geometry.boundingBox);
            bound.boxInitialized = true;
        } else bound.boxInitialized = false;
        if (geometry.boundingSphere !== null) {
            bound.sphere.copy(geometry.boundingSphere);
            bound.sphereInitialized = true;
        } else bound.sphereInitialized = false;
        // set drawRange count
        const drawRange = this._drawRanges[geometryId];
        const posAttr = geometry.getAttribute("position");
        drawRange.count = hasIndex ? srcIndex.count : posAttr.count;
        this._visibilityChanged = true;
        return geometryId;
    }
    /*
	deleteGeometry( geometryId ) {

		// TODO: delete geometry and associated instances

	}
	*/ deleteInstance(instanceId) {
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return this;
        drawInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    // get bounding box and compute it if it doesn't exist
    getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const bound = this._bounds[geometryId];
        const box = bound.box;
        const geometry = this.geometry;
        if (bound.boxInitialized === false) {
            box.makeEmpty();
            const index = geometry.index;
            const position = geometry.attributes.position;
            const drawRange = this._drawRanges[geometryId];
            for(let i = drawRange.start, l = drawRange.start + drawRange.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($0d79572b4b22d35c$var$_vector$5.fromBufferAttribute(position, iv));
            }
            bound.boxInitialized = true;
        }
        target.copy(box);
        return target;
    }
    // get bounding sphere and compute it if it doesn't exist
    getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const bound = this._bounds[geometryId];
        const sphere = bound.sphere;
        const geometry = this.geometry;
        if (bound.sphereInitialized === false) {
            sphere.makeEmpty();
            this.getBoundingBoxAt(geometryId, $0d79572b4b22d35c$var$_box$1);
            $0d79572b4b22d35c$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            const drawRange = this._drawRanges[geometryId];
            let maxRadiusSq = 0;
            for(let i = drawRange.start, l = drawRange.start + drawRange.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $0d79572b4b22d35c$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($0d79572b4b22d35c$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            bound.sphereInitialized = true;
        }
        target.copy(sphere);
        return target;
    }
    setMatrixAt(instanceId, matrix) {
        // @TODO: Map geometryId to index of the arrays because
        //        optimize() can make geometryId mismatch the index
        const drawInfo = this._drawInfo;
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return this;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    getMatrixAt(instanceId, matrix) {
        const drawInfo = this._drawInfo;
        const matricesArray = this._matricesTexture.image.data;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return null;
        return matrix.fromArray(matricesArray, instanceId * 16);
    }
    setColorAt(instanceId, color) {
        if (this._colorsTexture === null) this._initColorsTexture();
        // @TODO: Map id to index of the arrays because
        //        optimize() can make id mismatch the index
        const colorsTexture = this._colorsTexture;
        const colorsArray = this._colorsTexture.image.data;
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return this;
        color.toArray(colorsArray, instanceId * 4);
        colorsTexture.needsUpdate = true;
        return this;
    }
    getColorAt(instanceId, color) {
        const colorsArray = this._colorsTexture.image.data;
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return null;
        return color.fromArray(colorsArray, instanceId * 4);
    }
    setVisibleAt(instanceId, value) {
        // if the geometry is out of range, not active, or visibility state
        // does not change then return early
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false || drawInfo[instanceId].visible === value) return this;
        drawInfo[instanceId].visible = value;
        this._visibilityChanged = true;
        return this;
    }
    getVisibleAt(instanceId) {
        // return early if the geometry is out of range or not active
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return false;
        return drawInfo[instanceId].visible;
    }
    setGeometryIdAt(instanceId, geometryId) {
        // return early if the geometry is out of range or not active
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return null;
        // check if the provided geometryId is within the valid range
        if (geometryId < 0 || geometryId >= this._geometryCount) return null;
        drawInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    getGeometryIdAt(instanceId) {
        const drawInfo = this._drawInfo;
        if (instanceId >= drawInfo.length || drawInfo[instanceId].active === false) return -1;
        return drawInfo[instanceId].geometryIndex;
    }
    getGeometryRangeAt(geometryId, target = {}) {
        if (geometryId < 0 || geometryId >= this._geometryCount) return null;
        const drawRange = this._drawRanges[geometryId];
        target.start = drawRange.start;
        target.count = drawRange.count;
        return target;
    }
    raycast(raycaster, intersects) {
        const drawInfo = this._drawInfo;
        const drawRanges = this._drawRanges;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $0d79572b4b22d35c$var$_mesh.material = this.material;
        $0d79572b4b22d35c$var$_mesh.geometry.index = batchGeometry.index;
        $0d79572b4b22d35c$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($0d79572b4b22d35c$var$_mesh.geometry.boundingBox === null) $0d79572b4b22d35c$var$_mesh.geometry.boundingBox = new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
        if ($0d79572b4b22d35c$var$_mesh.geometry.boundingSphere === null) $0d79572b4b22d35c$var$_mesh.geometry.boundingSphere = new $0d79572b4b22d35c$export$805e8b72413ccaba();
        for(let i = 0, l = drawInfo.length; i < l; i++){
            if (!drawInfo[i].visible || !drawInfo[i].active) continue;
            const geometryId = drawInfo[i].geometryIndex;
            const drawRange = drawRanges[geometryId];
            $0d79572b4b22d35c$var$_mesh.geometry.setDrawRange(drawRange.start, drawRange.count);
            // ge the intersects
            this.getMatrixAt(i, $0d79572b4b22d35c$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $0d79572b4b22d35c$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $0d79572b4b22d35c$var$_mesh.geometry.boundingSphere);
            $0d79572b4b22d35c$var$_mesh.raycast(raycaster, $0d79572b4b22d35c$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $0d79572b4b22d35c$var$_batchIntersects.length; j < l; j++){
                const intersect = $0d79572b4b22d35c$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $0d79572b4b22d35c$var$_batchIntersects.length = 0;
        }
        $0d79572b4b22d35c$var$_mesh.material = null;
        $0d79572b4b22d35c$var$_mesh.geometry.index = null;
        $0d79572b4b22d35c$var$_mesh.geometry.attributes = {};
        $0d79572b4b22d35c$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._drawRanges = source._drawRanges.map((range)=>({
                ...range
            }));
        this._reservedRanges = source._reservedRanges.map((range)=>({
                ...range
            }));
        this._drawInfo = source._drawInfo.map((inf)=>({
                ...inf
            }));
        this._bounds = source._bounds.map((bound)=>({
                boxInitialized: bound.boxInitialized,
                box: bound.box.clone(),
                sphereInitialized: bound.sphereInitialized,
                sphere: bound.sphere.clone()
            }));
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._geometryCount = source._geometryCount;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
        return this;
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const drawInfo = this._drawInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const drawRanges = this._drawRanges;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled) {
            $0d79572b4b22d35c$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $0d79572b4b22d35c$var$_frustum.setFromProjectionMatrix($0d79572b4b22d35c$var$_projScreenMatrix$2, renderer.coordinateSystem);
        }
        let count = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $0d79572b4b22d35c$var$_invMatrixWorld.copy(this.matrixWorld).invert();
            $0d79572b4b22d35c$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($0d79572b4b22d35c$var$_invMatrixWorld);
            $0d79572b4b22d35c$var$_forward.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($0d79572b4b22d35c$var$_invMatrixWorld);
            for(let i = 0, l = drawInfo.length; i < l; i++)if (drawInfo[i].visible && drawInfo[i].active) {
                const geometryId = drawInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $0d79572b4b22d35c$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $0d79572b4b22d35c$var$_sphere$2).applyMatrix4($0d79572b4b22d35c$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !$0d79572b4b22d35c$var$_frustum.intersectsSphere($0d79572b4b22d35c$var$_sphere$2);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const z = $0d79572b4b22d35c$var$_temp.subVectors($0d79572b4b22d35c$var$_sphere$2.center, $0d79572b4b22d35c$var$_vector$5).dot($0d79572b4b22d35c$var$_forward);
                    $0d79572b4b22d35c$var$_renderList.push(drawRanges[geometryId], z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $0d79572b4b22d35c$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $0d79572b4b22d35c$var$sortTransparent : $0d79572b4b22d35c$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[count] = item.start * bytesPerElement;
                multiDrawCounts[count] = item.count;
                indirectArray[count] = item.index;
                count++;
            }
            $0d79572b4b22d35c$var$_renderList.reset();
        } else {
            for(let i = 0, l = drawInfo.length; i < l; i++)if (drawInfo[i].visible && drawInfo[i].active) {
                const geometryId = drawInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $0d79572b4b22d35c$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $0d79572b4b22d35c$var$_sphere$2).applyMatrix4($0d79572b4b22d35c$var$_matrix$1);
                    culled = !$0d79572b4b22d35c$var$_frustum.intersectsSphere($0d79572b4b22d35c$var$_sphere$2);
                }
                if (!culled) {
                    const range = drawRanges[geometryId];
                    multiDrawStarts[count] = range.start * bytesPerElement;
                    multiDrawCounts[count] = range.count;
                    indirectArray[count] = i;
                    count++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = count;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
class $0d79572b4b22d35c$export$fbaaa33907730a0c extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = "LineBasicMaterial";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $0d79572b4b22d35c$var$_vStart = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_vEnd = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_inverseMatrix$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_ray$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$a186db52eed6d40e();
const $0d79572b4b22d35c$var$_sphere$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$805e8b72413ccaba();
const $0d79572b4b22d35c$var$_intersectPointOnRay = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_intersectPointOnSegment = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$17d680238e50603e extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(geometry = new $0d79572b4b22d35c$export$b7be63a67df8959(), material = new $0d79572b4b22d35c$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $0d79572b4b22d35c$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $0d79572b4b22d35c$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $0d79572b4b22d35c$var$_vStart.distanceTo($0d79572b4b22d35c$var$_vEnd);
            }
            geometry.setAttribute("lineDistance", new $0d79572b4b22d35c$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0d79572b4b22d35c$var$_sphere$1.copy(geometry.boundingSphere);
        $0d79572b4b22d35c$var$_sphere$1.applyMatrix4(matrixWorld);
        $0d79572b4b22d35c$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($0d79572b4b22d35c$var$_sphere$1) === false) return;
        //
        $0d79572b4b22d35c$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $0d79572b4b22d35c$var$_ray$1.copy(raycaster.ray).applyMatrix4($0d79572b4b22d35c$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $0d79572b4b22d35c$var$checkIntersection(this, raycaster, $0d79572b4b22d35c$var$_ray$1, localThresholdSq, a, b);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $0d79572b4b22d35c$var$checkIntersection(this, raycaster, $0d79572b4b22d35c$var$_ray$1, localThresholdSq, a, b);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $0d79572b4b22d35c$var$checkIntersection(this, raycaster, $0d79572b4b22d35c$var$_ray$1, localThresholdSq, i, i + 1);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $0d79572b4b22d35c$var$checkIntersection(this, raycaster, $0d79572b4b22d35c$var$_ray$1, localThresholdSq, end - 1, start);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $0d79572b4b22d35c$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b) {
    const positionAttribute = object.geometry.attributes.position;
    $0d79572b4b22d35c$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $0d79572b4b22d35c$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($0d79572b4b22d35c$var$_vStart, $0d79572b4b22d35c$var$_vEnd, $0d79572b4b22d35c$var$_intersectPointOnRay, $0d79572b4b22d35c$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $0d79572b4b22d35c$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($0d79572b4b22d35c$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $0d79572b4b22d35c$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: a,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const $0d79572b4b22d35c$var$_start = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_end = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$ff1ed10fedfdd604 extends $0d79572b4b22d35c$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $0d79572b4b22d35c$var$_start.fromBufferAttribute(positionAttribute, i);
                $0d79572b4b22d35c$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $0d79572b4b22d35c$var$_start.distanceTo($0d79572b4b22d35c$var$_end);
            }
            geometry.setAttribute("lineDistance", new $0d79572b4b22d35c$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $0d79572b4b22d35c$export$f85a24d745e4f17d extends $0d79572b4b22d35c$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = "LineLoop";
    }
}
class $0d79572b4b22d35c$export$a178c45366ce5d6b extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = "PointsMaterial";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $0d79572b4b22d35c$var$_inverseMatrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_ray = /*@__PURE__*/ new $0d79572b4b22d35c$export$a186db52eed6d40e();
const $0d79572b4b22d35c$var$_sphere = /*@__PURE__*/ new $0d79572b4b22d35c$export$805e8b72413ccaba();
const $0d79572b4b22d35c$var$_position$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$1c787534cb11aa3e extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(geometry = new $0d79572b4b22d35c$export$b7be63a67df8959(), material = new $0d79572b4b22d35c$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0d79572b4b22d35c$var$_sphere.copy(geometry.boundingSphere);
        $0d79572b4b22d35c$var$_sphere.applyMatrix4(matrixWorld);
        $0d79572b4b22d35c$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($0d79572b4b22d35c$var$_sphere) === false) return;
        //
        $0d79572b4b22d35c$var$_inverseMatrix.copy(matrixWorld).invert();
        $0d79572b4b22d35c$var$_ray.copy(raycaster.ray).applyMatrix4($0d79572b4b22d35c$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $0d79572b4b22d35c$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $0d79572b4b22d35c$var$testPoint($0d79572b4b22d35c$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $0d79572b4b22d35c$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $0d79572b4b22d35c$var$testPoint($0d79572b4b22d35c$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $0d79572b4b22d35c$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $0d79572b4b22d35c$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $0d79572b4b22d35c$export$64b5c384219d3699();
        $0d79572b4b22d35c$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
class $0d79572b4b22d35c$export$6e09d1edf8d5a25c extends $0d79572b4b22d35c$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $0d79572b4b22d35c$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $0d79572b4b22d35c$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $0d79572b4b22d35c$export$9270d786f73ce6fe extends $0d79572b4b22d35c$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $0d79572b4b22d35c$export$727aa5ec3fe39bf0;
        this.minFilter = $0d79572b4b22d35c$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $0d79572b4b22d35c$export$3466bac9141a5cc4 extends $0d79572b4b22d35c$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $0d79572b4b22d35c$export$5fe6b8e34b274fcb extends $0d79572b4b22d35c$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $0d79572b4b22d35c$export$9d9334239a5a5e06;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $0d79572b4b22d35c$export$d80173634de65bff extends $0d79572b4b22d35c$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $0d79572b4b22d35c$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $0d79572b4b22d35c$export$f7189e49152d1c13 extends $0d79572b4b22d35c$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $0d79572b4b22d35c$export$c977b3e384af9ae1() : new $0d79572b4b22d35c$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const mat = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $0d79572b4b22d35c$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $0d79572b4b22d35c$export$64b5c384219d3699();
        binormals[0] = new $0d79572b4b22d35c$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($0d79572b4b22d35c$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($0d79572b4b22d35c$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $0d79572b4b22d35c$export$3f87a931616cde04 extends $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget = new $0d79572b4b22d35c$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $0d79572b4b22d35c$export$b1eedc9aab6300e8 extends $0d79572b4b22d35c$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = "ArcCurve";
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $0d79572b4b22d35c$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $0d79572b4b22d35c$var$tmp = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$px = /*@__PURE__*/ new $0d79572b4b22d35c$var$CubicPoly();
const $0d79572b4b22d35c$var$py = /*@__PURE__*/ new $0d79572b4b22d35c$var$CubicPoly();
const $0d79572b4b22d35c$var$pz = /*@__PURE__*/ new $0d79572b4b22d35c$var$CubicPoly();
class $0d79572b4b22d35c$export$b9146b27c24b744c extends $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $0d79572b4b22d35c$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $0d79572b4b22d35c$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $0d79572b4b22d35c$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $0d79572b4b22d35c$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $0d79572b4b22d35c$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $0d79572b4b22d35c$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $0d79572b4b22d35c$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $0d79572b4b22d35c$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $0d79572b4b22d35c$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $0d79572b4b22d35c$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $0d79572b4b22d35c$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($0d79572b4b22d35c$var$px.calc(weight), $0d79572b4b22d35c$var$py.calc(weight), $0d79572b4b22d35c$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $0d79572b4b22d35c$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $0d79572b4b22d35c$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $0d79572b4b22d35c$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $0d79572b4b22d35c$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $0d79572b4b22d35c$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $0d79572b4b22d35c$var$QuadraticBezier(t, p0, p1, p2) {
    return $0d79572b4b22d35c$var$QuadraticBezierP0(t, p0) + $0d79572b4b22d35c$var$QuadraticBezierP1(t, p1) + $0d79572b4b22d35c$var$QuadraticBezierP2(t, p2);
}
//
function $0d79572b4b22d35c$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $0d79572b4b22d35c$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $0d79572b4b22d35c$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $0d79572b4b22d35c$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $0d79572b4b22d35c$var$CubicBezier(t, p0, p1, p2, p3) {
    return $0d79572b4b22d35c$var$CubicBezierP0(t, p0) + $0d79572b4b22d35c$var$CubicBezierP1(t, p1) + $0d79572b4b22d35c$var$CubicBezierP2(t, p2) + $0d79572b4b22d35c$var$CubicBezierP3(t, p3);
}
class $0d79572b4b22d35c$export$e36650d36468bb39 extends $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), v1 = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), v2 = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), v3 = new $0d79572b4b22d35c$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $0d79572b4b22d35c$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($0d79572b4b22d35c$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $0d79572b4b22d35c$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $0d79572b4b22d35c$export$13d5f1c9525f246c extends $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0d79572b4b22d35c$export$64b5c384219d3699(), v1 = new $0d79572b4b22d35c$export$64b5c384219d3699(), v2 = new $0d79572b4b22d35c$export$64b5c384219d3699(), v3 = new $0d79572b4b22d35c$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $0d79572b4b22d35c$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($0d79572b4b22d35c$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $0d79572b4b22d35c$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $0d79572b4b22d35c$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $0d79572b4b22d35c$export$ab2e07e76531a47e extends $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), v2 = new $0d79572b4b22d35c$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0d79572b4b22d35c$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $0d79572b4b22d35c$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $0d79572b4b22d35c$export$1fdfd9d9cf487600 extends $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $0d79572b4b22d35c$export$64b5c384219d3699(), v2 = new $0d79572b4b22d35c$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = "LineCurve3";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0d79572b4b22d35c$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $0d79572b4b22d35c$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $0d79572b4b22d35c$export$5938c4ee491a43ad extends $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), v1 = new $0d79572b4b22d35c$export$c977b3e384af9ae1(), v2 = new $0d79572b4b22d35c$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0d79572b4b22d35c$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($0d79572b4b22d35c$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $0d79572b4b22d35c$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $0d79572b4b22d35c$export$bf3f4c7e459f90fc extends $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $0d79572b4b22d35c$export$64b5c384219d3699(), v1 = new $0d79572b4b22d35c$export$64b5c384219d3699(), v2 = new $0d79572b4b22d35c$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $0d79572b4b22d35c$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($0d79572b4b22d35c$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $0d79572b4b22d35c$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $0d79572b4b22d35c$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $0d79572b4b22d35c$export$d3bdd77da77afc1b extends $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $0d79572b4b22d35c$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($0d79572b4b22d35c$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $0d79572b4b22d35c$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $0d79572b4b22d35c$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $0d79572b4b22d35c$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $0d79572b4b22d35c$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $0d79572b4b22d35c$export$b9146b27c24b744c,
    CubicBezierCurve: $0d79572b4b22d35c$export$e36650d36468bb39,
    CubicBezierCurve3: $0d79572b4b22d35c$export$13d5f1c9525f246c,
    EllipseCurve: $0d79572b4b22d35c$export$3f87a931616cde04,
    LineCurve: $0d79572b4b22d35c$export$ab2e07e76531a47e,
    LineCurve3: $0d79572b4b22d35c$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $0d79572b4b22d35c$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $0d79572b4b22d35c$export$bf3f4c7e459f90fc,
    SplineCurve: $0d79572b4b22d35c$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $0d79572b4b22d35c$export$4aaf9b66af1bbf2c extends $0d79572b4b22d35c$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? "LineCurve" : "LineCurve3";
            this.curves.push(new $0d79572b4b22d35c$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $0d79572b4b22d35c$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $0d79572b4b22d35c$export$4b2950bdac9b6ee9 extends $0d79572b4b22d35c$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $0d79572b4b22d35c$export$ab2e07e76531a47e(this.currentPoint.clone(), new $0d79572b4b22d35c$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $0d79572b4b22d35c$export$5938c4ee491a43ad(this.currentPoint.clone(), new $0d79572b4b22d35c$export$c977b3e384af9ae1(aCPx, aCPy), new $0d79572b4b22d35c$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $0d79572b4b22d35c$export$e36650d36468bb39(this.currentPoint.clone(), new $0d79572b4b22d35c$export$c977b3e384af9ae1(aCP1x, aCP1y), new $0d79572b4b22d35c$export$c977b3e384af9ae1(aCP2x, aCP2y), new $0d79572b4b22d35c$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $0d79572b4b22d35c$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $0d79572b4b22d35c$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $0d79572b4b22d35c$export$6d839803fcd1882c extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(points = [
        new $0d79572b4b22d35c$export$c977b3e384af9ae1(0, -0.5),
        new $0d79572b4b22d35c$export$c977b3e384af9ae1(0.5, 0),
        new $0d79572b4b22d35c$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $0d79572b4b22d35c$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const uv = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
        const normal = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const curNormal = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const prevNormal = new $0d79572b4b22d35c$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $0d79572b4b22d35c$export$41680e8551036033 extends $0d79572b4b22d35c$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $0d79572b4b22d35c$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = "CapsuleGeometry";
        this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $0d79572b4b22d35c$export$d5c0e8d607467193 extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const uv = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $0d79572b4b22d35c$export$68f745719dbe5198 extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $0d79572b4b22d35c$export$64b5c384219d3699();
            const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
            const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $0d79572b4b22d35c$export$a7a48974f285c9b3 extends $0d79572b4b22d35c$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $0d79572b4b22d35c$export$60e57a7d3f20ff65 extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $0d79572b4b22d35c$export$64b5c384219d3699();
            const b = new $0d79572b4b22d35c$export$64b5c384219d3699();
            const c = new $0d79572b4b22d35c$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $0d79572b4b22d35c$export$64b5c384219d3699();
            const b = new $0d79572b4b22d35c$export$64b5c384219d3699();
            const c = new $0d79572b4b22d35c$export$64b5c384219d3699();
            const centroid = new $0d79572b4b22d35c$export$64b5c384219d3699();
            const uvA = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
            const uvB = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
            const uvC = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $0d79572b4b22d35c$export$c0babfeb8708fc9c extends $0d79572b4b22d35c$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $0d79572b4b22d35c$var$_v0 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v1$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_normal = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_triangle = /*@__PURE__*/ new $0d79572b4b22d35c$export$5a465592bfe74b48();
class $0d79572b4b22d35c$export$4730b1542707547f extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($0d79572b4b22d35c$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $0d79572b4b22d35c$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $0d79572b4b22d35c$var$_triangle.getNormal($0d79572b4b22d35c$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $0d79572b4b22d35c$var$_triangle[vertKeys[j]];
                    const v1 = $0d79572b4b22d35c$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($0d79572b4b22d35c$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $0d79572b4b22d35c$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $0d79572b4b22d35c$var$_v0.fromBufferAttribute(positionAttr, index0);
                $0d79572b4b22d35c$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($0d79572b4b22d35c$var$_v0.x, $0d79572b4b22d35c$var$_v0.y, $0d79572b4b22d35c$var$_v0.z);
                vertices.push($0d79572b4b22d35c$var$_v1$1.x, $0d79572b4b22d35c$var$_v1$1.y, $0d79572b4b22d35c$var$_v1$1.z);
            }
            this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $0d79572b4b22d35c$export$6428a7f2611ef1fa extends $0d79572b4b22d35c$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $0d79572b4b22d35c$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $0d79572b4b22d35c$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $0d79572b4b22d35c$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $0d79572b4b22d35c$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $0d79572b4b22d35c$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $0d79572b4b22d35c$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $0d79572b4b22d35c$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $0d79572b4b22d35c$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $0d79572b4b22d35c$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $0d79572b4b22d35c$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $0d79572b4b22d35c$var$equals(last, last.next)) {
        $0d79572b4b22d35c$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $0d79572b4b22d35c$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($0d79572b4b22d35c$var$equals(p, p.next) || $0d79572b4b22d35c$var$area(p.prev, p, p.next) === 0)) {
            $0d79572b4b22d35c$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $0d79572b4b22d35c$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $0d79572b4b22d35c$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $0d79572b4b22d35c$var$isEarHashed(ear, minX, minY, invSize) : $0d79572b4b22d35c$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $0d79572b4b22d35c$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $0d79572b4b22d35c$var$earcutLinked($0d79572b4b22d35c$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $0d79572b4b22d35c$var$cureLocalIntersections($0d79572b4b22d35c$var$filterPoints(ear), triangles, dim);
                $0d79572b4b22d35c$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $0d79572b4b22d35c$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $0d79572b4b22d35c$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($0d79572b4b22d35c$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $0d79572b4b22d35c$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $0d79572b4b22d35c$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $0d79572b4b22d35c$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($0d79572b4b22d35c$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $0d79572b4b22d35c$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $0d79572b4b22d35c$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $0d79572b4b22d35c$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $0d79572b4b22d35c$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $0d79572b4b22d35c$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $0d79572b4b22d35c$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $0d79572b4b22d35c$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $0d79572b4b22d35c$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $0d79572b4b22d35c$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $0d79572b4b22d35c$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $0d79572b4b22d35c$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$0d79572b4b22d35c$var$equals(a, b) && $0d79572b4b22d35c$var$intersects(a, p, p.next, b) && $0d79572b4b22d35c$var$locallyInside(a, b) && $0d79572b4b22d35c$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $0d79572b4b22d35c$var$removeNode(p);
            $0d79572b4b22d35c$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $0d79572b4b22d35c$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $0d79572b4b22d35c$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $0d79572b4b22d35c$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $0d79572b4b22d35c$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $0d79572b4b22d35c$var$filterPoints(a, a.next);
                c = $0d79572b4b22d35c$var$filterPoints(c, c.next);
                // run earcut on each half
                $0d79572b4b22d35c$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $0d79572b4b22d35c$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $0d79572b4b22d35c$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $0d79572b4b22d35c$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($0d79572b4b22d35c$var$getLeftmost(list));
    }
    queue.sort($0d79572b4b22d35c$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $0d79572b4b22d35c$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $0d79572b4b22d35c$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $0d79572b4b22d35c$var$eliminateHole(hole, outerNode) {
    const bridge = $0d79572b4b22d35c$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $0d79572b4b22d35c$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $0d79572b4b22d35c$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $0d79572b4b22d35c$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $0d79572b4b22d35c$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $0d79572b4b22d35c$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($0d79572b4b22d35c$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $0d79572b4b22d35c$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $0d79572b4b22d35c$var$sectorContainsSector(m, p) {
    return $0d79572b4b22d35c$var$area(m.prev, m, p.prev) < 0 && $0d79572b4b22d35c$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $0d79572b4b22d35c$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $0d79572b4b22d35c$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $0d79572b4b22d35c$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $0d79572b4b22d35c$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $0d79572b4b22d35c$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $0d79572b4b22d35c$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $0d79572b4b22d35c$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $0d79572b4b22d35c$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$0d79572b4b22d35c$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($0d79572b4b22d35c$var$locallyInside(a, b) && $0d79572b4b22d35c$var$locallyInside(b, a) && $0d79572b4b22d35c$var$middleInside(a, b) && // locally visible
    ($0d79572b4b22d35c$var$area(a.prev, a, b.prev) || $0d79572b4b22d35c$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $0d79572b4b22d35c$var$equals(a, b) && $0d79572b4b22d35c$var$area(a.prev, a, a.next) > 0 && $0d79572b4b22d35c$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $0d79572b4b22d35c$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $0d79572b4b22d35c$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $0d79572b4b22d35c$var$intersects(p1, q1, p2, q2) {
    const o1 = $0d79572b4b22d35c$var$sign($0d79572b4b22d35c$var$area(p1, q1, p2));
    const o2 = $0d79572b4b22d35c$var$sign($0d79572b4b22d35c$var$area(p1, q1, q2));
    const o3 = $0d79572b4b22d35c$var$sign($0d79572b4b22d35c$var$area(p2, q2, p1));
    const o4 = $0d79572b4b22d35c$var$sign($0d79572b4b22d35c$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $0d79572b4b22d35c$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $0d79572b4b22d35c$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $0d79572b4b22d35c$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $0d79572b4b22d35c$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $0d79572b4b22d35c$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $0d79572b4b22d35c$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $0d79572b4b22d35c$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $0d79572b4b22d35c$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $0d79572b4b22d35c$var$locallyInside(a, b) {
    return $0d79572b4b22d35c$var$area(a.prev, a, a.next) < 0 ? $0d79572b4b22d35c$var$area(a, b, a.next) >= 0 && $0d79572b4b22d35c$var$area(a, a.prev, b) >= 0 : $0d79572b4b22d35c$var$area(a, b, a.prev) < 0 || $0d79572b4b22d35c$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $0d79572b4b22d35c$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $0d79572b4b22d35c$var$splitPolygon(a, b) {
    const a2 = new $0d79572b4b22d35c$var$Node(a.i, a.x, a.y), b2 = new $0d79572b4b22d35c$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $0d79572b4b22d35c$var$insertNode(i, x, y, last) {
    const p = new $0d79572b4b22d35c$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $0d79572b4b22d35c$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $0d79572b4b22d35c$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $0d79572b4b22d35c$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $0d79572b4b22d35c$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $0d79572b4b22d35c$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $0d79572b4b22d35c$var$removeDupEndPts(contour);
        $0d79572b4b22d35c$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($0d79572b4b22d35c$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $0d79572b4b22d35c$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $0d79572b4b22d35c$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $0d79572b4b22d35c$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $0d79572b4b22d35c$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $0d79572b4b22d35c$export$598697a1efa63ca7 extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(shapes = new $0d79572b4b22d35c$export$6428a7f2611ef1fa([
        new $0d79572b4b22d35c$export$c977b3e384af9ae1(0.5, 0.5),
        new $0d79572b4b22d35c$export$c977b3e384af9ae1(-0.5, 0.5),
        new $0d79572b4b22d35c$export$c977b3e384af9ae1(-0.5, -0.5),
        new $0d79572b4b22d35c$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $0d79572b4b22d35c$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $0d79572b4b22d35c$export$64b5c384219d3699();
                normal = new $0d79572b4b22d35c$export$64b5c384219d3699();
                position2 = new $0d79572b4b22d35c$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$0d79572b4b22d35c$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($0d79572b4b22d35c$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $0d79572b4b22d35c$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $0d79572b4b22d35c$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $0d79572b4b22d35c$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $0d79572b4b22d35c$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $0d79572b4b22d35c$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $0d79572b4b22d35c$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $0d79572b4b22d35c$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(a_x, a_y),
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(b_x, b_y),
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $0d79572b4b22d35c$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $0d79572b4b22d35c$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $0d79572b4b22d35c$export$9567cc828c9535da extends $0d79572b4b22d35c$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $0d79572b4b22d35c$export$1954e2b809fe361e extends $0d79572b4b22d35c$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $0d79572b4b22d35c$export$68cb731f50f614af extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const uv = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $0d79572b4b22d35c$export$57a29a1c803e9065 extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(shapes = new $0d79572b4b22d35c$export$6428a7f2611ef1fa([
        new $0d79572b4b22d35c$export$c977b3e384af9ae1(0, 0.5),
        new $0d79572b4b22d35c$export$c977b3e384af9ae1(-0.5, -0.5),
        new $0d79572b4b22d35c$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($0d79572b4b22d35c$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($0d79572b4b22d35c$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $0d79572b4b22d35c$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $0d79572b4b22d35c$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $0d79572b4b22d35c$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $0d79572b4b22d35c$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $0d79572b4b22d35c$export$1b417fc3b307a251 extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const normal = new $0d79572b4b22d35c$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $0d79572b4b22d35c$export$fb3f7adc68bd6e02 extends $0d79572b4b22d35c$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $0d79572b4b22d35c$export$a2312a2a1fa56495 extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const normal = new $0d79572b4b22d35c$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $0d79572b4b22d35c$export$77e9bfadfb9ab8c8 extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const normal = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const P1 = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const P2 = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const B = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const T = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const N = new $0d79572b4b22d35c$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $0d79572b4b22d35c$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $0d79572b4b22d35c$export$7897d9d48904490c extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(path = new $0d79572b4b22d35c$export$bf3f4c7e459f90fc(new $0d79572b4b22d35c$export$64b5c384219d3699(-1, -1, 0), new $0d79572b4b22d35c$export$64b5c384219d3699(-1, 1, 0), new $0d79572b4b22d35c$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const normal = new $0d79572b4b22d35c$export$64b5c384219d3699();
        const uv = new $0d79572b4b22d35c$export$c977b3e384af9ae1();
        let P = new $0d79572b4b22d35c$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $0d79572b4b22d35c$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $0d79572b4b22d35c$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $0d79572b4b22d35c$export$7897d9d48904490c(new $0d79572b4b22d35c$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $0d79572b4b22d35c$export$4b739da06d24892b extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $0d79572b4b22d35c$export$64b5c384219d3699();
            const end = new $0d79572b4b22d35c$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($0d79572b4b22d35c$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($0d79572b4b22d35c$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $0d79572b4b22d35c$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $0d79572b4b22d35c$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $0d79572b4b22d35c$export$33e43285f7406bd5,
    CapsuleGeometry: $0d79572b4b22d35c$export$41680e8551036033,
    CircleGeometry: $0d79572b4b22d35c$export$d5c0e8d607467193,
    ConeGeometry: $0d79572b4b22d35c$export$a7a48974f285c9b3,
    CylinderGeometry: $0d79572b4b22d35c$export$68f745719dbe5198,
    DodecahedronGeometry: $0d79572b4b22d35c$export$c0babfeb8708fc9c,
    EdgesGeometry: $0d79572b4b22d35c$export$4730b1542707547f,
    ExtrudeGeometry: $0d79572b4b22d35c$export$598697a1efa63ca7,
    IcosahedronGeometry: $0d79572b4b22d35c$export$9567cc828c9535da,
    LatheGeometry: $0d79572b4b22d35c$export$6d839803fcd1882c,
    OctahedronGeometry: $0d79572b4b22d35c$export$1954e2b809fe361e,
    PlaneGeometry: $0d79572b4b22d35c$export$967d831af31f69ce,
    PolyhedronGeometry: $0d79572b4b22d35c$export$60e57a7d3f20ff65,
    RingGeometry: $0d79572b4b22d35c$export$68cb731f50f614af,
    ShapeGeometry: $0d79572b4b22d35c$export$57a29a1c803e9065,
    SphereGeometry: $0d79572b4b22d35c$export$1b417fc3b307a251,
    TetrahedronGeometry: $0d79572b4b22d35c$export$fb3f7adc68bd6e02,
    TorusGeometry: $0d79572b4b22d35c$export$a2312a2a1fa56495,
    TorusKnotGeometry: $0d79572b4b22d35c$export$77e9bfadfb9ab8c8,
    TubeGeometry: $0d79572b4b22d35c$export$7897d9d48904490c,
    WireframeGeometry: $0d79572b4b22d35c$export$4b739da06d24892b
});
class $0d79572b4b22d35c$export$e8564da406055a3 extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = "ShadowMaterial";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $0d79572b4b22d35c$export$21c421a2e1df9d22 extends $0d79572b4b22d35c$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = "RawShaderMaterial";
    }
}
class $0d79572b4b22d35c$export$f2980790215acccd extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d79572b4b22d35c$export$2852a58ebdac27b8;
        this.normalScale = new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $0d79572b4b22d35c$export$d93cc409a0768c5f();
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $0d79572b4b22d35c$export$28d04986c4269c9f extends $0d79572b4b22d35c$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $0d79572b4b22d35c$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $0d79572b4b22d35c$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $0d79572b4b22d35c$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $0d79572b4b22d35c$export$24c72f71cbaf0678 extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = "MeshPhongMaterial";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $0d79572b4b22d35c$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d79572b4b22d35c$export$2852a58ebdac27b8;
        this.normalScale = new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $0d79572b4b22d35c$export$d93cc409a0768c5f();
        this.combine = $0d79572b4b22d35c$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $0d79572b4b22d35c$export$df893cf97e765622 extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d79572b4b22d35c$export$2852a58ebdac27b8;
        this.normalScale = new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $0d79572b4b22d35c$export$bfe8c0a091f41ae7 extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d79572b4b22d35c$export$2852a58ebdac27b8;
        this.normalScale = new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $0d79572b4b22d35c$export$5023a9a8114806b8 extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = "MeshLambertMaterial";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $0d79572b4b22d35c$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d79572b4b22d35c$export$2852a58ebdac27b8;
        this.normalScale = new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $0d79572b4b22d35c$export$d93cc409a0768c5f();
        this.combine = $0d79572b4b22d35c$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $0d79572b4b22d35c$export$6f5fef6235ec12ee extends $0d79572b4b22d35c$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $0d79572b4b22d35c$export$2852a58ebdac27b8;
        this.normalScale = new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $0d79572b4b22d35c$export$327886a3efaeaebe extends $0d79572b4b22d35c$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// converts an array to a specific type
function $0d79572b4b22d35c$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $0d79572b4b22d35c$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $0d79572b4b22d35c$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $0d79572b4b22d35c$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $0d79572b4b22d35c$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $0d79572b4b22d35c$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $0d79572b4b22d35c$var$convertArray(times, track.times.constructor);
        track.values = $0d79572b4b22d35c$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $0d79572b4b22d35c$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === "quaternion") {
            const referenceQuat = new $0d79572b4b22d35c$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
            $0d79572b4b22d35c$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $0d79572b4b22d35c$export$d875e029ef558d3;
    return targetClip;
}
const $0d79572b4b22d35c$export$7ee8caa573e71ad1 = {
    convertArray: $0d79572b4b22d35c$var$convertArray,
    isTypedArray: $0d79572b4b22d35c$var$isTypedArray,
    getKeyframeOrder: $0d79572b4b22d35c$var$getKeyframeOrder,
    sortedArray: $0d79572b4b22d35c$var$sortedArray,
    flattenJSON: $0d79572b4b22d35c$var$flattenJSON,
    subclip: $0d79572b4b22d35c$var$subclip,
    makeClipAdditive: $0d79572b4b22d35c$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $0d79572b4b22d35c$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $0d79572b4b22d35c$export$3646682e7a3959 extends $0d79572b4b22d35c$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $0d79572b4b22d35c$export$7f795934b84ab523,
            endingEnd: $0d79572b4b22d35c$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $0d79572b4b22d35c$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $0d79572b4b22d35c$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $0d79572b4b22d35c$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $0d79572b4b22d35c$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $0d79572b4b22d35c$export$a8e6009059f51e1a extends $0d79572b4b22d35c$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $0d79572b4b22d35c$export$fb9758ef7ef8d5cc extends $0d79572b4b22d35c$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $0d79572b4b22d35c$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $0d79572b4b22d35c$var$convertArray(times, this.TimeBufferType);
        this.values = $0d79572b4b22d35c$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $0d79572b4b22d35c$var$convertArray(track.times, Array),
                "values": $0d79572b4b22d35c$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $0d79572b4b22d35c$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $0d79572b4b22d35c$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $0d79572b4b22d35c$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $0d79572b4b22d35c$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $0d79572b4b22d35c$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $0d79572b4b22d35c$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $0d79572b4b22d35c$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $0d79572b4b22d35c$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $0d79572b4b22d35c$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($0d79572b4b22d35c$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $0d79572b4b22d35c$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$0d79572b4b22d35c$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$0d79572b4b22d35c$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$0d79572b4b22d35c$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $0d79572b4b22d35c$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $0d79572b4b22d35c$export$d3a344b98cf0b775 extends $0d79572b4b22d35c$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$0d79572b4b22d35c$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$0d79572b4b22d35c$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$0d79572b4b22d35c$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $0d79572b4b22d35c$export$995b32462a65e855;
$0d79572b4b22d35c$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$0d79572b4b22d35c$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $0d79572b4b22d35c$export$83444c5d885347d8 extends $0d79572b4b22d35c$export$b0e479f45b7006d6 {
}
$0d79572b4b22d35c$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $0d79572b4b22d35c$export$d45f0d1a4d9a9314 extends $0d79572b4b22d35c$export$b0e479f45b7006d6 {
}
$0d79572b4b22d35c$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $0d79572b4b22d35c$export$2db1cfb7923d931e extends $0d79572b4b22d35c$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$0d79572b4b22d35c$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $0d79572b4b22d35c$export$b8043f12b5aafbd7 extends $0d79572b4b22d35c$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $0d79572b4b22d35c$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$0d79572b4b22d35c$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$0d79572b4b22d35c$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $0d79572b4b22d35c$export$6ce41d4f3a8df9cd extends $0d79572b4b22d35c$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$0d79572b4b22d35c$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$0d79572b4b22d35c$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$0d79572b4b22d35c$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $0d79572b4b22d35c$export$995b32462a65e855;
$0d79572b4b22d35c$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$0d79572b4b22d35c$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $0d79572b4b22d35c$export$5ce2dcb4cc9f2bff extends $0d79572b4b22d35c$export$b0e479f45b7006d6 {
}
$0d79572b4b22d35c$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $0d79572b4b22d35c$export$d942c706bf23829c {
    constructor(name = "", duration = -1, tracks = [], blendMode = $0d79572b4b22d35c$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $0d79572b4b22d35c$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($0d79572b4b22d35c$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($0d79572b4b22d35c$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $0d79572b4b22d35c$var$getKeyframeOrder(times);
            times = $0d79572b4b22d35c$var$sortedArray(times, 1, order);
            values = $0d79572b4b22d35c$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $0d79572b4b22d35c$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $0d79572b4b22d35c$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $0d79572b4b22d35c$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($0d79572b4b22d35c$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($0d79572b4b22d35c$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($0d79572b4b22d35c$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $0d79572b4b22d35c$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $0d79572b4b22d35c$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $0d79572b4b22d35c$export$5ce2dcb4cc9f2bff;
        case "color":
            return $0d79572b4b22d35c$export$83444c5d885347d8;
        case "quaternion":
            return $0d79572b4b22d35c$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $0d79572b4b22d35c$export$d3a344b98cf0b775;
        case "string":
            return $0d79572b4b22d35c$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $0d79572b4b22d35c$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $0d79572b4b22d35c$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $0d79572b4b22d35c$var$flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $0d79572b4b22d35c$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $0d79572b4b22d35c$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $0d79572b4b22d35c$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $0d79572b4b22d35c$export$99cc795e99919eed();
class $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $0d79572b4b22d35c$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
$0d79572b4b22d35c$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const $0d79572b4b22d35c$var$loading = {};
class $0d79572b4b22d35c$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $0d79572b4b22d35c$export$98435a25b5cf7b2b extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $0d79572b4b22d35c$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($0d79572b4b22d35c$var$loading[url] !== undefined) {
            $0d79572b4b22d35c$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $0d79572b4b22d35c$var$loading[url] = [];
        $0d79572b4b22d35c$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === "undefined" || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $0d79572b4b22d35c$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get("X-File-Size") || response.headers.get("Content-Length");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $0d79572b4b22d35c$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $0d79572b4b22d35c$export$94affb487e701bf2.add(url, data);
            const callbacks = $0d79572b4b22d35c$var$loading[url];
            delete $0d79572b4b22d35c$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $0d79572b4b22d35c$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $0d79572b4b22d35c$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $0d79572b4b22d35c$export$29711c7e14f61db extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0d79572b4b22d35c$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $0d79572b4b22d35c$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $0d79572b4b22d35c$export$bd73ce947a280350 extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $0d79572b4b22d35c$export$3466bac9141a5cc4();
        const loader = new $0d79572b4b22d35c$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $0d79572b4b22d35c$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $0d79572b4b22d35c$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $0d79572b4b22d35c$export$8905ce1c7a2464a1 extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $0d79572b4b22d35c$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $0d79572b4b22d35c$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $0d79572b4b22d35c$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.slice(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $0d79572b4b22d35c$export$2ec114afc2cf6308 extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $0d79572b4b22d35c$export$ee2e5a18258a4049();
        texture.colorSpace = $0d79572b4b22d35c$export$561f394b24edfcaa;
        const loader = new $0d79572b4b22d35c$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $0d79572b4b22d35c$export$792d8a18f2c55855 extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $0d79572b4b22d35c$export$b691f601014eabe1();
        const loader = new $0d79572b4b22d35c$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $0d79572b4b22d35c$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $0d79572b4b22d35c$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $0d79572b4b22d35c$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $0d79572b4b22d35c$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $0d79572b4b22d35c$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $0d79572b4b22d35c$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $0d79572b4b22d35c$export$fd1bfc71f64c538c extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $0d79572b4b22d35c$export$5431306cf43de24a();
        const loader = new $0d79572b4b22d35c$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $0d79572b4b22d35c$export$6ecadb6ed240d696 extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = "Light";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        if (this.target !== undefined) data.object.target = this.target.uuid;
        return data;
    }
}
class $0d79572b4b22d35c$export$8d474f55edbb9624 extends $0d79572b4b22d35c$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = "HemisphereLight";
        this.position.copy($0d79572b4b22d35c$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $0d79572b4b22d35c$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $0d79572b4b22d35c$var$_projScreenMatrix$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_lightPositionWorld$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_lookTarget$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.intensity = 1;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $0d79572b4b22d35c$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $0d79572b4b22d35c$export$35efe6f4c85463d2();
        this._frameExtents = new $0d79572b4b22d35c$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $0d79572b4b22d35c$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $0d79572b4b22d35c$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($0d79572b4b22d35c$var$_lightPositionWorld$1);
        $0d79572b4b22d35c$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($0d79572b4b22d35c$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $0d79572b4b22d35c$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($0d79572b4b22d35c$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($0d79572b4b22d35c$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $0d79572b4b22d35c$var$SpotLightShadow extends $0d79572b4b22d35c$var$LightShadow {
    constructor(){
        super(new $0d79572b4b22d35c$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $0d79572b4b22d35c$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $0d79572b4b22d35c$export$81495cbb73897362 extends $0d79572b4b22d35c$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = "SpotLight";
        this.position.copy($0d79572b4b22d35c$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $0d79572b4b22d35c$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $0d79572b4b22d35c$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $0d79572b4b22d35c$var$_projScreenMatrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_lightPositionWorld = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_lookTarget = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$var$PointLightShadow extends $0d79572b4b22d35c$var$LightShadow {
    constructor(){
        super(new $0d79572b4b22d35c$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $0d79572b4b22d35c$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $0d79572b4b22d35c$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $0d79572b4b22d35c$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $0d79572b4b22d35c$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $0d79572b4b22d35c$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $0d79572b4b22d35c$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $0d79572b4b22d35c$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $0d79572b4b22d35c$export$64b5c384219d3699(1, 0, 0),
            new $0d79572b4b22d35c$export$64b5c384219d3699(-1, 0, 0),
            new $0d79572b4b22d35c$export$64b5c384219d3699(0, 0, 1),
            new $0d79572b4b22d35c$export$64b5c384219d3699(0, 0, -1),
            new $0d79572b4b22d35c$export$64b5c384219d3699(0, 1, 0),
            new $0d79572b4b22d35c$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $0d79572b4b22d35c$export$64b5c384219d3699(0, 1, 0),
            new $0d79572b4b22d35c$export$64b5c384219d3699(0, 1, 0),
            new $0d79572b4b22d35c$export$64b5c384219d3699(0, 1, 0),
            new $0d79572b4b22d35c$export$64b5c384219d3699(0, 1, 0),
            new $0d79572b4b22d35c$export$64b5c384219d3699(0, 0, 1),
            new $0d79572b4b22d35c$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $0d79572b4b22d35c$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($0d79572b4b22d35c$var$_lightPositionWorld);
        $0d79572b4b22d35c$var$_lookTarget.copy(camera.position);
        $0d79572b4b22d35c$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($0d79572b4b22d35c$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$0d79572b4b22d35c$var$_lightPositionWorld.x, -$0d79572b4b22d35c$var$_lightPositionWorld.y, -$0d79572b4b22d35c$var$_lightPositionWorld.z);
        $0d79572b4b22d35c$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($0d79572b4b22d35c$var$_projScreenMatrix);
    }
}
class $0d79572b4b22d35c$export$4c9c1cb3f0b6f455 extends $0d79572b4b22d35c$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $0d79572b4b22d35c$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $0d79572b4b22d35c$var$DirectionalLightShadow extends $0d79572b4b22d35c$var$LightShadow {
    constructor(){
        super(new $0d79572b4b22d35c$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $0d79572b4b22d35c$export$3fea33cc9972c868 extends $0d79572b4b22d35c$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = "DirectionalLight";
        this.position.copy($0d79572b4b22d35c$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $0d79572b4b22d35c$export$e4dd07dff30cc924();
        this.shadow = new $0d79572b4b22d35c$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $0d79572b4b22d35c$export$af279bfef9ec2c96 extends $0d79572b4b22d35c$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = "AmbientLight";
    }
}
class $0d79572b4b22d35c$export$61db2d908bbd2429 extends $0d79572b4b22d35c$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $0d79572b4b22d35c$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $0d79572b4b22d35c$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $0d79572b4b22d35c$export$e7ef036e309b38d2 extends $0d79572b4b22d35c$export$6ecadb6ed240d696 {
    constructor(sh = new $0d79572b4b22d35c$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $0d79572b4b22d35c$export$3bd6d323353dcf96 extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0d79572b4b22d35c$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $0d79572b4b22d35c$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $0d79572b4b22d35c$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $0d79572b4b22d35c$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $0d79572b4b22d35c$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $0d79572b4b22d35c$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $0d79572b4b22d35c$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $0d79572b4b22d35c$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $0d79572b4b22d35c$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $0d79572b4b22d35c$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    createMaterialFromType(type) {
        return $0d79572b4b22d35c$export$3bd6d323353dcf96.createMaterialFromType(type);
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $0d79572b4b22d35c$export$e8564da406055a3,
            SpriteMaterial: $0d79572b4b22d35c$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $0d79572b4b22d35c$export$21c421a2e1df9d22,
            ShaderMaterial: $0d79572b4b22d35c$export$83c7d75d550a8b0d,
            PointsMaterial: $0d79572b4b22d35c$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $0d79572b4b22d35c$export$28d04986c4269c9f,
            MeshStandardMaterial: $0d79572b4b22d35c$export$f2980790215acccd,
            MeshPhongMaterial: $0d79572b4b22d35c$export$24c72f71cbaf0678,
            MeshToonMaterial: $0d79572b4b22d35c$export$df893cf97e765622,
            MeshNormalMaterial: $0d79572b4b22d35c$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $0d79572b4b22d35c$export$5023a9a8114806b8,
            MeshDepthMaterial: $0d79572b4b22d35c$export$2698c22ec13825db,
            MeshDistanceMaterial: $0d79572b4b22d35c$export$33e187ed002f2a19,
            MeshBasicMaterial: $0d79572b4b22d35c$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $0d79572b4b22d35c$export$6f5fef6235ec12ee,
            LineDashedMaterial: $0d79572b4b22d35c$export$327886a3efaeaebe,
            LineBasicMaterial: $0d79572b4b22d35c$export$fbaaa33907730a0c,
            Material: $0d79572b4b22d35c$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $0d79572b4b22d35c$export$b5d2dc08d867e41a {
    static decodeText(array) {
        console.warn("THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.");
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $0d79572b4b22d35c$export$231f009cbe414146 extends $0d79572b4b22d35c$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $0d79572b4b22d35c$export$dc275bb96327833a extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0d79572b4b22d35c$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $0d79572b4b22d35c$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $0d79572b4b22d35c$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $0d79572b4b22d35c$export$231f009cbe414146() : new $0d79572b4b22d35c$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $0d79572b4b22d35c$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $0d79572b4b22d35c$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $0d79572b4b22d35c$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $0d79572b4b22d35c$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $0d79572b4b22d35c$export$32ea87a8b54d744a : $0d79572b4b22d35c$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $0d79572b4b22d35c$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $0d79572b4b22d35c$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $0d79572b4b22d35c$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $0d79572b4b22d35c$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $0d79572b4b22d35c$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $0d79572b4b22d35c$export$40110c8505c5ad19 extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $0d79572b4b22d35c$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $0d79572b4b22d35c$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                if (onError !== undefined) onError(new Error("THREE.ObjectLoader: Can't load " + url));
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $0d79572b4b22d35c$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $0d79572b4b22d35c$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $0d79572b4b22d35c$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $0d79572b4b22d35c$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $0d79572b4b22d35c$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $0d79572b4b22d35c$var$Geometries) geometry = $0d79572b4b22d35c$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $0d79572b4b22d35c$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $0d79572b4b22d35c$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $0d79572b4b22d35c$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $0d79572b4b22d35c$export$99cc795e99919eed(onLoad);
            loader = new $0d79572b4b22d35c$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $0d79572b4b22d35c$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $0d79572b4b22d35c$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $0d79572b4b22d35c$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $0d79572b4b22d35c$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $0d79572b4b22d35c$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $0d79572b4b22d35c$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $0d79572b4b22d35c$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $0d79572b4b22d35c$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $0d79572b4b22d35c$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $0d79572b4b22d35c$export$b691f601014eabe1();
                else texture = new $0d79572b4b22d35c$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $0d79572b4b22d35c$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $0d79572b4b22d35c$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $0d79572b4b22d35c$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $0d79572b4b22d35c$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $0d79572b4b22d35c$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $0d79572b4b22d35c$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $0d79572b4b22d35c$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $0d79572b4b22d35c$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $0d79572b4b22d35c$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== "") object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case "PerspectiveCamera":
                object = new $0d79572b4b22d35c$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $0d79572b4b22d35c$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $0d79572b4b22d35c$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $0d79572b4b22d35c$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || "";
                break;
            case "PointLight":
                object = new $0d79572b4b22d35c$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $0d79572b4b22d35c$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $0d79572b4b22d35c$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || "";
                break;
            case "HemisphereLight":
                object = new $0d79572b4b22d35c$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $0d79572b4b22d35c$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $0d79572b4b22d35c$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $0d79572b4b22d35c$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $0d79572b4b22d35c$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $0d79572b4b22d35c$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "BatchedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $0d79572b4b22d35c$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._visibility = data.visibility;
                object._active = data.active;
                object._bounds = data.bounds.map((bound)=>{
                    const box = new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
                    box.min.fromArray(bound.boxMin);
                    box.max.fromArray(bound.boxMax);
                    const sphere = new $0d79572b4b22d35c$export$805e8b72413ccaba();
                    sphere.radius = bound.sphereRadius;
                    sphere.center.fromArray(bound.sphereCenter);
                    return {
                        boxInitialized: bound.boxInitialized,
                        box: box,
                        sphereInitialized: bound.sphereInitialized,
                        sphere: sphere
                    };
                });
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._geometryCount = data.geometryCount;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                break;
            case "LOD":
                object = new $0d79572b4b22d35c$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $0d79572b4b22d35c$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $0d79572b4b22d35c$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $0d79572b4b22d35c$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $0d79572b4b22d35c$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $0d79572b4b22d35c$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $0d79572b4b22d35c$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $0d79572b4b22d35c$export$b127726e56765aa4();
                break;
            default:
                object = new $0d79572b4b22d35c$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty("uuid", uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $0d79572b4b22d35c$export$e4dd07dff30cc924();
            }
        });
    }
}
const $0d79572b4b22d35c$var$TEXTURE_MAPPING = {
    UVMapping: $0d79572b4b22d35c$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $0d79572b4b22d35c$export$8759762a6477f2c4,
    CubeRefractionMapping: $0d79572b4b22d35c$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $0d79572b4b22d35c$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $0d79572b4b22d35c$export$ee99d97d46898098,
    CubeUVReflectionMapping: $0d79572b4b22d35c$export$dbf3e70ff37af79
};
const $0d79572b4b22d35c$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $0d79572b4b22d35c$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $0d79572b4b22d35c$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $0d79572b4b22d35c$export$c7e7c00b14f51a4f
};
const $0d79572b4b22d35c$var$TEXTURE_FILTER = {
    NearestFilter: $0d79572b4b22d35c$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $0d79572b4b22d35c$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $0d79572b4b22d35c$export$d2327c1afe5bfdf2,
    LinearFilter: $0d79572b4b22d35c$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $0d79572b4b22d35c$export$19a719f377145a13,
    LinearMipmapLinearFilter: $0d79572b4b22d35c$export$5d8599b6a933fb1b
};
class $0d79572b4b22d35c$export$52286b55c4a9b51f extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $0d79572b4b22d35c$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    if (onLoad) onLoad(imageBitmap);
                    scope.manager.itemEnd(url);
                }).catch((e)=>{
                    if (onError) onError(e);
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $0d79572b4b22d35c$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $0d79572b4b22d35c$export$94affb487e701bf2.remove(url);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $0d79572b4b22d35c$export$94affb487e701bf2.add(url, promise);
        scope.manager.itemStart(url);
    }
}
let $0d79572b4b22d35c$var$_context;
class $0d79572b4b22d35c$export$fcbc63750ec2a81f {
    static getContext() {
        if ($0d79572b4b22d35c$var$_context === undefined) $0d79572b4b22d35c$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $0d79572b4b22d35c$var$_context;
    }
    static setContext(value) {
        $0d79572b4b22d35c$var$_context = value;
    }
}
class $0d79572b4b22d35c$export$d8d5fccfbf47714e extends $0d79572b4b22d35c$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $0d79572b4b22d35c$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $0d79572b4b22d35c$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
const $0d79572b4b22d35c$var$_eyeRight = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_eyeLeft = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_projectionMatrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
class $0d79572b4b22d35c$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $0d79572b4b22d35c$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $0d79572b4b22d35c$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $0d79572b4b22d35c$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($0d79572b4b22d35c$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $0d79572b4b22d35c$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $0d79572b4b22d35c$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $0d79572b4b22d35c$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $0d79572b4b22d35c$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($0d79572b4b22d35c$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $0d79572b4b22d35c$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $0d79572b4b22d35c$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($0d79572b4b22d35c$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($0d79572b4b22d35c$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($0d79572b4b22d35c$var$_eyeRight);
    }
}
class $0d79572b4b22d35c$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $0d79572b4b22d35c$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $0d79572b4b22d35c$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $0d79572b4b22d35c$var$now() {
    return performance.now();
}
const $0d79572b4b22d35c$var$_position$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_quaternion$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$23d6a54f0bbc85a3();
const $0d79572b4b22d35c$var$_scale$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_orientation$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$8a1b810c6fde8951 extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $0d79572b4b22d35c$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $0d79572b4b22d35c$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($0d79572b4b22d35c$var$_position$1, $0d79572b4b22d35c$var$_quaternion$1, $0d79572b4b22d35c$var$_scale$1);
        $0d79572b4b22d35c$var$_orientation$1.set(0, 0, -1).applyQuaternion($0d79572b4b22d35c$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($0d79572b4b22d35c$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($0d79572b4b22d35c$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($0d79572b4b22d35c$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($0d79572b4b22d35c$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($0d79572b4b22d35c$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($0d79572b4b22d35c$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($0d79572b4b22d35c$var$_position$1.x, $0d79572b4b22d35c$var$_position$1.y, $0d79572b4b22d35c$var$_position$1.z);
            listener.setOrientation($0d79572b4b22d35c$var$_orientation$1.x, $0d79572b4b22d35c$var$_orientation$1.y, $0d79572b4b22d35c$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $0d79572b4b22d35c$export$153755f98d9861de extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $0d79572b4b22d35c$var$_position = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_quaternion = /*@__PURE__*/ new $0d79572b4b22d35c$export$23d6a54f0bbc85a3();
const $0d79572b4b22d35c$var$_scale = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_orientation = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$4b3e397ef1832507 extends $0d79572b4b22d35c$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($0d79572b4b22d35c$var$_position, $0d79572b4b22d35c$var$_quaternion, $0d79572b4b22d35c$var$_scale);
        $0d79572b4b22d35c$var$_orientation.set(0, 0, 1).applyQuaternion($0d79572b4b22d35c$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($0d79572b4b22d35c$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($0d79572b4b22d35c$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($0d79572b4b22d35c$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($0d79572b4b22d35c$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($0d79572b4b22d35c$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($0d79572b4b22d35c$var$_orientation.z, endTime);
        } else {
            panner.setPosition($0d79572b4b22d35c$var$_position.x, $0d79572b4b22d35c$var$_position.y, $0d79572b4b22d35c$var$_position.z);
            panner.setOrientation($0d79572b4b22d35c$var$_orientation.x, $0d79572b4b22d35c$var$_orientation.y, $0d79572b4b22d35c$var$_orientation.z);
        }
    }
}
class $0d79572b4b22d35c$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $0d79572b4b22d35c$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $0d79572b4b22d35c$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $0d79572b4b22d35c$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $0d79572b4b22d35c$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $0d79572b4b22d35c$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $0d79572b4b22d35c$var$_reservedRe = new RegExp("[" + $0d79572b4b22d35c$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $0d79572b4b22d35c$var$_wordChar = "[^" + $0d79572b4b22d35c$var$_RESERVED_CHARS_RE + "]";
const $0d79572b4b22d35c$var$_wordCharOrDot = "[^" + $0d79572b4b22d35c$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $0d79572b4b22d35c$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace("WC", $0d79572b4b22d35c$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $0d79572b4b22d35c$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace("WCOD", $0d79572b4b22d35c$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $0d79572b4b22d35c$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $0d79572b4b22d35c$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $0d79572b4b22d35c$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $0d79572b4b22d35c$var$_wordChar);
const $0d79572b4b22d35c$var$_trackRe = new RegExp("^" + $0d79572b4b22d35c$var$_directoryRe + $0d79572b4b22d35c$var$_nodeRe + $0d79572b4b22d35c$var$_objectRe + $0d79572b4b22d35c$var$_propertyRe + "$");
const $0d79572b4b22d35c$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones",
    "map"
];
class $0d79572b4b22d35c$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $0d79572b4b22d35c$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $0d79572b4b22d35c$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $0d79572b4b22d35c$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $0d79572b4b22d35c$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $0d79572b4b22d35c$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $0d79572b4b22d35c$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($0d79572b4b22d35c$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $0d79572b4b22d35c$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($0d79572b4b22d35c$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $0d79572b4b22d35c$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$0d79572b4b22d35c$export$7bf70fcf9f891893.Composite = $0d79572b4b22d35c$var$Composite;
$0d79572b4b22d35c$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$0d79572b4b22d35c$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$0d79572b4b22d35c$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._getValue_direct,
    $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._getValue_array,
    $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$0d79572b4b22d35c$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_direct,
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_array,
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $0d79572b4b22d35c$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $0d79572b4b22d35c$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $0d79572b4b22d35c$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $0d79572b4b22d35c$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $0d79572b4b22d35c$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $0d79572b4b22d35c$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $0d79572b4b22d35c$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $0d79572b4b22d35c$export$7f795934b84ab523,
            endingEnd: $0d79572b4b22d35c$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $0d79572b4b22d35c$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $0d79572b4b22d35c$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $0d79572b4b22d35c$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $0d79572b4b22d35c$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $0d79572b4b22d35c$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $0d79572b4b22d35c$export$24a4ccb5099273b5;
            settings.endingEnd = $0d79572b4b22d35c$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $0d79572b4b22d35c$export$24a4ccb5099273b5 : $0d79572b4b22d35c$export$7f795934b84ab523;
            else settings.endingStart = $0d79572b4b22d35c$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $0d79572b4b22d35c$export$24a4ccb5099273b5 : $0d79572b4b22d35c$export$7f795934b84ab523;
            else settings.endingEnd = $0d79572b4b22d35c$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $0d79572b4b22d35c$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $0d79572b4b22d35c$export$fbd77e5aefaa0102 extends $0d79572b4b22d35c$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $0d79572b4b22d35c$export$dfe0af1ca1acb78a($0d79572b4b22d35c$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $0d79572b4b22d35c$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $0d79572b4b22d35c$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $0d79572b4b22d35c$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $0d79572b4b22d35c$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $0d79572b4b22d35c$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $0d79572b4b22d35c$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $0d79572b4b22d35c$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $0d79572b4b22d35c$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $0d79572b4b22d35c$var$_id = 0;
class $0d79572b4b22d35c$export$c412d5ffe1f79209 extends $0d79572b4b22d35c$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, "id", {
            value: $0d79572b4b22d35c$var$_id++
        });
        this.name = "";
        this.usage = $0d79572b4b22d35c$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $0d79572b4b22d35c$export$25ec0e1af1389358 extends $0d79572b4b22d35c$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $0d79572b4b22d35c$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = "";
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
const $0d79572b4b22d35c$var$_matrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
class $0d79572b4b22d35c$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $0d79572b4b22d35c$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $0d79572b4b22d35c$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    setFromXRController(controller) {
        $0d79572b4b22d35c$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($0d79572b4b22d35c$var$_matrix);
        return this;
    }
    intersectObject(object, recursive = true, intersects = []) {
        $0d79572b4b22d35c$var$intersect(object, this, intersects, recursive);
        intersects.sort($0d79572b4b22d35c$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$0d79572b4b22d35c$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($0d79572b4b22d35c$var$ascSort);
        return intersects;
    }
}
function $0d79572b4b22d35c$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $0d79572b4b22d35c$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$0d79572b4b22d35c$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * phi (the polar angle) is measured from the positive y-axis. The positive y-axis is up.
 * theta (the azimuthal angle) is measured from the positive z-axis.
 */ class $0d79572b4b22d35c$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($0d79572b4b22d35c$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $0d79572b4b22d35c$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $0d79572b4b22d35c$export$cbcc6560bf79fb38 {
    constructor(n11, n12, n21, n22){
        $0d79572b4b22d35c$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $0d79572b4b22d35c$var$_vector$4 = /*@__PURE__*/ new $0d79572b4b22d35c$export$c977b3e384af9ae1();
class $0d79572b4b22d35c$export$60f553fa130f08b0 {
    constructor(min = new $0d79572b4b22d35c$export$c977b3e384af9ae1(Infinity, Infinity), max = new $0d79572b4b22d35c$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $0d79572b4b22d35c$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $0d79572b4b22d35c$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $0d79572b4b22d35c$var$_startP = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_startEnd = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$e0ba6359f1954fd3 {
    constructor(start = new $0d79572b4b22d35c$export$64b5c384219d3699(), end = new $0d79572b4b22d35c$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $0d79572b4b22d35c$var$_startP.subVectors(point, this.start);
        $0d79572b4b22d35c$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $0d79572b4b22d35c$var$_startEnd.dot($0d79572b4b22d35c$var$_startEnd);
        const startEnd_startP = $0d79572b4b22d35c$var$_startEnd.dot($0d79572b4b22d35c$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $0d79572b4b22d35c$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $0d79572b4b22d35c$var$_vector$3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$4b14638ffdd81e68 extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "SpotLightHelper";
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(positions, 3));
        const material = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $0d79572b4b22d35c$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $0d79572b4b22d35c$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($0d79572b4b22d35c$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $0d79572b4b22d35c$var$_vector$2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_boneMatrix = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
const $0d79572b4b22d35c$var$_matrixWorldInv = /*@__PURE__*/ new $0d79572b4b22d35c$export$2ae72fc923e5eb5();
class $0d79572b4b22d35c$export$5277df3c9e732259 extends $0d79572b4b22d35c$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $0d79572b4b22d35c$var$getBoneList(object);
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $0d79572b4b22d35c$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $0d79572b4b22d35c$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0d79572b4b22d35c$export$cbe7a62641830ebd(colors, 3));
        const material = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = "SkeletonHelper";
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $0d79572b4b22d35c$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $0d79572b4b22d35c$var$_boneMatrix.multiplyMatrices($0d79572b4b22d35c$var$_matrixWorldInv, bone.matrixWorld);
                $0d79572b4b22d35c$var$_vector$2.setFromMatrixPosition($0d79572b4b22d35c$var$_boneMatrix);
                position.setXYZ(j, $0d79572b4b22d35c$var$_vector$2.x, $0d79572b4b22d35c$var$_vector$2.y, $0d79572b4b22d35c$var$_vector$2.z);
                $0d79572b4b22d35c$var$_boneMatrix.multiplyMatrices($0d79572b4b22d35c$var$_matrixWorldInv, bone.parent.matrixWorld);
                $0d79572b4b22d35c$var$_vector$2.setFromMatrixPosition($0d79572b4b22d35c$var$_boneMatrix);
                position.setXYZ(j + 1, $0d79572b4b22d35c$var$_vector$2.x, $0d79572b4b22d35c$var$_vector$2.y, $0d79572b4b22d35c$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $0d79572b4b22d35c$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $0d79572b4b22d35c$var$getBoneList(object.children[i]));
    return boneList;
}
class $0d79572b4b22d35c$export$9a9291685b9e4023 extends $0d79572b4b22d35c$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $0d79572b4b22d35c$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $0d79572b4b22d35c$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $0d79572b4b22d35c$var$_vector$1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_color1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e();
const $0d79572b4b22d35c$var$_color2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$892596cec99bc70e();
class $0d79572b4b22d35c$export$8dca15f13f4f8172 extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "HemisphereLightHelper";
        const geometry = new $0d79572b4b22d35c$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $0d79572b4b22d35c$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $0d79572b4b22d35c$export$8dea267bd6bde117(colors, 3));
        this.add(new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $0d79572b4b22d35c$var$_color1.copy(this.light.color);
            $0d79572b4b22d35c$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $0d79572b4b22d35c$var$_color1 : $0d79572b4b22d35c$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($0d79572b4b22d35c$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $0d79572b4b22d35c$export$3875d39926561055 extends $0d79572b4b22d35c$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $0d79572b4b22d35c$export$892596cec99bc70e(color1);
        color2 = new $0d79572b4b22d35c$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0d79572b4b22d35c$export$cbe7a62641830ebd(colors, 3));
        const material = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $0d79572b4b22d35c$export$361430a10f533cd3 extends $0d79572b4b22d35c$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $0d79572b4b22d35c$export$892596cec99bc70e(color1);
        color2 = new $0d79572b4b22d35c$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0d79572b4b22d35c$export$cbe7a62641830ebd(colors, 3));
        const material = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $0d79572b4b22d35c$var$_v1 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v2 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_v3 = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
class $0d79572b4b22d35c$export$f8e434dc14203e7d extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "DirectionalLightHelper";
        if (size === undefined) size = 1;
        let geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $0d79572b4b22d35c$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $0d79572b4b22d35c$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $0d79572b4b22d35c$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $0d79572b4b22d35c$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $0d79572b4b22d35c$var$_v3.subVectors($0d79572b4b22d35c$var$_v2, $0d79572b4b22d35c$var$_v1);
        this.lightPlane.lookAt($0d79572b4b22d35c$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($0d79572b4b22d35c$var$_v2);
        this.targetLine.scale.z = $0d79572b4b22d35c$var$_v3.length();
    }
}
const $0d79572b4b22d35c$var$_vector = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
const $0d79572b4b22d35c$var$_camera = /*@__PURE__*/ new $0d79572b4b22d35c$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $0d79572b4b22d35c$export$ed8e93f853cd795 extends $0d79572b4b22d35c$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        const material = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine("n1", "n2");
        addLine("n2", "n4");
        addLine("n4", "n3");
        addLine("n3", "n1");
        // far
        addLine("f1", "f2");
        addLine("f2", "f4");
        addLine("f4", "f3");
        addLine("f3", "f1");
        // sides
        addLine("n1", "f1");
        addLine("n2", "f2");
        addLine("n3", "f3");
        addLine("n4", "f4");
        // cone
        addLine("p", "n1");
        addLine("p", "n2");
        addLine("p", "n3");
        addLine("p", "n4");
        // up
        addLine("u1", "u2");
        addLine("u2", "u3");
        addLine("u3", "u1");
        // target
        addLine("c", "t");
        addLine("p", "c");
        // cross
        addLine("cn1", "cn2");
        addLine("cn3", "cn4");
        addLine("cf1", "cf2");
        addLine("cf3", "cf4");
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0d79572b4b22d35c$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $0d79572b4b22d35c$export$892596cec99bc70e(0xff0000);
        const colorUp = new $0d79572b4b22d35c$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $0d79572b4b22d35c$export$892596cec99bc70e(0xffffff);
        const colorCross = new $0d79572b4b22d35c$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute("color");
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $0d79572b4b22d35c$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $0d79572b4b22d35c$var$setPoint("c", pointMap, geometry, $0d79572b4b22d35c$var$_camera, 0, 0, -1);
        $0d79572b4b22d35c$var$setPoint("t", pointMap, geometry, $0d79572b4b22d35c$var$_camera, 0, 0, 1);
        // near
        $0d79572b4b22d35c$var$setPoint("n1", pointMap, geometry, $0d79572b4b22d35c$var$_camera, -w, -h, -1);
        $0d79572b4b22d35c$var$setPoint("n2", pointMap, geometry, $0d79572b4b22d35c$var$_camera, w, -h, -1);
        $0d79572b4b22d35c$var$setPoint("n3", pointMap, geometry, $0d79572b4b22d35c$var$_camera, -w, h, -1);
        $0d79572b4b22d35c$var$setPoint("n4", pointMap, geometry, $0d79572b4b22d35c$var$_camera, w, h, -1);
        // far
        $0d79572b4b22d35c$var$setPoint("f1", pointMap, geometry, $0d79572b4b22d35c$var$_camera, -w, -h, 1);
        $0d79572b4b22d35c$var$setPoint("f2", pointMap, geometry, $0d79572b4b22d35c$var$_camera, w, -h, 1);
        $0d79572b4b22d35c$var$setPoint("f3", pointMap, geometry, $0d79572b4b22d35c$var$_camera, -w, h, 1);
        $0d79572b4b22d35c$var$setPoint("f4", pointMap, geometry, $0d79572b4b22d35c$var$_camera, w, h, 1);
        // up
        $0d79572b4b22d35c$var$setPoint("u1", pointMap, geometry, $0d79572b4b22d35c$var$_camera, w * 0.7, h * 1.1, -1);
        $0d79572b4b22d35c$var$setPoint("u2", pointMap, geometry, $0d79572b4b22d35c$var$_camera, -w * 0.7, h * 1.1, -1);
        $0d79572b4b22d35c$var$setPoint("u3", pointMap, geometry, $0d79572b4b22d35c$var$_camera, 0, h * 2, -1);
        // cross
        $0d79572b4b22d35c$var$setPoint("cf1", pointMap, geometry, $0d79572b4b22d35c$var$_camera, -w, 0, 1);
        $0d79572b4b22d35c$var$setPoint("cf2", pointMap, geometry, $0d79572b4b22d35c$var$_camera, w, 0, 1);
        $0d79572b4b22d35c$var$setPoint("cf3", pointMap, geometry, $0d79572b4b22d35c$var$_camera, 0, -h, 1);
        $0d79572b4b22d35c$var$setPoint("cf4", pointMap, geometry, $0d79572b4b22d35c$var$_camera, 0, h, 1);
        $0d79572b4b22d35c$var$setPoint("cn1", pointMap, geometry, $0d79572b4b22d35c$var$_camera, -w, 0, -1);
        $0d79572b4b22d35c$var$setPoint("cn2", pointMap, geometry, $0d79572b4b22d35c$var$_camera, w, 0, -1);
        $0d79572b4b22d35c$var$setPoint("cn3", pointMap, geometry, $0d79572b4b22d35c$var$_camera, 0, -h, -1);
        $0d79572b4b22d35c$var$setPoint("cn4", pointMap, geometry, $0d79572b4b22d35c$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $0d79572b4b22d35c$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $0d79572b4b22d35c$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $0d79572b4b22d35c$var$_vector.x, $0d79572b4b22d35c$var$_vector.y, $0d79572b4b22d35c$var$_vector.z);
    }
}
const $0d79572b4b22d35c$var$_box = /*@__PURE__*/ new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
class $0d79572b4b22d35c$export$38a664cc862a6a9d extends $0d79572b4b22d35c$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry.setIndex(new $0d79572b4b22d35c$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $0d79572b4b22d35c$var$_box.setFromObject(this.object);
        if ($0d79572b4b22d35c$var$_box.isEmpty()) return;
        const min = $0d79572b4b22d35c$var$_box.min;
        const max = $0d79572b4b22d35c$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $0d79572b4b22d35c$export$ce39f4bb96c9a290 extends $0d79572b4b22d35c$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry.setIndex(new $0d79572b4b22d35c$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $0d79572b4b22d35c$export$a34fe8156c66e5d7 extends $0d79572b4b22d35c$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $0d79572b4b22d35c$export$e176487c05830cc5(geometry2, new $0d79572b4b22d35c$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $0d79572b4b22d35c$var$_axis = /*@__PURE__*/ new $0d79572b4b22d35c$export$64b5c384219d3699();
let $0d79572b4b22d35c$var$_lineGeometry, $0d79572b4b22d35c$var$_coneGeometry;
class $0d79572b4b22d35c$export$a3008e7bd8d2cbe7 extends $0d79572b4b22d35c$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $0d79572b4b22d35c$export$64b5c384219d3699(0, 0, 1), origin = new $0d79572b4b22d35c$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($0d79572b4b22d35c$var$_lineGeometry === undefined) {
            $0d79572b4b22d35c$var$_lineGeometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
            $0d79572b4b22d35c$var$_lineGeometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $0d79572b4b22d35c$var$_coneGeometry = new $0d79572b4b22d35c$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $0d79572b4b22d35c$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $0d79572b4b22d35c$export$17d680238e50603e($0d79572b4b22d35c$var$_lineGeometry, new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $0d79572b4b22d35c$export$e176487c05830cc5($0d79572b4b22d35c$var$_coneGeometry, new $0d79572b4b22d35c$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $0d79572b4b22d35c$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($0d79572b4b22d35c$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $0d79572b4b22d35c$export$6c8303f35b8578fd extends $0d79572b4b22d35c$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $0d79572b4b22d35c$export$cbe7a62641830ebd(colors, 3));
        const material = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $0d79572b4b22d35c$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $0d79572b4b22d35c$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $0d79572b4b22d35c$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $0d79572b4b22d35c$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $0d79572b4b22d35c$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $0d79572b4b22d35c$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $0d79572b4b22d35c$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $0d79572b4b22d35c$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
class $0d79572b4b22d35c$export$c7c44baae9d9f25f extends $0d79572b4b22d35c$export$ec8b666c5fe2c75a {
    constructor(object, domElement = null){
        super();
        this.object = object;
        this.domElement = domElement;
        this.enabled = true;
        this.state = -1;
        this.keys = {};
        this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        this.touches = {
            ONE: null,
            TWO: null
        };
    }
    connect() {}
    disconnect() {}
    dispose() {}
    update() {}
}
class $0d79572b4b22d35c$export$bd934554fb721730 extends $0d79572b4b22d35c$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        console.warn('THREE.WebGLMultipleRenderTargets has been deprecated and will be removed in r172. Use THREE.WebGLRenderTarget and set the "count" parameter to enable MRT.');
        super(width, height, {
            ...options,
            count: count
        });
        this.isWebGLMultipleRenderTargets = true;
    }
    get texture() {
        return this.textures;
    }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $0d79572b4b22d35c$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $0d79572b4b22d35c$export$3545e07a80636437;
}



// OrbitControls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move
const $6c1447dc1cd4496f$var$_changeEvent = {
    type: "change"
};
const $6c1447dc1cd4496f$var$_startEvent = {
    type: "start"
};
const $6c1447dc1cd4496f$var$_endEvent = {
    type: "end"
};
const $6c1447dc1cd4496f$var$_ray = new (0, $0d79572b4b22d35c$export$a186db52eed6d40e)();
const $6c1447dc1cd4496f$var$_plane = new (0, $0d79572b4b22d35c$export$7ff5ac152ef991b0)();
const $6c1447dc1cd4496f$var$_TILT_LIMIT = Math.cos(70 * (0, $0d79572b4b22d35c$export$6a7ef315a0d1ef07).DEG2RAD);
const $6c1447dc1cd4496f$var$_v = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)();
const $6c1447dc1cd4496f$var$_twoPI = 2 * Math.PI;
const $6c1447dc1cd4496f$var$_STATE = {
    NONE: -1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6
};
const $6c1447dc1cd4496f$var$_EPS = 0.000001;
class $6c1447dc1cd4496f$export$8ff7788029dfdf52 extends (0, $0d79572b4b22d35c$export$c7c44baae9d9f25f) {
    constructor(object, domElement = null){
        super(object, domElement);
        this.state = $6c1447dc1cd4496f$var$_STATE.NONE;
        // Set to false to disable this control
        this.enabled = true;
        // "target" sets the location of focus, where the object orbits around
        this.target = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)();
        // Sets the 3D cursor (similar to Blender), from which the maxTargetRadius takes effect
        this.cursor = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)();
        // How far you can dolly in and out ( PerspectiveCamera only )
        this.minDistance = 0;
        this.maxDistance = Infinity;
        // How far you can zoom in and out ( OrthographicCamera only )
        this.minZoom = 0;
        this.maxZoom = Infinity;
        // Limit camera target within a spherical area around the cursor
        this.minTargetRadius = 0;
        this.maxTargetRadius = Infinity;
        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        // How far you can orbit horizontally, upper and lower limits.
        // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
        this.minAzimuthAngle = -Infinity; // radians
        this.maxAzimuthAngle = Infinity; // radians
        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        this.enableDamping = false;
        this.dampingFactor = 0.05;
        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        this.enableZoom = true;
        this.zoomSpeed = 1.0;
        // Set to false to disable rotating
        this.enableRotate = true;
        this.rotateSpeed = 1.0;
        // Set to false to disable panning
        this.enablePan = true;
        this.panSpeed = 1.0;
        this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
        this.keyPanSpeed = 7.0; // pixels moved per arrow key push
        this.zoomToCursor = false;
        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        this.autoRotate = false;
        this.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60
        // The four arrow keys
        this.keys = {
            LEFT: "ArrowLeft",
            UP: "ArrowUp",
            RIGHT: "ArrowRight",
            BOTTOM: "ArrowDown"
        };
        // Mouse buttons
        this.mouseButtons = {
            LEFT: (0, $0d79572b4b22d35c$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $0d79572b4b22d35c$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $0d79572b4b22d35c$export$7177b3e430c2d7ca).PAN
        };
        // Touch fingers
        this.touches = {
            ONE: (0, $0d79572b4b22d35c$export$d46bd3ead7cc759b).ROTATE,
            TWO: (0, $0d79572b4b22d35c$export$d46bd3ead7cc759b).DOLLY_PAN
        };
        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.zoom0 = this.object.zoom;
        // the target DOM element for key events
        this._domElementKeyEvents = null;
        // internals
        this._lastPosition = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)();
        this._lastQuaternion = new (0, $0d79572b4b22d35c$export$23d6a54f0bbc85a3)();
        this._lastTargetPosition = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)();
        // so camera.up is the orbit axis
        this._quat = new (0, $0d79572b4b22d35c$export$23d6a54f0bbc85a3)().setFromUnitVectors(object.up, new (0, $0d79572b4b22d35c$export$64b5c384219d3699)(0, 1, 0));
        this._quatInverse = this._quat.clone().invert();
        // current position in spherical coordinates
        this._spherical = new (0, $0d79572b4b22d35c$export$d712cd887b4a00f7)();
        this._sphericalDelta = new (0, $0d79572b4b22d35c$export$d712cd887b4a00f7)();
        this._scale = 1;
        this._panOffset = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)();
        this._rotateStart = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
        this._rotateEnd = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
        this._rotateDelta = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
        this._panStart = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
        this._panEnd = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
        this._panDelta = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
        this._dollyStart = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
        this._dollyEnd = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
        this._dollyDelta = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
        this._dollyDirection = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)();
        this._mouse = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
        this._performCursorZoom = false;
        this._pointers = [];
        this._pointerPositions = {};
        this._controlActive = false;
        // event listeners
        this._onPointerMove = $6c1447dc1cd4496f$var$onPointerMove.bind(this);
        this._onPointerDown = $6c1447dc1cd4496f$var$onPointerDown.bind(this);
        this._onPointerUp = $6c1447dc1cd4496f$var$onPointerUp.bind(this);
        this._onContextMenu = $6c1447dc1cd4496f$var$onContextMenu.bind(this);
        this._onMouseWheel = $6c1447dc1cd4496f$var$onMouseWheel.bind(this);
        this._onKeyDown = $6c1447dc1cd4496f$var$onKeyDown.bind(this);
        this._onTouchStart = $6c1447dc1cd4496f$var$onTouchStart.bind(this);
        this._onTouchMove = $6c1447dc1cd4496f$var$onTouchMove.bind(this);
        this._onMouseDown = $6c1447dc1cd4496f$var$onMouseDown.bind(this);
        this._onMouseMove = $6c1447dc1cd4496f$var$onMouseMove.bind(this);
        this._interceptControlDown = $6c1447dc1cd4496f$var$interceptControlDown.bind(this);
        this._interceptControlUp = $6c1447dc1cd4496f$var$interceptControlUp.bind(this);
        //
        if (this.domElement !== null) this.connect();
        this.update();
    }
    connect() {
        this.domElement.addEventListener("pointerdown", this._onPointerDown);
        this.domElement.addEventListener("pointercancel", this._onPointerUp);
        this.domElement.addEventListener("contextmenu", this._onContextMenu);
        this.domElement.addEventListener("wheel", this._onMouseWheel, {
            passive: false
        });
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.addEventListener("keydown", this._interceptControlDown, {
            passive: true,
            capture: true
        });
        this.domElement.style.touchAction = "none"; // disable touch scroll
    }
    disconnect() {
        this.domElement.removeEventListener("pointerdown", this._onPointerDown);
        this.domElement.removeEventListener("pointermove", this._onPointerMove);
        this.domElement.removeEventListener("pointerup", this._onPointerUp);
        this.domElement.removeEventListener("pointercancel", this._onPointerUp);
        this.domElement.removeEventListener("wheel", this._onMouseWheel);
        this.domElement.removeEventListener("contextmenu", this._onContextMenu);
        this.stopListenToKeyEvents();
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.removeEventListener("keydown", this._interceptControlDown, {
            capture: true
        });
        this.domElement.style.touchAction = "auto";
    }
    dispose() {
        this.disconnect();
    }
    getPolarAngle() {
        return this._spherical.phi;
    }
    getAzimuthalAngle() {
        return this._spherical.theta;
    }
    getDistance() {
        return this.object.position.distanceTo(this.target);
    }
    listenToKeyEvents(domElement) {
        domElement.addEventListener("keydown", this._onKeyDown);
        this._domElementKeyEvents = domElement;
    }
    stopListenToKeyEvents() {
        if (this._domElementKeyEvents !== null) {
            this._domElementKeyEvents.removeEventListener("keydown", this._onKeyDown);
            this._domElementKeyEvents = null;
        }
    }
    saveState() {
        this.target0.copy(this.target);
        this.position0.copy(this.object.position);
        this.zoom0 = this.object.zoom;
    }
    reset() {
        this.target.copy(this.target0);
        this.object.position.copy(this.position0);
        this.object.zoom = this.zoom0;
        this.object.updateProjectionMatrix();
        this.dispatchEvent($6c1447dc1cd4496f$var$_changeEvent);
        this.update();
        this.state = $6c1447dc1cd4496f$var$_STATE.NONE;
    }
    update(deltaTime = null) {
        const position = this.object.position;
        $6c1447dc1cd4496f$var$_v.copy(position).sub(this.target);
        // rotate offset to "y-axis-is-up" space
        $6c1447dc1cd4496f$var$_v.applyQuaternion(this._quat);
        // angle from z-axis around y-axis
        this._spherical.setFromVector3($6c1447dc1cd4496f$var$_v);
        if (this.autoRotate && this.state === $6c1447dc1cd4496f$var$_STATE.NONE) this._rotateLeft(this._getAutoRotationAngle(deltaTime));
        if (this.enableDamping) {
            this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor;
            this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor;
        } else {
            this._spherical.theta += this._sphericalDelta.theta;
            this._spherical.phi += this._sphericalDelta.phi;
        }
        // restrict theta to be between desired limits
        let min = this.minAzimuthAngle;
        let max = this.maxAzimuthAngle;
        if (isFinite(min) && isFinite(max)) {
            if (min < -Math.PI) min += $6c1447dc1cd4496f$var$_twoPI;
            else if (min > Math.PI) min -= $6c1447dc1cd4496f$var$_twoPI;
            if (max < -Math.PI) max += $6c1447dc1cd4496f$var$_twoPI;
            else if (max > Math.PI) max -= $6c1447dc1cd4496f$var$_twoPI;
            if (min <= max) this._spherical.theta = Math.max(min, Math.min(max, this._spherical.theta));
            else this._spherical.theta = this._spherical.theta > (min + max) / 2 ? Math.max(min, this._spherical.theta) : Math.min(max, this._spherical.theta);
        }
        // restrict phi to be between desired limits
        this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi));
        this._spherical.makeSafe();
        // move target to panned location
        if (this.enableDamping === true) this.target.addScaledVector(this._panOffset, this.dampingFactor);
        else this.target.add(this._panOffset);
        // Limit the target distance from the cursor to create a sphere around the center of interest
        this.target.sub(this.cursor);
        this.target.clampLength(this.minTargetRadius, this.maxTargetRadius);
        this.target.add(this.cursor);
        let zoomChanged = false;
        // adjust the camera position based on zoom only if we're not zooming to the cursor or if it's an ortho camera
        // we adjust zoom later in these cases
        if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera) this._spherical.radius = this._clampDistance(this._spherical.radius);
        else {
            const prevRadius = this._spherical.radius;
            this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale);
            zoomChanged = prevRadius != this._spherical.radius;
        }
        $6c1447dc1cd4496f$var$_v.setFromSpherical(this._spherical);
        // rotate offset back to "camera-up-vector-is-up" space
        $6c1447dc1cd4496f$var$_v.applyQuaternion(this._quatInverse);
        position.copy(this.target).add($6c1447dc1cd4496f$var$_v);
        this.object.lookAt(this.target);
        if (this.enableDamping === true) {
            this._sphericalDelta.theta *= 1 - this.dampingFactor;
            this._sphericalDelta.phi *= 1 - this.dampingFactor;
            this._panOffset.multiplyScalar(1 - this.dampingFactor);
        } else {
            this._sphericalDelta.set(0, 0, 0);
            this._panOffset.set(0, 0, 0);
        }
        // adjust camera position
        if (this.zoomToCursor && this._performCursorZoom) {
            let newRadius = null;
            if (this.object.isPerspectiveCamera) {
                // move the camera down the pointer ray
                // this method avoids floating point error
                const prevRadius = $6c1447dc1cd4496f$var$_v.length();
                newRadius = this._clampDistance(prevRadius * this._scale);
                const radiusDelta = prevRadius - newRadius;
                this.object.position.addScaledVector(this._dollyDirection, radiusDelta);
                this.object.updateMatrixWorld();
                zoomChanged = !!radiusDelta;
            } else if (this.object.isOrthographicCamera) {
                // adjust the ortho camera position based on zoom changes
                const mouseBefore = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)(this._mouse.x, this._mouse.y, 0);
                mouseBefore.unproject(this.object);
                const prevZoom = this.object.zoom;
                this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
                this.object.updateProjectionMatrix();
                zoomChanged = prevZoom !== this.object.zoom;
                const mouseAfter = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)(this._mouse.x, this._mouse.y, 0);
                mouseAfter.unproject(this.object);
                this.object.position.sub(mouseAfter).add(mouseBefore);
                this.object.updateMatrixWorld();
                newRadius = $6c1447dc1cd4496f$var$_v.length();
            } else {
                console.warn("WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.");
                this.zoomToCursor = false;
            }
            // handle the placement of the target
            if (newRadius !== null) {
                if (this.screenSpacePanning) // position the orbit target in front of the new camera position
                this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(newRadius).add(this.object.position);
                else {
                    // get the ray and translation plane to compute target
                    $6c1447dc1cd4496f$var$_ray.origin.copy(this.object.position);
                    $6c1447dc1cd4496f$var$_ray.direction.set(0, 0, -1).transformDirection(this.object.matrix);
                    // if the camera is 20 degrees above the horizon then don't adjust the focus target to avoid
                    // extremely large values
                    if (Math.abs(this.object.up.dot($6c1447dc1cd4496f$var$_ray.direction)) < $6c1447dc1cd4496f$var$_TILT_LIMIT) this.object.lookAt(this.target);
                    else {
                        $6c1447dc1cd4496f$var$_plane.setFromNormalAndCoplanarPoint(this.object.up, this.target);
                        $6c1447dc1cd4496f$var$_ray.intersectPlane($6c1447dc1cd4496f$var$_plane, this.target);
                    }
                }
            }
        } else if (this.object.isOrthographicCamera) {
            const prevZoom = this.object.zoom;
            this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
            if (prevZoom !== this.object.zoom) {
                this.object.updateProjectionMatrix();
                zoomChanged = true;
            }
        }
        this._scale = 1;
        this._performCursorZoom = false;
        // update condition is:
        // min(camera displacement, camera rotation in radians)^2 > EPS
        // using small-angle approximation cos(x/2) = 1 - x^2 / 8
        if (zoomChanged || this._lastPosition.distanceToSquared(this.object.position) > $6c1447dc1cd4496f$var$_EPS || 8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > $6c1447dc1cd4496f$var$_EPS || this._lastTargetPosition.distanceToSquared(this.target) > $6c1447dc1cd4496f$var$_EPS) {
            this.dispatchEvent($6c1447dc1cd4496f$var$_changeEvent);
            this._lastPosition.copy(this.object.position);
            this._lastQuaternion.copy(this.object.quaternion);
            this._lastTargetPosition.copy(this.target);
            return true;
        }
        return false;
    }
    _getAutoRotationAngle(deltaTime) {
        if (deltaTime !== null) return $6c1447dc1cd4496f$var$_twoPI / 60 * this.autoRotateSpeed * deltaTime;
        else return $6c1447dc1cd4496f$var$_twoPI / 60 / 60 * this.autoRotateSpeed;
    }
    _getZoomScale(delta) {
        const normalizedDelta = Math.abs(delta * 0.01);
        return Math.pow(0.95, this.zoomSpeed * normalizedDelta);
    }
    _rotateLeft(angle) {
        this._sphericalDelta.theta -= angle;
    }
    _rotateUp(angle) {
        this._sphericalDelta.phi -= angle;
    }
    _panLeft(distance, objectMatrix) {
        $6c1447dc1cd4496f$var$_v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
        $6c1447dc1cd4496f$var$_v.multiplyScalar(-distance);
        this._panOffset.add($6c1447dc1cd4496f$var$_v);
    }
    _panUp(distance, objectMatrix) {
        if (this.screenSpacePanning === true) $6c1447dc1cd4496f$var$_v.setFromMatrixColumn(objectMatrix, 1);
        else {
            $6c1447dc1cd4496f$var$_v.setFromMatrixColumn(objectMatrix, 0);
            $6c1447dc1cd4496f$var$_v.crossVectors(this.object.up, $6c1447dc1cd4496f$var$_v);
        }
        $6c1447dc1cd4496f$var$_v.multiplyScalar(distance);
        this._panOffset.add($6c1447dc1cd4496f$var$_v);
    }
    // deltaX and deltaY are in pixels; right and down are positive
    _pan(deltaX, deltaY) {
        const element = this.domElement;
        if (this.object.isPerspectiveCamera) {
            // perspective
            const position = this.object.position;
            $6c1447dc1cd4496f$var$_v.copy(position).sub(this.target);
            let targetDistance = $6c1447dc1cd4496f$var$_v.length();
            // half of the fov is center to top of screen
            targetDistance *= Math.tan(this.object.fov / 2 * Math.PI / 180.0);
            // we use only clientHeight here so aspect ratio does not distort speed
            this._panLeft(2 * deltaX * targetDistance / element.clientHeight, this.object.matrix);
            this._panUp(2 * deltaY * targetDistance / element.clientHeight, this.object.matrix);
        } else if (this.object.isOrthographicCamera) {
            // orthographic
            this._panLeft(deltaX * (this.object.right - this.object.left) / this.object.zoom / element.clientWidth, this.object.matrix);
            this._panUp(deltaY * (this.object.top - this.object.bottom) / this.object.zoom / element.clientHeight, this.object.matrix);
        } else {
            // camera neither orthographic nor perspective
            console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.");
            this.enablePan = false;
        }
    }
    _dollyOut(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) this._scale /= dollyScale;
        else {
            console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
            this.enableZoom = false;
        }
    }
    _dollyIn(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) this._scale *= dollyScale;
        else {
            console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
            this.enableZoom = false;
        }
    }
    _updateZoomParameters(x, y) {
        if (!this.zoomToCursor) return;
        this._performCursorZoom = true;
        const rect = this.domElement.getBoundingClientRect();
        const dx = x - rect.left;
        const dy = y - rect.top;
        const w = rect.width;
        const h = rect.height;
        this._mouse.x = dx / w * 2 - 1;
        this._mouse.y = -(dy / h) * 2 + 1;
        this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
    }
    _clampDistance(dist) {
        return Math.max(this.minDistance, Math.min(this.maxDistance, dist));
    }
    //
    // event callbacks - update the object state
    //
    _handleMouseDownRotate(event) {
        this._rotateStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownDolly(event) {
        this._updateZoomParameters(event.clientX, event.clientX);
        this._dollyStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownPan(event) {
        this._panStart.set(event.clientX, event.clientY);
    }
    _handleMouseMoveRotate(event) {
        this._rotateEnd.set(event.clientX, event.clientY);
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft($6c1447dc1cd4496f$var$_twoPI * this._rotateDelta.x / element.clientHeight); // yes, height
        this._rotateUp($6c1447dc1cd4496f$var$_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
        this.update();
    }
    _handleMouseMoveDolly(event) {
        this._dollyEnd.set(event.clientX, event.clientY);
        this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart);
        if (this._dollyDelta.y > 0) this._dollyOut(this._getZoomScale(this._dollyDelta.y));
        else if (this._dollyDelta.y < 0) this._dollyIn(this._getZoomScale(this._dollyDelta.y));
        this._dollyStart.copy(this._dollyEnd);
        this.update();
    }
    _handleMouseMovePan(event) {
        this._panEnd.set(event.clientX, event.clientY);
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
        this.update();
    }
    _handleMouseWheel(event) {
        this._updateZoomParameters(event.clientX, event.clientY);
        if (event.deltaY < 0) this._dollyIn(this._getZoomScale(event.deltaY));
        else if (event.deltaY > 0) this._dollyOut(this._getZoomScale(event.deltaY));
        this.update();
    }
    _handleKeyDown(event) {
        let needsUpdate = false;
        switch(event.code){
            case this.keys.UP:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateUp($6c1447dc1cd4496f$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(0, this.keyPanSpeed);
                needsUpdate = true;
                break;
            case this.keys.BOTTOM:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateUp(-$6c1447dc1cd4496f$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(0, -this.keyPanSpeed);
                needsUpdate = true;
                break;
            case this.keys.LEFT:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateLeft($6c1447dc1cd4496f$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(this.keyPanSpeed, 0);
                needsUpdate = true;
                break;
            case this.keys.RIGHT:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateLeft(-$6c1447dc1cd4496f$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(-this.keyPanSpeed, 0);
                needsUpdate = true;
                break;
        }
        if (needsUpdate) {
            // prevent the browser from scrolling on cursor keys
            event.preventDefault();
            this.update();
        }
    }
    _handleTouchStartRotate(event) {
        if (this._pointers.length === 1) this._rotateStart.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._rotateStart.set(x, y);
        }
    }
    _handleTouchStartPan(event) {
        if (this._pointers.length === 1) this._panStart.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._panStart.set(x, y);
        }
    }
    _handleTouchStartDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyStart.set(0, distance);
    }
    _handleTouchStartDollyPan(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enablePan) this._handleTouchStartPan(event);
    }
    _handleTouchStartDollyRotate(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enableRotate) this._handleTouchStartRotate(event);
    }
    _handleTouchMoveRotate(event) {
        if (this._pointers.length == 1) this._rotateEnd.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._rotateEnd.set(x, y);
        }
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft($6c1447dc1cd4496f$var$_twoPI * this._rotateDelta.x / element.clientHeight); // yes, height
        this._rotateUp($6c1447dc1cd4496f$var$_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
    }
    _handleTouchMovePan(event) {
        if (this._pointers.length === 1) this._panEnd.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._panEnd.set(x, y);
        }
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
    }
    _handleTouchMoveDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyEnd.set(0, distance);
        this._dollyDelta.set(0, Math.pow(this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed));
        this._dollyOut(this._dollyDelta.y);
        this._dollyStart.copy(this._dollyEnd);
        const centerX = (event.pageX + position.x) * 0.5;
        const centerY = (event.pageY + position.y) * 0.5;
        this._updateZoomParameters(centerX, centerY);
    }
    _handleTouchMoveDollyPan(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enablePan) this._handleTouchMovePan(event);
    }
    _handleTouchMoveDollyRotate(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enableRotate) this._handleTouchMoveRotate(event);
    }
    // pointers
    _addPointer(event) {
        this._pointers.push(event.pointerId);
    }
    _removePointer(event) {
        delete this._pointerPositions[event.pointerId];
        for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i] == event.pointerId) {
            this._pointers.splice(i, 1);
            return;
        }
    }
    _isTrackingPointer(event) {
        for(let i = 0; i < this._pointers.length; i++){
            if (this._pointers[i] == event.pointerId) return true;
        }
        return false;
    }
    _trackPointer(event) {
        let position = this._pointerPositions[event.pointerId];
        if (position === undefined) {
            position = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)();
            this._pointerPositions[event.pointerId] = position;
        }
        position.set(event.pageX, event.pageY);
    }
    _getSecondPointerPosition(event) {
        const pointerId = event.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
        return this._pointerPositions[pointerId];
    }
    //
    _customWheelEvent(event) {
        const mode = event.deltaMode;
        // minimal wheel event altered to meet delta-zoom demand
        const newEvent = {
            clientX: event.clientX,
            clientY: event.clientY,
            deltaY: event.deltaY
        };
        switch(mode){
            case 1:
                newEvent.deltaY *= 16;
                break;
            case 2:
                newEvent.deltaY *= 100;
                break;
        }
        // detect if event was triggered by pinching
        if (event.ctrlKey && !this._controlActive) newEvent.deltaY *= 10;
        return newEvent;
    }
}
function $6c1447dc1cd4496f$var$onPointerDown(event) {
    if (this.enabled === false) return;
    if (this._pointers.length === 0) {
        this.domElement.setPointerCapture(event.pointerId);
        this.domElement.addEventListener("pointermove", this._onPointerMove);
        this.domElement.addEventListener("pointerup", this._onPointerUp);
    }
    //
    if (this._isTrackingPointer(event)) return;
    //
    this._addPointer(event);
    if (event.pointerType === "touch") this._onTouchStart(event);
    else this._onMouseDown(event);
}
function $6c1447dc1cd4496f$var$onPointerMove(event) {
    if (this.enabled === false) return;
    if (event.pointerType === "touch") this._onTouchMove(event);
    else this._onMouseMove(event);
}
function $6c1447dc1cd4496f$var$onPointerUp(event) {
    this._removePointer(event);
    switch(this._pointers.length){
        case 0:
            this.domElement.releasePointerCapture(event.pointerId);
            this.domElement.removeEventListener("pointermove", this._onPointerMove);
            this.domElement.removeEventListener("pointerup", this._onPointerUp);
            this.dispatchEvent($6c1447dc1cd4496f$var$_endEvent);
            this.state = $6c1447dc1cd4496f$var$_STATE.NONE;
            break;
        case 1:
            const pointerId = this._pointers[0];
            const position = this._pointerPositions[pointerId];
            // minimal placeholder event - allows state correction on pointer-up
            this._onTouchStart({
                pointerId: pointerId,
                pageX: position.x,
                pageY: position.y
            });
            break;
    }
}
function $6c1447dc1cd4496f$var$onMouseDown(event) {
    let mouseAction;
    switch(event.button){
        case 0:
            mouseAction = this.mouseButtons.LEFT;
            break;
        case 1:
            mouseAction = this.mouseButtons.MIDDLE;
            break;
        case 2:
            mouseAction = this.mouseButtons.RIGHT;
            break;
        default:
            mouseAction = -1;
    }
    switch(mouseAction){
        case (0, $0d79572b4b22d35c$export$7177b3e430c2d7ca).DOLLY:
            if (this.enableZoom === false) return;
            this._handleMouseDownDolly(event);
            this.state = $6c1447dc1cd4496f$var$_STATE.DOLLY;
            break;
        case (0, $0d79572b4b22d35c$export$7177b3e430c2d7ca).ROTATE:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
                if (this.enablePan === false) return;
                this._handleMouseDownPan(event);
                this.state = $6c1447dc1cd4496f$var$_STATE.PAN;
            } else {
                if (this.enableRotate === false) return;
                this._handleMouseDownRotate(event);
                this.state = $6c1447dc1cd4496f$var$_STATE.ROTATE;
            }
            break;
        case (0, $0d79572b4b22d35c$export$7177b3e430c2d7ca).PAN:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
                if (this.enableRotate === false) return;
                this._handleMouseDownRotate(event);
                this.state = $6c1447dc1cd4496f$var$_STATE.ROTATE;
            } else {
                if (this.enablePan === false) return;
                this._handleMouseDownPan(event);
                this.state = $6c1447dc1cd4496f$var$_STATE.PAN;
            }
            break;
        default:
            this.state = $6c1447dc1cd4496f$var$_STATE.NONE;
    }
    if (this.state !== $6c1447dc1cd4496f$var$_STATE.NONE) this.dispatchEvent($6c1447dc1cd4496f$var$_startEvent);
}
function $6c1447dc1cd4496f$var$onMouseMove(event) {
    switch(this.state){
        case $6c1447dc1cd4496f$var$_STATE.ROTATE:
            if (this.enableRotate === false) return;
            this._handleMouseMoveRotate(event);
            break;
        case $6c1447dc1cd4496f$var$_STATE.DOLLY:
            if (this.enableZoom === false) return;
            this._handleMouseMoveDolly(event);
            break;
        case $6c1447dc1cd4496f$var$_STATE.PAN:
            if (this.enablePan === false) return;
            this._handleMouseMovePan(event);
            break;
    }
}
function $6c1447dc1cd4496f$var$onMouseWheel(event) {
    if (this.enabled === false || this.enableZoom === false || this.state !== $6c1447dc1cd4496f$var$_STATE.NONE) return;
    event.preventDefault();
    this.dispatchEvent($6c1447dc1cd4496f$var$_startEvent);
    this._handleMouseWheel(this._customWheelEvent(event));
    this.dispatchEvent($6c1447dc1cd4496f$var$_endEvent);
}
function $6c1447dc1cd4496f$var$onKeyDown(event) {
    if (this.enabled === false || this.enablePan === false) return;
    this._handleKeyDown(event);
}
function $6c1447dc1cd4496f$var$onTouchStart(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            switch(this.touches.ONE){
                case (0, $0d79572b4b22d35c$export$d46bd3ead7cc759b).ROTATE:
                    if (this.enableRotate === false) return;
                    this._handleTouchStartRotate(event);
                    this.state = $6c1447dc1cd4496f$var$_STATE.TOUCH_ROTATE;
                    break;
                case (0, $0d79572b4b22d35c$export$d46bd3ead7cc759b).PAN:
                    if (this.enablePan === false) return;
                    this._handleTouchStartPan(event);
                    this.state = $6c1447dc1cd4496f$var$_STATE.TOUCH_PAN;
                    break;
                default:
                    this.state = $6c1447dc1cd4496f$var$_STATE.NONE;
            }
            break;
        case 2:
            switch(this.touches.TWO){
                case (0, $0d79572b4b22d35c$export$d46bd3ead7cc759b).DOLLY_PAN:
                    if (this.enableZoom === false && this.enablePan === false) return;
                    this._handleTouchStartDollyPan(event);
                    this.state = $6c1447dc1cd4496f$var$_STATE.TOUCH_DOLLY_PAN;
                    break;
                case (0, $0d79572b4b22d35c$export$d46bd3ead7cc759b).DOLLY_ROTATE:
                    if (this.enableZoom === false && this.enableRotate === false) return;
                    this._handleTouchStartDollyRotate(event);
                    this.state = $6c1447dc1cd4496f$var$_STATE.TOUCH_DOLLY_ROTATE;
                    break;
                default:
                    this.state = $6c1447dc1cd4496f$var$_STATE.NONE;
            }
            break;
        default:
            this.state = $6c1447dc1cd4496f$var$_STATE.NONE;
    }
    if (this.state !== $6c1447dc1cd4496f$var$_STATE.NONE) this.dispatchEvent($6c1447dc1cd4496f$var$_startEvent);
}
function $6c1447dc1cd4496f$var$onTouchMove(event) {
    this._trackPointer(event);
    switch(this.state){
        case $6c1447dc1cd4496f$var$_STATE.TOUCH_ROTATE:
            if (this.enableRotate === false) return;
            this._handleTouchMoveRotate(event);
            this.update();
            break;
        case $6c1447dc1cd4496f$var$_STATE.TOUCH_PAN:
            if (this.enablePan === false) return;
            this._handleTouchMovePan(event);
            this.update();
            break;
        case $6c1447dc1cd4496f$var$_STATE.TOUCH_DOLLY_PAN:
            if (this.enableZoom === false && this.enablePan === false) return;
            this._handleTouchMoveDollyPan(event);
            this.update();
            break;
        case $6c1447dc1cd4496f$var$_STATE.TOUCH_DOLLY_ROTATE:
            if (this.enableZoom === false && this.enableRotate === false) return;
            this._handleTouchMoveDollyRotate(event);
            this.update();
            break;
        default:
            this.state = $6c1447dc1cd4496f$var$_STATE.NONE;
    }
}
function $6c1447dc1cd4496f$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}
function $6c1447dc1cd4496f$var$interceptControlDown(event) {
    if (event.key === "Control") {
        this._controlActive = true;
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.addEventListener("keyup", this._interceptControlUp, {
            passive: true,
            capture: true
        });
    }
}
function $6c1447dc1cd4496f$var$interceptControlUp(event) {
    if (event.key === "Control") {
        this._controlActive = false;
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.removeEventListener("keyup", this._interceptControlUp, {
            passive: true,
            capture: true
        });
    }
}



class $b5225408295f08ae$export$936f75e6792bf2dc extends (0, $0d79572b4b22d35c$export$e4dd07dff30cc924) {
    constructor(element = document.createElement("div")){
        super();
        this.isCSS2DObject = true;
        this.element = element;
        this.element.style.position = "absolute";
        this.element.style.userSelect = "none";
        this.element.setAttribute("draggable", false);
        this.center = new (0, $0d79572b4b22d35c$export$c977b3e384af9ae1)(0.5, 0.5); // ( 0, 0 ) is the lower left; ( 1, 1 ) is the top right
        this.addEventListener("removed", function() {
            this.traverse(function(object) {
                if (object.element instanceof Element && object.element.parentNode !== null) object.element.parentNode.removeChild(object.element);
            });
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.element = source.element.cloneNode(true);
        this.center = source.center;
        return this;
    }
}
//
const $b5225408295f08ae$var$_vector = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)();
const $b5225408295f08ae$var$_viewMatrix = new (0, $0d79572b4b22d35c$export$2ae72fc923e5eb5)();
const $b5225408295f08ae$var$_viewProjectionMatrix = new (0, $0d79572b4b22d35c$export$2ae72fc923e5eb5)();
const $b5225408295f08ae$var$_a = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)();
const $b5225408295f08ae$var$_b = new (0, $0d79572b4b22d35c$export$64b5c384219d3699)();
class $b5225408295f08ae$export$508520281a983506 {
    constructor(parameters = {}){
        const _this = this;
        let _width, _height;
        let _widthHalf, _heightHalf;
        const cache = {
            objects: new WeakMap()
        };
        const domElement = parameters.element !== undefined ? parameters.element : document.createElement("div");
        domElement.style.overflow = "hidden";
        this.domElement = domElement;
        this.getSize = function() {
            return {
                width: _width,
                height: _height
            };
        };
        this.render = function(scene, camera) {
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            $b5225408295f08ae$var$_viewMatrix.copy(camera.matrixWorldInverse);
            $b5225408295f08ae$var$_viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, $b5225408295f08ae$var$_viewMatrix);
            renderObject(scene, scene, camera);
            zOrder(scene);
        };
        this.setSize = function(width, height) {
            _width = width;
            _height = height;
            _widthHalf = _width / 2;
            _heightHalf = _height / 2;
            domElement.style.width = width + "px";
            domElement.style.height = height + "px";
        };
        function hideObject(object) {
            if (object.isCSS2DObject) object.element.style.display = "none";
            for(let i = 0, l = object.children.length; i < l; i++)hideObject(object.children[i]);
        }
        function renderObject(object, scene, camera) {
            if (object.visible === false) {
                hideObject(object);
                return;
            }
            if (object.isCSS2DObject) {
                $b5225408295f08ae$var$_vector.setFromMatrixPosition(object.matrixWorld);
                $b5225408295f08ae$var$_vector.applyMatrix4($b5225408295f08ae$var$_viewProjectionMatrix);
                const visible = $b5225408295f08ae$var$_vector.z >= -1 && $b5225408295f08ae$var$_vector.z <= 1 && object.layers.test(camera.layers) === true;
                const element = object.element;
                element.style.display = visible === true ? "" : "none";
                if (visible === true) {
                    object.onBeforeRender(_this, scene, camera);
                    element.style.transform = "translate(" + -100 * object.center.x + "%," + -100 * object.center.y + "%)" + "translate(" + ($b5225408295f08ae$var$_vector.x * _widthHalf + _widthHalf) + "px," + (-$b5225408295f08ae$var$_vector.y * _heightHalf + _heightHalf) + "px)";
                    if (element.parentNode !== domElement) domElement.appendChild(element);
                    object.onAfterRender(_this, scene, camera);
                }
                const objectData = {
                    distanceToCameraSquared: getDistanceToSquared(camera, object)
                };
                cache.objects.set(object, objectData);
            }
            for(let i = 0, l = object.children.length; i < l; i++)renderObject(object.children[i], scene, camera);
        }
        function getDistanceToSquared(object1, object2) {
            $b5225408295f08ae$var$_a.setFromMatrixPosition(object1.matrixWorld);
            $b5225408295f08ae$var$_b.setFromMatrixPosition(object2.matrixWorld);
            return $b5225408295f08ae$var$_a.distanceToSquared($b5225408295f08ae$var$_b);
        }
        function filterAndFlatten(scene) {
            const result = [];
            scene.traverseVisible(function(object) {
                if (object.isCSS2DObject) result.push(object);
            });
            return result;
        }
        function zOrder(scene) {
            const sorted = filterAndFlatten(scene).sort(function(a, b) {
                if (a.renderOrder !== b.renderOrder) return b.renderOrder - a.renderOrder;
                const distanceA = cache.objects.get(a).distanceToCameraSquared;
                const distanceB = cache.objects.get(b).distanceToCameraSquared;
                return distanceA - distanceB;
            });
            const zMax = sorted.length;
            for(let i = 0, l = sorted.length; i < l; i++)sorted[i].element.style.zIndex = zMax - i;
        }
    }
}



async function $b28963ea5393104c$export$be895a0087773bf6(file) {
    const text = await file.text();
    const lines = text.split("\n");
    const objects = new Set();
    for (const line of lines){
        if (line.startsWith("# Object")) try {
            const parts = line.substring(2).split(",");
            if (parts[0]) {
                const objectParts = parts[0].split(":");
                // Extract full object name (everything after "ObjectXX:")
                // e.g., "Object28: 17: 4T-1 - Molar Tube" -> "17: 4T-1 - Molar Tube"
                const objectName = objectParts.slice(1).join(":").trim();
                if (objectName) objects.add(objectName);
            }
        } catch (error) {
            console.warn("Error parsing object line:", line);
        }
    }
    return objects.size;
}
function $b28963ea5393104c$export$82c7f84255e60cc3() {
    const canvas = document.createElement("canvas");
    canvas.width = 2;
    canvas.height = 2;
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, 2);
    gradient.addColorStop(0, "#000000");
    gradient.addColorStop(1, "#222222");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 2, 2);
    const texture = new $0d79572b4b22d35c$export$f7189e49152d1c13(canvas);
    texture.minFilter = $0d79572b4b22d35c$export$8a72f490b25c56c8;
    return texture;
}
async function $b28963ea5393104c$export$8b4e6220de066d27(file, loadColors = false) {
    const text = await file.text();
    const lines = text.split("\n");
    const vertices = [];
    const faces = [];
    const colors = [];
    for (const line of lines){
        if (line.startsWith("v ")) {
            const parts = line.split(" ").filter(Boolean);
            vertices.push(parseFloat(parts[1]), parseFloat(parts[2]), parseFloat(parts[3]));
            if (parts.length >= 7 && loadColors) colors.push(parseFloat(parts[4]), parseFloat(parts[5]), parseFloat(parts[6]));
            else colors.push(1, 1, 1);
        } else if (line.startsWith("f ")) {
            const parts = line.split(" ").filter(Boolean);
            faces.push(parseInt(parts[1]) - 1, parseInt(parts[2]) - 1, parseInt(parts[3]) - 1);
        }
    }
    const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
    geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
    geometry.setAttribute("color", new $0d79572b4b22d35c$export$cbe7a62641830ebd(colors, 3));
    geometry.setIndex(faces);
    geometry.computeVertexNormals();
    return new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, new $0d79572b4b22d35c$export$f2980790215acccd({
        side: $0d79572b4b22d35c$export$3b296b6f144d5b03,
        vertexColors: true,
        metalness: 0.3,
        roughness: 0.5
    }));
}
async function $b28963ea5393104c$export$c87bd72117def6be(file, removeUnlabeled = false, loadColors = false) {
    const text = await file.text();
    const lines = text.split("\n");
    const vertices = [];
    const faces = [];
    const colors = [];
    const labels = new Map();
    const vertexToToothID = new Map();
    let currentObjectId = null;
    let currentObjectName = null;
    let currentToothId = -1;
    for (const line of lines){
        if (line.startsWith("# Object")) try {
            const parts = line.substring(2).split(",");
            if (!parts[0]) throw new Error("Invalid object line format");
            const objectParts = parts[0].split(":");
            if (objectParts.length < 2) throw new Error("Invalid object name format");
            currentObjectId = objectParts[0].trim();
            // Extract full object name (everything after "ObjectXX:")
            // e.g., "Object28: 17: 4T-1 - Molar Tube" -> "17: 4T-1 - Molar Tube"
            currentObjectName = objectParts.slice(1).join(":").trim();
            // Parse tooth ID from object name
            if (currentObjectName.startsWith("Tooth ")) {
                const toothNum = currentObjectName.split(" ")[1];
                if (!toothNum) throw new Error("Invalid tooth number");
                currentToothId = parseInt(toothNum);
                if (isNaN(currentToothId)) throw new Error("Invalid tooth number");
            } else if (currentObjectName.includes("Soft") || currentObjectName.includes("Gingival")) currentToothId = 0;
            else currentToothId = -1;
        } catch (error) {
            console.warn(`Error parsing object line: ${error.message}`);
            currentObjectId = null;
            currentObjectName = null;
            currentToothId = -1;
        }
        else if (line.startsWith("v ")) {
            // Skip vertices with tooth ID -1 if removeUnlabeled is true
            if (removeUnlabeled && currentToothId === -1) continue;
            const parts = line.split(" ").filter(Boolean);
            vertices.push(parseFloat(parts[1]), parseFloat(parts[2]), parseFloat(parts[3]));
            if (parts.length >= 7 && loadColors) colors.push(parseFloat(parts[4]), parseFloat(parts[5]), parseFloat(parts[6]));
            else colors.push(1, 1, 1);
            if (currentObjectName) {
                labels.set(vertices.length / 3 - 1, currentObjectName);
                vertexToToothID.set(vertices.length / 3 - 1, currentToothId);
            }
        } else if (line.startsWith("f ")) {
            const parts = line.split(" ").filter(Boolean);
            const v1 = parseInt(parts[1]) - 1;
            const v2 = parseInt(parts[2]) - 1;
            const v3 = parseInt(parts[3]) - 1;
            // Only add face if all vertices exist (not filtered out)
            if (!removeUnlabeled || vertexToToothID.get(v1) !== -1 && vertexToToothID.get(v2) !== -1 && vertexToToothID.get(v3) !== -1) faces.push(v1, v2, v3);
        }
    }
    const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
    geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(vertices, 3));
    geometry.setAttribute("color", new $0d79572b4b22d35c$export$cbe7a62641830ebd(colors, 3));
    geometry.setIndex(faces);
    geometry.computeVertexNormals();
    const mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, new $0d79572b4b22d35c$export$f2980790215acccd({
        side: $0d79572b4b22d35c$export$3b296b6f144d5b03,
        vertexColors: true,
        metalness: 0.3,
        roughness: 0.5
    }));
    return {
        object: mesh,
        vertexToToothID: vertexToToothID
    };
}
async function $b28963ea5393104c$export$10855d30050361d4(file) {
    const contents = await file.arrayBuffer();
    const stlData = new Uint8Array(contents);
    const isBinary = !$b28963ea5393104c$export$a493171f044f7c79(stlData);
    let positions = [];
    let indices = [];
    if (isBinary) $b28963ea5393104c$var$parseBinaryStl(stlData, positions, indices);
    else $b28963ea5393104c$var$parseAsciiStl(new TextDecoder().decode(stlData), positions, indices);
    // Create a new geometry with unique vertices
    const uniqueVertices = new Map();
    const newPositions = [];
    const newIndices = [];
    // Process each vertex
    for(let i = 0; i < indices.length; i++){
        const index = indices[i];
        const x = positions[index * 3];
        const y = positions[index * 3 + 1];
        const z = positions[index * 3 + 2];
        // Use float values directly as key by multiplying by a large number to preserve precision
        const vertexKey = x * 1e6 + y * 1e3 + z;
        if (!uniqueVertices.has(vertexKey)) {
            const newIndex = newPositions.length / 3;
            uniqueVertices.set(vertexKey, newIndex);
            newPositions.push(x, y, z);
        }
        newIndices.push(uniqueVertices.get(vertexKey));
    }
    const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
    geometry.setAttribute("position", new $0d79572b4b22d35c$export$cbe7a62641830ebd(newPositions, 3));
    geometry.setIndex(newIndices);
    geometry.computeVertexNormals();
    return new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, new $0d79572b4b22d35c$export$f2980790215acccd({
        side: $0d79572b4b22d35c$export$3b296b6f144d5b03,
        vertexColors: true,
        metalness: 0.3,
        roughness: 0.5
    }));
}
function $b28963ea5393104c$export$a493171f044f7c79(data) {
    const ascii = new TextDecoder().decode(data.slice(0, 5));
    return ascii.toLowerCase().startsWith("solid");
}
function $b28963ea5393104c$var$parseBinaryStl(data, positions, indices) {
    const dataView = new DataView(data.buffer);
    const triangles = dataView.getUint32(80, true);
    let offset = 84;
    for(let i = 0; i < triangles; i++){
        // Skip normal
        offset += 12;
        // Read vertices
        for(let j = 0; j < 3; j++){
            const x = dataView.getFloat32(offset, true);
            const y = dataView.getFloat32(offset + 4, true);
            const z = dataView.getFloat32(offset + 8, true);
            positions.push(x, y, z);
            indices.push(i * 3 + j);
            offset += 12;
        }
        // Skip attribute byte count
        offset += 2;
    }
}
function $b28963ea5393104c$var$parseAsciiStl(data, positions, indices) {
    const lines = data.split("\n");
    let vertexIndex = 0;
    for(let i = 0; i < lines.length; i++){
        const line = lines[i].trim();
        if (line.startsWith("vertex")) {
            const parts = line.split(/\s+/);
            positions.push(parseFloat(parts[1]), parseFloat(parts[2]), parseFloat(parts[3]));
            indices.push(vertexIndex++);
        }
    }
}
function $b28963ea5393104c$export$77a004ad2426cc6b(state) {
    if (!state.mesh) return;
    // Remove existing visualizations
    state.scene.remove(state.scene.getObjectByName("wireframe"));
    state.scene.remove(state.scene.getObjectByName("pointcloud"));
    if (state.showWireframe) {
        const wireframe = new $0d79572b4b22d35c$export$ff1ed10fedfdd604(new $0d79572b4b22d35c$export$4b739da06d24892b(state.mesh.geometry), state.wireframeMaterial);
        wireframe.name = "wireframe";
        state.scene.add(wireframe);
    }
    if (state.showPointCloud) {
        const pointCloud = new $0d79572b4b22d35c$export$1c787534cb11aa3e(state.mesh.geometry, state.pointsMaterial);
        pointCloud.name = "pointcloud";
        state.scene.add(pointCloud);
    }
    state.mesh.visible = !state.showPointCloud;
}


// Reading speed used to size the display time, words per minute. Deliberately
// pessimistic against the ~200-250 wpm range for prose on screen, because a toast is
// read while looking at something else.
const $7259ed209c831d5c$var$READING_WPM = 160;
// A toast never sits for less than this, so a two-word confirmation still registers,
// nor longer than this, so a long one does not camp in the corner. Past the cap the
// reader dismisses it by clicking, which is why that is supported.
const $7259ed209c831d5c$var$MIN_MS = 3000;
const $7259ed209c831d5c$var$MAX_MS = 30000;
/**
 * How long a message needs to be on screen to be readable.
 *
 * The pipeline's findings are sentences, not labels: a run can report rejected
 * landmarks, a constricted arch and the Refine caveat at once, which came to 130
 * words. At the fixed 12s those callers asked for, that was 12 seconds to read 39
 * seconds of text, so the end of the message was never seen.
 */ function $7259ed209c831d5c$export$c68215c556eed69d(message) {
    const words = String(message).trim().split(/\s+/).filter(Boolean).length;
    return Math.min($7259ed209c831d5c$var$MAX_MS, Math.max($7259ed209c831d5c$var$MIN_MS, words / $7259ed209c831d5c$var$READING_WPM * 60000));
}
/**
 * Show a transient message.
 *
 * @param {string} message plain text; markup is escaped, not rendered
 * @param {string} icon Font Awesome name, without the `fa-` prefix
 * @param {number} [duration] milliseconds. Omit to size it from the message length,
 *   which is what long findings need. An explicit value is honoured as a floor, so a
 *   caller asking for 12s on a 100-word message still gets long enough to read it.
 */ function $7259ed209c831d5c$export$f6cef6fcf9ca4e17(message, icon = "check", duration) {
    const toast = document.createElement("div");
    toast.className = "toast";
    // The icon is ours; the message is not. Filenames and server text reach here --
    // `Labels and tags saved to ${jsonFileName}` among them -- so the message goes in
    // as a text node rather than through innerHTML, where a name like
    // `<img src=x onerror=...>.json` would execute.
    const glyph = document.createElement("i");
    glyph.className = `fas fa-${icon}`;
    toast.appendChild(glyph);
    toast.appendChild(document.createTextNode(` ${message}`));
    const ms = Math.max(duration || 0, $7259ed209c831d5c$export$c68215c556eed69d(message));
    toast.style.animation = `fadeInOut ${ms / 1000}s ease-in-out`;
    // Dismissable, because a long finding holds the corner for a while and the reader
    // may be done with it sooner.
    toast.title = "Click to dismiss";
    const remove = ()=>toast.remove();
    toast.addEventListener("click", remove);
    document.body.appendChild(toast);
    setTimeout(remove, ms);
}


var $2a57802d05c0eaa2$exports = {};
$2a57802d05c0eaa2$exports = JSON.parse('[{"id":0,"name":"Gingiva","color":"#ffffff"},{"id":11,"name":"Tooth 11","color":"#1f77b4"},{"id":12,"name":"Tooth 12","color":"#aec7e8"},{"id":13,"name":"Tooth 13","color":"#ff7f0e"},{"id":14,"name":"Tooth 14","color":"#ffbb78"},{"id":15,"name":"Tooth 15","color":"#2ca02c"},{"id":16,"name":"Tooth 16","color":"#98df8a"},{"id":17,"name":"Tooth 17","color":"#d62728"},{"id":18,"name":"Tooth 18","color":"#ff9896"},{"id":21,"name":"Tooth 21","color":"#9467bd"},{"id":22,"name":"Tooth 22","color":"#c5b0d5"},{"id":23,"name":"Tooth 23","color":"#8c564b"},{"id":24,"name":"Tooth 24","color":"#c49c94"},{"id":25,"name":"Tooth 25","color":"#e377c2"},{"id":26,"name":"Tooth 26","color":"#f7b6d2"},{"id":27,"name":"Tooth 27","color":"#7f7f7f"},{"id":28,"name":"Tooth 28","color":"#ff2700"},{"id":31,"name":"Tooth 31","color":"#bcbd22"},{"id":32,"name":"Tooth 32","color":"#dbdb8d"},{"id":33,"name":"Tooth 33","color":"#17becf"},{"id":34,"name":"Tooth 34","color":"#9edae5"},{"id":35,"name":"Tooth 35","color":"#393b79"},{"id":36,"name":"Tooth 36","color":"#5254a3"},{"id":37,"name":"Tooth 37","color":"#6b6ecf"},{"id":38,"name":"Tooth 38","color":"#9c9ede"},{"id":41,"name":"Tooth 41","color":"#637939"},{"id":42,"name":"Tooth 42","color":"#8ca252"},{"id":43,"name":"Tooth 43","color":"#b5cf6b"},{"id":44,"name":"Tooth 44","color":"#cedb9c"},{"id":45,"name":"Tooth 45","color":"#8c6d31"},{"id":46,"name":"Tooth 46","color":"#bd9e39"},{"id":47,"name":"Tooth 47","color":"#e7ba52"},{"id":48,"name":"Tooth 48","color":"#0000ff"}]');


var $87cd5dd3a0b838ad$exports = {};
$87cd5dd3a0b838ad$exports = JSON.parse('[{"id":0,"name":"OK","color":"#b3b3b3"},{"id":1,"name":"Defect","color":"#9ef751"}]');


var $60270fe9f6d741b0$exports = {};
$60270fe9f6d741b0$exports = JSON.parse('[{"id":0,"name":"Background","color":"#FFFFFF"},{"id":1,"name":"17db","color":"#13cf8e"},{"id":2,"name":"17mb","color":"#d00367"},{"id":3,"name":"17dp","color":"#f40eea"},{"id":4,"name":"17mp","color":"#134bf6"},{"id":5,"name":"16db","color":"#13cf8e"},{"id":6,"name":"16mb","color":"#d00367"},{"id":7,"name":"16dp","color":"#f40eea"},{"id":8,"name":"16mp","color":"#134bf6"},{"id":9,"name":"15b","color":"#0def0c"},{"id":10,"name":"15p","color":"#d75303"},{"id":11,"name":"14b","color":"#0def0c"},{"id":12,"name":"14p","color":"#d75303"},{"id":13,"name":"13C","color":"#c527e7"},{"id":14,"name":"23C","color":"#c527e7"},{"id":15,"name":"24b","color":"#0def0c"},{"id":16,"name":"24p","color":"#d75303"},{"id":17,"name":"25b","color":"#0def0c"},{"id":18,"name":"25p","color":"#d75303"},{"id":19,"name":"26mb","color":"#d00367"},{"id":20,"name":"26mp","color":"#134bf6"},{"id":21,"name":"26db","color":"#13cf8e"},{"id":22,"name":"26dp","color":"#f40eea"},{"id":23,"name":"27mb","color":"#d00367"},{"id":24,"name":"27mp","color":"#134bf6"},{"id":25,"name":"27db","color":"#13cf8e"},{"id":26,"name":"27dp","color":"#f40eea"},{"id":27,"name":"37db","color":"#13cf8e"},{"id":28,"name":"37dl","color":"#f88800"},{"id":29,"name":"37ml","color":"#db1618"},{"id":30,"name":"37mb","color":"#d00367"},{"id":31,"name":"36db","color":"#13cf8e"},{"id":32,"name":"36dl","color":"#f88800"},{"id":33,"name":"36ml","color":"#db1618"},{"id":34,"name":"36mb","color":"#d00367"},{"id":35,"name":"35l","color":"#54dc26"},{"id":36,"name":"35b","color":"#0def0c"},{"id":37,"name":"34b","color":"#0def0c"},{"id":38,"name":"34l","color":"#54dc26"},{"id":39,"name":"33C","color":"#c527e7"},{"id":40,"name":"43C","color":"#c527e7"},{"id":41,"name":"44b","color":"#0def0c"},{"id":42,"name":"44l","color":"#54dc26"},{"id":43,"name":"45b","color":"#0def0c"},{"id":44,"name":"45l","color":"#54dc26"},{"id":45,"name":"46db","color":"#13cf8e"},{"id":46,"name":"46mb","color":"#d00367"},{"id":47,"name":"46dl","color":"#f88800"},{"id":48,"name":"46ml","color":"#db1618"},{"id":49,"name":"47db","color":"#13cf8e"},{"id":50,"name":"47mb","color":"#d00367"},{"id":51,"name":"47dl","color":"#f88800"},{"id":52,"name":"47ml","color":"#db1618"},{"id":53,"name":"12I","color":"#f42786"},{"id":54,"name":"11I","color":"#f42786"},{"id":55,"name":"21I","color":"#f42786"},{"id":56,"name":"22I","color":"#f42786"},{"id":57,"name":"41I","color":"#f42786"},{"id":58,"name":"42I","color":"#f42786"},{"id":59,"name":"31I","color":"#f42786"},{"id":60,"name":"32I","color":"#f42786"},{"id":61,"name":"17MMR","color":"#1d9dd0"},{"id":62,"name":"16MMR","color":"#1d9dd0"},{"id":63,"name":"15MMR","color":"#1d9dd0"},{"id":64,"name":"14MMR","color":"#1d9dd0"},{"id":65,"name":"24MMR","color":"#1d9dd0"},{"id":66,"name":"25MMR","color":"#1d9dd0"},{"id":67,"name":"26MMR","color":"#1d9dd0"},{"id":68,"name":"27MMR","color":"#1d9dd0"},{"id":69,"name":"27DMR","color":"#b01dd8"},{"id":70,"name":"26DMR","color":"#b01dd8"},{"id":71,"name":"25DMR","color":"#b01dd8"},{"id":72,"name":"24DMR","color":"#b01dd8"},{"id":73,"name":"37MMR","color":"#1d9dd0"},{"id":74,"name":"36MMR","color":"#1d9dd0"},{"id":75,"name":"35MMR","color":"#1d9dd0"},{"id":76,"name":"34MMR","color":"#1d9dd0"},{"id":77,"name":"44MMR","color":"#1d9dd0"},{"id":78,"name":"45MMR","color":"#1d9dd0"},{"id":79,"name":"46MMR","color":"#1d9dd0"},{"id":80,"name":"47MMR","color":"#1d9dd0"},{"id":81,"name":"47DMR","color":"#b01dd8"},{"id":82,"name":"46DMR","color":"#b01dd8"},{"id":83,"name":"45DMR","color":"#b01dd8"},{"id":84,"name":"44DMR","color":"#b01dd8"},{"id":85,"name":"34DMR","color":"#b01dd8"},{"id":86,"name":"35DMR","color":"#b01dd8"},{"id":87,"name":"36DMR","color":"#b01dd8"},{"id":88,"name":"37DMR","color":"#b01dd8"},{"id":89,"name":"17DMR","color":"#b01dd8"},{"id":90,"name":"16DMR","color":"#b01dd8"},{"id":91,"name":"15DMR","color":"#b01dd8"},{"id":92,"name":"14DMR","color":"#b01dd8"}]');



function $e586be2af700953a$export$ff099ae6aa7c9ea9(state, event) {
    state.mouse.x = event.clientX / window.innerWidth * 2 - 1;
    state.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    state.raycaster.setFromCamera(state.mouse, state.camera);
    return state.raycaster.intersectObject(state.mesh);
}
function $e586be2af700953a$export$53d69f272e12cd13(state, event) {
    state.mouse.x = event.clientX / window.innerWidth * 2 - 1;
    state.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    state.raycaster.setFromCamera(state.mouse, state.camera);
    // Get all keypoint spheres from the scene
    const keypointMeshes = state.scene.children.filter((child)=>child.name?.startsWith("keypoint-point-"));
    return state.raycaster.intersectObjects(keypointMeshes);
}



const $bebe1cbb5a309c8c$export$9add872513f17394 = 0.6;
const $bebe1cbb5a309c8c$export$89c2fa3be9416a68 = 1.5;
const $bebe1cbb5a309c8c$export$7f28898ca56d24c7 = false;
const $bebe1cbb5a309c8c$export$a94eb5254fe8721d = false;
const $bebe1cbb5a309c8c$export$a7951f5d41ce99ea = true;
const $bebe1cbb5a309c8c$export$b421f278bfd63bea = false;
const $bebe1cbb5a309c8c$export$b27485b49bff3d63 = false;
const $bebe1cbb5a309c8c$export$fc153b3df7cb20a2 = true;
const $bebe1cbb5a309c8c$export$bae6355c2bc79686 = true;
const $bebe1cbb5a309c8c$export$2bf5fe4866781794 = 0.5; // Displacement for keypoint label from keypoint
const $bebe1cbb5a309c8c$export$c4bcc317d02e655b = [
    [
        "ML_DMR",
        "ML_MMR"
    ],
    [
        "PR_MMR",
        "PR_DMR"
    ],
    [
        "14MMR",
        "14DMR"
    ],
    [
        "15MMR",
        "15DMR"
    ],
    [
        "16MMR",
        "16DMR"
    ],
    [
        "17MMR",
        "17DMR"
    ],
    [
        "18MMR",
        "18DMR"
    ],
    [
        "24MMR",
        "24DMR"
    ],
    [
        "25MMR",
        "25DMR"
    ],
    [
        "26MMR",
        "26DMR"
    ],
    [
        "27MMR",
        "27DMR"
    ],
    [
        "28MMR",
        "28DMR"
    ],
    [
        "34MMR",
        "34DMR"
    ],
    [
        "35MMR",
        "35DMR"
    ],
    [
        "36MMR",
        "36DMR"
    ],
    [
        "37MMR",
        "37DMR"
    ],
    [
        "38MMR",
        "38DMR"
    ],
    [
        "44MMR",
        "44DMR"
    ],
    [
        "45MMR",
        "45DMR"
    ],
    [
        "46MMR",
        "46DMR"
    ],
    [
        "47MMR",
        "47DMR"
    ],
    [
        "48MMR",
        "48DMR"
    ]
];


function $1161739a589c5758$export$3470880f2ce9a413(name) {
    return name.replace("keypoint-label-", "keypoint-point-");
}
function $1161739a589c5758$export$500cfe4fa432e2e4(name) {
    return name.replace("keypoint-point-", "keypoint-label-");
}
function $1161739a589c5758$var$createLabel(state, position, className, toothId, labelName) {
    const labelDiv = document.createElement("div");
    labelDiv.className = "keypoint-label";
    labelDiv.textContent = className + (toothId != null && state?.showToothIDForKeypoints ? ` (${toothId})` : "");
    labelDiv.style.backgroundColor = "rgba(0,0,0,0.7)";
    labelDiv.style.color = "white";
    labelDiv.style.padding = "5px";
    labelDiv.style.borderRadius = "3px";
    labelDiv.style.pointerEvents = "none";
    const label = new (0, $b5225408295f08ae$export$936f75e6792bf2dc)(labelDiv);
    // Shift label position slightly up and to the right of keypoint
    const labelPosition = position.clone().add(new $0d79572b4b22d35c$export$64b5c384219d3699(0.3, 0.3, 0));
    label.position.copy(labelPosition);
    label.position.x += (0, $bebe1cbb5a309c8c$export$2bf5fe4866781794);
    label.name = labelName;
    label.visible = state.showKeypointLabels;
    return label;
}
async function $1161739a589c5758$export$95aaa998465a9620(state, event) {
    if (!state.mesh) return;
    const intersects = (0, $e586be2af700953a$export$ff099ae6aa7c9ea9)(state, event);
    if (intersects.length > 0) {
        const point = intersects[0].point;
        const vertexId = intersects[0].face.a; // Get vertex ID from intersection
        const toothId = state.vertexToToothID ? state?.vertexToToothID?.get(vertexId) : null;
        const fileName = state.objFiles[state.currentFileIndex].name;
        if (!state.keypoints[fileName]) state.keypoints[fileName] = [];
        const currentClass = state.annotationClasses.find((c)=>c.id === state.currentClassId);
        // Create unique label name using uuid
        const uuid = crypto.randomUUID();
        const pointName = `keypoint-point-${uuid}`;
        const labelName = `keypoint-label-${uuid}`;
        // Store keypoint data including x,y,z coordinates, class name, point name, and tooth ID
        const keypointData = {
            x: point.x,
            y: point.y,
            z: point.z,
            className: currentClass.name,
            pointName: pointName,
            toothId: toothId,
            color: currentClass.color
        };
        state.keypoints[fileName].push(keypointData);
        // Create and add sphere to visualize keypoint
        const sphereGeometry = new $0d79572b4b22d35c$export$1b417fc3b307a251(0.25, 16, 16);
        const sphereMaterial = new $0d79572b4b22d35c$export$55cbcc9b622fe1f5({
            color: currentClass.color
        });
        const sphere = new $0d79572b4b22d35c$export$e176487c05830cc5(sphereGeometry, sphereMaterial);
        sphere.position.copy(point);
        sphere.name = pointName;
        sphere.userData.className = currentClass.name;
        sphere.userData.pointName = pointName;
        state.scene.add(sphere);
        // Create and add label
        const label = $1161739a589c5758$var$createLabel(state, point, currentClass.name, toothId, labelName);
        state.scene.add(label);
        // Update keypoint list UI
        $1161739a589c5758$export$ba8a23d4c41e2355(state, fileName);
    }
    $1161739a589c5758$export$ef655c5027b28822(state);
}
function $1161739a589c5758$export$b41a034cf4e47fcc(state, point) {
    // Remove label from scene
    const labelToRemove = state.scene.children.find((child)=>child.name === $1161739a589c5758$export$500cfe4fa432e2e4(point.name));
    if (labelToRemove) state.scene.remove(labelToRemove);
    // Remove keypoint from keypoints array
    const fileName = state.objFiles[state.currentFileIndex].name;
    state.keypoints[fileName] = state.keypoints[fileName].filter((keypoint)=>keypoint.pointName !== point.name);
    // Remove keypoint from scene
    state.scene.remove(point);
}
function $1161739a589c5758$export$ef655c5027b28822(state) {
    // Remove existing lines
    state.scene.children = state.scene.children.filter((child)=>!child.name?.startsWith("keypoint-line-"));
    if (!state.showMarginalRidgeLines || state.labelingMode != "keypoint") return;
    const fileName = state.objFiles[state.currentFileIndex]?.name;
    if (!fileName) return;
    const fileKeypoints = state.keypoints[fileName];
    if (!fileKeypoints) return;
    const lines = [];
    // Draw lines connecting point pairs with same tooth ID
    for(let i = 0; i < fileKeypoints.length; i++)for(let j = i + 1; j < fileKeypoints.length; j++){
        const keypoint1 = fileKeypoints[i];
        const keypoint2 = fileKeypoints[j];
        if (keypoint1.toothId != keypoint2.toothId) continue;
        // Check if points are a valid pair to connect
        const isPair = (0, $bebe1cbb5a309c8c$export$c4bcc317d02e655b).some(([p1, p2])=>keypoint1.className === p1 && keypoint2.className === p2 || keypoint1.className === p2 && keypoint2.className === p1);
        if (isPair) {
            const start = new $0d79572b4b22d35c$export$64b5c384219d3699(keypoint1.x, keypoint1.y, keypoint1.z);
            const end = new $0d79572b4b22d35c$export$64b5c384219d3699(keypoint2.x, keypoint2.y, keypoint2.z);
            // Project line endpoints to screen space
            const startScreen = start.clone().project(state.camera);
            const endScreen = end.clone().project(state.camera);
            // Get distance to camera for depth sorting
            const midpoint = new $0d79572b4b22d35c$export$64b5c384219d3699().addVectors(start, end).multiplyScalar(0.5);
            const distanceToCamera = midpoint.distanceTo(state.camera.position);
            const lineGeometry = new $0d79572b4b22d35c$export$b7be63a67df8959().setFromPoints([
                start,
                end
            ]);
            const lineMaterial = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
                color: 0xffff00,
                linewidth: 2,
                transparent: false,
                depthTest: false
            });
            const line = new $0d79572b4b22d35c$export$17d680238e50603e(lineGeometry, lineMaterial);
            line.name = `keypoint-line-${keypoint1.pointName}-${keypoint2.pointName}`;
            line.renderOrder = 999;
            lines.push({
                line: line,
                distanceToCamera: distanceToCamera,
                startScreen: startScreen,
                endScreen: endScreen,
                keypoint1: keypoint1,
                keypoint2: keypoint2
            });
        }
    }
    // Sort lines by distance to camera (furthest first)
    lines.sort((a, b)=>b.distanceToCamera - a.distanceToCamera);
    // Filter out overlapping lines, keeping near segments
    const visibleLines = [];
    lines.forEach((lineInfo)=>{
        // Remove any existing overlapping lines that are further away
        for(let i = visibleLines.length - 1; i >= 0; i--){
            const existingLine = visibleLines[i];
            // Get line segments in screen space
            const line1Start = lineInfo.startScreen;
            const line1End = lineInfo.endScreen;
            const line2Start = existingLine.startScreen;
            const line2End = existingLine.endScreen;
            // Skip if keypoints are in the same jaw side
            const toothId1 = lineInfo.keypoint1.toothId;
            const toothId2 = existingLine.keypoint1.toothId;
            if (toothId1 && toothId2 && toothId1?.toString()?.length > 1 && toothId2?.toString()?.length > 1 && toothId1.toString().slice(0, 1) == toothId2.toString().slice(0, 1)) continue;
            // Check if bounding boxes overlap
            const x1 = line1Start.x;
            const y1 = line1Start.y;
            const x2 = line1End.x;
            const y2 = line1End.y;
            const x3 = line2Start.x;
            const y3 = line2Start.y;
            const x4 = line2End.x;
            const y4 = line2End.y;
            const minX1 = Math.min(x1, x2);
            const maxX1 = Math.max(x1, x2);
            const minY1 = Math.min(y1, y2);
            const maxY1 = Math.max(y1, y2);
            const minX2 = Math.min(x3, x4);
            const maxX2 = Math.max(x3, x4);
            const minY2 = Math.min(y3, y4);
            const maxY2 = Math.max(y3, y4);
            const overlaps = !(maxX1 < minX2 || maxX2 < minX1 || maxY1 < minY2 || maxY2 < minY1);
            if (overlaps) {
                // If current line is closer, remove the existing line
                if (lineInfo.distanceToCamera < existingLine.distanceToCamera) visibleLines.splice(i, 1);
                else continue;
            }
        }
        // Add the current line if it wasn't blocked by a closer line
        visibleLines.push(lineInfo);
    });
    // Add visible lines to scene
    visibleLines.forEach(({ line: line })=>{
        state.scene.add(line);
    });
}
function $1161739a589c5758$export$bfe768c9e6a38e42(state, fileName) {
    if (!state || !fileName) return;
    // Remove all keypoint-related objects from the scene
    for(let i = state.scene.children.length - 1; i >= 0; i--){
        const child = state.scene.children[i];
        if (child.name?.startsWith("keypoint-")) state.scene.remove(child);
    }
    // Draw new keypoint spheres with attached labels
    const fileKeypoints = state.keypoints[fileName];
    if (fileKeypoints && Array.isArray(fileKeypoints)) {
        fileKeypoints.forEach((keypoint)=>{
            const keypointClass = state.annotationClasses.find((c)=>c.name === keypoint.className);
            if (!keypointClass) return;
            const uuid = crypto.randomUUID();
            const pointName = keypoint.pointName || `keypoint-point-${uuid}`;
            const labelName = $1161739a589c5758$export$500cfe4fa432e2e4(pointName);
            // Create sphere for keypoint
            const sphereGeometry = new $0d79572b4b22d35c$export$1b417fc3b307a251(0.25, 16, 16);
            const sphereMaterial = new $0d79572b4b22d35c$export$55cbcc9b622fe1f5({
                color: keypointClass.color
            });
            const sphere = new $0d79572b4b22d35c$export$e176487c05830cc5(sphereGeometry, sphereMaterial);
            const position = new $0d79572b4b22d35c$export$64b5c384219d3699(keypoint.x, keypoint.y, keypoint.z);
            sphere.position.copy(position);
            sphere.name = pointName;
            sphere.userData.className = keypoint.className;
            sphere.userData.keypointData = keypoint;
            sphere.userData.pointName = pointName;
            state.scene.add(sphere);
            // Create and add label
            const label = $1161739a589c5758$var$createLabel(state, position, keypointClass.name, keypoint.toothId, labelName);
            state.scene.add(label);
        });
        $1161739a589c5758$export$ef655c5027b28822(state, fileKeypoints);
    }
}
function $1161739a589c5758$export$71e48a4bb0d1ef6e(state, keypoint) {
    // Remove any existing selection box
    state.scene.children = state.scene.children.filter((child)=>child.name !== "keypoint-selection-box");
    // Create box geometry slightly larger than the keypoint sphere
    const boxGeometry = new $0d79572b4b22d35c$export$33e43285f7406bd5(0.5, 0.5, 0.5);
    const boxMaterial = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
        color: 0xffff00,
        depthTest: false // Disable depth testing so selection box is always visible
    });
    const boxWireframe = new $0d79572b4b22d35c$export$ff1ed10fedfdd604(new $0d79572b4b22d35c$export$4730b1542707547f(boxGeometry), boxMaterial);
    boxWireframe.position.copy(keypoint.position);
    boxWireframe.name = "keypoint-selection-box";
    boxWireframe.renderOrder = 1000; // Ensure selection box renders on top of everything
    state.scene.add(boxWireframe);
}
function $1161739a589c5758$export$73d6d749976300df(state) {
    // Remove keypoint selection
    state.scene.children = state.scene.children.filter((child)=>child.name !== "keypoint-selection-box");
    state.selectionBox = null;
    state.selectedKeypoint = null;
    // Remove highlight from all keypoint items
    document.querySelectorAll(".keypoint-item").forEach((item)=>{
        item.style.backgroundColor = "transparent";
    });
}
function $1161739a589c5758$export$8b8aee2d415106c3(state, keypoint) {
    // If clicking the same keypoint that's already selected, deselect it
    if (state.selectedKeypoint === keypoint) {
        $1161739a589c5758$export$73d6d749976300df(state);
        return;
    }
    // Remove existing selection box if any
    $1161739a589c5758$export$73d6d749976300df(state);
    state.selectedKeypoint = keypoint;
    // Create new selection box after setting selected keypoint
    $1161739a589c5758$export$71e48a4bb0d1ef6e(state, keypoint);
    // Find and scroll to the corresponding keypoint item in the list
    const keypointItems = document.querySelectorAll(".keypoint-item");
    const fileName = state.objFiles[state.currentFileIndex].name;
    const keypointIndex = state.keypoints[fileName].findIndex((kp)=>kp.pointName === keypoint.userData.pointName);
    if (keypointIndex >= 0) {
        // Highlight the selected keypoint in the list
        keypointItems.forEach((item)=>{
            item.style.backgroundColor = "transparent";
        });
        keypointItems[keypointIndex].style.backgroundColor = "rgba(255, 255, 255, 0.2)";
        keypointItems[keypointIndex].scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    }
}
function $1161739a589c5758$export$ba8a23d4c41e2355(state, fileName) {
    const keypointContainer = document.getElementById("inner-keypoints-container");
    keypointContainer.innerHTML = "";
    if (state.keypoints[fileName]) state.keypoints[fileName].forEach((keypoint, index)=>{
        const keypointDiv = document.createElement("div");
        keypointDiv.className = "keypoint-item";
        // Get color from annotation class if not stored in keypoint
        const keypointClass = state.annotationClasses.find((c)=>c.name === keypoint.className);
        const color = keypoint.color || (keypointClass ? keypointClass.color : "#ccc");
        keypoint.color = color; // Store color in keypoint for future use
        keypointDiv.style.borderLeft = `4px solid ${color}`;
        // Highlight if this keypoint is selected
        if (state.selectedKeypoint && state.selectedKeypoint.userData.pointName === keypoint.pointName) keypointDiv.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
        // Make the div clickable to select keypoint
        keypointDiv.style.cursor = "pointer";
        keypointDiv.addEventListener("click", ()=>{
            const keypointObj = state.scene.getObjectByName(keypoint.pointName);
            if (keypointObj) $1161739a589c5758$export$8b8aee2d415106c3(state, keypointObj);
        });
        // Add ID display
        const idSpan = document.createElement("span");
        idSpan.textContent = `#${index + 1}`;
        idSpan.style.marginRight = "4px";
        idSpan.style.color = "#999";
        // Add class select
        const classSelect = document.createElement("select");
        classSelect.style.width = "120px";
        classSelect.style.marginRight = "4px";
        // Add class options
        state.annotationClasses.forEach((annotationClass)=>{
            const option = document.createElement("option");
            option.value = annotationClass.name;
            option.textContent = annotationClass.name;
            if (keypoint.className === annotationClass.name) option.selected = true;
            classSelect.appendChild(option);
        });
        classSelect.addEventListener("change", (e)=>{
            keypoint.className = e.target.value;
            const selectedClass = state.annotationClasses.find((c)=>c.name === e.target.value);
            if (selectedClass) {
                keypoint.color = selectedClass.color;
                keypointDiv.style.borderLeft = `4px solid ${selectedClass.color}`;
                // Update keypoint visualization
                const keypointObj = state.scene.getObjectByName(keypoint.pointName);
                if (keypointObj) keypointObj.material.color = new $0d79572b4b22d35c$export$892596cec99bc70e(selectedClass.color);
            }
            if (state.autoSave) saveLabels(state);
            $1161739a589c5758$export$bfe768c9e6a38e42(state, fileName);
        });
        // Add tooth ID select
        const toothSelect = document.createElement("select");
        toothSelect.style.width = "80px";
        toothSelect.style.marginLeft = "4px";
        // Add options
        const options = [
            {
                value: "0",
                text: "Unknown"
            },
            ...Array.from({
                length: 8
            }, (_, i)=>({
                    value: `1${i + 1}`,
                    text: `Tooth 1${i + 1}`
                })),
            ...Array.from({
                length: 8
            }, (_, i)=>({
                    value: `2${i + 1}`,
                    text: `Tooth 2${i + 1}`
                })),
            ...Array.from({
                length: 8
            }, (_, i)=>({
                    value: `3${i + 1}`,
                    text: `Tooth 3${i + 1}`
                })),
            ...Array.from({
                length: 8
            }, (_, i)=>({
                    value: `4${i + 1}`,
                    text: `Tooth 4${i + 1}`
                }))
        ];
        options.forEach((opt)=>{
            const option = document.createElement("option");
            option.value = opt.value;
            option.textContent = opt.text;
            toothSelect.appendChild(option);
        });
        toothSelect.value = keypoint.toothId || "0";
        toothSelect.addEventListener("change", (e)=>{
            keypoint.toothId = parseInt(e.target.value);
            if (state.autoSave) saveLabels(state);
            $1161739a589c5758$export$bfe768c9e6a38e42(state, fileName);
        });
        keypointDiv.appendChild(idSpan);
        keypointDiv.appendChild(classSelect);
        keypointDiv.appendChild(toothSelect);
        keypointContainer.appendChild(keypointDiv);
    });
}
function $1161739a589c5758$export$29046b3757f0ed55(state, isVisible) {
    // Find all keypoint label objects in the scene
    const keypointLabels = state.scene.children.filter((child)=>child.name?.startsWith("keypoint-label-"));
    // Update their visibility based on showKeypointLabels state
    keypointLabels.forEach((label)=>{
        label.visible = isVisible;
    });
}


/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $2d68152abb7d3417$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $2d68152abb7d3417$var$Z_BINARY = 0;
const $2d68152abb7d3417$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $2d68152abb7d3417$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $2d68152abb7d3417$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $2d68152abb7d3417$var$STORED_BLOCK = 0;
const $2d68152abb7d3417$var$STATIC_TREES = 1;
const $2d68152abb7d3417$var$DYN_TREES = 2;
/* The three kinds of block type */ const $2d68152abb7d3417$var$MIN_MATCH$1 = 3;
const $2d68152abb7d3417$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $2d68152abb7d3417$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $2d68152abb7d3417$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $2d68152abb7d3417$var$L_CODES$1 = $2d68152abb7d3417$var$LITERALS$1 + 1 + $2d68152abb7d3417$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $2d68152abb7d3417$var$D_CODES$1 = 30;
/* number of distance codes */ const $2d68152abb7d3417$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $2d68152abb7d3417$var$HEAP_SIZE$1 = 2 * $2d68152abb7d3417$var$L_CODES$1 + 1;
/* maximum heap size */ const $2d68152abb7d3417$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $2d68152abb7d3417$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $2d68152abb7d3417$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $2d68152abb7d3417$var$END_BLOCK = 256;
/* end of block literal code */ const $2d68152abb7d3417$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $2d68152abb7d3417$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $2d68152abb7d3417$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $2d68152abb7d3417$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $2d68152abb7d3417$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $2d68152abb7d3417$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $2d68152abb7d3417$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $2d68152abb7d3417$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $2d68152abb7d3417$var$static_ltree = new Array(($2d68152abb7d3417$var$L_CODES$1 + 2) * 2);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $2d68152abb7d3417$var$static_dtree = new Array($2d68152abb7d3417$var$D_CODES$1 * 2);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $2d68152abb7d3417$var$_dist_code = new Array($2d68152abb7d3417$var$DIST_CODE_LEN);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $2d68152abb7d3417$var$_length_code = new Array($2d68152abb7d3417$var$MAX_MATCH$1 - $2d68152abb7d3417$var$MIN_MATCH$1 + 1);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $2d68152abb7d3417$var$base_length = new Array($2d68152abb7d3417$var$LENGTH_CODES$1);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $2d68152abb7d3417$var$base_dist = new Array($2d68152abb7d3417$var$D_CODES$1);
$2d68152abb7d3417$var$zero$1($2d68152abb7d3417$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $2d68152abb7d3417$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $2d68152abb7d3417$var$static_l_desc;
let $2d68152abb7d3417$var$static_d_desc;
let $2d68152abb7d3417$var$static_bl_desc;
function $2d68152abb7d3417$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $2d68152abb7d3417$var$d_code = (dist)=>{
    return dist < 256 ? $2d68152abb7d3417$var$_dist_code[dist] : $2d68152abb7d3417$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $2d68152abb7d3417$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $2d68152abb7d3417$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $2d68152abb7d3417$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $2d68152abb7d3417$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $2d68152abb7d3417$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $2d68152abb7d3417$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $2d68152abb7d3417$var$send_code = (s, c, tree)=>{
    $2d68152abb7d3417$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $2d68152abb7d3417$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $2d68152abb7d3417$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $2d68152abb7d3417$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $2d68152abb7d3417$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $2d68152abb7d3417$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $2d68152abb7d3417$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $2d68152abb7d3417$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($2d68152abb7d3417$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $2d68152abb7d3417$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $2d68152abb7d3417$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $2d68152abb7d3417$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($2d68152abb7d3417$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $2d68152abb7d3417$var$LENGTH_CODES$1 - 1; code++){
        $2d68152abb7d3417$var$base_length[code] = length;
        for(n = 0; n < 1 << $2d68152abb7d3417$var$extra_lbits[code]; n++)$2d68152abb7d3417$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $2d68152abb7d3417$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $2d68152abb7d3417$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $2d68152abb7d3417$var$extra_dbits[code]; n++)$2d68152abb7d3417$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $2d68152abb7d3417$var$D_CODES$1; code++){
        $2d68152abb7d3417$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $2d68152abb7d3417$var$extra_dbits[code] - 7; n++)$2d68152abb7d3417$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $2d68152abb7d3417$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $2d68152abb7d3417$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $2d68152abb7d3417$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $2d68152abb7d3417$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $2d68152abb7d3417$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $2d68152abb7d3417$var$gen_codes($2d68152abb7d3417$var$static_ltree, $2d68152abb7d3417$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $2d68152abb7d3417$var$D_CODES$1; n++){
        $2d68152abb7d3417$var$static_dtree[n * 2 + 1] = 5;
        $2d68152abb7d3417$var$static_dtree[n * 2] = $2d68152abb7d3417$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $2d68152abb7d3417$var$static_l_desc = new $2d68152abb7d3417$var$StaticTreeDesc($2d68152abb7d3417$var$static_ltree, $2d68152abb7d3417$var$extra_lbits, $2d68152abb7d3417$var$LITERALS$1 + 1, $2d68152abb7d3417$var$L_CODES$1, $2d68152abb7d3417$var$MAX_BITS$1);
    $2d68152abb7d3417$var$static_d_desc = new $2d68152abb7d3417$var$StaticTreeDesc($2d68152abb7d3417$var$static_dtree, $2d68152abb7d3417$var$extra_dbits, 0, $2d68152abb7d3417$var$D_CODES$1, $2d68152abb7d3417$var$MAX_BITS$1);
    $2d68152abb7d3417$var$static_bl_desc = new $2d68152abb7d3417$var$StaticTreeDesc(new Array(0), $2d68152abb7d3417$var$extra_blbits, 0, $2d68152abb7d3417$var$BL_CODES$1, $2d68152abb7d3417$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $2d68152abb7d3417$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $2d68152abb7d3417$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $2d68152abb7d3417$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $2d68152abb7d3417$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$2d68152abb7d3417$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $2d68152abb7d3417$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $2d68152abb7d3417$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $2d68152abb7d3417$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $2d68152abb7d3417$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $2d68152abb7d3417$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($2d68152abb7d3417$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $2d68152abb7d3417$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $2d68152abb7d3417$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $2d68152abb7d3417$var$_length_code[lc];
            $2d68152abb7d3417$var$send_code(s, code + $2d68152abb7d3417$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $2d68152abb7d3417$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $2d68152abb7d3417$var$base_length[code];
                $2d68152abb7d3417$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $2d68152abb7d3417$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $2d68152abb7d3417$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $2d68152abb7d3417$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $2d68152abb7d3417$var$base_dist[code];
                $2d68152abb7d3417$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $2d68152abb7d3417$var$send_code(s, $2d68152abb7d3417$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $2d68152abb7d3417$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $2d68152abb7d3417$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$2d68152abb7d3417$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $2d68152abb7d3417$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $2d68152abb7d3417$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $2d68152abb7d3417$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $2d68152abb7d3417$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $2d68152abb7d3417$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$2d68152abb7d3417$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$2d68152abb7d3417$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$2d68152abb7d3417$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $2d68152abb7d3417$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $2d68152abb7d3417$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $2d68152abb7d3417$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $2d68152abb7d3417$var$send_code(s, $2d68152abb7d3417$var$REP_3_6, s.bl_tree);
            $2d68152abb7d3417$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $2d68152abb7d3417$var$send_code(s, $2d68152abb7d3417$var$REPZ_3_10, s.bl_tree);
            $2d68152abb7d3417$var$send_bits(s, count - 3, 3);
        } else {
            $2d68152abb7d3417$var$send_code(s, $2d68152abb7d3417$var$REPZ_11_138, s.bl_tree);
            $2d68152abb7d3417$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $2d68152abb7d3417$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $2d68152abb7d3417$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $2d68152abb7d3417$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $2d68152abb7d3417$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $2d68152abb7d3417$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$2d68152abb7d3417$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $2d68152abb7d3417$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $2d68152abb7d3417$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $2d68152abb7d3417$var$send_bits(s, dcodes - 1, 5);
    $2d68152abb7d3417$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $2d68152abb7d3417$var$send_bits(s, s.bl_tree[$2d68152abb7d3417$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $2d68152abb7d3417$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $2d68152abb7d3417$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $2d68152abb7d3417$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $2d68152abb7d3417$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $2d68152abb7d3417$var$Z_TEXT;
    for(n = 32; n < $2d68152abb7d3417$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $2d68152abb7d3417$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $2d68152abb7d3417$var$Z_BINARY;
};
let $2d68152abb7d3417$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $2d68152abb7d3417$var$_tr_init$1 = (s)=>{
    if (!$2d68152abb7d3417$var$static_init_done) {
        $2d68152abb7d3417$var$tr_static_init();
        $2d68152abb7d3417$var$static_init_done = true;
    }
    s.l_desc = new $2d68152abb7d3417$var$TreeDesc(s.dyn_ltree, $2d68152abb7d3417$var$static_l_desc);
    s.d_desc = new $2d68152abb7d3417$var$TreeDesc(s.dyn_dtree, $2d68152abb7d3417$var$static_d_desc);
    s.bl_desc = new $2d68152abb7d3417$var$TreeDesc(s.bl_tree, $2d68152abb7d3417$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $2d68152abb7d3417$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $2d68152abb7d3417$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $2d68152abb7d3417$var$send_bits(s, ($2d68152abb7d3417$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $2d68152abb7d3417$var$bi_windup(s); /* align on byte boundary */ 
    $2d68152abb7d3417$var$put_short(s, stored_len);
    $2d68152abb7d3417$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $2d68152abb7d3417$var$_tr_align$1 = (s)=>{
    $2d68152abb7d3417$var$send_bits(s, $2d68152abb7d3417$var$STATIC_TREES << 1, 3);
    $2d68152abb7d3417$var$send_code(s, $2d68152abb7d3417$var$END_BLOCK, $2d68152abb7d3417$var$static_ltree);
    $2d68152abb7d3417$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $2d68152abb7d3417$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $2d68152abb7d3417$var$Z_UNKNOWN$1) s.strm.data_type = $2d68152abb7d3417$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $2d68152abb7d3417$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $2d68152abb7d3417$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $2d68152abb7d3417$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $2d68152abb7d3417$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $2d68152abb7d3417$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $2d68152abb7d3417$var$send_bits(s, ($2d68152abb7d3417$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $2d68152abb7d3417$var$compress_block(s, $2d68152abb7d3417$var$static_ltree, $2d68152abb7d3417$var$static_dtree);
    } else {
        $2d68152abb7d3417$var$send_bits(s, ($2d68152abb7d3417$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $2d68152abb7d3417$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $2d68152abb7d3417$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $2d68152abb7d3417$var$init_block(s);
    if (last) $2d68152abb7d3417$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $2d68152abb7d3417$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($2d68152abb7d3417$var$_length_code[lc] + $2d68152abb7d3417$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$2d68152abb7d3417$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $2d68152abb7d3417$var$_tr_init_1 = $2d68152abb7d3417$var$_tr_init$1;
var $2d68152abb7d3417$var$_tr_stored_block_1 = $2d68152abb7d3417$var$_tr_stored_block$1;
var $2d68152abb7d3417$var$_tr_flush_block_1 = $2d68152abb7d3417$var$_tr_flush_block$1;
var $2d68152abb7d3417$var$_tr_tally_1 = $2d68152abb7d3417$var$_tr_tally$1;
var $2d68152abb7d3417$var$_tr_align_1 = $2d68152abb7d3417$var$_tr_align$1;
var $2d68152abb7d3417$var$trees = {
    _tr_init: $2d68152abb7d3417$var$_tr_init_1,
    _tr_stored_block: $2d68152abb7d3417$var$_tr_stored_block_1,
    _tr_flush_block: $2d68152abb7d3417$var$_tr_flush_block_1,
    _tr_tally: $2d68152abb7d3417$var$_tr_tally_1,
    _tr_align: $2d68152abb7d3417$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2d68152abb7d3417$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $2d68152abb7d3417$var$adler32_1 = $2d68152abb7d3417$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $2d68152abb7d3417$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $2d68152abb7d3417$var$crcTable = new Uint32Array($2d68152abb7d3417$var$makeTable());
const $2d68152abb7d3417$var$crc32 = (crc, buf, len, pos)=>{
    const t = $2d68152abb7d3417$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $2d68152abb7d3417$var$crc32_1 = $2d68152abb7d3417$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $2d68152abb7d3417$var$messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $2d68152abb7d3417$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $2d68152abb7d3417$var$_tr_init, _tr_stored_block: $2d68152abb7d3417$var$_tr_stored_block, _tr_flush_block: $2d68152abb7d3417$var$_tr_flush_block, _tr_tally: $2d68152abb7d3417$var$_tr_tally, _tr_align: $2d68152abb7d3417$var$_tr_align } = $2d68152abb7d3417$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2d68152abb7d3417$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $2d68152abb7d3417$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $2d68152abb7d3417$var$Z_FULL_FLUSH$1, Z_FINISH: $2d68152abb7d3417$var$Z_FINISH$3, Z_BLOCK: $2d68152abb7d3417$var$Z_BLOCK$1, Z_OK: $2d68152abb7d3417$var$Z_OK$3, Z_STREAM_END: $2d68152abb7d3417$var$Z_STREAM_END$3, Z_STREAM_ERROR: $2d68152abb7d3417$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $2d68152abb7d3417$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $2d68152abb7d3417$var$Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: $2d68152abb7d3417$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $2d68152abb7d3417$var$Z_FILTERED, Z_HUFFMAN_ONLY: $2d68152abb7d3417$var$Z_HUFFMAN_ONLY, Z_RLE: $2d68152abb7d3417$var$Z_RLE, Z_FIXED: $2d68152abb7d3417$var$Z_FIXED, Z_DEFAULT_STRATEGY: $2d68152abb7d3417$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $2d68152abb7d3417$var$Z_UNKNOWN, Z_DEFLATED: $2d68152abb7d3417$var$Z_DEFLATED$2 } = $2d68152abb7d3417$var$constants$2;
/*============================================================================*/ const $2d68152abb7d3417$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $2d68152abb7d3417$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $2d68152abb7d3417$var$DEF_MEM_LEVEL = 8;
const $2d68152abb7d3417$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $2d68152abb7d3417$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $2d68152abb7d3417$var$L_CODES = $2d68152abb7d3417$var$LITERALS + 1 + $2d68152abb7d3417$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $2d68152abb7d3417$var$D_CODES = 30;
/* number of distance codes */ const $2d68152abb7d3417$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $2d68152abb7d3417$var$HEAP_SIZE = 2 * $2d68152abb7d3417$var$L_CODES + 1;
/* maximum heap size */ const $2d68152abb7d3417$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $2d68152abb7d3417$var$MIN_MATCH = 3;
const $2d68152abb7d3417$var$MAX_MATCH = 258;
const $2d68152abb7d3417$var$MIN_LOOKAHEAD = $2d68152abb7d3417$var$MAX_MATCH + $2d68152abb7d3417$var$MIN_MATCH + 1;
const $2d68152abb7d3417$var$PRESET_DICT = 0x20;
const $2d68152abb7d3417$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $2d68152abb7d3417$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $2d68152abb7d3417$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $2d68152abb7d3417$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $2d68152abb7d3417$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $2d68152abb7d3417$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $2d68152abb7d3417$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $2d68152abb7d3417$var$FINISH_STATE = 666; /* stream complete */ 
const $2d68152abb7d3417$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $2d68152abb7d3417$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $2d68152abb7d3417$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $2d68152abb7d3417$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $2d68152abb7d3417$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $2d68152abb7d3417$var$err = (strm, errorCode)=>{
    strm.msg = $2d68152abb7d3417$var$messages[errorCode];
    return errorCode;
};
const $2d68152abb7d3417$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $2d68152abb7d3417$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $2d68152abb7d3417$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $2d68152abb7d3417$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $2d68152abb7d3417$var$HASH = $2d68152abb7d3417$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $2d68152abb7d3417$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $2d68152abb7d3417$var$flush_block_only = (s, last)=>{
    $2d68152abb7d3417$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $2d68152abb7d3417$var$flush_pending(s.strm);
};
const $2d68152abb7d3417$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $2d68152abb7d3417$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $2d68152abb7d3417$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $2d68152abb7d3417$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $2d68152abb7d3417$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $2d68152abb7d3417$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $2d68152abb7d3417$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $2d68152abb7d3417$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $2d68152abb7d3417$var$MAX_MATCH - (strend - scan);
        scan = strend - $2d68152abb7d3417$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $2d68152abb7d3417$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $2d68152abb7d3417$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $2d68152abb7d3417$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $2d68152abb7d3417$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $2d68152abb7d3417$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[str + $2d68152abb7d3417$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $2d68152abb7d3417$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $2d68152abb7d3417$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $2d68152abb7d3417$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $2d68152abb7d3417$var$Z_FINISH$3 || flush === $2d68152abb7d3417$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $2d68152abb7d3417$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $2d68152abb7d3417$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $2d68152abb7d3417$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $2d68152abb7d3417$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $2d68152abb7d3417$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $2d68152abb7d3417$var$Z_NO_FLUSH$2 && flush !== $2d68152abb7d3417$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $2d68152abb7d3417$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $2d68152abb7d3417$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $2d68152abb7d3417$var$Z_FINISH$3) && flush !== $2d68152abb7d3417$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $2d68152abb7d3417$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $2d68152abb7d3417$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $2d68152abb7d3417$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $2d68152abb7d3417$var$BS_FINISH_STARTED : $2d68152abb7d3417$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $2d68152abb7d3417$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $2d68152abb7d3417$var$MIN_LOOKAHEAD) {
            $2d68152abb7d3417$var$fill_window(s);
            if (s.lookahead < $2d68152abb7d3417$var$MIN_LOOKAHEAD && flush === $2d68152abb7d3417$var$Z_NO_FLUSH$2) return $2d68152abb7d3417$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $2d68152abb7d3417$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[s.strstart + $2d68152abb7d3417$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $2d68152abb7d3417$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $2d68152abb7d3417$var$longest_match(s, hash_head);
        if (s.match_length >= $2d68152abb7d3417$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $2d68152abb7d3417$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $2d68152abb7d3417$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[s.strstart + $2d68152abb7d3417$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $2d68152abb7d3417$var$MIN_MATCH - 1 ? s.strstart : $2d68152abb7d3417$var$MIN_MATCH - 1;
    if (flush === $2d68152abb7d3417$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2d68152abb7d3417$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_FINISH_STARTED;
        /***/ return $2d68152abb7d3417$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
    /***/ }
    return $2d68152abb7d3417$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $2d68152abb7d3417$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $2d68152abb7d3417$var$MIN_LOOKAHEAD) {
            $2d68152abb7d3417$var$fill_window(s);
            if (s.lookahead < $2d68152abb7d3417$var$MIN_LOOKAHEAD && flush === $2d68152abb7d3417$var$Z_NO_FLUSH$2) return $2d68152abb7d3417$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $2d68152abb7d3417$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[s.strstart + $2d68152abb7d3417$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $2d68152abb7d3417$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $2d68152abb7d3417$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $2d68152abb7d3417$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $2d68152abb7d3417$var$Z_FILTERED || s.match_length === $2d68152abb7d3417$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $2d68152abb7d3417$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $2d68152abb7d3417$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $2d68152abb7d3417$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $2d68152abb7d3417$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[s.strstart + $2d68152abb7d3417$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $2d68152abb7d3417$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $2d68152abb7d3417$var$MIN_MATCH - 1 ? s.strstart : $2d68152abb7d3417$var$MIN_MATCH - 1;
    if (flush === $2d68152abb7d3417$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2d68152abb7d3417$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_FINISH_STARTED;
        /***/ return $2d68152abb7d3417$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
    /***/ }
    return $2d68152abb7d3417$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $2d68152abb7d3417$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $2d68152abb7d3417$var$MAX_MATCH) {
            $2d68152abb7d3417$var$fill_window(s);
            if (s.lookahead <= $2d68152abb7d3417$var$MAX_MATCH && flush === $2d68152abb7d3417$var$Z_NO_FLUSH$2) return $2d68152abb7d3417$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $2d68152abb7d3417$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $2d68152abb7d3417$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $2d68152abb7d3417$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $2d68152abb7d3417$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 1, s.match_length - $2d68152abb7d3417$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $2d68152abb7d3417$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2d68152abb7d3417$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_FINISH_STARTED;
        /***/ return $2d68152abb7d3417$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
    /***/ }
    return $2d68152abb7d3417$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $2d68152abb7d3417$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $2d68152abb7d3417$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $2d68152abb7d3417$var$Z_NO_FLUSH$2) return $2d68152abb7d3417$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2d68152abb7d3417$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $2d68152abb7d3417$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2d68152abb7d3417$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_FINISH_STARTED;
        /***/ return $2d68152abb7d3417$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2d68152abb7d3417$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2d68152abb7d3417$var$BS_NEED_MORE;
    /***/ }
    return $2d68152abb7d3417$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $2d68152abb7d3417$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $2d68152abb7d3417$var$configuration_table = [
    /*      good lazy nice chain */ new $2d68152abb7d3417$var$Config(0, 0, 0, 0, $2d68152abb7d3417$var$deflate_stored),
    /* 0 store only */ new $2d68152abb7d3417$var$Config(4, 4, 8, 4, $2d68152abb7d3417$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $2d68152abb7d3417$var$Config(4, 5, 16, 8, $2d68152abb7d3417$var$deflate_fast),
    /* 2 */ new $2d68152abb7d3417$var$Config(4, 6, 32, 32, $2d68152abb7d3417$var$deflate_fast),
    /* 3 */ new $2d68152abb7d3417$var$Config(4, 4, 16, 16, $2d68152abb7d3417$var$deflate_slow),
    /* 4 lazy matches */ new $2d68152abb7d3417$var$Config(8, 16, 32, 32, $2d68152abb7d3417$var$deflate_slow),
    /* 5 */ new $2d68152abb7d3417$var$Config(8, 16, 128, 128, $2d68152abb7d3417$var$deflate_slow),
    /* 6 */ new $2d68152abb7d3417$var$Config(8, 32, 128, 256, $2d68152abb7d3417$var$deflate_slow),
    /* 7 */ new $2d68152abb7d3417$var$Config(32, 128, 258, 1024, $2d68152abb7d3417$var$deflate_slow),
    /* 8 */ new $2d68152abb7d3417$var$Config(32, 258, 258, 4096, $2d68152abb7d3417$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $2d68152abb7d3417$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $2d68152abb7d3417$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $2d68152abb7d3417$var$configuration_table[s.level].max_lazy;
    s.good_match = $2d68152abb7d3417$var$configuration_table[s.level].good_length;
    s.nice_match = $2d68152abb7d3417$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $2d68152abb7d3417$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $2d68152abb7d3417$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $2d68152abb7d3417$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $2d68152abb7d3417$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($2d68152abb7d3417$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $2d68152abb7d3417$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $2d68152abb7d3417$var$BL_CODES + 1) * 2);
    $2d68152abb7d3417$var$zero(this.dyn_ltree);
    $2d68152abb7d3417$var$zero(this.dyn_dtree);
    $2d68152abb7d3417$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($2d68152abb7d3417$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $2d68152abb7d3417$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $2d68152abb7d3417$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $2d68152abb7d3417$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $2d68152abb7d3417$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $2d68152abb7d3417$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $2d68152abb7d3417$var$INIT_STATE && //#ifdef GZIP
    s.status !== $2d68152abb7d3417$var$GZIP_STATE && //#endif
    s.status !== $2d68152abb7d3417$var$EXTRA_STATE && s.status !== $2d68152abb7d3417$var$NAME_STATE && s.status !== $2d68152abb7d3417$var$COMMENT_STATE && s.status !== $2d68152abb7d3417$var$HCRC_STATE && s.status !== $2d68152abb7d3417$var$BUSY_STATE && s.status !== $2d68152abb7d3417$var$FINISH_STATE) return 1;
    return 0;
};
const $2d68152abb7d3417$var$deflateResetKeep = (strm)=>{
    if ($2d68152abb7d3417$var$deflateStateCheck(strm)) return $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $2d68152abb7d3417$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $2d68152abb7d3417$var$GZIP_STATE : //#endif
    s.wrap ? $2d68152abb7d3417$var$INIT_STATE : $2d68152abb7d3417$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $2d68152abb7d3417$var$_tr_init(s);
    return $2d68152abb7d3417$var$Z_OK$3;
};
const $2d68152abb7d3417$var$deflateReset = (strm)=>{
    const ret = $2d68152abb7d3417$var$deflateResetKeep(strm);
    if (ret === $2d68152abb7d3417$var$Z_OK$3) $2d68152abb7d3417$var$lm_init(strm.state);
    return ret;
};
const $2d68152abb7d3417$var$deflateSetHeader = (strm, head)=>{
    if ($2d68152abb7d3417$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $2d68152abb7d3417$var$Z_OK$3;
};
const $2d68152abb7d3417$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $2d68152abb7d3417$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $2d68152abb7d3417$var$MAX_MEM_LEVEL || method !== $2d68152abb7d3417$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $2d68152abb7d3417$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $2d68152abb7d3417$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $2d68152abb7d3417$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $2d68152abb7d3417$var$MIN_MATCH - 1) / $2d68152abb7d3417$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $2d68152abb7d3417$var$deflateReset(strm);
};
const $2d68152abb7d3417$var$deflateInit = (strm, level)=>{
    return $2d68152abb7d3417$var$deflateInit2(strm, level, $2d68152abb7d3417$var$Z_DEFLATED$2, $2d68152abb7d3417$var$MAX_WBITS$1, $2d68152abb7d3417$var$DEF_MEM_LEVEL, $2d68152abb7d3417$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $2d68152abb7d3417$var$deflate$2 = (strm, flush)=>{
    if ($2d68152abb7d3417$var$deflateStateCheck(strm) || flush > $2d68152abb7d3417$var$Z_BLOCK$1 || flush < 0) return strm ? $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_STREAM_ERROR$2) : $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $2d68152abb7d3417$var$FINISH_STATE && flush !== $2d68152abb7d3417$var$Z_FINISH$3) return $2d68152abb7d3417$var$err(strm, strm.avail_out === 0 ? $2d68152abb7d3417$var$Z_BUF_ERROR$1 : $2d68152abb7d3417$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $2d68152abb7d3417$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $2d68152abb7d3417$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $2d68152abb7d3417$var$rank(flush) <= $2d68152abb7d3417$var$rank(old_flush) && flush !== $2d68152abb7d3417$var$Z_FINISH$3) return $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $2d68152abb7d3417$var$FINISH_STATE && strm.avail_in !== 0) return $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $2d68152abb7d3417$var$INIT_STATE && s.wrap === 0) s.status = $2d68152abb7d3417$var$BUSY_STATE;
    if (s.status === $2d68152abb7d3417$var$INIT_STATE) {
        /* zlib header */ let header = $2d68152abb7d3417$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $2d68152abb7d3417$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $2d68152abb7d3417$var$PRESET_DICT;
        header += 31 - header % 31;
        $2d68152abb7d3417$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $2d68152abb7d3417$var$putShortMSB(s, strm.adler >>> 16);
            $2d68152abb7d3417$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $2d68152abb7d3417$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $2d68152abb7d3417$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $2d68152abb7d3417$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $2d68152abb7d3417$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $2d68152abb7d3417$var$put_byte(s, 31);
        $2d68152abb7d3417$var$put_byte(s, 139);
        $2d68152abb7d3417$var$put_byte(s, 8);
        if (!s.gzhead) {
            $2d68152abb7d3417$var$put_byte(s, 0);
            $2d68152abb7d3417$var$put_byte(s, 0);
            $2d68152abb7d3417$var$put_byte(s, 0);
            $2d68152abb7d3417$var$put_byte(s, 0);
            $2d68152abb7d3417$var$put_byte(s, 0);
            $2d68152abb7d3417$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $2d68152abb7d3417$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $2d68152abb7d3417$var$put_byte(s, $2d68152abb7d3417$var$OS_CODE);
            s.status = $2d68152abb7d3417$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $2d68152abb7d3417$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $2d68152abb7d3417$var$Z_OK$3;
            }
        } else {
            $2d68152abb7d3417$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $2d68152abb7d3417$var$put_byte(s, s.gzhead.time & 0xff);
            $2d68152abb7d3417$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $2d68152abb7d3417$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $2d68152abb7d3417$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $2d68152abb7d3417$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $2d68152abb7d3417$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $2d68152abb7d3417$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $2d68152abb7d3417$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $2d68152abb7d3417$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $2d68152abb7d3417$var$EXTRA_STATE;
        }
    }
    if (s.status === $2d68152abb7d3417$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $2d68152abb7d3417$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $2d68152abb7d3417$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $2d68152abb7d3417$var$NAME_STATE;
    }
    if (s.status === $2d68152abb7d3417$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $2d68152abb7d3417$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $2d68152abb7d3417$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $2d68152abb7d3417$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $2d68152abb7d3417$var$COMMENT_STATE;
    }
    if (s.status === $2d68152abb7d3417$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $2d68152abb7d3417$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $2d68152abb7d3417$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $2d68152abb7d3417$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2d68152abb7d3417$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $2d68152abb7d3417$var$HCRC_STATE;
    }
    if (s.status === $2d68152abb7d3417$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $2d68152abb7d3417$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $2d68152abb7d3417$var$Z_OK$3;
                }
            }
            $2d68152abb7d3417$var$put_byte(s, strm.adler & 0xff);
            $2d68152abb7d3417$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $2d68152abb7d3417$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $2d68152abb7d3417$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $2d68152abb7d3417$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $2d68152abb7d3417$var$Z_NO_FLUSH$2 && s.status !== $2d68152abb7d3417$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $2d68152abb7d3417$var$deflate_stored(s, flush) : s.strategy === $2d68152abb7d3417$var$Z_HUFFMAN_ONLY ? $2d68152abb7d3417$var$deflate_huff(s, flush) : s.strategy === $2d68152abb7d3417$var$Z_RLE ? $2d68152abb7d3417$var$deflate_rle(s, flush) : $2d68152abb7d3417$var$configuration_table[s.level].func(s, flush);
        if (bstate === $2d68152abb7d3417$var$BS_FINISH_STARTED || bstate === $2d68152abb7d3417$var$BS_FINISH_DONE) s.status = $2d68152abb7d3417$var$FINISH_STATE;
        if (bstate === $2d68152abb7d3417$var$BS_NEED_MORE || bstate === $2d68152abb7d3417$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $2d68152abb7d3417$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $2d68152abb7d3417$var$BS_BLOCK_DONE) {
            if (flush === $2d68152abb7d3417$var$Z_PARTIAL_FLUSH) $2d68152abb7d3417$var$_tr_align(s);
            else if (flush !== $2d68152abb7d3417$var$Z_BLOCK$1) {
                $2d68152abb7d3417$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $2d68152abb7d3417$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $2d68152abb7d3417$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $2d68152abb7d3417$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $2d68152abb7d3417$var$Z_OK$3;
            }
        }
    }
    if (flush !== $2d68152abb7d3417$var$Z_FINISH$3) return $2d68152abb7d3417$var$Z_OK$3;
    if (s.wrap <= 0) return $2d68152abb7d3417$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $2d68152abb7d3417$var$put_byte(s, strm.adler & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.adler >> 8 & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.adler >> 16 & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.adler >> 24 & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.total_in & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $2d68152abb7d3417$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $2d68152abb7d3417$var$putShortMSB(s, strm.adler >>> 16);
        $2d68152abb7d3417$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $2d68152abb7d3417$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $2d68152abb7d3417$var$Z_OK$3 : $2d68152abb7d3417$var$Z_STREAM_END$3;
};
const $2d68152abb7d3417$var$deflateEnd = (strm)=>{
    if ($2d68152abb7d3417$var$deflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $2d68152abb7d3417$var$BUSY_STATE ? $2d68152abb7d3417$var$err(strm, $2d68152abb7d3417$var$Z_DATA_ERROR$2) : $2d68152abb7d3417$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $2d68152abb7d3417$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($2d68152abb7d3417$var$deflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $2d68152abb7d3417$var$INIT_STATE || s.lookahead) return $2d68152abb7d3417$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $2d68152abb7d3417$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $2d68152abb7d3417$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $2d68152abb7d3417$var$fill_window(s);
    while(s.lookahead >= $2d68152abb7d3417$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($2d68152abb7d3417$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $2d68152abb7d3417$var$HASH(s, s.ins_h, s.window[str + $2d68152abb7d3417$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $2d68152abb7d3417$var$MIN_MATCH - 1;
        $2d68152abb7d3417$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $2d68152abb7d3417$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $2d68152abb7d3417$var$Z_OK$3;
};
var $2d68152abb7d3417$var$deflateInit_1 = $2d68152abb7d3417$var$deflateInit;
var $2d68152abb7d3417$var$deflateInit2_1 = $2d68152abb7d3417$var$deflateInit2;
var $2d68152abb7d3417$var$deflateReset_1 = $2d68152abb7d3417$var$deflateReset;
var $2d68152abb7d3417$var$deflateResetKeep_1 = $2d68152abb7d3417$var$deflateResetKeep;
var $2d68152abb7d3417$var$deflateSetHeader_1 = $2d68152abb7d3417$var$deflateSetHeader;
var $2d68152abb7d3417$var$deflate_2$1 = $2d68152abb7d3417$var$deflate$2;
var $2d68152abb7d3417$var$deflateEnd_1 = $2d68152abb7d3417$var$deflateEnd;
var $2d68152abb7d3417$var$deflateSetDictionary_1 = $2d68152abb7d3417$var$deflateSetDictionary;
var $2d68152abb7d3417$var$deflateInfo = "pako deflate (from Nodeca project)";
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $2d68152abb7d3417$var$deflate_1$2 = {
    deflateInit: $2d68152abb7d3417$var$deflateInit_1,
    deflateInit2: $2d68152abb7d3417$var$deflateInit2_1,
    deflateReset: $2d68152abb7d3417$var$deflateReset_1,
    deflateResetKeep: $2d68152abb7d3417$var$deflateResetKeep_1,
    deflateSetHeader: $2d68152abb7d3417$var$deflateSetHeader_1,
    deflate: $2d68152abb7d3417$var$deflate_2$1,
    deflateEnd: $2d68152abb7d3417$var$deflateEnd_1,
    deflateSetDictionary: $2d68152abb7d3417$var$deflateSetDictionary_1,
    deflateInfo: $2d68152abb7d3417$var$deflateInfo
};
const $2d68152abb7d3417$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $2d68152abb7d3417$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(const p in source)if ($2d68152abb7d3417$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $2d68152abb7d3417$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $2d68152abb7d3417$var$common = {
    assign: $2d68152abb7d3417$var$assign,
    flattenChunks: $2d68152abb7d3417$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $2d68152abb7d3417$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $2d68152abb7d3417$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $2d68152abb7d3417$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$2d68152abb7d3417$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$2d68152abb7d3417$var$_utf8len[254] = $2d68152abb7d3417$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $2d68152abb7d3417$var$string2buf = (str)=>{
    if (typeof TextEncoder === "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $2d68152abb7d3417$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $2d68152abb7d3417$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = "";
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $2d68152abb7d3417$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $2d68152abb7d3417$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $2d68152abb7d3417$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $2d68152abb7d3417$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $2d68152abb7d3417$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $2d68152abb7d3417$var$strings = {
    string2buf: $2d68152abb7d3417$var$string2buf,
    buf2string: $2d68152abb7d3417$var$buf2string,
    utf8border: $2d68152abb7d3417$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $2d68152abb7d3417$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $2d68152abb7d3417$var$zstream = $2d68152abb7d3417$var$ZStream;
const $2d68152abb7d3417$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2d68152abb7d3417$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $2d68152abb7d3417$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $2d68152abb7d3417$var$Z_FULL_FLUSH, Z_FINISH: $2d68152abb7d3417$var$Z_FINISH$2, Z_OK: $2d68152abb7d3417$var$Z_OK$2, Z_STREAM_END: $2d68152abb7d3417$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $2d68152abb7d3417$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $2d68152abb7d3417$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $2d68152abb7d3417$var$Z_DEFLATED$1 } = $2d68152abb7d3417$var$constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $2d68152abb7d3417$var$Deflate$1(options) {
    this.options = $2d68152abb7d3417$var$common.assign({
        level: $2d68152abb7d3417$var$Z_DEFAULT_COMPRESSION,
        method: $2d68152abb7d3417$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $2d68152abb7d3417$var$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $2d68152abb7d3417$var$zstream();
    this.strm.avail_out = 0;
    let status = $2d68152abb7d3417$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $2d68152abb7d3417$var$Z_OK$2) throw new Error($2d68152abb7d3417$var$messages[status]);
    if (opt.header) $2d68152abb7d3417$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $2d68152abb7d3417$var$strings.string2buf(opt.dictionary);
        else if ($2d68152abb7d3417$var$toString$1.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $2d68152abb7d3417$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $2d68152abb7d3417$var$Z_OK$2) throw new Error($2d68152abb7d3417$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2d68152abb7d3417$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2d68152abb7d3417$var$Z_FINISH$2 : $2d68152abb7d3417$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $2d68152abb7d3417$var$strings.string2buf(data);
    else if ($2d68152abb7d3417$var$toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $2d68152abb7d3417$var$Z_SYNC_FLUSH || _flush_mode === $2d68152abb7d3417$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $2d68152abb7d3417$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $2d68152abb7d3417$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $2d68152abb7d3417$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $2d68152abb7d3417$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2d68152abb7d3417$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2d68152abb7d3417$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2d68152abb7d3417$var$Z_OK$2) this.result = $2d68152abb7d3417$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $2d68152abb7d3417$var$deflate$1(input, options) {
    const deflator = new $2d68152abb7d3417$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $2d68152abb7d3417$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2d68152abb7d3417$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $2d68152abb7d3417$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $2d68152abb7d3417$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $2d68152abb7d3417$var$deflate$1(input, options);
}
var $2d68152abb7d3417$var$Deflate_1$1 = $2d68152abb7d3417$var$Deflate$1;
var $2d68152abb7d3417$var$deflate_2 = $2d68152abb7d3417$var$deflate$1;
var $2d68152abb7d3417$var$deflateRaw_1$1 = $2d68152abb7d3417$var$deflateRaw$1;
var $2d68152abb7d3417$var$gzip_1$1 = $2d68152abb7d3417$var$gzip$1;
var $2d68152abb7d3417$var$constants$1 = $2d68152abb7d3417$var$constants$2;
var $2d68152abb7d3417$var$deflate_1$1 = {
    Deflate: $2d68152abb7d3417$var$Deflate_1$1,
    deflate: $2d68152abb7d3417$var$deflate_2,
    deflateRaw: $2d68152abb7d3417$var$deflateRaw_1$1,
    gzip: $2d68152abb7d3417$var$gzip_1$1,
    constants: $2d68152abb7d3417$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $2d68152abb7d3417$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $2d68152abb7d3417$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $2d68152abb7d3417$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $2d68152abb7d3417$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $2d68152abb7d3417$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $2d68152abb7d3417$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $2d68152abb7d3417$var$TYPE$1;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $2d68152abb7d3417$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2d68152abb7d3417$var$MAXBITS = 15;
const $2d68152abb7d3417$var$ENOUGH_LENS$1 = 852;
const $2d68152abb7d3417$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $2d68152abb7d3417$var$CODES$1 = 0;
const $2d68152abb7d3417$var$LENS$1 = 1;
const $2d68152abb7d3417$var$DISTS$1 = 2;
const $2d68152abb7d3417$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $2d68152abb7d3417$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $2d68152abb7d3417$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $2d68152abb7d3417$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $2d68152abb7d3417$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($2d68152abb7d3417$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($2d68152abb7d3417$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $2d68152abb7d3417$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $2d68152abb7d3417$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $2d68152abb7d3417$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $2d68152abb7d3417$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $2d68152abb7d3417$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $2d68152abb7d3417$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $2d68152abb7d3417$var$LENS$1) {
        base = $2d68152abb7d3417$var$lbase;
        extra = $2d68152abb7d3417$var$lext;
        match = 257;
    } else {
        base = $2d68152abb7d3417$var$dbase;
        extra = $2d68152abb7d3417$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $2d68152abb7d3417$var$LENS$1 && used > $2d68152abb7d3417$var$ENOUGH_LENS$1 || type === $2d68152abb7d3417$var$DISTS$1 && used > $2d68152abb7d3417$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $2d68152abb7d3417$var$LENS$1 && used > $2d68152abb7d3417$var$ENOUGH_LENS$1 || type === $2d68152abb7d3417$var$DISTS$1 && used > $2d68152abb7d3417$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $2d68152abb7d3417$var$inftrees = $2d68152abb7d3417$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2d68152abb7d3417$var$CODES = 0;
const $2d68152abb7d3417$var$LENS = 1;
const $2d68152abb7d3417$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $2d68152abb7d3417$var$Z_FINISH$1, Z_BLOCK: $2d68152abb7d3417$var$Z_BLOCK, Z_TREES: $2d68152abb7d3417$var$Z_TREES, Z_OK: $2d68152abb7d3417$var$Z_OK$1, Z_STREAM_END: $2d68152abb7d3417$var$Z_STREAM_END$1, Z_NEED_DICT: $2d68152abb7d3417$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $2d68152abb7d3417$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $2d68152abb7d3417$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $2d68152abb7d3417$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $2d68152abb7d3417$var$Z_BUF_ERROR, Z_DEFLATED: $2d68152abb7d3417$var$Z_DEFLATED } = $2d68152abb7d3417$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $2d68152abb7d3417$var$HEAD = 16180; /* i: waiting for magic header */ 
const $2d68152abb7d3417$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $2d68152abb7d3417$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $2d68152abb7d3417$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $2d68152abb7d3417$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $2d68152abb7d3417$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $2d68152abb7d3417$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $2d68152abb7d3417$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $2d68152abb7d3417$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $2d68152abb7d3417$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $2d68152abb7d3417$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $2d68152abb7d3417$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $2d68152abb7d3417$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $2d68152abb7d3417$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $2d68152abb7d3417$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $2d68152abb7d3417$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $2d68152abb7d3417$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $2d68152abb7d3417$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $2d68152abb7d3417$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $2d68152abb7d3417$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $2d68152abb7d3417$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $2d68152abb7d3417$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $2d68152abb7d3417$var$DIST = 16202; /* i: waiting for distance code */ 
const $2d68152abb7d3417$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $2d68152abb7d3417$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $2d68152abb7d3417$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $2d68152abb7d3417$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $2d68152abb7d3417$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $2d68152abb7d3417$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $2d68152abb7d3417$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $2d68152abb7d3417$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $2d68152abb7d3417$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $2d68152abb7d3417$var$ENOUGH_LENS = 852;
const $2d68152abb7d3417$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $2d68152abb7d3417$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $2d68152abb7d3417$var$DEF_WBITS = $2d68152abb7d3417$var$MAX_WBITS;
const $2d68152abb7d3417$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $2d68152abb7d3417$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $2d68152abb7d3417$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $2d68152abb7d3417$var$HEAD || state.mode > $2d68152abb7d3417$var$SYNC) return 1;
    return 0;
};
const $2d68152abb7d3417$var$inflateResetKeep = (strm)=>{
    if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $2d68152abb7d3417$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($2d68152abb7d3417$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($2d68152abb7d3417$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $2d68152abb7d3417$var$Z_OK$1;
};
const $2d68152abb7d3417$var$inflateReset = (strm)=>{
    if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $2d68152abb7d3417$var$inflateResetKeep(strm);
};
const $2d68152abb7d3417$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $2d68152abb7d3417$var$inflateReset(strm);
};
const $2d68152abb7d3417$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $2d68152abb7d3417$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $2d68152abb7d3417$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $2d68152abb7d3417$var$inflateReset2(strm, windowBits);
    if (ret !== $2d68152abb7d3417$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $2d68152abb7d3417$var$inflateInit = (strm)=>{
    return $2d68152abb7d3417$var$inflateInit2(strm, $2d68152abb7d3417$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $2d68152abb7d3417$var$virgin = true;
let $2d68152abb7d3417$var$lenfix, $2d68152abb7d3417$var$distfix; // We have no pointers in JS, so keep tables separate
const $2d68152abb7d3417$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($2d68152abb7d3417$var$virgin) {
        $2d68152abb7d3417$var$lenfix = new Int32Array(512);
        $2d68152abb7d3417$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $2d68152abb7d3417$var$inftrees($2d68152abb7d3417$var$LENS, state.lens, 0, 288, $2d68152abb7d3417$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $2d68152abb7d3417$var$inftrees($2d68152abb7d3417$var$DISTS, state.lens, 0, 32, $2d68152abb7d3417$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $2d68152abb7d3417$var$virgin = false;
    }
    state.lencode = $2d68152abb7d3417$var$lenfix;
    state.lenbits = 9;
    state.distcode = $2d68152abb7d3417$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $2d68152abb7d3417$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $2d68152abb7d3417$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($2d68152abb7d3417$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $2d68152abb7d3417$var$TYPE) state.mode = $2d68152abb7d3417$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $2d68152abb7d3417$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $2d68152abb7d3417$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $2d68152abb7d3417$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2d68152abb7d3417$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $2d68152abb7d3417$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $2d68152abb7d3417$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $2d68152abb7d3417$var$DICTID : $2d68152abb7d3417$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $2d68152abb7d3417$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $2d68152abb7d3417$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2d68152abb7d3417$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2d68152abb7d3417$var$TIME;
        /* falls through */ case $2d68152abb7d3417$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $2d68152abb7d3417$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2d68152abb7d3417$var$OS;
        /* falls through */ case $2d68152abb7d3417$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2d68152abb7d3417$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2d68152abb7d3417$var$EXLEN;
        /* falls through */ case $2d68152abb7d3417$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $2d68152abb7d3417$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $2d68152abb7d3417$var$EXTRA;
        /* falls through */ case $2d68152abb7d3417$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $2d68152abb7d3417$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $2d68152abb7d3417$var$NAME;
        /* falls through */ case $2d68152abb7d3417$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $2d68152abb7d3417$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $2d68152abb7d3417$var$COMMENT;
        /* falls through */ case $2d68152abb7d3417$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $2d68152abb7d3417$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $2d68152abb7d3417$var$HCRC;
        /* falls through */ case $2d68152abb7d3417$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $2d68152abb7d3417$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $2d68152abb7d3417$var$TYPE;
            break;
        case $2d68152abb7d3417$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $2d68152abb7d3417$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2d68152abb7d3417$var$DICT;
        /* falls through */ case $2d68152abb7d3417$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $2d68152abb7d3417$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $2d68152abb7d3417$var$TYPE;
        /* falls through */ case $2d68152abb7d3417$var$TYPE:
            if (flush === $2d68152abb7d3417$var$Z_BLOCK || flush === $2d68152abb7d3417$var$Z_TREES) break inf_leave;
        /* falls through */ case $2d68152abb7d3417$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $2d68152abb7d3417$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2d68152abb7d3417$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $2d68152abb7d3417$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2d68152abb7d3417$var$LEN_; /* decode codes */ 
                    if (flush === $2d68152abb7d3417$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2d68152abb7d3417$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $2d68152abb7d3417$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $2d68152abb7d3417$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2d68152abb7d3417$var$COPY_;
            if (flush === $2d68152abb7d3417$var$Z_TREES) break inf_leave;
        /* falls through */ case $2d68152abb7d3417$var$COPY_:
            state.mode = $2d68152abb7d3417$var$COPY;
        /* falls through */ case $2d68152abb7d3417$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $2d68152abb7d3417$var$TYPE;
            break;
        case $2d68152abb7d3417$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $2d68152abb7d3417$var$LENLENS;
        /* falls through */ case $2d68152abb7d3417$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $2d68152abb7d3417$var$inftrees($2d68152abb7d3417$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $2d68152abb7d3417$var$CODELENS;
        /* falls through */ case $2d68152abb7d3417$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $2d68152abb7d3417$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $2d68152abb7d3417$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $2d68152abb7d3417$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $2d68152abb7d3417$var$inftrees($2d68152abb7d3417$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $2d68152abb7d3417$var$inftrees($2d68152abb7d3417$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $2d68152abb7d3417$var$LEN_;
            if (flush === $2d68152abb7d3417$var$Z_TREES) break inf_leave;
        /* falls through */ case $2d68152abb7d3417$var$LEN_:
            state.mode = $2d68152abb7d3417$var$LEN;
        /* falls through */ case $2d68152abb7d3417$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $2d68152abb7d3417$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $2d68152abb7d3417$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $2d68152abb7d3417$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $2d68152abb7d3417$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $2d68152abb7d3417$var$LENEXT;
        /* falls through */ case $2d68152abb7d3417$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $2d68152abb7d3417$var$DIST;
        /* falls through */ case $2d68152abb7d3417$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $2d68152abb7d3417$var$DISTEXT;
        /* falls through */ case $2d68152abb7d3417$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $2d68152abb7d3417$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $2d68152abb7d3417$var$MATCH;
        /* falls through */ case $2d68152abb7d3417$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $2d68152abb7d3417$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $2d68152abb7d3417$var$LEN;
            break;
        case $2d68152abb7d3417$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $2d68152abb7d3417$var$LEN;
            break;
        case $2d68152abb7d3417$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $2d68152abb7d3417$var$crc32_1(state.check, output, _out, put - _out) : $2d68152abb7d3417$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $2d68152abb7d3417$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $2d68152abb7d3417$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $2d68152abb7d3417$var$LENGTH;
        /* falls through */ case $2d68152abb7d3417$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $2d68152abb7d3417$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $2d68152abb7d3417$var$DONE;
        /* falls through */ case $2d68152abb7d3417$var$DONE:
            ret = $2d68152abb7d3417$var$Z_STREAM_END$1;
            break inf_leave;
        case $2d68152abb7d3417$var$BAD:
            ret = $2d68152abb7d3417$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $2d68152abb7d3417$var$MEM:
            return $2d68152abb7d3417$var$Z_MEM_ERROR$1;
        case $2d68152abb7d3417$var$SYNC:
        /* falls through */ default:
            return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $2d68152abb7d3417$var$BAD && (state.mode < $2d68152abb7d3417$var$CHECK || flush !== $2d68152abb7d3417$var$Z_FINISH$1)) $2d68152abb7d3417$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $2d68152abb7d3417$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $2d68152abb7d3417$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $2d68152abb7d3417$var$TYPE ? 128 : 0) + (state.mode === $2d68152abb7d3417$var$LEN_ || state.mode === $2d68152abb7d3417$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $2d68152abb7d3417$var$Z_FINISH$1) && ret === $2d68152abb7d3417$var$Z_OK$1) ret = $2d68152abb7d3417$var$Z_BUF_ERROR;
    return ret;
};
const $2d68152abb7d3417$var$inflateEnd = (strm)=>{
    if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $2d68152abb7d3417$var$Z_OK$1;
};
const $2d68152abb7d3417$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $2d68152abb7d3417$var$Z_OK$1;
};
const $2d68152abb7d3417$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($2d68152abb7d3417$var$inflateStateCheck(strm)) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $2d68152abb7d3417$var$DICT) return $2d68152abb7d3417$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $2d68152abb7d3417$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $2d68152abb7d3417$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $2d68152abb7d3417$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $2d68152abb7d3417$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $2d68152abb7d3417$var$MEM;
        return $2d68152abb7d3417$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $2d68152abb7d3417$var$Z_OK$1;
};
var $2d68152abb7d3417$var$inflateReset_1 = $2d68152abb7d3417$var$inflateReset;
var $2d68152abb7d3417$var$inflateReset2_1 = $2d68152abb7d3417$var$inflateReset2;
var $2d68152abb7d3417$var$inflateResetKeep_1 = $2d68152abb7d3417$var$inflateResetKeep;
var $2d68152abb7d3417$var$inflateInit_1 = $2d68152abb7d3417$var$inflateInit;
var $2d68152abb7d3417$var$inflateInit2_1 = $2d68152abb7d3417$var$inflateInit2;
var $2d68152abb7d3417$var$inflate_2$1 = $2d68152abb7d3417$var$inflate$2;
var $2d68152abb7d3417$var$inflateEnd_1 = $2d68152abb7d3417$var$inflateEnd;
var $2d68152abb7d3417$var$inflateGetHeader_1 = $2d68152abb7d3417$var$inflateGetHeader;
var $2d68152abb7d3417$var$inflateSetDictionary_1 = $2d68152abb7d3417$var$inflateSetDictionary;
var $2d68152abb7d3417$var$inflateInfo = "pako inflate (from Nodeca project)";
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $2d68152abb7d3417$var$inflate_1$2 = {
    inflateReset: $2d68152abb7d3417$var$inflateReset_1,
    inflateReset2: $2d68152abb7d3417$var$inflateReset2_1,
    inflateResetKeep: $2d68152abb7d3417$var$inflateResetKeep_1,
    inflateInit: $2d68152abb7d3417$var$inflateInit_1,
    inflateInit2: $2d68152abb7d3417$var$inflateInit2_1,
    inflate: $2d68152abb7d3417$var$inflate_2$1,
    inflateEnd: $2d68152abb7d3417$var$inflateEnd_1,
    inflateGetHeader: $2d68152abb7d3417$var$inflateGetHeader_1,
    inflateSetDictionary: $2d68152abb7d3417$var$inflateSetDictionary_1,
    inflateInfo: $2d68152abb7d3417$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $2d68152abb7d3417$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $2d68152abb7d3417$var$gzheader = $2d68152abb7d3417$var$GZheader;
const $2d68152abb7d3417$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2d68152abb7d3417$var$Z_NO_FLUSH, Z_FINISH: $2d68152abb7d3417$var$Z_FINISH, Z_OK: $2d68152abb7d3417$var$Z_OK, Z_STREAM_END: $2d68152abb7d3417$var$Z_STREAM_END, Z_NEED_DICT: $2d68152abb7d3417$var$Z_NEED_DICT, Z_STREAM_ERROR: $2d68152abb7d3417$var$Z_STREAM_ERROR, Z_DATA_ERROR: $2d68152abb7d3417$var$Z_DATA_ERROR, Z_MEM_ERROR: $2d68152abb7d3417$var$Z_MEM_ERROR } = $2d68152abb7d3417$var$constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2d68152abb7d3417$var$Inflate$1(options) {
    this.options = $2d68152abb7d3417$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ""
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $2d68152abb7d3417$var$zstream();
    this.strm.avail_out = 0;
    let status = $2d68152abb7d3417$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $2d68152abb7d3417$var$Z_OK) throw new Error($2d68152abb7d3417$var$messages[status]);
    this.header = new $2d68152abb7d3417$var$gzheader();
    $2d68152abb7d3417$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $2d68152abb7d3417$var$strings.string2buf(opt.dictionary);
        else if ($2d68152abb7d3417$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $2d68152abb7d3417$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $2d68152abb7d3417$var$Z_OK) throw new Error($2d68152abb7d3417$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2d68152abb7d3417$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2d68152abb7d3417$var$Z_FINISH : $2d68152abb7d3417$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($2d68152abb7d3417$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $2d68152abb7d3417$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $2d68152abb7d3417$var$Z_NEED_DICT && dictionary) {
            status = $2d68152abb7d3417$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $2d68152abb7d3417$var$Z_OK) status = $2d68152abb7d3417$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $2d68152abb7d3417$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $2d68152abb7d3417$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $2d68152abb7d3417$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $2d68152abb7d3417$var$inflate_1$2.inflateReset(strm);
            status = $2d68152abb7d3417$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $2d68152abb7d3417$var$Z_STREAM_ERROR:
            case $2d68152abb7d3417$var$Z_DATA_ERROR:
            case $2d68152abb7d3417$var$Z_NEED_DICT:
            case $2d68152abb7d3417$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $2d68152abb7d3417$var$Z_STREAM_END) {
                if (this.options.to === "string") {
                    let next_out_utf8 = $2d68152abb7d3417$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $2d68152abb7d3417$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $2d68152abb7d3417$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $2d68152abb7d3417$var$Z_STREAM_END) {
            status = $2d68152abb7d3417$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2d68152abb7d3417$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2d68152abb7d3417$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2d68152abb7d3417$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $2d68152abb7d3417$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $2d68152abb7d3417$var$inflate$1(input, options) {
    const inflator = new $2d68152abb7d3417$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $2d68152abb7d3417$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2d68152abb7d3417$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $2d68152abb7d3417$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2d68152abb7d3417$var$Inflate_1$1 = $2d68152abb7d3417$var$Inflate$1;
var $2d68152abb7d3417$var$inflate_2 = $2d68152abb7d3417$var$inflate$1;
var $2d68152abb7d3417$var$inflateRaw_1$1 = $2d68152abb7d3417$var$inflateRaw$1;
var $2d68152abb7d3417$var$ungzip$1 = $2d68152abb7d3417$var$inflate$1;
var $2d68152abb7d3417$var$constants = $2d68152abb7d3417$var$constants$2;
var $2d68152abb7d3417$var$inflate_1$1 = {
    Inflate: $2d68152abb7d3417$var$Inflate_1$1,
    inflate: $2d68152abb7d3417$var$inflate_2,
    inflateRaw: $2d68152abb7d3417$var$inflateRaw_1$1,
    ungzip: $2d68152abb7d3417$var$ungzip$1,
    constants: $2d68152abb7d3417$var$constants
};
const { Deflate: $2d68152abb7d3417$var$Deflate, deflate: $2d68152abb7d3417$var$deflate, deflateRaw: $2d68152abb7d3417$var$deflateRaw, gzip: $2d68152abb7d3417$var$gzip } = $2d68152abb7d3417$var$deflate_1$1;
const { Inflate: $2d68152abb7d3417$var$Inflate, inflate: $2d68152abb7d3417$var$inflate, inflateRaw: $2d68152abb7d3417$var$inflateRaw, ungzip: $2d68152abb7d3417$var$ungzip } = $2d68152abb7d3417$var$inflate_1$1;
var $2d68152abb7d3417$export$ae157b6234afe138 = $2d68152abb7d3417$var$Deflate;
var $2d68152abb7d3417$export$2316623ecd1285ab = $2d68152abb7d3417$var$deflate;
var $2d68152abb7d3417$export$e95d6a8f69fb340a = $2d68152abb7d3417$var$deflateRaw;
var $2d68152abb7d3417$export$69f0ea7cf3a331a8 = $2d68152abb7d3417$var$gzip;
var $2d68152abb7d3417$export$d1de70a877d6e43c = $2d68152abb7d3417$var$Inflate;
var $2d68152abb7d3417$export$cae1ce83fe4a1782 = $2d68152abb7d3417$var$inflate;
var $2d68152abb7d3417$export$d0f0aa2d05c905c5 = $2d68152abb7d3417$var$inflateRaw;
var $2d68152abb7d3417$export$95adf9d270383091 = $2d68152abb7d3417$var$ungzip;
var $2d68152abb7d3417$export$1a988e7317c65621 = $2d68152abb7d3417$var$constants$2;
var $2d68152abb7d3417$export$2e2bcd8739ae039 = {
    Deflate: $2d68152abb7d3417$export$ae157b6234afe138,
    deflate: $2d68152abb7d3417$export$2316623ecd1285ab,
    deflateRaw: $2d68152abb7d3417$export$e95d6a8f69fb340a,
    gzip: $2d68152abb7d3417$export$69f0ea7cf3a331a8,
    Inflate: $2d68152abb7d3417$export$d1de70a877d6e43c,
    inflate: $2d68152abb7d3417$export$cae1ce83fe4a1782,
    inflateRaw: $2d68152abb7d3417$export$d0f0aa2d05c905c5,
    ungzip: $2d68152abb7d3417$export$95adf9d270383091,
    constants: $2d68152abb7d3417$export$1a988e7317c65621
};


function $268abebfadfa5867$export$b2f28d1f55574017(labels) {
    if (!labels) return [];
    let encoded = [];
    let count = 1;
    for(let i = 1; i < labels.length; i++)if (labels[i] === labels[i - 1]) count++;
    else {
        encoded.push(count);
        encoded.push(labels[i - 1]);
        count = 1;
    }
    encoded.push(count);
    encoded.push(labels[labels.length - 1]);
    return encoded;
}
function $268abebfadfa5867$export$6331e6257b65859c(encoded) {
    let decoded = [];
    for(let i = 0; i < encoded.length; i += 2){
        const count = encoded[i];
        const label = encoded[i + 1];
        for(let j = 0; j < count; j++)decoded.push(label);
    }
    return new Uint32Array(decoded);
}
/**
 * Decode a base64-encoded numpy array
 * @param {Object} encodedData - The encoded data with shape, dtype and base64 data
 * @returns {ArrayBuffer|Float32Array|Int32Array} - The decoded array
 */ function $268abebfadfa5867$var$decodeBase64Array(encodedData) {
    if (!encodedData || !encodedData.data) return null;
    const { shape: shape, dtype: dtype, data: data } = encodedData;
    const binary = atob(data);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    // Create the appropriate typed array based on dtype
    let typedArray;
    if (dtype.includes("float32")) typedArray = new Float32Array(bytes.buffer);
    else if (dtype.includes("int32")) typedArray = new Int32Array(bytes.buffer);
    else if (dtype.includes("float64")) typedArray = new Float64Array(bytes.buffer);
    else if (dtype.includes("int64")) // JavaScript doesn't have Int64Array, so use BigInt64Array
    typedArray = new BigInt64Array(bytes.buffer);
    else // Default to generic ArrayBuffer
    return bytes.buffer;
    // Reshape the array if necessary
    if (shape && shape.length > 1) {
        // For 2D arrays, we'll convert to nested arrays
        const result = [];
        const [rows, cols] = shape;
        for(let i = 0; i < rows; i++){
            const row = [];
            for(let j = 0; j < cols; j++)row.push(typedArray[i * cols + j]);
            result.push(row);
        }
        return result;
    }
    return typedArray;
}
/**
 * Decode a nested dictionary with base64-encoded arrays
 * @param {Object} data - The encoded nested dictionary
 * @returns {Object} - The decoded nested dictionary
 */ function $268abebfadfa5867$export$2130189ea4ff8c6d(data) {
    if (!data) return null;
    const decoded = {};
    for (const [key, value] of Object.entries(data)){
        if (value && typeof value === "object" && "data" in value && "shape" in value && "dtype" in value) // This is a base64-encoded array
        decoded[key] = $268abebfadfa5867$var$decodeBase64Array(value);
        else if (value && typeof value === "object") // This could be a nested dictionary
        decoded[key] = $268abebfadfa5867$export$2130189ea4ff8c6d(value);
        else // This is a regular value
        decoded[key] = value;
    }
    return decoded;
}
/**
 * Decode keypoints that have been compressed with zlib and encoded as base64
 * @param {Object} compressedKeypoints - The compressed keypoints object
 * @returns {Array} - The decoded keypoints array
 */ function $268abebfadfa5867$var$decodeCompressedKeypoints(compressedKeypoints) {
    if (!compressedKeypoints || !compressedKeypoints.data) return null;
    const { encoding: encoding, data: data } = compressedKeypoints;
    if (encoding !== "zlib+base64") {
        console.error("Unsupported keypoints encoding:", encoding);
        return null;
    }
    // Convert base64 to binary
    const binary = atob(data);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    // Decompress with pako (a JavaScript zlib implementation)
    try {
        // Import pako if it's not already imported
        if (typeof (0, $2d68152abb7d3417$export$2e2bcd8739ae039) === "undefined") throw new Error("pako library is not available. Make sure to import it.");
        // Use pako to decompress the data
        const decompressed = (0, $2d68152abb7d3417$export$2e2bcd8739ae039).inflate(bytes);
        // Convert Uint8Array to string
        const decompressedStr = new TextDecoder("utf-8").decode(decompressed);
        // Parse the JSON string
        const parsedData = JSON.parse(decompressedStr);
        // Check if the result is still compressed (has encoding and data fields)
        if (parsedData && typeof parsedData === "object" && parsedData.encoding && parsedData.data) // Recursively decode the nested compressed data
        return $268abebfadfa5867$var$decodeCompressedKeypoints(parsedData);
        return parsedData;
    } catch (error) {
        console.error("Error decompressing keypoints:", error);
        return null;
    }
}
function $268abebfadfa5867$export$e2db2a8c20f5e55a(result) {
    if (!result) return result;
    // Make a deep copy for decoding
    result = JSON.parse(JSON.stringify(result));
    // Check if this is already decoded or not compressed
    if (!result.is_compressed) return result; // Return as is if not compressed
    // Decode using the is_compressed flag format
    try {
        // Decode labels if present
        if (result.labels && typeof result.labels === "object") {
            const encoding = result.labels.encoding;
            if (encoding === "runlength") result.labels = $268abebfadfa5867$export$6331e6257b65859c(result.labels.data);
        } else if (result.labels && typeof result.labels === "string") // For backward compatibility with old string format
        result.labels = $268abebfadfa5867$export$6331e6257b65859c(JSON.parse(atob(result.labels)));
        // Decode instance_ids if present
        if (result.instance_ids && typeof result.instance_ids === "object") {
            const encoding = result.instance_ids.encoding;
            if (encoding === "runlength") result.instance_ids = $268abebfadfa5867$export$6331e6257b65859c(result.instance_ids.data);
        } else if (result.instance_ids && typeof result.instance_ids === "string") // For backward compatibility with old string format
        result.instance_ids = $268abebfadfa5867$export$6331e6257b65859c(JSON.parse(atob(result.instance_ids)));
        // Decode boundary_points if present
        if (result.boundary_points && typeof result.boundary_points === "object") result.boundary_points = $268abebfadfa5867$export$2130189ea4ff8c6d(result.boundary_points);
        else if (result.boundary_points && typeof result.boundary_points === "string") // For backward compatibility with old string format
        result.boundary_points = JSON.parse(atob(result.boundary_points));
        // Decode simplified_boundary_points if present
        if (result.simplified_boundary_points && typeof result.simplified_boundary_points === "object") result.simplified_boundary_points = $268abebfadfa5867$export$2130189ea4ff8c6d(result.simplified_boundary_points);
        else if (result.simplified_boundary_points && typeof result.simplified_boundary_points === "string") // For backward compatibility with old string format
        result.simplified_boundary_points = JSON.parse(atob(result.simplified_boundary_points));
        // Decode keypoints if present
        if (result.keypoints && typeof result.keypoints === "object") {
            const encoding = result.keypoints.encoding;
            if (encoding === "zlib+base64") result.keypoints = $268abebfadfa5867$var$decodeCompressedKeypoints(result.keypoints);
        } else if (result.keypoints && typeof result.keypoints === "string") // For backward compatibility with old string format
        result.keypoints = JSON.parse(atob(result.keypoints));
        // Decode reconstruction_result if present
        if (result.reconstruction_result && typeof result.reconstruction_result === "object") result.reconstruction_result = $268abebfadfa5867$export$2130189ea4ff8c6d(result.reconstruction_result);
        else if (result.reconstruction_result && typeof result.reconstruction_result === "string") // For backward compatibility with old string format
        result.reconstruction_result = JSON.parse(atob(result.reconstruction_result));
        // Remove the is_compressed flag
        delete result.is_compressed;
    } catch (error) {
        console.error("Error decoding processing result:", error);
        console.error("Failed result structure:", result);
    }
    return result;
}
function $268abebfadfa5867$export$9d64a90f1f347368(annotationClasses, labels, keypoints) {
    // Convert keypoint objects to snake_case format
    const encodedKeypoints = keypoints?.map((keypoint)=>({
            x: keypoint.x,
            y: keypoint.y,
            z: keypoint.z,
            class_name: keypoint.className,
            tooth_id: keypoint.toothId
        })) || [];
    // Encode labels using run-length encoding if labels exist
    const encodedLabels = labels ? $268abebfadfa5867$export$b2f28d1f55574017(labels) : [];
    let data = {
        version: "1.1",
        class_names: annotationClasses.map((c)=>c.name),
        class_colors: annotationClasses.map((c)=>c.color),
        class_ids: annotationClasses.map((c)=>c.id),
        labels: encodedLabels,
        keypoints: encodedKeypoints,
        run_length_encoding: true
    };
    return data;
}
function $268abebfadfa5867$export$55fcb30c18df4457(data) {
    if (data.run_length_encoding) data.labels = $268abebfadfa5867$export$6331e6257b65859c(data.labels);
    // Add unique id to each keypoint if keypoints exist
    if (data.keypoints) data.keypoints = data.keypoints.map((point)=>({
            x: point.x,
            y: point.y,
            z: point.z,
            className: point.class_name,
            pointName: `keypoint-point-${crypto.randomUUID()}`,
            toothId: point.tooth_id || null
        }));
    return data;
}



// Add a new object to store processing times for different models and file sizes
const $b3301d11178af01b$export$86065947754e0d0f = {
    teethml: [],
    defectml: [],
    keypointml: [],
    teethseparation: [],
    arrangement: []
};
// Function to estimate processing time based on model type only, ignoring file size
function $b3301d11178af01b$export$c24606b8d46faa72(fileSize, modelType) {
    // Default estimates if no history
    const defaultEstimates = {
        teethml: 40,
        defectml: 10,
        keypointml: 15,
        teethseparation: 160,
        arrangement: 30 // seconds
    };
    // If we have history for this model type, calculate average processing time
    if ($b3301d11178af01b$export$86065947754e0d0f[modelType].length > 0) {
        const relevantHistory = $b3301d11178af01b$export$86065947754e0d0f[modelType];
        // Get the most recent entries (up to 5)
        const recentEntries = relevantHistory.slice(-5);
        // Calculate simple average of processing times
        let totalTime = 0;
        recentEntries.forEach((entry)=>{
            totalTime += entry.timeInSeconds;
        });
        return Math.round(totalTime / recentEntries.length);
    }
    // Return default estimate if no relevant history
    return defaultEstimates[modelType];
}
// Function to update the progress bar
function $b3301d11178af01b$export$55220155eeb8e52c(percent, timeRemaining) {
    const processingIndicator = document.getElementById("processing-indicator");
    const progressBar = document.querySelector("#processing-indicator .progress-bar");
    const progressPercent = document.querySelector("#processing-indicator .progress-percent");
    const progressTime = document.querySelector("#processing-indicator .progress-time");
    // Force proper positioning
    processingIndicator.style.position = "fixed";
    processingIndicator.style.bottom = "0";
    processingIndicator.style.top = "auto";
    processingIndicator.style.left = "0";
    processingIndicator.style.width = "100%";
    processingIndicator.style.zIndex = "9999";
    // Make sure the indicator is visible
    processingIndicator.style.display = "block";
    // Update progress bar width
    progressBar.style.width = `${percent}%`;
    progressPercent.textContent = `${Math.round(percent)}%`;
    if (timeRemaining !== undefined) // Check if timeRemaining is a string (for "Almost done here...")
    {
        if (typeof timeRemaining === "string") progressTime.textContent = timeRemaining;
    }
    // Auto-collapse sidebar when processing starts
    if (percent <= 10) (0, $a78b7212404532f0$export$4087e547c9157774)();
// Processing complete - sidebar remains in its current state
}




// Global state object
const $66dbd4fb7330af32$export$8e769ad4338a911e = {
    scene: null,
    camera: null,
    renderer: null,
    mesh: null,
    controls: null,
    boundaryScene: null,
    boundaryCamera: null,
    boundaryRenderer: null,
    boundaryMesh: null,
    boundaryControls: null,
    simplifiedBoundaryScene: null,
    simplifiedBoundaryCamera: null,
    simplifiedBoundaryRenderer: null,
    simplifiedBoundaryMesh: null,
    simplifiedBoundaryControls: null,
    showWireframe: (0, $bebe1cbb5a309c8c$export$7f28898ca56d24c7),
    showPointCloud: (0, $bebe1cbb5a309c8c$export$a94eb5254fe8721d),
    wireframeMaterial: null,
    pointsMaterial: null,
    ambientLight: null,
    directionalLight1: null,
    directionalLight2: null,
    loadingFile: false,
    processingFile: false,
    boundaryPoints: null,
    boundaryLines: null,
    simplifiedBoundaryPoints: null,
    simplifiedBoundaryLines: null,
    labelRenderer: null,
    boundaryLabelRenderer: null,
    simplifiedBoundaryLabelRenderer: null,
    classLabels: [],
    keypoints: {},
    keypointLabels: [],
    showToothIDForKeypoints: false,
    labelingMode: "keypoint",
    annotationClasses: (0, (/*@__PURE__*/$parcel$interopDefault($60270fe9f6d741b0$exports))),
    currentClassId: 1,
    showKeypointLabels: true,
    showMarginalRidgeLines: true,
    brightnessAmount: 1.5,
    objFiles: [
        {
            name: "currentFile.obj"
        }
    ],
    currentFileIndex: 0,
    separationPhase: 0,
    separationData: {
        originalMesh: null,
        segmentedMesh: null,
        analyzedTeeth: null,
        finalResult: null
    },
    multiViewRenderers: {
        original: null,
        segmented: null,
        analysis: null,
        final: null
    },
    multiViewScenes: {
        original: null,
        segmented: null,
        analysis: null,
        final: null
    },
    multiViewCameras: {
        original: null,
        segmented: null,
        analysis: null,
        final: null
    },
    multiViewControls: {
        original: null,
        segmented: null,
        analysis: null,
        final: null
    },
    multiViewLabelRenderers: {
        original: null,
        segmented: null,
        analysis: null,
        final: null
    },
    // Overlay view for arrangement mode
    overlayViewMode: "dual",
    overlayRenderer: null,
    overlayScene: null,
    overlayCamera: null,
    overlayControls: null,
    overlayLabelRenderer: null,
    arrangementOriginalObjects: null,
    arrangementTransformedObjects: null,
    // Feedback review mode state
    feedbackMode: false,
    feedbackData: [],
    currentFeedbackIndex: 0,
    feedbackManager: null,
    // Displacement table data
    displacementTable: null,
    lastArrangementInfoJson: null
};


// Pure helpers for arrangement file handling: patient-ID extraction/consistency
// and Azure-folder file classification. Kept DOM-free so they can be unit tested
// in isolation (see src/__tests__/arrangementFiles.test.js).
// Reduce an upload path or file name to its base name (drop any directory or
// azure:// prefix), so patient-ID extraction works for both file uploads and
// Azure blob paths.
function $0f1e8af8606ec915$export$6bc8936542c530ec(pathOrName) {
    if (!pathOrName) return "";
    const trimmed = String(pathOrName).trim();
    const lastSlash = Math.max(trimmed.lastIndexOf("/"), trimmed.lastIndexOf("\\"));
    return lastSlash >= 0 ? trimmed.slice(lastSlash + 1) : trimmed;
}
// Patient ID convention: the leading identifier ends at the first space, or
// at a "-<digit>" suffix if that comes first - whichever occurs earlier.
// The "-<digit>" form covers per-export/variant suffixes that are NOT part
// of the patient identity (e.g. "-0"/"-1" file-revision markers seen on both
// internal tenant/case-id exports, "1234567890123-0 Obj3D L.obj", and native
// OnyxCeph3 exports with no space before the suffix at all,
// "1234567890123-0_OnyxCeph3_Export Lower.obj") - two files for the same
// case can legitimately differ only in that suffix and must still match.
// Returns "" when the name has no token.
function $0f1e8af8606ec915$export$6aeccaccecbe18a4(pathOrName) {
    const base = $0f1e8af8606ec915$export$6bc8936542c530ec(pathOrName);
    if (!base) return "";
    const spaceIndex = base.indexOf(" ");
    const dashDigitMatch = base.match(/-\d/);
    const dashIndex = dashDigitMatch ? dashDigitMatch.index : -1;
    let endIndex;
    if (dashIndex === -1) endIndex = spaceIndex;
    else if (spaceIndex === -1) endIndex = dashIndex;
    else endIndex = Math.min(spaceIndex, dashIndex);
    const id = endIndex === -1 ? base : base.slice(0, endIndex);
    return id.trim();
}
// Verify that all provided arrangement file names share the same patient ID.
// `entries` is a list of {label, name} for the files actually supplied.
// Returns an error string when the IDs disagree or any ID is empty, else null.
function $0f1e8af8606ec915$export$f17070002f5b84d7(entries) {
    const present = entries.filter((e)=>e.name);
    if (present.length < 2) return null;
    const ids = present.map((e)=>({
            label: e.label,
            id: $0f1e8af8606ec915$export$6aeccaccecbe18a4(e.name)
        }));
    const missing = ids.filter((e)=>!e.id);
    if (missing.length > 0) return "Could not determine patient ID from file name(s): " + missing.map((e)=>e.label).join(", ") + ". Expected names like '<patient_id> <role>'.";
    const reference = ids[0].id;
    const mismatched = ids.filter((e)=>e.id !== reference);
    if (mismatched.length > 0) {
        const summary = ids.map((e)=>`${e.label}: ${e.id}`).join(", ");
        return "Patient ID mismatch across files (" + summary + "). All files must belong to the same patient.";
    }
    return null;
}
// Naming convention used to resolve arrangement files from a single Azure folder.
// Configurable so it can be adjusted without touching the matcher:
//   - Jaw .obj files are classified by the LAST name token (case-insensitive):
//     "U"/"Upper" -> upper, "L"/"Lower" -> lower. Onyxceph exports look like
//     "... Obj3D L.obj".
//   - `excludeObj`: .obj names containing any of these substrings are ignored.
//     "step" = post-treatment setups (not the arrangement input); "simplified" =
//     decimated preview meshes.
//   - Info is the .json whose name contains "info"; when several match, the file
//     named exactly "Info.json" wins (`preferExact`) - e.g. over "Modified Info.json".
//   - Landmarks is the .csv whose name contains "landmarks" (not "Wire 3D" /
//     "Protocol Distances").
//   - `contains`/`preferExact` are matched case-insensitively; set `contains` to
//     "" to match by extension alone.
// NOTE: this classifier does not itself check patient-ID consistency - it only
// resolves each role by name convention. The resolved azure:// paths are
// written into the same per-file fields the submit path already validates
// (see collectArrangementInputs()'s validatePatientIdConsistency call), so a
// folder with mismatched patient IDs across roles is still caught there.
const $0f1e8af8606ec915$export$20e16ed430da6e39 = {
    upper: {
        ext: ".obj",
        tokens: [
            "u",
            "upper"
        ]
    },
    lower: {
        ext: ".obj",
        tokens: [
            "l",
            "lower"
        ]
    },
    info: {
        ext: ".json",
        contains: "info",
        preferExact: "info.json"
    },
    landmarks: {
        ext: ".csv",
        contains: "landmarks"
    },
    excludeObj: [
        "step",
        "simplified"
    ]
};
// True when a file name matches a keyword-based role (info/landmarks): the
// extension matches and, if a keyword is configured, the name contains it.
function $0f1e8af8606ec915$var$matchesKeywordRole(nameLower, roleConfig) {
    if (!nameLower.endsWith(roleConfig.ext)) return false;
    if (roleConfig.contains && !nameLower.includes(roleConfig.contains)) return false;
    return true;
}
// Determine the jaw role of an .obj file by its last name token. Splitting on
// spaces, underscores and hyphens handles both "... Obj3D L.obj" and
// "..._upper.obj" (internal) conventions. Matching the whole last token (not a
// substring) avoids "Upper" being read as lower via the "l" in it, and avoids a
// patient-id fragment being mistaken for a role. Returns "upper"/"lower"/null.
function $0f1e8af8606ec915$var$objJawRole(nameWithoutExt, config) {
    const tokens = nameWithoutExt.toLowerCase().split(/[\s_-]+/).filter(Boolean);
    if (tokens.length === 0) return null;
    const last = tokens[tokens.length - 1];
    if (config.upper.tokens.includes(last)) return "upper";
    if (config.lower.tokens.includes(last)) return "lower";
    return null;
}
// Pick the single resolved candidate for a role, or null. When several match,
// `preferExact` (an exact case-insensitive basename) breaks the tie if exactly
// one candidate matches it; otherwise the role stays unresolved (ambiguous).
function $0f1e8af8606ec915$var$pickCandidate(list, preferExact) {
    if (list.length <= 1) return list[0] || null;
    if (preferExact) {
        const exact = list.filter((e)=>e.name.toLowerCase() === preferExact.toLowerCase());
        if (exact.length === 1) return exact[0];
    }
    return null; // still ambiguous
}
// Classify the blobs of a single arrangement folder into the four expected roles.
// `blobs` is the endpoint's files array: [{ name, reference, ... }].
// Pure function - never throws. Returns:
//   {
//     resolved: { lower, upper, info, landmarks },  // azure:// reference or null
//     errors:   [string],                            // block submit when non-empty
//     unmatched: [string]                            // informational (ignored files)
//   }
// Robustness rules:
//   - required jaw (.obj) with 0 matches   -> error
//   - a role matched by >1 file that a tie-breaker cannot resolve -> ambiguity error
//   - optional file (info/landmarks) with 0 matches -> null, no error
// Patient-ID is NOT checked (folder = single case boundary; see config note).
function $0f1e8af8606ec915$export$1a787057b09eb396(blobs, config = $0f1e8af8606ec915$export$20e16ed430da6e39) {
    const candidates = {
        upper: [],
        lower: [],
        info: [],
        landmarks: []
    };
    const unmatched = [];
    const excludeObj = config.excludeObj || [];
    for (const blob of blobs || []){
        const name = blob && blob.name ? String(blob.name) : "";
        if (!name) continue;
        const nameLower = name.toLowerCase();
        const entry = {
            name: name,
            reference: blob.reference
        };
        // Branch by extension first so info/landmarks can never be read as a jaw
        // obj and a jaw obj can never be read as info/landmarks. Info/landmarks
        // additionally require their keyword so unrelated extra files are ignored.
        if ($0f1e8af8606ec915$var$matchesKeywordRole(nameLower, config.info)) candidates.info.push(entry);
        else if ($0f1e8af8606ec915$var$matchesKeywordRole(nameLower, config.landmarks)) candidates.landmarks.push(entry);
        else if (nameLower.endsWith(config.upper.ext)) {
            // upper.ext and lower.ext are both ".obj". Skip excluded obj variants
            // (post-treatment "step" setups, "simplified" preview meshes).
            if (excludeObj.some((term)=>nameLower.includes(term))) {
                unmatched.push(name);
                continue;
            }
            const nameWithoutExt = name.slice(0, -config.upper.ext.length);
            const role = $0f1e8af8606ec915$var$objJawRole(nameWithoutExt, config);
            if (role) candidates[role].push(entry);
            else unmatched.push(name);
        } else unmatched.push(name);
    }
    const roleLabels = {
        upper: "upper jaw (.obj)",
        lower: "lower jaw (.obj)",
        info: "info.json",
        landmarks: "landmarks (.csv)"
    };
    // Resolve each role to a single file (with tie-breakers where configured).
    const picked = {
        lower: $0f1e8af8606ec915$var$pickCandidate(candidates.lower),
        upper: $0f1e8af8606ec915$var$pickCandidate(candidates.upper),
        info: $0f1e8af8606ec915$var$pickCandidate(candidates.info, config.info.preferExact),
        landmarks: $0f1e8af8606ec915$var$pickCandidate(candidates.landmarks, config.landmarks.preferExact)
    };
    const errors = [];
    // Required jaw files must resolve to exactly one file.
    for (const role of [
        "lower",
        "upper"
    ])if (candidates[role].length === 0) errors.push(`No ${roleLabels[role]} file found in folder`);
    // A role with multiple candidates that no tie-breaker resolved is ambiguous.
    for (const role of [
        "lower",
        "upper",
        "info",
        "landmarks"
    ])if (candidates[role].length > 1 && !picked[role]) {
        const names = candidates[role].map((e)=>e.name).join(", ");
        errors.push(`Ambiguous ${roleLabels[role]}: multiple files matched (${names})`);
    }
    const resolved = {
        lower: picked.lower ? picked.lower.reference : null,
        upper: picked.upper ? picked.upper.reference : null,
        info: picked.info ? picked.info.reference : null,
        landmarks: picked.landmarks ? picked.landmarks.reference : null
    };
    return {
        resolved: resolved,
        errors: errors,
        unmatched: unmatched
    };
}














// Function to create labels JSON from the inference result
function $dcddfe328dd861cb$export$2118c26b454acfe3(neededFields = null) {
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult || !(0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult.labels) return null;
    // Create JSON file with labels in the format described in dataset_format.md
    const processingMode = document.getElementById("processing-mode-dropdown")?.value || "teethml";
    const classesData = processingMode === "defectml" ? (0, (/*@__PURE__*/$parcel$interopDefault($87cd5dd3a0b838ad$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($2a57802d05c0eaa2$exports)));
    // Get unique classes and instances in the result
    const uniqueClasses = new Set((0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult.labels);
    // Encode labels and instance_ids using run-length encoding
    const labelsData = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult.labels;
    const instanceIdsData = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult.instance_ids || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult.labels;
    // Create base JSON content
    const result = {
        version: "1.0",
        is_compressed: true
    };
    // If neededFields is provided, only include those fields
    // Otherwise include all fields
    const includeField = (field)=>!neededFields || neededFields.includes(field);
    // Add fields based on selection
    if (includeField("labels")) result.labels = {
        encoding: "runlength",
        data: (0, $268abebfadfa5867$export$b2f28d1f55574017)(labelsData)
    };
    if (includeField("instance_ids")) result.instance_ids = {
        encoding: "runlength",
        data: (0, $268abebfadfa5867$export$b2f28d1f55574017)(instanceIdsData)
    };
    if (includeField("class_ids")) result.class_ids = Array.from(uniqueClasses);
    if (includeField("class_names")) result.class_names = Array.from(uniqueClasses).map((classId)=>{
        const classData = classesData.find((c)=>c.id === parseInt(classId));
        return classData ? classData.name : `Unknown (${classId})`;
    });
    if (includeField("class_colors")) result.class_colors = Array.from(uniqueClasses).map((classId)=>{
        const classData = classesData.find((c)=>c.id === parseInt(classId));
        return classData ? classData.color : "#FFFFFF";
    });
    if (includeField("boundary_points") && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult.boundary_points) result.boundary_points = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult.boundary_points;
    if (includeField("simplified_boundary_points") && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult.simplified_boundary_points) result.simplified_boundary_points = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult.simplified_boundary_points;
    return result;
}



"use strict";
function $6d5e785c5f814af7$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $371a3837fd81d701$exports = {};
// shim for using process in browser
var $371a3837fd81d701$var$process = $371a3837fd81d701$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = "browser";
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ""; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$371a3837fd81d701$var$process.cwd = function() {
    return "/";
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $dd87d7aee5b911f1$var$toString } = Object.prototype;
const { getPrototypeOf: $dd87d7aee5b911f1$var$getPrototypeOf } = Object;
const $dd87d7aee5b911f1$var$kindOf = ((cache)=>(thing)=>{
        const str = $dd87d7aee5b911f1$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $dd87d7aee5b911f1$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$dd87d7aee5b911f1$var$kindOf(thing) === type;
};
const $dd87d7aee5b911f1$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $dd87d7aee5b911f1$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $dd87d7aee5b911f1$var$isUndefined = $dd87d7aee5b911f1$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $dd87d7aee5b911f1$var$isBuffer(val) {
    return val !== null && !$dd87d7aee5b911f1$var$isUndefined(val) && val.constructor !== null && !$dd87d7aee5b911f1$var$isUndefined(val.constructor) && $dd87d7aee5b911f1$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $dd87d7aee5b911f1$var$isArrayBuffer = $dd87d7aee5b911f1$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $dd87d7aee5b911f1$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $dd87d7aee5b911f1$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $dd87d7aee5b911f1$var$isString = $dd87d7aee5b911f1$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $dd87d7aee5b911f1$var$isFunction = $dd87d7aee5b911f1$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $dd87d7aee5b911f1$var$isNumber = $dd87d7aee5b911f1$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $dd87d7aee5b911f1$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $dd87d7aee5b911f1$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $dd87d7aee5b911f1$var$isPlainObject = (val)=>{
    if ($dd87d7aee5b911f1$var$kindOf(val) !== "object") return false;
    const prototype = $dd87d7aee5b911f1$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $dd87d7aee5b911f1$var$isDate = $dd87d7aee5b911f1$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $dd87d7aee5b911f1$var$isFile = $dd87d7aee5b911f1$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $dd87d7aee5b911f1$var$isBlob = $dd87d7aee5b911f1$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $dd87d7aee5b911f1$var$isFileList = $dd87d7aee5b911f1$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $dd87d7aee5b911f1$var$isStream = (val)=>$dd87d7aee5b911f1$var$isObject(val) && $dd87d7aee5b911f1$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $dd87d7aee5b911f1$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $dd87d7aee5b911f1$var$isFunction(thing.append) && ((kind = $dd87d7aee5b911f1$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $dd87d7aee5b911f1$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $dd87d7aee5b911f1$var$isURLSearchParams = $dd87d7aee5b911f1$var$kindOfTest("URLSearchParams");
const [$dd87d7aee5b911f1$var$isReadableStream, $dd87d7aee5b911f1$var$isRequest, $dd87d7aee5b911f1$var$isResponse, $dd87d7aee5b911f1$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($dd87d7aee5b911f1$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $dd87d7aee5b911f1$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $dd87d7aee5b911f1$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($dd87d7aee5b911f1$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $dd87d7aee5b911f1$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $dd87d7aee5b911f1$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $dd87d7aee5b911f1$var$isContextDefined = (context)=>!$dd87d7aee5b911f1$var$isUndefined(context) && context !== $dd87d7aee5b911f1$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $dd87d7aee5b911f1$var$merge() {
    const { caseless: caseless } = $dd87d7aee5b911f1$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $dd87d7aee5b911f1$var$findKey(result, key) || key;
        if ($dd87d7aee5b911f1$var$isPlainObject(result[targetKey]) && $dd87d7aee5b911f1$var$isPlainObject(val)) result[targetKey] = $dd87d7aee5b911f1$var$merge(result[targetKey], val);
        else if ($dd87d7aee5b911f1$var$isPlainObject(val)) result[targetKey] = $dd87d7aee5b911f1$var$merge({}, val);
        else if ($dd87d7aee5b911f1$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $dd87d7aee5b911f1$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $dd87d7aee5b911f1$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $dd87d7aee5b911f1$var$forEach(b, (val, key)=>{
        if (thisArg && $dd87d7aee5b911f1$var$isFunction(val)) a[key] = (0, $6d5e785c5f814af7$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $dd87d7aee5b911f1$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $dd87d7aee5b911f1$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $dd87d7aee5b911f1$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $dd87d7aee5b911f1$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $dd87d7aee5b911f1$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $dd87d7aee5b911f1$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($dd87d7aee5b911f1$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$dd87d7aee5b911f1$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $dd87d7aee5b911f1$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $dd87d7aee5b911f1$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $dd87d7aee5b911f1$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $dd87d7aee5b911f1$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $dd87d7aee5b911f1$var$isHTMLForm = $dd87d7aee5b911f1$var$kindOfTest("HTMLFormElement");
const $dd87d7aee5b911f1$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $dd87d7aee5b911f1$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $dd87d7aee5b911f1$var$isRegExp = $dd87d7aee5b911f1$var$kindOfTest("RegExp");
const $dd87d7aee5b911f1$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $dd87d7aee5b911f1$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $dd87d7aee5b911f1$var$freezeMethods = (obj)=>{
    $dd87d7aee5b911f1$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($dd87d7aee5b911f1$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$dd87d7aee5b911f1$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $dd87d7aee5b911f1$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $dd87d7aee5b911f1$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $dd87d7aee5b911f1$var$noop = ()=>{};
const $dd87d7aee5b911f1$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $dd87d7aee5b911f1$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $dd87d7aee5b911f1$var$DIGIT = "0123456789";
const $dd87d7aee5b911f1$var$ALPHABET = {
    DIGIT: $dd87d7aee5b911f1$var$DIGIT,
    ALPHA: $dd87d7aee5b911f1$var$ALPHA,
    ALPHA_DIGIT: $dd87d7aee5b911f1$var$ALPHA + $dd87d7aee5b911f1$var$ALPHA.toUpperCase() + $dd87d7aee5b911f1$var$DIGIT
};
const $dd87d7aee5b911f1$var$generateString = (size = 16, alphabet = $dd87d7aee5b911f1$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $dd87d7aee5b911f1$var$isSpecCompliantForm(thing) {
    return !!(thing && $dd87d7aee5b911f1$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $dd87d7aee5b911f1$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($dd87d7aee5b911f1$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $dd87d7aee5b911f1$var$isArray(source) ? [] : {};
                $dd87d7aee5b911f1$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$dd87d7aee5b911f1$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $dd87d7aee5b911f1$var$isAsyncFn = $dd87d7aee5b911f1$var$kindOfTest("AsyncFunction");
const $dd87d7aee5b911f1$var$isThenable = (thing)=>thing && ($dd87d7aee5b911f1$var$isObject(thing) || $dd87d7aee5b911f1$var$isFunction(thing)) && $dd87d7aee5b911f1$var$isFunction(thing.then) && $dd87d7aee5b911f1$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $dd87d7aee5b911f1$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $dd87d7aee5b911f1$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $dd87d7aee5b911f1$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $dd87d7aee5b911f1$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $dd87d7aee5b911f1$var$isFunction($dd87d7aee5b911f1$var$_global.postMessage));
const $dd87d7aee5b911f1$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($dd87d7aee5b911f1$var$_global) : typeof $371a3837fd81d701$exports !== "undefined" && $371a3837fd81d701$exports.nextTick || $dd87d7aee5b911f1$var$_setImmediate;
var // *********************
$dd87d7aee5b911f1$export$2e2bcd8739ae039 = {
    isArray: $dd87d7aee5b911f1$var$isArray,
    isArrayBuffer: $dd87d7aee5b911f1$var$isArrayBuffer,
    isBuffer: $dd87d7aee5b911f1$var$isBuffer,
    isFormData: $dd87d7aee5b911f1$var$isFormData,
    isArrayBufferView: $dd87d7aee5b911f1$var$isArrayBufferView,
    isString: $dd87d7aee5b911f1$var$isString,
    isNumber: $dd87d7aee5b911f1$var$isNumber,
    isBoolean: $dd87d7aee5b911f1$var$isBoolean,
    isObject: $dd87d7aee5b911f1$var$isObject,
    isPlainObject: $dd87d7aee5b911f1$var$isPlainObject,
    isReadableStream: $dd87d7aee5b911f1$var$isReadableStream,
    isRequest: $dd87d7aee5b911f1$var$isRequest,
    isResponse: $dd87d7aee5b911f1$var$isResponse,
    isHeaders: $dd87d7aee5b911f1$var$isHeaders,
    isUndefined: $dd87d7aee5b911f1$var$isUndefined,
    isDate: $dd87d7aee5b911f1$var$isDate,
    isFile: $dd87d7aee5b911f1$var$isFile,
    isBlob: $dd87d7aee5b911f1$var$isBlob,
    isRegExp: $dd87d7aee5b911f1$var$isRegExp,
    isFunction: $dd87d7aee5b911f1$var$isFunction,
    isStream: $dd87d7aee5b911f1$var$isStream,
    isURLSearchParams: $dd87d7aee5b911f1$var$isURLSearchParams,
    isTypedArray: $dd87d7aee5b911f1$var$isTypedArray,
    isFileList: $dd87d7aee5b911f1$var$isFileList,
    forEach: $dd87d7aee5b911f1$var$forEach,
    merge: $dd87d7aee5b911f1$var$merge,
    extend: $dd87d7aee5b911f1$var$extend,
    trim: $dd87d7aee5b911f1$var$trim,
    stripBOM: $dd87d7aee5b911f1$var$stripBOM,
    inherits: $dd87d7aee5b911f1$var$inherits,
    toFlatObject: $dd87d7aee5b911f1$var$toFlatObject,
    kindOf: $dd87d7aee5b911f1$var$kindOf,
    kindOfTest: $dd87d7aee5b911f1$var$kindOfTest,
    endsWith: $dd87d7aee5b911f1$var$endsWith,
    toArray: $dd87d7aee5b911f1$var$toArray,
    forEachEntry: $dd87d7aee5b911f1$var$forEachEntry,
    matchAll: $dd87d7aee5b911f1$var$matchAll,
    isHTMLForm: $dd87d7aee5b911f1$var$isHTMLForm,
    hasOwnProperty: $dd87d7aee5b911f1$var$hasOwnProperty,
    hasOwnProp: $dd87d7aee5b911f1$var$hasOwnProperty,
    reduceDescriptors: $dd87d7aee5b911f1$var$reduceDescriptors,
    freezeMethods: $dd87d7aee5b911f1$var$freezeMethods,
    toObjectSet: $dd87d7aee5b911f1$var$toObjectSet,
    toCamelCase: $dd87d7aee5b911f1$var$toCamelCase,
    noop: $dd87d7aee5b911f1$var$noop,
    toFiniteNumber: $dd87d7aee5b911f1$var$toFiniteNumber,
    findKey: $dd87d7aee5b911f1$var$findKey,
    global: $dd87d7aee5b911f1$var$_global,
    isContextDefined: $dd87d7aee5b911f1$var$isContextDefined,
    ALPHABET: $dd87d7aee5b911f1$var$ALPHABET,
    generateString: $dd87d7aee5b911f1$var$generateString,
    isSpecCompliantForm: $dd87d7aee5b911f1$var$isSpecCompliantForm,
    toJSONObject: $dd87d7aee5b911f1$var$toJSONObject,
    isAsyncFn: $dd87d7aee5b911f1$var$isAsyncFn,
    isThenable: $dd87d7aee5b911f1$var$isThenable,
    setImmediate: $dd87d7aee5b911f1$var$_setImmediate,
    asap: $dd87d7aee5b911f1$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $5ea015c4d79f37d4$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).inherits($5ea015c4d79f37d4$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $5ea015c4d79f37d4$var$prototype = $5ea015c4d79f37d4$var$AxiosError.prototype;
const $5ea015c4d79f37d4$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $5ea015c4d79f37d4$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($5ea015c4d79f37d4$var$AxiosError, $5ea015c4d79f37d4$var$descriptors);
Object.defineProperty($5ea015c4d79f37d4$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$5ea015c4d79f37d4$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($5ea015c4d79f37d4$var$prototype);
    (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $5ea015c4d79f37d4$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $5ea015c4d79f37d4$export$2e2bcd8739ae039 = $5ea015c4d79f37d4$var$AxiosError;


// eslint-disable-next-line strict
var $e672bf91317ec75e$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
"use strict";
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
"use strict";
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup["-".charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup["_".charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case "ascii":
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case "base64":
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf);
    else return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$8dff54558831dec9$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $4a6eda7d0e4e0857$export$d622b2ad8d90c771($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $91eefa0e9905462d$require$Buffer = $8dff54558831dec9$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $91eefa0e9905462d$var$isVisitable(thing) {
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $91eefa0e9905462d$var$removeBrackets(key) {
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $91eefa0e9905462d$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $91eefa0e9905462d$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $91eefa0e9905462d$var$isFlatArray(arr) {
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(arr) && !arr.some($91eefa0e9905462d$var$isVisitable);
}
const $91eefa0e9905462d$var$predicates = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toFlatObject((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $91eefa0e9905462d$var$toFormData(obj, formData, options) {
    if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $e672bf91317ec75e$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $91eefa0e9905462d$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(value) && $91eefa0e9905462d$var$isFlatArray(value) || ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFileList(value) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $91eefa0e9905462d$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $91eefa0e9905462d$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($91eefa0e9905462d$var$isVisitable(value)) return true;
        formData.append($91eefa0e9905462d$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($91eefa0e9905462d$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $91eefa0e9905462d$var$isVisitable
    });
    function build(value, path) {
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $91eefa0e9905462d$export$2e2bcd8739ae039 = $91eefa0e9905462d$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a8ace30d6be5420f$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a8ace30d6be5420f$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $91eefa0e9905462d$export$2e2bcd8739ae039)(params, this, options);
}
const $a8ace30d6be5420f$var$prototype = $a8ace30d6be5420f$var$AxiosURLSearchParams.prototype;
$a8ace30d6be5420f$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a8ace30d6be5420f$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $a8ace30d6be5420f$var$encode);
    } : $a8ace30d6be5420f$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $a8ace30d6be5420f$export$2e2bcd8739ae039 = $a8ace30d6be5420f$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4fd1af83f2f58271$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $4fd1af83f2f58271$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $4fd1af83f2f58271$var$encode;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $a8ace30d6be5420f$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $32eaa2f57683a696$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $32eaa2f57683a696$export$2e2bcd8739ae039 = $32eaa2f57683a696$var$InterceptorManager;





"use strict";
var $752758ab0a7f5c66$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $355bc59bf705c9c1$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $a8ace30d6be5420f$export$2e2bcd8739ae039);


"use strict";
var $11b43b7e85819944$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $f4103de442339deb$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $e2de44a9ceb94f00$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $355bc59bf705c9c1$export$2e2bcd8739ae039,
        FormData: $11b43b7e85819944$export$2e2bcd8739ae039,
        Blob: $f4103de442339deb$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $39b78c5090c22bee$exports = {};

$parcel$export($39b78c5090c22bee$exports, "hasBrowserEnv", () => $39b78c5090c22bee$export$c4996c4b7b93b0bf);
$parcel$export($39b78c5090c22bee$exports, "navigator", () => $39b78c5090c22bee$export$ec7c8efa7f5790ae);
$parcel$export($39b78c5090c22bee$exports, "hasStandardBrowserEnv", () => $39b78c5090c22bee$export$c0bcc9250309d66);
$parcel$export($39b78c5090c22bee$exports, "hasStandardBrowserWebWorkerEnv", () => $39b78c5090c22bee$export$c81692cf5af97dac);
$parcel$export($39b78c5090c22bee$exports, "origin", () => $39b78c5090c22bee$export$f710a83a91838a36);
const $39b78c5090c22bee$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $39b78c5090c22bee$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $39b78c5090c22bee$export$c0bcc9250309d66 = $39b78c5090c22bee$export$c4996c4b7b93b0bf && (!$39b78c5090c22bee$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($39b78c5090c22bee$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $39b78c5090c22bee$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $39b78c5090c22bee$export$f710a83a91838a36 = $39b78c5090c22bee$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $ea81919fd25bf5ee$export$2e2bcd8739ae039 = {
    ...$39b78c5090c22bee$exports,
    ...(0, $e2de44a9ceb94f00$export$2e2bcd8739ae039)
};


"use strict";
function $30f8a2a6cf953adb$export$2e2bcd8739ae039(data, options) {
    return (0, $91eefa0e9905462d$export$2e2bcd8739ae039)(data, new (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).isNode && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $6a3c091df0d84895$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $6a3c091df0d84895$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $6a3c091df0d84895$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $6a3c091df0d84895$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFormData(formData) && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($6a3c091df0d84895$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $6a3c091df0d84895$export$2e2bcd8739ae039 = $6a3c091df0d84895$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $ef2ca59660cd3355$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $ef2ca59660cd3355$var$defaults = {
    transitional: (0, $752758ab0a7f5c66$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $6a3c091df0d84895$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isBuffer(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isStream(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFile(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isBlob(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $30f8a2a6cf953adb$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $91eefa0e9905462d$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $ef2ca59660cd3355$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $ef2ca59660cd3355$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isResponse(data) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).from(e, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $ef2ca59660cd3355$var$defaults.headers[method] = {};
});
var $ef2ca59660cd3355$export$2e2bcd8739ae039 = $ef2ca59660cd3355$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $291583a5afa8db94$var$ignoreDuplicateOf = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $291583a5afa8db94$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $291583a5afa8db94$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $48690bd6ad3e07ee$var$$internals = Symbol("internals");
function $48690bd6ad3e07ee$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $48690bd6ad3e07ee$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(value) ? value.map($48690bd6ad3e07ee$var$normalizeValue) : String(value);
}
function $48690bd6ad3e07ee$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $48690bd6ad3e07ee$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $48690bd6ad3e07ee$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $48690bd6ad3e07ee$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $48690bd6ad3e07ee$var$buildAccessors(obj, header) {
    const accessorName = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $48690bd6ad3e07ee$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $48690bd6ad3e07ee$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $48690bd6ad3e07ee$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$48690bd6ad3e07ee$var$isValidHeaderName(header)) setHeaders((0, $291583a5afa8db94$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $48690bd6ad3e07ee$var$normalizeHeader(header);
        if (header) {
            const key = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $48690bd6ad3e07ee$var$parseTokens(value);
                if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $48690bd6ad3e07ee$var$normalizeHeader(header);
        if (header) {
            const key = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $48690bd6ad3e07ee$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $48690bd6ad3e07ee$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $48690bd6ad3e07ee$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $48690bd6ad3e07ee$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $48690bd6ad3e07ee$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $48690bd6ad3e07ee$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $48690bd6ad3e07ee$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$48690bd6ad3e07ee$var$$internals] = this[$48690bd6ad3e07ee$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $48690bd6ad3e07ee$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $48690bd6ad3e07ee$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$48690bd6ad3e07ee$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).reduceDescriptors($48690bd6ad3e07ee$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).freezeMethods($48690bd6ad3e07ee$var$AxiosHeaders);
var $48690bd6ad3e07ee$export$2e2bcd8739ae039 = $48690bd6ad3e07ee$var$AxiosHeaders;


"use strict";
function $911997d73ecb1b76$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $ef2ca59660cd3355$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $448296c149bd8ddc$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $6c2f3c73d6d5f6ef$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).inherits($6c2f3c73d6d5f6ef$var$CanceledError, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039 = $6c2f3c73d6d5f6ef$var$CanceledError;







"use strict";
function $55c8e0f1225ee9af$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $efa8df7222ed1688$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d372d424fc163558$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d372d424fc163558$export$2e2bcd8739ae039 = $d372d424fc163558$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $29c7b59ddef676ee$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $29c7b59ddef676ee$export$2e2bcd8739ae039 = $29c7b59ddef676ee$var$throttle;



const $88d62766b1643c16$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $d372d424fc163558$export$2e2bcd8739ae039)(50, 250);
    return (0, $29c7b59ddef676ee$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $88d62766b1643c16$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $88d62766b1643c16$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $13f2a6fa0ac73c37$export$2e2bcd8739ae039 = (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).origin), (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $137fb9d8cf1263fb$export$2e2bcd8739ae039 = (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $eba4b00fb694fb37$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $342b126be5d771fa$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $e6f70ed6e6c8e983$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $eba4b00fb694fb37$export$2e2bcd8739ae039)(requestedURL)) return (0, $342b126be5d771fa$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $f81b12bbdaede375$var$headersToObject = (thing)=>thing instanceof (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f81b12bbdaede375$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isPlainObject(target) && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f81b12bbdaede375$var$headersToObject(a), $f81b12bbdaede375$var$headersToObject(b), prop, true)
    };
    (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $3ac8458f32a7eabb$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f81b12bbdaede375$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $4fd1af83f2f58271$export$2e2bcd8739ae039)((0, $e6f70ed6e6c8e983$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $13f2a6fa0ac73c37$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $137fb9d8cf1263fb$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $e2ad59241befd87c$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $e2ad59241befd87c$export$2e2bcd8739ae039 = $e2ad59241befd87c$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $3ac8458f32a7eabb$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $55c8e0f1225ee9af$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Request aborted", (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Network Error", (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $752758ab0a7f5c66$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ETIMEDOUT : (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $88d62766b1643c16$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $88d62766b1643c16$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $efa8df7222ed1688$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $8b87899adf041493$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039) ? err : new (0, $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $8b87899adf041493$export$2e2bcd8739ae039 = $8b87899adf041493$var$composeSignals;


const $0a6968d914447494$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $0a6968d914447494$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $0a6968d914447494$var$readStream(iterable))yield* $0a6968d914447494$export$71b051935044bd5d(chunk, chunkSize);
};
const $0a6968d914447494$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $0a6968d914447494$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $0a6968d914447494$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $cac6cc68d9700abe$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $cac6cc68d9700abe$var$isReadableStreamSupported = $cac6cc68d9700abe$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $cac6cc68d9700abe$var$encodeText = $cac6cc68d9700abe$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $cac6cc68d9700abe$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $cac6cc68d9700abe$var$supportsRequestStream = $cac6cc68d9700abe$var$isReadableStreamSupported && $cac6cc68d9700abe$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $cac6cc68d9700abe$var$DEFAULT_CHUNK_SIZE = 65536;
const $cac6cc68d9700abe$var$supportsResponseStream = $cac6cc68d9700abe$var$isReadableStreamSupported && $cac6cc68d9700abe$var$test(()=>(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $cac6cc68d9700abe$var$resolvers = {
    stream: $cac6cc68d9700abe$var$supportsResponseStream && ((res)=>res.body)
};
$cac6cc68d9700abe$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$cac6cc68d9700abe$var$resolvers[type] && ($cac6cc68d9700abe$var$resolvers[type] = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $cac6cc68d9700abe$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $ea81919fd25bf5ee$export$2e2bcd8739ae039).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(body)) return (await $cac6cc68d9700abe$var$encodeText(body)).byteLength;
};
const $cac6cc68d9700abe$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $cac6cc68d9700abe$var$getBodyLength(body) : length;
};
var $cac6cc68d9700abe$export$2e2bcd8739ae039 = $cac6cc68d9700abe$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $3ac8458f32a7eabb$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $8b87899adf041493$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $cac6cc68d9700abe$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $cac6cc68d9700abe$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $88d62766b1643c16$export$d9fadd12586c18d6)(requestContentLength, (0, $88d62766b1643c16$export$c1b28109d46c3592)((0, $88d62766b1643c16$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $0a6968d914447494$export$b0119225647bd83)(_request.body, $cac6cc68d9700abe$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $cac6cc68d9700abe$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($cac6cc68d9700abe$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $88d62766b1643c16$export$d9fadd12586c18d6)(responseContentLength, (0, $88d62766b1643c16$export$c1b28109d46c3592)((0, $88d62766b1643c16$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $0a6968d914447494$export$b0119225647bd83)(response.body, $cac6cc68d9700abe$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $cac6cc68d9700abe$var$resolvers[(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).findKey($cac6cc68d9700abe$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $55c8e0f1225ee9af$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Network Error", (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $f045b92bde59d4db$var$knownAdapters = {
    http: (0, $e672bf91317ec75e$export$2e2bcd8739ae039),
    xhr: (0, $e2ad59241befd87c$export$2e2bcd8739ae039),
    fetch: (0, $cac6cc68d9700abe$export$2e2bcd8739ae039)
};
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach($f045b92bde59d4db$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $f045b92bde59d4db$var$renderReason = (reason)=>`- ${reason}`;
const $f045b92bde59d4db$var$isResolvedHandle = (adapter)=>(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $f045b92bde59d4db$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f045b92bde59d4db$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f045b92bde59d4db$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($f045b92bde59d4db$var$renderReason).join("\n") : " " + $f045b92bde59d4db$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $f045b92bde59d4db$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $ea0b54f24b63fdde$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039)(null, config);
}
function $ea0b54f24b63fdde$export$2e2bcd8739ae039(config) {
    $ea0b54f24b63fdde$var$throwIfCancellationRequested(config);
    config.headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $911997d73ecb1b76$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $f045b92bde59d4db$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $ef2ca59660cd3355$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $ea0b54f24b63fdde$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $911997d73ecb1b76$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $448296c149bd8ddc$export$2e2bcd8739ae039)(reason)) {
            $ea0b54f24b63fdde$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $911997d73ecb1b76$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $423f3e33bc14b731$export$a4ad2735b021c132 = "1.7.9";



"use strict";
const $e5581fe52505dda0$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $e5581fe52505dda0$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $e5581fe52505dda0$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $e5581fe52505dda0$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $423f3e33bc14b731$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$e5581fe52505dda0$var$deprecatedWarnings[opt]) {
            $e5581fe52505dda0$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$e5581fe52505dda0$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $e5581fe52505dda0$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("options must be an object", (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $e5581fe52505dda0$export$2e2bcd8739ae039 = {
    assertOptions: $e5581fe52505dda0$var$assertOptions,
    validators: $e5581fe52505dda0$var$validators
};



"use strict";
const $9b4f9b19ff2e012e$var$validators = (0, $e5581fe52505dda0$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $9b4f9b19ff2e012e$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $32eaa2f57683a696$export$2e2bcd8739ae039)(),
            response: new (0, $32eaa2f57683a696$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f81b12bbdaede375$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $e5581fe52505dda0$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $9b4f9b19ff2e012e$var$validators.transitional($9b4f9b19ff2e012e$var$validators.boolean),
            forcedJSONParsing: $9b4f9b19ff2e012e$var$validators.transitional($9b4f9b19ff2e012e$var$validators.boolean),
            clarifyTimeoutError: $9b4f9b19ff2e012e$var$validators.transitional($9b4f9b19ff2e012e$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $e5581fe52505dda0$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $9b4f9b19ff2e012e$var$validators.function,
                serialize: $9b4f9b19ff2e012e$var$validators.function
            }, true);
        }
        (0, $e5581fe52505dda0$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $9b4f9b19ff2e012e$var$validators.spelling("baseURL"),
            withXsrfToken: $9b4f9b19ff2e012e$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $ea0b54f24b63fdde$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $ea0b54f24b63fdde$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f81b12bbdaede375$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $e6f70ed6e6c8e983$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $4fd1af83f2f58271$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $9b4f9b19ff2e012e$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f81b12bbdaede375$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f81b12bbdaede375$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $9b4f9b19ff2e012e$var$Axios.prototype[method] = generateHTTPMethod();
    $9b4f9b19ff2e012e$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $9b4f9b19ff2e012e$export$2e2bcd8739ae039 = $9b4f9b19ff2e012e$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $7ba83383195eb7dd$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $7ba83383195eb7dd$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $7ba83383195eb7dd$export$2e2bcd8739ae039 = $7ba83383195eb7dd$var$CancelToken;






"use strict";
function $23fef0d39f41681f$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $fe1e4f499686cc9d$export$2e2bcd8739ae039(payload) {
    return (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $0e01926db91ea959$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($0e01926db91ea959$var$HttpStatusCode).forEach(([key, value])=>{
    $0e01926db91ea959$var$HttpStatusCode[value] = key;
});
var $0e01926db91ea959$export$2e2bcd8739ae039 = $0e01926db91ea959$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $740c54350e180ee0$var$createInstance(defaultConfig) {
    const context = new (0, $9b4f9b19ff2e012e$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $6d5e785c5f814af7$export$2e2bcd8739ae039)((0, $9b4f9b19ff2e012e$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).extend(instance, (0, $9b4f9b19ff2e012e$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $740c54350e180ee0$var$createInstance((0, $f81b12bbdaede375$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $740c54350e180ee0$var$axios = $740c54350e180ee0$var$createInstance((0, $ef2ca59660cd3355$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$740c54350e180ee0$var$axios.Axios = (0, $9b4f9b19ff2e012e$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$740c54350e180ee0$var$axios.CanceledError = (0, $6c2f3c73d6d5f6ef$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.CancelToken = (0, $7ba83383195eb7dd$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.isCancel = (0, $448296c149bd8ddc$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.VERSION = (0, $423f3e33bc14b731$export$a4ad2735b021c132);
$740c54350e180ee0$var$axios.toFormData = (0, $91eefa0e9905462d$export$2e2bcd8739ae039);
// Expose AxiosError class
$740c54350e180ee0$var$axios.AxiosError = (0, $5ea015c4d79f37d4$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$740c54350e180ee0$var$axios.Cancel = $740c54350e180ee0$var$axios.CanceledError;
// Expose all/spread
$740c54350e180ee0$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$740c54350e180ee0$var$axios.spread = (0, $23fef0d39f41681f$export$2e2bcd8739ae039);
// Expose isAxiosError
$740c54350e180ee0$var$axios.isAxiosError = (0, $fe1e4f499686cc9d$export$2e2bcd8739ae039);
// Expose mergeConfig
$740c54350e180ee0$var$axios.mergeConfig = (0, $f81b12bbdaede375$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.AxiosHeaders = (0, $48690bd6ad3e07ee$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.formToJSON = (thing)=>(0, $6a3c091df0d84895$export$2e2bcd8739ae039)((0, $dd87d7aee5b911f1$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$740c54350e180ee0$var$axios.getAdapter = (0, $f045b92bde59d4db$export$2e2bcd8739ae039).getAdapter;
$740c54350e180ee0$var$axios.HttpStatusCode = (0, $0e01926db91ea959$export$2e2bcd8739ae039);
$740c54350e180ee0$var$axios.default = $740c54350e180ee0$var$axios;
var // this module should only have a default export
$740c54350e180ee0$export$2e2bcd8739ae039 = $740c54350e180ee0$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $31b617b2b2526a86$export$1c00760e9e5a4e95, AxiosError: $31b617b2b2526a86$export$c1fbed17c2f6a328, CanceledError: $31b617b2b2526a86$export$1ab0c6b20d94fa14, isCancel: $31b617b2b2526a86$export$3b22524397b493c6, CancelToken: $31b617b2b2526a86$export$fd08e3cb425f0d61, VERSION: $31b617b2b2526a86$export$a4ad2735b021c132, all: $31b617b2b2526a86$export$84bf76cd7afc7469, Cancel: $31b617b2b2526a86$export$848c9b7ead0df967, isAxiosError: $31b617b2b2526a86$export$fbafdbe06a5b5a9a, spread: $31b617b2b2526a86$export$3ae0fd4797ed47c8, toFormData: $31b617b2b2526a86$export$10ae0d317ea97f8b, AxiosHeaders: $31b617b2b2526a86$export$4e7d6ff0f3e6520, HttpStatusCode: $31b617b2b2526a86$export$a972f69c851492b3, formToJSON: $31b617b2b2526a86$export$86d7c59254d6a2c9, getAdapter: $31b617b2b2526a86$export$17ddc20a97d669e2, mergeConfig: $31b617b2b2526a86$export$7ec1ebcfa9d8bd6a } = (0, $740c54350e180ee0$export$2e2bcd8739ae039);



// Base API URL that adapts to the environment
const $913d3a1574de567c$export$c3ee1e672e1e24e7 = "/api";
// Custom error class for processing errors
class $913d3a1574de567c$var$ProcessingError extends Error {
    constructor(message){
        super(message);
        this.name = "ProcessingError";
    }
}
// Auto logout function reference (will be set from inference.js)
let $913d3a1574de567c$var$autoLogoutCallback = null;
// Authentication status (will be set from inference.js)
let $913d3a1574de567c$var$isAuthenticationEnabled = true; // Default to true for safety
// Logout state tracking to prevent multiple simultaneous logouts
let $913d3a1574de567c$var$isLoggingOut = false;
let $913d3a1574de567c$var$logoutTimestamp = 0;
// Set up axios response interceptor to handle 401 errors globally
(0, $740c54350e180ee0$export$2e2bcd8739ae039).interceptors.response.use((response)=>{
    // Return successful responses as-is
    return response;
}, (error)=>{
    // Handle 401 Unauthorized responses
    if (error.response && error.response.status === 401) {
        console.log("\uD83D\uDEAA Received 401 response - checking auth status...");
        // Only trigger logout if authentication is enabled and not already logging out
        if ($913d3a1574de567c$var$isAuthenticationEnabled && !$913d3a1574de567c$var$isLoggingOut) {
            const now = Date.now();
            // Prevent rapid successive logout attempts (within 5 seconds)
            if (now - $913d3a1574de567c$var$logoutTimestamp < 5000) {
                console.log("\uD83D\uDEAA Recent logout attempt - skipping duplicate for 401");
                return Promise.reject(error);
            }
            console.log("\uD83D\uDEAA Authentication enabled - triggering auto logout");
            $913d3a1574de567c$var$isLoggingOut = true;
            $913d3a1574de567c$var$logoutTimestamp = now;
            // Call the auto logout callback if available
            if ($913d3a1574de567c$var$autoLogoutCallback) // Use setTimeout to prevent immediate re-entry and allow other requests to see the logout state
            setTimeout(()=>{
                $913d3a1574de567c$var$autoLogoutCallback();
            }, 100);
            else {
                // Fallback: clear token cookie and show error
                document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
                console.warn("Auto logout callback not set - token cleared");
                setTimeout(()=>{
                    $913d3a1574de567c$var$isLoggingOut = false;
                }, 2000);
            }
        } else if ($913d3a1574de567c$var$isLoggingOut) console.log("\uD83D\uDEAA Already logging out - skipping duplicate logout for 401");
        else console.log("\uD83D\uDEAA Authentication disabled - skipping auto logout for 401");
    }
    // Re-throw the error for the caller to handle
    return Promise.reject(error);
});
/**
 * Set the auto logout callback function
 * @param {Function} callback - Function to call on 401 responses
 */ function $913d3a1574de567c$export$b113a2854fcb981c(callback) {
    $913d3a1574de567c$var$autoLogoutCallback = callback;
}
/**
 * Set the authentication enabled status
 * @param {boolean} enabled - Whether authentication is enabled
 */ function $913d3a1574de567c$export$a71129c14700d3e(enabled) {
    $913d3a1574de567c$var$isAuthenticationEnabled = enabled;
}
/**
 * Get access token from the most reliable source (prioritizing input field, fallback to cookie)
 * @returns {string|null} Access token or null if not found/invalid
 */ function $913d3a1574de567c$export$84773cc9bf7dbe87() {
    // First try to get from input field (most up-to-date)
    const accessTokenInput = document.getElementById("access-token");
    let token = accessTokenInput?.value;
    // If input field is empty or invalid, try cookie
    if (!token || token.trim() === "" || token === "null" || token === "undefined") {
        const cookieToken = document.cookie.split("; ").find((row)=>row.startsWith("access_token="));
        if (cookieToken) token = cookieToken.split("=")[1];
    }
    // Validate token
    if (!token || token.trim() === "" || token === "null" || token === "undefined") return null;
    return token;
}
/**
 * Synchronize token between cookie and input field
 * @param {string|null} token - Token to sync (if null, will clear both)
 */ function $913d3a1574de567c$export$c0081454efbc7134(token) {
    const accessTokenInput = document.getElementById("access-token");
    if (token && token !== "null" && token !== "undefined") {
        // Set cookie with token
        document.cookie = `access_token=${token}; path=/; SameSite=Lax`;
        // Set input field
        if (accessTokenInput) accessTokenInput.value = token;
    } else {
        // Clear both cookie and input field
        document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        if (accessTokenInput) accessTokenInput.value = "";
    }
}
/**
 * Reset logout state (called after successful logout)
 */ function $913d3a1574de567c$export$620bbc03f95a612f() {
    $913d3a1574de567c$var$isLoggingOut = false;
    $913d3a1574de567c$var$logoutTimestamp = 0;
}
/**
 * API Service class to handle all API interactions
 */ class $913d3a1574de567c$export$ae14c375fc93363 {
    /**
     * Check if access token is valid and trigger logout if empty
     * @param {boolean} triggerLogout - Whether to trigger auto logout on invalid token
     * @returns {boolean} True if token is valid, false otherwise
     */ static isAccessTokenValid(triggerLogout = true) {
        const accessToken = $913d3a1574de567c$export$84773cc9bf7dbe87();
        const isTokenEmpty = !accessToken;
        if (isTokenEmpty && triggerLogout && $913d3a1574de567c$var$autoLogoutCallback && $913d3a1574de567c$var$isAuthenticationEnabled && !$913d3a1574de567c$var$isLoggingOut) {
            console.log("\uD83D\uDEAA Empty access token detected - triggering auto logout");
            const now = Date.now();
            if (now - $913d3a1574de567c$var$logoutTimestamp >= 5000) {
                // Prevent rapid successive calls
                $913d3a1574de567c$var$isLoggingOut = true;
                $913d3a1574de567c$var$logoutTimestamp = now;
                setTimeout(()=>$913d3a1574de567c$var$autoLogoutCallback(), 100);
            }
            return false;
        }
        return !isTokenEmpty;
    }
    /**
     * Validate access token on page load and trigger logout if invalid
     * Should be called during application initialization
     */ static async validateTokenOnLoad() {
        console.log("\uD83D\uDD10 Validating access token on load...");
        // Get token and sync if found
        const accessToken = $913d3a1574de567c$export$84773cc9bf7dbe87();
        if (accessToken) $913d3a1574de567c$export$c0081454efbc7134(accessToken); // Ensure cookie and input field are synchronized
        // Check if we have a valid token
        if (!this.isAccessTokenValid(false)) {
            console.log("\uD83D\uDEAA Invalid access token on load - checking auth status...");
            if ($913d3a1574de567c$var$autoLogoutCallback && $913d3a1574de567c$var$isAuthenticationEnabled && !$913d3a1574de567c$var$isLoggingOut) {
                console.log("\uD83D\uDEAA Authentication enabled - triggering auto logout");
                $913d3a1574de567c$var$isLoggingOut = true;
                $913d3a1574de567c$var$logoutTimestamp = Date.now();
                setTimeout(()=>$913d3a1574de567c$var$autoLogoutCallback(), 100);
            } else if (!$913d3a1574de567c$var$isAuthenticationEnabled) console.log("\uD83D\uDEAA Authentication disabled - skipping auto logout for invalid token");
            return false;
        }
        console.log("\u2705 Access token validation passed");
        return true;
    }
    /**
     * Get the authorization header using the access token
     * @returns {Object} Headers object with Authorization
     */ static getAuthHeaders() {
        // Check token validity before returning headers
        this.isAccessTokenValid();
        const accessToken = $913d3a1574de567c$export$84773cc9bf7dbe87();
        return {
            Authorization: accessToken ? `Bearer ${accessToken}` : ""
        };
    }
    /**
     * Get system status
     * @returns {Promise} Promise with system status data
     */ static async getSystemStatus() {
        try {
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).get(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/system-status`);
            return response.data;
        } catch (error) {
            console.error("Error getting system status:", error);
            throw error;
        }
    }
    /**
     * Get feedback configuration
     * @returns {Promise} Promise with feedback configuration data
     */ static async getFeedbackConfig() {
        try {
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).get(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/feedback-config`, {
                headers: {
                    ...this.getAuthHeaders()
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error getting feedback config:", error);
            throw error;
        }
    }
    /**
     * Upload a file for processing (supports both file upload and Azure path)
     * @param {File|null} file - The file to upload (for file mode)
     * @param {string|null} azurePath - The Azure blob path (for Azure mode)
     * @param {string} modelType - The model type to use (teethml, defectml, keypointml, etc.)
     * @param {string} jawSelection - The jaw selection (upper, lower)
     * @param {boolean} autoOrientation - TeethML only: rotate a scan exported with a
     *     different axis convention into the frame the models were trained in
     * @returns {Promise} Promise with upload response data
     */ static async uploadForProcessing(file, azurePath, modelType, jawSelection, autoOrientation = true) {
        try {
            const formData = new FormData();
            formData.append("model", modelType);
            formData.append("jaw", jawSelection);
            if (modelType === "teethml") formData.append("auto_orientation", String(autoOrientation));
            if (file) formData.append("file", file);
            else if (azurePath) formData.append("azure_path", azurePath);
            else throw new Error("Either file or Azure path must be provided");
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).post(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    ...this.getAuthHeaders()
                }
            });
            // Log response for debugging
            console.log("Upload response:", response.data);
            if (response.data.warning) console.log("Warning in response:", response.data.warning);
            // Return response data with warning if present
            return response.data;
        } catch (error) {
            console.error("Error uploading file:", error);
            // Extract detailed error message from response
            if (error.response && error.response.data) {
                const errorDetail = error.response.data.detail || error.response.data.message || error.message;
                const enhancedError = new Error(errorDetail);
                enhancedError.response = error.response;
                enhancedError.status = error.response.status;
                throw enhancedError;
            }
            throw error;
        }
    }
    /**
     * Validate file type for model (without processing)
     * @param {File|null} file - The file to validate (for file mode)
     * @param {string|null} azurePath - The Azure blob path (for Azure mode)
     * @param {string} modelType - Model type ('teethml', 'defectml', 'keypointml')
     * @param {string|null} jawSelection - Jaw selection ('upper' or 'lower')
     * @returns {Promise} Promise with validation response containing optional warning
     */ static async validateFileType(file, azurePath, modelType, jawSelection = null) {
        try {
            const formData = new FormData();
            formData.append("model", modelType);
            if (jawSelection) formData.append("jaw", jawSelection);
            if (file) formData.append("file", file);
            else if (azurePath) formData.append("azure_path", azurePath);
            else throw new Error("Either file or Azure path must be provided");
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).post(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/validate-file-type`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    ...this.getAuthHeaders()
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error validating file type:", error);
            // Don't throw - validation errors shouldn't block file selection
            return {};
        }
    }
    /**
     * List the immediate files in a single Azure folder (prefix).
     * @param {string} folderPath - The Azure folder path (e.g. "azure://container/case/model/")
     * @returns {Promise<Object>} { folder, container, prefix, files: [{ name, key, reference, size }] }
     * @throws Rethrows so the caller can surface the resolution error to the user.
     */ static async listAzureFolder(folderPath) {
        try {
            const formData = new FormData();
            formData.append("folder_path", folderPath);
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).post(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/list-azure-folder`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    ...this.getAuthHeaders()
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error listing Azure folder:", error);
            throw error;
        }
    }
    /**
     * Upload files for teeth reconstruction (supports both file upload and Azure path)
     * @param {File|null} meshFile - The mesh file (for file mode)
     * @param {string|null} meshAzurePath - The Azure blob path for mesh file (for Azure mode)
     * @param {File|Blob|null} labelsFile - The labels file (optional, for file mode)
     * @param {string|null} labelsAzurePath - The Azure blob path for labels file (optional, for Azure mode)
     * @returns {Promise} Promise with upload response data
     */ static async uploadForReconstruction(meshFile, meshAzurePath, labelsFile = null, labelsAzurePath = null) {
        try {
            const formData = new FormData();
            if (meshFile) formData.append("file", meshFile);
            else if (meshAzurePath) formData.append("azure_path", meshAzurePath);
            else throw new Error("Either mesh file or Azure path must be provided");
            if (labelsFile) formData.append("labels_file", labelsFile);
            else if (labelsAzurePath) formData.append("labels_azure_path", labelsAzurePath);
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).post(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/reconstruct`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    ...this.getAuthHeaders()
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error uploading for reconstruction:", error);
            throw error;
        }
    }
    /**
     * Upload files for teeth arrangement (supports both file upload and Azure path)
     * @param {File|null} primaryFile - The primary file (.obj or .pth) (for file mode)
     * @param {string|null} primaryAzurePath - The Azure blob path for primary file (for Azure mode)
     * @param {File|null} pairedFile - The paired file (optional, for jaw arrangement, for file mode)
     * @param {string|null} pairedAzurePath - The Azure blob path for paired file (optional, for Azure mode)
     * @param {File|null} infoJsonFile - Optional InfoJSON file (for file mode)
     * @param {string|null} infoJsonAzurePath - Optional InfoJSON Azure path (for Azure mode)
     * @param {File|null} landmarksCsvFile - Optional malocclusion landmarks CSV file (for file mode)
     * @param {string|null} landmarksCsvAzurePath - Optional malocclusion landmarks CSV Azure path (for Azure mode)
     * @param {Object} options - Arrangement options (config_file, weight_file, postprocessing, etc.)
     * @param {boolean} enablePostprocessing - Enable postprocessing flag (default: false)
     * @returns {Promise} Promise with upload response data
     */ static async uploadForArrangement(primaryFile, primaryAzurePath, pairedFile = null, pairedAzurePath = null, infoJsonFile = null, infoJsonAzurePath = null, landmarksCsvFile = null, landmarksCsvAzurePath = null, options = {}, enablePostprocessing = false, enableLeveling = false) {
        try {
            const formData = new FormData();
            if (primaryFile) formData.append("file", primaryFile);
            else if (primaryAzurePath) formData.append("azure_path", primaryAzurePath);
            else throw new Error("Either primary file or Azure path must be provided");
            if (pairedFile) formData.append("paired_file", pairedFile);
            else if (pairedAzurePath) formData.append("paired_azure_path", pairedAzurePath);
            // Add optional InfoJSON file or Azure path
            if (infoJsonFile) formData.append("info_json_file", infoJsonFile);
            else if (infoJsonAzurePath) formData.append("info_json_azure_path", infoJsonAzurePath);
            // Add optional landmarks CSV file or Azure path
            if (landmarksCsvFile) formData.append("landmarks_csv_file", landmarksCsvFile);
            else if (landmarksCsvAzurePath) formData.append("landmarks_csv_azure_path", landmarksCsvAzurePath);
            formData.append("options", JSON.stringify(options));
            formData.append("enable_postprocessing", enablePostprocessing ? "true" : "false");
            formData.append("enable_leveling", enableLeveling ? "true" : "false");
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).post(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/arrangement`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    ...this.getAuthHeaders()
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error uploading for arrangement:", error);
            throw error;
        }
    }
    /**
     * Upload inputs for arrangement refinement without model inference.
     * @param {File|null} primaryFile - Lower jaw OBJ file
     * @param {string|null} primaryAzurePath - Lower jaw Azure path
     * @param {File|null} pairedFile - Upper jaw OBJ file
     * @param {string|null} pairedAzurePath - Upper jaw Azure path
     * @param {Blob|File} infoJsonFile - Current arrangement InfoJSON
     * @param {File|null} landmarksCsvFile - Optional landmarks CSV file
     * @param {string|null} landmarksCsvAzurePath - Optional landmarks CSV Azure path
     * @param {Object} options - Postprocessing options payload
     * @returns {Promise<Object>}
     */ static async uploadForArrangementRefine(primaryFile, primaryAzurePath, pairedFile, pairedAzurePath, infoJsonFile, landmarksCsvFile = null, landmarksCsvAzurePath = null, options = {}) {
        try {
            const formData = new FormData();
            if (primaryFile) formData.append("file", primaryFile);
            else if (primaryAzurePath) formData.append("azure_path", primaryAzurePath);
            else throw new Error("Either primary file or Azure path must be provided");
            if (pairedFile) formData.append("paired_file", pairedFile);
            else if (pairedAzurePath) formData.append("paired_azure_path", pairedAzurePath);
            if (!infoJsonFile) throw new Error("Arrangement refine requires current InfoJSON");
            formData.append("info_json_file", infoJsonFile, "arrangement_info.json");
            if (landmarksCsvFile) formData.append("landmarks_csv_file", landmarksCsvFile);
            else if (landmarksCsvAzurePath) formData.append("landmarks_csv_azure_path", landmarksCsvAzurePath);
            formData.append("options", JSON.stringify(options));
            formData.append("enable_postprocessing", "true");
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).post(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/arrangement/refine`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    ...this.getAuthHeaders()
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error uploading for arrangement refine:", error);
            throw error;
        }
    }
    /**
     * Upload inputs for leveling refinement (no model inference).
     * Mirrors uploadForArrangementRefine but targets POST /api/arrangement/level
     * with the LevelingRefiner-specific options payload (options.leveling).
     */ static async uploadForArrangementLevel(primaryFile, primaryAzurePath, pairedFile, pairedAzurePath, infoJsonFile, landmarksCsvFile = null, landmarksCsvAzurePath = null, options = {}) {
        try {
            const formData = new FormData();
            if (primaryFile) formData.append("file", primaryFile);
            else if (primaryAzurePath) formData.append("azure_path", primaryAzurePath);
            else throw new Error("Either primary file or Azure path must be provided");
            if (pairedFile) formData.append("paired_file", pairedFile);
            else if (pairedAzurePath) formData.append("paired_azure_path", pairedAzurePath);
            if (!infoJsonFile) throw new Error("Arrangement level requires current InfoJSON");
            formData.append("info_json_file", infoJsonFile, "arrangement_info.json");
            if (landmarksCsvFile) formData.append("landmarks_csv_file", landmarksCsvFile);
            else if (landmarksCsvAzurePath) formData.append("landmarks_csv_azure_path", landmarksCsvAzurePath);
            formData.append("options", JSON.stringify(options));
            formData.append("enable_leveling", "true");
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).post(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/arrangement/level`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    ...this.getAuthHeaders()
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error uploading for arrangement level:", error);
            throw error;
        }
    }
    /**
     * Check processing status
     * @param {string} itemId - The processing item ID
     * @returns {Promise} Promise with status data
     */ static async checkStatus(itemId) {
        try {
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).get(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/status/${itemId}`);
            return response.data;
        } catch (error) {
            console.error("Error checking status:", error);
            throw error;
        }
    }
    /**
     * Poll status until completion or timeout
     * @param {string} itemId - The processing item ID
     * @param {function} progressCallback - Callback to update progress (percent, timeRemaining)
     * @param {number} estimatedTime - Estimated processing time in seconds
     * @param {number} startTime - Processing start time (milliseconds)
     * @param {boolean} decodeResult - Whether to decode the result (default: true)
     * @returns {Promise} Promise with final result data
     */ static async pollUntilCompletion(itemId, progressCallback, estimatedTime, startTime, decodeResult = true) {
        let status = "processing";
        let pollCount = 0;
        console.log(`Starting polling for item ${itemId}, estimated time: ${estimatedTime}s (no timeout)`);
        while(status === "processing"){
            await new Promise((resolve)=>setTimeout(resolve, 2000)); // Wait 2 seconds
            try {
                const statusData = await this.checkStatus(itemId);
                status = statusData.status;
                pollCount++;
                console.log(`Poll ${pollCount}: status = ${status}`);
                // Calculate remaining time
                const elapsedSeconds = (Date.now() - startTime) / 1000;
                const timeRemaining = Math.max(0, Math.round(estimatedTime - elapsedSeconds));
                // Calculate progress percentage (10-90%)
                const timeBasedProgress = (estimatedTime - timeRemaining) / estimatedTime * 100;
                const progressPercent = Math.max(10, Math.min(90, timeBasedProgress));
                // Decide on time display text
                let timeDisplay;
                if (elapsedSeconds > estimatedTime) timeDisplay = "Taking longer than expected...";
                else if (timeRemaining <= estimatedTime * 0.1) timeDisplay = "Almost done here...";
                else timeDisplay = `Est. time: ~${timeRemaining}s`;
                if (progressCallback) progressCallback(progressPercent, timeDisplay);
                if (status === "completed") {
                    console.log(`Processing completed after ${pollCount} polls (${Math.round(elapsedSeconds)}s)`);
                    if (progressCallback) progressCallback(100, 0); // Complete
                    // Return decoded or raw result based on parameter
                    return decodeResult ? (0, $268abebfadfa5867$export$e2db2a8c20f5e55a)(statusData.result) : statusData.result;
                } else if (status === "error") {
                    console.error(`Processing failed after ${pollCount} polls:`, statusData.error_reason);
                    // This is a processing error from the server - throw immediately
                    const errorMessage = statusData.error_reason || "Processing failed";
                    throw new $913d3a1574de567c$var$ProcessingError(errorMessage);
                }
            } catch (error) {
                // If this is a 401 error, it will be handled by the axios interceptor
                if (error.response && error.response.status === 401) {
                    console.error("Authentication error during polling");
                    throw error; // Let auth errors bubble up immediately
                } else if (error instanceof $913d3a1574de567c$var$ProcessingError) {
                    // This is a processing error from the server, not a network error
                    console.error("Server processing error:", error.message);
                    throw new Error(error.message);
                } else if (error.response) {
                    // HTTP error response - this is likely a temporary server issue, continue polling
                    console.warn(`HTTP error during polling (attempt ${pollCount}):`, error.response.status, error.message);
                    continue;
                } else {
                    // Network error or other connectivity issue - continue polling
                    console.warn(`Network error during polling (attempt ${pollCount}):`, error.message);
                    continue;
                }
            }
        }
        // This should never be reached due to the infinite loop, but kept for safety
        throw new Error(`Processing ended with unexpected status: ${status}`);
    }
    /**
     * Submit feedback data to the server
     * @param {FormData} formData - FormData containing feedback and files
     * @returns {Promise} Promise with submission response data
     */ static async submitFeedback(formData) {
        try {
            console.log("\uD83D\uDCDD Submitting feedback to server...");
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).post(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/feedback`, formData, {
                headers: {
                    ...this.getAuthHeaders()
                },
                // Set a longer timeout for file uploads
                timeout: 300000 // 5 minutes
            });
            console.log("\uD83D\uDCDD Feedback submitted successfully:", response.data);
            return response.data;
        } catch (error) {
            console.error("\uD83D\uDCDD Error submitting feedback:", error);
            if (error.response) {
                // Server responded with error status
                const errorMessage = error.response.data?.detail || error.response.data?.message || `Server error (${error.response.status})`;
                throw new Error(errorMessage);
            } else if (error.request) // Request was made but no response received
            throw new Error("No response from server. Please check your connection.");
            else // Something else happened
            throw new Error(error.message || "Unknown error occurred");
        }
    }
    /**
     * Record an arrangement InfoJSON accept/reject review decision.
     * The write is blocking on the server: the returned promise rejects if the
     * decision could not be persisted, so callers must not download on failure.
     * The reason for a rejection is captured separately via the feedback form.
     * @param {string} itemId - The task/item id of the arrangement job
     * @param {string} decision - "accept" or "reject"
     * @returns {Promise} Promise with the recorded decision
     */ static async submitReviewDecision(itemId, decision) {
        try {
            const formData = new FormData();
            formData.append("item_id", itemId);
            formData.append("decision", decision);
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).post(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/arrangement/review`, formData, {
                headers: {
                    ...this.getAuthHeaders()
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error recording review decision:", error);
            if (error.response) {
                const errorMessage = error.response.data?.detail || error.response.data?.message || `Server error (${error.response.status})`;
                throw new Error(errorMessage);
            } else if (error.request) throw new Error("No response from server. Please check your connection.");
            else throw new Error(error.message || "Unknown error occurred");
        }
    }
    /**
     * Generate signed URLs for downloading Azure files
     * @param {string|Array<string>} azurePaths - Single Azure path or array of paths
     * @param {number} expiryHours - Hours until the signed URLs expire (default: 1)
     * @returns {Promise} Promise with signed URL data
     */ static async generateAzureDownloadUrls(azurePaths, expiryHours = 1) {
        try {
            console.log("\uD83D\uDD17 Generating Azure download URLs:", azurePaths);
            const formData = new FormData();
            formData.append("azure_paths", JSON.stringify(azurePaths));
            formData.append("expiry_hours", expiryHours.toString());
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).post(`${$913d3a1574de567c$export$c3ee1e672e1e24e7}/azure-download-url`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    ...this.getAuthHeaders()
                }
            });
            console.log("\uD83D\uDD17 Azure download URLs generated successfully:", response.data);
            return response.data;
        } catch (error) {
            console.error("\uD83D\uDD17 Error generating Azure download URLs:", error);
            if (error.response) {
                // Server responded with error status
                const errorMessage = error.response.data?.detail || error.response.data?.message || `Server error (${error.response.status})`;
                throw new Error(errorMessage);
            } else if (error.request) // Request was made but no response received
            throw new Error("No response from server. Please check your connection.");
            else // Something else happened
            throw new Error(error.message || "Unknown error occurred");
        }
    }
    /**
     * Download file from Azure using signed URL and return as a File object
     * @param {string} azurePath - Azure blob path
     * @param {number} expiryHours - Hours until the signed URL expires (default: 1)
     * @returns {Promise<File>} Promise that resolves to a File object
     */ static async downloadAzureFile(azurePath, expiryHours = 1) {
        try {
            console.log("\uD83D\uDCE5 Downloading Azure file:", azurePath);
            // Generate signed URL
            console.log("\uD83D\uDD17 Generating signed URL...");
            const urlData = await this.generateAzureDownloadUrls(azurePath, expiryHours);
            console.log("\uD83D\uDD17 Signed URL generated:", urlData);
            if (!urlData.signed_url) throw new Error("No signed URL received from server");
            const signedUrl = urlData.signed_url;
            // Download the file using the signed URL
            console.log("\u2B07\uFE0F Downloading file from signed URL...");
            const response = await (0, $740c54350e180ee0$export$2e2bcd8739ae039).get(signedUrl, {
                responseType: "blob"
            });
            console.log("\u2B07\uFE0F Download response:", {
                status: response.status,
                contentType: response.headers["content-type"],
                dataSize: response.data?.size || "unknown"
            });
            if (!response.data || response.data.size === 0) throw new Error("Downloaded file is empty or invalid");
            // Extract filename from the Azure path
            const filename = azurePath.split("/").pop() || "downloaded_file";
            // Create and return File object
            const file = new File([
                response.data
            ], filename, {
                type: response.headers["content-type"] || "application/octet-stream"
            });
            console.log("\uD83D\uDCE5 Azure file downloaded successfully:", {
                filename: filename,
                fileSize: file.size,
                fileType: file.type
            });
            return file;
        } catch (error) {
            console.error("\uD83D\uDCE5 Error downloading Azure file:", error);
            if (error.response) console.error("\uD83D\uDCE5 Response error details:", {
                status: error.response.status,
                statusText: error.response.statusText,
                data: error.response.data
            });
            throw error;
        }
    }
}


// Function to initialize multi-view rendering
function $de78056e9ef47f69$var$initMultiViewRendering() {
    const multiViewContainer = document.getElementById("multi-view-container");
    multiViewContainer.style.display = "grid";
    // Hide the main rendering
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "none";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "none";
    // Setup view titles
    document.getElementById("original-view").setAttribute("data-title", "Original Model");
    document.getElementById("segmented-view").setAttribute("data-title", "Segmented Model");
    document.getElementById("analysis-view").setAttribute("data-title", "Teeth");
    document.getElementById("final-view").setAttribute("data-title", "Final Result");
    // Initialize each view
    const views = [
        "original",
        "segmented",
        "analysis",
        "final"
    ];
    views.forEach((view)=>{
        // Create scene
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view] = new $0d79572b4b22d35c$export$38af1803e3442a7f();
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].background = (0, $b28963ea5393104c$export$82c7f84255e60cc3)();
        // Create camera
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view] = new $0d79572b4b22d35c$export$74e4ae24825f68d7(75, window.innerWidth / 2 / (window.innerHeight / 2), 0.1, 1000);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view].position.set(0, 0, 60);
        // Create renderer
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view] = new $0d79572b4b22d35c$export$f6cc00ef28d7cf97({
            antialias: true
        });
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view].setSize(window.innerWidth / 2, window.innerHeight / 2);
        document.getElementById(`${view}-view`).appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view].domElement);
        // Create CSS2D label renderer
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view] = new (0, $b5225408295f08ae$export$508520281a983506)();
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].setSize(window.innerWidth / 2, window.innerHeight / 2);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].domElement.style.position = "absolute";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].domElement.style.top = "0";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].domElement.style.left = "0";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].domElement.style.pointerEvents = "none";
        document.getElementById(`${view}-view`).appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].domElement);
        // Create controls
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view] = new (0, $6c1447dc1cd4496f$export$8ff7788029dfdf52)((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view], (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view].domElement);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].enableDamping = true;
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].dampingFactor = 0.5;
        // Add lights with brightness setting
        const ambientLight = new $0d79572b4b22d35c$export$af279bfef9ec2c96(0xffffff, 0.4 * (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].add(ambientLight);
        const directionalLight1 = new $0d79572b4b22d35c$export$3fea33cc9972c868(0xffffff, 0.6 * (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount);
        directionalLight1.position.set(1, 1, 1);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].add(directionalLight1);
        const directionalLight2 = new $0d79572b4b22d35c$export$3fea33cc9972c868(0xffffff, 0.4 * (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount);
        directionalLight2.position.set(-1, -1, -1);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].add(directionalLight2);
    });
    // Link all views' camera controls
    views.forEach((view)=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].addEventListener("change", ()=>{
            views.forEach((otherView)=>{
                if (otherView !== view) {
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[otherView].position.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view].position);
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[otherView].rotation.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view].rotation);
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[otherView].target.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].target);
                }
            });
        });
    });
    // Add render function to animation loop
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView = true;
}
// Function to handle teeth separation
async function $de78056e9ef47f69$export$be647402357873d6() {
    const processingIndicator = document.getElementById("processing-indicator");
    processingIndicator.style.display = "block";
    // Reset progress bar
    (0, $b3301d11178af01b$export$55220155eeb8e52c)(0);
    try {
        // Update task label
        document.querySelector("#processing-indicator .progress-task").textContent = "Processing Teeth Reconstruction...";
        // Use different approach based on separation phase
        let file;
        let jawSelection;
        let labelsFile = null;
        // We're continuing from segmentation step (phase 1 or 2)
        if (((0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase === 1 || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase === 2) && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult) {
            console.log("Using existing segmentation results");
            console.log("Current separation phase:", (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase);
            file = document.getElementById("file-select").files[0];
            const jawElement1 = document.querySelector("#jaw-selection-options .jaw-button.active");
            if (!jawElement1) throw new Error("Please select a jaw type (Upper or Lower) before processing");
            jawSelection = jawElement1.getAttribute("data-jaw");
        } else {
            console.log("Starting fresh reconstruction");
            const fileInput = document.getElementById("file-select");
            if (!fileInput.files || !fileInput.files[0]) throw new Error("Please select an OBJ file first");
            file = fileInput.files[0];
            const jawElement2 = document.querySelector("#jaw-selection-options .jaw-button.active");
            if (!jawElement2) throw new Error("Please select a jaw type (Upper or Lower) before processing");
            jawSelection = jawElement2.getAttribute("data-jaw");
            // Ask for labels JSON file
            // Create an input file element for the JSON file
            const jsonFileInput = document.createElement("input");
            jsonFileInput.type = "file";
            jsonFileInput.accept = ".json";
            jsonFileInput.style.display = "none";
            document.body.appendChild(jsonFileInput);
            // Create a promise to handle the file selection
            const jsonFilePromise = new Promise((resolve, reject)=>{
                jsonFileInput.onchange = (e)=>{
                    if (e.target.files.length > 0) resolve(e.target.files[0]);
                    else reject(new Error("No JSON file selected"));
                };
                // If the user cancels, we'll reject after a timeout
                setTimeout(()=>{
                    if (!jsonFileInput.files.length) reject(new Error("JSON file selection timed out"));
                }, 60000); // 1 minute timeout
            });
            // Prompt user to select JSON file
            jsonFileInput.click();
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Please select the labels JSON file", "info");
            try {
                labelsFile = await jsonFilePromise;
                (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Selected JSON file: ${labelsFile.name}`, "check-circle");
            } catch (error) {
                throw new Error("Failed to load labels file: " + error.message);
            } finally{
                document.body.removeChild(jsonFileInput);
            }
        }
        // Estimate processing time
        const estimatedTime = (0, $b3301d11178af01b$export$c24606b8d46faa72)(file.size, "teethseparation");
        // Record start time
        const startTime = Date.now();
        // Prepare labels data for reconstruction
        let jsonFile = null;
        if (((0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase === 1 || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase === 2) && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult) {
            // If we're in phase 1 or 2 (segmentation done) and have results, create and add the labels file
            console.log("Creating labels file from inference results");
            // Only include necessary fields for reconstruction: is_compressed, labels, instance_ids
            const labelsData = (0, $dcddfe328dd861cb$export$2118c26b454acfe3)([
                "is_compressed",
                "labels",
                "instance_ids"
            ]);
            const labelsBlob = new Blob([
                JSON.stringify(labelsData, null, 2)
            ], {
                type: "application/json"
            });
            jsonFile = new File([
                labelsBlob
            ], file.name.replace(/\.[^/.]+$/, "") + "_labels.json", {
                type: "application/json"
            });
        } else if (labelsFile) {
            // Use the labels file selected by the user
            console.log("Using selected labels file:", labelsFile.name);
            jsonFile = labelsFile;
        }
        // Validate file type before uploading (reconstruction requires PREPARED file)
        try {
            const validationResponse = await (0, $913d3a1574de567c$export$ae14c375fc93363).validateFileType(file, null, "teethml", jawSelection);
            if (validationResponse && validationResponse.warning) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(validationResponse.warning, "exclamation-triangle", 5000);
        } catch (error) {
            console.warn("Failed to validate file type for reconstruction:", error);
        // Don't block reconstruction if validation fails
        }
        // Use the ApiService to upload for reconstruction
        const uploadResponse = await (0, $913d3a1574de567c$export$ae14c375fc93363).uploadForReconstruction(file, null, jsonFile, null // labelsAzurePath (not using Azure)
        );
        // Show warning if present in response
        if (uploadResponse && uploadResponse.warning) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(uploadResponse.warning, "exclamation-triangle", 5000);
        const itemId = uploadResponse.item_id;
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastProcessedItemId = itemId;
        // Use the ApiService to poll for status until completed
        const processingResult = await (0, $913d3a1574de567c$export$ae14c375fc93363).pollUntilCompletion(itemId, (0, $b3301d11178af01b$export$55220155eeb8e52c), estimatedTime, startTime);
        // Store the full processing result in global state
        if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData = {};
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.processingResult = processingResult;
        // Record processing time
        const processingTimeInSeconds = (Date.now() - startTime) / 1000;
        (0, $b3301d11178af01b$export$86065947754e0d0f)["teethseparation"].push({
            timeInSeconds: processingTimeInSeconds
        });
        // Keep only the last 5 entries
        if ((0, $b3301d11178af01b$export$86065947754e0d0f)["teethseparation"].length > 5) (0, $b3301d11178af01b$export$86065947754e0d0f)["teethseparation"].shift();
        // Short delay to show 100% completion before hiding
        await new Promise((resolve)=>setTimeout(resolve, 750));
        // Hide processing indicator to show results
        processingIndicator.style.display = "none";
        // Process the results and set up the multi-view display
        $de78056e9ef47f69$var$initMultiViewRendering();
        $de78056e9ef47f69$var$setupMultiViewContent(processingResult);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Teeth reconstruction completed successfully", "check-circle");
    } catch (error) {
        console.error("Error during teeth reconstruction:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error during teeth reconstruction: " + error.message, "exclamation-triangle");
        // Make sure to hide the indicator on error
        processingIndicator.style.display = "none";
        document.getElementById("next-phase-button").style.display = "block";
        document.getElementById("next-phase-button").textContent = "Try Again";
    }
}
// Setup content for multi-view panels
function $de78056e9ef47f69$var$setupMultiViewContent(processingResult) {
    // Store reconstruction result
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.reconstructionResult = processingResult.reconstruction_result;
    // Add detailed logging
    console.log("Setting up multi-view content");
    console.log("Reconstruction result available:", !!processingResult.reconstruction_result);
    console.log("Reconstruction result:", processingResult.reconstruction_result);
    // Find the teeth data in the reconstruction result
    let teethData = null;
    if (processingResult.reconstruction_result) {
        console.log("Reconstruction result keys:", Object.keys(processingResult.reconstruction_result));
        // Check various possible locations for teeth data
        if (processingResult.reconstruction_result.teeth) {
            // Check if teeth is an object with numeric keys instead of a standard array
            if (typeof processingResult.reconstruction_result.teeth === "object" && !Array.isArray(processingResult.reconstruction_result.teeth)) {
                // Convert object with numeric keys to array
                teethData = Object.keys(processingResult.reconstruction_result.teeth).filter((key)=>!isNaN(parseInt(key))).sort((a, b)=>parseInt(a) - parseInt(b)).map((key)=>processingResult.reconstruction_result.teeth[key]);
                console.log("Converted teeth object to array, length:", teethData.length);
            } else teethData = processingResult.reconstruction_result.teeth;
            console.log("Found teeth data in reconstructionResult.teeth");
        } else if (processingResult.reconstruction_result.reconstruction_result && processingResult.reconstruction_result.reconstruction_result.teeth) {
            // Similar check for nested teeth data
            if (typeof processingResult.reconstruction_result.reconstruction_result.teeth === "object" && !Array.isArray(processingResult.reconstruction_result.reconstruction_result.teeth)) {
                teethData = Object.keys(processingResult.reconstruction_result.reconstruction_result.teeth).filter((key)=>!isNaN(parseInt(key))).sort((a, b)=>parseInt(a) - parseInt(b)).map((key)=>processingResult.reconstruction_result.reconstruction_result.teeth[key]);
                console.log("Converted nested teeth object to array, length:", teethData.length);
            } else teethData = processingResult.reconstruction_result.reconstruction_result.teeth;
            console.log("Found teeth data in reconstructionResult.reconstruction_result.teeth");
        } else if (processingResult.reconstruction_result.data && processingResult.reconstruction_result.data.teeth) {
            // Similar check for data.teeth
            if (typeof processingResult.reconstruction_result.data.teeth === "object" && !Array.isArray(processingResult.reconstruction_result.data.teeth)) {
                teethData = Object.keys(processingResult.reconstruction_result.data.teeth).filter((key)=>!isNaN(parseInt(key))).sort((a, b)=>parseInt(a) - parseInt(b)).map((key)=>processingResult.reconstruction_result.data.teeth[key]);
                console.log("Converted data.teeth object to array, length:", teethData.length);
            } else teethData = processingResult.reconstruction_result.data.teeth;
            console.log("Found teeth data in reconstructionResult.data.teeth");
        } else // Look for any property that might contain teeth data
        for (const key of Object.keys(processingResult.reconstruction_result)){
            const value = processingResult.reconstruction_result[key];
            if (value && typeof value === "object") {
                console.log(`Checking property '${key}' for teeth data:`, value);
                // If this property is an array, it might be the teeth data
                if (Array.isArray(value) && value.length > 0 && value[0].vertices) {
                    teethData = value;
                    console.log(`Found possible teeth data in reconstructionResult.${key}`);
                    break;
                }
                // Or it might be nested one level deeper
                if (value.teeth && Array.isArray(value.teeth)) {
                    teethData = value.teeth;
                    console.log(`Found teeth data in reconstructionResult.${key}.teeth`);
                    break;
                }
                // Or it might be an object with numeric keys
                if (key === "teeth" && typeof value === "object") {
                    const numericKeys = Object.keys(value).filter((k)=>!isNaN(parseInt(k)));
                    if (numericKeys.length > 0) {
                        teethData = numericKeys.sort((a, b)=>parseInt(a) - parseInt(b)).map((k)=>value[k]);
                        console.log(`Converted object to array from reconstructionResult.${key}, length:`, teethData.length);
                        break;
                    }
                }
            }
        }
        console.log("Teeth data found:", !!teethData);
        if (teethData) {
            console.log("Teeth data length:", teethData.length);
            if (teethData.length > 0) console.log("First tooth data keys:", Object.keys(teethData[0]));
        }
    }
    // 1. Original view - display the original mesh without colors
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.originalMesh) {
        const originalModel = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.originalMesh.clone();
        originalModel.material = new $0d79572b4b22d35c$export$f2980790215acccd({
            color: 0xcccccc,
            metalness: 0.2,
            roughness: 0.7
        });
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.original.add(originalModel);
    } else {
        // If no original mesh saved (should not happen), display the current mesh
        const originalModel = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.clone();
        originalModel.material = new $0d79572b4b22d35c$export$f2980790215acccd({
            color: 0xcccccc,
            metalness: 0.2,
            roughness: 0.7
        });
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.original.add(originalModel);
    }
    // 2. Segmented view - display segmented mesh with colors
    const segmentedModel = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.clone();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.segmented.add(segmentedModel);
    // Add labels to segmented view
    if (processingResult.reconstruction_result && processingResult.reconstruction_result.labels) $de78056e9ef47f69$var$addLabelsToSegmentedView(segmentedModel, processingResult.reconstruction_result);
    // 3 & 4. Analysis and Final views - display the reconstructed result
    if (teethData && teethData.length > 0) {
        console.log("Setting up teeth reconstruction with data:", {
            teethCount: teethData.length,
            firstToothSample: teethData[0],
            hasGingiva: !!(processingResult.reconstruction_result.gingiva || processingResult.reconstruction_result && processingResult.reconstruction_result.gingiva),
            hasObjFile: !!(processingResult.final_obj || processingResult.reconstruction_result && processingResult.reconstruction_result.final_obj)
        });
        // Debug: check if the teeth data contains properly formatted vertices/faces
        const firstTooth = teethData[0];
        console.log("First tooth vertex format check:", {
            hasVertices: !!firstTooth.vertices,
            verticesType: typeof firstTooth.vertices,
            isVerticesArray: Array.isArray(firstTooth.vertices),
            verticesLength: firstTooth.vertices ? firstTooth.vertices.length : 0,
            isVerticesEncoded: firstTooth.vertices && firstTooth.vertices.encoding && firstTooth.vertices.data,
            hasFaces: !!firstTooth.faces,
            facesType: typeof firstTooth.faces,
            isFacesArray: Array.isArray(firstTooth.faces),
            facesLength: firstTooth.faces ? firstTooth.faces.length : 0,
            isFacesEncoded: firstTooth.faces && firstTooth.faces.encoding && firstTooth.faces.data
        });
        try {
            // Find gingiva data
            let gingivaData = null;
            if (processingResult.reconstruction_result.gingiva) gingivaData = processingResult.reconstruction_result.gingiva;
            else if (processingResult.reconstruction_result.reconstruction_result && processingResult.reconstruction_result.reconstruction_result.gingiva) gingivaData = processingResult.reconstruction_result.reconstruction_result.gingiva;
            // Add teeth with roots to analysis view (100% opaque)
            $de78056e9ef47f69$var$addReconstructedTeeth((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.analysis, teethData, false);
            // Add root direction arrows to analysis view
            $de78056e9ef47f69$var$addRootDirectionArrows(teethData);
            // Add teeth with roots to final view (solid)
            $de78056e9ef47f69$var$addReconstructedTeeth((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.final, teethData, false);
            // Add gingiva to final view if available (80% opacity)
            if (gingivaData) $de78056e9ef47f69$var$addGingiva((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.final, gingivaData);
            // Show reconstruction timings if available
            let timings = null;
            if (processingResult.reconstruction_result.timings) timings = processingResult.reconstruction_result.timings;
            else if (processingResult.reconstruction_result.reconstruction_result && processingResult.reconstruction_result.reconstruction_result.timings) timings = processingResult.reconstruction_result.reconstruction_result.timings;
            if (timings) {
                const timingInfo = document.createElement("div");
                timingInfo.classList.add("timing-info");
                timingInfo.style.position = "absolute";
                timingInfo.style.bottom = "10px";
                timingInfo.style.right = "10px";
                timingInfo.style.background = "rgba(0,0,0,0.7)";
                timingInfo.style.color = "white";
                timingInfo.style.padding = "10px";
                timingInfo.style.borderRadius = "5px";
                timingInfo.style.fontSize = "12px";
                let timingText = "<strong>Reconstruction Timings:</strong><br>";
                for (const [key, value] of Object.entries(timings))timingText += `${key}: ${value.toFixed(2)}s<br>`;
                timingInfo.innerHTML = timingText;
                document.getElementById("final-view").appendChild(timingInfo);
            }
        } catch (error) {
            console.error("Error setting up reconstructed teeth:", error);
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error displaying reconstructed teeth: " + error.message, "exclamation-triangle");
            // Fallback to segmented model if error occurs
            const analysisModel = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.clone();
            analysisModel.material = new $0d79572b4b22d35c$export$f2980790215acccd({
                vertexColors: true,
                metalness: 0.2,
                roughness: 0.7
            });
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.analysis.add(analysisModel);
            const finalModel = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.clone();
            finalModel.material = new $0d79572b4b22d35c$export$f2980790215acccd({
                vertexColors: true,
                metalness: 0.3,
                roughness: 0.5
            });
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.final.add(finalModel);
        }
    } else {
        console.warn("No valid teeth reconstruction data. Using fallback segmented model.");
        // Fallback if no reconstruction result
        const analysisModel = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.clone();
        analysisModel.material = new $0d79572b4b22d35c$export$f2980790215acccd({
            vertexColors: true,
            metalness: 0.2,
            roughness: 0.7
        });
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.analysis.add(analysisModel);
        const finalModel = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.clone();
        finalModel.material = new $0d79572b4b22d35c$export$f2980790215acccd({
            vertexColors: true,
            metalness: 0.3,
            roughness: 0.5
        });
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.final.add(finalModel);
    }
    // Add call to show download buttons at the end of setup
    $de78056e9ef47f69$export$e9bdd49321747af5();
}
// Add reconstructed teeth to scene
function $de78056e9ef47f69$var$addReconstructedTeeth(scene, teethData, isTransparent) {
    if (!teethData || !teethData.length) {
        console.error("No teeth data available or teeth data is empty");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error: No valid teeth data received", "exclamation-triangle");
        return;
    }
    console.log(`Adding ${teethData.length} teeth to scene`);
    let validTeethCount = 0;
    let skippedTeethCount = 0;
    teethData.forEach((tooth, index)=>{
        console.log(`Processing tooth ${index} with instance ID ${tooth.instance_id || "unknown"}`);
        try {
            // Deep clone the tooth data to avoid modifying the original
            const toothCopy = JSON.parse(JSON.stringify(tooth));
            // Check if tooth vertices/faces need decoding (might be compressed in nested data)
            if (toothCopy.vertices && toothCopy.vertices.encoding && toothCopy.vertices.data) {
                console.log(`Decoding compressed tooth ${index} vertices data`);
                try {
                    toothCopy.vertices = (0, $268abebfadfa5867$export$2130189ea4ff8c6d)(toothCopy.vertices);
                    console.log(`Successfully decoded vertices for tooth ${index}, got ${toothCopy.vertices.length} vertices`);
                } catch (error) {
                    console.error(`Failed to decode vertices for tooth ${index}:`, error);
                    return; // Skip this tooth
                }
            }
            if (toothCopy.faces && toothCopy.faces.encoding && toothCopy.faces.data) {
                console.log(`Decoding compressed tooth ${index} faces data`);
                try {
                    toothCopy.faces = (0, $268abebfadfa5867$export$2130189ea4ff8c6d)(toothCopy.faces);
                    console.log(`Successfully decoded faces for tooth ${index}, got ${toothCopy.faces.length} faces`);
                } catch (error) {
                    console.error(`Failed to decode faces for tooth ${index}:`, error);
                    return; // Skip this tooth
                }
            }
            // Validate vertex and face data
            if (!toothCopy.vertices || !Array.isArray(toothCopy.vertices) || toothCopy.vertices.length === 0) {
                console.warn(`Skipping tooth ${index} (ID: ${toothCopy.instance_id}) - Missing or invalid vertices`);
                skippedTeethCount++;
                return;
            }
            if (!toothCopy.faces || !Array.isArray(toothCopy.faces) || toothCopy.faces.length === 0) {
                console.warn(`Skipping tooth ${index} (ID: ${toothCopy.instance_id}) - Missing or invalid faces`);
                skippedTeethCount++;
                return;
            }
            // Ensure vertices are in the correct format (array of [x,y,z] arrays)
            if (!Array.isArray(toothCopy.vertices[0]) || toothCopy.vertices[0].length !== 3) {
                console.warn(`Tooth ${index} has invalid vertex format:`, toothCopy.vertices[0]);
                skippedTeethCount++;
                return;
            }
            // Create geometry
            const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
            // Add vertices
            try {
                const vertices = new Float32Array(toothCopy.vertices.flat());
                geometry.setAttribute("position", new $0d79572b4b22d35c$export$8dea267bd6bde117(vertices, 3));
            } catch (error) {
                console.error(`Error creating vertex buffer for tooth ${index}:`, error);
                skippedTeethCount++;
                return;
            }
            // Add faces
            try {
                const indices = new Uint32Array(toothCopy.faces.flat());
                geometry.setIndex(new $0d79572b4b22d35c$export$8dea267bd6bde117(indices, 1));
            } catch (error) {
                console.error(`Error creating face indices for tooth ${index}:`, error);
                skippedTeethCount++;
                return;
            }
            // Compute normals for proper lighting
            try {
                geometry.computeVertexNormals();
            } catch (error) {
                console.error(`Error computing normals for tooth ${index}:`, error);
            // Continue anyway as this is not critical
            }
            // Determine tooth material based on type and transparency
            let color = $de78056e9ef47f69$var$getToothColor(toothCopy.class_id);
            let material;
            if (isTransparent) material = new $0d79572b4b22d35c$export$24c72f71cbaf0678({
                color: color,
                transparent: true,
                opacity: 0.7,
                side: $0d79572b4b22d35c$export$3b296b6f144d5b03
            });
            else material = new $0d79572b4b22d35c$export$24c72f71cbaf0678({
                color: color,
                side: $0d79572b4b22d35c$export$3b296b6f144d5b03
            });
            const mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, material);
            mesh.userData = {
                instanceId: toothCopy.instance_id,
                classId: toothCopy.class_id,
                type: "tooth"
            };
            scene.add(mesh);
            validTeethCount++;
            console.log(`Successfully added tooth ${index} (ID: ${toothCopy.instance_id}) to scene`);
        } catch (error) {
            console.error(`Unexpected error processing tooth ${index}:`, error);
            skippedTeethCount++;
        }
    });
    console.log(`Added ${validTeethCount} teeth to scene, skipped ${skippedTeethCount} teeth with issues`);
    if (validTeethCount === 0) {
        console.error("No valid teeth with geometry were found");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error: No valid teeth with geometry received", "exclamation-triangle");
    } else console.log(`Successfully added ${validTeethCount} teeth to the scene`);
}
// Add gingiva to scene
function $de78056e9ef47f69$var$addGingiva(scene, gingivaData) {
    console.log("Adding gingiva to scene, data available:", !!gingivaData);
    try {
        // Deep clone the gingiva data to avoid modifying the original
        const gingivaCopy = JSON.parse(JSON.stringify(gingivaData));
        // Check if gingiva data needs decoding (might be compressed in nested data)
        if (gingivaCopy && gingivaCopy.vertices && gingivaCopy.vertices.encoding && gingivaCopy.vertices.data) {
            console.log("Decoding compressed gingiva vertices data");
            try {
                gingivaCopy.vertices = (0, $268abebfadfa5867$export$2130189ea4ff8c6d)(gingivaCopy.vertices);
                console.log(`Successfully decoded gingiva vertices, got ${gingivaCopy.vertices.length} vertices`);
            } catch (error) {
                console.error("Failed to decode gingiva vertices:", error);
                (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error decoding gingiva data", "exclamation-triangle");
                return;
            }
        }
        if (gingivaCopy && gingivaCopy.faces && gingivaCopy.faces.encoding && gingivaCopy.faces.data) {
            console.log("Decoding compressed gingiva faces data");
            try {
                gingivaCopy.faces = (0, $268abebfadfa5867$export$2130189ea4ff8c6d)(gingivaCopy.faces);
                console.log(`Successfully decoded gingiva faces, got ${gingivaCopy.faces.length} faces`);
            } catch (error) {
                console.error("Failed to decode gingiva faces:", error);
                (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error decoding gingiva data", "exclamation-triangle");
                return;
            }
        }
        // Validate gingiva data
        if (!gingivaCopy || !gingivaCopy.vertices || !Array.isArray(gingivaCopy.vertices) || gingivaCopy.vertices.length === 0) {
            console.warn("No valid gingiva vertices available");
            return;
        }
        if (!gingivaCopy.faces || !Array.isArray(gingivaCopy.faces) || gingivaCopy.faces.length === 0) {
            console.warn("No valid gingiva faces available");
            return;
        }
        // Ensure vertices are in the correct format (array of [x,y,z] arrays)
        if (!Array.isArray(gingivaCopy.vertices[0]) || gingivaCopy.vertices[0].length !== 3) {
            console.warn("Gingiva has invalid vertex format:", gingivaCopy.vertices[0]);
            return;
        }
        // Create geometry
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        // Add vertices
        try {
            const vertices = new Float32Array(gingivaCopy.vertices.flat());
            geometry.setAttribute("position", new $0d79572b4b22d35c$export$8dea267bd6bde117(vertices, 3));
            console.log("Successfully created gingiva vertices buffer");
        } catch (error) {
            console.error("Error creating gingiva vertex buffer:", error);
            return;
        }
        // Add faces
        try {
            const indices = new Uint32Array(gingivaCopy.faces.flat());
            geometry.setIndex(new $0d79572b4b22d35c$export$8dea267bd6bde117(indices, 1));
            console.log("Successfully created gingiva face indices buffer");
        } catch (error) {
            console.error("Error creating gingiva face indices:", error);
            return;
        }
        // Compute normals for proper lighting
        try {
            geometry.computeVertexNormals();
        } catch (error) {
            console.error("Error computing gingiva normals:", error);
        // Continue anyway as this is not critical
        }
        // Create a material for gingiva - pinkish color
        const material = new $0d79572b4b22d35c$export$24c72f71cbaf0678({
            color: 0xf7a8b8,
            side: $0d79572b4b22d35c$export$3b296b6f144d5b03,
            transparent: true,
            opacity: 0.8
        });
        const mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, material);
        mesh.userData = {
            type: "gingiva"
        };
        scene.add(mesh);
        console.log("Successfully added gingiva to the scene");
    } catch (error) {
        console.error("Unexpected error adding gingiva:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error adding gingiva to scene", "exclamation-triangle");
    }
}
// Add root direction arrows to the analysis view
function $de78056e9ef47f69$var$addRootDirectionArrows(teethData) {
    if (!teethData || !teethData.length) {
        console.warn("No teeth data available for root direction arrows");
        return;
    }
    teethData.forEach((tooth)=>{
        if (!tooth.root_direction || !Array.isArray(tooth.root_direction) || tooth.root_direction.length !== 3) return; // Skip if no valid root direction
        // Get tooth position (center)
        let center = new $0d79572b4b22d35c$export$64b5c384219d3699(0, 0, 0);
        if (tooth.vertices) {
            // If vertices are available, compute center from vertices
            let vertices = tooth.vertices;
            // Check if vertices need decoding
            if (vertices.encoding && vertices.data) vertices = (0, $268abebfadfa5867$export$2130189ea4ff8c6d)(vertices);
            if (Array.isArray(vertices) && vertices.length > 0) {
                const vertexCount = vertices.length;
                for(let i = 0; i < vertexCount; i++){
                    center.x += vertices[i][0];
                    center.y += vertices[i][1];
                    center.z += vertices[i][2];
                }
                center.divideScalar(vertexCount);
            }
        }
        // Create arrow from center in the direction of root_direction
        const rootDir = new $0d79572b4b22d35c$export$64b5c384219d3699(tooth.root_direction[0], tooth.root_direction[1], tooth.root_direction[2]).normalize();
        // Arrow length should be proportional to tooth size
        const arrowLength = 5; // Default value
        const arrowHelper = new $0d79572b4b22d35c$export$a3008e7bd8d2cbe7(rootDir, center, arrowLength, 0xff0000, arrowLength * 0.2, arrowLength * 0.1 // Head width
        );
        // Add arrow to analysis view
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.analysis.add(arrowHelper);
    });
}
// Function to show the download button
function $de78056e9ef47f69$export$e9bdd49321747af5() {
    // Remove existing container if present
    const existingContainer = document.getElementById("download-buttons-container");
    if (existingContainer) existingContainer.remove();
    // Create a container for the buttons
    const buttonContainer = document.createElement("div");
    buttonContainer.id = "download-buttons-container";
    // Create JSON download button
    const downloadLabelsButton = document.createElement("button");
    downloadLabelsButton.id = "download-results-button";
    downloadLabelsButton.textContent = "Download Labels JSON";
    downloadLabelsButton.addEventListener("click", $de78056e9ef47f69$export$5bf3538b3aee0c5e);
    buttonContainer.appendChild(downloadLabelsButton);
    // Find the final_obj data in potentially nested structures
    let finalObjData = null;
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.reconstructionResult) {
        const reconstructionResult = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.reconstructionResult;
        if (reconstructionResult.final_obj) {
            finalObjData = reconstructionResult.final_obj;
            console.log("Found final_obj in reconstructionResult.final_obj");
        } else if (reconstructionResult.reconstruction_result && reconstructionResult.reconstruction_result.final_obj) {
            finalObjData = reconstructionResult.reconstruction_result.final_obj;
            console.log("Found final_obj in reconstructionResult.reconstruction_result.final_obj");
        } else // Look for final_obj in any property
        for (const key of Object.keys(reconstructionResult)){
            const value = reconstructionResult[key];
            if (value && typeof value === "object" && value.final_obj) {
                finalObjData = value.final_obj;
                console.log(`Found final_obj in reconstructionResult.${key}.final_obj`);
                break;
            }
        }
    }
    // Create OBJ download button if final_obj data is available
    if (finalObjData) {
        const downloadObjButton = document.createElement("button");
        downloadObjButton.id = "download-obj-button";
        downloadObjButton.textContent = "Download Reconstructed OBJ";
        downloadObjButton.addEventListener("click", $de78056e9ef47f69$export$c98e14c6d3edb414);
        buttonContainer.appendChild(downloadObjButton);
        console.log("Added Download OBJ button, final_obj is available");
    } else console.log("No final_obj available in reconstruction result:", (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData?.reconstructionResult);
    // Add the container to the body
    document.body.appendChild(buttonContainer);
}
// Function to download the segmentation results as JSON
function $de78056e9ef47f69$export$5bf3538b3aee0c5e() {
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult || !(0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult.labels) {
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No segmentation results to download", "exclamation-triangle");
        return;
    }
    // Include all fields for user download
    const jsonContent = (0, $dcddfe328dd861cb$export$2118c26b454acfe3)([
        "is_compressed",
        "labels",
        "instance_ids",
        "class_ids",
        "class_names",
        "class_colors",
        "boundary_points",
        "simplified_boundary_points"
    ]);
    // Create and download file
    const fileName = document.getElementById("file-select").files[0].name.replace(/\.[^/.]+$/, "") + "_labels.json";
    const blob = new Blob([
        JSON.stringify(jsonContent, null, 2)
    ], {
        type: "application/json"
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
// Function to download the reconstructed 3D model as OBJ file
function $de78056e9ef47f69$export$c98e14c6d3edb414() {
    let finalObjData = null;
    // Find the final_obj data in potentially nested structures
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.reconstructionResult) {
        const reconstructionResult = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.reconstructionResult;
        if (reconstructionResult.final_obj) finalObjData = reconstructionResult.final_obj;
        else if (reconstructionResult.reconstruction_result && reconstructionResult.reconstruction_result.final_obj) finalObjData = reconstructionResult.reconstruction_result.final_obj;
        else // Look for final_obj in any property
        for (const key of Object.keys(reconstructionResult)){
            const value = reconstructionResult[key];
            if (value && typeof value === "object" && value.final_obj) {
                finalObjData = value.final_obj;
                break;
            }
        }
    }
    if (!finalObjData) {
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No reconstruction data available to download", "exclamation-triangle");
        return;
    }
    try {
        // Decode base64 to binary string
        const binaryString = atob(finalObjData);
        // Convert binary string to array buffer
        const bytes = new Uint8Array(binaryString.length);
        for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
        // Create blob and download
        const blob = new Blob([
            bytes
        ], {
            type: "application/octet-stream"
        });
        const url = URL.createObjectURL(blob);
        // Create filename based on original file
        const fileName = document.getElementById("file-select").files[0].name.replace(/\.[^/.]+$/, "") + "_reconstructed.obj";
        // Create download link
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Reconstructed OBJ downloaded successfully", "check-circle");
    } catch (error) {
        console.error("Error downloading OBJ file:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error downloading OBJ file: " + error.message, "exclamation-triangle");
    }
}
// Get color for tooth based on class ID
function $de78056e9ef47f69$var$getToothColor(classId) {
    // Map from FDI tooth numbering to consistent colors
    const colors = {
        // Upper right quadrant (1)
        11: 0x3498db,
        12: 0x2ecc71,
        13: 0xf1c40f,
        14: 0xe74c3c,
        15: 0x9b59b6,
        16: 0x1abc9c,
        17: 0xd35400,
        18: 0x34495e,
        // Upper left quadrant (2)
        21: 0x3498db,
        22: 0x2ecc71,
        23: 0xf1c40f,
        24: 0xe74c3c,
        25: 0x9b59b6,
        26: 0x1abc9c,
        27: 0xd35400,
        28: 0x34495e,
        // Lower left quadrant (3)
        31: 0x3498db,
        32: 0x2ecc71,
        33: 0xf1c40f,
        34: 0xe74c3c,
        35: 0x9b59b6,
        36: 0x1abc9c,
        37: 0xd35400,
        38: 0x34495e,
        // Lower right quadrant (4)
        41: 0x3498db,
        42: 0x2ecc71,
        43: 0xf1c40f,
        44: 0xe74c3c,
        45: 0x9b59b6,
        46: 0x1abc9c,
        47: 0xd35400,
        48: 0x34495e // third molar - wet asphalt blue
    };
    // Return specific color if defined, or generate one based on class ID
    if (colors[classId]) return colors[classId];
    else {
        // Generate a more vibrant color based on the classId
        const hue = classId % 10 / 10;
        return new $0d79572b4b22d35c$export$892596cec99bc70e().setHSL(hue, 0.9, 0.6).getHex();
    }
}
// Function to add labels to the segmented view
function $de78056e9ef47f69$var$addLabelsToSegmentedView(mesh, inferenceResult) {
    if (!mesh || !inferenceResult || !inferenceResult.labels) return;
    const geometry = mesh.geometry;
    const labelPositions = {};
    // Calculate average position for each class
    for(let i = 0; i < inferenceResult.labels.length; i++){
        const label = inferenceResult.labels[i];
        if (!labelPositions[label]) labelPositions[label] = {
            sum: new $0d79572b4b22d35c$export$64b5c384219d3699(),
            count: 0
        };
        const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699().fromBufferAttribute(geometry.attributes.position, i);
        labelPositions[label].sum.add(vertex);
        labelPositions[label].count++;
    }
    // Get appropriate class data
    const processingMode = "teethml"; // Always teeth for separation mode
    const classesData = (0, (/*@__PURE__*/$parcel$interopDefault($2a57802d05c0eaa2$exports)));
    // Create and position class labels
    Object.entries(labelPositions).forEach(([label, data])=>{
        const avgPosition = data.sum.divideScalar(data.count);
        const classData = classesData.find((c)=>c.id === parseInt(label));
        if (classData) {
            const labelDiv = document.createElement("div");
            labelDiv.className = "tooth-label";
            labelDiv.textContent = classData.name;
            labelDiv.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
            labelDiv.style.color = "white";
            labelDiv.style.padding = "2px 5px";
            labelDiv.style.borderRadius = "3px";
            labelDiv.style.fontSize = "12px";
            labelDiv.style.fontWeight = "bold";
            const labelObject = new (0, $b5225408295f08ae$export$936f75e6792bf2dc)(labelDiv);
            labelObject.position.copy(avgPosition);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.segmented.add(labelObject);
        }
    });
}






/**
 * Postprocessing Settings Management Module
 * Handles UI controls, localStorage persistence, and parameter collection
 * for arrangement postprocessing settings
 */ 

let $ddb3f022a87c2bc1$var$gapRuleCounter = 0;
let $ddb3f022a87c2bc1$var$fixedToothCounter = 0;
/**
 * Default postprocessing settings
 * These values are used as fallback when server is unavailable
 */ let $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS = {
    enabled: true,
    gap_min: "0.22",
    gap_max: "0.30",
    tightness: "0.26",
    midline_mode: "adjust",
    archform: "disabled"
};
/**
 * Load default postprocessing settings from server
 * Falls back to defaults if server request fails
 */ async function $ddb3f022a87c2bc1$var$loadDefaultSettingsFromServer() {
    try {
        const response = await fetch("/api/postprocessing-defaults");
        if (response.ok) {
            const serverDefaults = await response.json();
            // Convert numeric values to strings for UI compatibility
            $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS = {
                enabled: true,
                gap_min: String(serverDefaults.gap_min || 0.22),
                gap_max: String(serverDefaults.gap_max || 0.3),
                tightness: String(serverDefaults.tightness || 0.26),
                midline_mode: serverDefaults.midline_mode || "adjust",
                archform: "disabled"
            };
            $ddb3f022a87c2bc1$var$populateArchformDropdown(serverDefaults.archform_options);
            // Update minimum threshold for validation (use gap_max from server)
            MIN_GAP_MAX_THRESHOLD = parseFloat(serverDefaults.gap_max || 0.3);
            console.log("\u2713 Loaded postprocessing defaults from server:", $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS);
            console.log(`  Minimum gap_max threshold for validation: ${MIN_GAP_MAX_THRESHOLD}`);
        } else {
            console.warn("Failed to load postprocessing defaults from server (status:", response.status, "), using fallback defaults");
            return false;
        }
    } catch (error) {
        console.warn("Error loading postprocessing defaults from server:", error, "Using hardcoded defaults");
        return false;
    }
}
/**
 * Fill the archform menu from the server's list.
 *
 * The list comes from the template file rather than being restated here, so a new
 * archform becomes selectable without a frontend change. Called before saved
 * settings are restored, so the saved value has an option to select. Leaves the
 * static Disabled fallback in place if the server sent nothing usable.
 *
 * @param {Array<{value: string, label: string, lower_label: string}>} options
 */ function $ddb3f022a87c2bc1$var$populateArchformDropdown(options) {
    const dropdown = document.getElementById("archform-dropdown");
    if (!dropdown || !Array.isArray(options) || options.length === 0) return;
    dropdown.innerHTML = "";
    options.forEach((option)=>{
        if (!option || !option.value) return;
        const element = document.createElement("option");
        element.value = option.value;
        element.textContent = option.label || option.value;
        if (option.lower_label) element.title = `Lower arch: ${option.lower_label}`;
        dropdown.appendChild(element);
    });
}
/**
 * Update HTML elements with default values from server
 * Called after loading defaults to ensure UI shows correct initial values
 * Only updates if values haven't been set yet (empty or placeholder)
 */ function $ddb3f022a87c2bc1$var$updateHTMLElementsWithDefaults() {
    const gapMinSlider = document.getElementById("gap-min-slider");
    const gapMaxSlider = document.getElementById("gap-max-slider");
    const tightnessSlider = document.getElementById("tightness-slider");
    const gapMinValue = document.getElementById("gap-min-value");
    const gapMaxValue = document.getElementById("gap-max-value");
    const tightnessValue = document.getElementById("tightness-value");
    // Check if values are empty or placeholder ("--")
    // Range inputs return empty string if value attribute is not set
    const gapMinEmpty = !gapMinSlider || !gapMinSlider.value || gapMinSlider.value === "";
    const gapMaxEmpty = !gapMaxSlider || !gapMaxSlider.value || gapMaxSlider.value === "";
    const tightnessEmpty = !tightnessSlider || !tightnessSlider.value || tightnessSlider.value === "";
    if (gapMinSlider && gapMinEmpty) {
        gapMinSlider.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_min;
        if (gapMinValue) gapMinValue.textContent = parseFloat($ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_min).toFixed(2);
    }
    if (gapMaxSlider && gapMaxEmpty) {
        gapMaxSlider.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_max;
        if (gapMaxValue) gapMaxValue.textContent = parseFloat($ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_max).toFixed(2);
    }
    if (tightnessSlider && tightnessEmpty) {
        tightnessSlider.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.tightness;
        if (tightnessValue) tightnessValue.textContent = parseFloat($ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.tightness).toFixed(2);
    }
}
async function $ddb3f022a87c2bc1$export$66e810c40c8a96f8() {
    const enableCheckbox = document.getElementById("enable-postprocessing-checkbox");
    const controlsContainer = document.getElementById("postprocessing-controls");
    if (!enableCheckbox || !controlsContainer) return;
    // Load defaults from server first; saved settings from localStorage are
    // restored later, AFTER the gap-rules and fixed-teeth tables are initialized
    // (loadPostprocessingSettings needs window.addGapRuleFromData /
    // window.addFixedToothFromData, which those init functions assign).
    const defaultsLoaded = await $ddb3f022a87c2bc1$var$loadDefaultSettingsFromServer();
    // Update HTML elements with default values if they haven't been set yet
    // This ensures HTML shows correct values even before localStorage is checked
    if (defaultsLoaded) $ddb3f022a87c2bc1$var$updateHTMLElementsWithDefaults();
    // Toggle controls visibility and disabled state
    function togglePostprocessingControls() {
        const isEnabled = enableCheckbox.checked;
        if (isEnabled) {
            controlsContainer.style.display = "flex";
            controlsContainer.classList.remove("disabled");
            enablePostprocessingInputs(true);
        } else {
            controlsContainer.style.display = "none";
            controlsContainer.classList.add("disabled");
            enablePostprocessingInputs(false);
        }
        // Save settings when checkbox changes
        $ddb3f022a87c2bc1$export$4bec613efb57fa32();
    }
    // Enable/disable all postprocessing inputs
    function enablePostprocessingInputs(enabled) {
        const inputs = controlsContainer.querySelectorAll("input, select, button");
        inputs.forEach((input)=>{
            input.disabled = !enabled;
        });
    }
    // Initialize range slider value displays
    function updateRangeValue(sliderId, valueId) {
        const slider = document.getElementById(sliderId);
        const valueDisplay = document.getElementById(valueId);
        if (slider && valueDisplay) {
            slider.addEventListener("input", (e)=>{
                valueDisplay.textContent = parseFloat(e.target.value).toFixed(2);
                // Save settings when slider changes
                $ddb3f022a87c2bc1$export$4bec613efb57fa32();
            });
            // Set initial value
            valueDisplay.textContent = parseFloat(slider.value).toFixed(2);
        }
    }
    // Initialize range sliders
    updateRangeValue("gap-min-slider", "gap-min-value");
    updateRangeValue("gap-max-slider", "gap-max-value");
    updateRangeValue("tightness-slider", "tightness-value");
    // Validate gap range (gap_min < gap_max)
    const gapMinSlider = document.getElementById("gap-min-slider");
    const gapMaxSlider = document.getElementById("gap-max-slider");
    const gapMaxValue = document.getElementById("gap-max-value");
    if (gapMinSlider && gapMaxSlider && gapMaxValue) {
        function validateGapRange() {
            const min = parseFloat(gapMinSlider.value);
            const max = parseFloat(gapMaxSlider.value);
            if (min >= max) {
                gapMaxSlider.value = (min + 0.01).toFixed(2);
                gapMaxValue.textContent = gapMaxSlider.value;
            }
            // Warn if gap_max < default threshold (loaded from server)
            if (max < MIN_GAP_MAX_THRESHOLD) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Warning: max gap (${max.toFixed(2)}mm) is below recommended minimum (${MIN_GAP_MAX_THRESHOLD.toFixed(2)}mm). This may result in unstable postprocessing. Increase tightness if you need to put teeth closer.`, "exclamation-triangle");
        }
        gapMinSlider.addEventListener("input", validateGapRange);
        gapMaxSlider.addEventListener("input", ()=>{
            const min = parseFloat(gapMinSlider.value);
            let max = parseFloat(gapMaxSlider.value);
            if (max <= min) {
                gapMinSlider.value = (max - 0.01).toFixed(2);
                document.getElementById("gap-min-value").textContent = gapMinSlider.value;
            }
            // Warn if gap_max < default threshold (loaded from server)
            if (max < MIN_GAP_MAX_THRESHOLD) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Warning: max gap (${max.toFixed(2)}mm) is below recommended minimum (${MIN_GAP_MAX_THRESHOLD.toFixed(2)}mm). This may result in unstable postprocessing. Increase tightness if you need to put teeth closer.`, "exclamation-triangle");
            gapMaxValue.textContent = max.toFixed(2);
        });
    }
    // Initialize custom gap rules table
    $ddb3f022a87c2bc1$var$initializeCustomGapRules();
    // Initialize freeze (fixed teeth) table
    $ddb3f022a87c2bc1$var$initializeFixedTeeth();
    // Restore saved settings now that the gap-rules and fixed-teeth tables (and
    // their window.add*FromData restorers) exist - restoring earlier would clear
    // the tables and silently drop saved rules and frozen teeth.
    $ddb3f022a87c2bc1$export$4d770224d5182406();
    // Set up checkbox toggle
    enableCheckbox.addEventListener("change", togglePostprocessingControls);
    // Add event listener to midline mode dropdown to save settings
    const midlineModeDropdown = document.getElementById("midline-mode-dropdown");
    if (midlineModeDropdown) midlineModeDropdown.addEventListener("change", ()=>{
        $ddb3f022a87c2bc1$export$4bec613efb57fa32();
    });
    const archformDropdown = document.getElementById("archform-dropdown");
    if (archformDropdown) archformDropdown.addEventListener("change", ()=>{
        $ddb3f022a87c2bc1$export$21841be6eb9a8d69();
        $ddb3f022a87c2bc1$export$4bec613efb57fa32();
    });
    const archformRotationsCheckbox = document.getElementById("enable-archform-rotations-checkbox");
    if (archformRotationsCheckbox) archformRotationsCheckbox.addEventListener("change", ()=>{
        $ddb3f022a87c2bc1$export$4bec613efb57fa32();
    });
    // Add reset button functionality
    const resetButton = document.getElementById("reset-postprocessing-button");
    if (resetButton) resetButton.addEventListener("click", ()=>{
        $ddb3f022a87c2bc1$export$107c0d23caa13917();
    });
    // Initial state
    togglePostprocessingControls();
}
/**
 * Initialize custom gap rules table
 */ function $ddb3f022a87c2bc1$var$initializeCustomGapRules() {
    const addButton = document.getElementById("add-gap-rule-button");
    const tbody = document.getElementById("custom-gap-rules-tbody");
    const table = document.getElementById("custom-gap-rules-table");
    const emptyMessage = document.getElementById("custom-gap-rules-empty");
    if (!addButton || !tbody || !table || !emptyMessage) return;
    function updateTableVisibility() {
        const hasRules = tbody.children.length > 0;
        table.style.display = hasRules ? "table" : "none";
        emptyMessage.style.display = hasRules ? "none" : "block";
    }
    // Make addGapRule globally accessible for loading saved settings
    window.addGapRuleFromData = function addGapRule(toothA = "", toothB = "", gapMin = "", gapMax = "") {
        const row = document.createElement("tr");
        row.dataset.ruleId = `rule-${$ddb3f022a87c2bc1$var$gapRuleCounter++}`;
        const toothACell = document.createElement("td");
        const toothAInput = document.createElement("input");
        toothAInput.type = "number";
        toothAInput.value = toothA;
        toothAInput.placeholder = "e.g., 15";
        toothAInput.min = "11";
        toothAInput.max = "48";
        toothACell.appendChild(toothAInput);
        const toothBCell = document.createElement("td");
        const toothBInput = document.createElement("input");
        toothBInput.type = "number";
        toothBInput.value = toothB;
        toothBInput.placeholder = "e.g., 16";
        toothBInput.min = "11";
        toothBInput.max = "48";
        toothBCell.appendChild(toothBInput);
        const gapMinCell = document.createElement("td");
        const gapMinInput = document.createElement("input");
        gapMinInput.type = "number";
        gapMinInput.value = gapMin;
        // Use dynamic default from server (or fallback if not loaded yet)
        gapMinInput.placeholder = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_min || "0.22";
        gapMinInput.step = "0.01";
        gapMinInput.min = "0";
        gapMinCell.appendChild(gapMinInput);
        const gapMaxCell = document.createElement("td");
        const gapMaxInput = document.createElement("input");
        gapMaxInput.type = "number";
        gapMaxInput.value = gapMax;
        // Use dynamic default from server (or fallback if not loaded yet)
        gapMaxInput.placeholder = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_max || "0.30";
        gapMaxInput.step = "0.01";
        // Minimum gap_max should be at least gap_min from defaults
        // This ensures gap_max >= gap_min constraint can be satisfied
        const minGapMax = parseFloat($ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_min || 0.22);
        gapMaxInput.min = String(Math.max(0, minGapMax - 0.01)); // Allow slightly below gap_min for flexibility
        gapMaxCell.appendChild(gapMaxInput);
        // Validate gap_min < gap_max and warn if gap_max < recommended minimum
        // Use a flag to prevent recursive validation
        let isValidating = false;
        function validateRuleGaps() {
            if (isValidating) return;
            isValidating = true;
            const minStr = gapMinInput.value.trim();
            const maxStr = gapMaxInput.value.trim();
            const min = minStr !== "" ? parseFloat(minStr) : NaN;
            let max = maxStr !== "" ? parseFloat(maxStr) : NaN;
            // Only validate if both values are valid numbers
            if (!isNaN(min) && !isNaN(max)) {
                if (min >= max) gapMaxInput.value = (min + 0.01).toFixed(2);
                // Warn if gap_max < recommended minimum (from server defaults)
                if (max < MIN_GAP_MAX_THRESHOLD) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Warning: max gap (${max.toFixed(2)}mm) is below recommended minimum (${MIN_GAP_MAX_THRESHOLD.toFixed(2)}mm). This may result in unstable postprocessing. Increase tightness if you need to put teeth closer.`, "exclamation-triangle");
            }
            isValidating = false;
        }
        function validateRuleGapsReverse() {
            if (isValidating) return;
            isValidating = true;
            const minStr = gapMinInput.value.trim();
            const maxStr = gapMaxInput.value.trim();
            const min = minStr !== "" ? parseFloat(minStr) : NaN;
            let max = maxStr !== "" ? parseFloat(maxStr) : NaN;
            // Only validate if both values are valid numbers
            if (!isNaN(min) && !isNaN(max)) {
                if (max <= min) gapMinInput.value = (max - 0.01).toFixed(2);
                // Warn if gap_max < recommended minimum (from server defaults)
                if (max < MIN_GAP_MAX_THRESHOLD) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Warning: max gap (${max.toFixed(2)}mm) is below recommended minimum (${MIN_GAP_MAX_THRESHOLD.toFixed(2)}mm). This may result in unstable postprocessing. Increase tightness if you need to put teeth closer.`, "exclamation-triangle");
            }
            isValidating = false;
        }
        gapMinInput.addEventListener("blur", validateRuleGaps);
        gapMaxInput.addEventListener("blur", validateRuleGapsReverse);
        const actionsCell = document.createElement("td");
        const removeButton = document.createElement("button");
        removeButton.type = "button";
        removeButton.className = "remove-rule-button";
        removeButton.textContent = "Remove";
        removeButton.addEventListener("click", ()=>{
            row.remove();
            updateTableVisibility();
            // Save settings when rule is removed
            $ddb3f022a87c2bc1$export$4bec613efb57fa32();
        });
        actionsCell.appendChild(removeButton);
        // Add event listeners to save settings when inputs change
        [
            toothAInput,
            toothBInput,
            gapMinInput,
            gapMaxInput
        ].forEach((input)=>{
            input.addEventListener("change", ()=>{
                $ddb3f022a87c2bc1$export$4bec613efb57fa32();
            });
        });
        row.appendChild(toothACell);
        row.appendChild(toothBCell);
        row.appendChild(gapMinCell);
        row.appendChild(gapMaxCell);
        row.appendChild(actionsCell);
        tbody.appendChild(row);
        updateTableVisibility();
    };
    addButton.addEventListener("click", ()=>{
        window.addGapRuleFromData();
        // Save settings when new rule is added
        $ddb3f022a87c2bc1$export$4bec613efb57fa32();
    });
    updateTableVisibility();
}
// When False, the "Molar Movement Correction" toggle is hidden and the
// correction stays at its config-driven default (on, per the shipped
// postprocessing_config.json). Controlled by the server setting
// ENABLE_MOLAR_MOVEMENT_TOGGLE.
let $ddb3f022a87c2bc1$var$molarMovementToggleEnabled = true;
function $ddb3f022a87c2bc1$export$21841be6eb9a8d69() {
    const dropdown = document.getElementById("archform-dropdown");
    const group = document.getElementById("archform-rotations-control-group");
    if (!group) return;
    const selection = dropdown ? dropdown.value : "disabled";
    group.style.display = selection && selection !== "disabled" ? "" : "none";
}
function $ddb3f022a87c2bc1$export$b80f21d54e0e670a(enabled) {
    $ddb3f022a87c2bc1$var$molarMovementToggleEnabled = enabled !== false;
    const group = document.getElementById("molar-movement-control-group");
    const checkbox = document.getElementById("enable-molar-movement-checkbox");
    if (group) group.style.display = $ddb3f022a87c2bc1$var$molarMovementToggleEnabled ? "" : "none";
    if (!$ddb3f022a87c2bc1$var$molarMovementToggleEnabled && checkbox) checkbox.checked = true;
}
/**
 * Initialize the freeze (fixed teeth) table: each row is one FDI number the
 * user wants held immovable during arrangement. Mirrors the custom
 * gap rules table -- the DOM is the source of truth, re-scraped on collect.
 */ function $ddb3f022a87c2bc1$var$initializeFixedTeeth() {
    const addButton = document.getElementById("add-fixed-tooth-button");
    const tbody = document.getElementById("fixed-teeth-tbody");
    const table = document.getElementById("fixed-teeth-table");
    const emptyMessage = document.getElementById("fixed-teeth-empty");
    if (!addButton || !tbody || !table || !emptyMessage) return;
    function updateTableVisibility() {
        const hasTeeth = tbody.children.length > 0;
        table.style.display = hasTeeth ? "table" : "none";
        emptyMessage.style.display = hasTeeth ? "none" : "block";
    }
    // Exposed globally so loadPostprocessingSettings() can restore saved teeth.
    window.addFixedToothFromData = function addFixedTooth(fdi = "") {
        const row = document.createElement("tr");
        row.dataset.fixedToothId = `fixed-${$ddb3f022a87c2bc1$var$fixedToothCounter++}`;
        const toothCell = document.createElement("td");
        const toothInput = document.createElement("input");
        toothInput.type = "number";
        toothInput.value = fdi;
        toothInput.placeholder = "e.g., 11";
        toothInput.min = "11";
        toothInput.max = "48";
        toothInput.addEventListener("change", ()=>{
            $ddb3f022a87c2bc1$export$4bec613efb57fa32();
        });
        toothCell.appendChild(toothInput);
        const actionsCell = document.createElement("td");
        const removeButton = document.createElement("button");
        removeButton.type = "button";
        removeButton.className = "remove-rule-button";
        removeButton.textContent = "Remove";
        removeButton.addEventListener("click", ()=>{
            row.remove();
            updateTableVisibility();
            $ddb3f022a87c2bc1$export$4bec613efb57fa32();
        });
        actionsCell.appendChild(removeButton);
        row.appendChild(toothCell);
        row.appendChild(actionsCell);
        tbody.appendChild(row);
        updateTableVisibility();
    };
    addButton.addEventListener("click", ()=>{
        window.addFixedToothFromData();
        $ddb3f022a87c2bc1$export$4bec613efb57fa32();
    });
    updateTableVisibility();
}
function $ddb3f022a87c2bc1$export$166b6ebc095f584e() {
    const fixedTeeth = [];
    const tbody = document.getElementById("fixed-teeth-tbody");
    if (tbody) tbody.querySelectorAll("tr").forEach((row)=>{
        const input = row.querySelector("input");
        if (!input) return;
        const raw = input.value.trim();
        if (raw === "") return;
        const fdi = parseInt(raw, 10);
        if (Number.isNaN(fdi)) return;
        fixedTeeth.push(fdi);
    });
    return fixedTeeth;
}
function $ddb3f022a87c2bc1$export$8b14b38614a79e7e(fdi) {
    const quadrant = Math.floor(fdi / 10);
    const position = fdi % 10;
    return quadrant >= 1 && quadrant <= 4 && position >= 1 && position <= 8;
}
function $ddb3f022a87c2bc1$export$f0bf5b8c7f675d0() {
    const fixedTeeth = [];
    const seen = new Set();
    $ddb3f022a87c2bc1$export$166b6ebc095f584e().forEach((fdi)=>{
        // Permanent teeth only (see isPermanentToothFdi). Warn instead of
        // silently dropping so the operator gets the same feedback as the
        // gap-range inputs. This runs at submit time only, so the toast is not
        // raised on every save.
        if (!$ddb3f022a87c2bc1$export$8b14b38614a79e7e(fdi)) {
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Ignoring frozen tooth ${fdi}: not a permanent tooth FDI (11-48).`, "exclamation-triangle");
            return;
        }
        if (!seen.has(fdi)) {
            seen.add(fdi);
            fixedTeeth.push(fdi);
        }
    });
    return fixedTeeth;
}
function $ddb3f022a87c2bc1$export$9e22e8760fcefed2() {
    const enableCheckbox = document.getElementById("enable-postprocessing-checkbox");
    if (!enableCheckbox || !enableCheckbox.checked) return {
        enabled: false
    };
    const gapMin = parseFloat(document.getElementById("gap-min-slider").value);
    const gapMax = parseFloat(document.getElementById("gap-max-slider").value);
    const tightness = parseFloat(document.getElementById("tightness-slider").value);
    const midlineMode = document.getElementById("midline-mode-dropdown").value;
    const archformDropdown = document.getElementById("archform-dropdown");
    const archform = archformDropdown ? archformDropdown.value : "disabled";
    const molarMovementCheckbox = document.getElementById("enable-molar-movement-checkbox");
    const enableMolarMovementCorrection = !$ddb3f022a87c2bc1$var$molarMovementToggleEnabled || molarMovementCheckbox?.checked !== false;
    const archformRotationsCheckbox = document.getElementById("enable-archform-rotations-checkbox");
    // The checkbox ships ticked, so a missing element means "the default", not
    // "off": send true, the same thing the server would have chosen anyway.
    const enableArchformRotations = archformRotationsCheckbox ? !!archformRotationsCheckbox.checked : true;
    // Collect custom gap rules
    const customGapRules = [];
    const tbody = document.getElementById("custom-gap-rules-tbody");
    if (tbody) {
        const rows = tbody.querySelectorAll("tr");
        rows.forEach((row)=>{
            const inputs = row.querySelectorAll("input");
            if (inputs.length >= 4) {
                const toothA = inputs[0].value.trim();
                const toothB = inputs[1].value.trim();
                const gapMin = inputs[2].value.trim();
                const gapMax = inputs[3].value.trim();
                // Only add if tooth_a and tooth_b are provided
                if (toothA && toothB) {
                    const rule = {
                        tooth_a: parseInt(toothA),
                        tooth_b: parseInt(toothB)
                    };
                    if (gapMin) rule.gap_min = parseFloat(gapMin);
                    if (gapMax) rule.gap_max = parseFloat(gapMax);
                    customGapRules.push(rule);
                }
            }
        });
    }
    const postprocessingParams = {
        gap_min: gapMin,
        gap_max: gapMax,
        tightness: tightness,
        midline_mode: midlineMode,
        enable_molar_movement_correction: enableMolarMovementCorrection,
        archform: archform,
        enable_archform_rotations: enableArchformRotations
    };
    if (customGapRules.length > 0) postprocessingParams.custom_gap_rules = customGapRules;
    const fixedTeeth = $ddb3f022a87c2bc1$export$f0bf5b8c7f675d0();
    if (fixedTeeth.length > 0) postprocessingParams.fixed_teeth = fixedTeeth;
    return {
        enabled: true,
        parameters: postprocessingParams
    };
}
function $ddb3f022a87c2bc1$export$4bec613efb57fa32() {
    try {
        const enableCheckbox = document.getElementById("enable-postprocessing-checkbox");
        const gapMinSlider = document.getElementById("gap-min-slider");
        const gapMaxSlider = document.getElementById("gap-max-slider");
        const tightnessSlider = document.getElementById("tightness-slider");
        const midlineModeDropdown = document.getElementById("midline-mode-dropdown");
        if (!enableCheckbox || !gapMinSlider || !gapMaxSlider || !tightnessSlider || !midlineModeDropdown) return;
        // Collect custom gap rules
        const customGapRules = [];
        const tbody = document.getElementById("custom-gap-rules-tbody");
        if (tbody) {
            const rows = tbody.querySelectorAll("tr");
            rows.forEach((row)=>{
                const inputs = row.querySelectorAll("input");
                if (inputs.length >= 4) {
                    const toothA = inputs[0].value.trim();
                    const toothB = inputs[1].value.trim();
                    const gapMin = inputs[2].value.trim();
                    const gapMax = inputs[3].value.trim();
                    if (toothA && toothB) customGapRules.push({
                        tooth_a: toothA,
                        tooth_b: toothB,
                        gap_min: gapMin,
                        gap_max: gapMax
                    });
                }
            });
        }
        const molarMovementCheckbox = document.getElementById("enable-molar-movement-checkbox");
        const archformDropdown = document.getElementById("archform-dropdown");
        const settings = {
            enabled: enableCheckbox.checked,
            gap_min: gapMinSlider.value,
            gap_max: gapMaxSlider.value,
            tightness: tightnessSlider.value,
            midline_mode: midlineModeDropdown.value,
            custom_gap_rules: customGapRules,
            // Persist the raw table contents (no validation/toast) so a reload
            // restores exactly what is on screen; validation happens at submit.
            fixed_teeth: $ddb3f022a87c2bc1$export$166b6ebc095f584e(),
            enable_molar_movement_correction: molarMovementCheckbox ? molarMovementCheckbox.checked : true,
            archform: archformDropdown ? archformDropdown.value : "disabled",
            enable_archform_rotations: document.getElementById("enable-archform-rotations-checkbox")?.checked !== false
        };
        localStorage.setItem("postprocessingSettings", JSON.stringify(settings));
        console.log("Postprocessing settings saved to localStorage");
    } catch (error) {
        console.error("Error saving postprocessing settings:", error);
    }
}
function $ddb3f022a87c2bc1$export$4d770224d5182406() {
    try {
        const savedSettings = localStorage.getItem("postprocessingSettings");
        // Get UI elements
        const enableCheckbox = document.getElementById("enable-postprocessing-checkbox");
        const gapMinSlider = document.getElementById("gap-min-slider");
        const gapMaxSlider = document.getElementById("gap-max-slider");
        const tightnessSlider = document.getElementById("tightness-slider");
        const midlineModeDropdown = document.getElementById("midline-mode-dropdown");
        if (!savedSettings) {
            console.log("No saved postprocessing settings found - using defaults");
            // Apply default settings for new users
            if (enableCheckbox) enableCheckbox.checked = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.enabled;
            if (gapMinSlider) {
                gapMinSlider.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_min;
                const gapMinValue = document.getElementById("gap-min-value");
                if (gapMinValue) gapMinValue.textContent = parseFloat($ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_min).toFixed(2);
            }
            if (gapMaxSlider) {
                gapMaxSlider.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_max;
                const gapMaxValue = document.getElementById("gap-max-value");
                if (gapMaxValue) gapMaxValue.textContent = parseFloat($ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_max).toFixed(2);
            }
            if (tightnessSlider) {
                tightnessSlider.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.tightness;
                const tightnessValue = document.getElementById("tightness-value");
                if (tightnessValue) tightnessValue.textContent = parseFloat($ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.tightness).toFixed(2);
            }
            if (midlineModeDropdown) midlineModeDropdown.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.midline_mode;
            const archformDropdown = document.getElementById("archform-dropdown");
            if (archformDropdown) archformDropdown.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.archform;
            const archformRotationsCheckbox = document.getElementById("enable-archform-rotations-checkbox");
            if (archformRotationsCheckbox) archformRotationsCheckbox.checked = true;
            $ddb3f022a87c2bc1$export$21841be6eb9a8d69();
            return;
        }
        const settings = JSON.parse(savedSettings);
        console.log("Loading postprocessing settings from localStorage:", settings);
        // Apply settings to UI
        if (enableCheckbox) enableCheckbox.checked = settings.enabled !== undefined ? settings.enabled : true;
        if (gapMinSlider) {
            const gapMin = settings.gap_min !== undefined ? settings.gap_min : $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_min;
            gapMinSlider.value = gapMin;
            const gapMinValue = document.getElementById("gap-min-value");
            if (gapMinValue) gapMinValue.textContent = parseFloat(gapMin).toFixed(2);
        }
        if (gapMaxSlider) {
            const gapMax = settings.gap_max !== undefined ? settings.gap_max : $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_max;
            gapMaxSlider.value = gapMax;
            const gapMaxValue = document.getElementById("gap-max-value");
            if (gapMaxValue) gapMaxValue.textContent = parseFloat(gapMax).toFixed(2);
        }
        if (tightnessSlider) {
            const tightness = settings.tightness !== undefined ? settings.tightness : $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.tightness;
            tightnessSlider.value = tightness;
            const tightnessValue = document.getElementById("tightness-value");
            if (tightnessValue) tightnessValue.textContent = parseFloat(tightness).toFixed(2);
        }
        if (midlineModeDropdown && settings.midline_mode) midlineModeDropdown.value = settings.midline_mode;
        else if (midlineModeDropdown) // Default to "adjust" if not in saved settings
        midlineModeDropdown.value = "adjust";
        // A saved archform whose template is no longer offered would silently
        // select nothing, so fall back to the default unless the option is present.
        const archformDropdown = document.getElementById("archform-dropdown");
        if (archformDropdown) {
            const saved = settings.archform;
            const offered = saved && Array.from(archformDropdown.options).some((option)=>option.value === saved);
            archformDropdown.value = offered ? saved : "disabled";
        }
        // Absent in a saved blob written before this option existed, and the
        // default is on, so `!== false` rather than `=== true`.
        const archformRotationsCheckbox = document.getElementById("enable-archform-rotations-checkbox");
        if (archformRotationsCheckbox) archformRotationsCheckbox.checked = settings.enable_archform_rotations !== false;
        // Kept next to the dropdown restore above, so the checkbox
        // matches the selection the technician is looking at.
        $ddb3f022a87c2bc1$export$21841be6eb9a8d69();
        const molarMovementCheckbox = document.getElementById("enable-molar-movement-checkbox");
        if (molarMovementCheckbox) // When the toggle is hidden, ignore saved state and stay checked
        // (config-driven default) so a stale "off" value can't turn the
        // correction off behind a hidden toggle.
        molarMovementCheckbox.checked = !$ddb3f022a87c2bc1$var$molarMovementToggleEnabled || settings.enable_molar_movement_correction !== false;
        // Load custom gap rules
        if (settings.custom_gap_rules && Array.isArray(settings.custom_gap_rules)) {
            const tbody = document.getElementById("custom-gap-rules-tbody");
            if (tbody) {
                // Clear existing rules first
                tbody.innerHTML = "";
                // Add saved rules
                settings.custom_gap_rules.forEach((rule)=>{
                    // Use the addGapRule function if it's accessible, otherwise add manually
                    if (typeof window.addGapRuleFromData === "function") window.addGapRuleFromData(rule.tooth_a, rule.tooth_b, rule.gap_min, rule.gap_max);
                });
            }
        }
        // Load frozen (fixed) teeth
        if (settings.fixed_teeth && Array.isArray(settings.fixed_teeth)) {
            const tbody = document.getElementById("fixed-teeth-tbody");
            if (tbody) {
                tbody.innerHTML = "";
                settings.fixed_teeth.forEach((fdi)=>{
                    if (typeof window.addFixedToothFromData === "function") window.addFixedToothFromData(fdi);
                });
            }
        }
        console.log("Postprocessing settings loaded successfully");
    } catch (error) {
        console.error("Error loading postprocessing settings:", error);
    }
}
function $ddb3f022a87c2bc1$export$7de7bccc87a83087() {
    const postprocessingSection = document.getElementById("postprocessing-section");
    if (!postprocessingSection) {
        console.warn("Postprocessing section element not found");
        return;
    }
    const processingModeDropdown = document.getElementById("processing-mode-dropdown");
    const processingMode = processingModeDropdown?.value || "arrangement";
    const isFeedbackMode = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode || false;
    const shouldShow = processingMode === "arrangement" && !isFeedbackMode;
    console.log("updatePostprocessingSectionVisibility:", {
        processingMode: processingMode,
        isFeedbackMode: isFeedbackMode,
        shouldShow: shouldShow,
        currentDisplay: postprocessingSection.style.display
    });
    // Explicitly set display style to ensure visibility
    if (shouldShow) {
        postprocessingSection.style.display = "block";
        postprocessingSection.style.setProperty("display", "block", "important");
        console.log("Postprocessing section set to visible");
    } else {
        postprocessingSection.style.display = "none";
        console.log("Postprocessing section set to hidden");
    }
    // Also update gingiva estimation section visibility
    const gingivaEstimationSection = document.getElementById("gingiva-estimation-section");
    if (gingivaEstimationSection) {
        if (shouldShow) gingivaEstimationSection.style.display = "block";
        else gingivaEstimationSection.style.display = "none";
    }
}
function $ddb3f022a87c2bc1$export$107c0d23caa13917() {
    try {
        // Clear localStorage
        localStorage.removeItem("postprocessingSettings");
        console.log("Postprocessing settings cleared from localStorage");
        // Reset UI to default values
        const enableCheckbox = document.getElementById("enable-postprocessing-checkbox");
        const gapMinSlider = document.getElementById("gap-min-slider");
        const gapMaxSlider = document.getElementById("gap-max-slider");
        const tightnessSlider = document.getElementById("tightness-slider");
        const midlineModeDropdown = document.getElementById("midline-mode-dropdown");
        // Reset UI to default values using constants
        if (enableCheckbox) enableCheckbox.checked = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.enabled;
        if (gapMinSlider) {
            gapMinSlider.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_min;
            const gapMinValue = document.getElementById("gap-min-value");
            if (gapMinValue) gapMinValue.textContent = parseFloat($ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_min).toFixed(2);
        }
        if (gapMaxSlider) {
            gapMaxSlider.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_max;
            const gapMaxValue = document.getElementById("gap-max-value");
            if (gapMaxValue) gapMaxValue.textContent = parseFloat($ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.gap_max).toFixed(2);
        }
        if (tightnessSlider) {
            tightnessSlider.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.tightness;
            const tightnessValue = document.getElementById("tightness-value");
            if (tightnessValue) tightnessValue.textContent = parseFloat($ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.tightness).toFixed(2);
        }
        if (midlineModeDropdown) midlineModeDropdown.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.midline_mode;
        const archformDropdown = document.getElementById("archform-dropdown");
        if (archformDropdown) archformDropdown.value = $ddb3f022a87c2bc1$var$DEFAULT_POSTPROCESSING_SETTINGS.archform;
        // Reset restores defaults and has no saved settings to consult, so the
        // default is written directly. The default is on.
        const archformRotationsCheckbox = document.getElementById("enable-archform-rotations-checkbox");
        if (archformRotationsCheckbox) archformRotationsCheckbox.checked = true;
        // Kept next to the dropdown reset above, so the checkbox
        // matches the selection the technician is looking at.
        $ddb3f022a87c2bc1$export$21841be6eb9a8d69();
        const molarMovementCheckbox = document.getElementById("enable-molar-movement-checkbox");
        if (molarMovementCheckbox) molarMovementCheckbox.checked = true;
        // Clear custom gap rules
        const tbody = document.getElementById("custom-gap-rules-tbody");
        if (tbody) tbody.innerHTML = "";
        // Update table visibility
        const table = document.getElementById("custom-gap-rules-table");
        const emptyMessage = document.getElementById("custom-gap-rules-empty");
        if (table) table.style.display = "none";
        if (emptyMessage) emptyMessage.style.display = "block";
        // Clear frozen (fixed) teeth
        const fixedTbody = document.getElementById("fixed-teeth-tbody");
        if (fixedTbody) fixedTbody.innerHTML = "";
        const fixedTable = document.getElementById("fixed-teeth-table");
        const fixedEmpty = document.getElementById("fixed-teeth-empty");
        if (fixedTable) fixedTable.style.display = "none";
        if (fixedEmpty) fixedEmpty.style.display = "block";
        // Trigger the toggle to update UI state - show controls since enabled by default
        const controlsContainer = document.getElementById("postprocessing-controls");
        if (controlsContainer) {
            controlsContainer.style.display = "flex";
            controlsContainer.classList.remove("disabled");
        }
        // Enable all inputs
        if (controlsContainer) {
            const inputs = controlsContainer.querySelectorAll("input, select, button");
            inputs.forEach((input)=>{
                input.disabled = false;
            });
        }
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Postprocessing settings reset to defaults", "check-circle");
    } catch (error) {
        console.error("Error resetting postprocessing settings:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error resetting settings", "exclamation-triangle");
    }
}


class $aa8a35ff0d89d373$export$15f3eed9d687d3e3 {
    constructor(){
        this.isVisible = false;
        this.currentRating = 0;
        this.currentProcessingMode = null;
        this.feedbackData = null;
        this.feedbackConfig = null;
        this.initialized = false;
    }
    /**
     * Initialize the feedback manager
     */ async init() {
        if (this.initialized) return;
        try {
            await this.loadFeedbackConfig();
        } catch (error) {
            console.warn("Failed to load feedback config, using defaults:", error);
        }
        this.setupEventListeners();
        this.loadDoctorName();
        this.setupStarRating();
        this.initialized = true;
        console.log("\uD83D\uDCDD Feedback manager initialized successfully");
    }
    /**
     * Load feedback configuration from server
     */ async loadFeedbackConfig() {
        try {
            console.log("\uD83D\uDCDD Loading feedback configuration from server...");
            this.feedbackConfig = await (0, $913d3a1574de567c$export$ae14c375fc93363).getFeedbackConfig();
            console.log("\uD83D\uDCDD Feedback configuration loaded:", this.feedbackConfig);
        } catch (error) {
            console.error("\uD83D\uDCDD Failed to load feedback configuration:", error);
            // Fallback to default configuration
            this.feedbackConfig = this.getDefaultConfig();
        }
        this.applyGtInfoJsonVisibility();
    }
    /**
     * Show or hide the GT InfoJSON upload block based on server config.
     */ applyGtInfoJsonVisibility() {
        const group = document.getElementById("feedback-gt-info-json-group");
        if (!group) return;
        const enabled = this.feedbackConfig?.gt_info_json_upload?.enabled !== false;
        group.style.display = enabled ? "" : "none";
    }
    /**
     * Get default feedback configuration as fallback
     */ getDefaultConfig() {
        return {
            questions: {
                arrangement: [
                    {
                        id: "alignment_standards",
                        type: "rating_with_comment",
                        question: "Rate the alignment result of the upper and lower jaw for clinical standards",
                        required: true
                    },
                    {
                        id: "occlusal_relationship",
                        type: "rating_with_comment",
                        question: "Rate the occlusal relationship between the upper and lower jaw for clinical standards",
                        required: true
                    },
                    {
                        id: "treatment_expectations",
                        type: "rating_with_comment",
                        question: "Rate how well the result meets your expectation for the post-treatment effects of the patient",
                        required: true
                    }
                ],
                teethml: [
                    {
                        id: "segmentation_accuracy",
                        type: "rating_with_comment",
                        question: "Rate the teeth segmentation accuracy for clinical use",
                        required: true
                    }
                ],
                defectml: [
                    {
                        id: "defect_detection",
                        type: "rating_with_comment",
                        question: "Rate the clinical relevance of the detected defects",
                        required: true
                    }
                ],
                keypointml: [
                    {
                        id: "keypoint_accuracy",
                        type: "rating_with_comment",
                        question: "Rate the anatomical correctness of the detected keypoints",
                        required: true
                    }
                ]
            },
            rating_descriptions: {
                0: "",
                1: "1 - Unacceptable",
                2: "2 - Below Expected",
                3: "3 - Average",
                4: "4 - Good",
                5: "5 - Very Good"
            },
            form_settings: {
                doctor_name_required: true,
                rating_required: true,
                comments_required: false
            }
        };
    }
    /**
     * Setup all event listeners
     */ setupEventListeners() {
        // Submit button
        const submitButton = document.getElementById("feedback-submit");
        if (submitButton) submitButton.addEventListener("click", ()=>this.handleSubmit());
        // Feedback buttons (both external and sidebar)
        const feedbackButton = document.getElementById("feedback-button");
        if (feedbackButton) feedbackButton.addEventListener("click", ()=>this.toggle());
        const sidebarFeedbackButton = document.getElementById("sidebar-feedback-button");
        if (sidebarFeedbackButton) sidebarFeedbackButton.addEventListener("click", ()=>this.toggle());
        // Collapsed feedback button in sidebar header
        const collapsedFeedbackButton = document.getElementById("feedback-button-collapsed");
        if (collapsedFeedbackButton) collapsedFeedbackButton.addEventListener("click", ()=>this.toggle());
        // Doctor name input - save to localStorage on change
        const doctorNameInput = document.getElementById("doctor-name");
        if (doctorNameInput) doctorNameInput.addEventListener("blur", ()=>{
            this.saveDoctorName(doctorNameInput.value);
        });
        // GT InfoJSON file input: show selected filename
        const gtInfoJsonFile = document.getElementById("feedback-gt-info-json-file");
        const gtInfoJsonFileName = document.getElementById("feedback-gt-info-json-file-name");
        if (gtInfoJsonFile && gtInfoJsonFileName) gtInfoJsonFile.addEventListener("change", (event)=>{
            const file = event.target.files[0];
            if (file) gtInfoJsonFileName.textContent = file.name;
            else gtInfoJsonFileName.textContent = "";
        });
        // Close on ESC key
        document.addEventListener("keydown", (event)=>{
            if (event.key === "Escape" && this.isVisible) this.hide();
        });
        // Prevent closing when clicking inside the sidebar
        const sidebar = document.getElementById("feedback-sidebar");
        if (sidebar) sidebar.addEventListener("click", (event)=>{
            event.stopPropagation();
        });
    }
    /**
     * Setup star rating functionality
     */ setupStarRating() {
        const stars = document.querySelectorAll(".star");
        const ratingDescription = document.getElementById("rating-description");
        // Get descriptions from config or use defaults
        const descriptions = this.feedbackConfig?.rating_descriptions || {
            0: "",
            1: "1 - Unacceptable",
            2: "2 - Below Expected",
            3: "3 - Average",
            4: "4 - Good",
            5: "5 - Very Good"
        };
        stars.forEach((star, index)=>{
            star.addEventListener("click", ()=>{
                this.currentRating = index + 1;
                this.updateStarDisplay();
                if (ratingDescription) ratingDescription.textContent = descriptions[this.currentRating];
            });
            star.addEventListener("mouseenter", ()=>{
                const rating = index + 1;
                this.highlightStars(rating);
                if (ratingDescription) ratingDescription.textContent = descriptions[rating];
            });
        });
        const starsContainer = document.getElementById("rating-stars");
        if (starsContainer) starsContainer.addEventListener("mouseleave", ()=>{
            this.updateStarDisplay();
            if (ratingDescription) ratingDescription.textContent = descriptions[this.currentRating];
        });
    }
    /**
     * Highlight stars up to the given rating
     * @param {number} rating - Rating from 1-5
     */ highlightStars(rating) {
        const stars = document.querySelectorAll(".star");
        stars.forEach((star, index)=>{
            if (index < rating) star.classList.add("active");
            else star.classList.remove("active");
        });
    }
    /**
     * Update star display based on current rating
     */ updateStarDisplay() {
        this.highlightStars(this.currentRating);
    }
    /**
     * Load doctor name from localStorage
     */ loadDoctorName() {
        try {
            const savedName = localStorage.getItem("teethml-doctor-name");
            const doctorNameInput = document.getElementById("doctor-name");
            if (savedName && doctorNameInput) doctorNameInput.value = savedName;
        } catch (error) {
            console.warn("Failed to load doctor name from localStorage:", error);
        }
    }
    /**
     * Save doctor name to localStorage
     * @param {string} name - Doctor name to save
     */ saveDoctorName(name) {
        try {
            if (name && name.trim()) localStorage.setItem("teethml-doctor-name", name.trim());
        } catch (error) {
            console.warn("Failed to save doctor name to localStorage:", error);
        }
    }
    /**
     * Toggle the feedback form
     */ toggle() {
        if (this.isVisible) this.hide();
        else this.show();
    }
    /**
     * Show the feedback form
     * @param {string} processingMode - Current processing mode
     * @param {Object} predictionData - Prediction results data
     */ show(processingMode = null, predictionData = null) {
        console.log("\uD83D\uDCDD Showing feedback form for mode:", processingMode);
        // Use stored processing mode if not provided
        if (!processingMode && this.currentProcessingMode) processingMode = this.currentProcessingMode;
        if (processingMode) {
            this.currentProcessingMode = processingMode;
            // Preserve existing predictionData if new predictionData is not provided
            const existingPredictionData = this.feedbackData?.predictionData;
            const finalPredictionData = predictionData !== null ? predictionData : existingPredictionData;
            const fileData = this.collectFileData();
            this.feedbackData = {
                processingMode: processingMode,
                predictionData: finalPredictionData,
                timestamp: new Date().toISOString(),
                // Original processing job id, used by the server to link this
                // feedback to the job's audit record.
                originalItemId: (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastProcessedItemId || null,
                files: fileData,
                // Create meshFiles array from the collected file data for compatibility with feedback display
                meshFiles: this.extractMeshFilesFromFileData(fileData)
            };
            // Show/hide mode-specific questions
            this.updateQuestionVisibility(processingMode);
        }
        // Reset form
        this.resetForm();
        // Show the feedback form in the right sidebar
        const feedbackFormSection = document.getElementById("feedback-form-section");
        const rightSidebar = document.getElementById("right-sidebar");
        const appContainer = document.querySelector(".app-container");
        if (feedbackFormSection) {
            feedbackFormSection.style.display = "block";
            this.isVisible = true;
        }
        // In Processing mode, temporarily show the right sidebar for feedback
        if (rightSidebar && appContainer) {
            const isProcessingMode = !(0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode;
            if (isProcessingMode) {
                rightSidebar.style.display = "block";
                appContainer.classList.remove("hide-right-sidebar");
                // Expand right sidebar if it's collapsed
                if (rightSidebar.classList.contains("right-sidebar-collapsed")) {
                    rightSidebar.classList.remove("right-sidebar-collapsed");
                    appContainer.classList.remove("right-collapsed");
                    const collapseBtn = document.getElementById("collapse-right");
                    if (collapseBtn) {
                        collapseBtn.innerHTML = "\u276F";
                        collapseBtn.title = "Collapse sidebar";
                    }
                    rightSidebar.querySelector(".sidebar-title").textContent = "Feedback";
                }
            }
        }
        // Focus on first input
        setTimeout(()=>{
            const doctorNameInput = document.getElementById("doctor-name");
            if (doctorNameInput && !doctorNameInput.value) doctorNameInput.focus();
        }, 300);
    }
    /**
     * Hide the feedback form
     */ hide() {
        console.log("\uD83D\uDCDD Hiding feedback form");
        // Hide the feedback form in the right sidebar
        const feedbackFormSection = document.getElementById("feedback-form-section");
        if (feedbackFormSection) {
            feedbackFormSection.style.display = "none";
            this.isVisible = false;
        }
        // In Processing mode, hide the right sidebar again after feedback
        const rightSidebar = document.getElementById("right-sidebar");
        const appContainer = document.querySelector(".app-container");
        if (rightSidebar && appContainer) {
            const isProcessingMode = !(0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode;
            if (isProcessingMode) {
                rightSidebar.style.display = "none";
                appContainer.classList.add("hide-right-sidebar");
                // Reset sidebar title
                const sidebarTitle = rightSidebar.querySelector(".sidebar-title");
                if (sidebarTitle) sidebarTitle.textContent = "Details";
            }
        }
        // Reset form after animation
        setTimeout(()=>{
            this.resetForm();
        }, 300);
    }
    /**
     * Update question visibility based on processing mode
     * @param {string} processingMode - Current processing mode
     */ updateQuestionVisibility(processingMode) {
        const questionsContainer = document.getElementById("dynamic-questions");
        if (!questionsContainer || !this.feedbackConfig) return;
        // Clear existing questions
        questionsContainer.innerHTML = "";
        // Get questions for this processing mode
        const questions = this.feedbackConfig.questions[processingMode] || [];
        if (questions.length === 0) {
            questionsContainer.style.display = "none";
            return;
        }
        // Generate HTML for each question
        questions.forEach((question, index)=>{
            if (question.type === "yes_no") {
                const questionDiv = this.createYesNoQuestion(question, index);
                questionsContainer.appendChild(questionDiv);
            } else if (question.type === "rating_with_comment" || question.type === "rating_and_comment") {
                const questionDiv = this.createRatingAndCommentQuestion(question, index);
                questionsContainer.appendChild(questionDiv);
            } else {
                console.warn(`\u{1F4DD} Unknown question type: ${question.type}, treating as yes_no`);
                const questionDiv = this.createYesNoQuestion(question, index);
                questionsContainer.appendChild(questionDiv);
            }
        });
        questionsContainer.style.display = "block";
        console.log(`\u{1F4DD} Generated ${questions.length} questions for ${processingMode} mode`);
    }
    /**
     * Create a yes/no question element
     * @param {Object} question - Question configuration
     * @param {number} index - Question index
     * @returns {HTMLElement} Question element
     */ createYesNoQuestion(question, index) {
        const questionDiv = document.createElement("div");
        questionDiv.className = "yes-no-question";
        const questionText = document.createElement("div");
        questionText.className = "question-text";
        const requiredMark = question.required !== false ? ' <span class="required-asterisk">*</span>' : "";
        questionText.innerHTML = `<strong>Question ${index + 1}:</strong> ${question.question}${requiredMark}`;
        const radioContainer = document.createElement("div");
        radioContainer.className = "radio-container";
        // Create radio wrapper
        const radioWrapper = document.createElement("div");
        radioWrapper.className = "radio-wrapper";
        // Create Yes radio button and label
        const yesLabel = document.createElement("label");
        yesLabel.className = "radio-label yes-label";
        const yesRadio = document.createElement("input");
        yesRadio.type = "radio";
        yesRadio.id = `${question.id}-yes`;
        yesRadio.name = question.id;
        yesRadio.value = "yes";
        yesRadio.className = "radio-input";
        const yesText = document.createElement("span");
        yesText.textContent = "Yes";
        yesLabel.appendChild(yesRadio);
        yesLabel.appendChild(yesText);
        // Create No radio button and label
        const noLabel = document.createElement("label");
        noLabel.className = "radio-label no-label";
        const noRadio = document.createElement("input");
        noRadio.type = "radio";
        noRadio.id = `${question.id}-no`;
        noRadio.name = question.id;
        noRadio.value = "no";
        noRadio.className = "radio-input";
        const noText = document.createElement("span");
        noText.textContent = "No";
        noLabel.appendChild(noRadio);
        noLabel.appendChild(noText);
        // Add event listeners to handle visual feedback
        yesRadio.addEventListener("change", (e)=>{
            if (e.target.checked) {
                radioWrapper.classList.add("yes-selected");
                radioWrapper.classList.remove("no-selected");
            }
        });
        noRadio.addEventListener("change", (e)=>{
            if (e.target.checked) {
                radioWrapper.classList.add("no-selected");
                radioWrapper.classList.remove("yes-selected");
            }
        });
        // Start with no selection (empty by default)
        radioWrapper.appendChild(yesLabel);
        radioWrapper.appendChild(noLabel);
        radioContainer.appendChild(radioWrapper);
        questionDiv.appendChild(questionText);
        questionDiv.appendChild(radioContainer);
        return questionDiv;
    }
    /**
     * Create a rating and comment question element
     * @param {Object} question - Question configuration
     * @param {number} index - Question index
     * @returns {HTMLElement} Question element
     */ createRatingAndCommentQuestion(question, index) {
        const questionDiv = document.createElement("div");
        questionDiv.className = "rating-comment-question";
        const questionText = document.createElement("div");
        questionText.className = "question-text";
        const requiredMark = question.required !== false ? ' <span class="required-asterisk">*</span>' : "";
        questionText.innerHTML = `<strong>Question ${index + 1}:</strong> ${question.question}${requiredMark}`;
        // Rating section
        const ratingSection = document.createElement("div");
        ratingSection.className = "rating-section";
        const ratingLabel = document.createElement("div");
        ratingLabel.className = "rating-label";
        ratingLabel.textContent = "Rating:";
        const ratingContainer = document.createElement("div");
        ratingContainer.className = "star-rating";
        ratingContainer.dataset.questionId = question.id; // Add question ID to container
        for(let i = 1; i <= 5; i++){
            const star = document.createElement("span");
            star.className = "star";
            star.textContent = "\u2605";
            star.dataset.rating = i;
            star.dataset.questionId = question.id;
            star.addEventListener("click", (e)=>{
                const rating = parseInt(e.target.dataset.rating);
                const questionId = e.target.dataset.questionId;
                console.log(`\u{1F4DD} Star clicked - Rating: ${rating}, Question: ${questionId}`);
                // Update visual state
                this.updateQuestionStarDisplay(ratingContainer, rating);
                // Store rating on the container
                ratingContainer.dataset.rating = rating;
                console.log(`\u{1F4DD} Rating stored on container for ${questionId}: ${rating}`, {
                    container: ratingContainer,
                    storedRating: ratingContainer.dataset.rating
                });
            });
            // Add hover events for individual question stars
            star.addEventListener("mouseenter", (e)=>{
                const rating = parseInt(e.target.dataset.rating);
                this.updateQuestionStarDisplay(ratingContainer, rating);
            });
            ratingContainer.appendChild(star);
        }
        // Add mouseleave event to the container to restore actual rating
        ratingContainer.addEventListener("mouseleave", ()=>{
            const actualRating = parseInt(ratingContainer.dataset.rating) || 0;
            this.updateQuestionStarDisplay(ratingContainer, actualRating);
        });
        // Comment section
        const commentSection = document.createElement("div");
        commentSection.className = "comment-section";
        const commentLabel = document.createElement("label");
        commentLabel.textContent = "Comments:";
        commentLabel.setAttribute("for", `comment-${question.id}`);
        const commentTextarea = document.createElement("textarea");
        commentTextarea.id = `comment-${question.id}`;
        commentTextarea.name = `comment-${question.id}`;
        commentTextarea.className = "comment-input";
        commentTextarea.placeholder = "Optional comments about this question...";
        commentTextarea.rows = 3;
        // Assemble the question
        ratingSection.appendChild(ratingLabel);
        ratingSection.appendChild(ratingContainer);
        commentSection.appendChild(commentLabel);
        commentSection.appendChild(commentTextarea);
        questionDiv.appendChild(questionText);
        questionDiv.appendChild(ratingSection);
        questionDiv.appendChild(commentSection);
        return questionDiv;
    }
    /**
     * Update star display for individual question ratings
     * @param {HTMLElement} ratingContainer - Container with stars
     * @param {number} rating - Rating from 1-5
     */ updateQuestionStarDisplay(ratingContainer, rating) {
        const allStars = ratingContainer.querySelectorAll(".star");
        allStars.forEach((s, idx)=>{
            if (idx < rating) s.classList.add("active");
            else s.classList.remove("active");
        });
    }
    /**
     * Initialize feedback data after processing completes and show feedback button
     * @param {string} processingMode - Current processing mode
     * @param {Object} predictionData - Prediction results data
     */ initializeForProcessing(processingMode, predictionData = null) {
        console.log("\uD83D\uDCDD Initializing feedback for processing mode:", processingMode);
        this.currentProcessingMode = processingMode;
        const fileData = this.collectFileData();
        this.feedbackData = {
            processingMode: processingMode,
            predictionData: predictionData,
            timestamp: new Date().toISOString(),
            // Original processing job id, used by the server to link this
            // feedback to the job's audit record.
            originalItemId: (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastProcessedItemId || null,
            files: fileData,
            // Create meshFiles array from the collected file data for compatibility with feedback display
            meshFiles: this.extractMeshFilesFromFileData(fileData)
        };
        // Show the feedback button
        this.showFeedbackButton();
    }
    /**
     * Show the feedback buttons
     */ showFeedbackButton() {
        const feedbackButton = document.getElementById("feedback-button");
        const sidebarFeedbackButton = document.getElementById("sidebar-feedback-button");
        if (feedbackButton) feedbackButton.style.display = "flex";
        if (sidebarFeedbackButton) sidebarFeedbackButton.style.display = "flex";
        console.log("\uD83D\uDCDD Feedback buttons shown");
    }
    /**
     * Hide the feedback buttons
     */ hideFeedbackButton() {
        const feedbackButton = document.getElementById("feedback-button");
        const sidebarFeedbackButton = document.getElementById("sidebar-feedback-button");
        if (feedbackButton) feedbackButton.style.display = "none";
        if (sidebarFeedbackButton) sidebarFeedbackButton.style.display = "none";
        console.log("\uD83D\uDCDD Feedback buttons hidden");
    }
    /**
     * Reset the form to initial state
     */ resetForm() {
        // Reset rating
        this.currentRating = 0;
        this.updateStarDisplay();
        const ratingDescription = document.getElementById("rating-description");
        if (ratingDescription) ratingDescription.textContent = "";
        // Reset radio buttons in dynamic questions to empty state
        const radioInputs = document.querySelectorAll("#dynamic-questions .radio-input");
        radioInputs.forEach((radioInput)=>{
            radioInput.checked = false;
            // Reset visual state to empty
            const wrapper = radioInput.closest(".radio-wrapper");
            if (wrapper) {
                wrapper.classList.remove("no-selected");
                wrapper.classList.remove("yes-selected");
            }
        });
        // Reset comment
        const commentsTextarea = document.getElementById("additional-comments");
        if (commentsTextarea) commentsTextarea.value = "";
        // Reset GT InfoJSON inputs
        const gtFileInput = document.getElementById("feedback-gt-info-json-file");
        if (gtFileInput) gtFileInput.value = "";
        const gtFileName = document.getElementById("feedback-gt-info-json-file-name");
        if (gtFileName) gtFileName.textContent = "";
        const gtAzurePath = document.getElementById("feedback-gt-info-json-azure-path");
        if (gtAzurePath) gtAzurePath.value = "";
        // Reset submit button
        const submitButton = document.getElementById("feedback-submit");
        if (submitButton) {
            submitButton.disabled = false;
            submitButton.innerHTML = "Submit Feedback";
        }
        // Show form, hide success
        const formContainer = document.getElementById("feedback-form-container");
        const successContainer = document.getElementById("feedback-success");
        if (formContainer) formContainer.style.display = "block";
        if (successContainer) successContainer.style.display = "none";
    }
    /**
     * Collect current file data
     * @returns {Object} File data object
     */ collectFileData() {
        const files = {};
        // Get processing mode
        const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
        if (processingMode === "arrangement") {
            // Collect arrangement files
            const lowerJawFile = document.getElementById("lower-jaw-file")?.files[0];
            const upperJawFile = document.getElementById("upper-jaw-file")?.files[0];
            if (lowerJawFile) files.lowerJawFile = {
                name: lowerJawFile.name,
                size: lowerJawFile.size,
                type: lowerJawFile.type,
                file: lowerJawFile // Store the actual file object
            };
            if (upperJawFile) files.upperJawFile = {
                name: upperJawFile.name,
                size: upperJawFile.size,
                type: upperJawFile.type,
                file: upperJawFile // Store the actual file object
            };
            // Check for Azure paths
            const lowerJawAzurePath = document.getElementById("lower-jaw-azure-path")?.value;
            const upperJawAzurePath = document.getElementById("upper-jaw-azure-path")?.value;
            if (lowerJawAzurePath) files.lowerJawAzurePath = lowerJawAzurePath;
            if (upperJawAzurePath) files.upperJawAzurePath = upperJawAzurePath;
            // Collect postprocessing parameters for arrangement mode
            try {
                const postprocessingData = (0, $ddb3f022a87c2bc1$export$9e22e8760fcefed2)();
                files.postprocessing = postprocessingData;
            } catch (error) {
                console.warn("Failed to collect postprocessing parameters:", error);
                // Set default disabled state if collection fails
                files.postprocessing = {
                    enabled: false
                };
            }
        } else {
            // Collect single file
            const singleFile = document.getElementById("file-select")?.files[0];
            if (singleFile) files.inputFile = {
                name: singleFile.name,
                size: singleFile.size,
                type: singleFile.type,
                file: singleFile // Store the actual file object
            };
            // Check for Azure path
            const azurePath = document.getElementById("azure-path-input")?.value;
            if (azurePath) files.azurePath = azurePath;
        }
        // Optional GT InfoJSON Azure path
        const gtInfoJsonAzurePath = document.getElementById("feedback-gt-info-json-azure-path")?.value?.trim();
        if (gtInfoJsonAzurePath) files.gtInfoJsonAzurePath = gtInfoJsonAzurePath;
        return files;
    }
    /**
     * Extract mesh files from collected file data for display compatibility
     * @param {Object} fileData - Collected file data
     * @returns {Array} Array of mesh file objects
     */ extractMeshFilesFromFileData(fileData) {
        const meshFiles = [];
        // For arrangement mode, extract lower and upper jaw files
        if (fileData.lowerJawFile?.file) meshFiles.push(fileData.lowerJawFile.file);
        if (fileData.upperJawFile?.file) meshFiles.push(fileData.upperJawFile.file);
        // For other modes, extract the single input file
        if (fileData.inputFile?.file) meshFiles.push(fileData.inputFile.file);
        console.log(`\u{1F4C1} Extracted ${meshFiles.length} mesh files from file data for feedback display`);
        return meshFiles;
    }
    /**
     * Collect form data
     * @returns {Object} Form data object
     */ collectFormData() {
        const doctorName = document.getElementById("doctor-name")?.value?.trim() || "";
        const additionalComments = document.getElementById("additional-comments")?.value?.trim() || "";
        const formData = {
            doctorName: doctorName,
            rating: this.currentRating,
            additionalComments: additionalComments,
            processingMode: this.currentProcessingMode
        };
        // Collect dynamic questions based on current processing mode
        if (this.feedbackConfig && this.currentProcessingMode) {
            const questions = this.feedbackConfig.questions[this.currentProcessingMode] || [];
            const questionResponses = {};
            questions.forEach((question)=>{
                if (question.type === "yes_no") {
                    const selectedRadio = document.querySelector(`input[name="${question.id}"]:checked`);
                    if (selectedRadio) questionResponses[question.id] = selectedRadio.value;
                    else questionResponses[question.id] = null;
                } else if (question.type === "rating_with_comment" || question.type === "rating_and_comment") {
                    // Collect rating and comment
                    const ratingContainer = document.querySelector(`.star-rating[data-question-id="${question.id}"]`);
                    let rating = null;
                    if (ratingContainer && ratingContainer.dataset.rating) {
                        rating = parseInt(ratingContainer.dataset.rating);
                        console.log(`\u{1F4DD} Found rating for ${question.id}: ${rating}`);
                    } else console.warn(`\u{1F4DD} No rating found for question ${question.id}`, {
                        ratingContainer: ratingContainer,
                        rating: ratingContainer?.dataset?.rating
                    });
                    // Collect comment
                    const commentInput = document.getElementById(`comment-${question.id}`);
                    const comment = commentInput ? commentInput.value.trim() : "";
                    const questionResponse = {
                        rating: rating,
                        comment: comment || null
                    };
                    questionResponses[question.id] = questionResponse;
                    console.log(`\u{1F4DD} Collected response for ${question.id}:`, questionResponse);
                } else {
                    console.warn(`\u{1F4DD} Unknown question type: ${question.type} for question ${question.id}`);
                    questionResponses[question.id] = null;
                }
            });
            // Store responses using the processing mode as key
            if (Object.keys(questionResponses).length > 0) formData.dynamicQuestions = questionResponses;
        }
        console.log(`\u{1F4DD} Final form data collected:`, {
            processingMode: this.currentProcessingMode,
            questionCount: Object.keys(formData.dynamicQuestions || {}).length,
            dynamicQuestions: formData.dynamicQuestions,
            doctorName: formData.doctorName,
            rating: formData.rating
        });
        return formData;
    }
    /**
     * Validate form data
     * @param {Object} formData - Form data to validate
     * @returns {Object} Validation result
     */ validateForm(formData) {
        const errors = [];
        if (!formData.doctorName) errors.push("Doctor name is required");
        if (formData.rating === 0) errors.push("Please provide a rating");
        // Synchronous GT InfoJSON checks (size + filename).
        // Structural JSON parsing happens async in handleSubmit before upload.
        const gtFile = document.getElementById("feedback-gt-info-json-file")?.files?.[0];
        // Limit is published via feedback config from the server.
        // If absent, skip client-side check.
        const maxKb = this.feedbackConfig?.gt_info_json_upload?.max_size_kb;
        if (gtFile) {
            if (!gtFile.name.toLowerCase().endsWith(".json")) errors.push("GT InfoJSON must be a .json file");
            if (maxKb && gtFile.size > maxKb * 1024) errors.push(`GT InfoJSON exceeds ${maxKb} KB (got ${gtFile.size} bytes)`);
        }
        // Check if required questions are answered
        if (this.feedbackConfig && this.currentProcessingMode) {
            const modeQuestions = this.feedbackConfig.questions[this.currentProcessingMode] || [];
            const answeredQuestions = formData.dynamicQuestions || {};
            // Validate each question based on its required property
            modeQuestions.forEach((question, index)=>{
                const response = answeredQuestions[question.id];
                const isRequired = question.required !== false; // Default to required if not specified
                console.log(`\u{1F4DD} Validating question ${index + 1} (${question.id})`, {
                    questionType: question.type,
                    response: response,
                    question: question.question,
                    isRequired: isRequired
                });
                // Only validate if the question is required
                if (!isRequired) {
                    console.log(`\u{1F4DD} Question ${index + 1} is optional, skipping validation`);
                    return;
                }
                if (question.type === "yes_no") {
                    if (response === null || response === undefined || response === "") {
                        const errorMsg = `Please answer Question ${index + 1}: ${question.question}`;
                        console.log(`\u{1F4DD} Validation error (yes_no):`, errorMsg);
                        errors.push(errorMsg);
                    }
                } else if (question.type === "rating_with_comment" || question.type === "rating_and_comment") {
                    if (!response || response.rating === null || response.rating === undefined || response.rating === 0) {
                        const errorMsg = `Please provide a rating for Question ${index + 1}: ${question.question}`;
                        console.log(`\u{1F4DD} Validation error (rating_with_comment):`, errorMsg, {
                            hasResponse: !!response,
                            rating: response?.rating,
                            comment: response?.comment
                        });
                        errors.push(errorMsg);
                    } else console.log(`\u{1F4DD} Question ${index + 1} validated successfully - rating: ${response.rating}`);
                } else // Unknown question type, validate if required
                if (response === null || response === undefined || response === "") {
                    const errorMsg = `Please answer Question ${index + 1}: ${question.question}`;
                    console.log(`\u{1F4DD} Validation error (unknown type):`, errorMsg);
                    errors.push(errorMsg);
                }
            });
        }
        return {
            isValid: errors.length === 0,
            errors: errors
        };
    }
    /**
     * Validate structural shape of GT InfoJSON before submit.
     * Returns null if valid (or no file selected), or an error string.
     */ async validateGtInfoJsonStructure() {
        const gtFile = document.getElementById("feedback-gt-info-json-file")?.files?.[0];
        if (!gtFile) return null;
        let parsed;
        try {
            parsed = JSON.parse(await gtFile.text());
        } catch (e) {
            return `GT InfoJSON is not valid JSON: ${e.message}`;
        }
        if (!parsed || typeof parsed !== "object" || Array.isArray(parsed) || !("Version" in parsed) || !("Objects" in parsed)) return "GT InfoJSON must contain 'Version' and 'Objects'";
        if (!Array.isArray(parsed.Objects)) return "GT InfoJSON 'Objects' must be a list";
        for(let i = 0; i < parsed.Objects.length; i++){
            const obj = parsed.Objects[i];
            if (!obj || typeof obj !== "object") return `GT InfoJSON Objects[${i}] must be an object`;
            if (!("Type" in obj) || !("Transform" in obj)) return `GT InfoJSON Objects[${i}] must contain 'Type' and 'Transform'`;
            if (!Array.isArray(obj.Transform) || obj.Transform.length !== 16) return `GT InfoJSON Objects[${i}].Transform must be a 16-element list`;
            if (!obj.Transform.every((v)=>typeof v === "number" && Number.isFinite(v))) return `GT InfoJSON Objects[${i}].Transform elements must be numbers`;
        }
        return null;
    }
    /**
     * Handle form submission
     */ async handleSubmit() {
        console.log("\uD83D\uDCDD Handling feedback form submission");
        // Collect form data
        const formData = this.collectFormData();
        console.log("\uD83D\uDCDD Collected form data:", formData);
        // Validate form
        const validation = this.validateForm(formData);
        if (!validation.isValid) {
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(validation.errors.join(", "), "exclamation-triangle");
            return;
        }
        // Structural validation of GT InfoJSON
        const gtStructureError = await this.validateGtInfoJsonStructure();
        if (gtStructureError) {
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(gtStructureError, "exclamation-triangle");
            return;
        }
        // Save doctor name
        this.saveDoctorName(formData.doctorName);
        // Update submit button to loading state
        const submitButton = document.getElementById("feedback-submit");
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.innerHTML = `
                <div class="feedback-loading">
                    <div class="feedback-spinner"></div>
                    Submitting...
                </div>
            `;
        }
        try {
            // Prepare submission data
            const submissionData = {
                ...this.feedbackData,
                formData: formData,
                submissionTime: new Date().toISOString()
            };
            console.log("\uD83D\uDCDD Submitting feedback data:", submissionData);
            // Submit feedback
            await this.submitFeedback(submissionData);
            // Show success state
            this.showSuccessState();
        } catch (error) {
            console.error("\uD83D\uDCDD Failed to submit feedback:", error);
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Failed to submit feedback. Please try again.", "exclamation-triangle");
            // Reset submit button
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.innerHTML = "Submit Feedback";
            }
        }
    }
    /**
     * Submit feedback to server
     * @param {Object} feedbackData - Complete feedback data
     */ async submitFeedback(feedbackData) {
        try {
            // Create FormData for file uploads
            const formData = new FormData();
            // Add feedback JSON data
            formData.append("feedback_data", JSON.stringify(feedbackData));
            // Add files if they exist
            await this.appendFiles(formData);
            // Detect GT InfoJSON upload attempt before the response so we can
            // distinguish "no GT submitted" from "GT submitted but server failed
            // to persist it" (server returns gt_info_json_stored=false in that
            // second case after only logging a warning -- without this check the
            // clinician would see a green success toast while their GT was lost).
            const gtInfoJsonFile = document.getElementById("feedback-gt-info-json-file")?.files?.[0];
            const gtInfoJsonAzurePath = document.getElementById("feedback-gt-info-json-azure-path")?.value?.trim();
            const gtInfoJsonAttempted = Boolean(gtInfoJsonFile || gtInfoJsonAzurePath);
            // Submit to server
            const response = await (0, $913d3a1574de567c$export$ae14c375fc93363).submitFeedback(formData);
            if (!response || response.error) throw new Error(response?.error || "Unknown error occurred");
            if (gtInfoJsonAttempted && response.gt_info_json_stored === false) {
                console.warn("\uD83D\uDCDD Feedback saved but GT InfoJSON was not stored:", response);
                (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Feedback saved, but GT InfoJSON failed to store. Please retry the GT upload.", "exclamation-triangle");
                return;
            }
            console.log("\uD83D\uDCDD Feedback submitted successfully:", response);
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Feedback submitted successfully!", "check-circle");
        } catch (error) {
            console.error("\uD83D\uDCDD Error submitting feedback:", error);
            throw error;
        }
    }
    /**
     * Append files to form data for submission
     * @param {FormData} formData - FormData to append files to
     */ async appendFiles(formData) {
        const processingMode = this.currentProcessingMode;
        if (processingMode === "arrangement") {
            // Append arrangement files
            const lowerJawFile = document.getElementById("lower-jaw-file")?.files[0];
            const upperJawFile = document.getElementById("upper-jaw-file")?.files[0];
            if (lowerJawFile) formData.append("lower_jaw_file", lowerJawFile);
            if (upperJawFile) formData.append("upper_jaw_file", upperJawFile);
        } else {
            // Append single file
            const singleFile = document.getElementById("file-select")?.files[0];
            if (singleFile) formData.append("input_file", singleFile);
        }
        // Add prediction results as JSON file if available
        if (this.feedbackData?.predictionData) {
            const predictionBlob = new Blob([
                JSON.stringify(this.feedbackData.predictionData, null, 2)
            ], {
                type: "application/json"
            });
            formData.append("prediction_results", predictionBlob, "prediction_results.json");
        }
        // Optional GT InfoJSON: file takes precedence over Azure path
        const gtInfoJsonFile = document.getElementById("feedback-gt-info-json-file")?.files?.[0];
        const gtInfoJsonAzurePath = document.getElementById("feedback-gt-info-json-azure-path")?.value?.trim();
        if (gtInfoJsonFile) formData.append("gt_info_json_file", gtInfoJsonFile);
        else if (gtInfoJsonAzurePath) formData.append("gt_info_json_azure_path", gtInfoJsonAzurePath);
    }
    /**
     * Show success state
     */ showSuccessState() {
        const formContainer = document.getElementById("feedback-form-container");
        const successContainer = document.getElementById("feedback-success");
        if (formContainer) formContainer.style.display = "none";
        if (successContainer) successContainer.style.display = "block";
        // Auto-hide after 3 seconds
        setTimeout(()=>{
            this.hide();
        }, 3000);
    }
}
const $aa8a35ff0d89d373$export$d3c1098c3ede00c2 = new $aa8a35ff0d89d373$export$15f3eed9d687d3e3();
// Initialize the feedback manager when DOM is ready
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", async ()=>{
    try {
        await $aa8a35ff0d89d373$export$d3c1098c3ede00c2.init();
    } catch (error) {
        console.warn("Failed to initialize feedback manager:", error);
    }
});
else // DOM is already loaded
(async ()=>{
    try {
        await $aa8a35ff0d89d373$export$d3c1098c3ede00c2.init();
    } catch (error) {
        console.warn("Failed to initialize feedback manager:", error);
    }
})();
function $aa8a35ff0d89d373$export$f95c1e417f283156(processingMode, predictionData = null) {
    $aa8a35ff0d89d373$export$d3c1098c3ede00c2.show(processingMode, predictionData);
}
function $aa8a35ff0d89d373$export$e8b319b217cce0c5() {
    $aa8a35ff0d89d373$export$d3c1098c3ede00c2.hide();
}
function $aa8a35ff0d89d373$export$6abedbe6567986dc(processingMode, predictionData = null) {
    $aa8a35ff0d89d373$export$d3c1098c3ede00c2.initializeForProcessing(processingMode, predictionData);
}
function $aa8a35ff0d89d373$export$103f403a87b4df10() {
    $aa8a35ff0d89d373$export$d3c1098c3ede00c2.showFeedbackButton();
}
function $aa8a35ff0d89d373$export$325c923fa31af59e() {
    $aa8a35ff0d89d373$export$d3c1098c3ede00c2.hideFeedbackButton();
}


/**
 * Feedback Parser Module
 * Utilities for parsing and managing feedback data from local folders
 */ /**
 * Feedback configuration for different processing modes
 */ const $3229c9fdc637713a$export$4a1af812267f0131 = {
    teethml: [
        "Is the tooth segmentation accurate?",
        "Are the tooth boundaries clearly defined?",
        "Would you use this result in clinical practice?"
    ],
    defectml: [
        "Are the defects correctly identified?",
        "Is the defect classification accurate?",
        "Are there any missed defects?"
    ],
    keypointml: [
        "Are the keypoints correctly positioned?",
        "Are all expected keypoints detected?",
        "Is the keypoint classification accurate?"
    ],
    arrangement: [
        "Is the teeth arrangement clinically acceptable?",
        "Are the occlusal contacts properly established?",
        "Would you approve this arrangement plan?"
    ],
    teethseparation: [
        "Is the tooth separation accurate?",
        "Are the individual teeth properly reconstructed?",
        "Is the gingival line preservation adequate?"
    ]
};
const $3229c9fdc637713a$export$37c4015f15ed5032 = {
    teethml: "Teeth Segmentation",
    defectml: "Defect Detection",
    keypointml: "Keypoint Detection",
    arrangement: "Teeth Arrangement",
    teethseparation: "Teeth Reconstruction"
};
async function $3229c9fdc637713a$export$d1abe408b3392df1(files) {
    const feedbackGroups = $3229c9fdc637713a$var$groupFilesByFeedbackId(files);
    const parsedFeedback = [];
    for (const [id, fileGroup] of feedbackGroups)try {
        const feedbackItem = await $3229c9fdc637713a$var$parseFeedbackItem(id, fileGroup);
        parsedFeedback.push(feedbackItem);
    } catch (error) {
        console.warn(`Failed to parse feedback ${id}:`, error);
        // Add a basic item with error info
        parsedFeedback.push({
            id: id,
            error: error.message,
            files: fileGroup,
            processingMode: "unknown",
            date: null,
            valid: false
        });
    }
    return parsedFeedback.sort($3229c9fdc637713a$var$compareFeedbackItems);
}
/**
 * Group files by their feedback ID (parent folder name)
 * @param {File[]} files - Array of files
 * @returns {Map<string, File[]>} Map of feedback ID to files
 */ function $3229c9fdc637713a$var$groupFilesByFeedbackId(files) {
    const groups = new Map();
    for (const file of files){
        const pathParts = file.webkitRelativePath.split("/");
        if (pathParts.length < 2) continue;
        // Extract feedback ID from the path structure
        // Handle multiple path patterns:
        // 1. feedback/ml-feedback/[feedbackId]/files... (when selecting parent feedback dir)
        // 2. [feedbackId]/files... (when selecting ml-feedback dir directly)
        // 3. ml-feedback/[feedbackId]/files... (when selecting feedback dir with ml-feedback)
        let feedbackId = null;
        if (pathParts.length >= 3 && pathParts[0] === "feedback" && pathParts[1] === "ml-feedback") feedbackId = pathParts[2]; // feedback/ml-feedback/[id]/...
        else if (pathParts.length >= 2 && pathParts[0] === "ml-feedback") feedbackId = pathParts[1]; // ml-feedback/[id]/...
        else if (pathParts.length >= 1) // When selecting ml-feedback directory directly, the first part is the feedback ID
        feedbackId = pathParts[0]; // [id]/...
        if (!feedbackId || feedbackId === "ml-feedback") continue; // Skip if no ID or if it's the ml-feedback folder itself
        if (!groups.has(feedbackId)) groups.set(feedbackId, []);
        groups.get(feedbackId).push(file);
    }
    console.log(`\u{1F4CB} Grouped files into ${groups.size} feedback items:`, Array.from(groups.keys()));
    return groups;
}
/**
 * Parse an individual feedback item from its files
 * @param {string} id - Feedback ID
 * @param {File[]} files - Files associated with this feedback
 * @returns {Promise<Object>} Parsed feedback item
 */ async function $3229c9fdc637713a$var$parseFeedbackItem(id, files) {
    const feedbackItem = {
        id: id,
        files: files,
        valid: true,
        error: null,
        // Basic info
        processingMode: null,
        doctorName: null,
        rating: null,
        date: null,
        // Files
        meshFiles: [],
        resultFiles: [],
        formDataFile: null,
        // Parsed data
        formData: null,
        predictionData: null,
        responses: {},
        comments: null,
        systemInfo: {},
        postprocessing: null
    };
    // Categorize files
    $3229c9fdc637713a$var$categorizeFeedbackFiles(files, feedbackItem);
    // Parse form data if available
    if (feedbackItem.formDataFile) await $3229c9fdc637713a$var$parseFormData(feedbackItem);
    // Parse prediction results if available
    await $3229c9fdc637713a$var$parsePredictionResults(feedbackItem);
    // Validate the feedback item
    $3229c9fdc637713a$var$validateFeedbackItem(feedbackItem);
    return feedbackItem;
}
/**
 * Categorize feedback files by their type and purpose
 * @param {File[]} files - Files to categorize
 * @param {Object} feedbackItem - Feedback item to populate
 */ function $3229c9fdc637713a$var$categorizeFeedbackFiles(files, feedbackItem) {
    console.log(`\u{1F50D} Categorizing ${files.length} files for feedback ${feedbackItem.id}:`);
    for (const file of files){
        const fileName = file.name.toLowerCase();
        const fileExt = fileName.split(".").pop();
        console.log(`  \u{1F4C4} File: ${file.name} (${fileName})`);
        if (fileName === "feedback.json" || fileName === "form_data.json" || fileName === "feedback_complete.json") {
            feedbackItem.formDataFile = file;
            console.log(`    \u{2705} Set as form data file`);
        } else if (fileExt === "obj" || fileExt === "stl") {
            feedbackItem.meshFiles.push(file);
            console.log(`    \u{2705} Added to mesh files`);
        } else if (fileExt === "json" && (fileName.includes("result") || fileName.includes("prediction"))) {
            feedbackItem.resultFiles.push(file);
            console.log(`    \u{2705} Added to result files`);
        } else console.log(`    \u{274C} Not categorized`);
    }
    console.log(`\u{1F4CB} Categorization result for ${feedbackItem.id}:`, {
        formDataFile: feedbackItem.formDataFile?.name || "None",
        meshFiles: feedbackItem.meshFiles.length,
        resultFiles: feedbackItem.resultFiles.length
    });
}
/**
 * Parse form data from the feedback JSON file
 * @param {Object} feedbackItem - Feedback item to populate
 */ async function $3229c9fdc637713a$var$parseFormData(feedbackItem) {
    try {
        console.log(`\u{1F4C4} Parsing form data for ${feedbackItem.id}:`, feedbackItem.formDataFile?.name);
        if (!feedbackItem.formDataFile) throw new Error("No form data file available");
        const text = await $3229c9fdc637713a$var$readFileAsText(feedbackItem.formDataFile);
        console.log(`\u{1F4D6} Read ${text.length} characters from form data file`);
        const data = JSON.parse(text);
        console.log(`\u{2705} Successfully parsed JSON data:`, Object.keys(data));
        feedbackItem.formData = data;
        // Handle different feedback file formats
        let formData, feedbackData;
        if (data.feedback_data && data.feedback_data.formData) {
            // feedback_complete.json format
            feedbackData = data.feedback_data;
            formData = feedbackData.formData;
            feedbackItem.processingMode = formData.processingMode || feedbackData.processingMode;
            feedbackItem.doctorName = formData.doctorName || formData.doctor_name;
            feedbackItem.rating = formData.rating;
            feedbackItem.comments = formData.additionalComments || formData.comments;
            // Handle dynamic questions from feedback_complete.json
            if (formData.dynamicQuestions) feedbackItem.responses = formData.dynamicQuestions;
            // Extract date from multiple possible locations
            if (data.submission_time) feedbackItem.date = new Date(data.submission_time);
            else if (feedbackData.timestamp) feedbackItem.date = new Date(feedbackData.timestamp);
            else if (feedbackData.submissionTime) feedbackItem.date = new Date(feedbackData.submissionTime);
            // Extract postprocessing parameters for arrangement mode
            if (feedbackItem.processingMode === "arrangement") {
                if (feedbackData.files?.postprocessing) feedbackItem.postprocessing = feedbackData.files.postprocessing;
                else if (feedbackData.postprocessing) feedbackItem.postprocessing = feedbackData.postprocessing;
            }
        } else {
            // Legacy feedback.json or form_data.json format
            feedbackItem.processingMode = data.processing_mode || data.processingMode;
            feedbackItem.doctorName = data.doctor_name || data.doctorName;
            feedbackItem.rating = data.rating;
            feedbackItem.comments = data.comments;
            feedbackItem.systemInfo = data.system_info || data.systemInfo || {};
            // Parse responses
            if (data.responses || data.question_responses) {
                const responses = data.responses || data.question_responses;
                if (typeof responses === "object") feedbackItem.responses = responses;
                else if (typeof responses === "string") try {
                    feedbackItem.responses = JSON.parse(responses);
                } catch (e) {
                    console.warn("Failed to parse responses:", e);
                    feedbackItem.responses = {};
                }
            }
            // Extract date
            if (data.timestamp) feedbackItem.date = new Date(data.timestamp);
            else if (data.date) feedbackItem.date = new Date(data.date);
            // Extract postprocessing parameters for arrangement mode (legacy format)
            if (feedbackItem.processingMode === "arrangement") {
                if (data.files?.postprocessing) feedbackItem.postprocessing = data.files.postprocessing;
                else if (data.postprocessing) feedbackItem.postprocessing = data.postprocessing;
            }
        }
        console.log(`Parsed feedback for ${feedbackItem.id}:`, {
            processingMode: feedbackItem.processingMode,
            doctorName: feedbackItem.doctorName,
            rating: feedbackItem.rating,
            date: feedbackItem.date
        });
    } catch (error) {
        console.warn(`Failed to parse form data for ${feedbackItem.id}:`, error);
        feedbackItem.error = `Form data parsing error: ${error.message}`;
    }
}
/**
 * Parse prediction results from result JSON files
 * @param {Object} feedbackItem - Feedback item to populate
 */ async function $3229c9fdc637713a$var$parsePredictionResults(feedbackItem) {
    for (const resultFile of feedbackItem.resultFiles)try {
        const text = await $3229c9fdc637713a$var$readFileAsText(resultFile);
        const data = JSON.parse(text);
        // Store the first valid result file as the main prediction data
        if (!feedbackItem.predictionData) feedbackItem.predictionData = data;
    } catch (error) {
        console.warn(`Failed to parse result file ${resultFile.name}:`, error);
    }
}
/**
 * Validate a feedback item for completeness and correctness
 * @param {Object} feedbackItem - Feedback item to validate
 */ function $3229c9fdc637713a$var$validateFeedbackItem(feedbackItem) {
    const issues = [];
    // Check for essential components
    if (!feedbackItem.formData) issues.push("No form data found");
    // Check for mesh files with fallback logic
    if (feedbackItem.meshFiles.length === 0) {
        // Try to find mesh files from different sources
        let foundMeshFiles = false;
        // Check if we can infer mesh files from file names or other sources
        if (feedbackItem.files && feedbackItem.files.length > 0) {
            const potentialMeshFiles = feedbackItem.files.filter((file)=>file.name.toLowerCase().endsWith(".obj") || file.name.toLowerCase().endsWith(".stl"));
            if (potentialMeshFiles.length > 0) {
                console.log(`\u{1F504} Found ${potentialMeshFiles.length} potential mesh files during validation`);
                feedbackItem.meshFiles = potentialMeshFiles;
                foundMeshFiles = true;
            }
        }
        if (!foundMeshFiles) // This is now a warning rather than an error for some feedback types
        console.warn(`\u{26A0}\u{FE0F} No mesh files found for feedback ${feedbackItem.id}`);
    }
    // Check processing mode with fallback logic
    if (!feedbackItem.processingMode) {
        // Try to infer processing mode from available data
        let inferredMode = null;
        // Check if we have arrangement-like data
        if (feedbackItem.predictionData?.arrangement_result) inferredMode = "arrangement";
        else if (feedbackItem.meshFiles.some((file)=>file.name.toLowerCase().includes("upper") || file.name.toLowerCase().includes("lower") || file.name.toLowerCase().includes("mandibular") || file.name.toLowerCase().includes("maxillary"))) inferredMode = "arrangement";
        else if (feedbackItem.meshFiles.length > 0) inferredMode = "segmentation"; // Default mode
        if (inferredMode) {
            console.log(`\u{1F50D} Inferred processing mode '${inferredMode}' for feedback ${feedbackItem.id}`);
            feedbackItem.processingMode = inferredMode;
        } else issues.push("Processing mode not specified");
    }
    if (!feedbackItem.date) {
        // Use file modification date as fallback
        const fileDates = feedbackItem.files.map((f)=>f.lastModified).filter((d)=>d);
        if (fileDates.length > 0) feedbackItem.date = new Date(Math.min(...fileDates));
        else issues.push("No date information available");
    }
    // Set validity - be more lenient with validation
    // Only mark as invalid if critical issues exist
    const criticalIssues = issues.filter((issue)=>issue.includes("No form data found") || issue.includes("Processing mode not specified"));
    feedbackItem.valid = criticalIssues.length === 0;
    if (issues.length > 0) {
        feedbackItem.error = issues.join("; ");
        if (feedbackItem.valid) console.warn(`\u{26A0}\u{FE0F} Feedback ${feedbackItem.id} has warnings: ${feedbackItem.error}`);
    }
}
/**
 * Compare two feedback items for sorting
 * @param {Object} a - First feedback item
 * @param {Object} b - Second feedback item
 * @returns {number} Comparison result
 */ function $3229c9fdc637713a$var$compareFeedbackItems(a, b) {
    // Sort valid items before invalid ones
    if (a.valid !== b.valid) return a.valid ? -1 : 1;
    // Sort by date (newest first)
    if (a.date && b.date) return b.date - a.date;
    // Sort by ID as fallback
    return a.id.localeCompare(b.id);
}
/**
 * Read a file as text
 * @param {File} file - File to read
 * @returns {Promise<string>} File contents as text
 */ function $3229c9fdc637713a$var$readFileAsText(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = ()=>reject(reader.error);
        reader.readAsText(file);
    });
}
function $3229c9fdc637713a$export$e3c93597035f1506(mode) {
    return $3229c9fdc637713a$export$37c4015f15ed5032[mode] || mode || "Unknown";
}
function $3229c9fdc637713a$export$746aa48e3c4efd24(mode) {
    return $3229c9fdc637713a$export$4a1af812267f0131[mode] || [];
}
function $3229c9fdc637713a$export$826b115f41be2836(feedbackData) {
    const stats = {
        total: feedbackData.length,
        valid: 0,
        invalid: 0,
        processingModes: {},
        averageRating: 0,
        dateRange: {
            earliest: null,
            latest: null
        }
    };
    let ratingSum = 0;
    let ratingCount = 0;
    for (const item of feedbackData){
        if (item.valid) stats.valid++;
        else stats.invalid++;
        // Count processing modes
        const mode = item.processingMode || "unknown";
        stats.processingModes[mode] = (stats.processingModes[mode] || 0) + 1;
        // Calculate average rating
        if (item.rating && typeof item.rating === "number") {
            ratingSum += item.rating;
            ratingCount++;
        }
        // Track date range
        if (item.date) {
            if (!stats.dateRange.earliest || item.date < stats.dateRange.earliest) stats.dateRange.earliest = item.date;
            if (!stats.dateRange.latest || item.date > stats.dateRange.latest) stats.dateRange.latest = item.date;
        }
    }
    stats.averageRating = ratingCount > 0 ? ratingSum / ratingCount : 0;
    return stats;
}



/**
 * Leveling Refinement Settings Module
 *
 * UI model:
 *   - Overbite is the master slider for the upper-arch defaults.
 *   - Each anterior tooth has a target "Incisal Edge Position (mm from
 *     occlusal plane, positive = into the bite)." Defaults are computed
 *     on the fly from Overbite + smile-arc table; manual overrides
 *     replace the default for individual teeth without affecting
 *     Overbite.
 *   - With "Break L/R symmetry" off (default), only three editable
 *     rows are shown per jaw (Central / Lateral / Canine); the value is
 *     applied to the mirrored FDI when sending to the backend.
 */ 

// Order of the Break Symmetry override rows: laid out across the arch
// (canine -> central -> midline -> central -> canine) so the table reads left
// to right like the dentition. Upper: 13,12,11,21,22,23; Lower: 33,32,31,41,42,43.
const $6ed76de03aae65c4$var$UPPER_FDIS = [
    13,
    12,
    11,
    21,
    22,
    23
];
const $6ed76de03aae65c4$var$LOWER_FDIS = [
    33,
    32,
    31,
    41,
    42,
    43
];
// Right-side FDIs used as the "primary" when symmetry is on.
const $6ed76de03aae65c4$var$UPPER_SYMMETRIC_PRIMARY = [
    11,
    12,
    13
];
const $6ed76de03aae65c4$var$LOWER_SYMMETRIC_PRIMARY = [
    31,
    32,
    33
];
// Mirror pairs: right -> left and vice versa.
const $6ed76de03aae65c4$var$MIRROR_PAIRS = {
    11: 21,
    21: 11,
    12: 22,
    22: 12,
    13: 23,
    23: 13,
    31: 41,
    41: 31,
    32: 42,
    42: 32,
    33: 43,
    43: 33
};
const $6ed76de03aae65c4$var$TOOTH_LABEL = {
    11: "11 Central",
    21: "21 Central",
    12: "12 Lateral",
    22: "22 Lateral",
    13: "13 Canine",
    23: "23 Canine",
    31: "31 Central",
    41: "41 Central",
    32: "32 Lateral",
    42: "42 Lateral",
    33: "33 Canine",
    43: "43 Canine",
    // Symmetric (single-row) labels:
    "sym-central-upper": "Central\n(11/21)",
    "sym-lateral-upper": "Lateral\n(12/22)",
    "sym-canine-upper": "Canine\n(13/23)",
    "sym-central-lower": "Central\n(31/41)",
    "sym-lateral-lower": "Lateral\n(32/42)",
    "sym-canine-lower": "Canine\n(33/43)"
};
let $6ed76de03aae65c4$var$MAX_SHIFT_MM = 10.0;
// Smile-arc offsets (overbite-independent, used to compute upper defaults).
// Loaded from /api/postprocessing-defaults on init.
let $6ed76de03aae65c4$var$UPPER_SMILE_ARC = {
    11: 0.0,
    12: -0.299,
    13: 0.448,
    21: 0.0,
    22: -0.299,
    23: 0.448
};
let $6ed76de03aae65c4$var$LOWER_SMILE_ARC = {
    31: 0.6,
    32: 0.606,
    33: 1.414,
    41: 0.6,
    42: 0.606,
    43: 1.414
};
let $6ed76de03aae65c4$var$DEFAULT_OVERBITE_MM = 1.6;
// When False, the anterior-leveling activation checkbox is hidden and leveling
// is forced always-on (production). Controlled by the server setting
// ENABLE_LEVELING_ACTIVATION_TOGGLE via applyLevelingActivationToggle().
let $6ed76de03aae65c4$var$levelingActivationToggleEnabled = true;
function $6ed76de03aae65c4$export$782ea94c0c6863be(enabled) {
    $6ed76de03aae65c4$var$levelingActivationToggleEnabled = enabled !== false;
    const enableCheckbox = document.getElementById("enable-leveling-checkbox");
    const controlsContainer = document.getElementById("leveling-controls");
    if ($6ed76de03aae65c4$var$levelingActivationToggleEnabled) {
        if (enableCheckbox) enableCheckbox.style.display = "";
        return;
    }
    if (enableCheckbox) {
        enableCheckbox.style.display = "none";
        enableCheckbox.checked = true;
    }
    if (controlsContainer) {
        controlsContainer.style.display = "flex";
        controlsContainer.classList.remove("disabled");
        controlsContainer.querySelectorAll("input, select, button").forEach((input)=>{
            input.disabled = false;
        });
    }
}
// FDI used as the lower vertical reference for the overbite anchor. 31 and
// 41 share the same smile-arc value by construction.
const $6ed76de03aae65c4$var$LOWER_CENTRAL_REF_FDI = 31;
// Upper incisors (responsive to Overbite slider).
const $6ed76de03aae65c4$var$UPPER_INCISOR_FDIS = new Set([
    11,
    12,
    21,
    22
]);
function $6ed76de03aae65c4$var$upperDefaultFor(fdi, overbiteMm) {
    // Upper incisors anchor scales with the Overbite slider.
    // Upper canines (13, 23) are clinically decoupled from Overbite -- their
    // anchor is pinned to the DEFAULT_OVERBITE_MM value so their default
    // position does not change when the slider moves.
    const lowerCentralRef = $6ed76de03aae65c4$var$LOWER_SMILE_ARC[$6ed76de03aae65c4$var$LOWER_CENTRAL_REF_FDI] ?? 0;
    const anchor = $6ed76de03aae65c4$var$UPPER_INCISOR_FDIS.has(fdi) ? overbiteMm - lowerCentralRef : $6ed76de03aae65c4$var$DEFAULT_OVERBITE_MM - lowerCentralRef;
    return anchor + ($6ed76de03aae65c4$var$UPPER_SMILE_ARC[fdi] ?? 0);
}
function $6ed76de03aae65c4$var$lowerDefaultFor(fdi) {
    return $6ed76de03aae65c4$var$LOWER_SMILE_ARC[fdi] ?? 0;
}
function $6ed76de03aae65c4$var$currentOverbite() {
    const slider = document.getElementById("overbite-mm-slider");
    return slider ? parseFloat(slider.value) : $6ed76de03aae65c4$var$DEFAULT_OVERBITE_MM;
}
function $6ed76de03aae65c4$var$isSymmetryBroken() {
    const cb = document.getElementById("leveling-break-symmetry-checkbox");
    return !!(cb && cb.checked);
}
async function $6ed76de03aae65c4$var$loadDefaultSettingsFromServer() {
    try {
        const response = await fetch("/api/postprocessing-defaults");
        if (!response.ok) return false;
        const serverDefaults = await response.json();
        const lev = serverDefaults?.leveling;
        if (!lev) return false;
        $6ed76de03aae65c4$var$DEFAULT_OVERBITE_MM = Number.isFinite(lev.overbite_mm) ? lev.overbite_mm : 1.6;
        if (lev.upper_smile_arc && typeof lev.upper_smile_arc === "object") {
            $6ed76de03aae65c4$var$UPPER_SMILE_ARC = {};
            for (const [fdi, mm] of Object.entries(lev.upper_smile_arc))$6ed76de03aae65c4$var$UPPER_SMILE_ARC[parseInt(fdi, 10)] = Number(mm);
        }
        if (lev.lower_smile_arc && typeof lev.lower_smile_arc === "object") {
            $6ed76de03aae65c4$var$LOWER_SMILE_ARC = {};
            for (const [fdi, mm] of Object.entries(lev.lower_smile_arc))$6ed76de03aae65c4$var$LOWER_SMILE_ARC[parseInt(fdi, 10)] = Number(mm);
        }
        if (Number.isFinite(lev.max_target_shift_mm)) $6ed76de03aae65c4$var$MAX_SHIFT_MM = lev.max_target_shift_mm;
        return true;
    } catch (error) {
        console.warn("Error loading leveling defaults from server:", error, "Using hardcoded fallbacks");
        return false;
    }
}
function $6ed76de03aae65c4$var$buildShiftRow(tbody, fdi, labelText) {
    const tr = document.createElement("tr");
    const tdFdi = document.createElement("td");
    // pre-line keeps explicit "\n" in the label (e.g. "Canine\n(13/23)") as a
    // line break so all rows wrap consistently regardless of column width.
    tdFdi.style.whiteSpace = "pre-line";
    tdFdi.textContent = labelText;
    const tdInput = document.createElement("td");
    const input = document.createElement("input");
    input.type = "number";
    input.step = "0.01";
    input.dataset.fdi = String(fdi);
    tdInput.appendChild(input);
    tr.appendChild(tdFdi);
    tr.appendChild(tdInput);
    tbody.appendChild(tr);
}
function $6ed76de03aae65c4$var$rebuildShiftRows() {
    const upperTbody = document.getElementById("upper-relative-shifts-tbody");
    const lowerTbody = document.getElementById("lower-shifts-tbody");
    if (!upperTbody || !lowerTbody) return;
    const broken = $6ed76de03aae65c4$var$isSymmetryBroken();
    upperTbody.innerHTML = "";
    lowerTbody.innerHTML = "";
    if (broken) {
        for (const fdi of $6ed76de03aae65c4$var$UPPER_FDIS)$6ed76de03aae65c4$var$buildShiftRow(upperTbody, fdi, $6ed76de03aae65c4$var$TOOTH_LABEL[fdi]);
        for (const fdi of $6ed76de03aae65c4$var$LOWER_FDIS)$6ed76de03aae65c4$var$buildShiftRow(lowerTbody, fdi, $6ed76de03aae65c4$var$TOOTH_LABEL[fdi]);
    } else {
        // Use the right-side FDI as the carrier; mirror at submit time.
        // Ordered canine -> lateral -> central to match the across-arch layout
        // of the Break Symmetry rows.
        $6ed76de03aae65c4$var$buildShiftRow(upperTbody, 13, $6ed76de03aae65c4$var$TOOTH_LABEL["sym-canine-upper"]);
        $6ed76de03aae65c4$var$buildShiftRow(upperTbody, 12, $6ed76de03aae65c4$var$TOOTH_LABEL["sym-lateral-upper"]);
        $6ed76de03aae65c4$var$buildShiftRow(upperTbody, 11, $6ed76de03aae65c4$var$TOOTH_LABEL["sym-central-upper"]);
        $6ed76de03aae65c4$var$buildShiftRow(lowerTbody, 33, $6ed76de03aae65c4$var$TOOTH_LABEL["sym-canine-lower"]);
        $6ed76de03aae65c4$var$buildShiftRow(lowerTbody, 32, $6ed76de03aae65c4$var$TOOTH_LABEL["sym-lateral-lower"]);
        $6ed76de03aae65c4$var$buildShiftRow(lowerTbody, 31, $6ed76de03aae65c4$var$TOOTH_LABEL["sym-central-lower"]);
    }
    $6ed76de03aae65c4$var$refreshPlaceholders();
    $6ed76de03aae65c4$var$attachShiftInputListeners();
}
function $6ed76de03aae65c4$var$refreshPlaceholders() {
    const overbite = $6ed76de03aae65c4$var$currentOverbite();
    document.querySelectorAll("#upper-relative-shifts-tbody input[type='number']").forEach((input)=>{
        const fdi = parseInt(input.dataset.fdi, 10);
        const def = $6ed76de03aae65c4$var$upperDefaultFor(fdi, overbite);
        input.placeholder = `${def.toFixed(2)} (auto)`;
    });
    document.querySelectorAll("#lower-shifts-tbody input[type='number']").forEach((input)=>{
        const fdi = parseInt(input.dataset.fdi, 10);
        const def = $6ed76de03aae65c4$var$lowerDefaultFor(fdi);
        input.placeholder = `${def.toFixed(2)} (auto)`;
    });
}
function $6ed76de03aae65c4$var$clampShiftInput(input) {
    const raw = input.value.trim();
    if (raw === "") return;
    const value = parseFloat(raw);
    if (!Number.isFinite(value)) {
        input.value = "";
        return;
    }
    if (Math.abs(value) > $6ed76de03aae65c4$var$MAX_SHIFT_MM) {
        const clamped = Math.max(-$6ed76de03aae65c4$var$MAX_SHIFT_MM, Math.min($6ed76de03aae65c4$var$MAX_SHIFT_MM, value));
        input.value = clamped.toFixed(2);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Position ${value.toFixed(2)}mm exceeds +-${$6ed76de03aae65c4$var$MAX_SHIFT_MM}mm cap; clamped to ${clamped.toFixed(2)}mm`, "exclamation-triangle");
    }
}
function $6ed76de03aae65c4$var$attachShiftInputListeners() {
    document.querySelectorAll("#upper-relative-shifts-tbody input[type='number'], #lower-shifts-tbody input[type='number']").forEach((input)=>{
        input.addEventListener("change", ()=>{
            $6ed76de03aae65c4$var$clampShiftInput(input);
            $6ed76de03aae65c4$export$c9a7c46235fca259();
        });
    });
}
async function $6ed76de03aae65c4$export$3ed9847792e393b7() {
    const enableCheckbox = document.getElementById("enable-leveling-checkbox");
    const controlsContainer = document.getElementById("leveling-controls");
    if (!enableCheckbox || !controlsContainer) return;
    await $6ed76de03aae65c4$var$loadDefaultSettingsFromServer();
    const overbiteSlider = document.getElementById("overbite-mm-slider");
    const overbiteValue = document.getElementById("overbite-mm-value");
    if (overbiteSlider && overbiteValue) {
        overbiteSlider.value = String($6ed76de03aae65c4$var$DEFAULT_OVERBITE_MM);
        overbiteValue.textContent = $6ed76de03aae65c4$var$DEFAULT_OVERBITE_MM.toFixed(2);
        overbiteSlider.addEventListener("input", (e)=>{
            overbiteValue.textContent = parseFloat(e.target.value).toFixed(2);
            $6ed76de03aae65c4$var$refreshPlaceholders();
            $6ed76de03aae65c4$export$c9a7c46235fca259();
        });
    }
    const symmetryCb = document.getElementById("leveling-break-symmetry-checkbox");
    if (symmetryCb) symmetryCb.addEventListener("change", ()=>{
        $6ed76de03aae65c4$var$rebuildShiftRows();
        $6ed76de03aae65c4$export$c9a7c46235fca259();
    });
    $6ed76de03aae65c4$var$rebuildShiftRows();
    enableCheckbox.checked = true;
    $6ed76de03aae65c4$export$ac76344c710e7019();
    function enableLevelingInputs(enabled) {
        const inputs = controlsContainer.querySelectorAll("input, select, button");
        inputs.forEach((input)=>{
            input.disabled = !enabled;
        });
    }
    function toggleLevelingControls() {
        const isEnabled = enableCheckbox.checked;
        if (isEnabled) {
            controlsContainer.style.display = "flex";
            controlsContainer.classList.remove("disabled");
            enableLevelingInputs(true);
        } else {
            controlsContainer.style.display = "none";
            controlsContainer.classList.add("disabled");
            enableLevelingInputs(false);
        }
        $6ed76de03aae65c4$export$c9a7c46235fca259();
    }
    enableCheckbox.addEventListener("change", toggleLevelingControls);
    function toggleShiftsSection(checkboxId, containerId) {
        const cb = document.getElementById(checkboxId);
        const container = document.getElementById(containerId);
        if (!cb || !container) return;
        container.style.display = cb.checked ? "flex" : "none";
        $6ed76de03aae65c4$export$c9a7c46235fca259();
    }
    const upperShiftsCb = document.getElementById("enable-upper-shifts-checkbox");
    const lowerShiftsCb = document.getElementById("enable-lower-shifts-checkbox");
    if (upperShiftsCb) upperShiftsCb.addEventListener("change", ()=>toggleShiftsSection("enable-upper-shifts-checkbox", "upper-shifts-controls"));
    if (lowerShiftsCb) lowerShiftsCb.addEventListener("change", ()=>toggleShiftsSection("enable-lower-shifts-checkbox", "lower-shifts-controls"));
    const resetButton = document.getElementById("reset-leveling-button");
    if (resetButton) resetButton.addEventListener("click", ()=>{
        $6ed76de03aae65c4$export$8b61b302670de024();
    });
    toggleLevelingControls();
}
function $6ed76de03aae65c4$var$readShiftOverrides(tbodyId) {
    // Read inputs from a tbody, expanding mirror-pairs when symmetry is on.
    const out = {};
    const tbody = document.getElementById(tbodyId);
    if (!tbody) return out;
    const broken = $6ed76de03aae65c4$var$isSymmetryBroken();
    tbody.querySelectorAll("input[type='number']").forEach((input)=>{
        const fdi = parseInt(input.dataset.fdi, 10);
        const raw = input.value.trim();
        if (!fdi || raw === "") return;
        const value = parseFloat(raw);
        if (!Number.isFinite(value)) return;
        out[fdi] = value;
        if (!broken) {
            const mirror = $6ed76de03aae65c4$var$MIRROR_PAIRS[fdi];
            if (mirror) out[mirror] = value;
        }
    });
    return out;
}
function $6ed76de03aae65c4$export$542a408f12c51875() {
    const enableCheckbox = document.getElementById("enable-leveling-checkbox");
    // When the activation toggle is hidden (production), leveling is always on
    // regardless of the (hidden) checkbox state.
    const isEnabled = !$6ed76de03aae65c4$var$levelingActivationToggleEnabled || enableCheckbox && enableCheckbox.checked;
    if (!isEnabled) return {
        enabled: false
    };
    const overbiteSlider = document.getElementById("overbite-mm-slider");
    const resolveCollisionsCb = document.getElementById("resolve-collisions-checkbox");
    const params = {
        overbite_mm: parseFloat(overbiteSlider.value),
        resolve_collisions: resolveCollisionsCb ? resolveCollisionsCb.checked : true
    };
    const upperShiftsCb = document.getElementById("enable-upper-shifts-checkbox");
    const lowerShiftsCb = document.getElementById("enable-lower-shifts-checkbox");
    const upperTargets = upperShiftsCb?.checked ? $6ed76de03aae65c4$var$readShiftOverrides("upper-relative-shifts-tbody") : {};
    const lowerTargets = lowerShiftsCb?.checked ? $6ed76de03aae65c4$var$readShiftOverrides("lower-shifts-tbody") : {};
    if (Object.keys(upperTargets).length > 0) params.upper_targets = upperTargets;
    if (Object.keys(lowerTargets).length > 0) params.lower_targets = lowerTargets;
    return {
        enabled: true,
        parameters: params
    };
}
function $6ed76de03aae65c4$var$readShiftRowsAsStrings(tbodyId) {
    const out = {};
    const tbody = document.getElementById(tbodyId);
    if (!tbody) return out;
    tbody.querySelectorAll("input[type='number']").forEach((input)=>{
        const fdi = input.dataset.fdi;
        if (fdi) out[fdi] = input.value;
    });
    return out;
}
function $6ed76de03aae65c4$export$c9a7c46235fca259() {
    try {
        const enableCheckbox = document.getElementById("enable-leveling-checkbox");
        const overbiteSlider = document.getElementById("overbite-mm-slider");
        if (!enableCheckbox || !overbiteSlider) return;
        const resolveCollisionsCb = document.getElementById("resolve-collisions-checkbox");
        const upperShiftsCb = document.getElementById("enable-upper-shifts-checkbox");
        const lowerShiftsCb = document.getElementById("enable-lower-shifts-checkbox");
        const symmetryCb = document.getElementById("leveling-break-symmetry-checkbox");
        const settings = {
            enabled: enableCheckbox.checked,
            overbite_mm: overbiteSlider.value,
            resolve_collisions: resolveCollisionsCb ? resolveCollisionsCb.checked : true,
            break_symmetry: !!(symmetryCb && symmetryCb.checked),
            upper_shifts_expanded: !!(upperShiftsCb && upperShiftsCb.checked),
            lower_shifts_expanded: !!(lowerShiftsCb && lowerShiftsCb.checked),
            upper_targets: $6ed76de03aae65c4$var$readShiftRowsAsStrings("upper-relative-shifts-tbody"),
            lower_targets: $6ed76de03aae65c4$var$readShiftRowsAsStrings("lower-shifts-tbody")
        };
        localStorage.setItem("levelingSettings", JSON.stringify(settings));
    } catch (error) {
        console.error("Error saving leveling settings:", error);
    }
}
function $6ed76de03aae65c4$var$applyShiftValues(tbodyId, values) {
    const tbody = document.getElementById(tbodyId);
    if (!tbody || !values) return;
    tbody.querySelectorAll("input[type='number']").forEach((input)=>{
        const fdi = input.dataset.fdi;
        if (fdi && Object.prototype.hasOwnProperty.call(values, fdi)) input.value = values[fdi];
    });
}
function $6ed76de03aae65c4$export$ac76344c710e7019() {
    try {
        const saved = localStorage.getItem("levelingSettings");
        if (!saved) return;
        const settings = JSON.parse(saved);
        const enableCheckbox = document.getElementById("enable-leveling-checkbox");
        const overbiteSlider = document.getElementById("overbite-mm-slider");
        const overbiteValue = document.getElementById("overbite-mm-value");
        if (enableCheckbox && typeof settings.enabled === "boolean" && $6ed76de03aae65c4$var$levelingActivationToggleEnabled) enableCheckbox.checked = settings.enabled;
        const resolveCollisionsCb = document.getElementById("resolve-collisions-checkbox");
        if (resolveCollisionsCb && typeof settings.resolve_collisions === "boolean") resolveCollisionsCb.checked = settings.resolve_collisions;
        const symmetryCb = document.getElementById("leveling-break-symmetry-checkbox");
        if (symmetryCb && typeof settings.break_symmetry === "boolean") {
            symmetryCb.checked = settings.break_symmetry;
            $6ed76de03aae65c4$var$rebuildShiftRows();
        }
        if (overbiteSlider && settings.overbite_mm != null) {
            overbiteSlider.value = settings.overbite_mm;
            if (overbiteValue) overbiteValue.textContent = parseFloat(settings.overbite_mm).toFixed(2);
            $6ed76de03aae65c4$var$refreshPlaceholders();
        }
        $6ed76de03aae65c4$var$applyShiftValues("upper-relative-shifts-tbody", settings.upper_targets);
        $6ed76de03aae65c4$var$applyShiftValues("lower-shifts-tbody", settings.lower_targets);
        const upperShiftsCb = document.getElementById("enable-upper-shifts-checkbox");
        const lowerShiftsCb = document.getElementById("enable-lower-shifts-checkbox");
        const upperShiftsContainer = document.getElementById("upper-shifts-controls");
        const lowerShiftsContainer = document.getElementById("lower-shifts-controls");
        if (upperShiftsCb && typeof settings.upper_shifts_expanded === "boolean") {
            upperShiftsCb.checked = settings.upper_shifts_expanded;
            if (upperShiftsContainer) upperShiftsContainer.style.display = settings.upper_shifts_expanded ? "flex" : "none";
        }
        if (lowerShiftsCb && typeof settings.lower_shifts_expanded === "boolean") {
            lowerShiftsCb.checked = settings.lower_shifts_expanded;
            if (lowerShiftsContainer) lowerShiftsContainer.style.display = settings.lower_shifts_expanded ? "flex" : "none";
        }
    } catch (error) {
        console.error("Error loading leveling settings:", error);
    }
}
function $6ed76de03aae65c4$export$45d0357138cffec3() {
// Visibility is governed by the parent postprocessing section.
}
function $6ed76de03aae65c4$export$8b61b302670de024() {
    try {
        localStorage.removeItem("levelingSettings");
        const enableCheckbox = document.getElementById("enable-leveling-checkbox");
        const overbiteSlider = document.getElementById("overbite-mm-slider");
        const overbiteValue = document.getElementById("overbite-mm-value");
        if (enableCheckbox) enableCheckbox.checked = true;
        const resolveCollisionsCb = document.getElementById("resolve-collisions-checkbox");
        if (resolveCollisionsCb) resolveCollisionsCb.checked = false;
        if (overbiteSlider) {
            overbiteSlider.value = String($6ed76de03aae65c4$var$DEFAULT_OVERBITE_MM);
            if (overbiteValue) overbiteValue.textContent = $6ed76de03aae65c4$var$DEFAULT_OVERBITE_MM.toFixed(2);
        }
        const symmetryCb = document.getElementById("leveling-break-symmetry-checkbox");
        if (symmetryCb) symmetryCb.checked = false;
        $6ed76de03aae65c4$var$rebuildShiftRows();
        document.querySelectorAll("#upper-relative-shifts-tbody input[type='number'], #lower-shifts-tbody input[type='number']").forEach((input)=>{
            input.value = "";
        });
        const upperShiftsCb = document.getElementById("enable-upper-shifts-checkbox");
        const lowerShiftsCb = document.getElementById("enable-lower-shifts-checkbox");
        const upperShiftsContainer = document.getElementById("upper-shifts-controls");
        const lowerShiftsContainer = document.getElementById("lower-shifts-controls");
        if (upperShiftsCb) {
            upperShiftsCb.checked = false;
            if (upperShiftsContainer) upperShiftsContainer.style.display = "none";
        }
        if (lowerShiftsCb) {
            lowerShiftsCb.checked = false;
            if (lowerShiftsContainer) lowerShiftsContainer.style.display = "none";
        }
        const controlsContainer = document.getElementById("leveling-controls");
        if (controlsContainer) {
            controlsContainer.style.display = "flex";
            controlsContainer.classList.remove("disabled");
            const inputs = controlsContainer.querySelectorAll("input, select, button");
            inputs.forEach((input)=>{
                input.disabled = false;
            });
        }
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Leveling settings reset to defaults", "check-circle");
    } catch (error) {
        console.error("Error resetting leveling settings:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error resetting leveling settings", "exclamation-triangle");
    }
}
function $6ed76de03aae65c4$export$c160e09b4f5ff496(value) {
    const span = document.getElementById("achieved-overbite-value");
    if (!span) return;
    if (value == null || !Number.isFinite(value)) span.textContent = "--";
    else span.textContent = `${Number(value).toFixed(2)} mm`;
}


// Global authentication state
let $a78b7212404532f0$var$isAuthenticationEnabled = true; // Default to true for safety
// Camera utilities
const $a78b7212404532f0$var$CAMERA_CONFIG = {
    FRUSTUM_SIZE: 100,
    NEAR: 0.1,
    FAR: 1000
};
// LocalStorage keys
const $a78b7212404532f0$var$STORAGE_KEY_GINGIVA_ESTIMATION = "arrangement-gingiva-estimation";
const $a78b7212404532f0$var$STORAGE_KEY_CALCULATE_SPACE_INTERSECTION = "arrangement-calculate-space-intersection";
const $a78b7212404532f0$var$STORAGE_KEY_AUTO_ORIENTATION = "segmentation-auto-orientation";
/**
 * Create an orthographic camera with the given aspect ratio
 * @param {number} aspect - Width/height aspect ratio
 * @param {number} frustumSize - Size of the viewing frustum (default: 100)
 * @returns {THREE.OrthographicCamera}
 */ function $a78b7212404532f0$var$createOrthographicCamera(aspect, frustumSize = $a78b7212404532f0$var$CAMERA_CONFIG.FRUSTUM_SIZE) {
    return new $0d79572b4b22d35c$export$9ebf355ee4ed261b(-frustumSize * aspect / 2, frustumSize * aspect / 2, frustumSize / 2, -frustumSize / 2, $a78b7212404532f0$var$CAMERA_CONFIG.NEAR, $a78b7212404532f0$var$CAMERA_CONFIG.FAR);
}
/**
 * Update orthographic camera frustum for new aspect ratio
 * @param {THREE.OrthographicCamera} camera - The camera to update
 * @param {number} aspect - New width/height aspect ratio
 * @param {number} frustumSize - Size of the viewing frustum (default: 100)
 */ function $a78b7212404532f0$var$updateOrthographicCamera(camera, aspect, frustumSize = $a78b7212404532f0$var$CAMERA_CONFIG.FRUSTUM_SIZE) {
    camera.left = -frustumSize * aspect / 2;
    camera.right = frustumSize * aspect / 2;
    camera.top = frustumSize / 2;
    camera.bottom = -frustumSize / 2;
    camera.updateProjectionMatrix();
}
// Check authentication status first, then validate tokens only if auth is enabled
async function $a78b7212404532f0$var$initializeAuthentication() {
    console.log("\uD83D\uDD10 Initializing authentication...");
    // Check if we're in OAuth callback flow (has ?code= parameter)
    const urlParams = new URLSearchParams(window.location.search);
    const oauthCode = urlParams.get("code");
    console.log("\uD83D\uDD0D URL params check - code param:", oauthCode ? "PRESENT" : "NOT FOUND");
    console.log("\uD83D\uDD0D Full URL:", window.location.href);
    if (oauthCode) {
        console.log("\uD83D\uDD10 OAuth callback detected - SKIPPING all auth checks!");
        console.log("\uD83D\uDD10 Waiting for server to process OAuth code and redirect...");
        // We're in OAuth callback flow - don't validate tokens yet
        // The server will process the code and set the cookie, then redirect
        // Just show a loading state and wait - DO NOT PROCEED WITH AUTH CHECKS
        return Promise.resolve(); // Explicitly return resolved promise
    }
    console.log("\uD83D\uDD10 No OAuth code found - proceeding with normal auth flow");
    try {
        // First check system status to know if authentication is enabled
        // This API call doesn't require authentication
        const data = await (0, $913d3a1574de567c$export$ae14c375fc93363).getSystemStatus();
        // Apply UI feature flags before any early returns below.
        $a78b7212404532f0$var$applyProcessingModeGate(data.enable_processing_mode_selector);
        $a78b7212404532f0$var$applyPatientIdMatchGate(data.enforce_patient_id_match);
        $a78b7212404532f0$var$applyPatientIdMatchStrictnessGate(data.strict_patient_id_match);
        $a78b7212404532f0$var$applyRequiredFilesGate(data.require_all_arrangement_files);
        $a78b7212404532f0$var$applyInterproximalAdvancedParamsGate(data.enable_interproximal_advanced_params);
        (0, $6ed76de03aae65c4$export$782ea94c0c6863be)(data.enable_leveling_activation_toggle);
        $a78b7212404532f0$var$applySpaceIntersectionToggleGate(data.enable_space_intersection_toggle);
        (0, $ddb3f022a87c2bc1$export$b80f21d54e0e670a)(data.enable_molar_movement_toggle);
        $a78b7212404532f0$var$applyInfoJsonReviewGate(data.enable_infojson_review_gate);
        $a78b7212404532f0$var$applyAutoOrientationGate(data.auto_orientation);
        // Store authentication status globally
        $a78b7212404532f0$var$isAuthenticationEnabled = data.authentication_enabled;
        // Also update the API service with authentication status
        (0, $913d3a1574de567c$export$a71129c14700d3e)(data.authentication_enabled);
        if (!data.authentication_enabled) {
            console.log("\uD83D\uDD13 Authentication is disabled - skipping token validation");
            document.getElementById("authentication").style.display = "none";
            return;
        }
        console.log("\uD83D\uDD10 Authentication is enabled - validating tokens...");
        // Only validate tokens if authentication is enabled
        const isTokenValid = await (0, $913d3a1574de567c$export$ae14c375fc93363).validateTokenOnLoad();
        if (!isTokenValid) // Token validation failed, auto logout already triggered
        return;
        // Check if user is logged in
        if (data.current_user === null) {
            // User is not logged in - perform auto logout
            console.log("Authentication required but user is null - auto logout");
            $a78b7212404532f0$var$performAutoLogout();
        } else console.log("User is authenticated:", data.current_user);
    } catch (error) {
        console.error("Error during authentication initialization:", error);
        // If we can't get system status, assume auth is enabled for safety
        // and check tokens
        console.log("\uD83D\uDD10 System status unavailable - assuming auth enabled, checking tokens...");
        $a78b7212404532f0$var$isAuthenticationEnabled = true;
        // Also update the API service with authentication status
        (0, $913d3a1574de567c$export$a71129c14700d3e)(true);
        $a78b7212404532f0$var$checkTokenAndLogout();
    }
}
/**
 * Hide the Processing Mode selector when the backend disables it (production).
 * UX gate only: the pipeline is locked to "arrangement" client-side. When the
 * flag is missing (older backend) or true, the selector stays visible.
 * @param {boolean|undefined} enabled Backend flag from /api/system-status
 */ // Whether the backend allows the Processing Mode selector. When false the
// selector stays hidden and the pipeline is locked to "arrangement". Stored at
// module scope so application-mode switches (Processing <-> Review) keep
// honoring it instead of re-showing the selector.
let $a78b7212404532f0$var$processingModeSelectorEnabled = true;
function $a78b7212404532f0$var$applyProcessingModeGate(enabled) {
    $a78b7212404532f0$var$processingModeSelectorEnabled = enabled !== false;
    $a78b7212404532f0$var$updateProcessingModeSelectorVisibility();
}
// When True, arrangement submission requires the patient ID (the first
// space-delimited token of each file name) to match across all uploaded
// files. Controlled by the ENFORCE_PATIENT_ID_MATCH server setting. Default
// True so a system-status fetch failure does not silently drop the check.
let $a78b7212404532f0$var$enforcePatientIdMatch = true;
function $a78b7212404532f0$var$applyPatientIdMatchGate(enabled) {
    $a78b7212404532f0$var$enforcePatientIdMatch = enabled !== false;
}
// When True, a patient-ID mismatch blocks submission (production). When
// False, it only shows a dismissible warning and submission proceeds -
// testers need to get past false positives (e.g. lab-storage names that
// don't follow the naming convention). Controlled by the
// STRICT_PATIENT_ID_MATCH server setting. Default True so a system-status
// fetch failure does not silently relax the check.
let $a78b7212404532f0$var$strictPatientIdMatch = true;
function $a78b7212404532f0$var$applyPatientIdMatchStrictnessGate(enabled) {
    $a78b7212404532f0$var$strictPatientIdMatch = enabled !== false;
}
// Apply the strict/warn split to a validatePatientIdConsistency() result.
// Returns an { error } object to propagate (blocks submission) when strict,
// or null after showing a dismissible warning toast (submission proceeds).
function $a78b7212404532f0$var$resolvePatientIdCheckError(idError) {
    if (!idError) return null;
    if ($a78b7212404532f0$var$strictPatientIdMatch) return {
        error: idError
    };
    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(idError, "exclamation-triangle", 6000);
    return null;
}
// When True, all four arrangement inputs (lower jaw, upper jaw, InfoJSON,
// landmarks CSV) are required before submitting. When False, only the jaws are
// required and InfoJSON / landmarks are optional. Controlled by the
// REQUIRE_ALL_ARRANGEMENT_FILES server setting.
let $a78b7212404532f0$var$requireAllArrangementFiles = true;
function $a78b7212404532f0$var$applyRequiredFilesGate(enabled) {
    $a78b7212404532f0$var$requireAllArrangementFiles = enabled !== false;
    $a78b7212404532f0$var$updateOptionalFileLabels();
}
// Show/hide the advanced interproximal parameters (Gap Range + Tightness).
// Controlled by ENABLE_INTERPROXIMAL_ADVANCED_PARAMS. When hidden, the sliders
// stay in the DOM at their defaults, so submitted parameters are unchanged.
function $a78b7212404532f0$var$applyInterproximalAdvancedParamsGate(enabled) {
    const section = document.getElementById("interproximal-advanced-params");
    if (!section) return;
    section.style.display = enabled === false ? "none" : "";
}
// When False, the "Compute Space/Intersection" toggle is hidden and the
// computation is forced on (production). Controlled by the server setting
// ENABLE_SPACE_INTERSECTION_TOGGLE.
let $a78b7212404532f0$var$spaceIntersectionToggleEnabled = true;
// Show/hide the Compute Space/Intersection toggle. When hidden, force the
// checkbox checked so the computation always runs; collectArrangementModelOptions
// also honors the flag so saved state cannot turn it off behind a hidden toggle.
function $a78b7212404532f0$var$applySpaceIntersectionToggleGate(enabled) {
    $a78b7212404532f0$var$spaceIntersectionToggleEnabled = enabled !== false;
    const group = document.getElementById("space-intersection-control-group");
    const checkbox = document.getElementById("calculate-space-intersection-checkbox");
    if (group) group.style.display = $a78b7212404532f0$var$spaceIntersectionToggleEnabled ? "" : "none";
    if (!$a78b7212404532f0$var$spaceIntersectionToggleEnabled && checkbox) checkbox.checked = true;
}
// When False, the deployment has turned segmentation auto orientation off
// entirely (server setting AUTO_ORIENTATION), so the checkbox is hidden and
// forced off. Unlike the toggles above this is not a UX gate: with it off the
// worker will not re-orient anything, and leaving a ticked checkbox on screen
// would promise a rotation that cannot happen.
let $a78b7212404532f0$var$autoOrientationEnabled = true;
// Show/hide the Auto Orientation checkbox. isAutoOrientationEnabled and
// updateModelOptionsSectionVisibility both honor the flag, so saved state cannot
// request auto orientation behind a hidden checkbox.
function $a78b7212404532f0$var$applyAutoOrientationGate(enabled) {
    $a78b7212404532f0$var$autoOrientationEnabled = enabled !== false;
    const section = document.getElementById("segmentation-options-section");
    const checkbox = document.getElementById("enable-auto-orientation-checkbox");
    if (!$a78b7212404532f0$var$autoOrientationEnabled) {
        if (section) section.style.display = "none";
        if (checkbox) checkbox.checked = false;
    }
}
// When True, the arrangement InfoJSON download is gated behind an explicit
// Accept/Reject review (production): Accept logs a compliance acceptance before
// downloading; Reject requires a reason (also logged). When False, a plain
// Download button is shown (legacy dev behavior). Controlled by the server
// setting ENABLE_INFOJSON_REVIEW_GATE.
let $a78b7212404532f0$var$infoJsonReviewGateEnabled = true;
const $a78b7212404532f0$var$INFOJSON_ACTION_BUTTON_IDS = [
    "download-infojson-button",
    "accept-infojson-button",
    "reject-infojson-button"
];
// Select the review gate mode. Re-applies the visible button set if a result is
// already on screen, so a late system-status response cannot leave a stale set.
function $a78b7212404532f0$var$applyInfoJsonReviewGate(enabled) {
    $a78b7212404532f0$var$infoJsonReviewGateEnabled = enabled !== false;
    const anyVisible = $a78b7212404532f0$var$INFOJSON_ACTION_BUTTON_IDS.some((id)=>{
        const el = document.getElementById(id);
        return el && el.style.display && el.style.display !== "none";
    });
    if (anyVisible) $a78b7212404532f0$var$showInfoJsonActions();
}
// Reveal the correct InfoJSON action buttons for the active gate mode: plain
// Download when the gate is off, Accept + Reject when it is on.
function $a78b7212404532f0$var$showInfoJsonActions() {
    const download = document.getElementById("download-infojson-button");
    const accept = document.getElementById("accept-infojson-button");
    const reject = document.getElementById("reject-infojson-button");
    if ($a78b7212404532f0$var$infoJsonReviewGateEnabled) {
        if (download) download.style.display = "none";
        if (accept) accept.style.display = "block";
        if (reject) reject.style.display = "block";
    } else {
        if (download) download.style.display = "block";
        if (accept) accept.style.display = "none";
        if (reject) reject.style.display = "none";
    }
}
// Hide every InfoJSON action button (used on reset / start-over / new run).
function $a78b7212404532f0$var$hideInfoJsonActions() {
    $a78b7212404532f0$var$INFOJSON_ACTION_BUTTON_IDS.forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.style.display = "none";
    });
}
// Accept: record the acceptance to the audit log (blocking on the server), then
// download the InfoJSON. On a logging failure the download is refused so the
// acceptance is never silently skipped.
async function $a78b7212404532f0$var$acceptInfoJson() {
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson) {
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No InfoJSON data available for download", "exclamation-triangle");
        return;
    }
    const itemId = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastProcessedItemId;
    if (!itemId) {
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Cannot record acceptance: missing job id", "exclamation-triangle");
        return;
    }
    try {
        await (0, $913d3a1574de567c$export$ae14c375fc93363).submitReviewDecision(itemId, "accept");
    } catch (error) {
        console.error("Failed to record acceptance:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Failed to record acceptance: ${error.message}`, "exclamation-triangle");
        return;
    }
    $a78b7212404532f0$var$downloadInfoJson();
}
// Reject: record the rejection decision immediately, then open the feedback
// form so the clinician can explain why. A rejection is negative feedback, so
// the reason is captured as feedback (linked to the same audit row via
// feedback_path) rather than a separate prompt.
async function $a78b7212404532f0$var$rejectInfoJson() {
    const itemId = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastProcessedItemId;
    if (!itemId) {
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Cannot record rejection: missing job id", "exclamation-triangle");
        return;
    }
    try {
        await (0, $913d3a1574de567c$export$ae14c375fc93363).submitReviewDecision(itemId, "reject");
        $a78b7212404532f0$var$hideInfoJsonActions();
    } catch (error) {
        console.error("Failed to record rejection:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Failed to record rejection: ${error.message}`, "exclamation-triangle");
    // Fall through: still open the feedback form so the clinician's reason
    // is captured even if the decision flag could not be persisted.
    }
    // Open the feedback form to capture the reason for the rejection.
    (0, $aa8a35ff0d89d373$export$f95c1e417f283156)("arrangement");
}
// Append "(Optional)" to the InfoJSON / landmarks labels when those inputs are
// not required, so the UI hint matches the active requiredness rule. Labels
// carry their base text in the data-optional-label attribute.
function $a78b7212404532f0$var$updateOptionalFileLabels() {
    const labels = document.querySelectorAll("[data-optional-label]");
    labels.forEach((label)=>{
        const base = label.getAttribute("data-optional-label");
        if ($a78b7212404532f0$var$requireAllArrangementFiles) label.textContent = base;
        else label.innerHTML = base + ' <span style="font-style: italic; color: #666;">(Optional)</span>';
    });
}
// Show/hide the Processing Mode selector and reconcile the two dividers around
// it for the current application mode. The selector is shown only in Processing
// mode when enabled. When the selector is hidden in Processing mode, the two
// dividers (one above the selector, one above File Selection) would stack into
// two lines, so we keep the leading divider (right after Application Mode) and
// hide the trailing one. In every other case both dividers stay visible.
function $a78b7212404532f0$var$updateProcessingModeSelectorVisibility() {
    const section = document.getElementById("processing-mode-section");
    if (!section) return;
    const inProcessing = !((0, $66dbd4fb7330af32$export$8e769ad4338a911e) && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode);
    const showSelector = inProcessing && $a78b7212404532f0$var$processingModeSelectorEnabled;
    section.style.display = showSelector ? "" : "none";
    if (!showSelector) {
        const dropdown = document.getElementById("processing-mode-dropdown");
        if (dropdown) dropdown.value = "arrangement";
    }
    // Leading divider (after Application Mode) is always visible.
    const leadingDivider = section.previousElementSibling;
    if (leadingDivider && leadingDivider.classList.contains("section-divider")) leadingDivider.style.display = "";
    // Trailing divider (above File Selection) is hidden only when the selector
    // is hidden in Processing mode, to avoid two stacked lines.
    const fileSelection = document.getElementById("file-selection-section");
    const trailingDivider = fileSelection ? fileSelection.previousElementSibling : null;
    if (trailingDivider && trailingDivider.classList.contains("section-divider")) {
        const hideTrailing = inProcessing && !$a78b7212404532f0$var$processingModeSelectorEnabled;
        trailingDivider.style.display = hideTrailing ? "none" : "";
    }
}
// Initialize authentication when page loads
$a78b7212404532f0$var$initializeAuthentication();
/**
 * Perform auto logout when no valid token is present
 */ function $a78b7212404532f0$var$performAutoLogout() {
    console.log("\uD83D\uDEAA Performing auto logout...");
    // Clear tokens using the unified function
    (0, $913d3a1574de567c$export$c0081454efbc7134)(null);
    // Clear any processing state
    $a78b7212404532f0$var$clearAllFilesAndState();
    // Hide processing elements
    const processingIndicator = document.getElementById("processing-indicator");
    if (processingIndicator) processingIndicator.style.display = "none";
    // Show authentication section
    const authenticationSection = document.getElementById("authentication");
    if (authenticationSection) authenticationSection.style.display = "block";
    // Only redirect to login page if authentication is enabled
    if ($a78b7212404532f0$var$isAuthenticationEnabled) // Show logout notification only when authentication is enabled
    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Session expired - Please log in to continue", "exclamation-triangle");
    else console.log("Authentication disabled - skipping login redirect and session expired message");
    // Reset logout state after a short delay
    setTimeout(()=>{
        (0, $913d3a1574de567c$export$620bbc03f95a612f)();
    }, 2000);
}
// Set up the auto logout callback for the API service
(0, $913d3a1574de567c$export$b113a2854fcb981c)($a78b7212404532f0$var$performAutoLogout);
/**
 * Check if token exists and perform logout if not (only when authentication is enabled)
 */ function $a78b7212404532f0$var$checkTokenAndLogout() {
    // Skip token checking if authentication is disabled
    if (!$a78b7212404532f0$var$isAuthenticationEnabled) {
        console.log("\uD83D\uDD13 Authentication disabled - skipping token check");
        return true;
    }
    const accessToken = (0, $913d3a1574de567c$export$84773cc9bf7dbe87)();
    if (!accessToken) {
        console.log("\uD83D\uDEAA No valid access token found - performing auto logout");
        $a78b7212404532f0$var$performAutoLogout();
        return false;
    }
    return true;
}
window.addEventListener("load", ()=>{
    // Authentication is now handled by initializeAuthentication()
    // which is called immediately when the script loads
    // Sync access token between cookie and input field
    const accessToken = (0, $913d3a1574de567c$export$84773cc9bf7dbe87)();
    if (accessToken) (0, $913d3a1574de567c$export$c0081454efbc7134)(accessToken); // Ensure cookie and input field are synchronized
    const copyTokenButton = document.getElementById("copy-token-button");
    copyTokenButton.addEventListener("click", ()=>{
        const accessTokenInput = document.getElementById("access-token");
        accessTokenInput.select();
        document.execCommand("copy");
        alert("Access token copied to clipboard");
    });
    // Add input mode change handler for toggle switch
    const inputModeToggle = document.getElementById("input-mode-toggle");
    if (inputModeToggle) {
        const toggleOptions = inputModeToggle.querySelectorAll(".toggle-option");
        toggleOptions.forEach((option)=>{
            option.addEventListener("click", (e)=>{
                const mode = e.target.getAttribute("data-mode");
                // Update active state
                toggleOptions.forEach((opt)=>opt.classList.remove("active"));
                e.target.classList.add("active");
                // Update UI based on mode
                $a78b7212404532f0$var$updateInputModeUI(mode);
                $a78b7212404532f0$var$updateArrangementActionButtons();
                // Add animation class
                e.target.classList.add("fade-in");
                setTimeout(()=>{
                    e.target.classList.remove("fade-in");
                }, 300);
            });
        });
    }
    // Add processing mode change handler for dropdown
    const processingModeDropdown = document.getElementById("processing-mode-dropdown");
    if (processingModeDropdown) processingModeDropdown.addEventListener("change", async (e)=>{
        const mode = e.target.value;
        const boundaryViews = [
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.domElement,
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement,
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.domElement,
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement
        ];
        // Update postprocessing section visibility based on mode
        (0, $ddb3f022a87c2bc1$export$7de7bccc87a83087)();
        // Update model processing options section visibility based on mode
        $a78b7212404532f0$var$updateModelOptionsSectionVisibility(mode);
        // Reset postprocessing checkbox when switching away from arrangement
        if (mode !== "arrangement") {
            const enableCheckbox = document.getElementById("enable-postprocessing-checkbox");
            if (enableCheckbox) {
                enableCheckbox.checked = false;
                const controlsContainer = document.getElementById("postprocessing-controls");
                if (controlsContainer) controlsContainer.style.display = "none";
            }
        }
        // Ensure all previous processing results are cleared when switching modes
        $a78b7212404532f0$var$clearAllFilesAndState();
        // Reset multi-view container if it exists
        $a78b7212404532f0$var$resetMultiViewContainer();
        // Ensure the main renderer is visible again
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "block";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "block";
        // Reset any processing state variables
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView = false;
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase = 0;
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult = null;
        // Update file selection UI based on processing mode
        $a78b7212404532f0$var$updateFileSelectionUI(mode);
        // Update instructions based on processing mode
        $a78b7212404532f0$var$updateModeInstructions(mode);
        // Validate file type if file is already selected
        if (mode === "arrangement") {
            // For arrangement mode, validate both lower and upper jaw files
            const lowerJawFileInput = document.getElementById("lower-jaw-file");
            const upperJawFileInput = document.getElementById("upper-jaw-file");
            const lowerJawAzurePathInput = document.getElementById("lower-jaw-azure-path");
            const upperJawAzurePathInput = document.getElementById("upper-jaw-azure-path");
            const lowerFile = lowerJawFileInput?.files[0];
            const upperFile = upperJawFileInput?.files[0];
            const lowerAzurePath = lowerJawAzurePathInput?.value.trim() || null;
            const upperAzurePath = upperJawAzurePathInput?.value.trim() || null;
            // Validate lower jaw file
            if (lowerFile || lowerAzurePath) await $a78b7212404532f0$var$validateFileTypeAndShowWarning(lowerFile, lowerAzurePath, "arrangement", null);
            // Validate upper jaw file
            if (upperFile || upperAzurePath) await $a78b7212404532f0$var$validateFileTypeAndShowWarning(upperFile, upperAzurePath, "arrangement", null);
        } else if (mode === "teethml" || mode === "defectml" || mode === "keypointml" || mode === "teethseparation") {
            const fileSelect = document.getElementById("file-select");
            const azurePathInput = document.getElementById("azure-path-input");
            const file = fileSelect?.files[0];
            const azurePath = azurePathInput?.value.trim() || null;
            const jawSelection = $a78b7212404532f0$var$getJawSelection();
            if (file || azurePath) {
                // For teethseparation, use teethml validation (same requirements)
                const modelForValidation = mode === "teethseparation" ? "teethml" : mode;
                await $a78b7212404532f0$var$validateFileTypeAndShowWarning(file, azurePath, modelForValidation, jawSelection);
            }
        }
        // Trigger window resize to properly layout views for the new mode
        setTimeout(()=>{
            $a78b7212404532f0$var$onWindowResize();
        }, 100);
    });
    // Add app mode toggle handler for switching between processing and feedback modes
    const appModeToggle = document.getElementById("app-mode-toggle");
    if (appModeToggle) {
        const toggleOptions = appModeToggle.querySelectorAll(".toggle-option");
        toggleOptions.forEach((option)=>{
            option.addEventListener("click", (e)=>{
                const mode = e.target.getAttribute("data-mode");
                // Update active state
                toggleOptions.forEach((opt)=>opt.classList.remove("active"));
                e.target.classList.add("active");
                // Switch between modes
                $a78b7212404532f0$var$switchApplicationMode(mode);
                // Add animation class
                e.target.classList.add("fade-in");
                setTimeout(()=>{
                    e.target.classList.remove("fade-in");
                }, 300);
            });
        });
    }
    // Add arrangement view mode toggle handler
    const arrangementViewModeToggle = document.getElementById("arrangement-view-mode-toggle");
    if (arrangementViewModeToggle) {
        const toggleOptions = arrangementViewModeToggle.querySelectorAll(".toggle-option");
        toggleOptions.forEach((option)=>{
            option.addEventListener("click", (e)=>{
                const mode = e.target.getAttribute("data-mode");
                // Update active state
                toggleOptions.forEach((opt)=>opt.classList.remove("active"));
                e.target.classList.add("active");
                // Switch between dual and overlay view
                $a78b7212404532f0$var$switchArrangementViewMode(mode);
                // Add animation class
                e.target.classList.add("fade-in");
                setTimeout(()=>{
                    e.target.classList.remove("fade-in");
                }, 300);
            });
        });
    }
    // Add opacity slider event listeners for overlay mode
    const originalOpacitySlider = document.getElementById("original-opacity-slider");
    const transformedOpacitySlider = document.getElementById("transformed-opacity-slider");
    const originalOpacityValue = document.getElementById("original-opacity-value");
    const transformedOpacityValue = document.getElementById("transformed-opacity-value");
    if (originalOpacitySlider) originalOpacitySlider.addEventListener("input", (e)=>{
        const opacity = e.target.value / 100;
        originalOpacityValue.textContent = `${e.target.value}%`;
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayOriginalMeshes) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayOriginalMeshes.forEach((mesh)=>{
            if (mesh.material) mesh.material.opacity = opacity;
        });
    });
    if (transformedOpacitySlider) transformedOpacitySlider.addEventListener("input", (e)=>{
        const opacity = e.target.value / 100;
        transformedOpacityValue.textContent = `${e.target.value}%`;
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayTransformedMeshes) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayTransformedMeshes.forEach((mesh)=>{
            if (mesh.material) mesh.material.opacity = opacity;
        });
    });
    // Add feedback navigation handlers
    const prevFeedbackBtn = document.getElementById("prev-feedback-btn");
    const nextFeedbackBtn = document.getElementById("next-feedback-btn");
    const loadFeedbackDirectoryBtn = document.getElementById("load-feedback-directory");
    if (prevFeedbackBtn) prevFeedbackBtn.addEventListener("click", ()=>{
        $a78b7212404532f0$var$navigateFeedback(-1);
    });
    if (nextFeedbackBtn) nextFeedbackBtn.addEventListener("click", ()=>{
        $a78b7212404532f0$var$navigateFeedback(1);
    });
    if (loadFeedbackDirectoryBtn) loadFeedbackDirectoryBtn.addEventListener("click", ()=>{
        $a78b7212404532f0$var$handleFeedbackDirectorySelection();
    });
    // Add feedback details panel toggle
    const toggleFeedbackDetails = document.getElementById("toggle-feedback-details");
    if (toggleFeedbackDetails) toggleFeedbackDetails.addEventListener("click", ()=>{
        toggleFeedbackDetailsPanel();
    });
    // Add keyboard navigation for feedback mode
    document.addEventListener("keydown", (event)=>{
        if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData.length === 0) return;
        switch(event.key){
            case "ArrowLeft":
                event.preventDefault();
                $a78b7212404532f0$var$navigateFeedback(-1);
                break;
            case "ArrowRight":
                event.preventDefault();
                $a78b7212404532f0$var$navigateFeedback(1);
                break;
        }
    });
    // Add next phase button to the body for the teeth separation workflow
    const nextPhaseButton = document.createElement("button");
    nextPhaseButton.id = "next-phase-button";
    nextPhaseButton.textContent = "Continue to Separation";
    nextPhaseButton.addEventListener("click", $a78b7212404532f0$var$proceedToNextPhase);
    document.body.appendChild(nextPhaseButton);
    // Add download InfoJSON button (shown directly when the review gate is off)
    const downloadInfoJsonButton = document.createElement("button");
    downloadInfoJsonButton.id = "download-infojson-button";
    downloadInfoJsonButton.textContent = "Download InfoJSON";
    downloadInfoJsonButton.addEventListener("click", $a78b7212404532f0$var$downloadInfoJson);
    document.body.appendChild(downloadInfoJsonButton);
    // Add Accept / Reject buttons (shown instead of the plain download when the
    // review gate is on). Accept logs a compliance acceptance then downloads;
    // Reject requires a reason and logs it. See applyInfoJsonReviewGate.
    const acceptInfoJsonButton = document.createElement("button");
    acceptInfoJsonButton.id = "accept-infojson-button";
    acceptInfoJsonButton.textContent = "Accept & Download InfoJSON";
    acceptInfoJsonButton.addEventListener("click", $a78b7212404532f0$var$acceptInfoJson);
    document.body.appendChild(acceptInfoJsonButton);
    const rejectInfoJsonButton = document.createElement("button");
    rejectInfoJsonButton.id = "reject-infojson-button";
    rejectInfoJsonButton.textContent = "Reject";
    rejectInfoJsonButton.addEventListener("click", $a78b7212404532f0$var$rejectInfoJson);
    document.body.appendChild(rejectInfoJsonButton);
    // Setup displacement table button and modal
    const displacementTableButton = document.getElementById("displacement-table-button");
    if (displacementTableButton) displacementTableButton.addEventListener("click", $a78b7212404532f0$var$showDisplacementTable);
    const closeDisplacementModal = document.getElementById("close-displacement-modal");
    if (closeDisplacementModal) closeDisplacementModal.addEventListener("click", ()=>{
        const modal = document.getElementById("displacement-table-modal");
        if (modal) modal.style.display = "none";
    });
    // Close modal when clicking outside of it
    const displacementTableModal = document.getElementById("displacement-table-modal");
    if (displacementTableModal) displacementTableModal.addEventListener("click", (event)=>{
        if (event.target === displacementTableModal) displacementTableModal.style.display = "none";
    });
    // Setup file input event listeners
    $a78b7212404532f0$var$setupFileInputListeners();
    // Add jaw selection change handler for buttons
    const jawSelectionOptions = document.getElementById("jaw-selection-options");
    if (jawSelectionOptions) {
        const jawButtons = jawSelectionOptions.querySelectorAll(".jaw-button");
        jawButtons.forEach((button)=>{
            button.addEventListener("click", (e)=>{
                const jaw = e.target.getAttribute("data-jaw");
                // Update active state
                jawButtons.forEach((btn)=>btn.classList.remove("active"));
                e.target.classList.add("active");
                // Add animation class
                e.target.classList.add("slide-in");
                setTimeout(()=>{
                    e.target.classList.remove("slide-in");
                }, 300);
            });
        });
    }
    // Initialize file selection UI based on default processing mode
    const defaultMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
    console.log("Default mode:", defaultMode);
    $a78b7212404532f0$var$updateFileSelectionUI(defaultMode);
    $a78b7212404532f0$var$updateModeInstructions(defaultMode);
    // Ensure postprocessing section is visible on initial page load
    // Use setTimeout to ensure all DOM elements are fully initialized
    // Call after updateFileSelectionUI to ensure it runs last
    setTimeout(()=>{
        (0, $ddb3f022a87c2bc1$export$7de7bccc87a83087)();
        $a78b7212404532f0$var$updateModelOptionsSectionVisibility(defaultMode);
        // Double-check after a short delay to ensure visibility is set
        setTimeout(()=>{
            const postprocessingSection = document.getElementById("postprocessing-section");
            if (postprocessingSection && defaultMode === "arrangement" && !(0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode) {
                postprocessingSection.style.display = "block";
                postprocessingSection.style.setProperty("display", "block", "important");
            }
        }, 50);
    }, 150);
    // Apply correct view layout for the default mode
    $a78b7212404532f0$var$onWindowResize();
});
/**
 * Get the current input mode from the toggle switch
 * @returns {string} The current input mode ('file' or 'azure')
 */ function $a78b7212404532f0$var$getInputMode() {
    const activeToggle = document.querySelector("#input-mode-toggle .toggle-option.active");
    return activeToggle ? activeToggle.getAttribute("data-mode") : "file";
}
/**
 * Whether the current input mode reads from Azure rather than local file uploads.
 * In Azure mode the user gives one folder path (arrangement) or a single blob
 * path (other modes); the resolved per-file azure fields feed the same
 * submit/preview chain.
 * @returns {boolean}
 */ function $a78b7212404532f0$var$isAzureInputMode() {
    return $a78b7212404532f0$var$getInputMode() === "azure";
}
// Scroll a text input so the END of a long value is visible (the file name at
// the end of an azure:// path, not the container prefix at the start).
function $a78b7212404532f0$var$scrollInputToEnd(el) {
    if (!el) return;
    if (el.value) el.title = el.value;
    else el.removeAttribute("title");
    const apply = ()=>{
        el.scrollLeft = el.scrollWidth;
    };
    apply();
    // Browsers reset an input's horizontal scroll to the start AFTER the blur
    // event is handled, so a synchronous set gets clobbered. Re-apply on the next
    // frame (once the field is unfocused) to keep the end pinned in view.
    requestAnimationFrame(apply);
}
// Show or hide the per-file Azure path fields based on the "Override individual
// file paths" checkbox. Only meaningful in Azure + arrangement mode.
function $a78b7212404532f0$var$updateAzureOverrideVisibility() {
    const checkbox = document.getElementById("override-azure-paths-checkbox");
    const pairedAzurePath = document.getElementById("paired-azure-path");
    if (!pairedAzurePath) return;
    const show = $a78b7212404532f0$var$isAzureInputMode() && checkbox && checkbox.checked;
    pairedAzurePath.style.display = show ? "block" : "none";
    if (show) [
        "lower-jaw-azure-path",
        "upper-jaw-azure-path",
        "info-json-azure-path",
        "landmarks-csv-azure-path"
    ].forEach((id)=>$a78b7212404532f0$var$scrollInputToEnd(document.getElementById(id)));
}
/**
 * Get the current jaw selection from the buttons
 * @returns {string} The current jaw selection ('upper' or 'lower')
 */ function $a78b7212404532f0$var$getJawSelection() {
    const activeButton = document.querySelector("#jaw-selection-options .jaw-button.active");
    return activeButton ? activeButton.getAttribute("data-jaw") : "upper";
}
/**
 * Update mode instructions based on selected processing mode
 * @param {string} mode - The selected processing mode
 */ function $a78b7212404532f0$var$updateModeInstructions(mode) {
    const instructionsElement = document.getElementById("mode-instructions");
    if (!instructionsElement) return;
    const instructions = {
        teethml: "<strong>Teeth Segmentation:</strong> Use prepared .obj files (with bottom) for best results.",
        defectml: "<strong>Defect Segmentation:</strong> Use raw files (.stl, without bottom) for optimal detection.",
        keypointml: "<strong>Keypoint Detection:</strong> Use separated objects (.obj files after segmentation).",
        teethseparation: "<strong>Teeth Reconstruction:</strong> Use prepared .obj files (with bottom) for reconstruction.",
        arrangement: "<strong>Teeth Arrangement:</strong> Use separated objects (.obj files) for both upper and lower jaws."
    };
    instructionsElement.innerHTML = instructions[mode] || instructions.arrangement;
    instructionsElement.classList.add("fade-in");
    setTimeout(()=>{
        instructionsElement.classList.remove("fade-in");
    }, 300);
}
/**
 * Update input mode UI (file upload vs Azure path)
 * @param {string} mode - The selected input mode ('file' or 'azure')
 */ function $a78b7212404532f0$var$updateInputModeUI(mode) {
    // Update single file selection sections
    const singleFileUpload = document.getElementById("single-file-upload");
    const singleAzurePath = document.getElementById("single-azure-path");
    // Update paired file selection sections
    const pairedFileUpload = document.getElementById("paired-file-upload");
    const pairedAzureFolder = document.getElementById("paired-azure-folder");
    if (mode === "azure") {
        // Azure mode: single blob path (non-arrangement) or the folder input
        // (arrangement). The per-file path fields are shown only when the
        // "Override individual file paths" checkbox is on (handled below).
        if (singleFileUpload) singleFileUpload.style.display = "none";
        if (singleAzurePath) singleAzurePath.style.display = "block";
        if (pairedFileUpload) pairedFileUpload.style.display = "none";
        if (pairedAzureFolder) pairedAzureFolder.style.display = "block";
    } else {
        // File upload mode.
        if (singleFileUpload) singleFileUpload.style.display = "block";
        if (singleAzurePath) singleAzurePath.style.display = "none";
        if (pairedFileUpload) pairedFileUpload.style.display = "block";
        if (pairedAzureFolder) pairedAzureFolder.style.display = "none";
    }
    // Per-file paths visibility is driven by the override checkbox.
    $a78b7212404532f0$var$updateAzureOverrideVisibility();
}
// Write the resolved azure:// references (or "") into the hidden per-file azure
// path inputs that the arrangement submit/preview paths already read.
function $a78b7212404532f0$var$setArrangementAzureFields(resolved) {
    const set = (id, value)=>{
        const el = document.getElementById(id);
        if (!el) return;
        el.value = value || "";
        // Keep the file name (end of the long path) in view, not the prefix.
        $a78b7212404532f0$var$scrollInputToEnd(el);
    };
    set("lower-jaw-azure-path", resolved ? resolved.lower : "");
    set("upper-jaw-azure-path", resolved ? resolved.upper : "");
    set("info-json-azure-path", resolved ? resolved.info : "");
    set("landmarks-csv-azure-path", resolved ? resolved.landmarks : "");
}
// Clear the folder resolution: empties the resolved azure fields and the
// preview/error displays so a stale/partial set can never be submitted.
function $a78b7212404532f0$var$resetArrangementFolderResolution() {
    $a78b7212404532f0$var$setArrangementAzureFields(null);
    const preview = document.getElementById("folder-resolve-preview");
    const error = document.getElementById("folder-resolve-error");
    if (preview) {
        preview.textContent = "";
        preview.style.display = "none";
    }
    if (error) {
        error.textContent = "";
        error.style.display = "none";
    }
    // Collapse the per-file override back to hidden.
    const checkbox = document.getElementById("override-azure-paths-checkbox");
    if (checkbox) checkbox.checked = false;
    $a78b7212404532f0$var$updateAzureOverrideVisibility();
    $a78b7212404532f0$var$updateArrangementActionButtons();
}
// Resolve one Azure folder into the 4 arrangement files: list the folder, match
// files by naming convention, populate the per-file Azure path fields, and warn
// about anything not resolved automatically. Whatever resolves is filled in; the
// fields stay editable so the user can correct or enter the rest by hand.
async function $a78b7212404532f0$var$resolveArrangementFolder(folderPath) {
    const preview = document.getElementById("folder-resolve-preview");
    const error = document.getElementById("folder-resolve-error");
    const setPreview = (html)=>{
        if (!preview) return;
        preview.innerHTML = html || "";
        preview.style.display = html ? "block" : "none";
    };
    const setError = (msg)=>{
        if (!error) return;
        error.textContent = msg || "";
        error.style.display = msg ? "block" : "none";
    };
    let response;
    try {
        response = await (0, $913d3a1574de567c$export$ae14c375fc93363).listAzureFolder(folderPath);
    } catch (e) {
        const detail = e?.response?.data?.detail || e?.message || "Failed to list Azure folder";
        setPreview("");
        setError(`Could not read folder: ${detail}`);
        $a78b7212404532f0$var$setArrangementAzureFields(null);
        $a78b7212404532f0$var$updateArrangementActionButtons();
        return;
    }
    const { resolved: resolved, errors: errors, unmatched: unmatched } = (0, $0f1e8af8606ec915$export$1a787057b09eb396)(response.files || []);
    // Populate whatever resolved. Unresolved roles become empty, editable fields.
    $a78b7212404532f0$var$setArrangementAzureFields(resolved);
    const baseName = (ref)=>ref ? String(ref).split("/").pop() : null;
    const esc = (s)=>String(s).replace(/[&<>"]/g, (c)=>({
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;"
            })[c]);
    // Middle-ellipsis: split the name into a shrinkable head and a pinned tail so
    // the distinguishing suffix (L/U role + extension) is ALWAYS visible while the
    // redundant leading id gets the ellipsis. Done in markup (two flex cells)
    // rather than CSS direction:rtl, which reorders names that start with digits.
    const midName = (name, tailLen)=>{
        const n = String(name);
        if (n.length <= tailLen + 6) return `<span class="fn-head">${esc(n)}</span>`;
        return `<span class="fn-head">${esc(n.slice(0, n.length - tailLen))}</span>` + `<span class="fn-tail">${esc(n.slice(-tailLen))}</span>`;
    };
    // One row per role: status icon + label on top, file name (middle-ellipsis)
    // full-width below. Required jaws that did not resolve are flagged so the user
    // knows to fill them in manually.
    const roleRow = (label, name, required)=>{
        if (name) return `<div class="resolve-row ok">` + `<div class="resolve-head"><span class="ic">\u{2713}</span>` + `<span class="role">${label}</span></div>` + `<div class="fname" title="${esc(name)}">${midName(name, 18)}</div>` + `</div>`;
        const cls = required ? "missing" : "none";
        const text = required ? "not found - enter manually" : "none";
        const icon = required ? "\u26A0" : "\u2013";
        return `<div class="resolve-row ${cls}">` + `<div class="resolve-head"><span class="ic">${icon}</span>` + `<span class="role">${label}</span></div>` + `<div class="fname placeholder">${text}</div>` + `</div>`;
    };
    let html = roleRow("Lower jaw", baseName(resolved.lower), true) + roleRow("Upper jaw", baseName(resolved.upper), true) + roleRow("Info JSON", baseName(resolved.info), false) + roleRow("Landmarks", baseName(resolved.landmarks), false);
    if (unmatched.length > 0) html += `<details class="resolve-ignored">` + `<summary>${unmatched.length} file(s) ignored</summary>` + `<ul>${unmatched.map((n)=>`<li title="${esc(n)}">${midName(n, 16)}</li>`).join("")}</ul>` + `</details>`;
    setPreview(html);
    if (errors.length > 0) {
        setError("Some files could not be selected automatically - tick 'Override individual file paths' and enter them manually:\n" + errors.join("\n"));
        // Auto-reveal the per-file paths so the user can fix the unresolved ones.
        const checkbox = document.getElementById("override-azure-paths-checkbox");
        if (checkbox) checkbox.checked = true;
    } else setError("");
    $a78b7212404532f0$var$updateAzureOverrideVisibility();
    $a78b7212404532f0$var$updateArrangementActionButtons();
    $a78b7212404532f0$var$checkAndLoadArrangementFiles();
}
/**
 * Update file selection UI based on processing mode
 * @param {string} mode - The selected processing mode
 */ function $a78b7212404532f0$var$updateFileSelectionUI(mode) {
    const singleFileSelection = document.getElementById("single-file-selection");
    const pairedFileSelection = document.getElementById("paired-file-selection");
    const jawSelectionSection = document.getElementById("jaw-selection-section");
    const jawSelectionOptions = document.getElementById("jaw-selection-options");
    if (mode === "arrangement") {
        // Show paired file selection for arrangement
        singleFileSelection.style.display = "none";
        pairedFileSelection.style.display = "block";
        jawSelectionSection.style.display = "none";
        jawSelectionOptions.style.display = "none";
    } else {
        // Show single file selection for other modes
        singleFileSelection.style.display = "block";
        pairedFileSelection.style.display = "none";
        jawSelectionSection.style.display = "block";
        jawSelectionOptions.style.display = "block";
        // Hide view mode toggle for non-arrangement modes
        const viewModeContainer = document.getElementById("arrangement-view-mode-container");
        if (viewModeContainer) viewModeContainer.style.display = "none";
    }
    // The Azure folder input (top of Azure mode) is arrangement-only; the paired
    // container that holds it is already shown only for arrangement, so no extra
    // handling is needed here. Re-sync per-file path visibility for the mode.
    $a78b7212404532f0$var$updateAzureOverrideVisibility();
    // Update visibility controls based on processing mode
    $a78b7212404532f0$var$updateVisibilityControlsForMode(mode);
    // Update keypoint labels checkbox based on processing mode
    // Disable it initially for all modes (will be enabled after inference for keypoint mode)
    $a78b7212404532f0$var$disableKeypointLabelsCheckbox();
    // Update arrangement labels checkbox based on processing mode
    // Only enable for arrangement mode
    if (mode === "arrangement") $a78b7212404532f0$var$disableArrangementLabelsCheckbox(); // Disabled until inference completes
    else $a78b7212404532f0$var$disableArrangementLabelsCheckbox(); // Disabled for all other modes
    // Also update input mode UI to ensure correct display
    const currentInputMode = $a78b7212404532f0$var$getInputMode();
    $a78b7212404532f0$var$updateInputModeUI(currentInputMode);
}
/**
 * Update visibility controls (Gingiva, Brackets) based on processing mode
 * These controls should only be visible in arrangement mode
 * @param {string} mode - The selected processing mode
 */ function $a78b7212404532f0$var$updateVisibilityControlsForMode(mode) {
    const visibilityContainer = document.querySelector(".visibility-options-container");
    if (!visibilityContainer) return;
    if (mode === "arrangement") // Show visibility controls in arrangement mode
    visibilityContainer.style.display = "block";
    else // Hide visibility controls in other modes
    visibilityContainer.style.display = "none";
}
/**
 * Whether segmentation should auto-orient the scan before inference.
 * @returns {boolean}
 */ function $a78b7212404532f0$var$isAutoOrientationEnabled() {
    if (!$a78b7212404532f0$var$autoOrientationEnabled) return false;
    const checkbox = document.getElementById("enable-auto-orientation-checkbox");
    return checkbox ? checkbox.checked : true;
}
/**
 * Initialize the auto orientation checkbox from localStorage.
 */ function $a78b7212404532f0$var$initializeAutoOrientation() {
    const checkbox = document.getElementById("enable-auto-orientation-checkbox");
    if (!checkbox) {
        console.warn("Auto orientation checkbox not found");
        return;
    }
    // Load saved value from localStorage, default to true (checked)
    const savedValue = localStorage.getItem($a78b7212404532f0$var$STORAGE_KEY_AUTO_ORIENTATION);
    if (!$a78b7212404532f0$var$autoOrientationEnabled) // Killed deployment-wide: ignore any saved opt-in, nothing will rotate.
    checkbox.checked = false;
    else if (savedValue !== null) {
        checkbox.checked = savedValue === "true";
        console.log(`[AutoOrientation] Loaded from localStorage: ${checkbox.checked}`);
    } else {
        checkbox.checked = true;
        console.log("[AutoOrientation] Using default: true");
    }
    // Add change listener to save to localStorage
    checkbox.addEventListener("change", function() {
        localStorage.setItem($a78b7212404532f0$var$STORAGE_KEY_AUTO_ORIENTATION, this.checked.toString());
        console.log(`[AutoOrientation] Saved to localStorage: ${this.checked}`);
    });
}
/**
 * Update model processing options section visibility based on processing mode
 * Model Processing Options (Gingiva Movement Estimation) should only be visible in arrangement mode
 * @param {string} mode - The selected processing mode
 */ function $a78b7212404532f0$var$updateModelOptionsSectionVisibility(mode) {
    const modelOptionsSection = document.getElementById("model-options-section");
    const segmentationOptionsSection = document.getElementById("segmentation-options-section");
    if (modelOptionsSection) modelOptionsSection.style.display = mode === "arrangement" ? "block" : "none";
    if (segmentationOptionsSection) segmentationOptionsSection.style.display = mode === "teethml" && $a78b7212404532f0$var$autoOrientationEnabled ? "block" : "none";
}
/**
 * Setup event listeners for file inputs
 */ // Function to validate file type and show warning if needed
async function $a78b7212404532f0$var$validateFileTypeAndShowWarning(file, azurePath, model, jaw) {
    if (!file && !azurePath) return;
    try {
        const validationResponse = await (0, $913d3a1574de567c$export$ae14c375fc93363).validateFileType(file, azurePath, model, jaw);
        if (validationResponse && validationResponse.warning) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(validationResponse.warning, "exclamation-triangle", 5000);
    } catch (error) {
        console.warn("Failed to validate file type:", error);
    // Don't block file selection if validation fails
    }
}
function $a78b7212404532f0$var$setupFileInputListeners() {
    // Single file input listener (existing)
    const fileSelect = document.getElementById("file-select");
    if (fileSelect) fileSelect.addEventListener("change", async (event)=>{
        const file = event.target.files[0];
        const fileNameDiv = document.getElementById("file-name");
        if (file && fileNameDiv) {
            fileNameDiv.textContent = file.name;
            // Clear previous inference results when selecting a new file
            $a78b7212404532f0$var$clearInferenceResults();
            // Validate file type for current model
            const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
            const jawSelection = $a78b7212404532f0$var$getJawSelection();
            // Only validate for non-arrangement modes
            if (processingMode !== "arrangement" && (processingMode === "teethml" || processingMode === "defectml" || processingMode === "keypointml" || processingMode === "teethseparation")) {
                // For teethseparation, use teethml validation (same requirements)
                const modelForValidation = processingMode === "teethseparation" ? "teethml" : processingMode;
                await $a78b7212404532f0$var$validateFileTypeAndShowWarning(file, null, modelForValidation, jawSelection);
            }
        }
    });
    // Lower jaw file input listener
    const lowerJawFile = document.getElementById("lower-jaw-file");
    if (lowerJawFile) lowerJawFile.addEventListener("change", async (event)=>{
        const file = event.target.files[0];
        const fileNameDiv = document.getElementById("lower-jaw-file-name");
        if (file) {
            if (file.name.toLowerCase().endsWith(".obj")) {
                fileNameDiv.textContent = file.name;
                fileNameDiv.style.color = "#666";
            } else {
                fileNameDiv.textContent = "Please select a .obj file";
                fileNameDiv.style.color = "#ff6b6b";
            }
            // Clear previous inference results when selecting a new file
            $a78b7212404532f0$var$clearInferenceResults();
            // Validate file type for arrangement (requires RECONSTRUCTED files)
            const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
            if (processingMode === "arrangement") await $a78b7212404532f0$var$validateFileTypeAndShowWarning(file, null, "arrangement", null);
            // Check if both files are now selected and load them
            $a78b7212404532f0$var$checkAndLoadArrangementFiles();
        } else if (fileNameDiv) {
            fileNameDiv.textContent = "";
            $a78b7212404532f0$var$clearInferenceResults();
            $a78b7212404532f0$var$checkAndLoadArrangementFiles();
        }
    });
    // Upper jaw file input listener
    const upperJawFile = document.getElementById("upper-jaw-file");
    if (upperJawFile) upperJawFile.addEventListener("change", async (event)=>{
        const file = event.target.files[0];
        const fileNameDiv = document.getElementById("upper-jaw-file-name");
        if (file) {
            if (file.name.toLowerCase().endsWith(".obj")) {
                fileNameDiv.textContent = file.name;
                fileNameDiv.style.color = "#666";
            } else {
                fileNameDiv.textContent = "Please select a .obj file";
                fileNameDiv.style.color = "#ff6b6b";
            }
            // Clear previous inference results when selecting a new file
            $a78b7212404532f0$var$clearInferenceResults();
            // Validate file type for arrangement (requires RECONSTRUCTED files)
            const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
            if (processingMode === "arrangement") await $a78b7212404532f0$var$validateFileTypeAndShowWarning(file, null, "arrangement", null);
            // Check if both files are now selected and load them
            $a78b7212404532f0$var$checkAndLoadArrangementFiles();
        } else if (fileNameDiv) {
            fileNameDiv.textContent = "";
            $a78b7212404532f0$var$clearInferenceResults();
            $a78b7212404532f0$var$checkAndLoadArrangementFiles();
        }
    });
    // InfoJSON file input listener (optional)
    const infoJsonFile = document.getElementById("info-json-file");
    if (infoJsonFile) infoJsonFile.addEventListener("change", (event)=>{
        const file = event.target.files[0];
        const fileNameDiv = document.getElementById("info-json-file-name");
        if (file) {
            if (file.name.toLowerCase().endsWith(".json")) {
                fileNameDiv.textContent = file.name;
                fileNameDiv.style.color = "#666";
            } else {
                fileNameDiv.textContent = "Please select a .json file";
                fileNameDiv.style.color = "#ff6b6b";
            }
            // InfoJSON is optional, so we still check and load files
            $a78b7212404532f0$var$checkAndLoadArrangementFiles();
        } else fileNameDiv.textContent = "";
    });
    // Landmarks CSV file input listener (optional)
    const landmarksCsvFile = document.getElementById("landmarks-csv-file");
    if (landmarksCsvFile) landmarksCsvFile.addEventListener("change", (event)=>{
        const file = event.target.files[0];
        const fileNameDiv = document.getElementById("landmarks-csv-file-name");
        if (file) {
            if (file.name.toLowerCase().endsWith(".csv")) {
                fileNameDiv.textContent = file.name;
                fileNameDiv.style.color = "#666";
            } else {
                fileNameDiv.textContent = "Please select a .csv file";
                fileNameDiv.style.color = "#ff6b6b";
            }
            // Landmarks CSV is optional, so we still check and load files
            $a78b7212404532f0$var$checkAndLoadArrangementFiles();
        } else fileNameDiv.textContent = "";
    });
    // Azure path input listener for single file mode
    const azurePathInput = document.getElementById("azure-path-input");
    if (azurePathInput) {
        let azurePathDebounceTimeout;
        azurePathInput.addEventListener("input", async ()=>{
            const azurePath = azurePathInput.value.trim();
            // Clear previous timeout
            clearTimeout(azurePathDebounceTimeout);
            if (azurePath) // Debounce validation to avoid too many requests while typing
            azurePathDebounceTimeout = setTimeout(async ()=>{
                const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
                const jawSelection = $a78b7212404532f0$var$getJawSelection();
                // Only validate for non-arrangement modes
                if (processingMode !== "arrangement" && (processingMode === "teethml" || processingMode === "defectml" || processingMode === "keypointml" || processingMode === "teethseparation")) {
                    // For teethseparation, use teethml validation (same requirements)
                    const modelForValidation = processingMode === "teethseparation" ? "teethml" : processingMode;
                    await $a78b7212404532f0$var$validateFileTypeAndShowWarning(null, azurePath, modelForValidation, jawSelection);
                }
            }, 1000); // Wait 1 second after user stops typing
        });
    }
    // Azure path input listeners for arrangement
    const lowerJawAzurePath = document.getElementById("lower-jaw-azure-path");
    if (lowerJawAzurePath) {
        let lowerJawAzurePathDebounceTimeout;
        lowerJawAzurePath.addEventListener("input", async ()=>{
            const azurePath = lowerJawAzurePath.value.trim();
            // Clear previous inference results when path changes
            $a78b7212404532f0$var$clearInferenceResults();
            // Clear previous timeout
            clearTimeout(lowerJawAzurePathDebounceTimeout);
            if (azurePath) // Debounce validation to avoid too many requests while typing
            lowerJawAzurePathDebounceTimeout = setTimeout(async ()=>{
                const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
                if (processingMode === "arrangement") await $a78b7212404532f0$var$validateFileTypeAndShowWarning(null, azurePath, "arrangement", null);
                $a78b7212404532f0$var$checkAndLoadArrangementFiles();
            }, 1000); // Wait 1 second after user stops typing
            else // If path is cleared, still check and load files
            lowerJawAzurePathDebounceTimeout = setTimeout(()=>{
                $a78b7212404532f0$var$checkAndLoadArrangementFiles();
            }, 500);
        });
    }
    const upperJawAzurePath = document.getElementById("upper-jaw-azure-path");
    if (upperJawAzurePath) {
        let upperJawAzurePathDebounceTimeout;
        upperJawAzurePath.addEventListener("input", async ()=>{
            const azurePath = upperJawAzurePath.value.trim();
            // Clear previous inference results when path changes
            $a78b7212404532f0$var$clearInferenceResults();
            // Clear previous timeout
            clearTimeout(upperJawAzurePathDebounceTimeout);
            if (azurePath) // Debounce validation to avoid too many requests while typing
            upperJawAzurePathDebounceTimeout = setTimeout(async ()=>{
                const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
                if (processingMode === "arrangement") await $a78b7212404532f0$var$validateFileTypeAndShowWarning(null, azurePath, "arrangement", null);
                $a78b7212404532f0$var$checkAndLoadArrangementFiles();
            }, 1000); // Wait 1 second after user stops typing
            else // If path is cleared, still check and load files
            upperJawAzurePathDebounceTimeout = setTimeout(()=>{
                $a78b7212404532f0$var$checkAndLoadArrangementFiles();
            }, 500);
        });
    }
    // Azure folder mode (arrangement only): resolve the 4 files from one folder.
    const arrangementFolderInput = document.getElementById("arrangement-folder-path");
    if (arrangementFolderInput) {
        let folderDebounceTimeout;
        arrangementFolderInput.addEventListener("input", ()=>{
            $a78b7212404532f0$var$clearInferenceResults();
            clearTimeout(folderDebounceTimeout);
            const folderPath = arrangementFolderInput.value.trim();
            if (!folderPath) {
                $a78b7212404532f0$var$resetArrangementFolderResolution();
                return;
            }
            // Debounce so we do not list on every keystroke.
            folderDebounceTimeout = setTimeout(()=>{
                $a78b7212404532f0$var$resolveArrangementFolder(folderPath);
            }, 1000);
        });
    }
    const resolveFolderBtn = document.getElementById("resolve-folder-btn");
    if (resolveFolderBtn) resolveFolderBtn.addEventListener("click", ()=>{
        const folderPath = (document.getElementById("arrangement-folder-path")?.value || "").trim();
        if (!folderPath) {
            $a78b7212404532f0$var$resetArrangementFolderResolution();
            return;
        }
        $a78b7212404532f0$var$resolveArrangementFolder(folderPath);
    });
    // "Override individual file paths" checkbox reveals/hides the per-file inputs.
    const overrideCheckbox = document.getElementById("override-azure-paths-checkbox");
    if (overrideCheckbox) overrideCheckbox.addEventListener("change", ()=>{
        $a78b7212404532f0$var$updateAzureOverrideVisibility();
    });
    // Keep the end (file name) of long Azure paths visible when editing stops.
    [
        "arrangement-folder-path",
        "lower-jaw-azure-path",
        "upper-jaw-azure-path",
        "info-json-azure-path",
        "landmarks-csv-azure-path"
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.addEventListener("blur", ()=>$a78b7212404532f0$var$scrollInputToEnd(el));
    });
}
$a78b7212404532f0$var$init();
$a78b7212404532f0$var$animate();
// Note: Postprocessing functions moved to postprocessing.js module
/**
 * Initialize gingiva estimation checkbox from localStorage
 */ function $a78b7212404532f0$var$initializeGingivaEstimation() {
    const gingivaCheckbox = document.getElementById("enable-gingiva-estimation-checkbox");
    if (!gingivaCheckbox) {
        console.warn("Gingiva estimation checkbox not found");
        return;
    }
    // Load saved value from localStorage, default to true (checked)
    const savedValue = localStorage.getItem($a78b7212404532f0$var$STORAGE_KEY_GINGIVA_ESTIMATION);
    if (savedValue !== null) {
        gingivaCheckbox.checked = savedValue === "true";
        console.log(`[GingivaEstimation] Loaded from localStorage: ${gingivaCheckbox.checked}`);
    } else {
        gingivaCheckbox.checked = true;
        console.log("[GingivaEstimation] Using default: true");
    }
    // Add change listener to save to localStorage
    gingivaCheckbox.addEventListener("change", function() {
        localStorage.setItem($a78b7212404532f0$var$STORAGE_KEY_GINGIVA_ESTIMATION, this.checked.toString());
        console.log(`[GingivaEstimation] Saved to localStorage: ${this.checked}`);
    });
}
/**
 * Initialize calculate space/intersection checkbox from localStorage
 */ function $a78b7212404532f0$var$initializeCalculateSpaceIntersection() {
    const checkbox = document.getElementById("calculate-space-intersection-checkbox");
    if (!checkbox) {
        console.warn("Calculate space/intersection checkbox not found");
        return;
    }
    // Load saved value from localStorage, default to true (checked)
    const savedValue = localStorage.getItem($a78b7212404532f0$var$STORAGE_KEY_CALCULATE_SPACE_INTERSECTION);
    if (savedValue !== null && $a78b7212404532f0$var$spaceIntersectionToggleEnabled) {
        checkbox.checked = savedValue === "true";
        console.log(`[CalculateSpaceIntersection] Loaded from localStorage: ${checkbox.checked}`);
    } else if (!$a78b7212404532f0$var$spaceIntersectionToggleEnabled) // Toggle hidden: computation always on, ignore any saved opt-out.
    checkbox.checked = true;
    else {
        checkbox.checked = true;
        console.log("[CalculateSpaceIntersection] Using default: true");
    }
    // Add change listener to save to localStorage
    checkbox.addEventListener("change", function() {
        localStorage.setItem($a78b7212404532f0$var$STORAGE_KEY_CALCULATE_SPACE_INTERSECTION, this.checked.toString());
        console.log(`[CalculateSpaceIntersection] Saved to localStorage: ${this.checked}`);
    });
}
function $a78b7212404532f0$var$init() {
    // Main view setup
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene = new $0d79572b4b22d35c$export$38af1803e3442a7f();
    const mainViewer = document.getElementById("main-viewer");
    const viewerRect = mainViewer.getBoundingClientRect();
    const aspect = viewerRect.width / viewerRect.height;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera = $a78b7212404532f0$var$createOrthographicCamera(aspect);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer = new $0d79572b4b22d35c$export$f6cc00ef28d7cf97({
        antialias: true
    });
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.setSize(viewerRect.width, viewerRect.height);
    mainViewer.appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement);
    // Label renderer setup for main view
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer = new (0, $b5225408295f08ae$export$508520281a983506)();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.setSize(viewerRect.width, viewerRect.height);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.position = "absolute";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.top = "0";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.left = "0";
    mainViewer.appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement);
    // Boundary view setup
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene = new $0d79572b4b22d35c$export$38af1803e3442a7f();
    const boundaryAspect = window.innerWidth / 2 / (window.innerHeight / 2);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera = $a78b7212404532f0$var$createOrthographicCamera(boundaryAspect);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer = new $0d79572b4b22d35c$export$f6cc00ef28d7cf97({
        antialias: true
    });
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.domElement.style.position = "absolute";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.domElement.style.right = "0";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.domElement.style.top = "0";
    document.body.appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.domElement);
    // Label renderer setup for boundary view
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer = new (0, $b5225408295f08ae$export$508520281a983506)();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement.style.position = "absolute";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement.style.right = "0";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement.style.top = "0";
    document.body.appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement);
    // Simplified boundary view setup
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene = new $0d79572b4b22d35c$export$38af1803e3442a7f();
    const simplifiedBoundaryAspect = window.innerWidth / 2 / (window.innerHeight / 2);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera = $a78b7212404532f0$var$createOrthographicCamera(simplifiedBoundaryAspect);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer = new $0d79572b4b22d35c$export$f6cc00ef28d7cf97({
        antialias: true
    });
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.domElement.style.position = "absolute";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.domElement.style.right = "0";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.domElement.style.bottom = "0";
    document.body.appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.domElement);
    // Label renderer setup for simplified boundary view
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer = new (0, $b5225408295f08ae$export$508520281a983506)();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement.style.position = "absolute";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement.style.right = "0";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement.style.bottom = "0";
    document.body.appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement);
    // Add vertical line separator
    const separator = document.createElement("div");
    separator.classList.add("view-separator");
    separator.style.position = "absolute";
    separator.style.top = "0";
    separator.style.left = "50%";
    separator.style.width = "2px";
    separator.style.height = "100%";
    separator.style.backgroundColor = "#000";
    document.body.appendChild(separator);
    // Add horizontal line separator for boundary views
    const horizontalSeparator = document.createElement("div");
    horizontalSeparator.classList.add("view-separator");
    horizontalSeparator.style.position = "absolute";
    horizontalSeparator.style.top = "50%";
    horizontalSeparator.style.right = "0";
    horizontalSeparator.style.width = "50%";
    horizontalSeparator.style.height = "2px";
    horizontalSeparator.style.backgroundColor = "#000";
    document.body.appendChild(horizontalSeparator);
    // Create gradient background for all views
    const bgTexture = (0, $b28963ea5393104c$export$82c7f84255e60cc3)();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.background = bgTexture;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.background = bgTexture;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.background = bgTexture;
    // Improve lighting for better object visibility in all views
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).ambientLight = new $0d79572b4b22d35c$export$af279bfef9ec2c96(0xffffff, 0.3 * (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).ambientLight);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).ambientLight.clone());
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).ambientLight.clone());
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight1 = new $0d79572b4b22d35c$export$3fea33cc9972c868(0xffffff, 0.7 * (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight1.position.set(1, 1, 1);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight1);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight1.clone());
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight1.clone());
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight2 = new $0d79572b4b22d35c$export$3fea33cc9972c868(0xffffff, 0.5 * (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight2.position.set(-1, -1, -1);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight2);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight2.clone());
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight2.clone());
    // Adjust camera position to see the entire object in all views
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera.position.set(0, 0, 60);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera.position.set(0, 0, 60);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera.position.set(0, 0, 60);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls = new (0, $6c1447dc1cd4496f$export$8ff7788029dfdf52)((0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.enableDamping = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.dampingFactor = 0.5;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.screenSpacePanning = false;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.enableRotate = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.autoRotate = false;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.enableZoom = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.enablePan = true;
    // Add event listener for control changes
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.addEventListener("change", ()=>{
        (0, $1161739a589c5758$export$ef655c5027b28822)((0, $66dbd4fb7330af32$export$8e769ad4338a911e));
    });
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls = new (0, $6c1447dc1cd4496f$export$8ff7788029dfdf52)((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.enableDamping = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.dampingFactor = 0.5;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.screenSpacePanning = false;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.enableRotate = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.autoRotate = false;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.enableZoom = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.enablePan = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls = new (0, $6c1447dc1cd4496f$export$8ff7788029dfdf52)((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.enableDamping = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.dampingFactor = 0.5;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.screenSpacePanning = false;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.enableRotate = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.autoRotate = false;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.enableZoom = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.enablePan = true;
    // Link the three views
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.addEventListener("change", ()=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera.position.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera.position);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera.rotation.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera.rotation);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.target.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.target);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera.position.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera.position);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera.rotation.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera.rotation);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.target.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.target);
    });
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.addEventListener("change", ()=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera.position.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera.position);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera.rotation.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera.rotation);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.target.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.target);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera.position.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera.position);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera.rotation.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera.rotation);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.target.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.target);
    });
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.addEventListener("change", ()=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera.position.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera.position);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera.rotation.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera.rotation);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.target.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.target);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera.position.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera.position);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera.rotation.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera.rotation);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.target.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.target);
    });
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).wireframeMaterial = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
        color: 0xffffff
    });
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).pointsMaterial = new $0d79572b4b22d35c$export$a178c45366ce5d6b({
        size: 0.05,
        vertexColors: true
    });
    window.addEventListener("resize", $a78b7212404532f0$var$onWindowResize);
    // Setup drag and drop
    const dropZone = document.body;
    dropZone.addEventListener("dragover", $a78b7212404532f0$var$handleDragOver);
    dropZone.addEventListener("drop", $a78b7212404532f0$var$handleDrop);
    document.getElementById("file-select").addEventListener("change", $a78b7212404532f0$var$handleFileSelect);
    document.getElementById("show-wire-frame").addEventListener("change", (e)=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).showWireframe = e.target.checked;
        $a78b7212404532f0$var$updateMeshVisualization();
    });
    document.getElementById("show-point-cloud").addEventListener("change", (e)=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).showPointCloud = e.target.checked;
        $a78b7212404532f0$var$updateMeshVisualization();
    });
    document.getElementById("show-keypoint-labels").addEventListener("change", (e)=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).showKeypointLabels = e.target.checked;
        // Update visibility of existing keypoint labels instead of redrawing
        $a78b7212404532f0$var$updateKeypointLabelsVisibility(e.target.checked);
    });
    document.getElementById("show-arrangement-labels").addEventListener("change", (e)=>{
        const showLabels = e.target.checked;
        // Update arrangement object label visibility
        $a78b7212404532f0$var$updateArrangementLabelsVisibility(showLabels);
        // Force a render update
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView) renderMultiView();
    });
    // Add brightness control
    document.getElementById("brightness-amount").addEventListener("input", (e)=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount = parseFloat(e.target.value);
        document.getElementById("brightness-amount-value").textContent = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount.toFixed(1);
        $a78b7212404532f0$var$updateBrightness();
    });
    // Add Process button
    const processButton = document.getElementById("process-button");
    processButton.addEventListener("click", $a78b7212404532f0$var$processFile);
    const clearResultsButton = document.getElementById("clear-results-button");
    if (clearResultsButton) clearResultsButton.addEventListener("click", $a78b7212404532f0$var$performInferenceClear);
    const refineButton = document.getElementById("refine-button");
    refineButton.addEventListener("click", $a78b7212404532f0$var$refineArrangement);
    $a78b7212404532f0$var$updateClearButtonFromState();
    $a78b7212404532f0$var$updateArrangementActionButtons();
    // Apply default values
    $a78b7212404532f0$var$updateLighting();
    // Initialize brightness control
    document.getElementById("brightness-amount-value").textContent = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount.toFixed(1);
    $a78b7212404532f0$var$updateBrightness();
    // Add text labels to views
    $a78b7212404532f0$var$addViewLabel((0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement, "Main View");
    $a78b7212404532f0$var$addViewLabel((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement, "Boundary View");
    $a78b7212404532f0$var$addViewLabel((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement, "Simplified Boundary View");
    // Apply correct layout based on default processing mode
    // Since arrangement is the default, hide boundary views initially
    const defaultMode = "arrangement"; // Since we set arrangement as default
    if (defaultMode === "arrangement") {
        // Set up single view layout for arrangement mode
        $a78b7212404532f0$var$hideAllBoundaryViews();
        $a78b7212404532f0$var$hideViewSeparators();
        // Resize main view to full width
        const aspect = window.innerWidth / window.innerHeight;
        $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera, aspect);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.setSize(window.innerWidth, window.innerHeight);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.setSize(window.innerWidth, window.innerHeight);
        // Update postprocessing section visibility
        (0, $ddb3f022a87c2bc1$export$7de7bccc87a83087)();
        $a78b7212404532f0$var$updateModelOptionsSectionVisibility("arrangement");
    } else {
        // Update postprocessing section visibility for other modes
        (0, $ddb3f022a87c2bc1$export$7de7bccc87a83087)();
        const currentMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
        $a78b7212404532f0$var$updateModelOptionsSectionVisibility(currentMode);
    }
    // Add start over button functionality
    const startOverButton = document.getElementById("start-over-button");
    if (startOverButton) startOverButton.addEventListener("click", ()=>{
        $a78b7212404532f0$var$clearAllFilesAndState();
        $a78b7212404532f0$var$hideStartOverAndFeedbackButtons();
        // Ensure left sidebar is expanded for new processing
        const leftSidebar = document.getElementById("left-sidebar");
        if (leftSidebar && leftSidebar.classList.contains("collapsed")) $a78b7212404532f0$var$toggleLeftSidebar();
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Ready for new processing", "check-circle");
    });
    // Setup event listeners for file handling
    window.addEventListener("dragover", $a78b7212404532f0$var$handleDragOver, false);
    window.addEventListener("drop", $a78b7212404532f0$var$handleDrop, false);
    document.getElementById("file-select").addEventListener("change", $a78b7212404532f0$var$handleFileSelect, false);
    // Process button event listener already added above
    // Initialize other UI elements
    window.addEventListener("resize", $a78b7212404532f0$var$onWindowResize, false);
    // Call setupControls function
    $a78b7212404532f0$var$setupControls();
    // Initialize postprocessing controls (async - loads defaults from server)
    (0, $ddb3f022a87c2bc1$export$66e810c40c8a96f8)().catch((error)=>{
        console.error("Failed to initialize postprocessing controls:", error);
    });
    (0, $6ed76de03aae65c4$export$3ed9847792e393b7)().catch((error)=>{
        console.error("Failed to initialize leveling controls:", error);
    });
    // Initialize gingiva estimation checkbox
    $a78b7212404532f0$var$initializeGingivaEstimation();
    // Initialize calculate space/intersection checkbox
    $a78b7212404532f0$var$initializeCalculateSpaceIntersection();
    $a78b7212404532f0$var$initializeAutoOrientation();
    // Update postprocessing section visibility on page load
    // Use setTimeout to ensure all DOM elements are fully initialized
    setTimeout(()=>{
        (0, $ddb3f022a87c2bc1$export$7de7bccc87a83087)();
        const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
        $a78b7212404532f0$var$updateModelOptionsSectionVisibility(processingMode);
        // Double-check after a short delay to ensure visibility is set
        setTimeout(()=>{
            const postprocessingSection = document.getElementById("postprocessing-section");
            if (postprocessingSection && processingMode === "arrangement" && !(0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode) {
                postprocessingSection.style.display = "block";
                postprocessingSection.style.setProperty("display", "block", "important");
            }
        }, 50);
    }, 150);
}
function $a78b7212404532f0$var$handleDragOver(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
}
function $a78b7212404532f0$var$handleDrop(event) {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) $a78b7212404532f0$var$handleFile(file);
}
function $a78b7212404532f0$var$handleFileSelect(event) {
    const file = event.target.files[0];
    if (file) {
        $a78b7212404532f0$var$clearVisualization();
        document.getElementById("process-button").textContent = "Process";
        setTimeout(()=>{
            $a78b7212404532f0$var$handleFile(file);
        }, 200);
    }
}
function $a78b7212404532f0$var$clearVisualization() {
    // Reset other states as needed
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh = null;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryMesh = null;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryMesh = null;
    // Remove existing class labels
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).classLabels.forEach((label)=>(0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(label));
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).classLabels = [];
    // Remove all keypoint objects and labels from scene
    for(let i = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children.length - 1; i >= 0; i--){
        const child = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children[i];
        if (child.name?.startsWith("keypoint-")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(child);
    }
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypoints = {};
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypointLabels = [];
    // Remove arrangement object labels from main scene
    for(let i = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children.length - 1; i >= 0; i--){
        const child = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children[i];
        if (child.isCSS2DObject && child.name?.startsWith("arrangement-label-")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(child);
    }
    // Clear overlay view if it exists
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene) while((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.children.length > 0){
        const child = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.children[0];
        if (child.geometry) child.geometry.dispose();
        if (child.material) {
            if (Array.isArray(child.material)) child.material.forEach((mat)=>mat.dispose());
            else child.material.dispose();
        }
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.remove(child);
    }
    // Remove overlay legend
    const overlayViewElement = document.getElementById("overlay-view");
    if (overlayViewElement) {
        const existingLegend = overlayViewElement.querySelector(".overlay-legend");
        if (existingLegend) existingLegend.remove();
    }
    // Remove boundary points and lines
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryPoints) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryPoints);
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLines) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLines);
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryPoints) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryPoints);
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLines) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLines);
    // Update visualizations
    $a78b7212404532f0$var$updateMeshVisualization();
}
function $a78b7212404532f0$var$clearFile() {
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.getObjectByName("mesh")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.getObjectByName("mesh"));
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.getObjectByName("boundaryMesh")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.getObjectByName("boundaryMesh"));
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.getObjectByName("simplifiedBoundaryMesh")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.getObjectByName("simplifiedBoundaryMesh"));
    // Clear file input
    document.getElementById("file-select").value = "";
    // Clear arrangement file inputs
    const lowerJawFile = document.getElementById("lower-jaw-file");
    const upperJawFile = document.getElementById("upper-jaw-file");
    const infoJsonFile = document.getElementById("info-json-file");
    const landmarksCsvFile = document.getElementById("landmarks-csv-file");
    if (lowerJawFile) lowerJawFile.value = "";
    if (upperJawFile) upperJawFile.value = "";
    if (infoJsonFile) infoJsonFile.value = "";
    if (landmarksCsvFile) landmarksCsvFile.value = "";
    // Clear Azure path inputs
    const singleAzurePath = document.getElementById("azure-path-input");
    const lowerJawAzurePath = document.getElementById("lower-jaw-azure-path");
    const upperJawAzurePath = document.getElementById("upper-jaw-azure-path");
    const infoJsonAzurePath = document.getElementById("info-json-azure-path");
    const landmarksCsvAzurePath = document.getElementById("landmarks-csv-azure-path");
    if (singleAzurePath) singleAzurePath.value = "";
    if (lowerJawAzurePath) lowerJawAzurePath.value = "";
    if (upperJawAzurePath) upperJawAzurePath.value = "";
    if (infoJsonAzurePath) infoJsonAzurePath.value = "";
    if (landmarksCsvAzurePath) landmarksCsvAzurePath.value = "";
    // Clear the Azure folder input and its resolution preview/error
    const arrangementFolderPath = document.getElementById("arrangement-folder-path");
    if (arrangementFolderPath) arrangementFolderPath.value = "";
    const folderResolvePreview = document.getElementById("folder-resolve-preview");
    if (folderResolvePreview) {
        folderResolvePreview.textContent = "";
        folderResolvePreview.style.display = "none";
    }
    const folderResolveError = document.getElementById("folder-resolve-error");
    if (folderResolveError) {
        folderResolveError.textContent = "";
        folderResolveError.style.display = "none";
    }
    const overrideAzurePathsCheckbox = document.getElementById("override-azure-paths-checkbox");
    if (overrideAzurePathsCheckbox) overrideAzurePathsCheckbox.checked = false;
    // Clear file name displays
    const lowerJawFileName = document.getElementById("lower-jaw-file-name");
    const upperJawFileName = document.getElementById("upper-jaw-file-name");
    const infoJsonFileName = document.getElementById("info-json-file-name");
    const landmarksCsvFileName = document.getElementById("landmarks-csv-file-name");
    if (lowerJawFileName) lowerJawFileName.textContent = "";
    if (upperJawFileName) upperJawFileName.textContent = "";
    if (infoJsonFileName) infoJsonFileName.textContent = "";
    if (landmarksCsvFileName) landmarksCsvFileName.textContent = "";
    // Remove jaw toggle controls
    const existingControls = document.getElementById("jaw-toggle-controls");
    if (existingControls) existingControls.remove();
    // Clear arrangement objects from main scene
    const meshesToRemove = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children.filter((child)=>child.isMesh && child.userData && child.userData.originalObject);
    meshesToRemove.forEach((mesh)=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(mesh);
        if (mesh.geometry) mesh.geometry.dispose();
        if (mesh.material) {
            if (Array.isArray(mesh.material)) mesh.material.forEach((mat)=>mat.dispose());
            else mesh.material.dispose();
        }
    });
    $a78b7212404532f0$var$clearVisualization();
    // Clear multi-view if active
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView) {
        // Reset multi-view container visibility
        document.getElementById("multi-view-container").style.display = "none";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "block";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "block";
        // Clear all scenes
        Object.keys((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes).forEach((view)=>{
            if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view]) // Keep only lights by removing other objects
            for(let i = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].children.length - 1; i >= 0; i--){
                const obj = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].children[i];
                if (!(obj instanceof $0d79572b4b22d35c$export$6ecadb6ed240d696)) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].remove(obj);
            }
        });
        // Reset multi-view container and turn off multi-view rendering
        $a78b7212404532f0$var$resetMultiViewContainer();
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView = false;
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLayoutInitialized = false;
    }
    // Also check for arrangement multi-view (when multi-view container is visible)
    const multiViewContainer = document.getElementById("multi-view-container");
    if (multiViewContainer && multiViewContainer.style.display !== "none") {
        $a78b7212404532f0$var$resetMultiViewContainer();
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "block";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "block";
        // Clear multi-view scenes for arrangement
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes) Object.keys((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes).forEach((view)=>{
            if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view]) // Keep only lights by removing other objects
            for(let i = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].children.length - 1; i >= 0; i--){
                const obj = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].children[i];
                if (!(obj instanceof $0d79572b4b22d35c$export$6ecadb6ed240d696)) {
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].remove(obj);
                    // Dispose of geometry and materials
                    if (obj.geometry) obj.geometry.dispose();
                    if (obj.material) {
                        if (Array.isArray(obj.material)) obj.material.forEach((mat)=>mat.dispose());
                        else obj.material.dispose();
                    }
                }
            }
        });
    }
    // Reset separation phase and data regardless of whether multi-view was active
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase = 0;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData = {
        originalMesh: null,
        segmentedMesh: null,
        analyzedTeeth: null,
        finalResult: null,
        reconstructionResult: null
    };
    // Clear last inference result
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult = null;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson = null;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).displacementTable = null;
    (0, $6ed76de03aae65c4$export$c160e09b4f5ff496)(null);
    // Hide the next phase button
    const nextPhaseButton = document.getElementById("next-phase-button");
    if (nextPhaseButton) nextPhaseButton.style.display = "none";
    // Hide the download InfoJSON button
    $a78b7212404532f0$var$hideInfoJsonActions();
    // Hide displacement table button
    const displacementTableButton = document.getElementById("displacement-table-button");
    if (displacementTableButton) displacementTableButton.style.display = "none";
    // Hide download buttons from teeth reconstruction
    const downloadButtonsContainer = document.getElementById("download-buttons-container");
    if (downloadButtonsContainer) downloadButtonsContainer.style.display = "none";
    // Hide start over button and feedback button
    $a78b7212404532f0$var$hideStartOverAndFeedbackButtons();
    (0, $aa8a35ff0d89d373$export$325c923fa31af59e)();
    // Re-enable all input fields for next inference
    $a78b7212404532f0$var$enableAllInputs();
    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("File cleared", "check-circle");
    document.getElementById("process-button").textContent = "Process";
    $a78b7212404532f0$var$updateClearButtonFromState();
    $a78b7212404532f0$var$updateArrangementActionButtons();
}
async function $a78b7212404532f0$var$handleFile(file) {
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).loadingFile) return;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).loadingFile = true;
    const fileExtension = file.name.split(".").pop().toLowerCase();
    let geometry;
    let tmpMesh;
    try {
        if (fileExtension === "obj") tmpMesh = await (0, $b28963ea5393104c$export$8b4e6220de066d27)(file);
        else if (fileExtension === "stl") tmpMesh = await (0, $b28963ea5393104c$export$10855d30050361d4)(file);
        else throw new Error("Unsupported file format");
    } catch (error) {
        console.error("Error loading file:", error.message);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Failed to load file: ${error.message}`, "error");
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).loadingFile = false;
        $a78b7212404532f0$var$clearFile();
        return;
    }
    if (!tmpMesh) throw new Error("Failed to load mesh");
    geometry = tmpMesh.geometry;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, new $0d79572b4b22d35c$export$f2980790215acccd({
        side: $0d79572b4b22d35c$export$3b296b6f144d5b03,
        vertexColors: true,
        metalness: 0.3,
        roughness: 0.5
    }));
    // Create boundary mesh
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryMesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, new $0d79572b4b22d35c$export$f2980790215acccd({
        side: $0d79572b4b22d35c$export$3b296b6f144d5b03,
        color: 0xffffff,
        metalness: 0.3,
        roughness: 0.5,
        opacity: 0.95,
        transparent: true
    }));
    // Create simplified boundary mesh
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryMesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, new $0d79572b4b22d35c$export$f2980790215acccd({
        side: $0d79572b4b22d35c$export$3b296b6f144d5b03,
        color: 0xffffff,
        metalness: 0.3,
        roughness: 0.5,
        opacity: 0.95,
        transparent: true
    }));
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.getObjectByName("mesh")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.getObjectByName("mesh"));
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.name = "mesh";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh);
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.getObjectByName("boundaryMesh")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.getObjectByName("boundaryMesh"));
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryMesh.name = "boundaryMesh";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryMesh);
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.getObjectByName("simplifiedBoundaryMesh")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.getObjectByName("simplifiedBoundaryMesh"));
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryMesh.name = "simplifiedBoundaryMesh";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryMesh);
    // Initialize color attribute if not present
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry.attributes.color) {
        const colors = new Float32Array((0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry.attributes.position.count * 3);
        colors.fill(1);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry.setAttribute("color", new $0d79572b4b22d35c$export$8dea267bd6bde117(colors, 3));
    }
    $a78b7212404532f0$var$updateMeshVisualization();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).loadingFile = false;
}
/**
 * Disable all input fields after successful inference
 */ function $a78b7212404532f0$var$disableAllInputs() {
    // Disable all file input groups by adding disabled class
    const fileInputGroups = document.querySelectorAll(".file-input-group");
    fileInputGroups.forEach((group)=>{
        group.classList.add("disabled");
    });
    // Disable file inputs
    const fileSelect = document.getElementById("file-select");
    const lowerJawFile = document.getElementById("lower-jaw-file");
    const upperJawFile = document.getElementById("upper-jaw-file");
    const infoJsonFile = document.getElementById("info-json-file");
    if (fileSelect) {
        fileSelect.disabled = true;
        const parentGroup = fileSelect.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.add("disabled");
    }
    if (lowerJawFile) {
        lowerJawFile.disabled = true;
        const parentGroup = lowerJawFile.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.add("disabled");
    }
    if (upperJawFile) {
        upperJawFile.disabled = true;
        const parentGroup = upperJawFile.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.add("disabled");
    }
    if (infoJsonFile) {
        infoJsonFile.disabled = true;
        const parentGroup = infoJsonFile.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.add("disabled");
    }
    // Disable Azure path inputs
    const singleAzurePath = document.getElementById("azure-path-input");
    const lowerJawAzurePath = document.getElementById("lower-jaw-azure-path");
    const upperJawAzurePath = document.getElementById("upper-jaw-azure-path");
    const infoJsonAzurePath = document.getElementById("info-json-azure-path");
    if (singleAzurePath) {
        singleAzurePath.disabled = true;
        const parentGroup = singleAzurePath.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.add("disabled");
    }
    if (lowerJawAzurePath) {
        lowerJawAzurePath.disabled = true;
        const parentGroup = lowerJawAzurePath.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.add("disabled");
    }
    if (upperJawAzurePath) {
        upperJawAzurePath.disabled = true;
        const parentGroup = upperJawAzurePath.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.add("disabled");
    }
    if (infoJsonAzurePath) {
        infoJsonAzurePath.disabled = true;
        const parentGroup = infoJsonAzurePath.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.add("disabled");
    }
    // Disable the Azure folder input and its resolve button
    const arrangementFolderPath = document.getElementById("arrangement-folder-path");
    if (arrangementFolderPath) {
        arrangementFolderPath.disabled = true;
        const parentGroup = arrangementFolderPath.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.add("disabled");
    }
    const resolveFolderBtn = document.getElementById("resolve-folder-btn");
    if (resolveFolderBtn) resolveFolderBtn.disabled = true;
    const overrideAzurePathsCheckbox = document.getElementById("override-azure-paths-checkbox");
    if (overrideAzurePathsCheckbox) overrideAzurePathsCheckbox.disabled = true;
    // Disable processing mode dropdown
    const processingModeDropdown = document.getElementById("processing-mode-dropdown");
    if (processingModeDropdown) {
        processingModeDropdown.disabled = true;
        processingModeDropdown.style.opacity = "0.5";
        processingModeDropdown.style.cursor = "not-allowed";
    }
    // Disable input mode toggle buttons
    const inputModeToggle = document.getElementById("input-mode-toggle");
    if (inputModeToggle) {
        inputModeToggle.classList.add("disabled");
        const toggleButtons = inputModeToggle.querySelectorAll(".toggle-option");
        toggleButtons.forEach((btn)=>{
            btn.style.pointerEvents = "none";
            btn.style.opacity = "0.5";
            btn.style.cursor = "not-allowed";
        });
    }
    // Disable jaw selection buttons
    const jawSelectionOptions = document.getElementById("jaw-selection-options");
    if (jawSelectionOptions) {
        jawSelectionOptions.classList.add("disabled");
        const jawSelectionButtons = jawSelectionOptions.querySelectorAll(".jaw-button");
        jawSelectionButtons.forEach((btn)=>{
            btn.disabled = true;
            btn.style.opacity = "0.5";
            btn.style.cursor = "not-allowed";
            btn.style.pointerEvents = "none";
        });
    }
}
/**
 * Enable all input fields when clearing to prepare for new inference
 */ function $a78b7212404532f0$var$enableAllInputs() {
    // Remove disabled class from all file input groups
    const fileInputGroups = document.querySelectorAll(".file-input-group");
    fileInputGroups.forEach((group)=>{
        group.classList.remove("disabled");
    });
    // Enable file inputs
    const fileSelect = document.getElementById("file-select");
    const lowerJawFile = document.getElementById("lower-jaw-file");
    const upperJawFile = document.getElementById("upper-jaw-file");
    const infoJsonFile = document.getElementById("info-json-file");
    if (fileSelect) {
        fileSelect.disabled = false;
        const parentGroup = fileSelect.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.remove("disabled");
    }
    if (lowerJawFile) {
        lowerJawFile.disabled = false;
        const parentGroup = lowerJawFile.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.remove("disabled");
    }
    if (upperJawFile) {
        upperJawFile.disabled = false;
        const parentGroup = upperJawFile.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.remove("disabled");
    }
    if (infoJsonFile) {
        infoJsonFile.disabled = false;
        const parentGroup = infoJsonFile.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.remove("disabled");
    }
    // Enable Azure path inputs
    const singleAzurePath = document.getElementById("azure-path-input");
    const lowerJawAzurePath = document.getElementById("lower-jaw-azure-path");
    const upperJawAzurePath = document.getElementById("upper-jaw-azure-path");
    const infoJsonAzurePath = document.getElementById("info-json-azure-path");
    if (singleAzurePath) {
        singleAzurePath.disabled = false;
        const parentGroup = singleAzurePath.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.remove("disabled");
    }
    if (lowerJawAzurePath) {
        lowerJawAzurePath.disabled = false;
        const parentGroup = lowerJawAzurePath.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.remove("disabled");
    }
    if (upperJawAzurePath) {
        upperJawAzurePath.disabled = false;
        const parentGroup = upperJawAzurePath.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.remove("disabled");
    }
    if (infoJsonAzurePath) {
        infoJsonAzurePath.disabled = false;
        const parentGroup = infoJsonAzurePath.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.remove("disabled");
    }
    // Enable the Azure folder input and its resolve button
    const arrangementFolderPath = document.getElementById("arrangement-folder-path");
    if (arrangementFolderPath) {
        arrangementFolderPath.disabled = false;
        const parentGroup = arrangementFolderPath.closest(".file-input-group");
        if (parentGroup) parentGroup.classList.remove("disabled");
    }
    const resolveFolderBtn = document.getElementById("resolve-folder-btn");
    if (resolveFolderBtn) resolveFolderBtn.disabled = false;
    const overrideAzurePathsCheckbox = document.getElementById("override-azure-paths-checkbox");
    if (overrideAzurePathsCheckbox) overrideAzurePathsCheckbox.disabled = false;
    // Enable processing mode dropdown
    const processingModeDropdown = document.getElementById("processing-mode-dropdown");
    if (processingModeDropdown) {
        processingModeDropdown.disabled = false;
        processingModeDropdown.style.opacity = "1";
        processingModeDropdown.style.cursor = "pointer";
    }
    // Enable input mode toggle buttons
    const inputModeToggle = document.getElementById("input-mode-toggle");
    if (inputModeToggle) {
        inputModeToggle.classList.remove("disabled");
        const toggleButtons = inputModeToggle.querySelectorAll(".toggle-option");
        toggleButtons.forEach((btn)=>{
            btn.style.pointerEvents = "auto";
            btn.style.opacity = "1";
            btn.style.cursor = "pointer";
        });
    }
    // Enable jaw selection buttons
    const jawSelectionOptions = document.getElementById("jaw-selection-options");
    if (jawSelectionOptions) {
        jawSelectionOptions.classList.remove("disabled");
        const jawSelectionButtons = jawSelectionOptions.querySelectorAll(".jaw-button");
        jawSelectionButtons.forEach((btn)=>{
            btn.disabled = false;
            btn.style.opacity = "1";
            btn.style.cursor = "pointer";
            btn.style.pointerEvents = "auto";
        });
    }
}
/**
 * Reset the process button to its default state
 */ function $a78b7212404532f0$var$resetProcessButton() {
    const processButton = document.getElementById("process-button");
    const processingIndicator = document.getElementById("processing-indicator");
    processButton.textContent = "Process";
    processButton.disabled = false;
    processingIndicator.style.display = "none";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingFile = false;
    $a78b7212404532f0$var$updateClearButtonFromState();
    $a78b7212404532f0$var$updateArrangementActionButtons();
}
/**
 * Enable Clear when there is something to reset; disable while a task is running.
 */ function $a78b7212404532f0$var$updateClearButtonFromState() {
    const btn = document.getElementById("clear-results-button");
    if (!btn) return;
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingFile) {
        btn.disabled = true;
        return;
    }
    const hasResults = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult != null || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson != null || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).displacementTable != null || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypoints && Object.keys((0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypoints).length > 0 || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase > 0 || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData && ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.segmentedMesh != null || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.finalResult != null || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.analyzedTeeth != null);
    btn.disabled = !hasResults;
}
function $a78b7212404532f0$var$performInferenceClear() {
    const btn = document.getElementById("clear-results-button");
    if (!btn || btn.disabled) return;
    $a78b7212404532f0$var$clearFile();
}
function $a78b7212404532f0$var$updateArrangementActionButtons() {
    const processButton = document.getElementById("process-button");
    const refineButton = document.getElementById("refine-button");
    const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
    const hasArrangementResult = Boolean((0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson);
    const showRefine = processingMode === "arrangement" && !(0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode && hasArrangementResult;
    if (processButton && processingMode === "arrangement" && !(0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingFile) {
        if (processButton.textContent !== "Processing...") processButton.textContent = "Process";
    }
    if (refineButton) {
        refineButton.style.display = showRefine ? "block" : "none";
        refineButton.disabled = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingFile || !showRefine;
    }
}
function $a78b7212404532f0$var$collectArrangementInputs() {
    if ($a78b7212404532f0$var$isAzureInputMode()) {
        const lowerJawAzurePath = document.getElementById("lower-jaw-azure-path").value.trim();
        const upperJawAzurePath = document.getElementById("upper-jaw-azure-path").value.trim();
        const infoJsonPath = document.getElementById("info-json-azure-path").value.trim();
        const landmarksCsvPath = document.getElementById("landmarks-csv-azure-path").value.trim();
        if (!lowerJawAzurePath || !upperJawAzurePath) return {
            error: "Please provide both lower and upper jaw Azure paths for arrangement"
        };
        if ($a78b7212404532f0$var$requireAllArrangementFiles && (!infoJsonPath || !landmarksCsvPath)) return {
            error: "Please provide all four Azure paths for arrangement (lower jaw, upper jaw, InfoJSON, landmarks CSV)"
        };
        if ($a78b7212404532f0$var$enforcePatientIdMatch) {
            const idError = (0, $0f1e8af8606ec915$export$f17070002f5b84d7)([
                {
                    label: "Lower jaw",
                    name: lowerJawAzurePath
                },
                {
                    label: "Upper jaw",
                    name: upperJawAzurePath
                },
                {
                    label: "InfoJSON",
                    name: infoJsonPath
                },
                {
                    label: "Landmarks CSV",
                    name: landmarksCsvPath
                }
            ]);
            const blockingError = $a78b7212404532f0$var$resolvePatientIdCheckError(idError);
            if (blockingError) return blockingError;
        }
        return {
            file: null,
            pairedFile: null,
            azurePath: lowerJawAzurePath,
            pairedAzurePath: upperJawAzurePath,
            infoJsonFile: null,
            infoJsonAzurePath: infoJsonPath || null,
            landmarksCsvFile: null,
            landmarksCsvAzurePath: landmarksCsvPath || null
        };
    }
    const lowerJawFile = document.getElementById("lower-jaw-file").files[0];
    const upperJawFile = document.getElementById("upper-jaw-file").files[0];
    const infoJsonFile = document.getElementById("info-json-file").files[0];
    const landmarksCsvFile = document.getElementById("landmarks-csv-file").files[0];
    if (!lowerJawFile || !upperJawFile) return {
        error: "Please select both lower and upper jaw files for arrangement"
    };
    if ($a78b7212404532f0$var$requireAllArrangementFiles && (!infoJsonFile || !landmarksCsvFile)) return {
        error: "Please select all four files for arrangement (lower jaw, upper jaw, InfoJSON, landmarks CSV)"
    };
    if (!lowerJawFile.name.toLowerCase().endsWith(".obj")) return {
        error: "Lower jaw file must be a .obj file"
    };
    if (!upperJawFile.name.toLowerCase().endsWith(".obj")) return {
        error: "Upper jaw file must be a .obj file"
    };
    if (infoJsonFile && !infoJsonFile.name.toLowerCase().endsWith(".json")) return {
        error: "InfoJSON file must be a .json file"
    };
    if (landmarksCsvFile && !landmarksCsvFile.name.toLowerCase().endsWith(".csv")) return {
        error: "Landmarks CSV file must be a .csv file"
    };
    if ($a78b7212404532f0$var$enforcePatientIdMatch) {
        const idError = (0, $0f1e8af8606ec915$export$f17070002f5b84d7)([
            {
                label: "Lower jaw",
                name: lowerJawFile.name
            },
            {
                label: "Upper jaw",
                name: upperJawFile.name
            },
            {
                label: "InfoJSON",
                name: infoJsonFile ? infoJsonFile.name : ""
            },
            {
                label: "Landmarks CSV",
                name: landmarksCsvFile ? landmarksCsvFile.name : ""
            }
        ]);
        const blockingError = $a78b7212404532f0$var$resolvePatientIdCheckError(idError);
        if (blockingError) return blockingError;
    }
    return {
        file: lowerJawFile,
        pairedFile: upperJawFile,
        azurePath: null,
        pairedAzurePath: null,
        infoJsonFile: infoJsonFile || null,
        infoJsonAzurePath: null,
        landmarksCsvFile: landmarksCsvFile || null,
        landmarksCsvAzurePath: null
    };
}
function $a78b7212404532f0$var$collectArrangementModelOptions() {
    const enableGingivaEstimation = document.getElementById("enable-gingiva-estimation-checkbox")?.checked ?? true;
    // When the toggle is hidden (production), the computation always runs
    // regardless of the (hidden) checkbox state.
    const calculateSpaceIntersection = !$a78b7212404532f0$var$spaceIntersectionToggleEnabled || document.getElementById("calculate-space-intersection-checkbox")?.checked !== false;
    return {
        enable_gingiva_estimation: enableGingivaEstimation,
        calculate_space_intersection: calculateSpaceIntersection
    };
}
function $a78b7212404532f0$var$handleArrangementWarnings(uploadResponse) {
    if (uploadResponse.warnings) {
        if (uploadResponse.warnings.main_file) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(uploadResponse.warnings.main_file, "exclamation-triangle", 5000);
        if (uploadResponse.warnings.paired_file) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(uploadResponse.warnings.paired_file, "exclamation-triangle", 5000);
    } else if (uploadResponse.warning) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(uploadResponse.warning, "exclamation-triangle", 5000);
}
async function $a78b7212404532f0$var$refineArrangement() {
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingFile) return;
    const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
    if (processingMode !== "arrangement") return;
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson) {
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Process arrangement first before running Refine", "exclamation-triangle");
        return;
    }
    const postprocessingData = (0, $ddb3f022a87c2bc1$export$9e22e8760fcefed2)();
    const levelingData = (0, $6ed76de03aae65c4$export$542a408f12c51875)();
    if (!postprocessingData.enabled && !levelingData.enabled) {
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Enable Interproximal and/or Leveling refinement to run Refine", "exclamation-triangle");
        return;
    }
    const arrangementInputs = $a78b7212404532f0$var$collectArrangementInputs();
    if (arrangementInputs.error) {
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(arrangementInputs.error, "exclamation-triangle");
        return;
    }
    const processButton = document.getElementById("process-button");
    const refineButton = document.getElementById("refine-button");
    const processingIndicator = document.getElementById("processing-indicator");
    const leftSidebar = document.getElementById("left-sidebar");
    if (leftSidebar && !leftSidebar.classList.contains("collapsed")) $a78b7212404532f0$var$toggleLeftSidebar();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingFile = true;
    processingIndicator.style.display = "block";
    (0, $b3301d11178af01b$export$55220155eeb8e52c)(0);
    document.querySelector("#processing-indicator .progress-task").textContent = "Refining ARRANGEMENT...";
    processButton.disabled = true;
    refineButton.disabled = true;
    const clearResultsButtonRefine = document.getElementById("clear-results-button");
    if (clearResultsButtonRefine) clearResultsButtonRefine.disabled = true;
    let refineSucceeded = false;
    try {
        const baseOptions = $a78b7212404532f0$var$collectArrangementModelOptions();
        const fileSize = arrangementInputs.file ? arrangementInputs.file.size : 1000000;
        const estimatedTime = (0, $b3301d11178af01b$export$c24606b8d46faa72)(fileSize, "arrangement");
        (0, $b3301d11178af01b$export$55220155eeb8e52c)(5, estimatedTime);
        const startTime = Date.now();
        let currentInfoJson = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson;
        let lastDecodedResult = null;
        let achievedOverbite = null;
        if (levelingData.enabled) {
            const levelOptions = {
                ...baseOptions,
                leveling: levelingData.parameters
            };
            // Leveling must honour the freeze list even when the postprocessing
            // checkbox is off: the freeze table lives inside the postprocessing
            // group, but /level consumes only fixed_teeth from that section (the
            // server enables validation whenever a postprocessing section is
            // present, independent of the checkbox). When postprocessing is on,
            // forward its full parameters; otherwise forward just the freeze list
            // so frozen teeth are still held during leveling instead of moving.
            if (postprocessingData.parameters) levelOptions.postprocessing = postprocessingData.parameters;
            else {
                const frozenTeeth = (0, $ddb3f022a87c2bc1$export$f0bf5b8c7f675d0)();
                if (frozenTeeth.length > 0) levelOptions.postprocessing = {
                    fixed_teeth: frozenTeeth
                };
            }
            const infoJsonBlob = new File([
                JSON.stringify(currentInfoJson, null, 2)
            ], "arrangement_info.json", {
                type: "application/json"
            });
            const uploadResponse = await (0, $913d3a1574de567c$export$ae14c375fc93363).uploadForArrangementLevel(arrangementInputs.file, arrangementInputs.azurePath, arrangementInputs.pairedFile, arrangementInputs.pairedAzurePath, infoJsonBlob, arrangementInputs.landmarksCsvFile, arrangementInputs.landmarksCsvAzurePath, levelOptions);
            $a78b7212404532f0$var$handleArrangementWarnings(uploadResponse);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastProcessedItemId = uploadResponse.item_id;
            lastDecodedResult = await (0, $913d3a1574de567c$export$ae14c375fc93363).pollUntilCompletion(uploadResponse.item_id, (0, $b3301d11178af01b$export$55220155eeb8e52c), estimatedTime, startTime);
            currentInfoJson = lastDecodedResult?.arrangement_result?.info_json || currentInfoJson;
            // Capture achieved overbite from the level step before a
            // subsequent postprocessing step overwrites lastDecodedResult.
            achievedOverbite = lastDecodedResult?.arrangement_result?.leveling_stats?.leveling_targets?.achieved_overbite ?? achievedOverbite;
        }
        if (postprocessingData.enabled) {
            const refineOptions = {
                ...baseOptions,
                postprocessing: postprocessingData.parameters
            };
            const infoJsonBlob = new File([
                JSON.stringify(currentInfoJson, null, 2)
            ], "arrangement_info.json", {
                type: "application/json"
            });
            const uploadResponse = await (0, $913d3a1574de567c$export$ae14c375fc93363).uploadForArrangementRefine(arrangementInputs.file, arrangementInputs.azurePath, arrangementInputs.pairedFile, arrangementInputs.pairedAzurePath, infoJsonBlob, arrangementInputs.landmarksCsvFile, arrangementInputs.landmarksCsvAzurePath, refineOptions);
            $a78b7212404532f0$var$handleArrangementWarnings(uploadResponse);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastProcessedItemId = uploadResponse.item_id;
            lastDecodedResult = await (0, $913d3a1574de567c$export$ae14c375fc93363).pollUntilCompletion(uploadResponse.item_id, (0, $b3301d11178af01b$export$55220155eeb8e52c), estimatedTime, startTime);
        }
        if (!lastDecodedResult) throw new Error("No refinement step produced a result");
        await $a78b7212404532f0$var$displayArrangementResults(lastDecodedResult.arrangement_result);
        // Prefer the value captured from the level step; fall back to the
        // final result in case only postprocessing ran.
        (0, $6ed76de03aae65c4$export$c160e09b4f5ff496)(achievedOverbite ?? lastDecodedResult.arrangement_result?.leveling_stats?.leveling_targets?.achieved_overbite);
        await new Promise((resolve)=>setTimeout(resolve, 750));
        processingIndicator.style.display = "none";
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Refinement completed", "check-circle");
        $a78b7212404532f0$var$showStartOverAndFeedbackButtons();
        $a78b7212404532f0$var$updateStartOverButtonVisibility();
        refineSucceeded = true;
    } catch (error) {
        console.error("Error during arrangement refinement:", error);
        const errorMessage = error.message || error.response?.data?.detail || "Error during arrangement refinement";
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(errorMessage, "exclamation-triangle");
        processingIndicator.style.display = "none";
    } finally{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingFile = false;
        processButton.disabled = false;
        if (refineSucceeded) $a78b7212404532f0$var$disableAllInputs();
        $a78b7212404532f0$var$updateClearButtonFromState();
        $a78b7212404532f0$var$updateArrangementActionButtons();
    }
}
async function $a78b7212404532f0$var$processFile() {
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingFile) return;
    // Get processing mode early to check if mesh is required
    const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
    // For arrangement mode, we don't need a pre-loaded mesh
    if (processingMode !== "arrangement" && !(0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh) return;
    const processButton = document.getElementById("process-button");
    // Collapse left sidebar at the start of processing to maximize viewer space
    const leftSidebar = document.getElementById("left-sidebar");
    if (leftSidebar && !leftSidebar.classList.contains("collapsed")) $a78b7212404532f0$var$toggleLeftSidebar();
    // Hide the download InfoJSON button during processing
    $a78b7212404532f0$var$hideInfoJsonActions();
    const processingIndicator = document.getElementById("processing-indicator");
    processingIndicator.style.display = "block";
    // Reset progress bar
    (0, $b3301d11178af01b$export$55220155eeb8e52c)(0);
    processButton.textContent = "Processing...";
    processButton.disabled = true;
    const refineButton = document.getElementById("refine-button");
    if (refineButton) refineButton.disabled = true;
    const clearResultsButton = document.getElementById("clear-results-button");
    if (clearResultsButton) clearResultsButton.disabled = true;
    // Disable keypoint labels checkbox during processing
    $a78b7212404532f0$var$disableKeypointLabelsCheckbox();
    // Disable arrangement labels checkbox during processing
    $a78b7212404532f0$var$disableArrangementLabelsCheckbox();
    let processSucceeded = false;
    try {
        let file, pairedFile, jawSelection, azurePath, pairedAzurePath;
        // Get current input mode
        const inputMode = $a78b7212404532f0$var$getInputMode();
        let infoJsonFile, infoJsonAzurePath;
        let landmarksCsvFile, landmarksCsvAzurePath;
        if (processingMode === "arrangement") {
            const arrangementInputs = $a78b7212404532f0$var$collectArrangementInputs();
            if (arrangementInputs.error) {
                (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(arrangementInputs.error, "exclamation-triangle");
                $a78b7212404532f0$var$resetProcessButton();
                return;
            }
            // Freeze is a postprocessing control. With postprocessing off the
            // frozen-teeth table (which persists in localStorage and is hidden
            // with the collapsed controls) would be silently dropped - ML fully
            // re-arranges the "frozen" teeth and returns 200. Block here instead,
            // mirroring the server's 400 for fixed_teeth without postprocessing.
            // Read the checkbox and the raw table directly (not
            // collectPostprocessingParameters/collectFixedTeeth) so this gate
            // does not re-run the toast-raising collectors; validation and the
            // per-FDI toasts happen once, later, at the real collection. Count
            // only valid permanent-tooth FDIs, so a stray invalid row does not
            // trip the gate (it would be dropped at collection regardless).
            const postprocessingEnabled = document.getElementById("enable-postprocessing-checkbox")?.checked;
            const hasFrozenTeeth = (0, $ddb3f022a87c2bc1$export$166b6ebc095f584e)().some((0, $ddb3f022a87c2bc1$export$8b14b38614a79e7e));
            if (!postprocessingEnabled && hasFrozenTeeth) {
                (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Frozen teeth require Enable Postprocessing. Enable it or clear the frozen-teeth list before running arrangement.", "exclamation-triangle");
                $a78b7212404532f0$var$resetProcessButton();
                return;
            }
            file = arrangementInputs.file;
            pairedFile = arrangementInputs.pairedFile;
            azurePath = arrangementInputs.azurePath;
            pairedAzurePath = arrangementInputs.pairedAzurePath;
            infoJsonFile = arrangementInputs.infoJsonFile;
            infoJsonAzurePath = arrangementInputs.infoJsonAzurePath;
            landmarksCsvFile = arrangementInputs.landmarksCsvFile;
            landmarksCsvAzurePath = arrangementInputs.landmarksCsvAzurePath;
            jawSelection = null; // Not needed for arrangement
        } else {
            if (inputMode === "azure") {
                // Single Azure path for other modes
                azurePath = document.getElementById("azure-path-input").value.trim();
                if (!azurePath) {
                    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Please provide an Azure path", "exclamation-triangle");
                    $a78b7212404532f0$var$resetProcessButton();
                    return;
                }
                file = null;
            } else {
                // Single file for other modes
                file = document.getElementById("file-select").files[0];
                azurePath = null;
                if (!file) {
                    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Please select a file", "exclamation-triangle");
                    $a78b7212404532f0$var$resetProcessButton();
                    return;
                }
            }
            jawSelection = $a78b7212404532f0$var$getJawSelection();
        }
        // Special handling for teeth separation mode
        if (processingMode === "teethseparation") {
            // Store the original mesh for later use
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.originalMesh = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.clone();
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase = 1; // Mark that we're in the segmentation phase
            // Continue with standard teeth segmentation as the first step
            // For Azure mode, file will be null, so use a default size for estimation
            const fileSize = file ? file.size : 1000000; // Default 1MB for Azure mode
            const estimatedTime = (0, $b3301d11178af01b$export$c24606b8d46faa72)(fileSize, "teethml");
            (0, $b3301d11178af01b$export$55220155eeb8e52c)(5, estimatedTime);
            // Record start time
            const startTime = Date.now();
            // Use the ApiService to upload the file
            const uploadResponse = await (0, $913d3a1574de567c$export$ae14c375fc93363).uploadForProcessing(file, azurePath, "teethml", jawSelection, $a78b7212404532f0$var$isAutoOrientationEnabled());
            // Show warning if present
            if (uploadResponse.warning) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(uploadResponse.warning, "exclamation-triangle", 5000);
            const itemId = uploadResponse.item_id;
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastProcessedItemId = itemId;
            // Update task label
            document.querySelector("#processing-indicator .progress-task").textContent = "Processing Teeth Segmentation...";
            // Poll for status until completed using the ApiService
            const decodedResult = await (0, $913d3a1574de567c$export$ae14c375fc93363).pollUntilCompletion(itemId, (0, $b3301d11178af01b$export$55220155eeb8e52c), estimatedTime, startTime);
            // Record processing time
            const processingTimeInSeconds = (Date.now() - startTime) / 1000;
            (0, $b3301d11178af01b$export$86065947754e0d0f)["teethml"].push({
                timeInSeconds: processingTimeInSeconds
            });
            // Keep only the last 5 entries for each model type
            if ((0, $b3301d11178af01b$export$86065947754e0d0f)["teethml"].length > 5) (0, $b3301d11178af01b$export$86065947754e0d0f)["teethml"].shift();
            // Apply segmentation colors
            $a78b7212404532f0$var$applyInferenceColors(decodedResult);
            // Short delay to show 100% completion before hiding
            await new Promise((resolve)=>setTimeout(resolve, 750));
            // Hide processing indicator
            processingIndicator.style.display = "none";
            // Show the "next phase" button
            const nextPhaseButton = document.getElementById("next-phase-button");
            nextPhaseButton.style.display = "block";
            nextPhaseButton.textContent = "Continue to Separation";
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Segmentation completed. Click 'Continue' to proceed.", "check-circle");
            // Show start over button if sidebar is collapsed
            $a78b7212404532f0$var$showStartOverAndFeedbackButtons();
            $a78b7212404532f0$var$updateStartOverButtonVisibility();
            processSucceeded = true;
        } else {
            // Standard processing for other modes
            // Estimate processing time based on file size and model
            // For Azure mode, file will be null, so use a default size for estimation
            const fileSize = file ? file.size : 1000000; // Default 1MB for Azure mode
            const estimatedTime = (0, $b3301d11178af01b$export$c24606b8d46faa72)(fileSize, processingMode);
            (0, $b3301d11178af01b$export$55220155eeb8e52c)(5, estimatedTime);
            // Record start time
            const startTime = Date.now();
            // Update task label
            document.querySelector("#processing-indicator .progress-task").textContent = `Processing ${processingMode.toUpperCase()}...`;
            let uploadResponse, itemId;
            if (processingMode === "arrangement") {
                const options = $a78b7212404532f0$var$collectArrangementModelOptions();
                const postprocessingData = (0, $ddb3f022a87c2bc1$export$9e22e8760fcefed2)();
                if (postprocessingData.enabled && postprocessingData.parameters) options.postprocessing = {
                    ...postprocessingData.parameters
                };
                const levelingData = (0, $6ed76de03aae65c4$export$542a408f12c51875)();
                if (levelingData.enabled && levelingData.parameters) options.leveling = {
                    ...levelingData.parameters
                };
                // For arrangement, use the special upload method with both files.
                // When Enable Postprocessing is checked, ML inference runs and refinement
                // (ArrangementRefiner) runs in the same worker task; otherwise inference only.
                // When Leveling refinement is checked, LevelingRefiner runs between ML
                // inference and ArrangementRefiner inside the same worker task.
                uploadResponse = await (0, $913d3a1574de567c$export$ae14c375fc93363).uploadForArrangement(file, azurePath, pairedFile, pairedAzurePath, infoJsonFile, infoJsonAzurePath, landmarksCsvFile, landmarksCsvAzurePath, options, postprocessingData.enabled, levelingData.enabled);
                $a78b7212404532f0$var$handleArrangementWarnings(uploadResponse);
                itemId = uploadResponse.item_id;
            } else {
                // Use the standard upload method for other modes
                uploadResponse = await (0, $913d3a1574de567c$export$ae14c375fc93363).uploadForProcessing(file, azurePath, processingMode, jawSelection, $a78b7212404532f0$var$isAutoOrientationEnabled());
                // Log upload response for debugging
                console.log("Upload response received:", uploadResponse);
                // Show warning if present
                if (uploadResponse && uploadResponse.warning) {
                    console.log("Showing warning toast:", uploadResponse.warning);
                    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(uploadResponse.warning, "exclamation-triangle", 5000);
                } else console.log("No warning in upload response");
                itemId = uploadResponse.item_id;
            }
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastProcessedItemId = itemId;
            // Poll for status until completed using the ApiService
            const decodedResult = await (0, $913d3a1574de567c$export$ae14c375fc93363).pollUntilCompletion(itemId, (0, $b3301d11178af01b$export$55220155eeb8e52c), estimatedTime, startTime);
            // Record processing time
            const processingTimeInSeconds = (Date.now() - startTime) / 1000;
            (0, $b3301d11178af01b$export$86065947754e0d0f)[processingMode].push({
                timeInSeconds: processingTimeInSeconds
            });
            // Keep only the last 5 entries for each model type
            if ((0, $b3301d11178af01b$export$86065947754e0d0f)[processingMode].length > 5) (0, $b3301d11178af01b$export$86065947754e0d0f)[processingMode].shift();
            // Process results based on the mode
            if (processingMode === "keypointml") {
                $a78b7212404532f0$var$addKeypoints(decodedResult.keypoints);
                // Enable keypoint labels checkbox for keypoint detection mode
                $a78b7212404532f0$var$enableKeypointLabelsCheckbox();
                // Disable arrangement labels checkbox (not used in keypoint mode)
                $a78b7212404532f0$var$disableArrangementLabelsCheckbox();
            } else if (processingMode === "defectml") {
                $a78b7212404532f0$var$applyInferenceColors(decodedResult);
                // Disable keypoint labels checkbox for defect segmentation mode
                $a78b7212404532f0$var$disableKeypointLabelsCheckbox();
                // Disable arrangement labels checkbox (not used in defect mode)
                $a78b7212404532f0$var$disableArrangementLabelsCheckbox();
            } else if (processingMode === "arrangement") {
                await $a78b7212404532f0$var$displayArrangementResults(decodedResult.arrangement_result);
                (0, $6ed76de03aae65c4$export$c160e09b4f5ff496)(decodedResult.arrangement_result?.leveling_stats?.leveling_targets?.achieved_overbite);
                // Disable keypoint labels checkbox for arrangement mode
                $a78b7212404532f0$var$disableKeypointLabelsCheckbox();
                // Enable arrangement labels checkbox for arrangement mode
                $a78b7212404532f0$var$enableArrangementLabelsCheckbox();
            } else {
                $a78b7212404532f0$var$applyInferenceColors(decodedResult);
                $a78b7212404532f0$var$addBoundaryPointsAndLines(decodedResult.boundary_points, decodedResult.simplified_boundary_points);
                // Disable keypoint labels checkbox for teeth segmentation mode
                $a78b7212404532f0$var$disableKeypointLabelsCheckbox();
                // Disable arrangement labels checkbox (not used in segmentation mode)
                $a78b7212404532f0$var$disableArrangementLabelsCheckbox();
            }
            // Short delay to show 100% completion before hiding
            await new Promise((resolve)=>setTimeout(resolve, 750));
            // Hide processing indicator to show results
            processingIndicator.style.display = "none";
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Processing completed", "check-circle");
            // Initialize feedback system after successful processing
            setTimeout(()=>{
                (0, $aa8a35ff0d89d373$export$6abedbe6567986dc)(processingMode, decodedResult);
            }, 1000);
            // Show start over button if sidebar is collapsed
            $a78b7212404532f0$var$showStartOverAndFeedbackButtons();
            $a78b7212404532f0$var$updateStartOverButtonVisibility();
            processSucceeded = true;
        }
    } catch (error) {
        console.error("Error during inference:", error);
        // Show detailed error message
        const errorMessage = error.message || error.response?.data?.detail || "Error during inference";
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(errorMessage, "exclamation-triangle");
        // Make sure to hide the indicator on error
        document.getElementById("processing-indicator").style.display = "none";
    } finally{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingFile = false;
        processButton.textContent = "Process";
        processButton.disabled = false;
        if (processSucceeded) // Lock file/mode inputs until user clicks Clear
        $a78b7212404532f0$var$disableAllInputs();
        $a78b7212404532f0$var$updateClearButtonFromState();
        $a78b7212404532f0$var$updateArrangementActionButtons();
    }
}
function $a78b7212404532f0$var$addKeypoints(keypoints) {
    if (!keypoints || !Array.isArray(keypoints)) {
        console.warn("Invalid keypoints data:", keypoints);
        return;
    }
    // Remove any existing keypoints and labels
    for(let i = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children.length - 1; i >= 0; i--){
        const child = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children[i];
        if (child.name?.startsWith("keypoint-")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(child);
    }
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypoints = {};
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypointLabels = [];
    // Create material for keypoints
    const sphereGeometry = new $0d79572b4b22d35c$export$1b417fc3b307a251(0.5, 32, 32);
    try {
        keypoints.forEach((keypoint)=>{
            // Validate keypoint data
            if (!keypoint || typeof keypoint.x !== "number" || typeof keypoint.y !== "number" || typeof keypoint.z !== "number") {
                console.warn("Invalid keypoint data:", keypoint);
                return;
            }
            // Skip if coordinates are not finite numbers
            if (!isFinite(keypoint.x) || !isFinite(keypoint.y) || !isFinite(keypoint.z)) {
                console.warn("Non-finite keypoint coordinates:", keypoint);
                return;
            }
            // Convert from snake_case to camelCase if needed
            const className = keypoint.className || keypoint.class_name || "unknown";
            const toothId = keypoint.toothId || keypoint.tooth_id || null;
            // Find keypoint class info
            const keypointClass = (0, (/*@__PURE__*/$parcel$interopDefault($60270fe9f6d741b0$exports))).find((c)=>c.name === className);
            if (!keypointClass) {
                console.warn(`Unknown keypoint class: ${className}`);
                return;
            }
            // Create unique ID for the keypoint
            const pointName = keypoint.pointName || `keypoint-point-${Math.random().toString(36).substr(2, 9)}`;
            // Prepare keypoint object for storage
            const keypointObject = {
                x: keypoint.x,
                y: keypoint.y,
                z: keypoint.z,
                className: className,
                pointName: pointName,
                toothId: toothId
            };
            // Store keypoint in global state
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypoints[pointName] = keypointObject;
            // Create visual representation of keypoint
            const sphereMaterial = new $0d79572b4b22d35c$export$55cbcc9b622fe1f5({
                color: new $0d79572b4b22d35c$export$892596cec99bc70e(keypointClass.color)
            });
            const sphere = new $0d79572b4b22d35c$export$e176487c05830cc5(sphereGeometry, sphereMaterial);
            sphere.position.set(keypoint.x, keypoint.y, keypoint.z);
            sphere.name = pointName;
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add(sphere);
            // Create label for keypoint
            const labelDiv = document.createElement("div");
            labelDiv.className = "keypoint-label";
            labelDiv.textContent = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).showToothIDForKeypoints ? `${className} (${toothId || "?"})` : className;
            labelDiv.style.color = keypointClass.color;
            labelDiv.style.backgroundColor = "rgba(0,0,0,0.5)";
            labelDiv.style.padding = "2px 6px";
            labelDiv.style.borderRadius = "3px";
            labelDiv.style.fontSize = "12px";
            const label = new (0, $b5225408295f08ae$export$936f75e6792bf2dc)(labelDiv);
            label.position.set(keypoint.x, keypoint.y, keypoint.z);
            label.name = `keypoint-label-${pointName}`;
            label.visible = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).showKeypointLabels;
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add(label);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypointLabels.push(label);
        });
        // Draw marginal ridge lines
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).showMarginalRidgeLines) (0, $1161739a589c5758$export$ef655c5027b28822)((0, $66dbd4fb7330af32$export$8e769ad4338a911e));
    } catch (error) {
        console.error("Error adding keypoints:", error);
    }
}
function $a78b7212404532f0$var$applyInferenceColors(inferenceResult) {
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh || !inferenceResult) {
        console.warn("Missing mesh or inference result");
        return;
    }
    // Store the inference result for later download
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult = inferenceResult;
    // Ensure labels are properly decoded
    let labels = inferenceResult.labels;
    if (!labels) {
        console.warn("No labels found in inference result");
        return;
    }
    // If labels are in compressed format, decode them
    if (typeof labels === "object" && labels.encoding === "runlength") labels = (0, $268abebfadfa5867$export$6331e6257b65859c)(labels.data);
    const geometry = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry;
    const colors = geometry.attributes.color;
    // Remove existing class labels
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).classLabels.forEach((label)=>(0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(label));
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).classLabels = [];
    const labelPositions = {};
    const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
    const classesData = processingMode === "defectml" ? (0, (/*@__PURE__*/$parcel$interopDefault($87cd5dd3a0b838ad$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($2a57802d05c0eaa2$exports)));
    for(let i = 0; i < labels.length; i++){
        const label = labels[i];
        const color = new $0d79572b4b22d35c$export$892596cec99bc70e($a78b7212404532f0$var$getColorForLabel(label, processingMode));
        colors.setXYZ(i, color.r, color.g, color.b);
        // Calculate average position for each class
        if (!labelPositions[label]) labelPositions[label] = {
            sum: new $0d79572b4b22d35c$export$64b5c384219d3699(),
            count: 0
        };
        const vertex = new $0d79572b4b22d35c$export$64b5c384219d3699().fromBufferAttribute(geometry.attributes.position, i);
        labelPositions[label].sum.add(vertex);
        labelPositions[label].count++;
    }
    colors.needsUpdate = true;
    // Create and position class labels
    Object.entries(labelPositions).forEach(([label, data])=>{
        const avgPosition = data.sum.divideScalar(data.count);
        const classData = classesData.find((c)=>c.id === parseInt(label));
        if (classData) {
            const labelDiv = document.createElement("div");
            labelDiv.className = "tooth-label";
            labelDiv.textContent = classData.name;
            labelDiv.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
            labelDiv.style.color = "white";
            labelDiv.style.padding = "2px 5px";
            labelDiv.style.borderRadius = "3px";
            const labelObject = new (0, $b5225408295f08ae$export$936f75e6792bf2dc)(labelDiv);
            labelObject.position.copy(avgPosition);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add(labelObject);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).classLabels.push(labelObject);
        } else console.warn("No class data found for label:", label);
    });
    // After applying colors, show the download button
    (0, $de78056e9ef47f69$export$e9bdd49321747af5)();
}
function $a78b7212404532f0$var$getColorForLabel(label, processingMode) {
    const classesData = processingMode === "defectml" ? (0, (/*@__PURE__*/$parcel$interopDefault($87cd5dd3a0b838ad$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($2a57802d05c0eaa2$exports)));
    const classData = classesData.find((c)=>c.id === parseInt(label));
    return classData ? classData.color : "#FFFFFF";
}
function $a78b7212404532f0$var$addBoundaryPointsAndLines(boundaryPointsData, simplifiedBoundaryPointsData) {
    // Remove existing boundary points and lines
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryPoints) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryPoints);
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLines) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLines);
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryPoints) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryPoints);
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLines) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLines);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryPoints = new $0d79572b4b22d35c$export$eb2fcfdbd7ba97d4();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLines = new $0d79572b4b22d35c$export$eb2fcfdbd7ba97d4();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryPoints = new $0d79572b4b22d35c$export$eb2fcfdbd7ba97d4();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLines = new $0d79572b4b22d35c$export$eb2fcfdbd7ba97d4();
    const sphereGeometry = new $0d79572b4b22d35c$export$1b417fc3b307a251(0.2, 32, 32);
    function drawLines(points, lines, color) {
        if (!Array.isArray(points) || points.length === 0) {
            console.warn("Invalid points array for drawing lines:", points);
            return;
        }
        const lineMaterial = new $0d79572b4b22d35c$export$fbaaa33907730a0c({
            color: color,
            linewidth: 2
        });
        for(let i = 0; i < points.length; i++){
            // Validate point array structure
            if (!Array.isArray(points[i]) || points[i].length < 3) {
                console.warn(`Invalid point at index ${i}:`, points[i]);
                continue;
            }
            // Validate next point
            const nextIdx = (i + 1) % points.length;
            if (!Array.isArray(points[nextIdx]) || points[nextIdx].length < 3) {
                console.warn(`Invalid next point at index ${nextIdx}:`, points[nextIdx]);
                continue;
            }
            const start = new $0d79572b4b22d35c$export$64b5c384219d3699(points[i][0], points[i][1], points[i][2]);
            const end = new $0d79572b4b22d35c$export$64b5c384219d3699(points[nextIdx][0], points[nextIdx][1], points[nextIdx][2]);
            // Skip if any coordinates are not finite numbers
            if (!isFinite(start.x) || !isFinite(start.y) || !isFinite(start.z) || !isFinite(end.x) || !isFinite(end.y) || !isFinite(end.z)) {
                console.warn("Non-finite coordinates detected:", {
                    start: start,
                    end: end
                });
                continue;
            }
            if (start.distanceTo(end) < 3) {
                const lineGeometry = new $0d79572b4b22d35c$export$b7be63a67df8959().setFromPoints([
                    start,
                    end
                ]);
                const line = new $0d79572b4b22d35c$export$17d680238e50603e(lineGeometry, lineMaterial);
                lines.add(line);
            }
        }
    }
    try {
        if (boundaryPointsData && typeof boundaryPointsData === "object") Object.entries(boundaryPointsData).forEach(([toothClass, points])=>{
            if (Array.isArray(points) && points.length > 0) {
                const color = new $0d79572b4b22d35c$export$892596cec99bc70e($a78b7212404532f0$var$getColorForLabel(parseInt(toothClass), "toothml"));
                const sphereMaterial = new $0d79572b4b22d35c$export$55cbcc9b622fe1f5({
                    color: color
                });
                points.forEach((point)=>{
                    if (!Array.isArray(point) || point.length < 3) {
                        console.warn("Invalid point:", point);
                        return;
                    }
                    if (!isFinite(point[0]) || !isFinite(point[1]) || !isFinite(point[2])) {
                        console.warn("Non-finite point coordinates:", point);
                        return;
                    }
                    const sphere = new $0d79572b4b22d35c$export$e176487c05830cc5(sphereGeometry, sphereMaterial);
                    sphere.position.set(point[0], point[1], point[2]);
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryPoints.add(sphere);
                });
                drawLines(points, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLines, color);
            } else console.warn(`No valid points array for tooth class ${toothClass}:`, points);
        });
        else console.warn("Invalid or missing boundary points data:", boundaryPointsData);
        if (simplifiedBoundaryPointsData && typeof simplifiedBoundaryPointsData === "object") Object.entries(simplifiedBoundaryPointsData).forEach(([toothClass, points])=>{
            if (Array.isArray(points) && points.length > 0) {
                const color = new $0d79572b4b22d35c$export$892596cec99bc70e($a78b7212404532f0$var$getColorForLabel(parseInt(toothClass)));
                const sphereMaterial = new $0d79572b4b22d35c$export$55cbcc9b622fe1f5({
                    color: color
                });
                points.forEach((point)=>{
                    if (!Array.isArray(point) || point.length < 3) {
                        console.warn("Invalid simplified point:", point);
                        return;
                    }
                    if (!isFinite(point[0]) || !isFinite(point[1]) || !isFinite(point[2])) {
                        console.warn("Non-finite simplified point coordinates:", point);
                        return;
                    }
                    const sphere = new $0d79572b4b22d35c$export$e176487c05830cc5(sphereGeometry, sphereMaterial);
                    sphere.position.set(point[0], point[1], point[2]);
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryPoints.add(sphere);
                });
                drawLines(points, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLines, color);
            } else console.warn(`No valid simplified points array for tooth class ${toothClass}:`, points);
        });
        else console.warn("Invalid or missing simplified boundary points data:", simplifiedBoundaryPointsData);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryPoints);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLines);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryPoints);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLines);
    } catch (error) {
        console.error("Error adding boundary points and lines:", error);
    }
}
function $a78b7212404532f0$var$updateMeshVisualization() {
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh) return;
    // Remove existing visualizations
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.getObjectByName("wireframe"));
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.getObjectByName("pointcloud"));
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).showWireframe) {
        const wireframe = new $0d79572b4b22d35c$export$ff1ed10fedfdd604(new $0d79572b4b22d35c$export$4b739da06d24892b((0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry), (0, $66dbd4fb7330af32$export$8e769ad4338a911e).wireframeMaterial);
        wireframe.name = "wireframe";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add(wireframe);
    }
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).showPointCloud) {
        const pointCloud = new $0d79572b4b22d35c$export$1c787534cb11aa3e((0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).pointsMaterial);
        pointCloud.name = "pointcloud";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add(pointCloud);
    }
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.visible = !((0, $66dbd4fb7330af32$export$8e769ad4338a911e).showWireframe || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).showPointCloud);
}
function $a78b7212404532f0$var$updateLighting() {
    const lightingAmount = 1.5; // Fixed lighting amount
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).ambientLight.intensity = 0.5 * lightingAmount;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight1.intensity = 0.5 * lightingAmount;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight2.intensity = 0.5 * lightingAmount;
}
/**
 * Update brightness for all scenes and views
 */ function $a78b7212404532f0$var$updateBrightness() {
    const brightnessMultiplier = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount;
    // Update main scene lighting
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).ambientLight) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).ambientLight.intensity = 0.3 * brightnessMultiplier;
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight1) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight1.intensity = 0.7 * brightnessMultiplier;
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight2) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).directionalLight2.intensity = 0.5 * brightnessMultiplier;
    // Update boundary scene lighting
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.children.forEach((child)=>{
        if (child instanceof $0d79572b4b22d35c$export$af279bfef9ec2c96) child.intensity = 0.3 * brightnessMultiplier;
        else if (child instanceof $0d79572b4b22d35c$export$3fea33cc9972c868) {
            if (child.position.x > 0) child.intensity = 0.7 * brightnessMultiplier;
            else child.intensity = 0.5 * brightnessMultiplier;
        }
    });
    // Update simplified boundary scene lighting
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.children.forEach((child)=>{
        if (child instanceof $0d79572b4b22d35c$export$af279bfef9ec2c96) child.intensity = 0.3 * brightnessMultiplier;
        else if (child instanceof $0d79572b4b22d35c$export$3fea33cc9972c868) {
            if (child.position.x > 0) child.intensity = 0.7 * brightnessMultiplier;
            else child.intensity = 0.5 * brightnessMultiplier;
        }
    });
    // Update multi-view scenes lighting
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes) Object.values((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes).forEach((scene)=>{
        if (scene) scene.children.forEach((child)=>{
            if (child instanceof $0d79572b4b22d35c$export$af279bfef9ec2c96) child.intensity = 0.4 * brightnessMultiplier;
            else if (child instanceof $0d79572b4b22d35c$export$3fea33cc9972c868) {
                if (child.position.x > 0) child.intensity = 0.6 * brightnessMultiplier;
                else child.intensity = 0.4 * brightnessMultiplier;
            }
        });
    });
}
/**
 * Helper function to hide all boundary views
 */ function $a78b7212404532f0$var$hideAllBoundaryViews() {
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.domElement) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.domElement.style.display = "none";
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement.style.display = "none";
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.domElement) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.domElement.style.display = "none";
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement.style.display = "none";
}
/**
 * Helper function to show all boundary views
 */ function $a78b7212404532f0$var$showAllBoundaryViews() {
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.domElement) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.domElement.style.display = "block";
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.domElement.style.display = "block";
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.domElement) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.domElement.style.display = "block";
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.domElement.style.display = "block";
}
/**
 * Helper function to hide view separators
 */ function $a78b7212404532f0$var$hideViewSeparators() {
    document.querySelectorAll(".view-separator").forEach((separator)=>{
        separator.style.display = "none";
    });
}
/**
 * Helper function to show view separators
 */ function $a78b7212404532f0$var$showViewSeparators() {
    document.querySelectorAll(".view-separator").forEach((separator)=>{
        separator.style.display = "block";
    });
}
/**
 * Setup teeth separation multi-view layout for 2x2 grid
 */ function $a78b7212404532f0$var$setupTeethSeparationMultiViewLayout() {
    // First ensure we start with a clean slate
    $a78b7212404532f0$var$resetMultiViewContainer();
    // Make sure multi-view container is visible and configure for 2x2 grid
    const multiViewContainer = document.getElementById("multi-view-container");
    if (multiViewContainer) {
        // Force clear any existing styles first
        multiViewContainer.removeAttribute("style");
        // Now set the proper 2x2 grid layout
        multiViewContainer.style.display = "grid";
        multiViewContainer.style.gridTemplateColumns = "1fr 1fr";
        multiViewContainer.style.gridTemplateRows = "1fr 1fr";
        multiViewContainer.style.gap = "2px";
        multiViewContainer.style.width = "100%";
        multiViewContainer.style.height = "100%";
        multiViewContainer.style.position = "absolute";
        multiViewContainer.style.top = "0";
        multiViewContainer.style.left = "0";
    }
    // Configure ALL FOUR view panels for 2x2 grid
    const viewPanels = [
        "original-view",
        "segmented-view",
        "analysis-view",
        "final-view"
    ];
    viewPanels.forEach((panelId)=>{
        const panel = document.getElementById(panelId);
        if (panel) {
            // Force clear existing styles
            panel.removeAttribute("style");
            // Set proper styles for 2x2 grid
            panel.style.width = "100%";
            panel.style.height = "100%";
            panel.style.display = "block";
            panel.style.position = "relative";
            panel.style.overflow = "hidden";
        }
    });
    // Calculate view dimensions for each quadrant
    const viewWidth = (window.innerWidth - 2) / 2; // Account for 2px gap
    const viewHeight = (window.innerHeight - 2) / 2; // Account for 2px gap
    // Configure renderers for all views
    Object.keys((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers).forEach((view)=>{
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view] && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view]) {
            // Use full quadrant proportions
            const aspect = viewWidth / viewHeight;
            $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view], aspect);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view].setSize(viewWidth, viewHeight);
            // Also resize label renderers
            if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view]) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].setSize(viewWidth, viewHeight);
        }
    });
    // Make sure main view is hidden during multi-view
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "none";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "none";
    // Hide boundary views during reconstruction
    $a78b7212404532f0$var$hideAllBoundaryViews();
    $a78b7212404532f0$var$hideViewSeparators();
}
function $a78b7212404532f0$var$onWindowResize() {
    const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
    // Get the main viewer container dimensions
    const mainViewer = document.getElementById("main-viewer");
    if (!mainViewer) {
        console.warn("Main viewer container not found");
        return;
    }
    const viewerRect = mainViewer.getBoundingClientRect();
    const viewerWidth = viewerRect.width;
    const viewerHeight = viewerRect.height;
    // Check if multi-view container is visible (arrangement dual view active)
    const multiViewContainer = document.getElementById("multi-view-container");
    const overlayViewContainer = document.getElementById("overlay-view-container");
    const isArrangementDualView = multiViewContainer && multiViewContainer.style.display !== "none" && processingMode === "arrangement";
    const isArrangementOverlayView = overlayViewContainer && overlayViewContainer.style.display !== "none" && processingMode === "arrangement";
    if (isArrangementOverlayView) // Handle arrangement overlay view layout - single full view
    {
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayCamera) {
            const aspect = viewerWidth / viewerHeight;
            $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayCamera, aspect);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer.setSize(viewerWidth, viewerHeight);
            if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer.setSize(viewerWidth, viewerHeight);
        }
    } else if (isArrangementDualView) // Handle arrangement dual view layout - 1x2 side-by-side
    $a78b7212404532f0$var$setupArrangementMultiViewLayout();
    else if (processingMode === "defectml" || processingMode === "keypointml" || processingMode === "teethseparation" && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase === 0 || processingMode === "arrangement" && !isArrangementDualView) {
        // Full viewer single view for:
        // - defect or keypoint detection
        // - initial phase of teeth separation (phase 0)
        // - arrangement loading/preview mode
        const aspect = viewerWidth / viewerHeight;
        $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera, aspect);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.setSize(viewerWidth, viewerHeight);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.setSize(viewerWidth, viewerHeight);
        // Make sure main view is visible
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "block";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "block";
        // Hide boundary views and multi-view
        $a78b7212404532f0$var$hideAllBoundaryViews();
        $a78b7212404532f0$var$hideViewSeparators();
        if (multiViewContainer) multiViewContainer.style.display = "none";
    } else if (processingMode === "teethseparation") {
        // Handle teeth separation mode based on phase and multi-view status
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView) // Phase 2+ with multi-view layout - use full screen with 2x2 grid
        $a78b7212404532f0$var$setupTeethSeparationMultiViewLayout();
        else if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase === 1) {
            // Phase 1 (segmentation) - use full view
            $a78b7212404532f0$var$hideAllBoundaryViews();
            $a78b7212404532f0$var$hideViewSeparators();
            // Make sure main view is visible and sized correctly
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "block";
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "block";
            // Adjust main view to use full viewer
            const aspect = viewerWidth / viewerHeight;
            $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera, aspect);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.setSize(viewerWidth, viewerHeight);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.setSize(viewerWidth, viewerHeight);
            // Hide multi-view container if it exists
            const multiViewContainer = document.getElementById("multi-view-container");
            if (multiViewContainer) multiViewContainer.style.display = "none";
            // Still update boundary camera settings for when they might be shown again
            const boundaryAspect = window.innerWidth / 2 / (window.innerHeight / 2);
            $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera, boundaryAspect);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
            const simplifiedBoundaryAspect = window.innerWidth / 2 / (window.innerHeight / 2);
            $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera, simplifiedBoundaryAspect);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
        } else {
            // Teeth separation phase 0 or other phases - single view
            // Make sure main view is visible
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "block";
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "block";
            // Full window single view
            const aspect = window.innerWidth / window.innerHeight;
            $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera, aspect);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.setSize(window.innerWidth, window.innerHeight);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.setSize(window.innerWidth, window.innerHeight);
            // Hide multi-view and boundary views
            const multiViewContainer = document.getElementById("multi-view-container");
            if (multiViewContainer) multiViewContainer.style.display = "none";
            $a78b7212404532f0$var$hideAllBoundaryViews();
            $a78b7212404532f0$var$hideViewSeparators();
        }
    } else {
        // Default split view layout for standard segmentation
        $a78b7212404532f0$var$showAllBoundaryViews();
        $a78b7212404532f0$var$showViewSeparators();
        const aspect = window.innerWidth / 2 / window.innerHeight;
        $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera, aspect);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.setSize(window.innerWidth / 2, window.innerHeight);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.setSize(window.innerWidth / 2, window.innerHeight);
        const boundaryAspect = window.innerWidth / 2 / (window.innerHeight / 2);
        $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera, boundaryAspect);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
        const simplifiedBoundaryAspect = window.innerWidth / 2 / (window.innerHeight / 2);
        $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera, simplifiedBoundaryAspect);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.setSize(window.innerWidth / 2, window.innerHeight / 2);
        // Hide multi-view for standard modes
        if (multiViewContainer) multiViewContainer.style.display = "none";
    }
}
function $a78b7212404532f0$var$animate() {
    requestAnimationFrame($a78b7212404532f0$var$animate);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.update();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryControls.update();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryControls.update();
    // Render main view
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.render((0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.render((0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera);
    // Only render boundary views if not in teethseparation mode or if we're not in phase 1
    const shouldRenderBoundaryViews = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingMode !== "teethseparation" || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingMode === "teethseparation" && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase !== 1;
    if (shouldRenderBoundaryViews) {
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryRenderer.render((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLabelRenderer.render((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryCamera);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryRenderer.render((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLabelRenderer.render((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryCamera);
    }
    // Render multi-view if active
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView) {
        // Check if this is the first time multi-view is being rendered and setup layout
        if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLayoutInitialized) {
            // Check processing mode to determine layout type
            const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
            if (processingMode === "arrangement") $a78b7212404532f0$var$setupArrangementMultiViewLayout();
            else $a78b7212404532f0$var$setupTeethSeparationMultiViewLayout();
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLayoutInitialized = true;
            // Force a layout refresh after a brief delay to ensure changes take effect
            setTimeout(()=>{
                if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView) {
                    if (processingMode === "arrangement") $a78b7212404532f0$var$setupArrangementMultiViewLayout();
                    else $a78b7212404532f0$var$setupTeethSeparationMultiViewLayout();
                }
            }, 100);
        }
        Object.keys((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers).forEach((view)=>{
            if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view] && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view]) {
                (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].update();
                (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view].render((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view], (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view]);
                // Render CSS2D labels
                if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view]) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].render((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view], (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view]);
            }
        });
    }
    // Render overlay view if active
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayViewMode === "overlay" && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene) {
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayControls.update();
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer.render((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayCamera);
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer.render((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayCamera);
    }
}
// Function to proceed to the next phase of teeth separation
function $a78b7212404532f0$var$proceedToNextPhase() {
    const nextPhaseButton = document.getElementById("next-phase-button");
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase === 1) {
        // Moving from segmentation to separation
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase = 2;
        nextPhaseButton.style.display = "none";
        // Store the segmented mesh data
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData.segmentedMesh = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.clone();
        // Begin teeth reconstruction processing
        (0, $de78056e9ef47f69$export$be647402357873d6)();
    } else if (nextPhaseButton.textContent === "Try Again") {
        // Handle the "Try Again" case
        nextPhaseButton.style.display = "none";
        // Reset any failed state and try the separation again
        (0, $de78056e9ef47f69$export$be647402357873d6)();
    }
}
/**
 * Initialize multi-view renderers for arrangement display
 */ function $a78b7212404532f0$var$initializeMultiViewRenderers() {
    const views = [
        "original",
        "segmented",
        "analysis",
        "final"
    ];
    views.forEach((view)=>{
        // Create scene
        if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view]) {
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view] = new $0d79572b4b22d35c$export$38af1803e3442a7f();
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].background = (0, $b28963ea5393104c$export$82c7f84255e60cc3)();
        }
        // Create camera
        if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view]) {
            const multiViewAspect = window.innerWidth / 2 / (window.innerHeight / 2);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view] = $a78b7212404532f0$var$createOrthographicCamera(multiViewAspect);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view].position.set(0, 0, 60);
        }
        // Create renderer
        if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view]) {
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view] = new $0d79572b4b22d35c$export$f6cc00ef28d7cf97({
                antialias: true
            });
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view].setSize(window.innerWidth / 2, window.innerHeight / 2);
            const viewElement = document.getElementById(`${view}-view`);
            if (viewElement) viewElement.appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view].domElement);
        }
        // Create CSS2D label renderer
        if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view]) {
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view] = new (0, $b5225408295f08ae$export$508520281a983506)();
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].setSize(window.innerWidth / 2, window.innerHeight / 2);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].domElement.style.position = "absolute";
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].domElement.style.top = "0";
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].domElement.style.left = "0";
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].domElement.style.pointerEvents = "none";
            const viewElement = document.getElementById(`${view}-view`);
            if (viewElement) viewElement.appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers[view].domElement);
        }
        // Create controls
        if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view]) {
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view] = new (0, $6c1447dc1cd4496f$export$8ff7788029dfdf52)((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view], (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view].domElement);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].enableDamping = true;
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].dampingFactor = 0.5;
        }
        // Add lights to the scene - ALWAYS ensure proper lighting
        // Remove existing lights first to avoid duplicates
        const existingLights = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].children.filter((child)=>child.isLight);
        existingLights.forEach((light)=>(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].remove(light));
        // Add comprehensive lighting setup with brightness setting
        const ambientLight = new $0d79572b4b22d35c$export$af279bfef9ec2c96(0xffffff, 0.4 * (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].add(ambientLight);
        const directionalLight1 = new $0d79572b4b22d35c$export$3fea33cc9972c868(0xffffff, 0.6 * (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount);
        directionalLight1.position.set(1, 1, 1);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].add(directionalLight1);
        const directionalLight2 = new $0d79572b4b22d35c$export$3fea33cc9972c868(0xffffff, 0.4 * (0, $66dbd4fb7330af32$export$8e769ad4338a911e).brightnessAmount);
        directionalLight2.position.set(-1, -1, -1);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].add(directionalLight2);
        console.log(`\u{1F4A1} Lighting setup completed for ${view} scene`);
    });
    // Link camera controls for synchronized viewing with loop prevention
    let multiViewSyncing = false;
    views.forEach((view)=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].addEventListener("change", ()=>{
            // Prevent recursive calls
            if (multiViewSyncing) return;
            multiViewSyncing = true;
            views.forEach((otherView)=>{
                if (otherView !== view && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[otherView] && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[otherView]) {
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[otherView].position.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view].position);
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[otherView].rotation.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view].rotation);
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[otherView].target.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].target);
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[otherView].update();
                }
            });
            multiViewSyncing = false;
        });
    });
    // Enable multi-view rendering in the animation loop
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView = true;
}
/**
 * Setup camera synchronization specifically for arrangement views (original and segmented)
 * This provides better performance than syncing all 4 views when only 2 are active
 */ function $a78b7212404532f0$var$setupArrangementCameraSynchronization() {
    const arrangementViews = [
        "original",
        "segmented"
    ];
    // Remove any existing event listeners to avoid duplicates
    arrangementViews.forEach((view)=>{
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view]._arrangementSyncListener) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].removeEventListener("change", (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view]._arrangementSyncListener);
    });
    // Flag to prevent infinite loops during synchronization
    let syncing = false;
    // Setup synchronization between only the arrangement views
    arrangementViews.forEach((view)=>{
        const syncListener = ()=>{
            // Prevent recursive calls
            if (syncing) return;
            const otherView = view === "original" ? "segmented" : "original";
            if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[otherView] && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[otherView]) {
                syncing = true;
                // Synchronize camera position, rotation, and target
                (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[otherView].position.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view].position);
                (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[otherView].rotation.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras[view].rotation);
                (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[otherView].target.copy((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].target);
                // Update the other view's controls without triggering events
                (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[otherView].update();
                syncing = false;
            }
        };
        // Store the listener reference for cleanup
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view]._arrangementSyncListener = syncListener;
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[view].addEventListener("change", syncListener);
    });
    console.log("\uD83D\uDD17 Arrangement camera synchronization setup complete");
}
/**
 * Display arrangement results with side-by-side visualization using InfoJson format
 * @param {Object} arrangementResult - The arrangement result data
 */ async function $a78b7212404532f0$var$displayArrangementResults(arrangementResult) {
    if (!arrangementResult) {
        console.warn("No arrangement result data");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No arrangement result data", "exclamation-triangle");
        return;
    }
    // Notes the pipeline wrote for the technician about the result they are about to
    // see. Shown before the meshes render, so an unexpected arch is explained rather
    // than left to be guessed at, and held longer than an ordinary toast because it
    // asks the reader to reconsider a choice.
    if (arrangementResult.warnings?.archform) (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(arrangementResult.warnings.archform, "exclamation-triangle", 12000);
    // Check if we have InfoJson data
    if (!arrangementResult.info_json || !arrangementResult.info_json.Objects) {
        console.warn("No InfoJson data found in arrangement result");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No InfoJson data found in arrangement result", "exclamation-triangle");
        return;
    }
    console.log("\uD83D\uDD04 Starting arrangement results display...");
    // Parse original files and create arrangement objects using InfoJson FIRST
    const { originalObjects: originalObjects, transformedObjects: transformedObjects } = await $a78b7212404532f0$var$parseArrangementFiles(arrangementResult.info_json);
    console.log(`\u{1F4CA} Parsed objects - Original: ${originalObjects.length}, Transformed: ${transformedObjects.length}`);
    // Ensure we have objects to display before setting up views
    if (originalObjects.length === 0 && transformedObjects.length === 0) {
        console.warn("\u26A0\uFE0F No objects found to display");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No objects found to display", "exclamation-triangle");
        return;
    }
    // Ensure multi-view container exists
    const multiViewContainer = document.getElementById("multi-view-container");
    if (!multiViewContainer) {
        console.error("\u274C Multi-view container not found!");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Display error: Multi-view container missing", "exclamation-triangle");
        return;
    }
    // Hide the original single view and show multi-view container
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "none";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "none";
    console.log("\uD83D\uDDA5\uFE0F Setting up multi-view display...");
    multiViewContainer.style.display = "block";
    // Initialize multi-view renderers if not already done
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers.original) {
        console.log("\uD83D\uDD27 Initializing multi-view renderers...");
        $a78b7212404532f0$var$initializeMultiViewRenderers();
    }
    // Clear existing scenes
    $a78b7212404532f0$var$clearMultiViewScenes();
    // Configure for 1x2 side-by-side layout
    $a78b7212404532f0$var$setupArrangementMultiViewLayout();
    // Check if we have both original and transformed objects for dual view
    if (originalObjects.length > 0 && transformedObjects.length > 0) {
        // Store objects in global state for view mode switching
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).arrangementOriginalObjects = originalObjects;
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).arrangementTransformedObjects = transformedObjects;
        // Show the view mode toggle
        const viewModeContainer = document.getElementById("arrangement-view-mode-container");
        if (viewModeContainer) viewModeContainer.style.display = "block";
        // Display original objects (left side) with jaw toggles
        console.log("\uD83D\uDCE6 Displaying original objects...");
        $a78b7212404532f0$var$displayArrangementObjectsInScene(originalObjects, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.original, "Original Objects", true // enable jaw toggles
        );
        // Display transformed objects (right side) - also enable jaw toggles for userData
        console.log("\uD83D\uDCE6 Displaying arranged objects...");
        $a78b7212404532f0$var$displayArrangementObjectsInScene(transformedObjects, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.segmented, "Arranged Objects", true // enable jaw toggles so userData.group is set for visibility controls
        );
        // Note: Jaw toggle controls removed - visibility controls are now in the left sidebar
        $a78b7212404532f0$var$cleanupFloatingJawControls();
        // Auto-position cameras to show objects and ensure multi-view rendering
        $a78b7212404532f0$var$autoPositionArrangementCameras();
        // Setup targeted camera synchronization for arrangement views
        $a78b7212404532f0$var$setupArrangementCameraSynchronization();
        // Force multi-view layout initialization
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLayoutInitialized = false; // Reset to force re-initialization
        console.log("\uD83D\uDD04 Reset multi-view layout flag to force re-initialization");
        // Force camera controls update to show objects properly
        setTimeout(()=>{
            console.log("\uD83D\uDCF9 Updating camera controls and layout...");
            if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls.original) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls.original.update();
            if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls.segmented) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls.segmented.update();
            // Force window resize to ensure proper layout
            $a78b7212404532f0$var$onWindowResize();
        }, 100);
        console.log("\u2705 Arrangement dual-view setup complete");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Arrangement completed - Left: Original, Right: Arranged", "check-circle");
        // Initialize feedback after successful arrangement
        setTimeout(()=>{
            (0, $aa8a35ff0d89d373$export$6abedbe6567986dc)("arrangement", arrangementResult);
        }, 1000);
    } else if (originalObjects.length > 0) {
        // No transformed objects, show original objects in main view instead
        console.log("\uD83D\uDCE6 Displaying original objects in main view...");
        // Hide multi-view and show main view
        multiViewContainer.style.display = "none";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "block";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "block";
        // Display original objects in main scene
        $a78b7212404532f0$var$displayOriginalObjectsInMainScene(originalObjects);
        // Note: Jaw toggle controls removed - visibility controls are now in the left sidebar
        $a78b7212404532f0$var$cleanupFloatingJawControls();
        // Force camera controls update
        setTimeout(()=>{
            console.log("\uD83D\uDCF9 Updating main view camera controls...");
            if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.update();
            $a78b7212404532f0$var$onWindowResize();
        }, 100);
        console.log("\u2705 Arrangement main-view setup complete");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Arrangement processing completed - showing original objects", "exclamation-triangle");
        // Initialize feedback after arrangement completion
        setTimeout(()=>{
            (0, $aa8a35ff0d89d373$export$6abedbe6567986dc)("arrangement", arrangementResult);
        }, 1000);
    }
    // Store InfoJSON data for download
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson = arrangementResult.info_json;
    $a78b7212404532f0$var$updateArrangementActionButtons();
    // Store displacement table if available
    if (arrangementResult.displacement_table) {
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).displacementTable = arrangementResult.displacement_table;
        // Show displacement table button
        const displacementTableButton = document.getElementById("displacement-table-button");
        if (displacementTableButton) displacementTableButton.style.display = "block";
    } else {
        // Hide displacement table button if no table available
        const displacementTableButton = document.getElementById("displacement-table-button");
        if (displacementTableButton) displacementTableButton.style.display = "none";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).displacementTable = null;
    }
    // Hide postprocessing section since results are now displayed
    (0, $ddb3f022a87c2bc1$export$7de7bccc87a83087)();
    // Show the InfoJSON action buttons (Accept/Reject when the review gate is
    // enabled, otherwise a plain Download button).
    $a78b7212404532f0$var$showInfoJsonActions();
    console.log("\uD83C\uDFAF Arrangement results display completed successfully");
}
/**
 * Auto-position cameras for arrangement multi-view to properly frame objects
 */ function $a78b7212404532f0$var$autoPositionArrangementCameras() {
    console.log("\uD83D\uDCF9 Auto-positioning arrangement cameras...");
    // Ensure multi-view rendering is enabled
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView = true;
    console.log("\uD83C\uDFAC Multi-view rendering enabled");
    const scenes = [
        {
            key: "original",
            scene: (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.original,
            camera: (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras.original
        },
        {
            key: "segmented",
            scene: (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.segmented,
            camera: (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras.segmented
        }
    ];
    // Use a SINGLE shared reference frame so both panels are centered and
    // framed identically. This makes global displacement directly readable:
    // an unmoved tooth lands at the same screen position in both panels, and a
    // uniform shift of the arranged arch shows up as a visible offset (instead
    // of being hidden by each panel re-centering on its own arch).
    const computeVisibleBox = (scene)=>{
        if (!scene) return null;
        const box = new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
        let count = 0;
        scene.traverse((object)=>{
            if (object.isMesh && object.visible) {
                const meshBox = new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3().setFromObject(object);
                if (meshBox.min.x !== Infinity) {
                    box.union(meshBox);
                    count++;
                }
            }
        });
        return count > 0 ? box : null;
    };
    const originalBox = computeVisibleBox((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.original);
    const arrangedBox = computeVisibleBox((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.segmented);
    const referenceBox = originalBox || arrangedBox;
    if (!referenceBox) {
        console.warn("\u26A0\uFE0F No visible meshes found in arrangement scenes");
        return;
    }
    // Shared pivot = Original arch center (fall back to Arranged if Original is
    // empty), so the Arranged panel is framed relative to where the original
    // teeth sit and any global shift is visible.
    const center = referenceBox.getCenter(new $0d79572b4b22d35c$export$64b5c384219d3699());
    // Framing distance from the union of both arches so neither panel clips.
    const unionBox = new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
    if (originalBox) unionBox.union(originalBox);
    if (arrangedBox) unionBox.union(arrangedBox);
    const size = unionBox.getSize(new $0d79572b4b22d35c$export$64b5c384219d3699());
    const maxDimension = Math.max(size.x, size.y, size.z);
    const distance = maxDimension * 1.5;
    console.log(`\u{1F4CF} Shared arrangement pivot - Center: (${center.x.toFixed(1)}, ` + `${center.y.toFixed(1)}, ${center.z.toFixed(1)}), ` + `frame size: ${maxDimension.toFixed(1)}`);
    scenes.forEach(({ key: key, scene: scene, camera: camera })=>{
        if (!scene || !camera) {
            console.warn(`\u{26A0}\u{FE0F} Missing scene or camera for ${key} view`);
            return;
        }
        // Identical center + distance for every panel.
        camera.position.set(center.x, center.y, center.z + distance);
        camera.lookAt(center.x, center.y, center.z);
        camera.updateProjectionMatrix();
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[key]) {
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[key].target.copy(center);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewControls[key].update();
        }
        console.log(`\u{1F4F9} ${key} camera positioned at shared center, distance ${distance.toFixed(1)}`);
    });
    console.log("\u2705 Camera auto-positioning completed (shared center)");
}
/**
 * Reset multi-view container to default state
 */ function $a78b7212404532f0$var$resetMultiViewContainer() {
    const multiViewContainer = document.getElementById("multi-view-container");
    if (multiViewContainer) {
        // Reset to default CSS properties
        multiViewContainer.style.display = "none";
        multiViewContainer.style.gridTemplateColumns = "";
        multiViewContainer.style.gridTemplateRows = "";
        multiViewContainer.style.gap = "";
        multiViewContainer.style.width = "";
        multiViewContainer.style.height = "";
        multiViewContainer.style.position = "";
        multiViewContainer.style.top = "";
        multiViewContainer.style.left = "";
        // Force remove any inline grid styles that might persist
        multiViewContainer.removeAttribute("style");
        multiViewContainer.style.display = "none";
    }
    // Reset all view panels to default state and ensure they're hidden
    const viewPanels = [
        "original-view",
        "segmented-view",
        "analysis-view",
        "final-view"
    ];
    viewPanels.forEach((panelId)=>{
        const panel = document.getElementById(panelId);
        if (panel) {
            // Force remove all inline styles
            panel.removeAttribute("style");
            panel.style.display = "none";
        }
    });
    // Clear any cached renderers that might have wrong sizes
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers) Object.keys((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers).forEach((view)=>{
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view]) // Force a resize to clear any cached dimensions
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers[view].setSize(1, 1);
    });
}
/**
 * Setup arrangement multi-view layout for 1x2 side-by-side views
 */ function $a78b7212404532f0$var$setupArrangementMultiViewLayout() {
    // Make sure multi-view container is visible and configure for 1x2 grid
    const multiViewContainer = document.getElementById("multi-view-container");
    if (multiViewContainer) {
        multiViewContainer.style.display = "grid";
        multiViewContainer.style.gridTemplateColumns = "1fr 1fr"; // 2 equal columns
        multiViewContainer.style.gridTemplateRows = "1fr"; // 1 row
        multiViewContainer.style.gap = "2px";
        multiViewContainer.style.width = "100%";
        multiViewContainer.style.height = "100%";
        multiViewContainer.style.position = "absolute";
        multiViewContainer.style.top = "0";
        multiViewContainer.style.left = "0";
    }
    // Hide unused views (only use original and segmented for arrangement)
    const analysisView = document.getElementById("analysis-view");
    const finalView = document.getElementById("final-view");
    if (analysisView) analysisView.style.display = "none";
    if (finalView) finalView.style.display = "none";
    // Show and configure the two main views
    const originalView = document.getElementById("original-view");
    const segmentedView = document.getElementById("segmented-view");
    if (originalView) {
        originalView.style.display = "block";
        originalView.style.width = "100%";
        originalView.style.height = "100%";
        originalView.style.position = "relative";
    }
    if (segmentedView) {
        segmentedView.style.display = "block";
        segmentedView.style.width = "100%";
        segmentedView.style.height = "100%";
        segmentedView.style.position = "relative";
    }
    // Calculate view dimensions for each half
    const viewWidth = (window.innerWidth - 2) / 2; // Account for 2px gap
    const viewHeight = window.innerHeight;
    // Resize the renderers for 50/50 split
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers.original && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras.original) {
        const aspect = viewWidth / viewHeight;
        $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras.original, aspect);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers.original.setSize(viewWidth, viewHeight);
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers.original) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers.original.setSize(viewWidth, viewHeight);
    }
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers.segmented && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras.segmented) {
        const aspect = viewWidth / viewHeight;
        $a78b7212404532f0$var$updateOrthographicCamera((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewCameras.segmented, aspect);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers.segmented.setSize(viewWidth, viewHeight);
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers.segmented) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLabelRenderers.segmented.setSize(viewWidth, viewHeight);
    }
    // Make sure main view is hidden during multi-view
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "none";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "none";
    // Hide boundary views during arrangement
    $a78b7212404532f0$var$hideAllBoundaryViews();
    $a78b7212404532f0$var$hideViewSeparators();
}
/**
 * Switch between dual view and overlay view modes for arrangement
 * @param {string} mode - "dual" or "overlay"
 */ function $a78b7212404532f0$var$switchArrangementViewMode(mode) {
    console.log(`\u{1F504} Switching arrangement view mode to: ${mode}`);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayViewMode = mode;
    const multiViewContainer = document.getElementById("multi-view-container");
    const overlayViewContainer = document.getElementById("overlay-view-container");
    if (mode === "overlay") {
        // Hide dual view, show overlay view
        if (multiViewContainer) multiViewContainer.style.display = "none";
        if (overlayViewContainer) overlayViewContainer.style.display = "block";
        // Initialize overlay view if needed
        if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer) $a78b7212404532f0$var$initializeOverlayView();
        // Display objects in overlay mode
        $a78b7212404532f0$var$displayArrangementOverlay();
    } else {
        // Show dual view, hide overlay view
        if (multiViewContainer) multiViewContainer.style.display = "block";
        if (overlayViewContainer) overlayViewContainer.style.display = "none";
        // Hide opacity controls in dual mode
        const opacityControls = document.getElementById("overlay-opacity-controls");
        if (opacityControls) opacityControls.style.display = "none";
        // Re-setup dual view layout
        $a78b7212404532f0$var$setupArrangementMultiViewLayout();
    }
    // Force window resize to update layout
    setTimeout(()=>{
        $a78b7212404532f0$var$onWindowResize();
    }, 100);
    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Switched to ${mode === "overlay" ? "Overlay" : "Dual"} view`, "check-circle");
}
/**
 * Initialize the overlay view renderer and scene
 */ function $a78b7212404532f0$var$initializeOverlayView() {
    console.log("\uD83D\uDD27 Initializing overlay view...");
    const overlayViewElement = document.getElementById("overlay-view");
    if (!overlayViewElement) {
        console.error("\u274C Overlay view element not found!");
        return;
    }
    // Force full width on the overlay view element
    overlayViewElement.style.width = "100%";
    overlayViewElement.style.display = "block";
    overlayViewElement.style.borderRight = "none";
    // Create scene
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene = new $0d79572b4b22d35c$export$38af1803e3442a7f();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.background = (0, $b28963ea5393104c$export$82c7f84255e60cc3)();
    // Create camera
    const aspect = window.innerWidth / window.innerHeight;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayCamera = $a78b7212404532f0$var$createOrthographicCamera(aspect);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayCamera.position.set(0, 0, 50);
    // Create renderer
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer = new $0d79572b4b22d35c$export$f6cc00ef28d7cf97({
        antialias: true
    });
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer.setSize(window.innerWidth, window.innerHeight);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer.setPixelRatio(window.devicePixelRatio);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer.domElement.style.position = "absolute";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer.domElement.style.top = "0";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer.domElement.style.left = "0";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer.domElement.style.zIndex = "1";
    overlayViewElement.appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer.domElement);
    // Create label renderer
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer = new (0, $b5225408295f08ae$export$508520281a983506)();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer.setSize(window.innerWidth, window.innerHeight);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer.domElement.style.position = "absolute";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer.domElement.style.top = "0";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer.domElement.style.left = "0";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer.domElement.style.zIndex = "2";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer.domElement.style.pointerEvents = "none";
    overlayViewElement.appendChild((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayLabelRenderer.domElement);
    // Add lights
    const ambientLight = new $0d79572b4b22d35c$export$af279bfef9ec2c96(0xffffff, 0.6);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.add(ambientLight);
    const directionalLight1 = new $0d79572b4b22d35c$export$3fea33cc9972c868(0xffffff, 0.5);
    directionalLight1.position.set(1, 1, 1);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.add(directionalLight1);
    const directionalLight2 = new $0d79572b4b22d35c$export$3fea33cc9972c868(0xffffff, 0.3);
    directionalLight2.position.set(-1, -1, -1);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.add(directionalLight2);
    // Create controls
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayControls = new (0, $6c1447dc1cd4496f$export$8ff7788029dfdf52)((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayCamera, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayRenderer.domElement);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayControls.enableDamping = true;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayControls.dampingFactor = 0.05;
    console.log("\u2705 Overlay view initialized");
}
/**
 * Display arrangement objects in overlay mode (pre as gray, post as blue)
 */ function $a78b7212404532f0$var$displayArrangementOverlay() {
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene) {
        console.error("\u274C Overlay scene not initialized!");
        return;
    }
    console.log("\uD83C\uDFA8 Displaying arrangement overlay...");
    // Clear existing objects
    while((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.children.length > 0){
        const child = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.children[0];
        if (child.geometry) child.geometry.dispose();
        if (child.material) {
            if (Array.isArray(child.material)) child.material.forEach((mat)=>mat.dispose());
            else child.material.dispose();
        }
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.remove(child);
    }
    // Re-add lights
    const ambientLight = new $0d79572b4b22d35c$export$af279bfef9ec2c96(0xffffff, 0.6);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.add(ambientLight);
    const directionalLight1 = new $0d79572b4b22d35c$export$3fea33cc9972c868(0xffffff, 0.5);
    directionalLight1.position.set(1, 1, 1);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.add(directionalLight1);
    const directionalLight2 = new $0d79572b4b22d35c$export$3fea33cc9972c868(0xffffff, 0.3);
    directionalLight2.position.set(-1, -1, -1);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.add(directionalLight2);
    // Initialize arrays to track meshes by layer
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayOriginalMeshes = [];
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayTransformedMeshes = [];
    // Display original objects in gray
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).arrangementOriginalObjects) {
        console.log("\uD83D\uDCE6 Adding original objects (gray)...");
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).arrangementOriginalObjects.forEach((objData)=>{
            if (!objData?.vertices || !Array.isArray(objData.vertices) || objData.vertices.length === 0) {
                console.warn("\u26A0\uFE0F Skipping object with no vertices:", objData);
                return;
            }
            // Create geometry from vertices
            const vertices = new Float32Array(objData.vertices.flat());
            const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
            geometry.setAttribute("position", new $0d79572b4b22d35c$export$8dea267bd6bde117(vertices, 3));
            // Add faces if available
            if (objData.faces && Array.isArray(objData.faces) && objData.faces.length > 0) {
                const faces = objData.faces.flat();
                geometry.setIndex(faces);
                geometry.computeVertexNormals();
            }
            // Apply gray material with transparency
            const grayMaterial = new $0d79572b4b22d35c$export$24c72f71cbaf0678({
                color: 0x808080,
                transparent: true,
                opacity: 0.5,
                side: $0d79572b4b22d35c$export$3b296b6f144d5b03
            });
            const mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, grayMaterial);
            // Set mesh name for getObjectType to work
            mesh.name = objData.name || "";
            // Set user data for visibility controls
            mesh.userData = {
                type: objData.type,
                group: objData.group,
                teethID: objData.teethID,
                descr: objData.descr,
                originalType: objData.originalType,
                layer: "original"
            };
            // Apply initial visibility based on current toggle states
            mesh.visible = $a78b7212404532f0$var$getInitialObjectVisibility(mesh);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.add(mesh);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayOriginalMeshes.push(mesh);
        });
    }
    // Display transformed objects in blue
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).arrangementTransformedObjects) {
        console.log("\uD83D\uDCE6 Adding transformed objects (blue)...");
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).arrangementTransformedObjects.forEach((objData)=>{
            if (!objData?.vertices || !Array.isArray(objData.vertices) || objData.vertices.length === 0) {
                console.warn("\u26A0\uFE0F Skipping object with no vertices:", objData);
                return;
            }
            // Create geometry from vertices
            const vertices = new Float32Array(objData.vertices.flat());
            const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
            geometry.setAttribute("position", new $0d79572b4b22d35c$export$8dea267bd6bde117(vertices, 3));
            // Add faces if available
            if (objData.faces && Array.isArray(objData.faces) && objData.faces.length > 0) {
                const faces = objData.faces.flat();
                geometry.setIndex(faces);
                geometry.computeVertexNormals();
            }
            // Apply blue material with transparency enabled
            const blueMaterial = new $0d79572b4b22d35c$export$24c72f71cbaf0678({
                color: 0x4a90e2,
                transparent: true,
                opacity: 1.0,
                side: $0d79572b4b22d35c$export$3b296b6f144d5b03
            });
            const mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, blueMaterial);
            // Set mesh name for getObjectType to work
            mesh.name = objData.name || "";
            // Set user data for visibility controls
            mesh.userData = {
                type: objData.type,
                group: objData.group,
                teethID: objData.teethID,
                descr: objData.descr,
                originalType: objData.originalType,
                layer: "transformed"
            };
            // Apply initial visibility based on current toggle states
            mesh.visible = $a78b7212404532f0$var$getInitialObjectVisibility(mesh);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.add(mesh);
            (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayTransformedMeshes.push(mesh);
        });
    }
    // Auto-position camera
    $a78b7212404532f0$var$autoPositionOverlayCamera();
    // Ensure opacity controls are visible
    $a78b7212404532f0$var$ensureOpacityControlsVisible();
    console.log("\u2705 Overlay display complete");
}
/**
 * Ensure opacity controls are visible and properly positioned
 */ function $a78b7212404532f0$var$ensureOpacityControlsVisible() {
    if (document.getElementById("overlay-opacity-controls")) return;
    // Ensure overlay container exists
    let container = document.getElementById("overlay-view-container");
    if (!container) {
        const mainViewer = document.getElementById("main-viewer");
        if (!mainViewer) return;
        container = document.createElement("div");
        container.id = "overlay-view-container";
        container.style.cssText = "display: none; width: 100%; height: 100%; position: absolute; top: 0; left: 0;";
        const view = document.createElement("div");
        view.className = "view-panel";
        view.id = "overlay-view";
        view.style.cssText = "width: 100% !important; display: block !important; border-right: none !important;";
        container.appendChild(view);
        mainViewer.appendChild(container);
    }
    // Create opacity controls
    const controls = document.createElement("div");
    controls.id = "overlay-opacity-controls";
    controls.style.cssText = "position: absolute; top: 20px; right: 20px; background: rgba(0, 0, 0, 0.8); padding: 15px; border-radius: 8px; color: white; min-width: 220px; z-index: 10000; pointer-events: auto;";
    controls.innerHTML = `
        <div style="margin-bottom: 15px;">
            <label style="display: flex; align-items: center; margin-bottom: 5px; font-size: 12px; font-weight: 600;">
                <span style="display: inline-block; width: 16px; height: 16px; background: #808080; border-radius: 3px; margin-right: 8px;"></span>
                Pre-Arrangement
            </label>
            <input type="range" id="original-opacity-slider" min="0" max="100" value="50" style="width: 100%; accent-color: #808080;">
            <span id="original-opacity-value" style="font-size: 11px;">50%</span>
        </div>
        <div>
            <label style="display: flex; align-items: center; margin-bottom: 5px; font-size: 12px; font-weight: 600;">
                <span style="display: inline-block; width: 16px; height: 16px; background: #4a90e2; border-radius: 3px; margin-right: 8px;"></span>
                Post-Arrangement
            </label>
            <input type="range" id="transformed-opacity-slider" min="0" max="100" value="100" style="width: 100%; accent-color: #4a90e2;">
            <span id="transformed-opacity-value" style="font-size: 11px;">100%</span>
        </div>
    `;
    container.appendChild(controls);
    // Setup slider event listeners
    const setupSlider = (sliderId, valueId, meshArray)=>{
        const slider = document.getElementById(sliderId);
        const valueSpan = document.getElementById(valueId);
        if (slider) slider.oninput = (e)=>{
            const opacity = e.target.value / 100;
            valueSpan.textContent = `${e.target.value}%`;
            meshArray?.forEach((mesh)=>{
                if (mesh.material) mesh.material.opacity = opacity;
            });
        };
    };
    setupSlider("original-opacity-slider", "original-opacity-value", (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayOriginalMeshes);
    setupSlider("transformed-opacity-slider", "transformed-opacity-value", (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayTransformedMeshes);
}
/**
 * Auto-position camera for overlay view to properly frame objects
 */ function $a78b7212404532f0$var$autoPositionOverlayCamera() {
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene || !(0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayCamera) return;
    console.log("\uD83D\uDCF9 Auto-positioning overlay camera...");
    // Calculate bounding box of all objects
    const box = new $0d79572b4b22d35c$export$6f7d5a9418ab2aa3();
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.traverse((object)=>{
        if (object.isMesh) box.expandByObject(object);
    });
    if (box.isEmpty()) {
        console.warn("\u26A0\uFE0F No objects to frame in overlay view");
        return;
    }
    const center = box.getCenter(new $0d79572b4b22d35c$export$64b5c384219d3699());
    const size = box.getSize(new $0d79572b4b22d35c$export$64b5c384219d3699());
    const maxDim = Math.max(size.x, size.y, size.z);
    // Position camera to view from front
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayCamera.position.set(center.x, center.y, center.z + maxDim * 2);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayControls.target.copy(center);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayControls.update();
    console.log("\u2705 Overlay camera positioned");
}
/**
 * Add a view label to distinguish between original and transformed views
 * @param {HTMLElement} viewElement - The view container element
 * @param {string} labelText - The label text to display
 * @param {string} side - "left" or "right" for positioning
 */ function $a78b7212404532f0$var$addViewLabel(viewElement, labelText, side) {
    if (!viewElement) return;
    // Remove existing label if any
    const existingLabel = viewElement.querySelector(".view-label");
    if (existingLabel) existingLabel.remove();
    // Create new label
    const label = document.createElement("div");
    label.className = "view-label";
    label.textContent = labelText;
    label.style.cssText = `
        position: absolute;
        top: 10px;
        ${side === "left" ? "left" : "right"}: 10px;
        background: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 8px 12px;
        border-radius: 6px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
        font-size: 14px;
        font-weight: bold;
        z-index: 1002;
        pointer-events: none;
        border: 1px solid rgba(255, 255, 255, 0.2);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    `;
    viewElement.appendChild(label);
}
function $a78b7212404532f0$var$getBracketColor() {
    return [
        170,
        203,
        255
    ]; // Light blue
}
/**
 * Parse arrangement files and apply InfoJSON transformations
 * @param {Object} infoJson - InfoJSON data containing transformation information
 * @param {Object} options - Configuration options
 * @param {Object} options.feedback - Feedback data (if parsing from feedback)
 * @param {boolean} options.fromFeedback - Whether parsing from feedback or UI inputs
 * @returns {Object} Object containing originalObjects and transformedObjects arrays
 */ async function $a78b7212404532f0$var$parseArrangementFiles(infoJson, options = {}) {
    const { feedback: feedback, fromFeedback: fromFeedback = false } = options;
    const originalObjects = [];
    const transformedObjects = [];
    let lowerJawFile, upperJawFile;
    if (fromFeedback) {
        // Get the mesh files from feedback
        if (!feedback?.meshFiles || feedback.meshFiles.length === 0) {
            console.warn("No mesh files found in feedback data, trying to reconstruct from file data");
            // Try to reconstruct mesh files from feedback file data as fallback
            if (feedback?.files) {
                const meshFiles = [];
                if (feedback.files.lowerJawFile?.file) meshFiles.push(feedback.files.lowerJawFile.file);
                if (feedback.files.upperJawFile?.file) meshFiles.push(feedback.files.upperJawFile.file);
                if (meshFiles.length > 0) {
                    console.log(`\u{1F504} Reconstructed ${meshFiles.length} mesh files from feedback file data`);
                    feedback.meshFiles = meshFiles;
                } else {
                    console.warn("\u26A0\uFE0F No mesh files found in feedback data or file data");
                    return {
                        originalObjects: originalObjects,
                        transformedObjects: transformedObjects
                    };
                }
            } else {
                console.warn("\u26A0\uFE0F No mesh files or file data found in feedback");
                return {
                    originalObjects: originalObjects,
                    transformedObjects: transformedObjects
                };
            }
        }
        // Try to identify lower and upper jaw files from the mesh files
        feedback.meshFiles.forEach((file)=>{
            const fileName = file.name.toLowerCase();
            if (fileName.includes("lower") || fileName.includes("mandibular")) lowerJawFile = file;
            else if (fileName.includes("upper") || fileName.includes("maxillary")) upperJawFile = file;
        });
        // If we can't identify by filename, use the first files as defaults
        if (!lowerJawFile && !upperJawFile) {
            console.log("\uD83D\uDCDD Could not identify jaw files by name, using available files");
            if (feedback.meshFiles.length >= 1) lowerJawFile = feedback.meshFiles[0];
            if (feedback.meshFiles.length >= 2) upperJawFile = feedback.meshFiles[1];
        }
        if (!lowerJawFile && !upperJawFile) {
            console.warn("No jaw files available for parsing");
            return {
                originalObjects: originalObjects,
                transformedObjects: transformedObjects
            };
        }
        console.log(`\u{1F4C1} Identified jaw files:`, {
            lower: lowerJawFile?.name || "None",
            upper: upperJawFile?.name || "None"
        });
    } else // Get files from UI inputs (file upload or Azure paths/folder)
    if ($a78b7212404532f0$var$isAzureInputMode()) {
        // For Azure mode, get the paths and download the files
        const lowerJawAzurePath = document.getElementById("lower-jaw-azure-path").value.trim();
        const upperJawAzurePath = document.getElementById("upper-jaw-azure-path").value.trim();
        if (!lowerJawAzurePath || !upperJawAzurePath) {
            console.warn("Azure paths not found for arrangement InfoJSON processing");
            return {
                originalObjects: originalObjects,
                transformedObjects: transformedObjects
            };
        }
        try {
            console.log("\uD83D\uDCE5 Downloading arrangement files for InfoJSON processing...");
            // Download both files from Azure
            const [downloadedLowerJaw, downloadedUpperJaw] = await Promise.all([
                (0, $913d3a1574de567c$export$ae14c375fc93363).downloadAzureFile(lowerJawAzurePath),
                (0, $913d3a1574de567c$export$ae14c375fc93363).downloadAzureFile(upperJawAzurePath)
            ]);
            lowerJawFile = downloadedLowerJaw;
            upperJawFile = downloadedUpperJaw;
            console.log("\uD83D\uDCE5 Successfully downloaded arrangement files for InfoJSON processing");
        } catch (error) {
            console.error("Error downloading Azure files for InfoJSON processing:", error);
            return {
                originalObjects: originalObjects,
                transformedObjects: transformedObjects
            };
        }
    } else {
        // For file mode, get files from inputs
        lowerJawFile = document.getElementById("lower-jaw-file").files[0];
        upperJawFile = document.getElementById("upper-jaw-file").files[0];
        if (!lowerJawFile || !upperJawFile) {
            console.warn("Original uploaded files not found");
            return {
                originalObjects: originalObjects,
                transformedObjects: transformedObjects
            };
        }
    }
    try {
        // Parse the available OBJ files
        const parsePromises = [];
        const sourceJaws = [];
        if (lowerJawFile) {
            parsePromises.push($a78b7212404532f0$var$parseObjFile(lowerJawFile));
            sourceJaws.push("lower");
        }
        if (upperJawFile) {
            parsePromises.push($a78b7212404532f0$var$parseObjFile(upperJawFile));
            sourceJaws.push("upper");
        }
        if (parsePromises.length === 0) {
            console.warn("No jaw files to parse");
            return {
                originalObjects: originalObjects,
                transformedObjects: transformedObjects
            };
        }
        console.log(`\u{1F504} Parsing ${parsePromises.length} jaw files...`);
        const results = await Promise.all(parsePromises);
        // Combine all objects from parsed files
        let allOriginalObjects = [];
        results.forEach((result, index)=>{
            const sourceJaw = sourceJaws[index];
            const objects = result.objects || [];
            allOriginalObjects = [
                ...allOriginalObjects,
                ...objects.map((obj)=>({
                        ...obj,
                        sourceJaw: sourceJaw
                    }))
            ];
        });
        console.log(`\u{1F9B7} Found ${allOriginalObjects.length} total objects from ${results.length} jaw files`);
        // Check if InfoJSON exists and has Objects
        if (!infoJson || !infoJson.Objects || infoJson.Objects.length === 0) {
            console.log("\u26A0\uFE0F No InfoJSON provided, creating objects directly from OBJ files (no transformations)");
            // When no InfoJSON is provided, just display the OBJ file contents as-is
            // Both original and transformed will be the same (identity transforms)
            allOriginalObjects.forEach((obj)=>{
                // Determine object type based on metadata
                let objType = null;
                let objDescr = obj.metadata?.Type;
                let teethID = obj.teethID;
                // Try to extract teethID from name if not set
                if (teethID === null && obj.name) {
                    const nameMatch = obj.name.match(/^(\d+):/);
                    if (nameMatch) teethID = parseInt(nameMatch[1]);
                }
                // Create a temp object to test with getObjectType
                const tempTestObj = {
                    name: obj.name || "",
                    userData: {
                        type: null,
                        descr: obj.metadata?.Type,
                        teethID: teethID,
                        originalType: obj.metadata?.Type
                    }
                };
                const detectedType = $a78b7212404532f0$var$getObjectType(tempTestObj);
                const isExplicitBracket = obj.metadata?.Type === "BrktAttm";
                const isImplicitBracket = teethID !== null && obj.name && $a78b7212404532f0$var$isBracketByName(obj.name);
                const isBracket = isExplicitBracket || isImplicitBracket;
                if (detectedType === "gingiva") {
                    objType = "gingiva";
                    objDescr = "Gingiva";
                } else if (detectedType === "tooth") {
                    objType = "tooth";
                    objDescr = "Tooth";
                } else if (isBracket) {
                    objType = 107;
                    objDescr = "BrktAttm";
                    console.log(`\u{2705} Identified bracket: ${obj.name} (teethID: ${teethID})`);
                }
                // Determine group (0=upper, 1=lower)
                const group = obj.sourceJaw === "lower" ? 1 : 0;
                const objData = {
                    name: obj.name,
                    vertices: obj.vertices,
                    faces: obj.faces || [],
                    group: group,
                    type: objType,
                    descr: objDescr,
                    color: [
                        255,
                        255,
                        255
                    ],
                    transform: [
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    teethID: teethID,
                    originalType: obj.metadata?.Type
                };
                // Add to both arrays (no transformation)
                originalObjects.push(objData);
                transformedObjects.push({
                    ...objData
                });
            });
            console.log(`\u{1F4CA} Created ${originalObjects.length} objects without InfoJSON (${originalObjects.filter((o)=>o.type === 107).length} brackets)`);
            return {
                originalObjects: originalObjects,
                transformedObjects: transformedObjects
            };
        }
        // InfoJSON exists - process with transformations
        console.log(`\u{1F4CB} Processing ${infoJson.Objects.length} objects from InfoJSON`);
        // Track processed objects to prevent duplicates
        const processedObjNames = new Set();
        let skippedDuplicates = 0;
        // First pass: Build a map of Type 107 bracket attachments for duplicate detection
        const bracketAttachments = new Set();
        infoJson.Objects.forEach((objInfo)=>{
            if (objInfo.Type === 107 && objInfo.Descr === "BrktAttm") bracketAttachments.add(objInfo.Name);
        });
        // Helper function to check if a Type 0 bracket has a corresponding Type 107 attachment
        const hasCorrespondingBracketAttachment = (type0Name)=>{
            // Extract bracket part without tooth number prefix (e.g., "17: 4T-1 - Molar Tube" -> "4T-1 - Molar Tube")
            const bracketPart = type0Name.includes(":") ? type0Name.split(":").slice(1).join(":").trim() : type0Name;
            return bracketAttachments.has(bracketPart);
        };
        // Process each object in InfoJson
        infoJson.Objects.forEach((objInfo, index)=>{
            // Create a unique key for duplicate detection
            let uniqueKey;
            if (objInfo.Type === 107 && objInfo.Descr === "BrktAttm") // For bracket attachments, use Index + Name to ensure uniqueness
            // This handles cases where bracket names don't exactly match between InfoJSON and OBJ
            uniqueKey = `Index${objInfo.Index}_${objInfo.Name}_Type${objInfo.Type}`;
            else // For non-bracket objects, use Index + Name to handle duplicates
            uniqueKey = `Index${objInfo.Index}_${objInfo.Name}`;
            // Skip duplicates based on unique key
            if (processedObjNames.has(uniqueKey)) {
                console.warn(`\u{26A0}\u{FE0F} SKIPPING DUPLICATE InfoJSON object: "${objInfo.Name}" (key: ${uniqueKey})`);
                skippedDuplicates++;
                return;
            }
            processedObjNames.add(uniqueKey);
            // Skip Type 0 bracket objects ONLY if there's a corresponding Type 107 bracket attachment
            if (objInfo.Type === 0 && $a78b7212404532f0$var$isBracketByName(objInfo.Name)) {
                if (hasCorrespondingBracketAttachment(objInfo.Name)) return; // Skip Type 0 bracket - has Type 107 counterpart
            // Keep Type 0 bracket - no Type 107 counterpart found
            }
            // Skip metadata-only objects (planes) - they don't have geometry in OBJ files
            // Type 108 = Maxilla plane, Type 109 = Mandible plane
            if (objInfo.Type === 108 || objInfo.Type === 109) {
                console.log(`\u{1F4D0} Skipping metadata plane: "${objInfo.Name}" (Type: ${objInfo.Type})`);
                return;
            }
            // Find matching original object using flexible matching strategy
            let originalObj = null;
            // Strategy 1: Exact name match
            originalObj = allOriginalObjects.find((obj)=>obj.name === objInfo.Name);
            // Strategy 2: For brackets, match by tooth ID (bracket model can vary)
            if (!originalObj && objInfo.Type === 107) {
                // Match bracket primarily by tooth ID, since bracket model numbers
                // can differ between InfoJSON and OBJ files (e.g., "2M-1" vs "3M-1")
                // Extract tooth ID from InfoJSON bracket name if TeethID is null
                let infoTeethId = objInfo.TeethID;
                if ((infoTeethId === null || infoTeethId === undefined) && objInfo.Name.includes(":")) {
                    const infoToothIdMatch = objInfo.Name.match(/^(\d+):/);
                    if (infoToothIdMatch) {
                        infoTeethId = parseInt(infoToothIdMatch[1]);
                        console.log(`\u{1F4CE} Extracted TeethID ${infoTeethId} from bracket name: "${objInfo.Name}"`);
                    }
                }
                originalObj = allOriginalObjects.find((obj)=>{
                    // Extract tooth ID from OBJ name (e.g., "21: 1X-1 - Metal SL" -> 21)
                    let objToothId = null;
                    if (obj.name.includes(":")) {
                        const toothIdMatch = obj.name.match(/^(\d+):/);
                        if (toothIdMatch) objToothId = parseInt(toothIdMatch[1]);
                    }
                    // Fallback to teethID if available
                    if (objToothId === null && obj.teethID !== undefined) objToothId = obj.teethID;
                    // Match if tooth ID matches AND object is a bracket
                    const toothIdMatches = infoTeethId === objToothId;
                    const isBracket = obj.metadata?.Type === "BrktAttm" || obj.teethID !== undefined || $a78b7212404532f0$var$isBracketByName(obj.name);
                    if (toothIdMatches && isBracket) {
                        // Log if bracket type names differ (for debugging)
                        if (objInfo.Name && obj.name) {
                            const infoBracketType = objInfo.Name.includes(":") ? objInfo.Name.split(":").slice(1).join(":").trim() : objInfo.Name;
                            const objBracketType = obj.name.includes(":") ? obj.name.split(":").slice(1).join(":").trim() : obj.name;
                            if (infoBracketType !== objBracketType) console.log(`\u{1F4CE} Matched bracket by tooth ID ${objToothId}: InfoJSON="${infoBracketType}" vs OBJ="${objBracketType}"`);
                        }
                        return true;
                    }
                    return false;
                });
            }
            // Strategy 3: For non-bracket objects only, try fuzzy matching
            if (!originalObj && !(objInfo.Type === 107 && objInfo.Descr === "BrktAttm") && objInfo.Name // Ensure Name exists before trying to use it
            ) {
                // Only do fuzzy matching for non-bracket objects (teeth, gingiva, etc.)
                const infoNameLower = objInfo.Name.toLowerCase();
                originalObj = allOriginalObjects.find((obj)=>{
                    const objNameLower = obj.name ? obj.name.toLowerCase() : "";
                    // Simple name similarity for non-bracket objects
                    return infoNameLower === objNameLower || infoNameLower.includes(objNameLower) || objNameLower.includes(infoNameLower);
                });
            }
            if (originalObj && originalObj.vertices && originalObj.vertices.length > 0) {
                // Check if transform is identity (skip untransformed brackets in arranged view)
                const isIdentityTransform = objInfo.Transform.every((val, idx)=>{
                    const expectedIdentity = [
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ];
                    return Math.abs(val - expectedIdentity[idx]) < 0.0001;
                });
                // Determine proper color for brackets
                let objectColor = objInfo.Color || [
                    255,
                    255,
                    255
                ];
                // Generate color only if not provided or default white/gray
                if (objInfo.Type === 107 && (!objInfo.Color || objInfo.Color[0] === 255 && objInfo.Color[1] === 255 && objInfo.Color[2] === 255 || objInfo.Color[0] === 0.8 && objInfo.Color[1] === 0.8 && objInfo.Color[2] === 0.8)) objectColor = $a78b7212404532f0$var$getBracketColor();
                // Create original object (no transformation)
                originalObjects.push({
                    name: objInfo.Name,
                    vertices: originalObj.vertices,
                    faces: originalObj.faces || [],
                    group: objInfo.Group,
                    type: objInfo.Type,
                    descr: objInfo.Descr,
                    color: objectColor,
                    transform: [
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    teethID: originalObj.teethID,
                    originalType: originalObj.metadata?.Type // Store original type from .obj file
                });
                // Create transformed object by applying InfoJson transformation
                const transformedVertices = $a78b7212404532f0$var$applyTransformationMatrix(originalObj.vertices, objInfo.Transform);
                transformedObjects.push({
                    name: objInfo.Name,
                    vertices: transformedVertices,
                    faces: originalObj.faces || [],
                    group: objInfo.Group,
                    type: objInfo.Type,
                    descr: objInfo.Descr,
                    color: objectColor,
                    transform: objInfo.Transform,
                    teethID: originalObj.teethID,
                    originalType: originalObj.metadata?.Type,
                    isIdentityTransform: isIdentityTransform // Track identity transforms
                });
            } else {
                // Only warn for objects that should have geometry
                // Types that typically have geometry: teeth (11-48), soft tissue (227-228), brackets (107)
                const shouldHaveGeometry = objInfo.Type >= 11 && objInfo.Type <= 48 || // Teeth
                objInfo.Type === 227 || objInfo.Type === 228 || // Soft tissue
                objInfo.Type === 107; // Brackets
                if (shouldHaveGeometry) console.warn(`\u{26A0}\u{FE0F} No geometry found in OBJ files for: "${objInfo.Name}" (Type: ${objInfo.Type}, Descr: ${objInfo.Descr})`);
                else console.log(`\u{1F4CB} Skipping non-visual object: "${objInfo.Name}" (Type: ${objInfo.Type}, Descr: ${objInfo.Descr})`);
            }
        });
        // Check for brackets in OBJ files that are missing from InfoJSON
        // This handles cases where the Python backend fails to add brackets
        console.log(`\u{1F50D} Checking for brackets in OBJ files not included in InfoJSON...`);
        const infoJsonObjectNames = new Set(infoJson.Objects.map((obj)=>obj.Name));
        const missingBrackets = allOriginalObjects.filter((obj)=>{
            // Check if this is a bracket that's not in InfoJSON
            const isInInfoJson = infoJsonObjectNames.has(obj.name);
            if (isInInfoJson) return false;
            // Check if it's a bracket
            const tempTestObj = {
                name: obj.name || "",
                userData: {
                    type: null,
                    descr: obj.metadata?.Type,
                    teethID: obj.teethID,
                    originalType: obj.metadata?.Type
                }
            };
            const detectedType = $a78b7212404532f0$var$getObjectType(tempTestObj);
            const isExplicitBracket = obj.metadata?.Type === "BrktAttm";
            const isImplicitBracket = obj.teethID !== null && obj.name && $a78b7212404532f0$var$isBracketByName(obj.name);
            return isExplicitBracket || isImplicitBracket || detectedType === "bracket";
        });
        if (missingBrackets.length > 0) {
            console.error(`\u{274C} Found ${missingBrackets.length} brackets in OBJ files that are missing from InfoJSON!`);
            console.error(`This indicates the Python backend failed to add brackets. Please check server logs.`);
            console.error(`Missing bracket names: ${missingBrackets.map((b)=>b.name).join(", ")}`);
        // Don't add brackets on frontend - this should be fixed in the backend
        }
        return {
            originalObjects: originalObjects,
            transformedObjects: transformedObjects
        };
    } catch (error) {
        console.error("Error parsing original files:", error);
        return {
            originalObjects: originalObjects,
            transformedObjects: transformedObjects
        };
    }
}
/**
 * Parse an .obj file following the same logic as Python tm_objects_from_obj_file
 * @param {File} file - The .obj file to parse
 * @returns {Promise<Object>} Promise resolving to parsed OBJ data
 */ function $a78b7212404532f0$var$parseObjFile(file) {
    return new Promise((resolve, reject)=>{
        console.log(`\u{1F50D} Starting to parse OBJ file: ${file.name} (${file.size} bytes)`);
        const reader = new FileReader();
        reader.onload = function(event) {
            try {
                const objContent = event.target.result;
                console.log(`\u{1F50D} OBJ file content loaded: ${objContent.length} characters`);
                if (!objContent || objContent.length === 0) throw new Error("OBJ file is empty");
                const lines = objContent.split("\n");
                console.log(`\u{1F50D} Processing ${lines.length} lines from OBJ file`);
                // Step 1: Read all vertices first (like Python version)
                const allVertices = [];
                // Step 2: Track objects and their faces/metadata
                const objectFaces = {}; // objectName -> list of faces
                const objectMetadata = {}; // objectName -> metadata dict
                let currentObjectName = null;
                let currentMetadata = {};
                lines.forEach((line, lineIndex)=>{
                    line = line.trim();
                    if (line.startsWith("v ")) {
                        // Parse vertex coordinates (x, y, z only)
                        const coords = line.split(/\s+/);
                        if (coords.length >= 4) {
                            const vertex = [
                                parseFloat(coords[1]),
                                parseFloat(coords[2]),
                                parseFloat(coords[3])
                            ];
                            allVertices.push(vertex);
                        }
                    } else if (line.startsWith("g ") || line.startsWith("o ")) {
                        // Object/group definition - get the name
                        const objectName = line.substring(2).trim();
                        if (objectName) {
                            // Only use non-empty names
                            currentObjectName = objectName;
                            if (!objectFaces[currentObjectName]) {
                                objectFaces[currentObjectName] = [];
                                // Use existing metadata if already stored, otherwise use current_metadata
                                if (!objectMetadata[currentObjectName]) objectMetadata[currentObjectName] = {
                                    ...currentMetadata
                                };
                                // Reset current_metadata for next object
                                currentMetadata = {};
                            }
                        }
                    } else if (line.startsWith("f ") && currentObjectName) {
                        // Parse face indices (OBJ uses 1-based indexing)
                        const faceIndices = [];
                        const parts = line.split(/\s+/);
                        for(let i = 1; i < parts.length; i++){
                            const vertexRef = parts[i];
                            // Handle different face formats: v, v/vt, v/vt/vn, v//vn
                            const vertexIdx = parseInt(vertexRef.split("/")[0]) - 1; // Convert to 0-based
                            faceIndices.push(vertexIdx);
                        }
                        if (faceIndices.length >= 3) {
                            // Valid face
                            // For now, assume triangular faces (take first 3 vertices)
                            const face = [
                                faceIndices[0],
                                faceIndices[1],
                                faceIndices[2]
                            ];
                            objectFaces[currentObjectName].push(face);
                        }
                    } else if (line.startsWith("# Object")) {
                        // Handle metadata from comment headers
                        const lineContent = line.substring(2).trim(); // Remove "# " prefix
                        if (lineContent.includes(":")) {
                            if (lineContent.split(":").length === 2 && !lineContent.includes(",")) {
                                // New format: "Object: Name"
                                const objectName = lineContent.split(":")[1].trim();
                                currentMetadata = {};
                            // We'll assign this when we encounter g/o tag
                            } else {
                                // Original format: "Object0: Name, Type: TypeName"
                                const parts = lineContent.split(",");
                                const objectNamePart = parts[0];
                                // Extract object name - handle formats like "Object45: 36: 4Y-2 - Metal SL"
                                let objectName;
                                let teethID = null;
                                if (objectNamePart.includes(":")) {
                                    const nameParts = objectNamePart.split(":");
                                    if (nameParts.length >= 3) {
                                        // Format: "Object45: 36: 4Y-2 - Metal SL"
                                        const nameAndId = nameParts.slice(1).join(":").trim();
                                        // Try to extract teethID and name
                                        const teethMatch = nameAndId.match(/^(\d+):\s*(.+)$/);
                                        if (teethMatch) {
                                            teethID = parseInt(teethMatch[1]);
                                            objectName = teethMatch[2].trim();
                                        } else objectName = nameAndId;
                                    } else // Format: "Object: Name"
                                    objectName = nameParts[1].trim();
                                } else objectName = objectNamePart.trim();
                                currentMetadata = {};
                                if (teethID !== null) currentMetadata.teethID = teethID;
                                // Parse Type from remaining parts
                                for(let i = 1; i < parts.length; i++){
                                    const part = parts[i].trim();
                                    if (part.includes("Type:")) {
                                        const type = part.split(":")[1].trim();
                                        currentMetadata.Type = type;
                                    }
                                }
                                // Store metadata for this specific object name
                                if (!objectMetadata[objectName]) objectMetadata[objectName] = {
                                    ...currentMetadata
                                };
                            }
                        }
                    } else if (line.startsWith("# ") && line.includes(":") && !line.startsWith("# Object")) {
                        // Regular metadata: "# key: value"
                        const metadataLine = line.substring(2); // Remove "# "
                        const colonIndex = metadataLine.indexOf(":");
                        if (colonIndex > 0) {
                            const key = metadataLine.substring(0, colonIndex).trim();
                            const value = metadataLine.substring(colonIndex + 1).trim();
                            currentMetadata[key] = value;
                        }
                    }
                });
                // Step 3: Group vertices into objects based on face indices (like Python)
                const objects = [];
                for (const [objectName, faces] of Object.entries(objectFaces)){
                    if (!faces || faces.length === 0) continue; // Skip objects with no faces
                    // Find all unique vertex indices used by this object
                    const uniqueVertexIndices = [
                        ...new Set(faces.flat())
                    ];
                    // Validate vertex indices
                    const validIndices = uniqueVertexIndices.filter((idx)=>idx >= 0 && idx < allVertices.length);
                    if (validIndices.length === 0) continue; // Skip objects with no valid vertices
                    // Extract vertices for this object
                    const objectVertices = validIndices.map((idx)=>allVertices[idx]);
                    // Remap face indices to local vertex indices
                    const vertexIndexMap = {};
                    validIndices.forEach((oldIdx, newIdx)=>{
                        vertexIndexMap[oldIdx] = newIdx;
                    });
                    const remappedFaces = faces.map((face)=>face.map((idx)=>vertexIndexMap[idx])).filter((face)=>face.every((idx)=>idx !== undefined));
                    // Create object with metadata
                    const metadata = objectMetadata[objectName] || {};
                    let teethID = metadata.teethID || null;
                    // If metadata doesn't have Type set, try to infer it from the object name
                    if (!metadata.Type) // Check if this is a bracket by name pattern: "tooth_number: bracket_description"
                    {
                        if (objectName.includes(":")) {
                            const nameMatch = objectName.match(/^(\d+):\s*(.+)$/);
                            if (nameMatch) {
                                const potentialTeethID = parseInt(nameMatch[1]);
                                const bracketDesc = nameMatch[2].trim();
                                // Validate this looks like a bracket (not a tooth)
                                if (!objectName.startsWith("Tooth ") && !objectName.includes("Soft Tissue") && !objectName.includes("Plane") && $a78b7212404532f0$var$isBracketByName(objectName)) {
                                    // This is a bracket!
                                    metadata.Type = "BrktAttm";
                                    if (teethID === null) {
                                        teethID = potentialTeethID;
                                        metadata.teethID = teethID;
                                    }
                                    console.log(`\u{1F527} Inferred bracket type for: ${objectName} (teethID: ${teethID})`);
                                }
                            }
                        }
                    }
                    const obj = {
                        id: `Object_${objects.length}`,
                        name: objectName,
                        vertices: objectVertices,
                        faces: remappedFaces,
                        metadata: metadata,
                        teethID: teethID
                    };
                    // Object created successfully
                    objects.push(obj);
                }
                if (objects.length === 0) {
                    console.log(`\u{26A0}\u{FE0F} No objects found in file "${file.name}" - trying fallback parsing`);
                    // Fallback: create a single object with all vertices/faces
                    if (allVertices.length > 0) objects.push({
                        id: "Object_0",
                        name: file.name.replace(".obj", ""),
                        vertices: allVertices,
                        faces: [],
                        metadata: {},
                        teethID: null
                    });
                }
                // Parsing completed successfully
                console.log(`\u{1F50D} Parsing complete for ${file.name}: ${objects.length} objects found`);
                console.log("\uD83D\uDD0D Objects summary:", objects.map((obj)=>({
                        name: obj.name,
                        id: obj.id,
                        vertexCount: obj.vertices?.length || 0,
                        faceCount: obj.faces?.length || 0,
                        metadata: obj.metadata,
                        teethID: obj.teethID
                    })));
                resolve({
                    objects: objects
                });
            } catch (error) {
                console.error(`\u{274C} Error parsing OBJ file "${file.name}":`, error);
                reject(error);
            }
        };
        reader.onerror = function() {
            reject(new Error(`Failed to read file: ${file.name}`));
        };
        reader.readAsText(file);
    });
}
/**
 * Clear all multi-view scenes
 */ function $a78b7212404532f0$var$clearMultiViewScenes() {
    Object.values((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes).forEach((scene)=>{
        if (scene) {
            // Remove all meshes from scene
            const meshesToRemove = scene.children.filter((child)=>child.isMesh);
            meshesToRemove.forEach((mesh)=>{
                scene.remove(mesh);
                if (mesh.geometry) mesh.geometry.dispose();
                if (mesh.material) {
                    if (Array.isArray(mesh.material)) mesh.material.forEach((mat)=>mat.dispose());
                    else mesh.material.dispose();
                }
            });
            // Remove all CSS2D labels from scene
            const labelsToRemove = scene.children.filter((child)=>child.isCSS2DObject);
            labelsToRemove.forEach((label)=>{
                scene.remove(label);
            });
        }
    });
}
// Feedback Review Mode Functions
function $a78b7212404532f0$var$switchApplicationMode(mode) {
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode = mode === "feedback";
    // Clear any existing state
    $a78b7212404532f0$var$clearAllFilesAndState();
    // Show/hide appropriate sections
    const processingModeSection = document.getElementById("processing-mode-section");
    const feedbackModeSection = document.getElementById("feedback-mode-section");
    const fileSelectionSection = document.getElementById("file-selection-section");
    const processActionsRow = document.querySelector(".process-actions-row");
    const currentMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode) {
        // Switch to feedback review mode
        console.log("\uD83D\uDD04 Switching to Feedback Review Mode");
        if (processingModeSection) processingModeSection.style.display = "none";
        if (feedbackModeSection) feedbackModeSection.style.display = "block";
        if (fileSelectionSection) fileSelectionSection.style.display = "none";
        if (processActionsRow) processActionsRow.style.display = "none";
        const refineBtnFeedback = document.getElementById("refine-button");
        if (refineBtnFeedback) refineBtnFeedback.style.display = "none";
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Switched to Feedback Review Mode", "info");
        // Clear processing state
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData = [];
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).currentFeedbackIndex = 0;
        // Hide feedback details section initially
        const feedbackDetailsSection = document.getElementById("feedback-details-section");
        if (feedbackDetailsSection) feedbackDetailsSection.style.display = "none";
        // Show right sidebar in feedback mode but start collapsed
        const rightSidebar = document.getElementById("right-sidebar");
        const appContainer = document.querySelector(".app-container");
        const collapseRightBtn = document.getElementById("collapse-right");
        if (rightSidebar && appContainer) {
            rightSidebar.style.display = "block";
            appContainer.classList.remove("hide-right-sidebar");
            // Start collapsed by default
            rightSidebar.classList.add("right-sidebar-collapsed");
            appContainer.classList.add("right-collapsed");
            if (collapseRightBtn) {
                collapseRightBtn.innerHTML = "\u276E";
                collapseRightBtn.title = "Expand sidebar";
            }
        }
    } else {
        // Switch to processing mode
        console.log("\uD83D\uDD04 Switching to Processing Mode");
        if (processingModeSection) processingModeSection.style.display = "block";
        if (feedbackModeSection) feedbackModeSection.style.display = "none";
        if (fileSelectionSection) fileSelectionSection.style.display = "block";
        if (processActionsRow) processActionsRow.style.display = "flex";
        // Hide feedback details section
        const feedbackDetailsSection = document.getElementById("feedback-details-section");
        if (feedbackDetailsSection) feedbackDetailsSection.style.display = "none";
        // Hide right sidebar in processing mode
        const rightSidebar = document.getElementById("right-sidebar");
        const appContainer = document.querySelector(".app-container");
        if (rightSidebar && appContainer) {
            rightSidebar.style.display = "none";
            appContainer.classList.add("hide-right-sidebar");
        }
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Switched to Processing Mode", "info");
        // Update file selection UI for current processing mode
        $a78b7212404532f0$var$updateFileSelectionUI(currentMode);
        $a78b7212404532f0$var$updateModeInstructions(currentMode);
    }
    // Re-assert the Processing Mode selector / divider visibility for the new
    // application mode so a disabled selector stays hidden after switching back
    // from Review, and the leading divider is correct in each mode.
    $a78b7212404532f0$var$updateProcessingModeSelectorVisibility();
    // Update postprocessing section visibility
    (0, $ddb3f022a87c2bc1$export$7de7bccc87a83087)();
    $a78b7212404532f0$var$updateModelOptionsSectionVisibility(currentMode);
    $a78b7212404532f0$var$updateClearButtonFromState();
    $a78b7212404532f0$var$updateArrangementActionButtons();
    // Trigger window resize to adjust layout
    setTimeout(()=>{
        $a78b7212404532f0$var$onWindowResize();
    }, 100);
}
async function $a78b7212404532f0$var$handleFeedbackDirectorySelection() {
    try {
        if (!window.showDirectoryPicker) {
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Directory picker not supported. Please use a modern browser (Chrome 86+, Edge 86+)", "error");
            return;
        }
        console.log("\uD83D\uDCC2 Selecting feedback directory...");
        const directoryHandle = await window.showDirectoryPicker();
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Loading feedback data...", "info");
        // Scan the directory recursively for feedback files
        const feedbackFiles = await $a78b7212404532f0$var$scanFeedbackDirectory(directoryHandle);
        console.log(`\u{1F4CB} Found ${feedbackFiles.length} feedback files:`, feedbackFiles.map((f)=>f.webkitRelativePath));
        if (feedbackFiles.length === 0) {
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No feedback files found in the selected directory", "warning");
            return;
        }
        // Parse feedback files
        const feedbackData = await (0, $3229c9fdc637713a$export$d1abe408b3392df1)(feedbackFiles);
        console.log(`\u{2705} Parsed ${feedbackData.length} feedback items`);
        // Store feedback data
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData = feedbackData;
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).currentFeedbackIndex = 0;
        // Update UI
        $a78b7212404532f0$var$updateFeedbackFolderStatus(directoryHandle.name, feedbackData.length);
        $a78b7212404532f0$var$updateFeedbackNavigation();
        $a78b7212404532f0$var$updateFeedbackCasesList(feedbackData);
        // Display first feedback item
        if (feedbackData.length > 0) {
            // Auto-switch to the processing mode of the first feedback item
            const firstFeedback = feedbackData[0];
            if (firstFeedback.processingMode && firstFeedback.valid) $a78b7212404532f0$var$switchToProcessingMode(firstFeedback.processingMode);
            await $a78b7212404532f0$var$displayFeedback(0);
            // Show feedback details section in right sidebar
            const feedbackDetailsSection = document.getElementById("feedback-details-section");
            if (feedbackDetailsSection) feedbackDetailsSection.style.display = "block";
            // Make sure right sidebar is expanded
            const rightSidebar = document.getElementById("right-sidebar");
            if (rightSidebar && rightSidebar.classList.contains("right-sidebar-collapsed")) $a78b7212404532f0$var$toggleRightSidebar();
        }
        // Show statistics
        const stats = (0, $3229c9fdc637713a$export$826b115f41be2836)(feedbackData);
        console.log("\uD83D\uDCCA Feedback Statistics:", stats);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Loaded ${feedbackData.length} feedback items from ${directoryHandle.name}`, "check-circle");
    } catch (error) {
        console.error("Error loading feedback directory:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Error loading feedback directory: ${error.message}`, "error");
    }
}
async function $a78b7212404532f0$var$scanFeedbackDirectory(directoryHandle) {
    const feedbackFiles = [];
    const scanDirectory = async (dirHandle, basePath = "")=>{
        for await (const [name, handle] of dirHandle.entries()){
            const path = basePath ? `${basePath}/${name}` : name;
            if (handle.kind === "directory") // Recursively scan subdirectories
            await scanDirectory(handle, path);
            else if (handle.kind === "file") // Check if this is a feedback-related file
            {
                if ($a78b7212404532f0$var$isFeedbackFile(name)) {
                    const file = await handle.getFile();
                    // Add webkitRelativePath property for compatibility with existing parser
                    Object.defineProperty(file, "webkitRelativePath", {
                        value: path,
                        writable: false
                    });
                    feedbackFiles.push(file);
                }
            }
        }
    };
    await scanDirectory(directoryHandle);
    return feedbackFiles;
}
function $a78b7212404532f0$var$isFeedbackFile(filename) {
    const fileName = filename.toLowerCase();
    return fileName === "feedback.json" || fileName === "form_data.json" || fileName === "feedback_complete.json" || fileName.endsWith(".obj") || fileName.endsWith(".stl") || fileName.endsWith(".csv") || // Include CSV files too
    fileName.endsWith(".json") && (fileName.includes("result") || fileName.includes("prediction") || fileName.includes("inference"));
}
function $a78b7212404532f0$var$updateFeedbackFolderStatus(folderName, count) {
    const folderStatus = document.getElementById("feedback-folder-status");
    const folderNameElement = document.getElementById("feedback-folder-name");
    const feedbackCount = document.getElementById("feedback-count");
    if (folderStatus && folderNameElement && feedbackCount) {
        folderNameElement.textContent = `\u{1F4C1} ${folderName}`;
        feedbackCount.textContent = `${count} items loaded`;
        folderStatus.style.display = "block";
    }
}
function $a78b7212404532f0$var$updateFeedbackNavigation() {
    const navigation = document.getElementById("feedback-navigation");
    const prevBtn = document.getElementById("prev-feedback-btn");
    const nextBtn = document.getElementById("next-feedback-btn");
    const currentIndex = document.getElementById("current-feedback-index");
    const totalCount = document.getElementById("total-feedback-count");
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData.length > 0) {
        if (navigation) navigation.style.display = "block";
        // Update counter
        if (currentIndex) currentIndex.textContent = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).currentFeedbackIndex + 1;
        if (totalCount) totalCount.textContent = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData.length;
        // Update button states
        if (prevBtn) prevBtn.disabled = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).currentFeedbackIndex === 0;
        if (nextBtn) nextBtn.disabled = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).currentFeedbackIndex === (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData.length - 1;
    } else if (navigation) navigation.style.display = "none";
}
function $a78b7212404532f0$var$navigateFeedback(direction) {
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData.length === 0) return;
    const newIndex = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).currentFeedbackIndex + direction;
    if (newIndex >= 0 && newIndex < (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData.length) {
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).currentFeedbackIndex = newIndex;
        $a78b7212404532f0$var$displayFeedback(newIndex);
        $a78b7212404532f0$var$updateFeedbackNavigation();
        $a78b7212404532f0$var$updateFeedbackCasesListSelection();
    }
}
function $a78b7212404532f0$var$updateFeedbackCasesList(feedbackData) {
    console.log("\uD83D\uDCCB Updating feedback cases list with", feedbackData.length, "items");
    // Create or update the feedback cases list container
    let casesContainer = document.getElementById("feedback-cases-list");
    if (!casesContainer) {
        // Create the cases list container if it doesn't exist
        const feedbackModeSection = document.getElementById("feedback-mode-section");
        if (!feedbackModeSection) return;
        casesContainer = document.createElement("div");
        casesContainer.id = "feedback-cases-list";
        casesContainer.className = "feedback-cases-list";
        casesContainer.innerHTML = `
            <div class="cases-header">
                <h4>Feedback Cases</h4>
                <div class="cases-count" id="feedback-cases-count">0 cases</div>
            </div>
            <div class="cases-list-container" id="cases-list-container">
                <!-- Cases will be populated here -->
            </div>
        `;
        feedbackModeSection.appendChild(casesContainer);
    }
    // Update cases count
    const casesCount = document.getElementById("feedback-cases-count");
    if (casesCount) casesCount.textContent = `${feedbackData.length} cases`;
    // Populate the cases list
    const listContainer = document.getElementById("cases-list-container");
    if (!listContainer) return;
    listContainer.innerHTML = "";
    feedbackData.forEach((feedback, index)=>{
        const caseItem = document.createElement("div");
        caseItem.className = "feedback-case-item";
        if (index === (0, $66dbd4fb7330af32$export$8e769ad4338a911e).currentFeedbackIndex) caseItem.classList.add("active");
        if (!feedback.valid) caseItem.classList.add("invalid");
        // Format processing mode
        const formattedMode = (0, $3229c9fdc637713a$export$e3c93597035f1506)(feedback.processingMode);
        const modeClass = feedback.processingMode || "unknown";
        // Format date and time
        let dateTimeStr = "Unknown date";
        if (feedback.date) {
            const dateStr = feedback.date.toLocaleDateString();
            const timeStr = feedback.date.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit"
            });
            dateTimeStr = `${dateStr} at ${timeStr}`;
        }
        // Create star rating
        const stars = [];
        for(let i = 1; i <= 5; i++){
            const star = document.createElement("span");
            star.className = `star-mini ${i <= (feedback.rating || 0) ? "filled" : "empty"}`;
            star.textContent = "\u2605";
            stars.push(star);
        }
        caseItem.innerHTML = `
            <div class="case-header">
                <div class="case-id" title="${feedback.id}">${feedback.id.substring(0, 8)}...</div>
                <div class="case-rating"></div>
            </div>
            <div class="case-info">
                <div class="case-doctor">Dr. ${feedback.doctorName || "Unknown"}</div>
                <div class="case-datetime">${dateTimeStr}</div>
                <div class="case-mode ${modeClass}">${formattedMode}</div>
                ${!feedback.valid ? `<div class="case-error">\u{26A0} ${feedback.error}</div>` : ""}
            </div>
        `;
        // Add the star rating
        const ratingContainer = caseItem.querySelector(".case-rating");
        stars.forEach((star)=>ratingContainer.appendChild(star));
        // Add click handler to navigate to this case
        caseItem.addEventListener("click", ()=>{
            $a78b7212404532f0$var$navigateToFeedbackCase(index);
        });
        listContainer.appendChild(caseItem);
    });
    // Show the cases list
    casesContainer.style.display = "block";
    console.log("\u2705 Feedback cases list updated successfully");
}
function $a78b7212404532f0$var$navigateToFeedbackCase(index) {
    if (index >= 0 && index < (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData.length) {
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).currentFeedbackIndex = index;
        $a78b7212404532f0$var$displayFeedback(index);
        $a78b7212404532f0$var$updateFeedbackNavigation();
        $a78b7212404532f0$var$updateFeedbackCasesListSelection();
    }
}
function $a78b7212404532f0$var$updateFeedbackCasesListSelection() {
    const caseItems = document.querySelectorAll(".feedback-case-item");
    caseItems.forEach((item, index)=>{
        if (index === (0, $66dbd4fb7330af32$export$8e769ad4338a911e).currentFeedbackIndex) item.classList.add("active");
        else item.classList.remove("active");
    });
}
async function $a78b7212404532f0$var$displayFeedback(index) {
    if (index < 0 || index >= (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData.length) return;
    const feedback = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackData[index];
    try {
        // Clear previous visualization
        $a78b7212404532f0$var$clearVisualization();
        // Reset view mode to dual when switching feedback items
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayViewMode = "dual";
        const overlayViewContainer = document.getElementById("overlay-view-container");
        if (overlayViewContainer) overlayViewContainer.style.display = "none";
        const multiViewContainer = document.getElementById("multi-view-container");
        if (multiViewContainer) multiViewContainer.style.display = "none";
        // Reset the toggle to dual view
        const viewModeToggle = document.getElementById("arrangement-view-mode-toggle");
        if (viewModeToggle) {
            const toggleOptions = viewModeToggle.querySelectorAll(".toggle-option");
            toggleOptions.forEach((opt)=>{
                if (opt.getAttribute("data-mode") === "dual") opt.classList.add("active");
                else opt.classList.remove("active");
            });
        }
        // Check if this is a valid feedback item
        if (!feedback.valid) {
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Invalid feedback item: ${feedback.error || "Unknown error"}`, "warning");
            $a78b7212404532f0$var$updateFeedbackDetailsPanel(feedback);
            return;
        }
        console.log(`\u{1F50D} Displaying feedback: ${feedback.id}, Mode: ${feedback.processingMode}`);
        // Auto-switch processing mode if needed
        if (feedback.processingMode && feedback.valid) $a78b7212404532f0$var$switchToProcessingMode(feedback.processingMode);
        // Special handling for arrangement feedbacks
        if (feedback.processingMode === "arrangement" && feedback.predictionData?.arrangement_result) {
            console.log("\uD83E\uDDB7 Displaying arrangement feedback with dual view");
            await $a78b7212404532f0$var$displayArrangementFeedback(feedback);
        } else {
            // Regular processing for other modes
            console.log(`\u{1F4E6} Processing regular mode: ${feedback.processingMode}`);
            console.log(`\u{1F4C1} Available mesh files: ${feedback.meshFiles?.length || 0}`, feedback.meshFiles?.map((f)=>f.name) || []);
            // Load and display the mesh
            if (feedback.meshFiles && feedback.meshFiles.length > 0) {
                console.log(`\u{1F504} Loading mesh file: ${feedback.meshFiles[0].name}`);
                try {
                    await $a78b7212404532f0$var$loadMeshFromFeedback(feedback.meshFiles[0]);
                    console.log(`\u{2705} Mesh loaded successfully`);
                } catch (error) {
                    console.error(`\u{274C} Error loading mesh:`, error);
                    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Error loading mesh: ${error.message}`, "error");
                }
            } else {
                console.warn(`\u{26A0}\u{FE0F} No mesh files found in feedback data, trying to reconstruct from file data`);
                // Try to reconstruct mesh files from feedback file data as fallback
                let meshFileToLoad = null;
                if (feedback?.files?.inputFile?.file) {
                    meshFileToLoad = feedback.files.inputFile.file;
                    console.log(`\u{1F504} Using reconstructed mesh file: ${meshFileToLoad.name}`);
                }
                if (meshFileToLoad) try {
                    await $a78b7212404532f0$var$loadMeshFromFeedback(meshFileToLoad);
                    console.log(`\u{2705} Mesh loaded successfully from reconstructed file data`);
                } catch (error) {
                    console.error(`\u{274C} Error loading reconstructed mesh:`, error);
                    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Error loading mesh: ${error.message}`, "error");
                }
                else {
                    console.warn(`\u{26A0}\u{FE0F} No mesh files or file data found in feedback`);
                    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No mesh files (.obj/.stl) found in this feedback item", "warning");
                }
            }
            // Apply prediction results if available
            if (feedback.predictionData) {
                console.log(`\u{1F3A8} Applying prediction results for mode: ${feedback.processingMode}`);
                $a78b7212404532f0$var$applyPredictionResults(feedback.predictionData, feedback.processingMode);
            } else console.log(`\u{2139}\u{FE0F} No prediction data available`);
        }
        // Update details panel
        $a78b7212404532f0$var$updateFeedbackDetailsPanel(feedback);
    } catch (error) {
        console.error("Error displaying feedback:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Error displaying feedback: ${error.message}`, "error");
    }
}
async function $a78b7212404532f0$var$loadMeshFromFeedback(file) {
    console.log(`\u{1F527} loadMeshFromFeedback: Starting to load ${file.name} (${file.size} bytes)`);
    const fileExtension = file.name.split(".").pop().toLowerCase();
    console.log(`\u{1F4C4} File extension: ${fileExtension}`);
    let tmpMesh;
    if (fileExtension === "obj") {
        console.log(`\u{1F504} Loading OBJ file...`);
        tmpMesh = await (0, $b28963ea5393104c$export$8b4e6220de066d27)(file);
    } else if (fileExtension === "stl") {
        console.log(`\u{1F504} Loading STL file...`);
        tmpMesh = await (0, $b28963ea5393104c$export$10855d30050361d4)(file);
    } else throw new Error(`Unsupported file format: ${fileExtension}`);
    console.log(`\u{1F4CB} Loaded mesh result:`, tmpMesh ? "Success" : "Failed");
    if (tmpMesh && tmpMesh.geometry) console.log(`\u{1F4D0} Mesh geometry vertices: ${tmpMesh.geometry.attributes.position?.count || "Unknown"}`);
    if (!tmpMesh) throw new Error("Failed to load mesh");
    const geometry = tmpMesh.geometry;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, new $0d79572b4b22d35c$export$f2980790215acccd({
        side: $0d79572b4b22d35c$export$3b296b6f144d5b03,
        vertexColors: true,
        metalness: 0.3,
        roughness: 0.5
    }));
    // Initialize color attribute if not present
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry.attributes.color) {
        const colors = new Float32Array((0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry.attributes.position.count * 3);
        colors.fill(1);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry.setAttribute("color", new $0d79572b4b22d35c$export$8dea267bd6bde117(colors, 3));
    }
    // Remove any existing mesh
    const existingMesh = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.getObjectByName("mesh");
    if (existingMesh) {
        console.log(`\u{1F5D1}\u{FE0F} Removing existing mesh from scene`);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(existingMesh);
    }
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.name = "mesh";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add((0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh);
    console.log(`\u{2705} Mesh added to scene with ${(0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry.attributes.position.count} vertices`);
    console.log(`\u{1F3AD} Scene now has ${(0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children.length} children`);
    // Frame the object in view
    $a78b7212404532f0$var$frameObject();
}
function $a78b7212404532f0$var$frameObject() {
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh) {
        console.warn(`\u{26A0}\u{FE0F} frameObject: No mesh to frame`);
        return;
    }
    console.log(`\u{1F4F9} Framing object in view...`);
    // Calculate bounding box
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry.computeBoundingBox();
    const box = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh.geometry.boundingBox;
    const size = box.getSize(new $0d79572b4b22d35c$export$64b5c384219d3699());
    const center = box.getCenter(new $0d79572b4b22d35c$export$64b5c384219d3699());
    console.log(`\u{1F4E6} Mesh bounding box - Center: (${center.x.toFixed(2)}, ${center.y.toFixed(2)}, ${center.z.toFixed(2)}), Size: (${size.x.toFixed(2)}, ${size.y.toFixed(2)}, ${size.z.toFixed(2)})`);
    // Position camera to frame the object
    const maxDimension = Math.max(size.x, size.y, size.z);
    const distance = maxDimension * 1.5;
    console.log(`\u{1F4F9} Positioning camera at distance ${distance.toFixed(2)} from center`);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).camera.position.set(center.x, center.y, center.z + distance);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.target.copy(center);
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).controls.update();
    console.log(`\u{2705} Camera positioned successfully`);
}
async function $a78b7212404532f0$var$displayArrangementFeedback(feedback) {
    console.log("\uD83E\uDDB7 Displaying arrangement feedback with dual jaw view");
    if (!feedback.predictionData?.arrangement_result) {
        console.warn("No arrangement result data");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No arrangement result data available", "warning");
        return;
    }
    // Check if we have InfoJSON data (similar to main displayArrangementResults)
    const arrangementResult = feedback.predictionData.arrangement_result;
    if (!arrangementResult.info_json || !arrangementResult.info_json.Objects) {
        console.warn("No InfoJSON data found in arrangement feedback");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No InfoJSON data found in arrangement feedback", "warning");
        return;
    }
    console.log("\uD83D\uDD04 Starting arrangement feedback display...");
    // Parse feedback files and create arrangement objects using InfoJSON
    const { originalObjects: originalObjects, transformedObjects: transformedObjects } = await $a78b7212404532f0$var$parseArrangementFiles(arrangementResult.info_json, {
        feedback: feedback,
        fromFeedback: true
    });
    console.log(`\u{1F4CA} Parsed feedback objects - Original: ${originalObjects.length}, Transformed: ${transformedObjects.length}`);
    // Ensure we have objects to display before setting up views
    if (originalObjects.length === 0 && transformedObjects.length === 0) {
        console.warn("\u26A0\uFE0F No objects found to display from feedback");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No objects found to display from feedback", "warning");
        return;
    }
    // Ensure multi-view container exists
    const multiViewContainer = document.getElementById("multi-view-container");
    if (!multiViewContainer) {
        console.error("\u274C Multi-view container not found!");
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Display error: Multi-view container missing", "error");
        return;
    }
    // Hide the original single view and show multi-view container
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "none";
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "none";
    console.log("\uD83D\uDDA5\uFE0F Setting up multi-view display for feedback...");
    multiViewContainer.style.display = "block";
    // Ensure multi-view container is properly visible
    console.log(`\u{1F4FA} Multi-view container display: ${multiViewContainer.style.display}`);
    console.log(`\u{1F4FA} Multi-view container dimensions: ${multiViewContainer.offsetWidth}x${multiViewContainer.offsetHeight}`);
    // Check if the individual view panels exist
    const originalView = document.getElementById("original-view");
    const segmentedView = document.getElementById("segmented-view");
    console.log(`\u{1F4FA} Original view exists: ${!!originalView}, display: ${originalView?.style.display}`);
    console.log(`\u{1F4FA} Segmented view exists: ${!!segmentedView}, display: ${segmentedView?.style.display}`);
    // Force visibility of view panels
    if (originalView) {
        originalView.style.display = "block";
        originalView.style.visibility = "visible";
    }
    if (segmentedView) {
        segmentedView.style.display = "block";
        segmentedView.style.visibility = "visible";
    }
    // Initialize multi-view renderers if needed
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewRenderers.original) {
        console.log("\uD83D\uDD27 Initializing multi-view renderers for feedback...");
        $a78b7212404532f0$var$initializeMultiViewRenderers();
    }
    // Clear existing scenes and setup layout
    $a78b7212404532f0$var$clearMultiViewScenes();
    $a78b7212404532f0$var$setupArrangementMultiViewLayout();
    try {
        console.log(`\u{1F3AC} About to display objects:`);
        console.log(`   - Original objects: ${originalObjects.length}`);
        console.log(`   - Transformed objects: ${transformedObjects.length}`);
        console.log(`   - Scene keys:`, Object.keys((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes));
        console.log(`   - Original scene exists:`, !!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.original);
        console.log(`   - Segmented scene exists:`, !!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.segmented);
        // Store objects in global state for view mode switching
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).arrangementOriginalObjects = originalObjects;
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).arrangementTransformedObjects = transformedObjects;
        // Show the view mode toggle
        const viewModeContainer = document.getElementById("arrangement-view-mode-container");
        if (viewModeContainer) viewModeContainer.style.display = "block";
        // Display objects in both views (same as main arrangement display)
        console.log(`\u{1F3A8} Displaying original objects in "Original Position" scene...`);
        await $a78b7212404532f0$var$displayArrangementObjectsInScene(originalObjects, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.original, "Original Position", true // Enable jaw toggles
        );
        console.log(`\u{1F3A8} Displaying transformed objects in "Arranged Position" scene...`);
        await $a78b7212404532f0$var$displayArrangementObjectsInScene(transformedObjects, (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes.segmented, "Arranged Position", true // Enable jaw toggles
        );
        // Auto-position cameras to show the arrangement
        console.log(`\u{1F4F9} Auto-positioning cameras for both scenes...`);
        $a78b7212404532f0$var$autoPositionArrangementCameras();
        // Setup targeted camera synchronization for arrangement views
        $a78b7212404532f0$var$setupArrangementCameraSynchronization();
        // Note: Jaw toggle controls removed - visibility controls are now in the left sidebar
        $a78b7212404532f0$var$cleanupFloatingJawControls();
        console.log(`\u{1F9B7} Jaw toggle controls skipped - using left sidebar...`);
        console.log(`\u{2705} Arrangement feedback display setup completed successfully`);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Arrangement feedback displayed with dual jaw view", "check-circle");
    } catch (error) {
        console.error("Error setting up arrangement feedback display:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Error displaying arrangement: ${error.message}`, "error");
    }
}
function $a78b7212404532f0$var$applyPredictionResults(predictionData, processingMode) {
    if (processingMode === "keypointml" && predictionData.keypoints) $a78b7212404532f0$var$addKeypoints(predictionData.keypoints);
    else if ((processingMode === "teethml" || processingMode === "defectml") && predictionData.labels) $a78b7212404532f0$var$applyInferenceColors(predictionData);
}
function $a78b7212404532f0$var$updateFeedbackDetailsPanel(feedback) {
    // Update basic information
    const doctorName = document.getElementById("feedback-doctor-name");
    const processingMode = document.getElementById("feedback-processing-mode");
    const starRating = document.getElementById("feedback-star-rating");
    const feedbackDate = document.getElementById("feedback-date");
    if (doctorName) doctorName.textContent = feedback.doctorName || "-";
    if (processingMode) processingMode.textContent = (0, $3229c9fdc637713a$export$e3c93597035f1506)(feedback.processingMode) || "-";
    if (feedbackDate) {
        if (feedback.date) {
            const dateStr = feedback.date.toLocaleDateString();
            const timeStr = feedback.date.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit"
            });
            feedbackDate.textContent = `${dateStr} at ${timeStr}`;
        } else feedbackDate.textContent = "-";
    }
    // Update star rating
    if (starRating) {
        starRating.innerHTML = "";
        if (feedback.rating) for(let i = 1; i <= 5; i++){
            const star = document.createElement("span");
            star.className = "star";
            star.textContent = "\u2605";
            if (i <= feedback.rating) star.style.color = "#ffc107";
            else {
                star.classList.add("empty");
                star.style.color = "#ddd";
            }
            starRating.appendChild(star);
        }
        else starRating.textContent = "-";
    }
    // Update questions and responses
    $a78b7212404532f0$var$updateFeedbackQuestions(feedback);
    // Update file information
    $a78b7212404532f0$var$updateFeedbackFileList(feedback);
    // Update comments
    $a78b7212404532f0$var$updateFeedbackComments(feedback);
    // Update system information
    $a78b7212404532f0$var$updateFeedbackSystemInfo(feedback);
    // Update postprocessing information (for arrangement mode)
    $a78b7212404532f0$var$updateFeedbackPostprocessingInfo(feedback);
}
function $a78b7212404532f0$var$updateFeedbackFileList(feedback) {
    const fileList = document.getElementById("feedback-file-list");
    if (!fileList) return;
    fileList.innerHTML = "";
    const allFiles = [
        ...feedback.meshFiles || [],
        ...feedback.resultFiles || [],
        feedback.formDataFile
    ].filter(Boolean);
    allFiles.forEach((file)=>{
        const fileItem = document.createElement("div");
        fileItem.className = "file-item";
        const fileName = document.createElement("div");
        fileName.className = "file-item-name";
        fileName.textContent = file.name;
        const fileDetails = document.createElement("div");
        fileDetails.className = "file-item-details";
        fileDetails.textContent = `${(file.size / 1024).toFixed(1)} KB`;
        fileItem.appendChild(fileName);
        fileItem.appendChild(fileDetails);
        fileList.appendChild(fileItem);
    });
}
function $a78b7212404532f0$var$updateFeedbackQuestions(feedback) {
    const questionsSection = document.getElementById("feedback-questions-section");
    const questionsList = document.getElementById("feedback-questions-list");
    console.log(`\u{1F4DD} UpdateFeedbackQuestions called:`, {
        hasResponses: !!(feedback.responses && Object.keys(feedback.responses).length > 0),
        responses: feedback.responses,
        processingMode: feedback.processingMode,
        hasConfig: !!(0, $aa8a35ff0d89d373$export$d3c1098c3ede00c2).feedbackConfig,
        configQuestions: (0, $aa8a35ff0d89d373$export$d3c1098c3ede00c2).feedbackConfig?.questions?.[feedback.processingMode]
    });
    if (feedback.responses && Object.keys(feedback.responses).length > 0) {
        if (questionsSection) questionsSection.style.display = "block";
        if (questionsList) {
            questionsList.innerHTML = "";
            // Get the questions config to maintain proper ordering and numbering
            let questionsConfig = [];
            if ((0, $aa8a35ff0d89d373$export$d3c1098c3ede00c2).feedbackConfig && feedback.processingMode) {
                questionsConfig = (0, $aa8a35ff0d89d373$export$d3c1098c3ede00c2).feedbackConfig.questions[feedback.processingMode] || [];
                console.log(`\u{1F4DD} Using config questions for ${feedback.processingMode}:`, questionsConfig);
            } else console.warn(`\u{1F4DD} No config available, feedback config:`, (0, $aa8a35ff0d89d373$export$d3c1098c3ede00c2).feedbackConfig, `processing mode:`, feedback.processingMode);
            let questionsDisplayed = 0;
            if (questionsConfig.length > 0) // Display questions in the same order as the config, with proper numbering
            questionsConfig.forEach((questionConfig, index)=>{
                const response = feedback.responses[questionConfig.id];
                if (response !== undefined && response !== null) {
                    const questionItem = $a78b7212404532f0$var$createQuestionElement(`Question ${index + 1}:`, questionConfig.question, response, questionConfig);
                    questionsList.appendChild(questionItem);
                    questionsDisplayed++;
                }
            });
            // Fallback: Display all responses if no config or no questions were displayed
            if (questionsDisplayed === 0) {
                console.log(`\u{1F4DD} No questions displayed from config, using fallback approach`);
                let questionIndex = 1;
                Object.entries(feedback.responses).forEach(([questionId, response])=>{
                    const questionItem = document.createElement("div");
                    questionItem.className = "question-item";
                    const questionText = document.createElement("div");
                    questionText.className = "question-text";
                    // Fallback formatting for questions not in config
                    let fallbackText = questionId.replace(/_/g, " ").replace(/\b\w/g, (l)=>l.toUpperCase());
                    questionText.innerHTML = `<strong>Question ${questionIndex}:</strong> ${fallbackText}`;
                    questionIndex++;
                    const questionResponse = document.createElement("div");
                    questionResponse.className = "question-response";
                    const indicator = document.createElement("span");
                    indicator.className = "response-indicator";
                    const responseText = document.createElement("span");
                    responseText.className = "response-text";
                    if (response === "yes" || response === true) {
                        indicator.classList.add("yes");
                        indicator.textContent = "\u2713";
                        responseText.textContent = "Yes";
                    } else {
                        indicator.classList.add("no");
                        indicator.textContent = "\u2717";
                        responseText.textContent = "No";
                    }
                    questionResponse.appendChild(indicator);
                    questionResponse.appendChild(responseText);
                    questionItem.appendChild(questionText);
                    questionItem.appendChild(questionResponse);
                    questionsList.appendChild(questionItem);
                    questionsDisplayed++;
                });
            }
            console.log(`\u{1F4DD} Displayed ${questionsDisplayed} questions for ${feedback.processingMode}`);
        }
    } else {
        if (questionsSection) questionsSection.style.display = "none";
        console.log(`\u{1F4DD} No responses found in feedback:`, feedback);
    }
}
// Helper function to create question elements that match the input form layout
function $a78b7212404532f0$var$createQuestionElement(questionPrefix, questionText, response, questionConfig = null) {
    const questionItem = document.createElement("div");
    // Determine question type from config or response format
    let questionType = "yes_no"; // default
    if (questionConfig && questionConfig.type) questionType = questionConfig.type;
    else if (typeof response === "object" && response !== null && response.rating !== undefined) questionType = "rating_with_comment";
    // Set appropriate CSS class based on question type
    if (questionType === "rating_with_comment" || questionType === "rating_and_comment") questionItem.className = "rating-comment-question readonly";
    else questionItem.className = "yes-no-question readonly";
    const questionTextEl = document.createElement("div");
    questionTextEl.className = "question-text";
    questionTextEl.innerHTML = `<strong>${questionPrefix}</strong> ${questionText}`;
    questionItem.appendChild(questionTextEl);
    if ((questionType === "rating_with_comment" || questionType === "rating_and_comment") && typeof response === "object" && response !== null) {
        // Create rating section matching input form layout
        const ratingSection = document.createElement("div");
        ratingSection.className = "rating-section readonly";
        const ratingLabel = document.createElement("div");
        ratingLabel.className = "rating-label";
        ratingLabel.textContent = "Rating:";
        const ratingContainer = document.createElement("div");
        ratingContainer.className = "star-rating readonly";
        // Create 5 stars showing the rating
        for(let i = 1; i <= 5; i++){
            const star = document.createElement("span");
            star.className = "star readonly";
            star.textContent = "\u2605";
            if (i <= (response.rating || 0)) star.classList.add("active");
            ratingContainer.appendChild(star);
        }
        ratingSection.appendChild(ratingLabel);
        ratingSection.appendChild(ratingContainer);
        questionItem.appendChild(ratingSection);
        // Add rating text
        const ratingText = document.createElement("div");
        ratingText.className = "rating-text readonly";
        ratingText.textContent = `${response.rating || 0}/5`;
        ratingText.style.marginTop = "0.2rem";
        ratingText.style.color = "#adb5bd";
        ratingText.style.fontSize = "0.75rem";
        questionItem.appendChild(ratingText);
        // Create comment section if there's a comment
        if (response.comment && response.comment.trim()) {
            const commentSection = document.createElement("div");
            commentSection.className = "comment-section readonly";
            const commentLabel = document.createElement("div");
            commentLabel.className = "comment-label";
            commentLabel.textContent = "Comments:";
            commentLabel.style.fontWeight = "600";
            commentLabel.style.color = "#e9ecef";
            commentLabel.style.fontSize = "0.9rem";
            commentLabel.style.marginTop = "1rem";
            commentLabel.style.marginBottom = "0.5rem";
            const commentDisplay = document.createElement("div");
            commentDisplay.className = "comment-display readonly";
            commentDisplay.textContent = response.comment;
            commentDisplay.style.padding = "10px 12px";
            commentDisplay.style.background = "#2d2d2d";
            commentDisplay.style.border = "1px solid #555";
            commentDisplay.style.borderRadius = "6px";
            commentDisplay.style.color = "#e9ecef";
            commentDisplay.style.fontSize = "0.9rem";
            commentDisplay.style.lineHeight = "1.4";
            commentSection.appendChild(commentLabel);
            commentSection.appendChild(commentDisplay);
            questionItem.appendChild(commentSection);
        }
    } else {
        // Handle yes/no questions - create radio-like display
        const radioContainer = document.createElement("div");
        radioContainer.className = "radio-container readonly";
        const radioWrapper = document.createElement("div");
        radioWrapper.className = "radio-wrapper readonly";
        // Create Yes option display
        const yesLabel = document.createElement("div");
        yesLabel.className = `radio-label yes-label readonly ${response === "yes" || response === true ? "selected" : ""}`;
        const yesIndicator = document.createElement("div");
        yesIndicator.className = "radio-indicator";
        yesIndicator.textContent = response === "yes" || response === true ? "\u25CF" : "\u25CB";
        const yesText = document.createElement("span");
        yesText.textContent = "Yes";
        yesLabel.appendChild(yesIndicator);
        yesLabel.appendChild(yesText);
        // Create No option display
        const noLabel = document.createElement("div");
        noLabel.className = `radio-label no-label readonly ${response === "no" || response === false ? "selected" : ""}`;
        const noIndicator = document.createElement("div");
        noIndicator.className = "radio-indicator";
        noIndicator.textContent = response === "no" || response === false ? "\u25CF" : "\u25CB";
        const noText = document.createElement("span");
        noText.textContent = "No";
        noLabel.appendChild(noIndicator);
        noLabel.appendChild(noText);
        radioWrapper.appendChild(yesLabel);
        radioWrapper.appendChild(noLabel);
        radioContainer.appendChild(radioWrapper);
        questionItem.appendChild(radioContainer);
    }
    return questionItem;
}
function $a78b7212404532f0$var$updateFeedbackComments(feedback) {
    const commentsSection = document.getElementById("feedback-comments-section");
    const commentsContent = document.getElementById("feedback-comments-content");
    if (feedback.comments && feedback.comments.trim()) {
        if (commentsSection) commentsSection.style.display = "block";
        if (commentsContent) commentsContent.innerHTML = `<p>${feedback.comments}</p>`;
    } else if (commentsSection) commentsSection.style.display = "none";
}
function $a78b7212404532f0$var$updateFeedbackSystemInfo(feedback) {
    const systemInfoGrid = document.getElementById("feedback-system-info-grid");
    if (!systemInfoGrid) return;
    systemInfoGrid.innerHTML = "";
    if (feedback.systemInfo && Object.keys(feedback.systemInfo).length > 0) Object.entries(feedback.systemInfo).forEach(([key, value])=>{
        const detailItem = document.createElement("div");
        detailItem.className = "detail-item";
        const label = document.createElement("label");
        label.textContent = key.replace(/_/g, " ").replace(/\b\w/g, (l)=>l.toUpperCase()) + ":";
        const span = document.createElement("span");
        span.textContent = typeof value === "object" ? JSON.stringify(value) : String(value);
        detailItem.appendChild(label);
        detailItem.appendChild(span);
        systemInfoGrid.appendChild(detailItem);
    });
    else {
        const noInfo = document.createElement("div");
        noInfo.className = "detail-item";
        noInfo.innerHTML = "<span>No system information available</span>";
        systemInfoGrid.appendChild(noInfo);
    }
}
function $a78b7212404532f0$var$updateFeedbackPostprocessingInfo(feedback) {
    const postprocessingSection = document.getElementById("feedback-postprocessing-section");
    const postprocessingContent = document.getElementById("feedback-postprocessing-content");
    const postprocessingInfo = document.getElementById("feedback-postprocessing-info");
    if (!postprocessingSection || !postprocessingContent || !postprocessingInfo) return;
    // Only show for arrangement mode
    if (feedback.processingMode !== "arrangement") {
        postprocessingSection.style.display = "none";
        return;
    }
    // Check if postprocessing data exists
    if (!feedback.postprocessing) {
        postprocessingSection.style.display = "none";
        return;
    }
    postprocessingSection.style.display = "block";
    postprocessingInfo.innerHTML = "";
    const postprocessing = feedback.postprocessing;
    const enabled = postprocessing.enabled || false;
    const parameters = postprocessing.parameters || {};
    // Create container for postprocessing info
    const infoContainer = document.createElement("div");
    infoContainer.className = "postprocessing-info-container";
    // Enable Postprocessing status
    const enabledItem = document.createElement("div");
    enabledItem.className = "detail-item";
    const enabledLabel = document.createElement("label");
    enabledLabel.textContent = "Enable Postprocessing:";
    const enabledValue = document.createElement("span");
    enabledValue.textContent = enabled ? "Yes" : "No";
    enabledValue.style.color = enabled ? "#4caf50" : "#f44336";
    enabledItem.appendChild(enabledLabel);
    enabledItem.appendChild(enabledValue);
    infoContainer.appendChild(enabledItem);
    // Only show parameters if postprocessing was enabled
    if (enabled && parameters) {
        // Gap Range Min
        if (parameters.gap_min !== undefined && parameters.gap_min !== null) {
            const gapMinItem = document.createElement("div");
            gapMinItem.className = "detail-item";
            const gapMinLabel = document.createElement("label");
            gapMinLabel.textContent = "Gap Range Min (mm):";
            const gapMinValue = document.createElement("span");
            gapMinValue.textContent = parameters.gap_min.toFixed(2);
            gapMinItem.appendChild(gapMinLabel);
            gapMinItem.appendChild(gapMinValue);
            infoContainer.appendChild(gapMinItem);
        }
        // Gap Range Max
        if (parameters.gap_max !== undefined && parameters.gap_max !== null) {
            const gapMaxItem = document.createElement("div");
            gapMaxItem.className = "detail-item";
            const gapMaxLabel = document.createElement("label");
            gapMaxLabel.textContent = "Gap Range Max (mm):";
            const gapMaxValue = document.createElement("span");
            gapMaxValue.textContent = parameters.gap_max.toFixed(2);
            gapMaxItem.appendChild(gapMaxLabel);
            gapMaxItem.appendChild(gapMaxValue);
            infoContainer.appendChild(gapMaxItem);
        }
        // Tightness
        if (parameters.tightness !== undefined && parameters.tightness !== null) {
            const tightnessItem = document.createElement("div");
            tightnessItem.className = "detail-item";
            const tightnessLabel = document.createElement("label");
            tightnessLabel.textContent = "Tightness (mm):";
            const tightnessValue = document.createElement("span");
            tightnessValue.textContent = parameters.tightness.toFixed(2);
            tightnessItem.appendChild(tightnessLabel);
            tightnessItem.appendChild(tightnessValue);
            infoContainer.appendChild(tightnessItem);
        }
        // Central Axis Mode
        if (parameters.central_axis_mode !== undefined && parameters.central_axis_mode !== null) {
            const centralAxisItem = document.createElement("div");
            centralAxisItem.className = "detail-item";
            const centralAxisLabel = document.createElement("label");
            centralAxisLabel.textContent = "Central Axis Mode:";
            const centralAxisValue = document.createElement("span");
            centralAxisValue.textContent = parameters.central_axis_mode === "both" ? "Both" : parameters.central_axis_mode === "upper" ? "Upper" : parameters.central_axis_mode;
            centralAxisItem.appendChild(centralAxisLabel);
            centralAxisItem.appendChild(centralAxisValue);
            infoContainer.appendChild(centralAxisItem);
        }
        // Space Management (formerly Custom Gap Rules)
        if (parameters.custom_gap_rules && Array.isArray(parameters.custom_gap_rules) && parameters.custom_gap_rules.length > 0) {
            const customRulesItem = document.createElement("div");
            customRulesItem.className = "detail-item";
            customRulesItem.style.flexDirection = "column";
            customRulesItem.style.alignItems = "flex-start";
            const customRulesLabel = document.createElement("label");
            customRulesLabel.textContent = "Space Management:";
            customRulesLabel.style.marginBottom = "0.5rem";
            customRulesItem.appendChild(customRulesLabel);
            const rulesList = document.createElement("div");
            rulesList.className = "custom-gap-rules-list";
            rulesList.style.width = "100%";
            rulesList.style.marginTop = "0.5rem";
            parameters.custom_gap_rules.forEach((rule, index)=>{
                const ruleItem = document.createElement("div");
                ruleItem.className = "custom-gap-rule-item";
                ruleItem.style.padding = "0.5rem";
                ruleItem.style.marginBottom = "0.25rem";
                ruleItem.style.background = "#2d2d2d";
                ruleItem.style.border = "1px solid #555";
                ruleItem.style.borderRadius = "4px";
                const ruleText = document.createElement("span");
                ruleText.style.fontSize = "0.85rem";
                ruleText.style.color = "#e9ecef";
                let ruleTextContent = `Rule ${index + 1}: Tooth ${rule.tooth_a} - Tooth ${rule.tooth_b}`;
                if (rule.gap_min !== undefined && rule.gap_min !== null) ruleTextContent += `, Min: ${rule.gap_min.toFixed(2)} mm`;
                if (rule.gap_max !== undefined && rule.gap_max !== null) ruleTextContent += `, Max: ${rule.gap_max.toFixed(2)} mm`;
                ruleText.textContent = ruleTextContent;
                ruleItem.appendChild(ruleText);
                rulesList.appendChild(ruleItem);
            });
            customRulesItem.appendChild(rulesList);
            infoContainer.appendChild(customRulesItem);
        } else if (enabled) {
            // Show "No custom rules" if postprocessing is enabled but no custom rules
            const noRulesItem = document.createElement("div");
            noRulesItem.className = "detail-item";
            const noRulesLabel = document.createElement("label");
            noRulesLabel.textContent = "Space Management:";
            const noRulesValue = document.createElement("span");
            noRulesValue.textContent = "None";
            noRulesValue.style.color = "#adb5bd";
            noRulesItem.appendChild(noRulesLabel);
            noRulesItem.appendChild(noRulesValue);
            infoContainer.appendChild(noRulesItem);
        }
    }
    postprocessingInfo.appendChild(infoContainer);
}
function $a78b7212404532f0$var$switchToProcessingMode(mode) {
    const processingModeDropdown = document.getElementById("processing-mode-dropdown");
    if (processingModeDropdown && processingModeDropdown.value !== mode) {
        console.log(`\u{1F504} Auto-switching processing mode from ${processingModeDropdown.value} to ${mode}`);
        // Update the dropdown value
        processingModeDropdown.value = mode;
        // Update mode instructions
        $a78b7212404532f0$var$updateModeInstructions(mode);
        // Update file selection UI (but don't clear files in feedback mode)
        if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).feedbackMode) $a78b7212404532f0$var$updateFileSelectionUI(mode);
        // Update model options section visibility
        $a78b7212404532f0$var$updateModelOptionsSectionVisibility(mode);
        // Show toast notification
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Switched to ${(0, $3229c9fdc637713a$export$e3c93597035f1506)(mode)} mode`, "info");
    }
}
// Function to setup additional controls
function $a78b7212404532f0$var$setupControls() {
    // Setup sidebar collapse/expand functionality
    $a78b7212404532f0$var$setupSidebarControls();
    // Setup keypoint label toggle
    const showKeypointLabelsCheckbox = document.getElementById("show-keypoint-labels");
    if (showKeypointLabelsCheckbox) showKeypointLabelsCheckbox.addEventListener("change", function() {
        // Update keypoint label visibility if they exist
        const keypointLabels = document.querySelectorAll(".keypoint-label");
        keypointLabels.forEach((label)=>{
            label.style.display = this.checked ? "block" : "none";
        });
    });
    // Setup boundaries toggle for teeth separation
    const showBoundariesCheckbox = document.getElementById("show-separation-boundaries");
    if (showBoundariesCheckbox) showBoundariesCheckbox.addEventListener("change", function() {
        // Update boundary marker visibility
        const boundaryMarkers = document.querySelectorAll(".boundary-marker");
        boundaryMarkers.forEach((marker)=>{
            marker.style.display = this.checked ? "block" : "none";
        });
    });
}
function $a78b7212404532f0$var$setupSidebarControls() {
    // Left sidebar collapse/expand
    const collapseLeftBtn = document.getElementById("collapse-left");
    if (collapseLeftBtn) collapseLeftBtn.addEventListener("click", $a78b7212404532f0$var$toggleLeftSidebar);
    // Right sidebar collapse/expand
    const collapseRightBtn = document.getElementById("collapse-right");
    if (collapseRightBtn) collapseRightBtn.addEventListener("click", $a78b7212404532f0$var$toggleRightSidebar);
    // Application mode toggle
    const appModeToggle = document.getElementById("app-mode-toggle");
    if (appModeToggle) appModeToggle.addEventListener("click", (e)=>{
        if (e.target.classList.contains("toggle-option")) {
            // Remove active class from all options
            appModeToggle.querySelectorAll(".toggle-option").forEach((option)=>{
                option.classList.remove("active");
            });
            // Add active class to clicked option
            e.target.classList.add("active");
            // Switch mode
            const mode = e.target.dataset.mode;
            $a78b7212404532f0$var$switchApplicationMode(mode);
        }
    });
    // Feedback directory selection
    const feedbackDirBtn = document.getElementById("feedback-directory-btn");
    if (feedbackDirBtn) feedbackDirBtn.addEventListener("click", $a78b7212404532f0$var$handleFeedbackDirectorySelection);
    // Feedback navigation
    const feedbackPrevBtn = document.getElementById("feedback-prev");
    const feedbackNextBtn = document.getElementById("feedback-next");
    if (feedbackPrevBtn) feedbackPrevBtn.addEventListener("click", ()=>$a78b7212404532f0$var$navigateFeedback(-1));
    if (feedbackNextBtn) feedbackNextBtn.addEventListener("click", ()=>$a78b7212404532f0$var$navigateFeedback(1));
    // Visibility controls for jaws, gingiva, and brackets
    const showUpperJawCheckbox = document.getElementById("show-upper-jaw");
    if (showUpperJawCheckbox) showUpperJawCheckbox.addEventListener("change", function() {
        const visible = this.checked;
        // Determine which scene(s) to update based on current view mode
        const sceneKey = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLayoutInitialized ? "both" : "main";
        $a78b7212404532f0$var$toggleJawVisibility(0, visible, sceneKey); // 0 for upper jaw
    });
    const showLowerJawCheckbox = document.getElementById("show-lower-jaw");
    if (showLowerJawCheckbox) showLowerJawCheckbox.addEventListener("change", function() {
        const visible = this.checked;
        // Determine which scene(s) to update based on current view mode
        const sceneKey = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLayoutInitialized ? "both" : "main";
        $a78b7212404532f0$var$toggleJawVisibility(1, visible, sceneKey); // 1 for lower jaw
    });
    const showGingivaCheckbox = document.getElementById("show-gingiva");
    if (showGingivaCheckbox) showGingivaCheckbox.addEventListener("change", function() {
        const visible = this.checked;
        // Determine which scene(s) to update based on current view mode
        const sceneKey = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLayoutInitialized ? "both" : "main";
        $a78b7212404532f0$var$toggleGingivaVisibility(visible, sceneKey);
    });
    const showBracketsCheckbox = document.getElementById("show-brackets");
    if (showBracketsCheckbox) showBracketsCheckbox.addEventListener("change", function() {
        const visible = this.checked;
        // Determine which scene(s) to update based on current view mode
        const sceneKey = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLayoutInitialized ? "both" : "main";
        $a78b7212404532f0$var$toggleBracketsVisibility(visible, sceneKey);
    });
}
function $a78b7212404532f0$var$toggleLeftSidebar() {
    const leftSidebar = document.getElementById("left-sidebar");
    const appContainer = document.querySelector(".app-container");
    const collapseBtn = document.getElementById("collapse-left");
    if (leftSidebar.classList.contains("collapsed")) {
        // Expand
        leftSidebar.classList.remove("collapsed");
        appContainer.classList.remove("left-collapsed");
        collapseBtn.innerHTML = "\u276E";
        collapseBtn.title = "Collapse sidebar";
    } else {
        // Collapse
        leftSidebar.classList.add("collapsed");
        appContainer.classList.add("left-collapsed");
        collapseBtn.innerHTML = "\u276F";
        collapseBtn.title = "Expand sidebar";
    }
    // Update feedback button visibility based on new sidebar state
    $a78b7212404532f0$var$updateStartOverButtonVisibility();
    // Trigger resize to update Three.js renderer
    setTimeout(()=>{
        $a78b7212404532f0$var$onWindowResize();
    }, 300); // Wait for CSS transition
}
/**
 * Collapse the left sidebar (used during processing to maximize viewer space)
 */ function $a78b7212404532f0$export$4087e547c9157774() {
    const leftSidebar = document.getElementById("left-sidebar");
    const appContainer = document.querySelector(".app-container");
    const collapseBtn = document.getElementById("collapse-left");
    // Only collapse if not already collapsed
    if (leftSidebar && !leftSidebar.classList.contains("collapsed")) {
        leftSidebar.classList.add("collapsed");
        appContainer?.classList.add("left-collapsed");
        if (collapseBtn) {
            collapseBtn.innerHTML = "\u276F";
            collapseBtn.title = "Expand sidebar";
        }
        // Trigger resize to update Three.js renderer
        setTimeout(()=>{
            $a78b7212404532f0$var$onWindowResize();
        }, 300); // Wait for CSS transition
    }
}
function $a78b7212404532f0$var$toggleRightSidebar() {
    const rightSidebar = document.getElementById("right-sidebar");
    const appContainer = document.querySelector(".app-container");
    const collapseBtn = document.getElementById("collapse-right");
    if (rightSidebar.classList.contains("right-sidebar-collapsed")) {
        // Expand
        rightSidebar.classList.remove("right-sidebar-collapsed");
        appContainer.classList.remove("right-collapsed");
        collapseBtn.innerHTML = "\u276F";
        collapseBtn.title = "Collapse sidebar";
        const sidebarTitle = rightSidebar.querySelector(".sidebar-title");
        if (sidebarTitle) sidebarTitle.textContent = "Details";
    } else {
        // Collapse
        rightSidebar.classList.add("right-sidebar-collapsed");
        appContainer.classList.add("right-collapsed");
        collapseBtn.innerHTML = "\u276E";
        collapseBtn.title = "Expand sidebar";
        const sidebarTitle = rightSidebar.querySelector(".sidebar-title");
        if (sidebarTitle) sidebarTitle.textContent = "Details";
    }
    // Trigger resize to update Three.js renderer
    setTimeout(()=>{
        $a78b7212404532f0$var$onWindowResize();
    }, 300); // Wait for CSS transition
}
/**
 * Apply 4x4 transformation matrix to vertices
 * @param {Array} vertices - Array of [x, y, z] vertex positions
 * @param {Array} transformMatrix - 16-element transformation matrix (row-major)
 * @returns {Array} Transformed vertices
 */ function $a78b7212404532f0$var$applyTransformationMatrix(vertices, transformMatrix) {
    if (!transformMatrix || transformMatrix.length !== 16) {
        console.warn("Invalid transformation matrix:", transformMatrix);
        return vertices; // Return original if invalid matrix
    }
    // Check if this is an identity matrix
    const isIdentity = transformMatrix.every((val, idx)=>{
        const expectedIdentity = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        return Math.abs(val - expectedIdentity[idx]) < 0.0001;
    });
    if (isIdentity) return vertices;
    const transformedVertices = [];
    let maxMovement = 0;
    vertices.forEach((vertex, idx)=>{
        const [x, y, z] = vertex;
        // Apply 4x4 transformation matrix
        // The matrix is in row-major format from NumPy (flattened row by row)
        // Matrix layout: [m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33]
        // For point transformation: [x', y', z', w'] = Matrix * [x, y, z, 1]^T
        const transformedX = transformMatrix[0] * x + transformMatrix[1] * y + transformMatrix[2] * z + transformMatrix[3];
        const transformedY = transformMatrix[4] * x + transformMatrix[5] * y + transformMatrix[6] * z + transformMatrix[7];
        const transformedZ = transformMatrix[8] * x + transformMatrix[9] * y + transformMatrix[10] * z + transformMatrix[11];
        transformedVertices.push([
            transformedX,
            transformedY,
            transformedZ
        ]);
        // Calculate movement for debugging (sample first few vertices)
        if (idx < 5) {
            const movement = Math.sqrt(Math.pow(transformedX - x, 2) + Math.pow(transformedY - y, 2) + Math.pow(transformedZ - z, 2));
            maxMovement = Math.max(maxMovement, movement);
        }
    });
    // Transformation applied successfully
    return transformedVertices;
}
/**
 * Clean up any existing floating jaw toggle controls from the DOM
 */ function $a78b7212404532f0$var$cleanupFloatingJawControls() {
    const existingControls = document.getElementById("jaw-toggle-controls");
    if (existingControls) {
        existingControls.remove();
        console.log("\uD83E\uDDF9 Cleaned up existing floating jaw controls");
    }
}
// Note: addJawToggleControls removed - visibility controls are now in the left sidebar
/**
 * Toggle visibility of jaw objects in scenes
 * @param {number} jawGroup - 0 for upper, 1 for lower
 * @param {boolean} visible - Whether to show or hide
 * @param {string} sceneKey - Key for the scene ('original', 'segmented', 'both', or 'main')
 */ function $a78b7212404532f0$var$toggleJawVisibility(jawGroup, visible, sceneKey) {
    const jawName = jawGroup === 0 ? "upper" : "lower";
    if (sceneKey === "both") {
        // Apply to both original and segmented views
        [
            "original",
            "segmented"
        ].forEach((viewKey)=>{
            const scene = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[viewKey];
            if (scene) scene.traverse((object)=>{
                if (object.isMesh && object.userData && object.userData.group === jawGroup) {
                    // Check if this object should be visible based on all toggle states
                    const shouldBeVisible = $a78b7212404532f0$var$shouldObjectBeVisible(object, visible);
                    object.visible = shouldBeVisible;
                }
                // Also handle labels for arrangement objects
                if (object.isCSS2DObject && object.name.startsWith("arrangement-label-")) {
                    // Get the associated mesh object to check jaw group
                    const associatedObjectName = object.name.replace("arrangement-label-", "");
                    const associatedMesh = scene.children.find((child)=>child.isMesh && child.userData && child.userData.group === jawGroup && (child.name === associatedObjectName || child.name.includes(associatedObjectName)));
                    if (associatedMesh) {
                        // Label visibility should respect both jaw visibility and label toggle
                        const showArrangementLabels = document.getElementById("show-arrangement-labels");
                        const labelsEnabled = showArrangementLabels ? showArrangementLabels.checked : false;
                        const shouldBeVisible = $a78b7212404532f0$var$shouldObjectBeVisible(associatedMesh, visible);
                        object.visible = labelsEnabled && shouldBeVisible;
                    }
                }
            });
        });
        // Also apply to overlay view if active
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.traverse((object)=>{
            if (object.isMesh && object.userData && object.userData.group === jawGroup) {
                const shouldBeVisible = $a78b7212404532f0$var$shouldObjectBeVisible(object, visible);
                object.visible = shouldBeVisible;
            }
        });
    } else {
        // Apply to single view
        const scene = sceneKey === "main" ? (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene : (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[sceneKey];
        if (scene) scene.traverse((object)=>{
            if (object.isMesh && object.userData && object.userData.group === jawGroup) {
                // Check if this object should be visible based on all toggle states
                const shouldBeVisible = $a78b7212404532f0$var$shouldObjectBeVisible(object, visible);
                object.visible = shouldBeVisible;
            }
            // Also handle labels for arrangement objects
            if (object.isCSS2DObject && object.name.startsWith("arrangement-label-")) {
                // Get the associated mesh object to check jaw group
                const associatedObjectName = object.name.replace("arrangement-label-", "");
                const associatedMesh = scene.children.find((child)=>child.isMesh && child.userData && child.userData.group === jawGroup && (child.name === associatedObjectName || child.name.includes(associatedObjectName)));
                if (associatedMesh) {
                    // Label visibility should respect both jaw visibility and label toggle
                    const showArrangementLabels = document.getElementById("show-arrangement-labels");
                    const labelsEnabled = showArrangementLabels ? showArrangementLabels.checked : false;
                    const shouldBeVisible = $a78b7212404532f0$var$shouldObjectBeVisible(associatedMesh, visible);
                    object.visible = labelsEnabled && shouldBeVisible;
                }
            }
        });
    }
}
/**
 * Display arrangement objects in a specific scene with optional jaw toggles
 * @param {Array} objects - Array of object data
 * @param {THREE.Scene} scene - The THREE.js scene
 * @param {String} title - Title for the view
 * @param {boolean} enableJawToggles - Whether to enable jaw toggle functionality
 */ function $a78b7212404532f0$var$displayArrangementObjectsInScene(objects, scene, title, enableJawToggles = false) {
    if (!objects || !Array.isArray(objects)) {
        console.warn("Invalid objects data for scene:", title);
        return;
    }
    console.log(`\u{1F3A8} Displaying ${objects.length} objects in scene: ${title}`);
    // Clear existing meshes and labels
    const meshesToRemove = scene.children.filter((child)=>child.isMesh);
    const labelsToRemove = scene.children.filter((child)=>child.isCSS2DObject);
    meshesToRemove.forEach((mesh)=>{
        scene.remove(mesh);
        if (mesh.geometry) mesh.geometry.dispose();
        if (mesh.material) {
            if (Array.isArray(mesh.material)) mesh.material.forEach((mat)=>mat.dispose());
            else mesh.material.dispose();
        }
    });
    labelsToRemove.forEach((label)=>{
        scene.remove(label);
    });
    // Track added objects to detect duplicates using index-based unique keys
    const addedObjectKeys = new Set();
    const brackets = objects.filter((obj)=>obj.type === 107 && obj.descr === "BrktAttm");
    const teeth = objects.filter((obj)=>obj.type >= 11 && obj.type <= 48);
    const others = objects.filter((obj)=>obj.type !== 107 && (obj.type < 11 || obj.type > 48));
    // Create objects in the scene
    objects.forEach((objData, index)=>{
        // Create unique key using index to avoid false duplicates
        const uniqueKey = `${index}_${objData.name || "unnamed"}`;
        // Check for duplicate keys (should never happen with index, but just in case)
        if (addedObjectKeys.has(uniqueKey)) {
            console.warn(`\u{26A0}\u{FE0F} DUPLICATE OBJECT KEY in ${title}: "${uniqueKey}" - skipping!`);
            return;
        }
        addedObjectKeys.add(uniqueKey);
        if (!objData.vertices || !Array.isArray(objData.vertices) || objData.vertices.length === 0) {
            console.warn(`Object ${objData.name || index} has no vertices`);
            return;
        }
        // Create geometry from vertices
        const vertices = new Float32Array(objData.vertices.flat());
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$8dea267bd6bde117(vertices, 3));
        // Add faces if available
        if (objData.faces && Array.isArray(objData.faces) && objData.faces.length > 0) {
            const faces = objData.faces.flat();
            geometry.setIndex(faces);
            geometry.computeVertexNormals();
        }
        // Determine color - convert from 0-255 to 0-1 range if needed
        let color = [
            0.8,
            0.8,
            0.8
        ]; // Default gray
        if (objData.color && Array.isArray(objData.color)) {
            // Check if values are in 0-255 range or 0-1 range
            const maxValue = Math.max(...objData.color);
            if (maxValue > 1) // Convert from 0-255 to 0-1
            color = objData.color.map((c)=>c / 255);
            else color = objData.color;
        }
        // Special handling for brackets to ensure proper colors
        // Create a temporary mesh object to use with getObjectType function
        const tempMesh = {
            name: objData.name || "",
            userData: {
                type: objData.type,
                descr: objData.descr,
                teethID: objData.teethID,
                originalType: objData.originalType
            }
        };
        // Determine object type using unified classification
        const objectType = $a78b7212404532f0$var$getObjectType(tempMesh);
        // Apply colors based on object type - GINGIVA ALWAYS GETS PINK
        if (objectType === "gingiva") // Pink color for all gingiva/soft tissue objects (ALWAYS, regardless of visibility)
        color = [
            1.0,
            0.5,
            0.5
        ]; // Pink for gingiva
        else if (objectType === "bracket") // Apply bracket color
        {
            if (!objData.color || objData.color[0] === 255 && objData.color[1] === 255 && objData.color[2] === 255 || objData.color[0] === 0.8 && objData.color[1] === 0.8 && objData.color[2] === 0.8) {
                const bracketColor = $a78b7212404532f0$var$getBracketColor();
                // Convert to 0-1 range
                color = bracketColor.map((c)=>c / 255);
            }
        }
        // Create material
        const material = new $0d79572b4b22d35c$export$f2980790215acccd({
            color: new $0d79572b4b22d35c$export$892596cec99bc70e(color[0], color[1], color[2]),
            side: $0d79572b4b22d35c$export$3b296b6f144d5b03,
            metalness: 0.3,
            roughness: 0.5,
            transparent: objData.name && objData.name.includes("Soft Tissue"),
            opacity: objData.name && objData.name.includes("Soft Tissue") ? 0.7 : 1.0
        });
        // Create mesh
        const mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, material);
        mesh.name = objData.name || `Object_${index}`;
        // Store jaw group information for toggle functionality
        if (enableJawToggles) mesh.userData = {
            group: objData.group,
            type: objData.type,
            descr: objData.descr,
            teethID: objData.teethID,
            originalType: objData.originalType // Store original type from .obj file
        };
        else // Still store type for object detection even if jaw toggles aren't enabled
        mesh.userData = {
            type: objData.type,
            descr: objData.descr,
            teethID: objData.teethID,
            originalType: objData.originalType // Store original type from .obj file
        };
        // Set initial visibility based on object type and checkbox states
        mesh.visible = $a78b7212404532f0$var$getInitialObjectVisibility(mesh);
        // Debug object visibility
        if (!mesh.visible) console.log(`\u{1F648} Object "${objData.name || index}" created but invisible - Type: ${$a78b7212404532f0$var$getObjectType(mesh)}`);
        else console.log(`\u{1F441}\u{FE0F} Object "${objData.name || index}" visible - Type: ${$a78b7212404532f0$var$getObjectType(mesh)}`);
        // Calculate center position for label placement
        geometry.computeBoundingBox();
        const boundingBox = geometry.boundingBox;
        const center = new $0d79572b4b22d35c$export$64b5c384219d3699();
        boundingBox.getCenter(center);
        // Create label for the object
        const labelDiv = document.createElement("div");
        labelDiv.className = "arrangement-object-label";
        // Create label text with object type indicator
        let labelText = objData.name || `Object_${index}`;
        if (objData.type === 107 && objData.descr === "BrktAttm") labelText += " [Bracket]";
        else if (objData.teethID) labelText += ` [Tooth ${objData.teethID}]`;
        else if (objData.name && objData.name.toLowerCase().includes("soft tissue")) labelText += " [Gingiva]";
        labelDiv.textContent = labelText;
        labelDiv.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
        labelDiv.style.color = "white";
        labelDiv.style.padding = "3px 6px";
        labelDiv.style.borderRadius = "4px";
        labelDiv.style.fontSize = "11px";
        labelDiv.style.fontFamily = "Arial, sans-serif";
        labelDiv.style.border = "1px solid rgba(255, 255, 255, 0.3)";
        labelDiv.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.5)";
        labelDiv.style.whiteSpace = "nowrap";
        const label = new (0, $b5225408295f08ae$export$936f75e6792bf2dc)(labelDiv);
        label.position.copy(center);
        label.name = `arrangement-label-${objData.name || index}`;
        // Check if arrangement object labels should be visible
        const showArrangementLabels = document.getElementById("show-arrangement-labels");
        label.visible = showArrangementLabels ? showArrangementLabels.checked : false;
        // Add both mesh and label to scene
        scene.add(mesh);
        scene.add(label);
    });
    // Summary of created objects
    const visibleMeshes = scene.children.filter((child)=>child.isMesh && child.visible).length;
    const totalMeshes = scene.children.filter((child)=>child.isMesh).length;
    console.log(`\u{1F4CA} Scene "${title}" summary: ${totalMeshes} objects created, ${visibleMeshes} visible`);
}
/**
 * Display objects in the main scene (globalState.scene)
 * @param {Array} objects - Array of object data to display
 */ function $a78b7212404532f0$var$displayOriginalObjectsInMainScene(objects) {
    if (!objects || !Array.isArray(objects)) {
        console.warn("Invalid objects data for main scene");
        return;
    }
    // Clear existing arrangement objects from main scene
    const meshesToRemove = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children.filter((child)=>child.isMesh && child.userData && child.userData.originalObject);
    meshesToRemove.forEach((mesh)=>{
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(mesh);
        if (mesh.geometry) mesh.geometry.dispose();
        if (mesh.material) {
            if (Array.isArray(mesh.material)) mesh.material.forEach((mat)=>mat.dispose());
            else mesh.material.dispose();
        }
    });
    // Create objects in the main scene
    objects.forEach((objData, index)=>{
        if (!objData.vertices || !Array.isArray(objData.vertices) || objData.vertices.length === 0) {
            console.warn(`Object ${objData.name || index} has no vertices`);
            return;
        }
        // Create geometry from vertices
        const vertices = new Float32Array(objData.vertices.flat());
        const geometry = new $0d79572b4b22d35c$export$b7be63a67df8959();
        geometry.setAttribute("position", new $0d79572b4b22d35c$export$8dea267bd6bde117(vertices, 3));
        // Add faces if available
        if (objData.faces && Array.isArray(objData.faces) && objData.faces.length > 0) {
            const faces = objData.faces.flat();
            geometry.setIndex(faces);
            geometry.computeVertexNormals();
        }
        // Determine color - convert from 0-255 to 0-1 range if needed
        let color = [
            0.8,
            0.8,
            0.8
        ]; // Default gray
        if (objData.color && Array.isArray(objData.color)) {
            // Check if values are in 0-255 range or 0-1 range
            const maxValue = Math.max(...objData.color);
            if (maxValue > 1) // Convert from 0-255 to 0-1
            color = objData.color.map((c)=>c / 255);
            else color = objData.color;
        }
        // Special handling for brackets to ensure proper colors
        // Create a temporary mesh object to use with getObjectType function
        const tempMesh = {
            name: objData.name || "",
            userData: {
                type: objData.type,
                descr: objData.descr,
                teethID: objData.teethID,
                originalType: objData.originalType
            }
        };
        // Determine object type using unified classification
        const objectType = $a78b7212404532f0$var$getObjectType(tempMesh);
        // Apply colors based on object type - GINGIVA ALWAYS GETS PINK
        if (objectType === "gingiva") // Pink color for all gingiva/soft tissue objects (ALWAYS, regardless of visibility)
        color = [
            1.0,
            0.5,
            0.5
        ]; // Pink for gingiva
        else if (objectType === "bracket") // Apply bracket color
        {
            if (!objData.color || objData.color[0] === 255 && objData.color[1] === 255 && objData.color[2] === 255 || objData.color[0] === 0.8 && objData.color[1] === 0.8 && objData.color[2] === 0.8) {
                const bracketColor = $a78b7212404532f0$var$getBracketColor();
                // Convert to 0-1 range
                color = bracketColor.map((c)=>c / 255);
            }
        }
        // Create material
        const material = new $0d79572b4b22d35c$export$f2980790215acccd({
            color: new $0d79572b4b22d35c$export$892596cec99bc70e(color[0], color[1], color[2]),
            side: $0d79572b4b22d35c$export$3b296b6f144d5b03,
            metalness: 0.3,
            roughness: 0.5,
            transparent: objData.name && objData.name.includes("Soft Tissue"),
            opacity: objData.name && objData.name.includes("Soft Tissue") ? 0.7 : 1.0
        });
        // Create mesh
        const mesh = new $0d79572b4b22d35c$export$e176487c05830cc5(geometry, material);
        mesh.name = objData.name || `Object_${index}`;
        // Store metadata for arrangement and jaw toggle functionality
        mesh.userData = {
            originalObject: true,
            group: objData.group,
            type: objData.type || objData.Type,
            descr: objData.descr || objData.Descr,
            id: objData.id,
            teethID: objData.teethID,
            originalType: objData.originalType // Store original type from .obj file
        };
        // Set initial visibility based on object type and checkbox states
        mesh.visible = $a78b7212404532f0$var$getInitialObjectVisibility(mesh);
        // Calculate center position for label placement
        geometry.computeBoundingBox();
        const boundingBox = geometry.boundingBox;
        const center = new $0d79572b4b22d35c$export$64b5c384219d3699();
        boundingBox.getCenter(center);
        // Create label for the object
        const labelDiv = document.createElement("div");
        labelDiv.className = "arrangement-object-label";
        // Create label text with object type indicator
        let labelText = objData.name || `Object_${index}`;
        if (objData.type === 107 && objData.descr === "BrktAttm") labelText += " [Bracket]";
        else if (objData.teethID) labelText += ` [Tooth ${objData.teethID}]`;
        else if (objData.name && objData.name.toLowerCase().includes("soft tissue")) labelText += " [Gingiva]";
        labelDiv.textContent = labelText;
        labelDiv.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
        labelDiv.style.color = "white";
        labelDiv.style.padding = "3px 6px";
        labelDiv.style.borderRadius = "4px";
        labelDiv.style.fontSize = "11px";
        labelDiv.style.fontFamily = "Arial, sans-serif";
        labelDiv.style.border = "1px solid rgba(255, 255, 255, 0.3)";
        labelDiv.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.5)";
        labelDiv.style.whiteSpace = "nowrap";
        const label = new (0, $b5225408295f08ae$export$936f75e6792bf2dc)(labelDiv);
        label.position.copy(center);
        label.name = `arrangement-label-${objData.name || index}`;
        // Check if arrangement object labels should be visible
        const showArrangementLabels = document.getElementById("show-arrangement-labels");
        label.visible = showArrangementLabels ? showArrangementLabels.checked : false;
        // Add both mesh and label to main scene
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add(mesh);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.add(label);
    });
}
/**
 * Check if both arrangement files are selected and load them for immediate preview
 */ async function $a78b7212404532f0$var$checkAndLoadArrangementFiles() {
    const processingMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
    if (processingMode === "arrangement") $a78b7212404532f0$var$updateArrangementActionButtons();
    // Get current input mode
    const inputMode = $a78b7212404532f0$var$getInputMode();
    console.log("\uD83D\uDD27 checkAndLoadArrangementFiles called - input mode:", inputMode);
    if ($a78b7212404532f0$var$isAzureInputMode()) {
        // For Azure mode, download the files for preview
        const lowerJawAzurePath = document.getElementById("lower-jaw-azure-path").value.trim();
        const upperJawAzurePath = document.getElementById("upper-jaw-azure-path").value.trim();
        // Only proceed if both Azure paths are provided and valid
        if (!lowerJawAzurePath || !upperJawAzurePath) return; // Wait for both paths to be entered
        // Validate that paths look like .obj files
        if (!lowerJawAzurePath.toLowerCase().endsWith(".obj") || !upperJawAzurePath.toLowerCase().endsWith(".obj")) return; // Wait for valid .obj paths
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Loading arrangement files from Azure preview...", "info");
        try {
            // Download both files from Azure
            console.log("\uD83D\uDCE5 Downloading files from Azure:", {
                lowerJawAzurePath: lowerJawAzurePath,
                upperJawAzurePath: upperJawAzurePath
            });
            const [lowerJawFile, upperJawFile] = await Promise.all([
                (0, $913d3a1574de567c$export$ae14c375fc93363).downloadAzureFile(lowerJawAzurePath),
                (0, $913d3a1574de567c$export$ae14c375fc93363).downloadAzureFile(upperJawAzurePath)
            ]);
            console.log("\uD83D\uDCE5 Downloaded files:", {
                lowerJaw: {
                    name: lowerJawFile.name,
                    size: lowerJawFile.size
                },
                upperJaw: {
                    name: upperJawFile.name,
                    size: upperJawFile.size
                }
            });
            // Parse both downloaded OBJ files
            console.log("\uD83D\uDD0D Parsing downloaded OBJ files...");
            const [lowerJawResult, upperJawResult] = await Promise.all([
                $a78b7212404532f0$var$parseObjFile(lowerJawFile),
                $a78b7212404532f0$var$parseObjFile(upperJawFile)
            ]);
            console.log("\uD83D\uDD0D Parse results:", {
                lowerJawObjects: lowerJawResult.objects?.length || 0,
                upperJawObjects: upperJawResult.objects?.length || 0
            });
            // The rest of the processing is the same as file mode
            // Extract objects arrays from the results
            const lowerJawObjects = lowerJawResult.objects || [];
            const upperJawObjects = upperJawResult.objects || [];
            // Combine all objects for preview using the same logic as file mode
            const allObjects = [];
            // Add lower jaw objects (group 1) - same processing as file mode
            lowerJawObjects.forEach((obj)=>{
                let finalTeethID = obj.teethID;
                if (finalTeethID === null && obj.name) {
                    const nameMatch = obj.name.match(/^(\d+):/);
                    if (nameMatch) finalTeethID = parseInt(nameMatch[1]);
                }
                const tempTestObj = {
                    name: obj.name || "",
                    userData: {
                        type: null,
                        descr: obj.metadata?.Type,
                        teethID: finalTeethID,
                        originalType: obj.metadata?.Type
                    }
                };
                const detectedType = $a78b7212404532f0$var$getObjectType(tempTestObj);
                const isExplicitBracket = obj.metadata?.Type === "BrktAttm";
                const isImplicitBracket = finalTeethID !== null && obj.name && $a78b7212404532f0$var$isBracketByName(obj.name);
                const isBracket = isExplicitBracket || isImplicitBracket;
                let objectType = null;
                let objectDescr = obj.metadata?.Type;
                if (detectedType === "gingiva") {
                    objectType = "gingiva";
                    objectDescr = "Gingiva";
                } else if (detectedType === "tooth") {
                    objectType = "tooth";
                    objectDescr = "Tooth";
                } else if (isBracket) {
                    objectType = 107;
                    objectDescr = "BrktAttm";
                }
                const mappedObj = {
                    name: obj.name,
                    vertices: obj.vertices,
                    faces: obj.faces,
                    group: 1,
                    type: objectType,
                    descr: objectDescr,
                    teethID: finalTeethID,
                    originalType: obj.metadata?.Type,
                    id: obj.id
                };
                allObjects.push(mappedObj);
            });
            // Add upper jaw objects (group 0) - same processing as file mode
            upperJawObjects.forEach((obj)=>{
                let finalTeethID = obj.teethID;
                if (finalTeethID === null && obj.name) {
                    const nameMatch = obj.name.match(/^(\d+):/);
                    if (nameMatch) finalTeethID = parseInt(nameMatch[1]);
                }
                const tempTestObj = {
                    name: obj.name || "",
                    userData: {
                        type: null,
                        descr: obj.metadata?.Type,
                        teethID: finalTeethID,
                        originalType: obj.metadata?.Type
                    }
                };
                const detectedType = $a78b7212404532f0$var$getObjectType(tempTestObj);
                const isExplicitBracket = obj.metadata?.Type === "BrktAttm";
                const isImplicitBracket = finalTeethID !== null && obj.name && $a78b7212404532f0$var$isBracketByName(obj.name);
                const isBracket = isExplicitBracket || isImplicitBracket;
                let objectType = null;
                let objectDescr = obj.metadata?.Type;
                if (detectedType === "gingiva") {
                    objectType = "gingiva";
                    objectDescr = "Gingiva";
                } else if (detectedType === "tooth") {
                    objectType = "tooth";
                    objectDescr = "Tooth";
                } else if (isBracket) {
                    objectType = 107;
                    objectDescr = "BrktAttm";
                }
                const mappedObj = {
                    name: obj.name,
                    vertices: obj.vertices,
                    faces: obj.faces,
                    group: 0,
                    type: objectType,
                    descr: objectDescr,
                    teethID: finalTeethID,
                    originalType: obj.metadata?.Type,
                    id: obj.id
                };
                allObjects.push(mappedObj);
            });
            console.log("\uD83D\uDCCA Total objects created:", allObjects.length);
            console.log("\uD83D\uDCCA Object details:", allObjects.map((obj)=>({
                    name: obj.name,
                    type: obj.type,
                    descr: obj.descr,
                    group: obj.group,
                    vertexCount: obj.vertices?.length || 0
                })));
            if (allObjects.length === 0) {
                console.warn("\u26A0\uFE0F No objects found after processing Azure files");
                console.log("Debug info:", {
                    lowerJawObjects: lowerJawObjects.length,
                    upperJawObjects: upperJawObjects.length,
                    lowerJawSample: lowerJawObjects.slice(0, 2),
                    upperJawSample: upperJawObjects.slice(0, 2)
                });
                (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No objects found in the Azure files", "exclamation-triangle");
                return;
            }
            // Display objects in main scene
            $a78b7212404532f0$var$displayOriginalObjectsInMainScene(allObjects);
            // Note: Jaw toggle controls removed - visibility controls are now in the left sidebar
            $a78b7212404532f0$var$cleanupFloatingJawControls();
            const processButton = document.getElementById("process-button");
            processButton.disabled = false;
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Loaded ${allObjects.length} objects from Azure - Ready for arrangement`, "check-circle");
        } catch (error) {
            console.error("Error loading Azure arrangement files:", error);
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Error loading Azure arrangement files: ${error.message}`, "exclamation-triangle");
        }
        return;
    }
    const lowerJawFile = document.getElementById("lower-jaw-file").files[0];
    const upperJawFile = document.getElementById("upper-jaw-file").files[0];
    // Only proceed if both files are selected and are .obj files
    if (!lowerJawFile || !upperJawFile) return; // Wait for both files to be selected
    if (!lowerJawFile.name.toLowerCase().endsWith(".obj") || !upperJawFile.name.toLowerCase().endsWith(".obj")) return; // Wait for valid .obj files
    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Loading arrangement files preview...", "info");
    try {
        // Parse both OBJ files
        const [lowerJawResult, upperJawResult] = await Promise.all([
            $a78b7212404532f0$var$parseObjFile(lowerJawFile),
            $a78b7212404532f0$var$parseObjFile(upperJawFile)
        ]);
        // Extract objects arrays from the results
        const lowerJawObjects = lowerJawResult.objects || [];
        const upperJawObjects = upperJawResult.objects || [];
        // Combine all objects for preview
        const allObjects = [];
        // Add lower jaw objects (group 1)
        lowerJawObjects.forEach((obj)=>{
            // Extract teethID from object name if not already present
            let finalTeethID = obj.teethID;
            if (finalTeethID === null && obj.name) {
                const nameMatch = obj.name.match(/^(\d+):/);
                if (nameMatch) finalTeethID = parseInt(nameMatch[1]);
            }
            // Create a temporary object for classification testing
            const tempTestObj = {
                name: obj.name || "",
                userData: {
                    type: null,
                    descr: obj.metadata?.Type,
                    teethID: finalTeethID,
                    originalType: obj.metadata?.Type
                }
            };
            // Detect object type using unified classification
            const detectedType = $a78b7212404532f0$var$getObjectType(tempTestObj);
            // Determine if this is a bracket object (legacy check)
            const isExplicitBracket = obj.metadata?.Type === "BrktAttm";
            const isImplicitBracket = finalTeethID !== null && obj.name && $a78b7212404532f0$var$isBracketByName(obj.name);
            const isBracket = isExplicitBracket || isImplicitBracket;
            // Enhanced mapping with proper type detection
            let objectType = null;
            let objectDescr = obj.metadata?.Type;
            if (detectedType === "gingiva") {
                objectType = "gingiva"; // Custom type for gingiva
                objectDescr = "Gingiva";
            } else if (detectedType === "tooth") {
                objectType = "tooth"; // Custom type for teeth
                objectDescr = "Tooth";
            } else if (isBracket) {
                objectType = 107; // Standard bracket type
                objectDescr = "BrktAttm";
            }
            const mappedObj = {
                name: obj.name,
                vertices: obj.vertices,
                faces: obj.faces,
                group: 1,
                type: objectType,
                descr: objectDescr,
                teethID: finalTeethID,
                originalType: obj.metadata?.Type,
                id: obj.id
            };
            allObjects.push(mappedObj);
        });
        // Add upper jaw objects (group 0)
        upperJawObjects.forEach((obj)=>{
            // Extract teethID from object name if not already present
            let finalTeethID = obj.teethID;
            if (finalTeethID === null && obj.name) {
                const nameMatch = obj.name.match(/^(\d+):/);
                if (nameMatch) finalTeethID = parseInt(nameMatch[1]);
            }
            // Create a temporary object for classification testing
            const tempTestObj = {
                name: obj.name || "",
                userData: {
                    type: null,
                    descr: obj.metadata?.Type,
                    teethID: finalTeethID,
                    originalType: obj.metadata?.Type
                }
            };
            // Detect object type using unified classification
            const detectedType = $a78b7212404532f0$var$getObjectType(tempTestObj);
            // Determine if this is a bracket object (legacy check)
            const isExplicitBracket = obj.metadata?.Type === "BrktAttm";
            const isImplicitBracket = finalTeethID !== null && obj.name && $a78b7212404532f0$var$isBracketByName(obj.name);
            const isBracket = isExplicitBracket || isImplicitBracket;
            // Enhanced mapping with proper type detection
            let objectType = null;
            let objectDescr = obj.metadata?.Type;
            if (detectedType === "gingiva") {
                objectType = "gingiva"; // Custom type for gingiva
                objectDescr = "Gingiva";
            } else if (detectedType === "tooth") {
                objectType = "tooth"; // Custom type for teeth
                objectDescr = "Tooth";
            } else if (isBracket) {
                objectType = 107; // Standard bracket type
                objectDescr = "BrktAttm";
            }
            const mappedObj = {
                name: obj.name,
                vertices: obj.vertices,
                faces: obj.faces,
                group: 0,
                type: objectType,
                descr: objectDescr,
                teethID: finalTeethID,
                originalType: obj.metadata?.Type,
                id: obj.id
            };
            allObjects.push(mappedObj);
        });
        if (allObjects.length === 0) {
            (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No objects found in the selected files", "exclamation-triangle");
            return;
        }
        // Display objects in main scene
        $a78b7212404532f0$var$displayOriginalObjectsInMainScene(allObjects);
        // Note: Jaw toggle controls removed - visibility controls are now in the left sidebar
        $a78b7212404532f0$var$cleanupFloatingJawControls();
        const processButton = document.getElementById("process-button");
        processButton.disabled = false;
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Loaded ${allObjects.length} objects - Ready for arrangement`, "check-circle");
    } catch (error) {
        console.error("Error loading arrangement files:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)(`Error loading arrangement files: ${error.message}`, "exclamation-triangle");
    }
}
// Note: addJawToggleControlsForMainView removed - visibility controls are now in the left sidebar
/**
 * Toggle visibility of gingiva/soft tissue objects in multiple scenes
 * @param {boolean} visible - Whether to show or hide
 * @param {string} sceneKey - Key for the scene ('original', 'segmented', or 'both')
 */ function $a78b7212404532f0$var$toggleGingivaVisibility(visible, sceneKey) {
    if (sceneKey === "both") {
        // Apply to both original and segmented views
        [
            "original",
            "segmented"
        ].forEach((viewKey)=>{
            const scene = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[viewKey];
            if (scene) scene.traverse((object)=>{
                if (object.isMesh && $a78b7212404532f0$var$getObjectType(object) === "gingiva") {
                    // Check jaw visibility for this object
                    const jawVisible = $a78b7212404532f0$var$getJawVisibility(object.userData?.group);
                    const shouldBeVisible = visible && jawVisible;
                    object.visible = shouldBeVisible;
                }
                // Also handle labels for gingiva objects
                if (object.isCSS2DObject && object.name.startsWith("arrangement-label-")) {
                    // Get the associated mesh object to check if it's gingiva
                    const associatedObjectName = object.name.replace("arrangement-label-", "");
                    const associatedMesh = scene.children.find((child)=>child.isMesh && (child.name === associatedObjectName || child.name.includes(associatedObjectName)));
                    if (associatedMesh && $a78b7212404532f0$var$getObjectType(associatedMesh) === "gingiva") {
                        // Label visibility should respect both gingiva visibility and label toggle
                        const showArrangementLabels = document.getElementById("show-arrangement-labels");
                        const labelsEnabled = showArrangementLabels ? showArrangementLabels.checked : false;
                        const jawVisible = $a78b7212404532f0$var$getJawVisibility(associatedMesh.userData?.group);
                        const shouldBeVisible = visible && jawVisible;
                        object.visible = labelsEnabled && shouldBeVisible;
                    }
                }
            });
        });
        // Also apply to overlay view if active
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.traverse((object)=>{
            if (object.isMesh && $a78b7212404532f0$var$getObjectType(object) === "gingiva") {
                const jawVisible = $a78b7212404532f0$var$getJawVisibility(object.userData?.group);
                const shouldBeVisible = visible && jawVisible;
                object.visible = shouldBeVisible;
            }
        });
    } else {
        // Apply to single view
        const scene = sceneKey === "main" ? (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene : (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[sceneKey];
        if (scene) scene.traverse((object)=>{
            if (object.isMesh && $a78b7212404532f0$var$getObjectType(object) === "gingiva") {
                // Check jaw visibility for this object
                const jawVisible = $a78b7212404532f0$var$getJawVisibility(object.userData?.group);
                const shouldBeVisible = visible && jawVisible;
                object.visible = shouldBeVisible;
            }
            // Also handle labels for gingiva objects
            if (object.isCSS2DObject && object.name.startsWith("arrangement-label-")) {
                // Get the associated mesh object to check if it's gingiva
                const associatedObjectName = object.name.replace("arrangement-label-", "");
                const associatedMesh = scene.children.find((child)=>child.isMesh && (child.name === associatedObjectName || child.name.includes(associatedObjectName)));
                if (associatedMesh && $a78b7212404532f0$var$getObjectType(associatedMesh) === "gingiva") {
                    // Label visibility should respect both gingiva visibility and label toggle
                    const showArrangementLabels = document.getElementById("show-arrangement-labels");
                    const labelsEnabled = showArrangementLabels ? showArrangementLabels.checked : false;
                    const jawVisible = $a78b7212404532f0$var$getJawVisibility(associatedMesh.userData?.group);
                    const shouldBeVisible = visible && jawVisible;
                    object.visible = labelsEnabled && shouldBeVisible;
                }
            }
        });
    }
}
/**
 * Determine the type of a dental object
 * @param {THREE.Object3D} object - The object to classify
 * @returns {string} Object type: 'gingiva', 'tooth', 'bracket', or 'other'
 */ function $a78b7212404532f0$var$getObjectType(object) {
    if (!object.name && !object.userData) return "other";
    const objectName = object.name || "unnamed";
    const name = object.name ? object.name.toLowerCase() : "";
    // Check for gingiva/soft tissue first (highest priority)
    const gingivaKeywords = [
        "gingiva",
        "soft tissue",
        "maxilla",
        "mandible",
        "gum",
        "tissue",
        "soft"
    ];
    if (gingivaKeywords.some((keyword)=>name.includes(keyword))) return "gingiva";
    // Check for tooth objects
    const toothPatterns = [
        /^tooth\s*\d+$/i,
        /^\d+\s*tooth$/i,
        /^[a-z]*\s*\d{1,2}$/i,
        /^(central|lateral|canine|premolar|molar|incisor)/i // Tooth types
    ];
    if (toothPatterns.some((pattern)=>pattern.test(name))) return "tooth";
    // Check for tooth-specific keywords (but exclude if it contains bracket keywords)
    const toothKeywords = [
        "crown",
        "root",
        "enamel",
        "dentin"
    ];
    const hasToothKeyword = toothKeywords.some((keyword)=>name.includes(keyword));
    if (hasToothKeyword) {
        const bracketKeywords = [
            "bracket",
            "brkt",
            "tube",
            "attachment"
        ];
        const hasBracketKeyword = bracketKeywords.some((keyword)=>name.includes(keyword));
        if (!hasBracketKeyword) return "tooth";
    }
    // Check for explicit object types set during mapping
    if (object.userData) {
        // Check for explicitly set gingiva type
        if (object.userData.type === "gingiva" || object.userData.descr === "Gingiva") return "gingiva";
        // Check for explicitly set tooth type
        if (object.userData.type === "tooth" || object.userData.descr === "Tooth") return "tooth";
        // Check for bracket type (Type 107 is bracket in InfoJson)
        if (object.userData.type === 107) return "bracket";
        // Check for bracket description
        if (object.userData.descr === "BrktAttm") return "bracket";
        // Check for original type from .obj file
        if (object.userData.originalType === "BrktAttm") return "bracket";
        // Check if teethID is set (brackets have associated tooth IDs)
        if (object.userData.teethID !== undefined && object.userData.teethID !== null) {
            // Additional check using name pattern to confirm it's a bracket
            if (object.name && $a78b7212404532f0$var$isBracketByName(object.name)) return "bracket";
        }
    }
    // Check by name pattern as fallback for brackets
    if (object.name && $a78b7212404532f0$var$isBracketByName(object.name)) {
        console.log(`\u{26A0}\u{FE0F} Object "${objectName}" classified as bracket by name pattern only - missing metadata`);
        return "bracket";
    }
    // Default: other object type
    return "other";
}
/**
 * Toggle visibility of bracket objects in multiple scenes
 * @param {boolean} visible - Whether to show or hide
 * @param {string} sceneKey - Key for the scene ('original', 'segmented', or 'both')
 */ function $a78b7212404532f0$var$toggleBracketsVisibility(visible, sceneKey) {
    if (sceneKey === "both") {
        // Apply to both original and segmented views
        [
            "original",
            "segmented"
        ].forEach((viewKey)=>{
            const scene = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[viewKey];
            if (scene) scene.traverse((object)=>{
                if (object.isMesh && $a78b7212404532f0$var$getObjectType(object) === "bracket") {
                    // Check jaw visibility for this object
                    const jawVisible = $a78b7212404532f0$var$getJawVisibility(object.userData?.group);
                    const shouldBeVisible = visible && jawVisible;
                    object.visible = shouldBeVisible;
                }
                // Also handle labels for bracket objects
                if (object.isCSS2DObject && object.name.startsWith("arrangement-label-")) {
                    // Get the associated mesh object to check if it's a bracket
                    const associatedObjectName = object.name.replace("arrangement-label-", "");
                    const associatedMesh = scene.children.find((child)=>child.isMesh && (child.name === associatedObjectName || child.name.includes(associatedObjectName)));
                    if (associatedMesh && $a78b7212404532f0$var$getObjectType(associatedMesh) === "bracket") {
                        // Label visibility should respect both bracket visibility and label toggle
                        const showArrangementLabels = document.getElementById("show-arrangement-labels");
                        const labelsEnabled = showArrangementLabels ? showArrangementLabels.checked : false;
                        const jawVisible = $a78b7212404532f0$var$getJawVisibility(associatedMesh.userData?.group);
                        const shouldBeVisible = visible && jawVisible;
                        object.visible = labelsEnabled && shouldBeVisible;
                    }
                }
            });
        });
        // Also apply to overlay view if active
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayScene.traverse((object)=>{
            if (object.isMesh && $a78b7212404532f0$var$getObjectType(object) === "bracket") {
                const jawVisible = $a78b7212404532f0$var$getJawVisibility(object.userData?.group);
                const shouldBeVisible = visible && jawVisible;
                object.visible = shouldBeVisible;
            }
        });
    } else {
        // Apply to single view
        const scene = sceneKey === "main" ? (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene : (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[sceneKey];
        if (scene) scene.traverse((object)=>{
            if (object.isMesh && $a78b7212404532f0$var$getObjectType(object) === "bracket") {
                // Check jaw visibility for this object
                const jawVisible = $a78b7212404532f0$var$getJawVisibility(object.userData?.group);
                const shouldBeVisible = visible && jawVisible;
                object.visible = shouldBeVisible;
            }
            // Also handle labels for bracket objects
            if (object.isCSS2DObject && object.name.startsWith("arrangement-label-")) {
                // Get the associated mesh object to check if it's a bracket
                const associatedObjectName = object.name.replace("arrangement-label-", "");
                const associatedMesh = scene.children.find((child)=>child.isMesh && (child.name === associatedObjectName || child.name.includes(associatedObjectName)));
                if (associatedMesh && $a78b7212404532f0$var$getObjectType(associatedMesh) === "bracket") {
                    // Label visibility should respect both bracket visibility and label toggle
                    const showArrangementLabels = document.getElementById("show-arrangement-labels");
                    const labelsEnabled = showArrangementLabels ? showArrangementLabels.checked : false;
                    const jawVisible = $a78b7212404532f0$var$getJawVisibility(associatedMesh.userData?.group);
                    const shouldBeVisible = visible && jawVisible;
                    object.visible = labelsEnabled && shouldBeVisible;
                }
            }
        });
    }
}
/**
 * Check if an object is a bracket based on name patterns
 * @param {string} name - The object name to check
 * @returns {boolean} True if the name indicates a bracket
 */ function $a78b7212404532f0$var$isBracketByName(name) {
    if (!name) return false;
    const nameLower = name.toLowerCase();
    // First, check for explicit exclusion patterns (definitely NOT brackets)
    const exclusionPatterns = [
        "tooth ",
        "gingiva",
        "soft tissue",
        "hard tissue",
        "plane",
        "mandible",
        "maxilla" // Jaw bones (unless they have bracket pattern)
    ];
    // If name matches any exclusion pattern, it's NOT a bracket
    if (exclusionPatterns.some((pattern)=>nameLower.includes(pattern))) return false;
    // Check for positive bracket indicators
    // Brackets can have explicit keywords OR follow the pattern "number: model - description"
    const bracketKeywords = [
        "bracket",
        "brkt",
        "tube",
        "attachment",
        "attm",
        "brace"
    ];
    // Check for explicit bracket keywords
    if (bracketKeywords.some((keyword)=>nameLower.includes(keyword))) return true;
    // Check for bracket naming pattern: "number: model - description"
    // Examples: "21: 1X-1 - Metal SL", "17: 4T-1 - Molar Tube"
    // Pattern: starts with digits, colon, then model number/description
    const bracketPattern = /^\d+:\s*[\w-]+/;
    if (bracketPattern.test(name)) // Additional check: if it has a colon and doesn't match exclusions, likely a bracket
    return true;
    // Default: not a bracket
    return false;
}
/**
 * Get the current visibility state of a jaw group
 * @param {number} jawGroup - 0 for upper, 1 for lower
 * @returns {boolean} True if the jaw should be visible
 */ function $a78b7212404532f0$var$getJawVisibility(jawGroup) {
    if (jawGroup === 0) {
        // Upper jaw
        const upperCheckbox = document.getElementById("show-upper-jaw");
        return upperCheckbox ? upperCheckbox.checked : true;
    } else if (jawGroup === 1) {
        // Lower jaw
        const lowerCheckbox = document.getElementById("show-lower-jaw");
        return lowerCheckbox ? lowerCheckbox.checked : true;
    }
    // Default: assume visible if no group specified
    return true;
}
/**
 * Check if an object should be visible based on all toggle states
 * @param {THREE.Object3D} object - The object to check
 * @param {boolean} jawVisible - Whether the jaw containing this object should be visible
 * @returns {boolean} True if the object should be visible
 */ function $a78b7212404532f0$var$shouldObjectBeVisible(object, jawVisible) {
    // If the jaw is hidden, hide everything in that jaw
    if (!jawVisible) return false;
    // If jaw is visible, check individual object type toggles
    const objectType = $a78b7212404532f0$var$getObjectType(object);
    switch(objectType){
        case "gingiva":
            const gingivaCheckbox = document.getElementById("show-gingiva");
            return gingivaCheckbox ? gingivaCheckbox.checked : false;
        case "bracket":
            const bracketsCheckbox = document.getElementById("show-brackets");
            return bracketsCheckbox ? bracketsCheckbox.checked : false;
        case "tooth":
        case "other":
        default:
            // For regular teeth and other objects, follow jaw visibility
            return jawVisible;
    }
}
/**
 * Get initial visibility for an object based on its type and checkbox states
 * @param {THREE.Object3D} object - The object to check
 * @returns {boolean} True if the object should be visible initially
 */ function $a78b7212404532f0$var$getInitialObjectVisibility(object) {
    const objectType = $a78b7212404532f0$var$getObjectType(object);
    // Handle object type visibility first
    switch(objectType){
        case "gingiva":
            // Gingiva hidden by default
            const gingivaCheckbox = document.getElementById("show-gingiva");
            return gingivaCheckbox ? gingivaCheckbox.checked : false;
        case "bracket":
            // Brackets hidden by default
            const bracketsCheckbox = document.getElementById("show-brackets");
            return bracketsCheckbox ? bracketsCheckbox.checked : false;
        case "tooth":
        case "other":
        default:
            // For teeth and other objects, check jaw group visibility
            if (object.userData && typeof object.userData.group === "number") {
                if (object.userData.group === 0) {
                    // Upper jaw
                    const upperCheckbox = document.getElementById("show-upper-jaw");
                    return upperCheckbox ? upperCheckbox.checked : true;
                } else if (object.userData.group === 1) {
                    // Lower jaw
                    const lowerCheckbox = document.getElementById("show-lower-jaw");
                    return lowerCheckbox ? lowerCheckbox.checked : true;
                }
            }
            // Default: show the object
            return true;
    }
}
/**
 * Clear only inference results (keeps files loaded but clears processing results)
 * This is called when new files are selected to ensure clean state for new inference
 */ function $a78b7212404532f0$var$clearInferenceResults() {
    console.log("\uD83E\uDDF9 Clearing previous inference results...");
    // Clear inference data
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult = null;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson = null;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).displacementTable = null;
    // Clear separation phase data
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase = 0;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData = {
        originalMesh: null,
        segmentedMesh: null,
        analyzedTeeth: null,
        finalResult: null,
        reconstructionResult: null
    };
    // Remove existing class labels from scene
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).classLabels) {
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).classLabels.forEach((label)=>(0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(label));
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).classLabels = [];
    }
    // Remove keypoint objects and labels
    for(let i = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children.length - 1; i >= 0; i--){
        const child = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children[i];
        if (child.name?.startsWith("keypoint-")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(child);
    }
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypoints = {};
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypointLabels = [];
    // Remove arrangement object labels from main scene
    for(let i = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children.length - 1; i >= 0; i--){
        const child = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.children[i];
        if (child.isCSS2DObject && child.name?.startsWith("arrangement-label-")) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.remove(child);
    }
    // Remove boundary points and lines
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryPoints) {
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryPoints);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryPoints = null;
    }
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLines) {
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLines);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).boundaryLines = null;
    }
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryPoints) {
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryPoints);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryPoints = null;
    }
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLines) {
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryScene.remove((0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLines);
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).simplifiedBoundaryLines = null;
    }
    // Clear multi-view scenes if active
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView && (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes) {
        Object.keys((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes).forEach((view)=>{
            if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view]) // Keep only lights by removing other objects
            for(let i = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].children.length - 1; i >= 0; i--){
                const obj = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].children[i];
                if (!(obj instanceof $0d79572b4b22d35c$export$6ecadb6ed240d696)) {
                    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].remove(obj);
                    // Dispose of geometry and materials
                    if (obj.geometry) obj.geometry.dispose();
                    if (obj.material) {
                        if (Array.isArray(obj.material)) obj.material.forEach((mat)=>mat.dispose());
                        else obj.material.dispose();
                    }
                }
            }
        });
        // Hide multi-view container and show main view
        const multiViewContainer = document.getElementById("multi-view-container");
        if (multiViewContainer) multiViewContainer.style.display = "none";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderer.domElement.style.display = "block";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).labelRenderer.domElement.style.display = "block";
        (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView = false;
    }
    // Hide result-related buttons
    $a78b7212404532f0$var$hideInfoJsonActions();
    const nextPhaseButton = document.getElementById("next-phase-button");
    if (nextPhaseButton) nextPhaseButton.style.display = "none";
    const downloadButtonsContainer = document.getElementById("download-buttons-container");
    if (downloadButtonsContainer) downloadButtonsContainer.style.display = "none";
    const downloadResultsButton = document.getElementById("download-results-button");
    if (downloadResultsButton) downloadResultsButton.style.display = "none";
    const downloadObjButton = document.getElementById("download-obj-button");
    if (downloadObjButton) downloadObjButton.style.display = "none";
    // Hide start over button
    $a78b7212404532f0$var$hideStartOverAndFeedbackButtons();
    const processButton = document.getElementById("process-button");
    if (processButton) {
        processButton.textContent = "Process";
        processButton.disabled = false;
    }
    // Re-enable keypoint labels checkbox when clearing results
    $a78b7212404532f0$var$enableKeypointLabelsCheckbox();
    // Update postprocessing section visibility after clearing results
    (0, $ddb3f022a87c2bc1$export$7de7bccc87a83087)();
    const currentMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
    $a78b7212404532f0$var$updateModelOptionsSectionVisibility(currentMode);
    $a78b7212404532f0$var$updateClearButtonFromState();
    $a78b7212404532f0$var$updateArrangementActionButtons();
    console.log("\u2705 Inference results cleared");
}
/**
 * Clear all files and state when switching processing modes
 */ function $a78b7212404532f0$var$clearAllFilesAndState() {
    // Clear the main file and all processing results
    $a78b7212404532f0$var$clearFile();
    // Clear arrangement file inputs
    const lowerJawFile = document.getElementById("lower-jaw-file");
    const upperJawFile = document.getElementById("upper-jaw-file");
    const infoJsonFile = document.getElementById("info-json-file");
    const landmarksCsvFile = document.getElementById("landmarks-csv-file");
    if (lowerJawFile) lowerJawFile.value = "";
    if (upperJawFile) upperJawFile.value = "";
    if (infoJsonFile) infoJsonFile.value = "";
    if (landmarksCsvFile) landmarksCsvFile.value = "";
    // Clear Azure path inputs
    const singleAzurePath = document.getElementById("azure-path-input");
    const lowerJawAzurePath = document.getElementById("lower-jaw-azure-path");
    const upperJawAzurePath = document.getElementById("upper-jaw-azure-path");
    const infoJsonAzurePath = document.getElementById("info-json-azure-path");
    const landmarksCsvAzurePath = document.getElementById("landmarks-csv-azure-path");
    if (singleAzurePath) singleAzurePath.value = "";
    if (lowerJawAzurePath) lowerJawAzurePath.value = "";
    if (upperJawAzurePath) upperJawAzurePath.value = "";
    if (infoJsonAzurePath) infoJsonAzurePath.value = "";
    if (landmarksCsvAzurePath) landmarksCsvAzurePath.value = "";
    // Clear the Azure folder input and its resolution preview/error
    const arrangementFolderPath = document.getElementById("arrangement-folder-path");
    if (arrangementFolderPath) arrangementFolderPath.value = "";
    const folderResolvePreview = document.getElementById("folder-resolve-preview");
    if (folderResolvePreview) {
        folderResolvePreview.textContent = "";
        folderResolvePreview.style.display = "none";
    }
    const folderResolveError = document.getElementById("folder-resolve-error");
    if (folderResolveError) {
        folderResolveError.textContent = "";
        folderResolveError.style.display = "none";
    }
    const overrideAzurePathsCheckbox = document.getElementById("override-azure-paths-checkbox");
    if (overrideAzurePathsCheckbox) overrideAzurePathsCheckbox.checked = false;
    // Clear arrangement file name displays
    const lowerJawFileName = document.getElementById("lower-jaw-file-name");
    const upperJawFileName = document.getElementById("upper-jaw-file-name");
    const infoJsonFileName = document.getElementById("info-json-file-name");
    const landmarksCsvFileName = document.getElementById("landmarks-csv-file-name");
    if (lowerJawFileName) lowerJawFileName.textContent = "";
    if (upperJawFileName) upperJawFileName.textContent = "";
    if (infoJsonFileName) infoJsonFileName.textContent = "";
    if (landmarksCsvFileName) landmarksCsvFileName.textContent = "";
    // Clear single file name display
    const fileNameDiv = document.getElementById("file-name");
    if (fileNameDiv) fileNameDiv.textContent = "";
    // Hide all mode-specific buttons
    $a78b7212404532f0$var$hideInfoJsonActions();
    const nextPhaseButton = document.getElementById("next-phase-button");
    if (nextPhaseButton) nextPhaseButton.style.display = "none";
    // Hide view mode toggle
    const viewModeContainer = document.getElementById("arrangement-view-mode-container");
    if (viewModeContainer) viewModeContainer.style.display = "none";
    // Reset view mode to dual
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).overlayViewMode = "dual";
    const overlayViewContainer = document.getElementById("overlay-view-container");
    if (overlayViewContainer) overlayViewContainer.style.display = "none";
    // Hide download buttons from teeth reconstruction
    const downloadButtonsContainer = document.getElementById("download-buttons-container");
    if (downloadButtonsContainer) downloadButtonsContainer.style.display = "none";
    const downloadResultsButton = document.getElementById("download-results-button");
    if (downloadResultsButton) downloadResultsButton.style.display = "none";
    const downloadObjButton = document.getElementById("download-obj-button");
    if (downloadObjButton) downloadObjButton.style.display = "none";
    // Remove jaw toggle controls if they exist
    const jawToggleControls = document.getElementById("jaw-toggle-controls");
    if (jawToggleControls) jawToggleControls.remove();
    // Reset process button
    const processButton = document.getElementById("process-button");
    if (processButton) {
        processButton.textContent = "Process";
        processButton.disabled = false;
    }
    // Reset processing state
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).processingFile = false;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationPhase = 0;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult = null;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson = null;
    // Clear separation data
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).separationData = {
        originalMesh: null,
        segmentedMesh: null,
        analyzedTeeth: null,
        finalResult: null,
        reconstructionResult: null
    };
    // Hide processing indicator
    const processingIndicator = document.getElementById("processing-indicator");
    if (processingIndicator) processingIndicator.style.display = "none";
    // Clear multi-view scenes if they exist
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes) Object.keys((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes).forEach((view)=>{
        if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view]) // Keep only lights by removing other objects
        for(let i = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].children.length - 1; i >= 0; i--){
            const obj = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].children[i];
            if (!(obj instanceof $0d79572b4b22d35c$export$6ecadb6ed240d696)) {
                (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes[view].remove(obj);
                // Dispose of geometry and materials
                if (obj.geometry) obj.geometry.dispose();
                if (obj.material) {
                    if (Array.isArray(obj.material)) obj.material.forEach((mat)=>mat.dispose());
                    else obj.material.dispose();
                }
            }
        }
    });
    // Reset multi-view container to default state
    $a78b7212404532f0$var$resetMultiViewContainer();
    // Turn off multi-view rendering
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).renderMultiView = false;
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewLayoutInitialized = false;
    // Hide start over button and feedback button
    $a78b7212404532f0$var$hideStartOverAndFeedbackButtons();
    (0, $aa8a35ff0d89d373$export$325c923fa31af59e)();
    // Update postprocessing section visibility after clearing all files and state
    (0, $ddb3f022a87c2bc1$export$7de7bccc87a83087)();
    const currentMode = document.getElementById("processing-mode-dropdown")?.value || "arrangement";
    $a78b7212404532f0$var$updateModelOptionsSectionVisibility(currentMode);
    $a78b7212404532f0$var$updateClearButtonFromState();
    $a78b7212404532f0$var$updateArrangementActionButtons();
    // Show success message
    (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Files cleared for new processing mode", "check-circle");
}
/**
 * Displacement table coloring: same thresholds as tools/arrangement/check_displacement_calculation.py
 * Returns "green" | "yellow" | "red" | null (no class).
 */ function $a78b7212404532f0$var$getDisplacementCellColorLevel(rawVal, movementKey, toothNum) {
    if (rawVal == null || toothNum == null) return null;
    const anteriorTeeth = new Set([
        11,
        12,
        13,
        21,
        22,
        23,
        31,
        32,
        33,
        41,
        42,
        43
    ]);
    const posteriorTeeth = new Set([
        14,
        15,
        16,
        17,
        18,
        24,
        25,
        26,
        27,
        28,
        34,
        35,
        36,
        37,
        38,
        44,
        45,
        46,
        47,
        48
    ]);
    let region = null;
    if (anteriorTeeth.has(toothNum)) region = "anterior";
    else if (posteriorTeeth.has(toothNum)) region = "posterior";
    if (movementKey === "mesial_distal") region = "posterior";
    if (region == null) return null;
    const thresholds = {
        mesial_distal: {
            anterior: null,
            posterior: [
                2.0,
                3.0,
                3.0
            ]
        },
        buccal_lingual: {
            anterior: [
                2.0,
                3.0,
                3.0
            ],
            posterior: [
                1.5,
                2.5,
                2.5
            ]
        },
        vertical: {
            anterior: [
                2.5,
                5.0,
                5.0
            ],
            posterior: [
                1.5,
                2.5,
                2.5
            ]
        },
        rotation: {
            anterior: [
                45.0,
                90.0,
                90.0
            ],
            posterior: [
                30.0,
                45.0,
                45.0
            ]
        },
        tip: {
            anterior: [
                10.0,
                15.0,
                15.0
            ],
            posterior: [
                8.0,
                12.0,
                12.0
            ]
        },
        torque: {
            anterior: [
                12.0,
                18.0,
                18.0
            ],
            posterior: [
                10.0,
                15.0,
                15.0
            ]
        }
    };
    const thr = thresholds[movementKey] && thresholds[movementKey][region];
    if (!thr) return null;
    const [gMax, yMax, rMin] = thr;
    const mag = Math.abs(rawVal);
    if (mag <= gMax) return "green";
    if (mag <= yMax) return "yellow";
    if (mag > rMin) return "red";
    return null;
}
/**
 * Show displacement table in modal
 */ function $a78b7212404532f0$var$showDisplacementTable() {
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).displacementTable || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).displacementTable.length === 0) {
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No displacement table data available", "exclamation-triangle");
        return;
    }
    const modal = document.getElementById("displacement-table-modal");
    const container = document.getElementById("displacement-table-container");
    if (!modal || !container) {
        console.error("Displacement table modal elements not found");
        return;
    }
    // Clear previous content
    container.innerHTML = "";
    // Create a map to organize data by tooth_id
    const dataByToothId = new Map();
    const toothIds = [];
    // Collect all unique tooth IDs and organize data
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).displacementTable.forEach((record)=>{
        const toothId = record.tooth_id || "-";
        if (!dataByToothId.has(toothId)) {
            dataByToothId.set(toothId, record);
            toothIds.push(toothId);
        }
    });
    // Separate tooth IDs into Maxilla (upper) and Mandible (lower)
    const maxillaIds = [];
    const mandibleIds = [];
    toothIds.forEach((toothId)=>{
        if (String(toothId).startsWith("upper-")) maxillaIds.push(toothId);
        else if (String(toothId).startsWith("lower-")) mandibleIds.push(toothId);
    });
    // Desired column order: Maxilla 18..11, 21..28; Mandible 48..41, 31..38
    const MAXILLA_ORDER = [
        18,
        17,
        16,
        15,
        14,
        13,
        12,
        11,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28
    ];
    const MANDIBLE_ORDER = [
        48,
        47,
        46,
        45,
        44,
        43,
        42,
        41,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38
    ];
    const sortByOrder = (order)=>(a, b)=>{
            const getFDI = (id)=>{
                const sid = String(id);
                const m = sid.match(/(?:upper|lower)-(\d+)/);
                return m ? parseInt(m[1], 10) : NaN;
            };
            const idxA = order.indexOf(getFDI(a));
            const idxB = order.indexOf(getFDI(b));
            const posA = idxA === -1 ? 999 : idxA;
            const posB = idxB === -1 ? 999 : idxB;
            return posA - posB;
        };
    maxillaIds.sort(sortByOrder(MAXILLA_ORDER));
    mandibleIds.sort(sortByOrder(MANDIBLE_ORDER));
    // Define metrics and their properties (rendered as rows within each jaw
    // table).
    const metrics = [
        {
            name: "Mesial/Distal (mm)",
            key: "mesial_distal",
            index: 0,
            decimals: 1
        },
        {
            name: "Buccal/Lingual (mm)",
            key: "buccal_lingual",
            index: 1,
            decimals: 1
        },
        {
            name: "Occlusal/Gingiva (mm)",
            key: "vertical",
            index: 2,
            decimals: 1
        },
        {
            name: "Torque (\xb0)",
            key: "torque",
            index: 3,
            decimals: 0
        },
        {
            name: "Angulation (\xb0)",
            key: "tip",
            index: 4,
            decimals: 0
        },
        {
            name: "Rotation (\xb0)",
            key: "rotation",
            index: 5,
            decimals: 0
        },
        {
            name: "Space/Intersection (mm)",
            key: "space_intersection",
            index: null,
            decimals: 1,
            isSpace: true
        }
    ];
    // Build one table for a single jaw. Tables are stacked vertically (Maxilla
    // on top, Mandible on bottom) so each jaw reads as its own block.
    const buildJawTable = (jawLabel, jawColor, jawToothIds)=>{
        const table = document.createElement("table");
        table.style.width = "100%";
        table.style.borderCollapse = "collapse";
        table.style.marginTop = "20px";
        table.style.fontSize = "15px";
        // Header: Metric (spans 2 rows) + the jaw group label, then a row of
        // individual tooth IDs.
        const thead = document.createElement("thead");
        const groupHeaderRow = document.createElement("tr");
        const metricHeader = document.createElement("th");
        metricHeader.textContent = "Metric";
        metricHeader.style.padding = "10px";
        metricHeader.style.border = "1px solid #ddd";
        metricHeader.style.backgroundColor = "#f2f2f2";
        metricHeader.style.textAlign = "left";
        metricHeader.style.minWidth = "200px";
        metricHeader.style.whiteSpace = "nowrap";
        metricHeader.setAttribute("rowspan", "2");
        groupHeaderRow.appendChild(metricHeader);
        const jawHeader = document.createElement("th");
        jawHeader.textContent = jawLabel;
        jawHeader.style.padding = "10px";
        jawHeader.style.border = "1px solid #ddd";
        jawHeader.style.backgroundColor = jawColor;
        jawHeader.style.textAlign = "center";
        jawHeader.style.fontWeight = "bold";
        jawHeader.setAttribute("colspan", jawToothIds.length.toString());
        groupHeaderRow.appendChild(jawHeader);
        thead.appendChild(groupHeaderRow);
        const toothHeaderRow = document.createElement("tr");
        jawToothIds.forEach((toothId)=>{
            const th = document.createElement("th");
            // Remove "upper-" or "lower-" prefix from tooth ID
            const displayText = String(toothId).replace(/^(upper|lower)-/, "");
            th.textContent = displayText;
            th.style.padding = "10px";
            th.style.border = "1px solid #ddd";
            th.style.backgroundColor = "#f2f2f2";
            th.style.textAlign = "center";
            toothHeaderRow.appendChild(th);
        });
        thead.appendChild(toothHeaderRow);
        table.appendChild(thead);
        // Body: one row per metric.
        const tbody = document.createElement("tbody");
        metrics.forEach((metric)=>{
            const row = document.createElement("tr");
            // Metric name cell
            const metricCell = document.createElement("td");
            metricCell.textContent = metric.name;
            metricCell.style.padding = "8px";
            metricCell.style.border = "1px solid #ddd";
            metricCell.style.fontWeight = "bold";
            metricCell.style.backgroundColor = "#f9f9f9";
            metricCell.style.minWidth = "200px";
            metricCell.style.whiteSpace = "nowrap";
            row.appendChild(metricCell);
            // Values for each tooth
            jawToothIds.forEach((toothId)=>{
                const record = dataByToothId.get(toothId);
                const cell = document.createElement("td");
                cell.style.padding = "8px";
                cell.style.border = "1px solid #ddd";
                cell.style.textAlign = "right";
                let displayValue = "-";
                let rawVal = null;
                let toothNum = null;
                // Extract tooth number for coloring
                if (record && record.tooth_id != null) {
                    const sid = String(record.tooth_id);
                    const m = sid.match(/(?:upper|lower)-(\d+)/);
                    toothNum = m ? parseInt(m[1], 10) : parseInt(sid, 10);
                    if (toothNum !== toothNum) toothNum = null; // NaN
                }
                if (metric.isSpace) // Space/Intersection value
                {
                    if (record && record.space_intersection != null && typeof record.space_intersection === "number") {
                        rawVal = record.space_intersection;
                        displayValue = rawVal.toFixed(metric.decimals);
                        // Color coding based on tooth type
                        const absVal = Math.abs(rawVal);
                        if (toothNum != null) {
                            const anteriorTeeth = new Set([
                                11,
                                12,
                                13,
                                14,
                                15,
                                21,
                                22,
                                23,
                                24,
                                25,
                                31,
                                32,
                                33,
                                34,
                                35,
                                41,
                                42,
                                43,
                                44,
                                45
                            ]);
                            const posteriorTeeth = new Set([
                                16,
                                17,
                                18,
                                26,
                                27,
                                28,
                                36,
                                37,
                                38,
                                46,
                                47,
                                48
                            ]);
                            if (anteriorTeeth.has(toothNum)) {
                                // Anterior (5-5): absVal <= 0.2 - green, absVal <= 0.4 - yellow, absVal > 0.4 - red
                                if (absVal <= 0.2) cell.classList.add("disp-green");
                                else if (absVal <= 0.4) cell.classList.add("disp-yellow");
                                else cell.classList.add("disp-red");
                            } else if (posteriorTeeth.has(toothNum)) {
                                // Posterior (5-8): absVal >= 0.1 - red, otherwise green
                                if (absVal >= 0.05) cell.classList.add("disp-red");
                                else cell.classList.add("disp-green");
                            } else // Unknown tooth type, default to green
                            cell.classList.add("disp-green");
                        } else // No tooth number, default to green
                        cell.classList.add("disp-green");
                    }
                } else // Displacement value
                if (record && record.displacement && Array.isArray(record.displacement) && metric.index !== null) {
                    const value = record.displacement[metric.index];
                    rawVal = typeof value === "number" ? value : null;
                    if (rawVal != null) {
                        displayValue = rawVal.toFixed(metric.decimals);
                        // Apply coloring
                        if (toothNum != null) {
                            const level = $a78b7212404532f0$var$getDisplacementCellColorLevel(rawVal, metric.key, toothNum);
                            if (level) cell.classList.add("disp-" + level);
                        }
                    } else if (value != null) displayValue = String(value);
                }
                cell.textContent = displayValue;
                row.appendChild(cell);
            });
            tbody.appendChild(row);
        });
        table.appendChild(tbody);
        return table;
    };
    // Stack the jaws vertically: Maxilla on top, Mandible on bottom.
    if (maxillaIds.length > 0) container.appendChild(buildJawTable("Maxilla", "#e3f2fd", maxillaIds));
    if (mandibleIds.length > 0) container.appendChild(buildJawTable("Mandible", "#fff3e0", mandibleIds));
    modal.style.display = "block";
}
/**
 * Download InfoJSON file from the last arrangement result
 */ function $a78b7212404532f0$var$downloadInfoJson() {
    if (!(0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson) {
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("No InfoJSON data available for download", "exclamation-triangle");
        return;
    }
    try {
        // Strip internal processing state from the downloaded file: the rigid A-P
        // shift the molar correction applied (scalar MolarMovementShiftZ) with its
        // per-FDI record (MolarMovementShiftByFdi), and the per-tooth archform
        // expansion (ArchformOffsets). All three are kept only so Refine can
        // reverse them, and none should leak into the InfoJSON the user downloads.
        // Shallow clone so the live object Refine re-uploads keeps them.
        const infoJsonForDownload = {
            ...(0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson
        };
        delete infoJsonForDownload.MolarMovementShiftZ;
        delete infoJsonForDownload.MolarMovementShiftByFdi;
        delete infoJsonForDownload.ArchformOffsets;
        // Create a blob with the InfoJSON data
        const jsonString = JSON.stringify(infoJsonForDownload, null, 2);
        const blob = new Blob([
            jsonString
        ], {
            type: "application/json"
        });
        // Create a download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "arrangement_info.json";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("InfoJSON file downloaded successfully", "check-circle");
    } catch (error) {
        console.error("Error downloading InfoJSON:", error);
        (0, $7259ed209c831d5c$export$f6cef6fcf9ca4e17)("Error downloading InfoJSON file", "exclamation-triangle");
    }
}
/**
 * Show the start over / feedback button (CSS handles collapsed/expanded visibility)
 */ function $a78b7212404532f0$var$showStartOverAndFeedbackButtons() {
    const startOverButton = document.getElementById("start-over-button");
    const feedbackButton = document.getElementById("feedback-button");
    const collapsedFeedbackButton = document.getElementById("feedback-button-collapsed");
    if (startOverButton) startOverButton.style.visibility = "visible";
    if (feedbackButton) feedbackButton.style.visibility = "visible";
    if (collapsedFeedbackButton) {
        // Remove display override and let CSS handle visibility based on sidebar state
        collapsedFeedbackButton.style.visibility = "visible";
        collapsedFeedbackButton.style.display = "";
    }
}
/**
 * Hide the start over / feedback button
 */ function $a78b7212404532f0$var$hideStartOverAndFeedbackButtons() {
    const startOverButton = document.getElementById("start-over-button");
    const feedbackButton = document.getElementById("feedback-button");
    const collapsedFeedbackButton = document.getElementById("feedback-button-collapsed");
    const displacementTableButton = document.getElementById("displacement-table-button");
    if (startOverButton) startOverButton.style.visibility = "hidden";
    if (feedbackButton) feedbackButton.style.visibility = "hidden";
    if (collapsedFeedbackButton) // Hide by setting display to none, overriding CSS
    collapsedFeedbackButton.style.display = "none";
    if (displacementTableButton) displacementTableButton.style.display = "none";
}
/**
 * Update start over button visibility based on results availability
 * (CSS handles the collapsed/expanded state visibility)
 */ function $a78b7212404532f0$var$updateStartOverButtonVisibility() {
    const startOverButton = document.getElementById("start-over-button");
    const feedbackButton = document.getElementById("feedback-button");
    const collapsedFeedbackButton = document.getElementById("feedback-button-collapsed");
    if (startOverButton) {
        // Check if we have processed results
        const hasResults = (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastInferenceResult || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).lastArrangementInfoJson || (0, $66dbd4fb7330af32$export$8e769ad4338a911e).mesh;
        // CSS will handle collapsed/expanded visibility
        // We just need to control whether the button exists based on results
        if (hasResults) {
            startOverButton.style.visibility = "visible";
            if (feedbackButton) feedbackButton.style.visibility = "visible";
            if (collapsedFeedbackButton) {
                // Remove display override and let CSS handle visibility based on sidebar state
                collapsedFeedbackButton.style.visibility = "visible";
                collapsedFeedbackButton.style.display = "";
            }
        } else {
            startOverButton.style.visibility = "hidden";
            if (feedbackButton) feedbackButton.style.visibility = "hidden";
            if (collapsedFeedbackButton) // Hide by setting display to none, overriding CSS
            collapsedFeedbackButton.style.display = "none";
        }
    }
}
/**
 * Enable the keypoint labels checkbox
 */ function $a78b7212404532f0$var$enableKeypointLabelsCheckbox() {
    const checkbox = document.getElementById("show-keypoint-labels");
    if (checkbox) {
        checkbox.disabled = false;
        const parentLabel = checkbox.closest(".checkbox-item");
        if (parentLabel) {
            parentLabel.style.opacity = "1";
            parentLabel.style.cursor = "pointer";
        }
    }
}
/**
 * Disable the keypoint labels checkbox
 */ function $a78b7212404532f0$var$disableKeypointLabelsCheckbox() {
    const checkbox = document.getElementById("show-keypoint-labels");
    if (checkbox) {
        checkbox.disabled = true;
        const parentLabel = checkbox.closest(".checkbox-item");
        if (parentLabel) {
            parentLabel.style.opacity = "0.5";
            parentLabel.style.cursor = "not-allowed";
        }
    }
}
/**
 * Enable the arrangement labels checkbox
 */ function $a78b7212404532f0$var$enableArrangementLabelsCheckbox() {
    const checkbox = document.getElementById("show-arrangement-labels");
    if (checkbox) {
        checkbox.disabled = false;
        const parentLabel = checkbox.closest(".checkbox-item");
        if (parentLabel) parentLabel.style.display = "block";
    }
}
/**
 * Disable the arrangement labels checkbox
 */ function $a78b7212404532f0$var$disableArrangementLabelsCheckbox() {
    const checkbox = document.getElementById("show-arrangement-labels");
    if (checkbox) {
        checkbox.disabled = true;
        const parentLabel = checkbox.closest(".checkbox-item");
        if (parentLabel) parentLabel.style.display = "none";
    }
}
/**
 * Update visibility of keypoint labels across all scenes
 * @param {boolean} visible - Whether labels should be visible
 */ function $a78b7212404532f0$var$updateKeypointLabelsVisibility(visible) {
    // Update labels in main scene
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.traverse((object)=>{
        if (object.isCSS2DObject && object.name.startsWith("keypoint-label-")) object.visible = visible;
    });
    // Update labels in multi-view scenes
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes) Object.values((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes).forEach((scene)=>{
        if (scene) scene.traverse((object)=>{
            if (object.isCSS2DObject && object.name.startsWith("keypoint-label-")) object.visible = visible;
        });
    });
    // Also update labels in keypointLabels array if it exists
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypointLabels && Array.isArray((0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypointLabels)) (0, $66dbd4fb7330af32$export$8e769ad4338a911e).keypointLabels.forEach((label)=>{
        label.visible = visible;
    });
}
/**
 * Update visibility of arrangement object labels across all scenes
 * @param {boolean} visible - Whether labels should be visible
 */ function $a78b7212404532f0$var$updateArrangementLabelsVisibility(visible) {
    // Helper function to check if an object should be visible based on current toggles
    const shouldLabelBeVisible = (scene, labelName)=>{
        if (!visible) return false;
        // Get the associated mesh object
        const associatedObjectName = labelName.replace("arrangement-label-", "");
        const associatedMesh = scene.children.find((child)=>child.isMesh && (child.name === associatedObjectName || child.name.includes(associatedObjectName)));
        if (!associatedMesh) return visible;
        // Check if the associated mesh is currently visible (respects jaw and bracket toggles)
        return associatedMesh.visible;
    };
    // Update labels in main scene
    (0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene.traverse((object)=>{
        if (object.isCSS2DObject && object.name.startsWith("arrangement-label-")) object.visible = shouldLabelBeVisible((0, $66dbd4fb7330af32$export$8e769ad4338a911e).scene, object.name);
    });
    // Update labels in multi-view scenes
    if ((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes) Object.values((0, $66dbd4fb7330af32$export$8e769ad4338a911e).multiViewScenes).forEach((scene)=>{
        if (scene) scene.traverse((object)=>{
            if (object.isCSS2DObject && object.name.startsWith("arrangement-label-")) object.visible = shouldLabelBeVisible(scene, object.name);
        });
    });
}


//# sourceMappingURL=index.7e588f61.js.map
